/* tslint:disable */
/* eslint-disable */
/**
 * Seccl API Documentation
 * #### Welcome to Seccl\'s API reference Hello and welcome! 👋 In this section, we\'ll cover  Our API is organised around REST (Representational State Transfer), which is a particular software architectural style. You can read [more about REST here](https://en.wikipedia.org/wiki/Representational_state_transfer).  Our API uses predictable resource-oriented URLs, accepts form-encoded request bodies and returns JSON-encoded responses. It also uses standard HTTP response codes, authentication and verbs.  You can use the Seccl API in test mode, which doesn\'t affect your live data or interact with other partners. The API route you use determines whether the request is in live mode or test mode. 
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * The unique identifier of the investment account
     * @type {string}
     * @memberof Account
     */
    'id': string;
    /**
     * The unique identifier of the firm
     * @type {string}
     * @memberof Account
     */
    'firmId'?: string;
    /**
     * The unique node identifier that the client record is attached to
     * @type {string}
     * @memberof Account
     */
    'nodeId'?: string;
    /**
     * The full name of the client, including title, first name and surname
     * @type {string}
     * @memberof Account
     */
    'name': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof Account
     */
    'currency'?: string;
    /**
     * 
     * @type {AccountAuditDetails}
     * @memberof Account
     */
    'auditDetails'?: AccountAuditDetails;
    /**
     * The type of account
     * @type {string}
     * @memberof Account
     */
    'accountType'?: string;
    /**
     * 
     * @type {SellDown}
     * @memberof Account
     */
    'autoDisinvest'?: SellDown;
    /**
     * 
     * @type {SellDownSellType}
     * @memberof Account
     */
    'autoDisinvestSellType'?: SellDownSellType;
    /**
     * 
     * @type {Array<AccountPortfolioGroupsInner>}
     * @memberof Account
     */
    'portfolioGroups'?: Array<AccountPortfolioGroupsInner>;
    /**
     * 
     * @type {WrapperType}
     * @memberof Account
     */
    'wrapperType'?: WrapperType;
    /**
     * 
     * @type {AccountWrapperDetail}
     * @memberof Account
     */
    'wrapperDetail': AccountWrapperDetail;
    /**
     * TBD
     * @type {boolean}
     * @memberof Account
     */
    'recurringPayment'?: boolean;
    /**
     * Contains details of any recurring order allocation on the account
     * @type {Array<AccountRecurringPaymentsInner>}
     * @memberof Account
     */
    'recurringPayments'?: Array<AccountRecurringPaymentsInner>;
    /**
     * 
     * @type {AccountRecurringOrders}
     * @memberof Account
     */
    'recurringOrders'?: AccountRecurringOrders | null;
    /**
     * 
     * @type {AccountStatus}
     * @memberof Account
     */
    'status'?: AccountStatus;
    /**
     * The unique identifier of the client account
     * @type {string}
     * @memberof Account
     */
    'clientId'?: string;
    /**
     * The name of the client account
     * @type {string}
     * @memberof Account
     */
    'clientName': string;
    /**
     * 
     * @type {Array<AccountClientsInner>}
     * @memberof Account
     */
    'clients'?: Array<AccountClientsInner>;
    /**
     * The clients national insurance number
     * @type {string}
     * @memberof Account
     */
    'clientNationalInsuranceNo'?: string;
    /**
     * The current value of the account. If no date parameters are provided, this will show as of today\'s date
     * @type {number}
     * @memberof Account
     */
    'currentValue'?: number;
    /**
     * The opening value of the account. If no date parameters are provided, this will show as 0
     * @type {number}
     * @memberof Account
     */
    'openingValue'?: number;
    /**
     * the percentage charge for an adviser
     * @type {number}
     * @memberof Account
     */
    'adviserCharge'?: number;
    /**
     * 
     * @type {AccountAdviserTieredCharges}
     * @memberof Account
     */
    'adviserTieredCharges'?: AccountAdviserTieredCharges;
    /**
     * 
     * @type {CreateAccountFeeStructures}
     * @memberof Account
     */
    'feeStructures'?: CreateAccountFeeStructures;
    /**
     * TBD
     * @type {any}
     * @memberof Account
     */
    'openingStockValue'?: any;
    /**
     * TBD
     * @type {number}
     * @memberof Account
     */
    'openingCashValue'?: number;
    /**
     * The sum of the positions.bookValue in the positions array
     * @type {number}
     * @memberof Account
     */
    'bookValue'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof Account
     */
    'transferBookValue'?: number;
    /**
     * The sum of the positions.nonTransferBookValue in the positions array
     * @type {number}
     * @memberof Account
     */
    'nonTransferBookValue'?: number;
    /**
     * The growth since book costs
     * @type {number}
     * @memberof Account
     */
    'growth'?: number;
    /**
     * The growth since assets on platform
     * @type {number}
     * @memberof Account
     */
    'adjustedGrowth'?: number;
    /**
     * The amount of cash in the account
     * @type {any}
     * @memberof Account
     */
    'closingCashValue'?: any;
    /**
     * The amount of cash in the account
     * @type {number}
     * @memberof Account
     */
    'uninvestedCash'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof Account
     */
    'closingStockValue'?: number;
    /**
     * The growth since book costs as percentage
     * @type {number}
     * @memberof Account
     */
    'growthPercent'?: number;
    /**
     * The growth since assets on platform as percentage
     * @type {number}
     * @memberof Account
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The sum of the transferValue within the positions array
     * @type {number}
     * @memberof Account
     */
    'transferValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'decisionMakerLei'?: string;
    /**
     * 
     * @type {AccountBankDetails}
     * @memberof Account
     */
    'bankDetails'?: AccountBankDetails;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    'discretionaryManagementCharge'?: number;
    /**
     * Unique Id of the last update
     * @type {string}
     * @memberof Account
     */
    'updateId'?: string;
    /**
     * TBD
     * @type {Array<AccountUpdateHistoryInner>}
     * @memberof Account
     */
    'updateHistory'?: Array<AccountUpdateHistoryInner>;
    /**
     * 
     * @type {AccountNominatedForAccounts}
     * @memberof Account
     */
    'nominatedForAccounts'?: AccountNominatedForAccounts;
}


/**
 * 
 * @export
 * @interface AccountAdviserFee
 */
export interface AccountAdviserFee {
    /**
     * 
     * @type {AdviserFeeSource}
     * @memberof AccountAdviserFee
     */
    'feeSource': AdviserFeeSource;
    /**
     * 
     * @type {Array<AccountFeeTier>}
     * @memberof AccountAdviserFee
     */
    'tiers'?: Array<AccountFeeTier>;
    /**
     * Fixed annual adviser fee rate applied to the account, expressed as a decimal fraction (e.g. 0.005 = 0.5%). Mutually exclusive with `tiers` — exactly one of `fixedRate` or `tiers` will be present. May be present alongside `fixedAccountFee`. 
     * @type {number}
     * @memberof AccountAdviserFee
     */
    'fixedRate'?: number;
    /**
     * Fixed annual adviser fee applied to the account, expressed as an absolute monetary amount in the account\'s currency (typically GBP). May be present alongside either `tiers` or `fixedRate`. 
     * @type {number}
     * @memberof AccountAdviserFee
     */
    'fixedAccountFee'?: number;
}
/**
 * 
 * @export
 * @interface AccountAdviserTieredCharges
 */
export interface AccountAdviserTieredCharges {
    /**
     * 
     * @type {Array<AccountAdviserTieredChargesTiersInner>}
     * @memberof AccountAdviserTieredCharges
     */
    'tiers'?: Array<AccountAdviserTieredChargesTiersInner>;
}
/**
 * 
 * @export
 * @interface AccountAdviserTieredChargesTiersInner
 */
export interface AccountAdviserTieredChargesTiersInner {
    /**
     * 
     * @type {number}
     * @memberof AccountAdviserTieredChargesTiersInner
     */
    'fromAmount': number;
    /**
     * 
     * @type {number}
     * @memberof AccountAdviserTieredChargesTiersInner
     */
    'rate': number;
    /**
     * 
     * @type {number}
     * @memberof AccountAdviserTieredChargesTiersInner
     */
    'toAmount'?: number;
}
/**
 * TBD
 * @export
 * @interface AccountAuditDetails
 */
export interface AccountAuditDetails {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof AccountAuditDetails
     */
    'updateDate'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountAuditDetails
     */
    'userFirmId': string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountAuditDetails
     */
    'userId': string;
    /**
     * TBD
     * @type {number}
     * @memberof AccountAuditDetails
     */
    'version': number;
    /**
     * TBD
     * @type {string}
     * @memberof AccountAuditDetails
     */
    'application': string;
}
/**
 * 
 * @export
 * @interface AccountBankDetails
 */
export interface AccountBankDetails {
    /**
     * The client\'s bank\'s sort code. This is a six-digit number
     * @type {string}
     * @memberof AccountBankDetails
     */
    'sortCode'?: string;
    /**
     * The client\'s account number. This is an eight-digit number
     * @type {string}
     * @memberof AccountBankDetails
     */
    'accountNumber'?: string;
    /**
     * verification status of the bank details
     * @type {string}
     * @memberof AccountBankDetails
     */
    'verificationStatus'?: AccountBankDetailsVerificationStatusEnum;
    /**
     * 
     * @type {BankDetailsVerificationCreatedBy}
     * @memberof AccountBankDetails
     */
    'createdBy'?: BankDetailsVerificationCreatedBy;
    /**
     * date on which the bank details were created
     * @type {string}
     * @memberof AccountBankDetails
     */
    'createdOn'?: string;
    /**
     * 
     * @type {BankDetailsVerificationVerificationInfo}
     * @memberof AccountBankDetails
     */
    'verificationInfo'?: BankDetailsVerificationVerificationInfo;
}

/**
    * @export
    * @enum {string}
    */
export enum AccountBankDetailsVerificationStatusEnum {
    Active = 'Active',
    Pending = 'Pending',
    Bypassed = 'Bypassed'
}

/**
 * 
 * @export
 * @interface AccountCashPosition
 */
export interface AccountCashPosition {
    /**
     * 
     * @type {string}
     * @memberof AccountCashPosition
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPosition
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPosition
     */
    'accountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPosition
     */
    'accountType'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof AccountCashPosition
     */
    'currency'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof AccountCashPosition
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPosition
     */
    'nodeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPosition
     */
    'positionType': string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPosition
     */
    'updateId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPosition
     */
    'growth'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPosition
     */
    'growthPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPosition
     */
    'adjustedGrowth'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPosition
     */
    'adjustedGrowthPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPosition
     */
    'openingValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPosition
     */
    'allocation'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPosition
     */
    'amount'?: number;
    /**
     * 
     * @type {AccountCashPositionAllOfAuditDetails}
     * @memberof AccountCashPosition
     */
    'auditDetails'?: AccountCashPositionAllOfAuditDetails;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPosition
     */
    'currentValue'?: number;
}
/**
 * 
 * @export
 * @interface AccountCashPositionAllOf
 */
export interface AccountCashPositionAllOf {
    /**
     * 
     * @type {number}
     * @memberof AccountCashPositionAllOf
     */
    'amount'?: number;
    /**
     * 
     * @type {AccountCashPositionAllOfAuditDetails}
     * @memberof AccountCashPositionAllOf
     */
    'auditDetails'?: AccountCashPositionAllOfAuditDetails;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPositionAllOf
     */
    'currentValue'?: number;
}
/**
 * 
 * @export
 * @interface AccountCashPositionAllOfAuditDetails
 */
export interface AccountCashPositionAllOfAuditDetails {
    /**
     * 
     * @type {string}
     * @memberof AccountCashPositionAllOfAuditDetails
     */
    'application'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPositionAllOfAuditDetails
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPositionAllOfAuditDetails
     */
    'userFirmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountCashPositionAllOfAuditDetails
     */
    'userId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountCashPositionAllOfAuditDetails
     */
    'version'?: number;
}
/**
 * 
 * @export
 * @interface AccountClientsInner
 */
export interface AccountClientsInner {
    /**
     * 
     * @type {boolean}
     * @memberof AccountClientsInner
     */
    'decisionMaker'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountClientsInner
     */
    'isLeadClient'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AccountClientsInner
     */
    'owner'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountClientsInner
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface AccountFeeTier
 */
export interface AccountFeeTier {
    /**
     * Lower bound of the tier range
     * @type {number}
     * @memberof AccountFeeTier
     */
    'fromAmount'?: number;
    /**
     * Upper bound of the tier range
     * @type {number}
     * @memberof AccountFeeTier
     */
    'toAmount'?: number;
    /**
     * Fee rate as a decimal fraction (e.g. 0.0078 = 0.78%)
     * @type {number}
     * @memberof AccountFeeTier
     */
    'rate'?: number;
}
/**
 * Accounts whose fees are covered by this account
 * @export
 * @interface AccountNominatedForAccounts
 */
export interface AccountNominatedForAccounts {
    /**
     * Array of account IDs whose fees are covered
     * @type {Array<string>}
     * @memberof AccountNominatedForAccounts
     */
    'group'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AccountPlatformFee
 */
export interface AccountPlatformFee {
    /**
     * 
     * @type {PlatformFeeSource}
     * @memberof AccountPlatformFee
     */
    'feeSource': PlatformFeeSource;
    /**
     * 
     * @type {Array<AccountFeeTier>}
     * @memberof AccountPlatformFee
     */
    'tiers': Array<AccountFeeTier>;
    /**
     * Fixed annual platform apportion fee applied to the account
     * @type {number}
     * @memberof AccountPlatformFee
     */
    'fixedRate'?: number;
}
/**
 * @type AccountPortfolioGroup
 * @export
 */
export type AccountPortfolioGroup = PensionAccountGroup;

/**
 * 
 * @export
 * @interface AccountPortfolioGroupsInner
 */
export interface AccountPortfolioGroupsInner {
    /**
     * 
     * @type {PensionAccountGroupIntent}
     * @memberof AccountPortfolioGroupsInner
     */
    'groupIntent'?: PensionAccountGroupIntent;
    /**
     * 
     * @type {PensionAccountGroupType}
     * @memberof AccountPortfolioGroupsInner
     */
    'groupType': PensionAccountGroupType;
    /**
     * TBD
     * @type {string}
     * @memberof AccountPortfolioGroupsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountPortfolioGroupsInner
     */
    'name'?: string;
}


/**
 * @type AccountPosition
 * @export
 */
export type AccountPosition = { positionType: 'AccountCashPosition' } & AccountCashPosition | { positionType: 'AccountStockPosition' } & AccountStockPosition | { positionType: 'Cash' } & AccountCashPosition | { positionType: 'Stock' } & AccountStockPosition;

/**
 * 
 * @export
 * @interface AccountPost200Response
 */
export interface AccountPost200Response {
    /**
     * 
     * @type {AccountPost200ResponseData}
     * @memberof AccountPost200Response
     */
    'data': AccountPost200ResponseData;
}
/**
 * 
 * @export
 * @interface AccountPost200ResponseData
 */
export interface AccountPost200ResponseData {
    /**
     * 
     * @type {any}
     * @memberof AccountPost200ResponseData
     */
    'id': any;
}
/**
 * Contains details of any recurring order allocation on the account
 * @export
 * @interface AccountRecurringOrders
 */
export interface AccountRecurringOrders {
    /**
     * TBD
     * @type {string}
     * @memberof AccountRecurringOrders
     */
    'movementType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountRecurringOrders
     */
    'investmentType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountRecurringOrders
     */
    'orderDay'?: string;
    /**
     * 
     * @type {Array<AccountRecurringOrdersDetailsInner>}
     * @memberof AccountRecurringOrders
     */
    'details'?: Array<AccountRecurringOrdersDetailsInner>;
}
/**
 * 
 * @export
 * @interface AccountRecurringOrdersDetailsInner
 */
export interface AccountRecurringOrdersDetailsInner {
    /**
     * TBD
     * @type {string}
     * @memberof AccountRecurringOrdersDetailsInner
     */
    'assetId': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof AccountRecurringOrdersDetailsInner
     */
    'currency'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof AccountRecurringOrdersDetailsInner
     */
    'percentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountRecurringOrdersDetailsInner
     */
    'assetName'?: string;
}
/**
 * 
 * @export
 * @interface AccountRecurringPaymentsInner
 */
export interface AccountRecurringPaymentsInner {
    /**
     * TBD
     * @type {number}
     * @memberof AccountRecurringPaymentsInner
     */
    'amount': number;
    /**
     * TBD
     * @type {boolean}
     * @memberof AccountRecurringPaymentsInner
     */
    'autoInvest'?: boolean;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof AccountRecurringPaymentsInner
     */
    'method'?: PaymentMethod;
    /**
     * 
     * @type {MovementType}
     * @memberof AccountRecurringPaymentsInner
     */
    'movementType'?: MovementType;
    /**
     * 
     * @type {PaymentDate}
     * @memberof AccountRecurringPaymentsInner
     */
    'paymentDay': PaymentDate;
    /**
     * 
     * @type {PaymentType}
     * @memberof AccountRecurringPaymentsInner
     */
    'paymentType'?: PaymentType;
    /**
     * TBD
     * @type {string}
     * @memberof AccountRecurringPaymentsInner
     */
    'companyRegNo'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum AccountStatus {
    Pending = 'Pending',
    Active = 'Active',
    Suspended = 'Suspended',
    Registered = 'Registered',
    Deleted = 'Deleted',
    Closed = 'Closed',
    Closing = 'Closing',
    TransferOut = 'Transfer Out'
}


/**
 * 
 * @export
 * @interface AccountStockPosition
 */
export interface AccountStockPosition {
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'accountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'accountType'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof AccountStockPosition
     */
    'currency'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof AccountStockPosition
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'nodeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'positionType': string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'updateId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'growth'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'growthPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'adjustedGrowth'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'adjustedGrowthPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'openingValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'allocation'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'assetId': string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'assetName'?: string;
    /**
     * 
     * @type {AccountCashPositionAllOfAuditDetails}
     * @memberof AccountStockPosition
     */
    'auditDetails'?: AccountCashPositionAllOfAuditDetails;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'isin'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'quantity'?: number;
    /**
     * 
     * @type {Array<AccountStockPositionAllOfPrices>}
     * @memberof AccountStockPosition
     */
    'prices'?: Array<AccountStockPositionAllOfPrices>;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'bookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'transferBookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'nonTransferBookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'transferValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'currentPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'instrumentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'minimumTransferUnit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPosition
     */
    'currentPriceDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPosition
     */
    'currentValue'?: number;
    /**
     * 
     * @type {CgtData}
     * @memberof AccountStockPosition
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof AccountStockPosition
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}
/**
 * 
 * @export
 * @interface AccountStockPositionAllOf
 */
export interface AccountStockPositionAllOf {
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOf
     */
    'assetId': string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOf
     */
    'assetName'?: string;
    /**
     * 
     * @type {AccountCashPositionAllOfAuditDetails}
     * @memberof AccountStockPositionAllOf
     */
    'auditDetails'?: AccountCashPositionAllOfAuditDetails;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOf
     */
    'isin'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'quantity'?: number;
    /**
     * 
     * @type {Array<AccountStockPositionAllOfPrices>}
     * @memberof AccountStockPositionAllOf
     */
    'prices'?: Array<AccountStockPositionAllOfPrices>;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'bookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'transferBookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'nonTransferBookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'transferValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'currentPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOf
     */
    'instrumentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'minimumTransferUnit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOf
     */
    'currentPriceDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'currentValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOf
     */
    'openingValue'?: number;
    /**
     * 
     * @type {CgtData}
     * @memberof AccountStockPositionAllOf
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof AccountStockPositionAllOf
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}
/**
 * 
 * @export
 * @interface AccountStockPositionAllOfAuditDetails
 */
export interface AccountStockPositionAllOfAuditDetails {
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfAuditDetails
     */
    'application': string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfAuditDetails
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfAuditDetails
     */
    'userFirmId': string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfAuditDetails
     */
    'userId': string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOfAuditDetails
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface AccountStockPositionAllOfPrices
 */
export interface AccountStockPositionAllOfPrices {
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfPrices
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfPrices
     */
    'insertDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOfPrices
     */
    'ask'?: number;
    /**
     * 
     * @type {AccountStockPositionAllOfAuditDetails}
     * @memberof AccountStockPositionAllOfPrices
     */
    'auditDetails'?: AccountStockPositionAllOfAuditDetails;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOfPrices
     */
    'bid'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfPrices
     */
    'firmId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOfPrices
     */
    'mid'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfPrices
     */
    'priceDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfPrices
     */
    'updateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfPrices
     */
    'assetId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOfPrices
     */
    'quoteUnit'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStockPositionAllOfPrices
     */
    'minimumTransferUnit'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfPrices
     */
    'currency'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof AccountStockPositionAllOfPrices
     */
    'exchangeRates'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof AccountStockPositionAllOfPrices
     */
    'instrumentType'?: string;
}
/**
 * The type of account; whether it is a cash or wrapper account
 * @export
 * @enum {string}
 */

export enum AccountType {
    Cash = 'Cash',
    Wrapper = 'Wrapper'
}


/**
 * 
 * @export
 * @interface AccountUpdateHistoryInner
 */
export interface AccountUpdateHistoryInner {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof AccountUpdateHistoryInner
     */
    'updateDate'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountUpdateHistoryInner
     */
    'updateAction': string;
    /**
     * 
     * @type {AccountUpdateHistoryInnerUpdateData}
     * @memberof AccountUpdateHistoryInner
     */
    'updateData': AccountUpdateHistoryInnerUpdateData;
    /**
     * TBD
     * @type {number}
     * @memberof AccountUpdateHistoryInner
     */
    'updateId': number;
    /**
     * TBD
     * @type {string}
     * @memberof AccountUpdateHistoryInner
     */
    'updateReason': string;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof AccountUpdateHistoryInner
     */
    'updatedFields': Array<string>;
}
/**
 * TBD
 * @export
 * @interface AccountUpdateHistoryInnerUpdateData
 */
export interface AccountUpdateHistoryInnerUpdateData {
    /**
     * TBD
     * @type {string}
     * @memberof AccountUpdateHistoryInnerUpdateData
     */
    'fromData': string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountUpdateHistoryInnerUpdateData
     */
    'toData': string;
}
/**
 * Contains details of the investment account
 * @export
 * @interface AccountWrapperDetail
 */
export interface AccountWrapperDetail {
    /**
     * 
     * @type {WrapperType}
     * @memberof AccountWrapperDetail
     */
    'wrapperType'?: WrapperType;
    /**
     * TBD
     * @type {boolean}
     * @memberof AccountWrapperDetail
     */
    'discretionary'?: boolean;
    /**
     * Unique id fo the scheme
     * @type {string}
     * @memberof AccountWrapperDetail
     */
    'schemeProductId'?: string;
    /**
     * 
     * @type {ClientProductStatus}
     * @memberof AccountWrapperDetail
     */
    'productStatus'?: ClientProductStatus;
    /**
     * 
     * @type {AccountWrapperDetailProductDetail}
     * @memberof AccountWrapperDetail
     */
    'productDetail'?: AccountWrapperDetailProductDetail;
    /**
     * TBD
     * @type {boolean}
     * @memberof AccountWrapperDetail
     */
    'advised'?: boolean;
    /**
     * TBD
     * @type {boolean}
     * @memberof AccountWrapperDetail
     */
    'trust'?: boolean;
    /**
     * TBD
     * @type {string}
     * @memberof AccountWrapperDetail
     */
    'assetAllocationId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountWrapperDetail
     */
    'assetAllocationName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountWrapperDetail
     */
    'clientProductId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof AccountWrapperDetail
     */
    'providerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountWrapperDetail
     */
    'externalId'?: string;
    /**
     * 
     * @type {Array<AccountWrapperDetailExternalIdsInner>}
     * @memberof AccountWrapperDetail
     */
    'externalIds'?: Array<AccountWrapperDetailExternalIdsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof AccountWrapperDetail
     */
    'flexibleBenefitsAccessed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountWrapperDetail
     */
    'flexiAccessDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountWrapperDetail
     */
    'pensionOptOut'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountWrapperDetail
     */
    'decisionMakerId'?: string;
}


/**
 * 
 * @export
 * @interface AccountWrapperDetailExternalIdsInner
 */
export interface AccountWrapperDetailExternalIdsInner {
    /**
     * 
     * @type {string}
     * @memberof AccountWrapperDetailExternalIdsInner
     */
    'idType': AccountWrapperDetailExternalIdsInnerIdTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountWrapperDetailExternalIdsInner
     */
    'value': string;
}

/**
    * @export
    * @enum {string}
    */
export enum AccountWrapperDetailExternalIdsInnerIdTypeEnum {
    ExternalProviderId = 'ExternalProviderId',
    ExternalProvider = 'ExternalProvider'
}

/**
 * 
 * @export
 * @interface AccountWrapperDetailProductDetail
 */
export interface AccountWrapperDetailProductDetail {
    /**
     * 
     * @type {boolean}
     * @memberof AccountWrapperDetailProductDetail
     */
    'flexibleBenefitsAccessed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountWrapperDetailProductDetail
     */
    'pensionOptOut'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountWrapperDetailProductDetail
     */
    'flexiAccessDate'?: string;
}
/**
 * Action tag on transactions
 * @export
 * @enum {string}
 */

export enum ActionTag {
    None = 'None',
    ClientActionRequired = 'ClientActionRequired',
    Resubmit = 'Resubmit'
}


/**
 * Contains details for the client\'s home address
 * @export
 * @interface AddressDetail
 */
export interface AddressDetail {
    /**
     * The flat number, building name, or building number of the client\'s home address
     * @type {string}
     * @memberof AddressDetail
     */
    'flatNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDetail
     */
    'buildingName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDetail
     */
    'buildingNumber'?: string;
    /**
     * The first line of the client\'s legal home address
     * @type {string}
     * @memberof AddressDetail
     */
    'address1': string;
    /**
     * The second line of the client\'s legal home address
     * @type {string}
     * @memberof AddressDetail
     */
    'address2'?: string;
    /**
     * The third line of the client\'s legal home address
     * @type {string}
     * @memberof AddressDetail
     */
    'address3'?: string;
    /**
     * The forth line of the client\'s legal home address
     * @type {string}
     * @memberof AddressDetail
     */
    'address4'?: string;
    /**
     * The client\'s country of residence
     * @type {string}
     * @memberof AddressDetail
     */
    'country': string;
    /**
     * The postcode of the client\'s legal home address
     * @type {string}
     * @memberof AddressDetail
     */
    'postCode': string;
}
/**
 * 
 * @export
 * @interface AddresslookupPost200Response
 */
export interface AddresslookupPost200Response {
    /**
     * 
     * @type {AddresslookupPost200ResponseData}
     * @memberof AddresslookupPost200Response
     */
    'data'?: AddresslookupPost200ResponseData;
}
/**
 * 
 * @export
 * @interface AddresslookupPost200ResponseData
 */
export interface AddresslookupPost200ResponseData {
    /**
     * 
     * @type {Array<AddresslookupPost200ResponseDataAddressesInner>}
     * @memberof AddresslookupPost200ResponseData
     */
    'addresses'?: Array<AddresslookupPost200ResponseDataAddressesInner>;
}
/**
 * 
 * @export
 * @interface AddresslookupPost200ResponseDataAddressesInner
 */
export interface AddresslookupPost200ResponseDataAddressesInner {
    /**
     * 
     * @type {string}
     * @memberof AddresslookupPost200ResponseDataAddressesInner
     */
    'flat_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresslookupPost200ResponseDataAddressesInner
     */
    'building_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresslookupPost200ResponseDataAddressesInner
     */
    'building_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresslookupPost200ResponseDataAddressesInner
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresslookupPost200ResponseDataAddressesInner
     */
    'sub_street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresslookupPost200ResponseDataAddressesInner
     */
    'town'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresslookupPost200ResponseDataAddressesInner
     */
    'postcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresslookupPost200ResponseDataAddressesInner
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface AddresslookupPostRequest
 */
export interface AddresslookupPostRequest {
    /**
     * Postcode to search for
     * @type {string}
     * @memberof AddresslookupPostRequest
     */
    'postcode': string;
}
/**
 * 
 * @export
 * @interface AdviserFeeSource
 */
export interface AdviserFeeSource {
    /**
     * Where the adviser fee structure is inherited from
     * @type {string}
     * @memberof AdviserFeeSource
     */
    'sourceType': AdviserFeeSourceSourceTypeEnum;
    /**
     * ID of the entity holding the fee structure
     * @type {string}
     * @memberof AdviserFeeSource
     */
    'sourceId': string;
}

/**
    * @export
    * @enum {string}
    */
export enum AdviserFeeSourceSourceTypeEnum {
    Account = 'Account',
    Client = 'Client',
    ClientFeeGroup = 'Client Fee Group'
}

/**
 * Contains details of any AML alerts raised on the client
 * @export
 * @interface AmlAlert
 */
export interface AmlAlert {
    /**
     * Category of the alert. Valid values are Person,Company,ID,Other,Risk
     * @type {string}
     * @memberof AmlAlert
     */
    'category'?: AmlAlertCategoryEnum;
    /**
     * Unique NorthRow rule ID of the alert
     * @type {string}
     * @memberof AmlAlert
     */
    'crid'?: string;
    /**
     * Description of the alert
     * @type {string}
     * @memberof AmlAlert
     */
    'message'?: string;
    /**
     * Score of the alert
     * @type {number}
     * @memberof AmlAlert
     */
    'score'?: number;
    /**
     * Type of the alert. Valid values are alert, info, verification
     * @type {string}
     * @memberof AmlAlert
     */
    'type'?: AmlAlertTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AmlAlertCategoryEnum {
    Person = 'Person',
    Company = 'Company',
    Id = 'ID',
    Other = 'Other',
    Risk = 'Risk'
}
/**
    * @export
    * @enum {string}
    */
export enum AmlAlertTypeEnum {
    Alert = 'alert',
    Info = 'info',
    Verification = 'verification'
}

/**
 * Fields used to value and communicate performance at the record level
 * @export
 * @interface AnalysisFields
 */
export interface AnalysisFields {
    /**
     * The on platform growth value of an investment (the growth since arrival on the platform) 
     * @type {number}
     * @memberof AnalysisFields
     */
    'adjustedGrowth'?: number;
    /**
     * The percentage adjusted growth at the current record level
     * @type {number}
     * @memberof AnalysisFields
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The growth value since the book cost at the current record level
     * @type {number}
     * @memberof AnalysisFields
     */
    'growth'?: number;
    /**
     * The percentage growth since the book cost at the current record level
     * @type {number}
     * @memberof AnalysisFields
     */
    'growthPercent'?: number;
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof AnalysisFields
     */
    'bookValue'?: number;
    /**
     * The book cost since the transfer settled
     * @type {number}
     * @memberof AnalysisFields
     */
    'nonTransferBookValue'?: number;
    /**
     * The number of units multiplied by the price on the day the transfer settled. This will be the same as the bookValue if there\'s been no in-specie transfer 
     * @type {number}
     * @memberof AnalysisFields
     */
    'transferBookValue'?: number;
    /**
     * The value of cash held by the record at the end of the specified period (if not specified this would be now) 
     * @type {number}
     * @memberof AnalysisFields
     */
    'closingCashValue'?: number;
    /**
     * The value of stock held by the record at the end of the specified period (if not specified this as at the most recent close of market) 
     * @type {number}
     * @memberof AnalysisFields
     */
    'closingStockValue'?: number;
    /**
     * The value of cash held at the current record level at the start of the specified period (if not specified this would be record creation) 
     * @type {number}
     * @memberof AnalysisFields
     */
    'openingCashValue'?: number;
    /**
     * The value of stock held at the current record level at the start of the specified period (if not specified this would be record creation) 
     * @type {number}
     * @memberof AnalysisFields
     */
    'openingStockValue'?: number;
    /**
     * The opening value of the current record - if no date parameters are provided, this will show as 0 
     * @type {number}
     * @memberof AnalysisFields
     */
    'openingValue'?: number;
    /**
     * The current total value at the current record level - if no date parameters are provided, this will show as at today\'s date 
     * @type {number}
     * @memberof AnalysisFields
     */
    'currentValue'?: number;
    /**
     * The value of the transfer onto the platform at the current record level
     * @type {number}
     * @memberof AnalysisFields
     */
    'transferValue'?: number;
    /**
     * The value of available cash held by the record that is not currently invested
     * @type {number}
     * @memberof AnalysisFields
     */
    'uninvestedCash'?: number;
    /**
     * 
     * @type {PendingDeposits}
     * @memberof AnalysisFields
     */
    'pendingDeposits'?: PendingDeposits;
    /**
     * Settled cash that can be withdrawn now (uninvested cash less any unsettled sells)
     * @type {number}
     * @memberof AnalysisFields
     */
    'withdrawableCash'?: number;
    /**
     * Completed sell orders whose cash has executed but not yet settled
     * @type {Array<UnsettledSell>}
     * @memberof AnalysisFields
     */
    'unsettledSells'?: Array<UnsettledSell>;
    /**
     * 
     * @type {RingfencedCashBreakdown}
     * @memberof AnalysisFields
     */
    'ringfencedCashBreakdown'?: RingfencedCashBreakdown;
}
/**
 * 
 * @export
 * @interface Asset
 */
export interface Asset {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof Asset
     */
    'id': string;
    /**
     * TBD
     * @type {string}
     * @memberof Asset
     */
    'type'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof Asset
     */
    'firmId': string;
    /**
     * International Securities Identification Number (ISIN). A 12-digit alphanumeric code that uniquely identifies a specific security 
     * @type {string}
     * @memberof Asset
     */
    'isin': string;
    /**
     * The short name of the asset
     * @type {string}
     * @memberof Asset
     */
    'shortName': string;
    /**
     * The long name of the asset
     * @type {string}
     * @memberof Asset
     */
    'longName': string;
    /**
     * The type of instrument/asset. The system accounts for Equity, Gilts, Corporate bonds, Cash and Other asset classes. 
     * @type {string}
     * @memberof Asset
     */
    'instrumentType'?: string;
    /**
     * 
     * @type {Array<AssetClassificationsInner>}
     * @memberof Asset
     */
    'classifications'?: Array<AssetClassificationsInner>;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof Asset
     */
    'currency': string;
    /**
     * TBD
     * @type {string}
     * @memberof Asset
     */
    'ticker'?: string;
    /**
     * The Market Identifier Code (MIC), which is an international indicator that identifies security trading exchanges
     * @type {string}
     * @memberof Asset
     */
    'mic'?: string;
    /**
     * unit cost
     * @type {number}
     * @memberof Asset
     */
    'mid'?: number;
    /**
     * The status of the asset. They are the following
     * @type {string}
     * @memberof Asset
     */
    'status'?: string;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof Asset
     */
    'availableToNodeId'?: Array<string>;
    /**
     * The date the of the latest price value in Seccl\'s system
     * @type {string}
     * @memberof Asset
     */
    'priceDate'?: string;
    /**
     * 
     * @type {AssetAuditDetails}
     * @memberof Asset
     */
    'auditDetails'?: AssetAuditDetails;
    /**
     * TBD
     * @type {string}
     * @memberof Asset
     */
    'updateId'?: string;
    /**
     * The number of decimal places that the asset can be held. For example, 0.0001 means the asset can be held to 4 decimal places. This is driven by the fund manager or instrument type 
     * @type {number}
     * @memberof Asset
     */
    'minimumTransferUnit'?: number;
    /**
     * This indicates the number of units for the quote, or price. For example, if the asset is £10 and the quoteUnit is 1, then £10 is the quote for a single unit; if the asset is £100 and the quoteUnit is 100, then £100 is the quote for 100 units
     * @type {number}
     * @memberof Asset
     */
    'quoteUnit'?: number;
    /**
     * The number of days the asset takes to settle upon order execution
     * @type {number}
     * @memberof Asset
     */
    'settlementPeriod'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof Asset
     */
    'customName'?: string;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof Asset
     */
    'nodeId'?: Array<string>;
    /**
     * unit cost, used for the sell price within asset rebalance
     * @type {number}
     * @memberof Asset
     */
    'bid': number;
    /**
     * unit cost, used for the buy price within asset rebalance
     * @type {number}
     * @memberof Asset
     */
    'ask'?: number;
    /**
     * Calculated percentage OCF
     * @type {number}
     * @memberof Asset
     */
    'ocfCalculated'?: number;
    /**
     * Estimated percentage OCF
     * @type {number}
     * @memberof Asset
     */
    'ocfEstimated': number;
    /**
     * Link to KIID document
     * @type {string}
     * @memberof Asset
     */
    'kiidDocumentUrl'?: string;
}
/**
 * TBD
 * @export
 * @interface AssetAuditDetails
 */
export interface AssetAuditDetails {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof AssetAuditDetails
     */
    'updateDate'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof AssetAuditDetails
     */
    'userFirmId': string;
    /**
     * TBD
     * @type {string}
     * @memberof AssetAuditDetails
     */
    'userId': string;
    /**
     * TBD
     * @type {number}
     * @memberof AssetAuditDetails
     */
    'version': number;
    /**
     * TBD
     * @type {string}
     * @memberof AssetAuditDetails
     */
    'application': string;
}
/**
 * 
 * @export
 * @interface AssetCharge
 */
export interface AssetCharge {
    /**
     * 
     * @type {string}
     * @memberof AssetCharge
     */
    'assetId': string;
    /**
     * 
     * @type {string}
     * @memberof AssetCharge
     */
    'assetName': string;
    /**
     * 
     * @type {Array<AssetChargeChargesInner>}
     * @memberof AssetCharge
     */
    'charges'?: Array<AssetChargeChargesInner>;
    /**
     * 
     * @type {number}
     * @memberof AssetCharge
     */
    'totalCharges': number | null;
}
/**
 * 
 * @export
 * @interface AssetChargeChargesInner
 */
export interface AssetChargeChargesInner {
    /**
     * 
     * @type {ChargeType}
     * @memberof AssetChargeChargesInner
     */
    'chargeType': ChargeType;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof AssetChargeChargesInner
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof AssetChargeChargesInner
     */
    'amount'?: number;
}


/**
 * 
 * @export
 * @interface AssetClassificationsInner
 */
export interface AssetClassificationsInner {
    /**
     * 
     * @type {string}
     * @memberof AssetClassificationsInner
     */
    'classificationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetClassificationsInner
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface AssetPostRequest
 */
export interface AssetPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetPostRequest
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPostRequest
     */
    'id'?: string;
}
/**
 * The response object containing pagination details
 * @export
 * @interface AtlasSearchMeta
 */
export interface AtlasSearchMeta {
    /**
     * The total returned records count
     * @type {number}
     * @memberof AtlasSearchMeta
     */
    'count': number;
    /**
     * 
     * @type {AtlasSearchMetaPagination}
     * @memberof AtlasSearchMeta
     */
    'pagination': AtlasSearchMetaPagination;
}
/**
 * The pagination details
 * @export
 * @interface AtlasSearchMetaPagination
 */
export interface AtlasSearchMetaPagination {
    /**
     * The amount of records per index
     * @type {number}
     * @memberof AtlasSearchMetaPagination
     */
    'pageSize'?: number;
    /**
     * The token to be used to fetch the next page of results
     * @type {string}
     * @memberof AtlasSearchMetaPagination
     */
    'nextToken'?: string;
    /**
     * The token to be used to fetch the next page of results
     * @type {string}
     * @memberof AtlasSearchMetaPagination
     */
    'prevToken'?: string;
}
/**
 * object containing audit trail details
 * @export
 * @interface AuditDetails
 */
export interface AuditDetails {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof AuditDetails
     */
    'updateDate'?: string;
    /**
     * Firm Id of user that implemented update
     * @type {string}
     * @memberof AuditDetails
     */
    'userFirmId': string;
    /**
     * Id of user that implemented update
     * @type {string}
     * @memberof AuditDetails
     */
    'userId': string;
    /**
     * TBD
     * @type {number}
     * @memberof AuditDetails
     */
    'version': number;
    /**
     * TBD
     * @type {string}
     * @memberof AuditDetails
     */
    'application': string;
}
/**
 * 
 * @export
 * @interface AuthHeader
 */
export interface AuthHeader {
    /**
     * 
     * @type {string}
     * @memberof AuthHeader
     */
    'Content-Type'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthHeader
     */
    'api-token'?: string;
}
/**
 * Auth object
 * @export
 * @interface AuthRequest
 */
export interface AuthRequest {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof AuthRequest
     */
    'firmId'?: string;
    /**
     * Unique identifer for the user
     * @type {string}
     * @memberof AuthRequest
     */
    'id'?: string;
    /**
     * Password for the user
     * @type {string}
     * @memberof AuthRequest
     */
    'password'?: string;
}
/**
 * Auth object
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
    /**
     * 
     * @type {AuthResponseData}
     * @memberof AuthResponse
     */
    'data'?: AuthResponseData;
}
/**
 * 
 * @export
 * @interface AuthResponseData
 */
export interface AuthResponseData {
    /**
     * Unique identifer of the users firm
     * @type {Array<AuthResponseDataScopesInner>}
     * @memberof AuthResponseData
     */
    'scopes'?: Array<AuthResponseDataScopesInner>;
    /**
     * Name of the service access is being granted to
     * @type {Array<string>}
     * @memberof AuthResponseData
     */
    'services'?: Array<string>;
    /**
     * Password for the user
     * @type {string}
     * @memberof AuthResponseData
     */
    'token'?: string;
    /**
     * Unique name for the user
     * @type {string}
     * @memberof AuthResponseData
     */
    'userName'?: string;
    /**
     * 
     * @type {UserMachineType}
     * @memberof AuthResponseData
     */
    'userType'?: UserMachineType;
    /**
     * Id of the user
     * @type {string}
     * @memberof AuthResponseData
     */
    'userId': string;
}


/**
 * 
 * @export
 * @interface AuthResponseDataScopesInner
 */
export interface AuthResponseDataScopesInner {
    /**
     * 
     * @type {Array<Permission>}
     * @memberof AuthResponseDataScopesInner
     */
    'ranges'?: Array<Permission>;
    /**
     * 
     * @type {Resource}
     * @memberof AuthResponseDataScopesInner
     */
    'scope': Resource;
}


/**
 * 
 * @export
 * @interface AuthoriseTransaction
 */
export interface AuthoriseTransaction {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof AuthoriseTransaction
     */
    'firmId': string;
    /**
     * The transaction ID of the withdrawal
     * @type {string}
     * @memberof AuthoriseTransaction
     */
    'id': string;
    /**
     * This field should be used to add narrative around why the payment is authorised
     * @type {string}
     * @memberof AuthoriseTransaction
     */
    'actionReason': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum AutoDisinvest {
    Partial = 'Partial',
    Full = 'Full'
}


/**
 * 
 * @export
 * @interface AvailableValueFields
 */
export interface AvailableValueFields {
    /**
     * The value of available cash held by the record that is not currently invested
     * @type {number}
     * @memberof AvailableValueFields
     */
    'uninvestedCash'?: number;
    /**
     * 
     * @type {PendingDeposits}
     * @memberof AvailableValueFields
     */
    'pendingDeposits'?: PendingDeposits;
    /**
     * Settled cash that can be withdrawn now (uninvested cash less any unsettled sells)
     * @type {number}
     * @memberof AvailableValueFields
     */
    'withdrawableCash'?: number;
    /**
     * Completed sell orders whose cash has executed but not yet settled
     * @type {Array<UnsettledSell>}
     * @memberof AvailableValueFields
     */
    'unsettledSells'?: Array<UnsettledSell>;
    /**
     * 
     * @type {RingfencedCashBreakdown}
     * @memberof AvailableValueFields
     */
    'ringfencedCashBreakdown'?: RingfencedCashBreakdown;
}
/**
 * The client\'s bank details
 * @export
 * @interface BankDetails
 */
export interface BankDetails {
    /**
     * The client\'s bank\'s sort code. This is a six-digit number
     * @type {string}
     * @memberof BankDetails
     */
    'sortCode'?: string;
    /**
     * The client\'s account number. This is an eight-digit number
     * @type {string}
     * @memberof BankDetails
     */
    'accountNumber'?: string;
}
/**
 * Direct debit instructions for these bank details
 * @export
 * @interface BankDetailsDirectDebit
 */
export interface BankDetailsDirectDebit {
    /**
     * Any
     * @type {boolean}
     * @memberof BankDetailsDirectDebit
     */
    'debitPaymentMandate'?: boolean;
    /**
     * date of agreement
     * @type {string}
     * @memberof BankDetailsDirectDebit
     */
    'debitPaymentMandateAgreementDate'?: string;
}
/**
 * Bank detail verification results
 * @export
 * @interface BankDetailsVerification
 */
export interface BankDetailsVerification {
    /**
     * verification status of the bank details
     * @type {string}
     * @memberof BankDetailsVerification
     */
    'verificationStatus'?: BankDetailsVerificationVerificationStatusEnum;
    /**
     * 
     * @type {BankDetailsVerificationCreatedBy}
     * @memberof BankDetailsVerification
     */
    'createdBy'?: BankDetailsVerificationCreatedBy;
    /**
     * date on which the bank details were created
     * @type {string}
     * @memberof BankDetailsVerification
     */
    'createdOn'?: string;
    /**
     * 
     * @type {BankDetailsVerificationVerificationInfo}
     * @memberof BankDetailsVerification
     */
    'verificationInfo'?: BankDetailsVerificationVerificationInfo;
}

/**
    * @export
    * @enum {string}
    */
export enum BankDetailsVerificationVerificationStatusEnum {
    Active = 'Active',
    Pending = 'Pending',
    Bypassed = 'Bypassed'
}

/**
 * the info associated with the user that created the bank details
 * @export
 * @interface BankDetailsVerificationCreatedBy
 */
export interface BankDetailsVerificationCreatedBy {
    /**
     * id of the user that created the bank details
     * @type {string}
     * @memberof BankDetailsVerificationCreatedBy
     */
    'userId'?: string;
    /**
     * firm id of the user that created the bank details
     * @type {string}
     * @memberof BankDetailsVerificationCreatedBy
     */
    'userFirmId'?: string;
    /**
     * type of the user that verified the bank details
     * @type {string}
     * @memberof BankDetailsVerificationCreatedBy
     */
    'userType'?: BankDetailsVerificationCreatedByUserTypeEnum;
    /**
     * name of the user that verified the bank details
     * @type {string}
     * @memberof BankDetailsVerificationCreatedBy
     */
    'userName'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BankDetailsVerificationCreatedByUserTypeEnum {
    Client = 'Client',
    User = 'User',
    Machine = 'Machine'
}

/**
 * the info associated with the verification of bank details
 * @export
 * @interface BankDetailsVerificationVerificationInfo
 */
export interface BankDetailsVerificationVerificationInfo {
    /**
     * date on which the bank details were verified
     * @type {string}
     * @memberof BankDetailsVerificationVerificationInfo
     */
    'verifiedOn'?: string;
    /**
     * 
     * @type {BankDetailsVerificationVerificationInfoVerifiedBy}
     * @memberof BankDetailsVerificationVerificationInfo
     */
    'verifiedBy'?: BankDetailsVerificationVerificationInfoVerifiedBy;
    /**
     * 
     * @type {BankDetailsVerificationVerificationInfoSource}
     * @memberof BankDetailsVerificationVerificationInfo
     */
    'source'?: BankDetailsVerificationVerificationInfoSource;
}
/**
 * the source of the bank account verification
 * @export
 * @interface BankDetailsVerificationVerificationInfoSource
 */
export interface BankDetailsVerificationVerificationInfoSource {
    /**
     * whether the verification was automatic or manual
     * @type {string}
     * @memberof BankDetailsVerificationVerificationInfoSource
     */
    'method'?: BankDetailsVerificationVerificationInfoSourceMethodEnum;
    /**
     * the external system for the bank account verification
     * @type {string}
     * @memberof BankDetailsVerificationVerificationInfoSource
     */
    'externalSystem'?: string;
    /**
     * verification reference id within the external system
     * @type {string}
     * @memberof BankDetailsVerificationVerificationInfoSource
     */
    'referenceId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BankDetailsVerificationVerificationInfoSourceMethodEnum {
    Manual = 'Manual',
    Automatic = 'Automatic'
}

/**
 * contains info on who verified the bank details
 * @export
 * @interface BankDetailsVerificationVerificationInfoVerifiedBy
 */
export interface BankDetailsVerificationVerificationInfoVerifiedBy {
    /**
     * id of the user that verified the bank details
     * @type {string}
     * @memberof BankDetailsVerificationVerificationInfoVerifiedBy
     */
    'userId'?: string;
    /**
     * firm id of the user that verified the bank details
     * @type {string}
     * @memberof BankDetailsVerificationVerificationInfoVerifiedBy
     */
    'userFirmId'?: string;
    /**
     * type of the user that verified the bank details
     * @type {string}
     * @memberof BankDetailsVerificationVerificationInfoVerifiedBy
     */
    'userType'?: BankDetailsVerificationVerificationInfoVerifiedByUserTypeEnum;
    /**
     * name of the user that verified the bank details
     * @type {string}
     * @memberof BankDetailsVerificationVerificationInfoVerifiedBy
     */
    'userName'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BankDetailsVerificationVerificationInfoVerifiedByUserTypeEnum {
    Client = 'Client',
    User = 'User',
    Machine = 'Machine'
}

/**
 * 
 * @export
 * @interface BaseAccountPosition
 */
export interface BaseAccountPosition {
    /**
     * 
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'accountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'accountType'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'currency'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'nodeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'positionType': string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccountPosition
     */
    'updateId'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseAccountPosition
     */
    'growth'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccountPosition
     */
    'growthPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccountPosition
     */
    'adjustedGrowth'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccountPosition
     */
    'adjustedGrowthPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccountPosition
     */
    'openingValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccountPosition
     */
    'allocation'?: number;
}
/**
 * 
 * @export
 * @interface BaseCreateClient
 */
export interface BaseCreateClient {
    /**
     * 
     * @type {string}
     * @memberof BaseCreateClient
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof BaseCreateClient
     */
    'firmId'?: string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof BaseCreateClient
     */
    'nodeId'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseCreateClient
     */
    'clientType'?: string;
    /**
     * The status of the client
     * @type {string}
     * @memberof BaseCreateClient
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof BaseCreateClient
     */
    'currency'?: string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof BaseCreateClient
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof BaseCreateClient
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof BaseCreateClient
     */
    'language'?: string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof BaseCreateClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof BaseCreateClient
     */
    'taxDomicile'?: string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof BaseCreateClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof BaseCreateClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
}
/**
 * 
 * @export
 * @interface BaseCreateClientBankDetails
 */
export interface BaseCreateClientBankDetails {
    /**
     * The client\'s bank\'s sort code. This is a six-digit number
     * @type {string}
     * @memberof BaseCreateClientBankDetails
     */
    'sortCode'?: string;
    /**
     * The client\'s account number. This is an eight-digit number
     * @type {string}
     * @memberof BaseCreateClientBankDetails
     */
    'accountNumber'?: string;
    /**
     * Any
     * @type {boolean}
     * @memberof BaseCreateClientBankDetails
     */
    'debitPaymentMandate'?: boolean;
    /**
     * date of agreement
     * @type {string}
     * @memberof BaseCreateClientBankDetails
     */
    'debitPaymentMandateAgreementDate'?: string;
}
/**
 * object containing clients group affiliations
 * @export
 * @interface BaseCreateClientClientGroups
 */
export interface BaseCreateClientClientGroups {
    /**
     * id of client fee group client is linked to
     * @type {string}
     * @memberof BaseCreateClientClientGroups
     */
    'clientFeeGroupId'?: string;
}
/**
 * Fee structures applied directly to the client
 * @export
 * @interface BaseCreateClientFeeStructures
 */
export interface BaseCreateClientFeeStructures {
    /**
     * Platform fee structure ID
     * @type {string}
     * @memberof BaseCreateClientFeeStructures
     */
    'platformFeeId'?: string | null;
    /**
     * Adviser fee structure ID
     * @type {string}
     * @memberof BaseCreateClientFeeStructures
     */
    'adviserFeeId'?: string | null;
}
/**
 * 
 * @export
 * @interface BaseEvent
 */
export interface BaseEvent {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof BaseEvent
     */
    'firmId': string;
    /**
     * The type of event occurring on the account.
     * @type {string}
     * @memberof BaseEvent
     */
    'eventType': string;
}
/**
 * 
 * @export
 * @interface BasePersistedClient
 */
export interface BasePersistedClient {
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClient
     */
    'id': string;
    /**
     * 
     * @type {ClientStatusEnum}
     * @memberof BasePersistedClient
     */
    'status': ClientStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClient
     */
    'emailToken'?: string;
    /**
     * expiry date/ time
     * @type {string}
     * @memberof BasePersistedClient
     */
    'emailTokenExpiry'?: string;
    /**
     * Flag signifing if the client has completed the email verification flow
     * @type {boolean}
     * @memberof BasePersistedClient
     */
    'emailVerified'?: boolean;
    /**
     * Flag signifing if the clients mobile number has been verifed
     * @type {boolean}
     * @memberof BasePersistedClient
     */
    'mobileVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClient
     */
    'smsToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClient
     */
    'smsTokenExpiry'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BasePersistedClient
     */
    'smsTokenVerified'?: boolean;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof BasePersistedClient
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof BasePersistedClient
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<BasePersistedClientNationalitiesInner>}
     * @memberof BasePersistedClient
     */
    'nationalities'?: Array<BasePersistedClientNationalitiesInner>;
    /**
     * The client\'s birth date in iso date time format
     * @type {string}
     * @memberof BasePersistedClient
     */
    'dateOfBirth'?: string;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof BasePersistedClient
     */
    'taxDomicile'?: string;
    /**
     * Before creating a client record, you must carry out necessary AML/KYC checks – this should be set to Approved
     * @type {string}
     * @memberof BasePersistedClient
     */
    'amlStatus'?: string;
    /**
     * 
     * @type {BasePersistedClientAmlData}
     * @memberof BasePersistedClient
     */
    'amlData'?: BasePersistedClientAmlData;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof BasePersistedClient
     */
    'termsAccepted'?: boolean;
    /**
     * The date time stamp of when the T&C\'s were accepted by the client
     * @type {string}
     * @memberof BasePersistedClient
     */
    'termsAcceptedDate'?: string;
    /**
     * 
     * @type {BasePersistedClientCommsStatus}
     * @memberof BasePersistedClient
     */
    'commsStatus'?: BasePersistedClientCommsStatus;
    /**
     * 
     * @type {Array<BasePersistedClientExternalIdsInner>}
     * @memberof BasePersistedClient
     */
    'externalIds'?: Array<BasePersistedClientExternalIdsInner>;
    /**
     * 
     * @type {BasePersistedClientBankDetails}
     * @memberof BasePersistedClient
     */
    'bankDetails'?: BasePersistedClientBankDetails;
    /**
     * The date the client record was created in ISO format (YYYY-MM-DD)
     * @type {string}
     * @memberof BasePersistedClient
     */
    'recordCreationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClient
     */
    'updateId': string;
    /**
     * Contains details of updates made to the client record
     * @type {Array<BasePersistedClientUpdateHistoryInner>}
     * @memberof BasePersistedClient
     */
    'updateHistory'?: Array<BasePersistedClientUpdateHistoryInner>;
    /**
     * 
     * @type {BasePersistedClientAuditDetails}
     * @memberof BasePersistedClient
     */
    'auditDetails'?: BasePersistedClientAuditDetails;
}


/**
 * Object containing details of the AML check
 * @export
 * @interface BasePersistedClientAmlData
 */
export interface BasePersistedClientAmlData {
    /**
     * 
     * @type {boolean}
     * @memberof BasePersistedClientAmlData
     */
    'amlEvidenceSeen'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClientAmlData
     */
    'checkDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClientAmlData
     */
    'checkResult'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasePersistedClientAmlData
     */
    'checkNode'?: Array<string>;
    /**
     * 
     * @type {Array<BasePersistedClientAmlDataChecksInner>}
     * @memberof BasePersistedClientAmlData
     */
    'checks'?: Array<BasePersistedClientAmlDataChecksInner>;
}
/**
 * 
 * @export
 * @interface BasePersistedClientAmlDataChecksInner
 */
export interface BasePersistedClientAmlDataChecksInner {
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClientAmlDataChecksInner
     */
    'variant': string;
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClientAmlDataChecksInner
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasePersistedClientAmlDataChecksInner
     */
    'options'?: Array<string>;
}
/**
 * contains details of previous changes
 * @export
 * @interface BasePersistedClientAuditDetails
 */
export interface BasePersistedClientAuditDetails {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof BasePersistedClientAuditDetails
     */
    'updateDate'?: string;
    /**
     * Firm Id
     * @type {string}
     * @memberof BasePersistedClientAuditDetails
     */
    'userFirmId': string;
    /**
     * id of the user
     * @type {string}
     * @memberof BasePersistedClientAuditDetails
     */
    'userId': string;
    /**
     * version of the update
     * @type {number}
     * @memberof BasePersistedClientAuditDetails
     */
    'version': number;
    /**
     * Means of teh update
     * @type {string}
     * @memberof BasePersistedClientAuditDetails
     */
    'application': string;
}
/**
 * 
 * @export
 * @interface BasePersistedClientBankDetails
 */
export interface BasePersistedClientBankDetails {
    /**
     * The client\'s bank\'s sort code. This is a six-digit number
     * @type {string}
     * @memberof BasePersistedClientBankDetails
     */
    'sortCode'?: string;
    /**
     * The client\'s account number. This is an eight-digit number
     * @type {string}
     * @memberof BasePersistedClientBankDetails
     */
    'accountNumber'?: string;
    /**
     * Any
     * @type {boolean}
     * @memberof BasePersistedClientBankDetails
     */
    'debitPaymentMandate'?: boolean;
    /**
     * date of agreement
     * @type {string}
     * @memberof BasePersistedClientBankDetails
     */
    'debitPaymentMandateAgreementDate'?: string;
    /**
     * verification status of the bank details
     * @type {string}
     * @memberof BasePersistedClientBankDetails
     */
    'verificationStatus'?: BasePersistedClientBankDetailsVerificationStatusEnum;
    /**
     * 
     * @type {BankDetailsVerificationCreatedBy}
     * @memberof BasePersistedClientBankDetails
     */
    'createdBy'?: BankDetailsVerificationCreatedBy;
    /**
     * date on which the bank details were created
     * @type {string}
     * @memberof BasePersistedClientBankDetails
     */
    'createdOn'?: string;
    /**
     * 
     * @type {BankDetailsVerificationVerificationInfo}
     * @memberof BasePersistedClientBankDetails
     */
    'verificationInfo'?: BankDetailsVerificationVerificationInfo;
}

/**
    * @export
    * @enum {string}
    */
export enum BasePersistedClientBankDetailsVerificationStatusEnum {
    Active = 'Active',
    Pending = 'Pending',
    Bypassed = 'Bypassed'
}

/**
 * 
 * @export
 * @interface BasePersistedClientCommsStatus
 */
export interface BasePersistedClientCommsStatus {
    /**
     * 
     * @type {boolean}
     * @memberof BasePersistedClientCommsStatus
     */
    'welcomeSent'?: boolean;
}
/**
 * 
 * @export
 * @interface BasePersistedClientExternalIdsInner
 */
export interface BasePersistedClientExternalIdsInner {
    /**
     * Name of the external id
     * @type {string}
     * @memberof BasePersistedClientExternalIdsInner
     */
    'idType'?: string;
    /**
     * value of the external ID
     * @type {string}
     * @memberof BasePersistedClientExternalIdsInner
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface BasePersistedClientNationalitiesInner
 */
export interface BasePersistedClientNationalitiesInner {
    /**
     * Nationality code
     * @type {string}
     * @memberof BasePersistedClientNationalitiesInner
     */
    'code'?: string;
    /**
     * Contains the identifer object
     * @type {Array<BasePersistedClientNationalitiesInnerIdentifiersInner>}
     * @memberof BasePersistedClientNationalitiesInner
     */
    'identifiers'?: Array<BasePersistedClientNationalitiesInnerIdentifiersInner>;
}
/**
 * 
 * @export
 * @interface BasePersistedClientNationalitiesInnerIdentifiersInner
 */
export interface BasePersistedClientNationalitiesInnerIdentifiersInner {
    /**
     * Name of national identifer
     * @type {string}
     * @memberof BasePersistedClientNationalitiesInnerIdentifiersInner
     */
    'name'?: string;
    /**
     * Is avalible
     * @type {boolean}
     * @memberof BasePersistedClientNationalitiesInnerIdentifiersInner
     */
    'available'?: boolean;
    /**
     * value of the identifer
     * @type {string}
     * @memberof BasePersistedClientNationalitiesInnerIdentifiersInner
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface BasePersistedClientUpdateHistoryInner
 */
export interface BasePersistedClientUpdateHistoryInner {
    /**
     * Id of the update
     * @type {number}
     * @memberof BasePersistedClientUpdateHistoryInner
     */
    'updateId'?: number;
    /**
     * Date update was applied
     * @type {string}
     * @memberof BasePersistedClientUpdateHistoryInner
     */
    'updateDate'?: string;
    /**
     * 
     * @type {BasePersistedClientUpdateHistoryInnerUpdateData}
     * @memberof BasePersistedClientUpdateHistoryInner
     */
    'updateData'?: BasePersistedClientUpdateHistoryInnerUpdateData;
    /**
     * The action that performed the update
     * @type {string}
     * @memberof BasePersistedClientUpdateHistoryInner
     */
    'updateAction'?: string;
    /**
     * Description of the reason for the update
     * @type {string}
     * @memberof BasePersistedClientUpdateHistoryInner
     */
    'updateReason'?: string;
    /**
     * Array of the Name of the fields that were updated
     * @type {Array<string>}
     * @memberof BasePersistedClientUpdateHistoryInner
     */
    'updatedFields'?: Array<string>;
}
/**
 * Object containing name of updated field and data updated
 * @export
 * @interface BasePersistedClientUpdateHistoryInnerUpdateData
 */
export interface BasePersistedClientUpdateHistoryInnerUpdateData {
    /**
     * 
     * @type {BasePersistedClientUpdateHistoryInnerUpdateDataFromData}
     * @memberof BasePersistedClientUpdateHistoryInnerUpdateData
     */
    'fromData'?: BasePersistedClientUpdateHistoryInnerUpdateDataFromData;
    /**
     * 
     * @type {BasePersistedClientUpdateHistoryInnerUpdateDataToData}
     * @memberof BasePersistedClientUpdateHistoryInnerUpdateData
     */
    'toData'?: BasePersistedClientUpdateHistoryInnerUpdateDataToData;
}
/**
 * Updated field and previous value
 * @export
 * @interface BasePersistedClientUpdateHistoryInnerUpdateDataFromData
 */
export interface BasePersistedClientUpdateHistoryInnerUpdateDataFromData {
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClientUpdateHistoryInnerUpdateDataFromData
     */
    'dateOfBirth'?: string;
}
/**
 * Updated field and updated value
 * @export
 * @interface BasePersistedClientUpdateHistoryInnerUpdateDataToData
 */
export interface BasePersistedClientUpdateHistoryInnerUpdateDataToData {
    /**
     * 
     * @type {string}
     * @memberof BasePersistedClientUpdateHistoryInnerUpdateDataToData
     */
    'dateOfBirth'?: string;
}
/**
 * 
 * @export
 * @interface BasePortfolioGroup
 */
export interface BasePortfolioGroup {
    /**
     * The unique identifier for the firm
     * @type {string}
     * @memberof BasePortfolioGroup
     */
    'firmId': string;
    /**
     * The intent or purpose of the group
     * @type {string}
     * @memberof BasePortfolioGroup
     */
    'groupIntent': BasePortfolioGroupGroupIntentEnum;
    /**
     * The display name of the group
     * @type {string}
     * @memberof BasePortfolioGroup
     */
    'name': string;
    /**
     * The unique identifier of the node to which this client group is scoped
     * @type {string}
     * @memberof BasePortfolioGroup
     */
    'nodeId': string;
}

/**
    * @export
    * @enum {string}
    */
export enum BasePortfolioGroupGroupIntentEnum {
    ClientFeeGroup = 'Client Fee Group',
    PensionAccountGroup = 'Pension Account Group'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum BeneficiaryRelationship {
    Charity = 'CHARITY',
    Wife = 'WIFE',
    Husband = 'HUSBAND',
    Daughter = 'DAUGHTER',
    Son = 'SON',
    Partner = 'PARTNER',
    Other = 'OTHER'
}


/**
 * Title of beneficiary
 * @export
 * @enum {string}
 */

export enum BeneficiaryTitle {
    Dr = 'Dr',
    Miss = 'Miss',
    Mr = 'Mr',
    Mrs = 'Mrs',
    Ms = 'Ms',
    Mx = 'Mx',
    Professor = 'Professor',
    Prof = 'Prof',
    Hon = 'Hon',
    Sir = 'Sir',
    Lord = 'Lord',
    Lady = 'Lady',
    Viscount = 'Viscount',
    Viscountess = 'Viscountess',
    Earl = 'Earl',
    Countess = 'Countess',
    Duke = 'Duke',
    Duchess = 'Duchess',
    Rev = 'Rev',
    Dame = 'Dame',
    Master = 'Master',
    Judge = 'Judge',
    Rabbi = 'Rabbi'
}


/**
 * 
 * @export
 * @interface BookValueFields
 */
export interface BookValueFields {
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof BookValueFields
     */
    'bookValue'?: number;
    /**
     * The book cost since the transfer settled
     * @type {number}
     * @memberof BookValueFields
     */
    'nonTransferBookValue'?: number;
    /**
     * The number of units multiplied by the price on the day the transfer settled. This will be the same as the bookValue if there\'s been no in-specie transfer 
     * @type {number}
     * @memberof BookValueFields
     */
    'transferBookValue'?: number;
}
/**
 * 
 * @export
 * @interface CapitalGainsScenarioSimulatedInvestment
 */
export interface CapitalGainsScenarioSimulatedInvestment {
    /**
     * The unique identifier of the asset
     * @type {string}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'assetId': string;
    /**
     * The short name of the asset
     * @type {string}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'assetName': string;
    /**
     * International Securities Identification Number (ISIN). A 12-digit alphanumeric code that uniquely identifies a specific security 
     * @type {string}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'isin': string;
    /**
     * The unique identifier of the position
     * @type {string}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'positionId': string;
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'bookValue': number;
    /**
     * A percentage value
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'allocation': number;
    /**
     * The number of units held
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'quantity': number;
    /**
     * The current value of the holding
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'value': number;
    /**
     * The realised profit or loss for this investment
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'realisedProfitLoss'?: number | null;
    /**
     * The current price per unit
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'price': number;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
    /**
     * The number of decimal places that the asset can be held. For example, 0.0001 means the asset can be held to 4 decimal places. This is driven by the fund manager or instrument type 
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'minimumTransferUnit': number;
    /**
     * 
     * @type {CapitalGainsScenarioSimulatedOrderResult}
     * @memberof CapitalGainsScenarioSimulatedInvestment
     */
    'simulatedOrder'?: CapitalGainsScenarioSimulatedOrderResult;
}
/**
 * 
 * @export
 * @interface CapitalGainsScenarioSimulatedOrder
 */
export interface CapitalGainsScenarioSimulatedOrder {
    /**
     * The number of units for the order
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrder
     */
    'unit': number;
    /**
     * 
     * @type {CapitalGainsSimulatedOrderUnitType}
     * @memberof CapitalGainsScenarioSimulatedOrder
     */
    'unitType': CapitalGainsSimulatedOrderUnitType;
    /**
     * 
     * @type {CapitalGainsSimulatedOrderMovementType}
     * @memberof CapitalGainsScenarioSimulatedOrder
     */
    'movementType': CapitalGainsSimulatedOrderMovementType;
}


/**
 * 
 * @export
 * @interface CapitalGainsScenarioSimulatedOrderResult
 */
export interface CapitalGainsScenarioSimulatedOrderResult {
    /**
     * 
     * @type {CapitalGainsSimulatedOrderUnitType}
     * @memberof CapitalGainsScenarioSimulatedOrderResult
     */
    'unitType': CapitalGainsSimulatedOrderUnitType;
    /**
     * The number of units specified for the order
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrderResult
     */
    'unit': number;
    /**
     * The calculated quantity of units for the order
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrderResult
     */
    'quantity': number;
    /**
     * 
     * @type {CapitalGainsSimulatedOrderMovementType}
     * @memberof CapitalGainsScenarioSimulatedOrderResult
     */
    'movementType': CapitalGainsSimulatedOrderMovementType;
    /**
     * The projected profit or loss from this simulated order
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrderResult
     */
    'profitLoss': number;
    /**
     * The projected value of the simulated order
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrderResult
     */
    'value': number;
    /**
     * The book value attributed to the simulated order
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrderResult
     */
    'bookValue': number;
}


/**
 * 
 * @export
 * @interface CapitalGainsScenarioSimulatedOrderTotals
 */
export interface CapitalGainsScenarioSimulatedOrderTotals {
    /**
     * Total projected profit or loss from all simulated orders
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrderTotals
     */
    'profitLoss': number;
    /**
     * Total projected value of all simulated orders
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrderTotals
     */
    'value': number;
    /**
     * Total book value of all simulated orders
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedOrderTotals
     */
    'bookValue': number;
}
/**
 * 
 * @export
 * @interface CapitalGainsScenarioSimulatedTotals
 */
export interface CapitalGainsScenarioSimulatedTotals {
    /**
     * Total realised profit or loss across all investments
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedTotals
     */
    'realisedProfitLoss': number;
    /**
     * Total value of all investments including simulated orders
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedTotals
     */
    'value': number;
    /**
     * Total book value of all investments including simulated orders
     * @type {number}
     * @memberof CapitalGainsScenarioSimulatedTotals
     */
    'bookValue': number;
    /**
     * 
     * @type {CapitalGainsScenarioSimulatedOrderTotals}
     * @memberof CapitalGainsScenarioSimulatedTotals
     */
    'simulatedOrders'?: CapitalGainsScenarioSimulatedOrderTotals;
}
/**
 * 
 * @export
 * @interface CapitalGainsScenarioSpreadsheetLinkResponse
 */
export interface CapitalGainsScenarioSpreadsheetLinkResponse {
    /**
     * 
     * @type {FilesFileTypePost200ResponseData}
     * @memberof CapitalGainsScenarioSpreadsheetLinkResponse
     */
    'data'?: FilesFileTypePost200ResponseData;
}
/**
 * The movement type for the simulated order
 * @export
 * @enum {string}
 */

export enum CapitalGainsSimulatedOrderMovementType {
    Buy = 'Buy',
    Sell = 'Sell'
}


/**
 * The type of unit for the simulated order
 * @export
 * @enum {string}
 */

export enum CapitalGainsSimulatedOrderUnitType {
    Quantity = 'Quantity',
    Amount = 'Amount',
    Percentage = 'Percentage'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum CashTransferValueType {
    Partial = 'Partial',
    Full = 'Full'
}


/**
 * 
 * @export
 * @interface CedingProvider
 */
export interface CedingProvider {
    /**
     * The unique identifier of the ceding provider
     * @type {string}
     * @memberof CedingProvider
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CedingProvider
     */
    'firmId': string;
    /**
     * The name of the ceding provider
     * @type {string}
     * @memberof CedingProvider
     */
    'name': string;
    /**
     * The status of the ceding provider
     * @type {string}
     * @memberof CedingProvider
     */
    'status'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof CedingProvider
     */
    'partyType'?: string;
    /**
     * Contains details of the ceding provider\'s external Ids in Origo and/or ATG
     * @type {Array<CedingProviderExternalIdsInner>}
     * @memberof CedingProvider
     */
    'externalIds'?: Array<CedingProviderExternalIdsInner>;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof CedingProvider
     */
    'companyType'?: Array<string>;
    /**
     * 
     * @type {GetIllustrationsListDataInnerAuditDetails}
     * @memberof CedingProvider
     */
    'auditDetails'?: GetIllustrationsListDataInnerAuditDetails;
    /**
     * Unique hash for previous change
     * @type {string}
     * @memberof CedingProvider
     */
    'updateId'?: string;
    /**
     * Contains details of what the ceding provider can facilitate for each system. If this does not exist for a given masterparty object, then it is not available to request a transfer from electronically
     * @type {Array<CedingProviderTransferProvidersInner>}
     * @memberof CedingProvider
     */
    'transferProviders'?: Array<CedingProviderTransferProvidersInner>;
}
/**
 * 
 * @export
 * @interface CedingProviderExternalIdsInner
 */
export interface CedingProviderExternalIdsInner {
    /**
     * The system that the identifier relates to
     * @type {string}
     * @memberof CedingProviderExternalIdsInner
     */
    'idType'?: string;
    /**
     * The ceding provider\'s identifier in the external system
     * @type {string}
     * @memberof CedingProviderExternalIdsInner
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface CedingProviderTransferProvidersInner
 */
export interface CedingProviderTransferProvidersInner {
    /**
     * The ceding provider\'s identifier in the external system
     * @type {string}
     * @memberof CedingProviderTransferProvidersInner
     */
    'providerReference'?: string;
    /**
     * 
     * @type {CedingProviderTransferProvidersInnerPENSION}
     * @memberof CedingProviderTransferProvidersInner
     */
    'PENSION'?: CedingProviderTransferProvidersInnerPENSION;
    /**
     * 
     * @type {CedingProviderTransferProvidersInnerPENSION}
     * @memberof CedingProviderTransferProvidersInner
     */
    'GIA'?: CedingProviderTransferProvidersInnerPENSION;
    /**
     * 
     * @type {CedingProviderTransferProvidersInnerISA}
     * @memberof CedingProviderTransferProvidersInner
     */
    'ISA'?: CedingProviderTransferProvidersInnerISA;
    /**
     * 
     * @type {CedingProviderTransferProvidersInnerJISA}
     * @memberof CedingProviderTransferProvidersInner
     */
    'JISA'?: CedingProviderTransferProvidersInnerJISA;
    /**
     * The external transfer system that the information contained in the array relates to
     * @type {string}
     * @memberof CedingProviderTransferProvidersInner
     */
    'transferProviderName': string;
}
/**
 * Contains details of what type of transfers can be supported for that wrapperType – for ATG transfers, this will include PENSION, GIA, ISA, and JISA; and for Origo transfers, this will include PENSION only
 * @export
 * @interface CedingProviderTransferProvidersInnerISA
 */
export interface CedingProviderTransferProvidersInnerISA {
    /**
     * Indicates whether cash transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerISA
     */
    'cashSupported'?: boolean;
    /**
     * Indicates whether in-specie transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerISA
     */
    'inSpecieSupported': boolean;
    /**
     * Indicates whether manual cash transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerISA
     */
    'manualCash'?: boolean;
    /**
     * Indicates whether manual in-specie transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerISA
     */
    'manualInSpecie'?: boolean;
    /**
     * Indicates what type of signature is required
     * @type {string}
     * @memberof CedingProviderTransferProvidersInnerISA
     */
    'signatureType'?: CedingProviderTransferProvidersInnerISASignatureTypeEnum;
    /**
     * This can be used to indicate what the ceding provider account reference should look like
     * @type {string}
     * @memberof CedingProviderTransferProvidersInnerISA
     */
    'accountReferenceHint': string;
    /**
     * Indicates whether the provider supports PayUK transfers for ISA
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerISA
     */
    'supportsPayUk'?: boolean;
    /**
     * Indicates whether the provider supports partial cash transfers
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerISA
     */
    'partialCash'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum CedingProviderTransferProvidersInnerISASignatureTypeEnum {
    Wet = 'Wet',
    Scanned = 'Scanned',
    Electronic = 'Electronic'
}

/**
 * Contains details of what type of transfers can be supported for that wrapperType – for ATG transfers, this will include PENSION, GIA, ISA, and JISA; and for Origo transfers, this will include PENSION only
 * @export
 * @interface CedingProviderTransferProvidersInnerJISA
 */
export interface CedingProviderTransferProvidersInnerJISA {
    /**
     * Indicates whether cash transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerJISA
     */
    'cashSupported'?: boolean;
    /**
     * Indicates whether in-specie transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerJISA
     */
    'inSpecieSupported': boolean;
    /**
     * Indicates whether manual cash transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerJISA
     */
    'manualCash'?: boolean;
    /**
     * Indicates whether manual in-specie transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerJISA
     */
    'manualInSpecie'?: boolean;
    /**
     * Indicates what type of signature is required
     * @type {string}
     * @memberof CedingProviderTransferProvidersInnerJISA
     */
    'signatureType'?: CedingProviderTransferProvidersInnerJISASignatureTypeEnum;
    /**
     * This can be used to indicate what the ceding provider account reference should look like
     * @type {string}
     * @memberof CedingProviderTransferProvidersInnerJISA
     */
    'accountReferenceHint': string;
    /**
     * Indicates whether the provider supports PayUK transfers for JISA
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerJISA
     */
    'supportsPayUk'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum CedingProviderTransferProvidersInnerJISASignatureTypeEnum {
    Wet = 'Wet',
    Scanned = 'Scanned',
    Electronic = 'Electronic'
}

/**
 * Contains details of what type of transfers can be supported for that wrapperType – for ATG transfers, this will include PENSION, GIA, ISA, and JISA; and for Origo transfers, this will include PENSION only
 * @export
 * @interface CedingProviderTransferProvidersInnerPENSION
 */
export interface CedingProviderTransferProvidersInnerPENSION {
    /**
     * Indicates whether cash transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerPENSION
     */
    'cashSupported'?: boolean;
    /**
     * Indicates whether in-specie transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerPENSION
     */
    'inSpecieSupported': boolean;
    /**
     * Indicates whether manual cash transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerPENSION
     */
    'manualCash'?: boolean;
    /**
     * Indicates whether manual in-specie transfers are supported
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerPENSION
     */
    'manualInSpecie'?: boolean;
    /**
     * Indicates what type of signature is required
     * @type {string}
     * @memberof CedingProviderTransferProvidersInnerPENSION
     */
    'signatureType'?: CedingProviderTransferProvidersInnerPENSIONSignatureTypeEnum;
    /**
     * This can be used to indicate what the ceding provider account reference should look like
     * @type {string}
     * @memberof CedingProviderTransferProvidersInnerPENSION
     */
    'accountReferenceHint': string;
    /**
     * Indicates whether the provider supports partial cash transfers
     * @type {boolean}
     * @memberof CedingProviderTransferProvidersInnerPENSION
     */
    'partialCash'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum CedingProviderTransferProvidersInnerPENSIONSignatureTypeEnum {
    Wet = 'Wet',
    Scanned = 'Scanned',
    Electronic = 'Electronic'
}

/**
 * 
 * @export
 * @interface CgtData
 */
export interface CgtData {
    /**
     * The realised profit loss for the portfolio
     * @type {number}
     * @memberof CgtData
     */
    'realisedProfitLoss'?: number | null;
    /**
     * The unrealised profit loss for the portfolio
     * @type {number}
     * @memberof CgtData
     */
    'unrealisedProfitLoss'?: number | null;
    /**
     * The value of stock at closing for the portfolio
     * @type {number}
     * @memberof CgtData
     */
    'closingGiaStockValue'?: number;
    /**
     * The list of matches that were found for the transaction
     * @type {Array<CgtMatch>}
     * @memberof CgtData
     */
    'matches'?: Array<CgtMatch>;
}
/**
 * 
 * @export
 * @interface CgtDisclaimerEntity
 */
export interface CgtDisclaimerEntity {
    /**
     * 
     * @type {Array<string>}
     * @memberof CgtDisclaimerEntity
     */
    'ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CgtDisclaimerEntity
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface CgtDisclaimersInner
 */
export interface CgtDisclaimersInner {
    /**
     * 
     * @type {DisclaimerType}
     * @memberof CgtDisclaimersInner
     */
    'type': DisclaimerType;
    /**
     * 
     * @type {string}
     * @memberof CgtDisclaimersInner
     */
    'text': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CgtDisclaimersInner
     */
    'fields': Array<string>;
    /**
     * 
     * @type {CgtDisclaimerEntity}
     * @memberof CgtDisclaimersInner
     */
    'entity'?: CgtDisclaimerEntity;
}


/**
 * 
 * @export
 * @interface CgtMatch
 */
export interface CgtMatch {
    /**
     * The type of match
     * @type {string}
     * @memberof CgtMatch
     */
    'matchType'?: CgtMatchMatchTypeEnum;
    /**
     * The date of the match
     * @type {string}
     * @memberof CgtMatch
     */
    'matchDate'?: string;
    /**
     * The number of units matched
     * @type {number}
     * @memberof CgtMatch
     */
    'matchedUnits'?: number;
    /**
     * The total book value of the matched units
     * @type {number}
     * @memberof CgtMatch
     */
    'matchedTotalBookValue'?: number | null;
    /**
     * The ids of the buy transactions that were matched
     * @type {Array<string>}
     * @memberof CgtMatch
     */
    'buyTransactionIds'?: Array<string> | null;
    /**
     * The ids of the sell transactions that were matched
     * @type {string}
     * @memberof CgtMatch
     */
    'sellTransactionId'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CgtMatchMatchTypeEnum {
    SameDayMatch = 'SAME_DAY_MATCH',
    ThirtyDayMatch = 'THIRTY_DAY_MATCH'
}

/**
 * 
 * @export
 * @interface CgtTarget
 */
export interface CgtTarget {
    /**
     * 
     * @type {CgtTargetType}
     * @memberof CgtTarget
     */
    'type': CgtTargetType;
    /**
     * The target amount to raise
     * @type {number}
     * @memberof CgtTarget
     */
    'amount': number;
    /**
     * 
     * @type {CgtTargetStrategy}
     * @memberof CgtTarget
     */
    'strategy': CgtTargetStrategy;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum CgtTargetStrategy {
    MostUnits = 'MostUnits',
    LeastUnits = 'LeastUnits',
    HighestPercentGain = 'HighestPercentGain',
    LowestPercentGain = 'LowestPercentGain',
    HighestTotalGain = 'HighestTotalGain',
    LowestTotalGain = 'LowestTotalGain',
    ProportionalValue = 'ProportionalValue'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum CgtTargetType {
    Value = 'Value',
    Gain = 'Gain'
}


/**
 * Change password object
 * @export
 * @interface ChangePassword
 */
export interface ChangePassword {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ChangePassword
     */
    'firmId'?: string;
    /**
     * Unique identifer for the user
     * @type {string}
     * @memberof ChangePassword
     */
    'id'?: string;
    /**
     * Existing password for the user
     * @type {string}
     * @memberof ChangePassword
     */
    'password'?: string;
    /**
     * The secret password to be set
     * @type {string}
     * @memberof ChangePassword
     */
    'newPassword'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ChargeType {
    Stamp = 'Stamp',
    Ptm = 'PTM',
    Dilution = 'Dilution',
    Initial = 'Initial',
    AccruedInterest = 'Accrued Interest',
    Platform = 'Platform',
    Dealing = 'Dealing',
    ExAnteEntry = 'Ex Ante Entry',
    ExAnteOngoing = 'Ex Ante Ongoing',
    ExAnteIncidental = 'Ex Ante Incidental',
    ExAnteTransaction = 'Ex Ante Transaction',
    ExAnteExit = 'Ex Ante Exit',
    IMifidCharge = 'IMifidCharge',
    Ocf = 'OCF'
}


/**
 * @type Client
 * @export
 */
export type Client = ClientEntity | ClientPerson;

/**
 * 
 * @export
 * @interface ClientAmlCheck
 */
export interface ClientAmlCheck {
    /**
     * 
     * @type {string}
     * @memberof ClientAmlCheck
     */
    'completedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAmlCheck
     */
    'trigger': ClientAmlCheckTriggerEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientAmlCheck
     */
    'outcome': ClientAmlCheckOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientAmlCheck
     */
    'vendor': ClientAmlCheckVendorEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientAmlCheck
     */
    'checkUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAmlCheck
     */
    'checkProfile': string;
    /**
     * 
     * @type {Array<AmlAlert>}
     * @memberof ClientAmlCheck
     */
    'alerts'?: Array<AmlAlert>;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientAmlCheckTriggerEnum {
    NewClientOnboarding = 'New Client Onboarding',
    BankDetailsChanged = 'Bank Details Changed'
}
/**
    * @export
    * @enum {string}
    */
export enum ClientAmlCheckOutcomeEnum {
    Accepted = 'Accepted',
    Verified = 'Verified',
    Failed = 'Failed'
}
/**
    * @export
    * @enum {string}
    */
export enum ClientAmlCheckVendorEnum {
    Northrow = 'Northrow'
}

/**
 * Object containing details of the AML check
 * @export
 * @interface ClientAmlData
 */
export interface ClientAmlData {
    /**
     * Flag to show if AML evidence has been seen
     * @type {boolean}
     * @memberof ClientAmlData
     */
    'amlEvidenceSeen'?: boolean;
}
/**
 * 
 * @export
 * @interface ClientCorporateOptional
 */
export interface ClientCorporateOptional {
    /**
     * 
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'updateId': string;
    /**
     * 
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientCorporateOptional
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientCorporateOptional
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientCorporateOptional
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientCorporateOptional
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientCorporateOptional
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientCorporateOptional
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered company name
     * @type {string}
     * @memberof ClientCorporateOptional
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsCorporate}
     * @memberof ClientCorporateOptional
     */
    'entityDetails'?: EntityDetailsCorporate;
}
/**
 * 
 * @export
 * @interface ClientCorporateOptional1
 */
export interface ClientCorporateOptional1 {
    /**
     * 
     * @type {string}
     * @memberof ClientCorporateOptional1
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientCorporateOptional1
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientCorporateOptional1
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientCorporateOptional1
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientCorporateOptional1
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientCorporateOptional1
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientCorporateOptional1
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientCorporateOptional1
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientCorporateOptional1
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientCorporateOptional1
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientCorporateOptional1
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientCorporateOptional1
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientCorporateOptional1
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered company name
     * @type {string}
     * @memberof ClientCorporateOptional1
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsCorporate}
     * @memberof ClientCorporateOptional1
     */
    'entityDetails'?: EntityDetailsCorporate;
}
/**
 * 
 * @export
 * @interface ClientCorporateOptionalAllOf
 */
export interface ClientCorporateOptionalAllOf {
    /**
     * 
     * @type {string}
     * @memberof ClientCorporateOptionalAllOf
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientCorporateOptionalAllOf
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientCorporateOptionalAllOf
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientCorporateOptionalAllOf
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientCorporateOptionalAllOf
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientCorporateOptionalAllOf
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientCorporateOptionalAllOf
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientCorporateOptionalAllOf
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientCorporateOptionalAllOf
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientCorporateOptionalAllOf
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientCorporateOptionalAllOf
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientCorporateOptionalAllOf
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientCorporateOptionalAllOf
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered company name
     * @type {string}
     * @memberof ClientCorporateOptionalAllOf
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsCorporate}
     * @memberof ClientCorporateOptionalAllOf
     */
    'entityDetails'?: EntityDetailsCorporate;
}
/**
 * @type ClientEntity
 * @export
 */
export type ClientEntity = CorporateClient | TrustClient;

/**
 * @type ClientFirmIdGetClientTypeParameter
 * @export
 */
export type ClientFirmIdGetClientTypeParameter = Array<string> | string;

/**
 * @type ClientFirmIdGetIdParameter
 * @export
 */
export type ClientFirmIdGetIdParameter = Array<string> | string;

/**
 * @type ClientFirmIdGetStatusParameter
 * @export
 */
export type ClientFirmIdGetStatusParameter = Array<string> | string;

/**
 * 
 * @export
 * @interface ClientIndividualMinorOptional
 */
export interface ClientIndividualMinorOptional {
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'updateId': string;
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientIndividualMinorOptional
     */
    'nodeId'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'status': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientIndividualMinorOptional
     */
    'addressDetail': AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientIndividualMinorOptional
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientIndividualMinorOptional
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientIndividualMinorOptional
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The parent client ID for the child client being created
     * @type {Array<string>}
     * @memberof ClientIndividualMinorOptional
     */
    'parentId'?: Array<string>;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof ClientIndividualMinorOptional
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualMinorOptional
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualMinorOptional
     */
    'phone'?: Telephone;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof ClientIndividualMinorOptional
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof ClientIndividualMinorOptional
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof ClientIndividualMinorOptional
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof ClientIndividualMinorOptional
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof ClientIndividualMinorOptional
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof ClientIndividualMinorOptional
     */
    'kycData'?: ClientKycData;
}


/**
 * 
 * @export
 * @interface ClientIndividualMinorOptional1
 */
export interface ClientIndividualMinorOptional1 {
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientIndividualMinorOptional1
     */
    'nodeId'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'status': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientIndividualMinorOptional1
     */
    'addressDetail': AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientIndividualMinorOptional1
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional1
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientIndividualMinorOptional1
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientIndividualMinorOptional1
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The parent client ID for the child client being created
     * @type {Array<string>}
     * @memberof ClientIndividualMinorOptional1
     */
    'parentId'?: Array<string>;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof ClientIndividualMinorOptional1
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualMinorOptional1
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualMinorOptional1
     */
    'phone'?: Telephone;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof ClientIndividualMinorOptional1
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional1
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof ClientIndividualMinorOptional1
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof ClientIndividualMinorOptional1
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof ClientIndividualMinorOptional1
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof ClientIndividualMinorOptional1
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional1
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional1
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof ClientIndividualMinorOptional1
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof ClientIndividualMinorOptional1
     */
    'kycData'?: ClientKycData;
}


/**
 * 
 * @export
 * @interface ClientIndividualMinorOptionalAllOf
 */
export interface ClientIndividualMinorOptionalAllOf {
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'nodeId'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'status': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'addressDetail': AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The parent client ID for the child client being created
     * @type {Array<string>}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'parentId'?: Array<string>;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'phone'?: Telephone;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof ClientIndividualMinorOptionalAllOf
     */
    'kycData'?: ClientKycData;
}


/**
 * 
 * @export
 * @interface ClientIndividualOptional
 */
export interface ClientIndividualOptional {
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'updateId': string;
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientIndividualOptional
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'status': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientIndividualOptional
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientIndividualOptional
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientIndividualOptional
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientIndividualOptional
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientIndividualOptional
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof ClientIndividualOptional
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualOptional
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualOptional
     */
    'phone'?: Telephone;
    /**
     * The age the client is expected to retire
     * @type {number}
     * @memberof ClientIndividualOptional
     */
    'retirementAge'?: number;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof ClientIndividualOptional
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof ClientIndividualOptional
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * The client\'s foreign (non-UK) tax residencies. Each entry either provides a tax identification number (TIN) or a reason why one is not available.
     * @type {Array<ForeignTaxResidency>}
     * @memberof ClientIndividualOptional
     */
    'foreignTaxResidencies'?: Array<ForeignTaxResidency>;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof ClientIndividualOptional
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof ClientIndividualOptional
     */
    'dateOfBirth'?: string;
    /**
     * Contains details of the client\'s employer – only required where the client is making employer payments to their pension
     * @type {Array<EmployersInner>}
     * @memberof ClientIndividualOptional
     */
    'employers'?: Array<EmployersInner>;
    /**
     * 
     * @type {EmploymentStatus}
     * @memberof ClientIndividualOptional
     */
    'employmentStatus'?: EmploymentStatus;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof ClientIndividualOptional
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof ClientIndividualOptional
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof ClientIndividualOptional
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof ClientIndividualOptional
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof ClientIndividualOptional
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof ClientIndividualOptional
     */
    'kycData'?: ClientKycData;
    /**
     * 
     * @type {ClientMigration}
     * @memberof ClientIndividualOptional
     */
    'migration'?: ClientMigration;
}


/**
 * 
 * @export
 * @interface ClientIndividualOptional1
 */
export interface ClientIndividualOptional1 {
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientIndividualOptional1
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'status': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientIndividualOptional1
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientIndividualOptional1
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientIndividualOptional1
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientIndividualOptional1
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientIndividualOptional1
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof ClientIndividualOptional1
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualOptional1
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualOptional1
     */
    'phone'?: Telephone;
    /**
     * The age the client is expected to retire
     * @type {number}
     * @memberof ClientIndividualOptional1
     */
    'retirementAge'?: number;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof ClientIndividualOptional1
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof ClientIndividualOptional1
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * The client\'s foreign (non-UK) tax residencies. Each entry either provides a tax identification number (TIN) or a reason why one is not available.
     * @type {Array<ForeignTaxResidency>}
     * @memberof ClientIndividualOptional1
     */
    'foreignTaxResidencies'?: Array<ForeignTaxResidency>;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof ClientIndividualOptional1
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof ClientIndividualOptional1
     */
    'dateOfBirth'?: string;
    /**
     * Contains details of the client\'s employer – only required where the client is making employer payments to their pension
     * @type {Array<EmployersInner>}
     * @memberof ClientIndividualOptional1
     */
    'employers'?: Array<EmployersInner>;
    /**
     * 
     * @type {EmploymentStatus}
     * @memberof ClientIndividualOptional1
     */
    'employmentStatus'?: EmploymentStatus;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof ClientIndividualOptional1
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof ClientIndividualOptional1
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof ClientIndividualOptional1
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof ClientIndividualOptional1
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof ClientIndividualOptional1
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof ClientIndividualOptional1
     */
    'kycData'?: ClientKycData;
    /**
     * 
     * @type {ClientMigration}
     * @memberof ClientIndividualOptional1
     */
    'migration'?: ClientMigration;
}


/**
 * 
 * @export
 * @interface ClientIndividualOptionalAllOf
 */
export interface ClientIndividualOptionalAllOf {
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf
     */
    'updateId': string;
}
/**
 * 
 * @export
 * @interface ClientIndividualOptionalAllOf1
 */
export interface ClientIndividualOptionalAllOf1 {
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'status': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'phone'?: Telephone;
    /**
     * The age the client is expected to retire
     * @type {number}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'retirementAge'?: number;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * The client\'s foreign (non-UK) tax residencies. Each entry either provides a tax identification number (TIN) or a reason why one is not available.
     * @type {Array<ForeignTaxResidency>}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'foreignTaxResidencies'?: Array<ForeignTaxResidency>;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'dateOfBirth'?: string;
    /**
     * Contains details of the client\'s employer – only required where the client is making employer payments to their pension
     * @type {Array<EmployersInner>}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'employers'?: Array<EmployersInner>;
    /**
     * 
     * @type {EmploymentStatus}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'employmentStatus'?: EmploymentStatus;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'kycData'?: ClientKycData;
    /**
     * 
     * @type {ClientMigration}
     * @memberof ClientIndividualOptionalAllOf1
     */
    'migration'?: ClientMigration;
}


/**
 * Flags to capture output from KYC (Know Your Customer) screening.
 * @export
 * @interface ClientKycData
 */
export interface ClientKycData {
    /**
     * If true, client has a positive match as a Domestic PEP (Politically Exposed Person)
     * @type {boolean}
     * @memberof ClientKycData
     */
    'domesticPep': boolean;
    /**
     * If true, client has a positive match as an associated person of a Domestic PEP
     * @type {boolean}
     * @memberof ClientKycData
     */
    'domesticAssociatedPep': boolean;
    /**
     * If true, client has a positive match as a Foreign PEP
     * @type {boolean}
     * @memberof ClientKycData
     */
    'foreignPep': boolean;
    /**
     * If true, client has a positive match as an associated person of a Foreign PEP
     * @type {boolean}
     * @memberof ClientKycData
     */
    'foreignAssociatedPep': boolean;
    /**
     * If true, client has a positive match as having a sanction
     * @type {boolean}
     * @memberof ClientKycData
     */
    'sanctioned': boolean;
}
/**
 * 
 * @export
 * @interface ClientMessage
 */
export interface ClientMessage {
    /**
     * The unique identifier for the node
     * @type {string}
     * @memberof ClientMessage
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientMessage
     */
    'firmId'?: string;
    /**
     * The id of the client to which the messages belong.
     * @type {string}
     * @memberof ClientMessage
     */
    'clientId'?: string;
    /**
     * 
     * @type {ClientMessageNodeId}
     * @memberof ClientMessage
     */
    'nodeId'?: ClientMessageNodeId;
    /**
     * 
     * @type {MessageType}
     * @memberof ClientMessage
     */
    'messageType'?: MessageType;
    /**
     * TBD
     * @type {boolean}
     * @memberof ClientMessage
     */
    'read'?: boolean;
    /**
     * TBD
     * @type {boolean}
     * @memberof ClientMessage
     */
    'archived'?: boolean;
    /**
     * The status of the message. One of ACTIVE, ARCHIVED, DELETED, PENDING or READ.
     * @type {string}
     * @memberof ClientMessage
     */
    'status'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof ClientMessage
     */
    'subject'?: string;
    /**
     * 
     * @type {ClientMessagePayload}
     * @memberof ClientMessage
     */
    'payload'?: ClientMessagePayload;
    /**
     * array of attachment Ids
     * @type {Array<string>}
     * @memberof ClientMessage
     */
    'attachments'?: Array<string>;
    /**
     * TBD
     * @type {string}
     * @memberof ClientMessage
     */
    'created'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerAuditDetails}
     * @memberof ClientMessage
     */
    'auditDetails'?: GetIllustrationsListDataInnerAuditDetails;
    /**
     * Unique hash for previous change
     * @type {string}
     * @memberof ClientMessage
     */
    'updateId'?: string;
    /**
     * 
     * @type {Array<ClientMessageUpdateHistoryInner>}
     * @memberof ClientMessage
     */
    'updateHistory'?: Array<ClientMessageUpdateHistoryInner>;
}


/**
 * @type ClientMessageNodeId
 * TBD
 * @export
 */
export type ClientMessageNodeId = Array<string> | string;

/**
 * TBD
 * @export
 * @interface ClientMessagePayload
 */
export interface ClientMessagePayload {
    /**
     * TBD
     * @type {string}
     * @memberof ClientMessagePayload
     */
    'body'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof ClientMessagePayload
     */
    'accountId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof ClientMessagePayload
     */
    'transactionId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof ClientMessagePayload
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientMessagePayload
     */
    'updatedFields'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientMessagePayload
     */
    'staticAttachments'?: Array<string>;
    /**
     * array of illustration attachment Ids
     * @type {Array<string>}
     * @memberof ClientMessagePayload
     */
    'illustrationIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ClientMessageUpdateHistoryInner
 */
export interface ClientMessageUpdateHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof ClientMessageUpdateHistoryInner
     */
    'updateId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientMessageUpdateHistoryInner
     */
    'updateFields'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientMessageUpdateHistoryInner
     */
    'updateAction'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientMessageUpdateHistoryInner
     */
    'updateReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientMessageUpdateHistoryInner
     */
    'updateDate'?: string;
    /**
     * 
     * @type {ClientMessageUpdateHistoryInnerUpdateData}
     * @memberof ClientMessageUpdateHistoryInner
     */
    'updateData'?: ClientMessageUpdateHistoryInnerUpdateData;
}
/**
 * 
 * @export
 * @interface ClientMessageUpdateHistoryInnerUpdateData
 */
export interface ClientMessageUpdateHistoryInnerUpdateData {
    /**
     * 
     * @type {ClientMessageUpdateHistoryInnerUpdateDataFromData}
     * @memberof ClientMessageUpdateHistoryInnerUpdateData
     */
    'fromData'?: ClientMessageUpdateHistoryInnerUpdateDataFromData;
    /**
     * 
     * @type {ClientMessageUpdateHistoryInnerUpdateDataFromData}
     * @memberof ClientMessageUpdateHistoryInnerUpdateData
     */
    'toData'?: ClientMessageUpdateHistoryInnerUpdateDataFromData;
}
/**
 * 
 * @export
 * @interface ClientMessageUpdateHistoryInnerUpdateDataFromData
 */
export interface ClientMessageUpdateHistoryInnerUpdateDataFromData {
    /**
     * 
     * @type {boolean}
     * @memberof ClientMessageUpdateHistoryInnerUpdateDataFromData
     */
    'read'?: boolean;
}
/**
 * 
 * @export
 * @interface ClientMfaFirmIdClientIdDelete200Response
 */
export interface ClientMfaFirmIdClientIdDelete200Response {
    /**
     * 
     * @type {ClientMfaFirmIdClientIdDelete200ResponseData}
     * @memberof ClientMfaFirmIdClientIdDelete200Response
     */
    'data'?: ClientMfaFirmIdClientIdDelete200ResponseData;
}
/**
 * 
 * @export
 * @interface ClientMfaFirmIdClientIdDelete200ResponseData
 */
export interface ClientMfaFirmIdClientIdDelete200ResponseData {
    /**
     * Indicates the result of the MFA reset request. `reset` means factors were removed, `no-factors-enrolled` means the user had no factors to remove, and `no-auth0-user` means no matching Auth0 user could be located for this client.
     * @type {string}
     * @memberof ClientMfaFirmIdClientIdDelete200ResponseData
     */
    'outcome': ClientMfaFirmIdClientIdDelete200ResponseDataOutcomeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ClientMfaFirmIdClientIdDelete200ResponseDataOutcomeEnum {
    Reset = 'reset',
    NoFactorsEnrolled = 'no-factors-enrolled',
    NoAuth0User = 'no-auth0-user'
}

/**
 * Contains details of the client\'s migration status
 * @export
 * @interface ClientMigration
 */
export interface ClientMigration {
    /**
     * 
     * @type {ClientMigrationStatus}
     * @memberof ClientMigration
     */
    'status'?: ClientMigrationStatus;
    /**
     * List of illustration IDs associated with the migration
     * @type {Array<string>}
     * @memberof ClientMigration
     */
    'illustrationIds'?: Array<string>;
    /**
     * 
     * @type {Suitability}
     * @memberof ClientMigration
     */
    'suitability'?: Suitability;
}


/**
 * The status of client migration
 * @export
 * @enum {string}
 */

export enum ClientMigrationStatus {
    Draft = 'Draft',
    ReadyForReview = 'ReadyForReview',
    InReview = 'InReview',
    ReadyToSend = 'ReadyToSend',
    SentToClient = 'SentToClient',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}


/**
 * 
 * @export
 * @interface ClientNationalitiesInner
 */
export interface ClientNationalitiesInner {
    /**
     * Nationality code
     * @type {string}
     * @memberof ClientNationalitiesInner
     */
    'code'?: string;
    /**
     * object containing details of identifier
     * @type {Array<ClientNationalitiesInnerIdentifiersInner>}
     * @memberof ClientNationalitiesInner
     */
    'identifiers'?: Array<ClientNationalitiesInnerIdentifiersInner>;
}
/**
 * 
 * @export
 * @interface ClientNationalitiesInnerIdentifiersInner
 */
export interface ClientNationalitiesInnerIdentifiersInner {
    /**
     * Name of the national identifier
     * @type {string}
     * @memberof ClientNationalitiesInnerIdentifiersInner
     */
    'name'?: string;
    /**
     * is avalible
     * @type {boolean}
     * @memberof ClientNationalitiesInnerIdentifiersInner
     */
    'available'?: boolean;
    /**
     * Value of the national identifer
     * @type {string}
     * @memberof ClientNationalitiesInnerIdentifiersInner
     */
    'value'?: string;
}
/**
 * @type ClientPerson
 * @export
 */
export type ClientPerson = IndividualClient | IndividualMinorClient;

/**
 * 
 * @export
 * @interface ClientPost201Response
 */
export interface ClientPost201Response {
    /**
     * 
     * @type {ClientPost201ResponseData}
     * @memberof ClientPost201Response
     */
    'data': ClientPost201ResponseData;
}
/**
 * 
 * @export
 * @interface ClientPost201ResponseData
 */
export interface ClientPost201ResponseData {
    /**
     * The unique ID of the client
     * @type {string}
     * @memberof ClientPost201ResponseData
     */
    'id': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ClientProductStatus {
    DrawdownPending = 'drawdownPending',
    DrawdownConfirmed = 'drawdownConfirmed'
}


/**
 * @type ClientSearchFirmIdGetMigrationStatusParameter
 * @export
 */
export type ClientSearchFirmIdGetMigrationStatusParameter = Array<string> | string;

/**
 * @type ClientSearchFirmIdGetMigrationSuitabilityStatusParameter
 * @export
 */
export type ClientSearchFirmIdGetMigrationSuitabilityStatusParameter = Array<string> | string;

/**
 * 
 * @export
 * @enum {string}
 */

export enum ClientStatusEnum {
    Active = 'Active',
    Pending = 'Pending',
    Registered = 'Registered'
}


/**
 * 
 * @export
 * @interface ClientTrustOptional
 */
export interface ClientTrustOptional {
    /**
     * 
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'updateId': string;
    /**
     * 
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientTrustOptional
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientTrustOptional
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientTrustOptional
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientTrustOptional
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientTrustOptional
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientTrustOptional
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered trust name
     * @type {string}
     * @memberof ClientTrustOptional
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsTrust}
     * @memberof ClientTrustOptional
     */
    'entityDetails'?: EntityDetailsTrust;
}
/**
 * 
 * @export
 * @interface ClientTrustOptional1
 */
export interface ClientTrustOptional1 {
    /**
     * 
     * @type {string}
     * @memberof ClientTrustOptional1
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientTrustOptional1
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientTrustOptional1
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientTrustOptional1
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientTrustOptional1
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientTrustOptional1
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientTrustOptional1
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientTrustOptional1
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientTrustOptional1
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientTrustOptional1
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientTrustOptional1
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientTrustOptional1
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientTrustOptional1
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered trust name
     * @type {string}
     * @memberof ClientTrustOptional1
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsTrust}
     * @memberof ClientTrustOptional1
     */
    'entityDetails'?: EntityDetailsTrust;
}
/**
 * 
 * @export
 * @interface ClientTrustOptionalAllOf
 */
export interface ClientTrustOptionalAllOf {
    /**
     * 
     * @type {string}
     * @memberof ClientTrustOptionalAllOf
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ClientTrustOptionalAllOf
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof ClientTrustOptionalAllOf
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientTrustOptionalAllOf
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof ClientTrustOptionalAllOf
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof ClientTrustOptionalAllOf
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof ClientTrustOptionalAllOf
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof ClientTrustOptionalAllOf
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof ClientTrustOptionalAllOf
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof ClientTrustOptionalAllOf
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof ClientTrustOptionalAllOf
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof ClientTrustOptionalAllOf
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof ClientTrustOptionalAllOf
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered trust name
     * @type {string}
     * @memberof ClientTrustOptionalAllOf
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsTrust}
     * @memberof ClientTrustOptionalAllOf
     */
    'entityDetails'?: EntityDetailsTrust;
}
/**
 * Contains details of the client\'s vulnerability
 * @export
 * @interface ClientVulnerability
 */
export interface ClientVulnerability {
    /**
     * 
     * @type {ClientVulnerabilityIsVulnerable}
     * @memberof ClientVulnerability
     */
    'isVulnerable'?: ClientVulnerabilityIsVulnerable;
    /**
     * The client\'s vulnerability details
     * @type {Array<string>}
     * @memberof ClientVulnerability
     */
    'reason'?: Array<string>;
    /**
     * Is the vulnerable client support temporary or not
     * @type {boolean}
     * @memberof ClientVulnerability
     */
    'isSupportTemporary'?: boolean;
}
/**
 * @type ClientVulnerabilityIsVulnerable
 * The client\'s vulnerability status
 * @export
 */
export type ClientVulnerabilityIsVulnerable = boolean | string;

/**
 * 
 * @export
 * @interface ClientproductActionCrystallisationFirmIdGet200Response
 */
export interface ClientproductActionCrystallisationFirmIdGet200Response {
    /**
     * 
     * @type {Array<GetCrystalliseGetData>}
     * @memberof ClientproductActionCrystallisationFirmIdGet200Response
     */
    'data'?: Array<GetCrystalliseGetData>;
    /**
     * 
     * @type {GetCrystalliseGetMeta}
     * @memberof ClientproductActionCrystallisationFirmIdGet200Response
     */
    'meta'?: GetCrystalliseGetMeta;
}
/**
 * 
 * @export
 * @interface ClientproductActionCrystallisationPostRequest
 */
export interface ClientproductActionCrystallisationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'accountId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'benefitsTakenBefore2006'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'fcaIndividualReference'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'protectedRetirementAgeOrLumpSum'?: boolean;
    /**
     * 
     * @type {CrystalliseAccountDetails}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'accountDetails'?: CrystalliseAccountDetails;
    /**
     * 
     * @type {boolean}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'advised'?: boolean;
    /**
     * 
     * @type {CrystalliseCrystallisationDetails}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'crystallisationDetails'?: CrystalliseCrystallisationDetails;
    /**
     * 
     * @type {boolean}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'guidance'?: boolean;
    /**
     * 
     * @type {Array<CrystalliseWithdrawalDetails>}
     * @memberof ClientproductActionCrystallisationPostRequest
     */
    'withdrawalDetails'?: Array<CrystalliseWithdrawalDetails>;
}
/**
 * 
 * @export
 * @interface ClientproductActionFirmIdGet200Response
 */
export interface ClientproductActionFirmIdGet200Response {
    /**
     * 
     * @type {Array<GetRegularCrystalliseGetData>}
     * @memberof ClientproductActionFirmIdGet200Response
     */
    'data'?: Array<GetRegularCrystalliseGetData>;
    /**
     * 
     * @type {GetCrystalliseGetMeta}
     * @memberof ClientproductActionFirmIdGet200Response
     */
    'meta'?: GetCrystalliseGetMeta;
}
/**
 * 
 * @export
 * @interface ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest
 */
export interface ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest
     */
    'updateId'?: string;
}
/**
 * 
 * @export
 * @interface ColourWithSource
 */
export interface ColourWithSource {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ColourWithSource
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof ColourWithSource
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ColourWithSourceAllOf
 */
export interface ColourWithSourceAllOf {
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof ColourWithSourceAllOf
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface CommunicationConfiguration
 */
export interface CommunicationConfiguration {
    /**
     * 
     * @type {CommunicationConfigurationFromEmail}
     * @memberof CommunicationConfiguration
     */
    'fromEmail': CommunicationConfigurationFromEmail;
}
/**
 * True if the client can create an account
 * @export
 * @interface CommunicationConfigurationFromEmail
 */
export interface CommunicationConfigurationFromEmail {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof CommunicationConfigurationFromEmail
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof CommunicationConfigurationFromEmail
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface CommunicationContent
 */
export interface CommunicationContent {
    /**
     * 
     * @type {CommunicationContentEmailTermsUrl}
     * @memberof CommunicationContent
     */
    'emailTermsUrl'?: CommunicationContentEmailTermsUrl;
    /**
     * 
     * @type {CommunicationContentEmailFooter}
     * @memberof CommunicationContent
     */
    'emailFooter'?: CommunicationContentEmailFooter;
    /**
     * 
     * @type {CommunicationContentFooterTerms}
     * @memberof CommunicationContent
     */
    'footerTerms'?: CommunicationContentFooterTerms;
    /**
     * 
     * @type {CommunicationContentPdfFooter}
     * @memberof CommunicationContent
     */
    'pdfFooter'?: CommunicationContentPdfFooter;
    /**
     * 
     * @type {CommunicationContentPensionPdfFooter}
     * @memberof CommunicationContent
     */
    'pensionPdfFooter'?: CommunicationContentPensionPdfFooter;
}
/**
 * the from email address
 * @export
 * @interface CommunicationContentEmailFooter
 */
export interface CommunicationContentEmailFooter {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof CommunicationContentEmailFooter
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof CommunicationContentEmailFooter
     */
    'value': string;
}
/**
 * the terms URL
 * @export
 * @interface CommunicationContentEmailTermsUrl
 */
export interface CommunicationContentEmailTermsUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof CommunicationContentEmailTermsUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof CommunicationContentEmailTermsUrl
     */
    'value': string;
}
/**
 * the terms in the email footer
 * @export
 * @interface CommunicationContentFooterTerms
 */
export interface CommunicationContentFooterTerms {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof CommunicationContentFooterTerms
     */
    'sourceNodeId': string;
    /**
     * The html value.
     * @type {string}
     * @memberof CommunicationContentFooterTerms
     */
    'value': string;
}
/**
 * the footer text in PDFs
 * @export
 * @interface CommunicationContentPdfFooter
 */
export interface CommunicationContentPdfFooter {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof CommunicationContentPdfFooter
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof CommunicationContentPdfFooter
     */
    'value': string;
}
/**
 * the footer text in pension PDFs
 * @export
 * @interface CommunicationContentPensionPdfFooter
 */
export interface CommunicationContentPensionPdfFooter {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof CommunicationContentPensionPdfFooter
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof CommunicationContentPensionPdfFooter
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface CommunicationTheme
 */
export interface CommunicationTheme {
    /**
     * 
     * @type {CommunicationThemeIllustrationBrandingColour}
     * @memberof CommunicationTheme
     */
    'illustrationBrandingColour': CommunicationThemeIllustrationBrandingColour;
}
/**
 * The banner colour that adds theming to illustration PDFs.
 * @export
 * @interface CommunicationThemeIllustrationBrandingColour
 */
export interface CommunicationThemeIllustrationBrandingColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof CommunicationThemeIllustrationBrandingColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof CommunicationThemeIllustrationBrandingColour
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ContentWithSource
 */
export interface ContentWithSource {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ContentWithSource
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof ContentWithSource
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ContentWithSourceAllOf
 */
export interface ContentWithSourceAllOf {
    /**
     * The value of the content.
     * @type {string}
     * @memberof ContentWithSourceAllOf
     */
    'value': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ContributionType {
    Employee = 'Employee',
    Employer = 'Employer',
    Personal = 'Personal',
    Transfer = 'Transfer'
}


/**
 * 
 * @export
 * @interface CorporateClient
 */
export interface CorporateClient {
    /**
     * 
     * @type {string}
     * @memberof CorporateClient
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CorporateClient
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof CorporateClient
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CorporateClient
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof CorporateClient
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof CorporateClient
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof CorporateClient
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof CorporateClient
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof CorporateClient
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof CorporateClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof CorporateClient
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof CorporateClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof CorporateClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered company name
     * @type {string}
     * @memberof CorporateClient
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsCorporate}
     * @memberof CorporateClient
     */
    'entityDetails'?: EntityDetailsCorporate;
}
/**
 * 
 * @export
 * @interface CorporateClientSpecifics
 */
export interface CorporateClientSpecifics {
    /**
     * 
     * @type {string}
     * @memberof CorporateClientSpecifics
     */
    'clientType'?: string;
    /**
     * The registered company name
     * @type {string}
     * @memberof CorporateClientSpecifics
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsCorporate}
     * @memberof CorporateClientSpecifics
     */
    'entityDetails'?: EntityDetailsCorporate;
}
/**
 * Object representing an entity client stakeholders who is not already a client
 * @export
 * @interface CorporateStakeholderNonClient
 */
export interface CorporateStakeholderNonClient {
    /**
     * The ID of the client object representing this stakeholder
     * @type {string}
     * @memberof CorporateStakeholderNonClient
     */
    'clientId': string;
    /**
     * Allowed management permissions
     * @type {boolean}
     * @memberof CorporateStakeholderNonClient
     */
    'clientAndAccountManagement': boolean;
}
/**
 * 
 * @export
 * @interface CorporateStakeholderRole
 */
export interface CorporateStakeholderRole {
    /**
     * Role of this stakeholder
     * @type {string}
     * @memberof CorporateStakeholderRole
     */
    'role'?: CorporateStakeholderRoleRoleEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CorporateStakeholderRoleRoleEnum {
    Director = 'Director',
    SignificantShareholder = 'Significant Shareholder',
    PrincipalOrPartner = 'Principal Or Partner'
}

/**
 * 
 * @export
 * @interface CreateAccount
 */
export interface CreateAccount {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateAccount
     */
    'firmId': string;
    /**
     * The unique identifier for the firm node\'s account
     * @type {string}
     * @memberof CreateAccount
     */
    'nodeId': string;
    /**
     * The type of account
     * @type {string}
     * @memberof CreateAccount
     */
    'accountType': CreateAccountAccountTypeEnum;
    /**
     * The name of the investment account
     * @type {string}
     * @memberof CreateAccount
     */
    'name': string;
    /**
     * The status of the account
     * @type {string}
     * @memberof CreateAccount
     */
    'status': CreateAccountStatusEnum;
    /**
     * The status of the account
     * @type {number}
     * @memberof CreateAccount
     */
    'adviserCharge'?: number;
    /**
     * 
     * @type {CreateAccountFeeStructures}
     * @memberof CreateAccount
     */
    'feeStructures'?: CreateAccountFeeStructures;
    /**
     * The status of the account
     * @type {number}
     * @memberof CreateAccount
     */
    'discretionaryManagementCharge': number | null;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof CreateAccount
     */
    'currency': string;
    /**
     * The unique identifier for a client
     * @type {string}
     * @memberof CreateAccount
     */
    'clientId'?: string;
    /**
     * 
     * @type {Array<CreateAccountClientsInner>}
     * @memberof CreateAccount
     */
    'clients'?: Array<CreateAccountClientsInner>;
    /**
     * 
     * @type {CreateAccountWrapperDetail}
     * @memberof CreateAccount
     */
    'wrapperDetail': CreateAccountWrapperDetail;
    /**
     * 
     * @type {string}
     * @memberof CreateAccount
     */
    'decisionMakerLei'?: string;
    /**
     * 
     * @type {CreateAccountBankDetails}
     * @memberof CreateAccount
     */
    'bankDetails'?: CreateAccountBankDetails;
    /**
     * 
     * @type {CreateAccountRecurringOrders}
     * @memberof CreateAccount
     */
    'recurringOrders'?: CreateAccountRecurringOrders;
    /**
     * 
     * @type {Array<CreateAccountPortfolioGroupsInner>}
     * @memberof CreateAccount
     */
    'portfolioGroups'?: Array<CreateAccountPortfolioGroupsInner>;
    /**
     * 
     * @type {CreateAccountAdviserTieredCharges}
     * @memberof CreateAccount
     */
    'adviserTieredCharges'?: CreateAccountAdviserTieredCharges;
    /**
     * 
     * @type {CreateAccountProductDetail}
     * @memberof CreateAccount
     */
    'productDetail'?: CreateAccountProductDetail;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateAccountAccountTypeEnum {
    Wrapper = 'Wrapper'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateAccountStatusEnum {
    Pending = 'Pending',
    Active = 'Active'
}

/**
 * 
 * @export
 * @interface CreateAccountAdviserTieredCharges
 */
export interface CreateAccountAdviserTieredCharges {
    /**
     * 
     * @type {Array<CreateAccountAdviserTieredChargesTiersInner>}
     * @memberof CreateAccountAdviserTieredCharges
     */
    'tiers'?: Array<CreateAccountAdviserTieredChargesTiersInner>;
}
/**
 * 
 * @export
 * @interface CreateAccountAdviserTieredChargesTiersInner
 */
export interface CreateAccountAdviserTieredChargesTiersInner {
    /**
     * 
     * @type {number}
     * @memberof CreateAccountAdviserTieredChargesTiersInner
     */
    'toAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAccountAdviserTieredChargesTiersInner
     */
    'rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAccountAdviserTieredChargesTiersInner
     */
    'fromAmount'?: number;
}
/**
 * 
 * @export
 * @interface CreateAccountBankDetails
 */
export interface CreateAccountBankDetails {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountBankDetails
     */
    'sortCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountBankDetails
     */
    'accountNumber'?: string;
}
/**
 * 
 * @export
 * @interface CreateAccountClientsInner
 */
export interface CreateAccountClientsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountClientsInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof CreateAccountClientsInner
     */
    'owner'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountClientsInner
     */
    'decisionMaker'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountClientsInner
     */
    'isLeadClient'?: boolean;
}
/**
 * Fee structures applied directly to the account
 * @export
 * @interface CreateAccountFeeStructures
 */
export interface CreateAccountFeeStructures {
    /**
     * Adviser fee structure ID
     * @type {string}
     * @memberof CreateAccountFeeStructures
     */
    'adviserFeeId'?: string;
}
/**
 * 
 * @export
 * @interface CreateAccountPortfolioGroupsInner
 */
export interface CreateAccountPortfolioGroupsInner {
    /**
     * 
     * @type {PensionAccountGroupIntent}
     * @memberof CreateAccountPortfolioGroupsInner
     */
    'groupIntent'?: PensionAccountGroupIntent;
    /**
     * 
     * @type {PensionAccountGroupType}
     * @memberof CreateAccountPortfolioGroupsInner
     */
    'groupType': PensionAccountGroupType;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountPortfolioGroupsInner
     */
    'name'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof CreateAccountPortfolioGroupsInner
     */
    'id'?: string;
}


/**
 * Name of the product
 * @export
 * @interface CreateAccountProductDetail
 */
export interface CreateAccountProductDetail {
    /**
     * TBD
     * @type {boolean}
     * @memberof CreateAccountProductDetail
     */
    'flexibleBenefitsAccessed'?: boolean;
    /**
     * TBD
     * @type {boolean}
     * @memberof CreateAccountProductDetail
     */
    'pensionOptOut'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountProductDetail
     */
    'flexiAccessDate'?: string;
}
/**
 * 
 * @export
 * @interface CreateAccountRecurringOrders
 */
export interface CreateAccountRecurringOrders {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRecurringOrders
     */
    'investmentType': CreateAccountRecurringOrdersInvestmentTypeEnum;
    /**
     * 
     * @type {MovementType}
     * @memberof CreateAccountRecurringOrders
     */
    'movementType': MovementType;
    /**
     * 
     * @type {number}
     * @memberof CreateAccountRecurringOrders
     */
    'orderDay': number;
    /**
     * 
     * @type {Array<CreateAccountRecurringOrdersDetailsInner>}
     * @memberof CreateAccountRecurringOrders
     */
    'details': Array<CreateAccountRecurringOrdersDetailsInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateAccountRecurringOrdersInvestmentTypeEnum {
    Bespoke = 'Bespoke'
}

/**
 * 
 * @export
 * @interface CreateAccountRecurringOrdersDetailsInner
 */
export interface CreateAccountRecurringOrdersDetailsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRecurringOrdersDetailsInner
     */
    'assetId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateAccountRecurringOrdersDetailsInner
     */
    'percentage': number;
}
/**
 * The details of the chosen investment account
 * @export
 * @interface CreateAccountWrapperDetail
 */
export interface CreateAccountWrapperDetail {
    /**
     * 
     * @type {WrapperType}
     * @memberof CreateAccountWrapperDetail
     */
    'wrapperType'?: WrapperType;
    /**
     * Indicates whether the account is managed on a discretionary basis. This should be set to true for Bespoke DFMs.
     * @type {boolean}
     * @memberof CreateAccountWrapperDetail
     */
    'discretionary'?: boolean;
    /**
     * Indicates whether the account is managed on an advised basis
     * @type {boolean}
     * @memberof CreateAccountWrapperDetail
     */
    'advised'?: boolean;
    /**
     * Indicates whether the account is managed on an advised basis
     * @type {boolean}
     * @memberof CreateAccountWrapperDetail
     */
    'trust'?: boolean;
    /**
     * The type of tax wrapper
     * @type {string}
     * @memberof CreateAccountWrapperDetail
     */
    'decisionMakerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWrapperDetail
     */
    'assetAllocationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWrapperDetail
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWrapperDetail
     */
    'schemeProductId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWrapperDetail
     */
    'clientProductId'?: string;
    /**
     * 
     * @type {Array<CreateAccountWrapperDetailNominationsInner>}
     * @memberof CreateAccountWrapperDetail
     */
    'nominations'?: Array<CreateAccountWrapperDetailNominationsInner>;
}


/**
 * 
 * @export
 * @interface CreateAccountWrapperDetailNominationsInner
 */
export interface CreateAccountWrapperDetailNominationsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWrapperDetailNominationsInner
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWrapperDetailNominationsInner
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountWrapperDetailNominationsInner
     */
    'surname'?: string;
    /**
     * 
     * @type {BeneficiaryRelationship}
     * @memberof CreateAccountWrapperDetailNominationsInner
     */
    'beneficiaryRelationship'?: BeneficiaryRelationship;
    /**
     * 
     * @type {number}
     * @memberof CreateAccountWrapperDetailNominationsInner
     */
    'beneficiaryProportion'?: number;
}


/**
 * 
 * @export
 * @interface CreateAdHocValuationStatementEvent
 */
export interface CreateAdHocValuationStatementEvent {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateAdHocValuationStatementEvent
     */
    'firmId': string;
    /**
     * The type of event occurring on the account.
     * @type {string}
     * @memberof CreateAdHocValuationStatementEvent
     */
    'eventType': string;
    /**
     * Unique identifier for the client’s investment account
     * @type {string}
     * @memberof CreateAdHocValuationStatementEvent
     */
    'clientId': string;
    /**
     * Start date used in the creation of documents, such as valuation statements
     * @type {string}
     * @memberof CreateAdHocValuationStatementEvent
     */
    'fromDate': string;
    /**
     * End date used in the creation of documents, such as valuation statements
     * @type {string}
     * @memberof CreateAdHocValuationStatementEvent
     */
    'toDate': string;
}
/**
 * 
 * @export
 * @interface CreateAdHocValuationStatementEventAllOf
 */
export interface CreateAdHocValuationStatementEventAllOf {
    /**
     * Unique identifier for the client’s investment account
     * @type {string}
     * @memberof CreateAdHocValuationStatementEventAllOf
     */
    'clientId': string;
    /**
     * Start date used in the creation of documents, such as valuation statements
     * @type {string}
     * @memberof CreateAdHocValuationStatementEventAllOf
     */
    'fromDate': string;
    /**
     * End date used in the creation of documents, such as valuation statements
     * @type {string}
     * @memberof CreateAdHocValuationStatementEventAllOf
     */
    'toDate': string;
}
/**
 * @type CreateClient
 * @export
 */
export type CreateClient = CorporateClient | IndividualClient | IndividualMinorClient | TrustClient;

/**
 * 
 * @export
 * @interface CreateClientFeeGroup
 */
export interface CreateClientFeeGroup {
    /**
     * 
     * @type {CreateClientFeeGroupIntentDetails}
     * @memberof CreateClientFeeGroup
     */
    'intentDetails': CreateClientFeeGroupIntentDetails;
    /**
     * The unique identifier for the firm
     * @type {string}
     * @memberof CreateClientFeeGroup
     */
    'firmId'?: string;
    /**
     * The intent or purpose of the group
     * @type {string}
     * @memberof CreateClientFeeGroup
     */
    'groupIntent'?: CreateClientFeeGroupGroupIntentEnum;
    /**
     * The display name of the group
     * @type {string}
     * @memberof CreateClientFeeGroup
     */
    'name'?: string;
    /**
     * The unique identifier of the node to which this client group is scoped
     * @type {Array<string>}
     * @memberof CreateClientFeeGroup
     */
    'nodeId'?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateClientFeeGroupGroupIntentEnum {
    ClientFeeGroup = 'Client Fee Group',
    PensionAccountGroup = 'Pension Account Group'
}

/**
 * The details of the client fee group
 * @export
 * @interface CreateClientFeeGroupIntentDetails
 */
export interface CreateClientFeeGroupIntentDetails {
    /**
     * 
     * @type {boolean}
     * @memberof CreateClientFeeGroupIntentDetails
     */
    'platformFee': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClientFeeGroupIntentDetails
     */
    'adviserFee': boolean;
    /**
     * The status of the client fee group
     * @type {string}
     * @memberof CreateClientFeeGroupIntentDetails
     */
    'status'?: CreateClientFeeGroupIntentDetailsStatusEnum;
    /**
     * 
     * @type {GetPortfolioGroupDataIntentDetailsFeeStructures}
     * @memberof CreateClientFeeGroupIntentDetails
     */
    'feeStructures'?: GetPortfolioGroupDataIntentDetailsFeeStructures;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateClientFeeGroupIntentDetailsStatusEnum {
    Active = 'Active',
    Archived = 'Archived'
}

/**
 * 
 * @export
 * @interface CreateClientResponse
 */
export interface CreateClientResponse {
    /**
     * 
     * @type {CreateClientResponseData}
     * @memberof CreateClientResponse
     */
    'data'?: CreateClientResponseData;
}
/**
 * 
 * @export
 * @interface CreateClientResponseData
 */
export interface CreateClientResponseData {
    /**
     * User id of newly created client
     * @type {string}
     * @memberof CreateClientResponseData
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface CreateIACashTransfer
 */
export interface CreateIACashTransfer {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateIACashTransfer
     */
    'firmId': string;
    /**
     * The unique identifier of the investment account where the cash is being transferred from
     * @type {string}
     * @memberof CreateIACashTransfer
     */
    'accountId': string;
    /**
     * Contains details of the transactions within the group
     * @type {Array<CreateIACashTransferTransactionsInner>}
     * @memberof CreateIACashTransfer
     */
    'transactions': Array<CreateIACashTransferTransactionsInner>;
}
/**
 * 
 * @export
 * @interface CreateIACashTransferTransactionsInner
 */
export interface CreateIACashTransferTransactionsInner {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'firmId': string;
    /**
     * The unique identifier of the investment account where the cash is being transferred from
     * @type {string}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'accountId': string;
    /**
     * The unique identifier of the investment account where the cash is being transferred to
     * @type {string}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'destinationAccount'?: string;
    /**
     * The type of transaction
     * @type {string}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'transactionType': string;
    /**
     * The subtype of transaction (In Specie, Cash, Internal)
     * @type {string}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'transactionSubType': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'currency': string;
    /**
     * 
     * @type {SellDown}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'autoDisinvest'?: SellDown;
    /**
     * 
     * @type {SellDownSellType}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'autoDisinvestSellType'?: SellDownSellType;
    /**
     * Indicates whether the money should be auto-invested to the model attached to the destinationAccount
     * @type {boolean}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'autoInvest'?: boolean;
    /**
     * A boolean value to indicate whether the transaction is to invest to model
     * @type {boolean}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'investToModel'?: boolean;
    /**
     * The amount to be transferred – this must be available as uninvested cash
     * @type {number}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'amount'?: number;
    /**
     * The movement of the assets and/or cash (this should be set to In)
     * @type {string}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'movementType': string;
    /**
     * The unique identifier for the asset to be invested in
     * @type {string}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'assetId'?: string;
    /**
     * The number of units to transfer
     * @type {number}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'quantity'?: number;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof CreateIACashTransferTransactionsInner
     */
    'method'?: PaymentMethod;
}


/**
 * 
 * @export
 * @interface CreateModel
 */
export interface CreateModel {
    /**
     * 
     * @type {ModelType}
     * @memberof CreateModel
     */
    'modelType': ModelType;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateModel
     */
    'firmId': string;
    /**
     * The name of the mode
     * @type {string}
     * @memberof CreateModel
     */
    'name': string;
    /**
     * A summary or information about the model
     * @type {string}
     * @memberof CreateModel
     */
    'commentary'?: string;
    /**
     * TBD The risk rating of the model on a scale of 1-10
     * @type {number}
     * @memberof CreateModel
     */
    'riskRating': number;
    /**
     * The url to the Key Features document for the model
     * @type {string}
     * @memberof CreateModel
     */
    'url'?: string;
    /**
     * The type of products the model can be used with
     * @type {Array<string>}
     * @memberof CreateModel
     */
    'productType': Array<string>;
    /**
     * The aim of the model
     * @type {string}
     * @memberof CreateModel
     */
    'aim'?: string;
    /**
     * The charge percentage of the model
     * @type {number}
     * @memberof CreateModel
     */
    'modelCharge'?: number;
    /**
     * Whether VAT can be applied to the model
     * @type {boolean}
     * @memberof CreateModel
     */
    'vatable'?: boolean;
    /**
     * Whether this model should have rebalances suspended
     * @type {boolean}
     * @memberof CreateModel
     */
    'suspendRebalances': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateModel
     */
    'availableToNodeId'?: Array<string>;
    /**
     * details of allocations
     * @type {Array<CreateModelAllocationsInner>}
     * @memberof CreateModel
     */
    'allocations'?: Array<CreateModelAllocationsInner>;
    /**
     * The cash allocation for the model. This is automatically generated where asset allocations do not add up to 1 (100%) but can be specified.
     * @type {number}
     * @memberof CreateModel
     */
    'cashAllocation'?: number;
    /**
     * 
     * @type {CreateModelInvestmentDecision}
     * @memberof CreateModel
     */
    'investmentDecision'?: CreateModelInvestmentDecision;
    /**
     * 
     * @type {Array<CreateModelAssetMixInner>}
     * @memberof CreateModel
     */
    'assetMix': Array<CreateModelAssetMixInner>;
}


/**
 * 
 * @export
 * @interface CreateModelAllocationsInner
 */
export interface CreateModelAllocationsInner {
    /**
     * The unique identifier for the asset in the model allocation
     * @type {string}
     * @memberof CreateModelAllocationsInner
     */
    'assetId': string;
    /**
     * he proportion of the asset in the model, where asset allocations total 1 (100%)
     * @type {number}
     * @memberof CreateModelAllocationsInner
     */
    'percentage': number;
}
/**
 * The proportion held of each asset class and cash in the model. This is required for producing growth rates for product illustrations where the wrapper is using a model portfolio investment strategy.
 * @export
 * @interface CreateModelAssetMixInner
 */
export interface CreateModelAssetMixInner {
    /**
     * The type of instrument/asset. The system accounts for Equity, Gilts, Corporate bonds, Cash and Other asset classes.
     * @type {string}
     * @memberof CreateModelAssetMixInner
     */
    'instrumentType'?: string;
    /**
     * The proportion of each asset class in the model, where asset allocations total 1 (100%). Please note the cash allocation is generated as the remaining proportion of assets not accounted for. For example, a model made up of 70% equities and 28% bonds will have a 2% cash allocation.
     * @type {number}
     * @memberof CreateModelAssetMixInner
     */
    'instrumentRateType'?: number;
    /**
     * A two-letter country code denoting the firm\'s location
     * @type {string}
     * @memberof CreateModelAssetMixInner
     */
    'firmCountry'?: string;
    /**
     * The National Identifier for the firm user/decision maker. For 1 nationals this is in the format XX123456X
     * @type {string}
     * @memberof CreateModelAssetMixInner
     */
    'personId'?: string;
    /**
     * 
     * @type {PersonalIdentifierType}
     * @memberof CreateModelAssetMixInner
     */
    'personIdType'?: PersonalIdentifierType;
    /**
     * A two-letter country code denoting the firm user/decision maker\'s location
     * @type {string}
     * @memberof CreateModelAssetMixInner
     */
    'personCountry'?: string;
}


/**
 * Investment decision details
 * @export
 * @interface CreateModelInvestmentDecision
 */
export interface CreateModelInvestmentDecision {
    /**
     * A 20-digit numerical identifier assigned to a DFM
     * @type {string}
     * @memberof CreateModelInvestmentDecision
     */
    'firmLei': string;
    /**
     * A two-letter country code denoting the firm\'s location
     * @type {string}
     * @memberof CreateModelInvestmentDecision
     */
    'firmCountry': string;
    /**
     * The National Identifier for the firm user/decision maker. For 1 nationals this is in the format XX123456X
     * @type {string}
     * @memberof CreateModelInvestmentDecision
     */
    'personId': string;
    /**
     * 
     * @type {PersonalIdentifierType}
     * @memberof CreateModelInvestmentDecision
     */
    'personIdType': PersonalIdentifierType;
    /**
     * A two-letter country code denoting the firm user/decision maker\'s location
     * @type {string}
     * @memberof CreateModelInvestmentDecision
     */
    'personCountry': string;
}


/**
 * 
 * @export
 * @interface CreateModelResponse
 */
export interface CreateModelResponse {
    /**
     * 
     * @type {CreateModelResponseData}
     * @memberof CreateModelResponse
     */
    'data'?: CreateModelResponseData;
}
/**
 * 
 * @export
 * @interface CreateModelResponseData
 */
export interface CreateModelResponseData {
    /**
     * User id of newly created model
     * @type {string}
     * @memberof CreateModelResponseData
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface CreatePensionAccountGroup
 */
export interface CreatePensionAccountGroup {
    /**
     * The unique identifier for the firm
     * @type {string}
     * @memberof CreatePensionAccountGroup
     */
    'firmId': string;
    /**
     * The intent or purpose of the group
     * @type {string}
     * @memberof CreatePensionAccountGroup
     */
    'groupIntent': CreatePensionAccountGroupGroupIntentEnum;
    /**
     * The display name of the group
     * @type {string}
     * @memberof CreatePensionAccountGroup
     */
    'name': string;
    /**
     * The unique identifier of the node to which this client group is scoped
     * @type {string}
     * @memberof CreatePensionAccountGroup
     */
    'nodeId': string;
    /**
     * 
     * @type {CreatePensionAccountGroupAllOfIntentDetails}
     * @memberof CreatePensionAccountGroup
     */
    'intentDetails': CreatePensionAccountGroupAllOfIntentDetails;
}

/**
    * @export
    * @enum {string}
    */
export enum CreatePensionAccountGroupGroupIntentEnum {
    ClientFeeGroup = 'Client Fee Group',
    PensionAccountGroup = 'Pension Account Group'
}

/**
 * 
 * @export
 * @interface CreatePensionAccountGroupAllOf
 */
export interface CreatePensionAccountGroupAllOf {
    /**
     * 
     * @type {CreatePensionAccountGroupAllOfIntentDetails}
     * @memberof CreatePensionAccountGroupAllOf
     */
    'intentDetails'?: CreatePensionAccountGroupAllOfIntentDetails;
}
/**
 * The details of the pension account group
 * @export
 * @interface CreatePensionAccountGroupAllOfIntentDetails
 */
export interface CreatePensionAccountGroupAllOfIntentDetails {
    /**
     * The type of pension account group
     * @type {string}
     * @memberof CreatePensionAccountGroupAllOfIntentDetails
     */
    'groupType'?: CreatePensionAccountGroupAllOfIntentDetailsGroupTypeEnum;
    /**
     * The unique identifier of the client product of which this group is a part
     * @type {string}
     * @memberof CreatePensionAccountGroupAllOfIntentDetails
     */
    'clientProductId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CreatePensionAccountGroupAllOfIntentDetailsGroupTypeEnum {
    Uncrystallised = 'Uncrystallised',
    Crystallised = 'Crystallised',
    Beneficiary = 'Beneficiary',
    CrystallisedTransfer = 'CrystallisedTransfer'
}

/**
 * 
 * @export
 * @interface CreatePortfolioRealignEvent
 */
export interface CreatePortfolioRealignEvent {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreatePortfolioRealignEvent
     */
    'firmId': string;
    /**
     * The type of event occurring on the account.
     * @type {string}
     * @memberof CreatePortfolioRealignEvent
     */
    'eventType': string;
    /**
     * Unique identifier for the client’s investment account
     * @type {string}
     * @memberof CreatePortfolioRealignEvent
     */
    'accountId': string;
}
/**
 * 
 * @export
 * @interface CreatePortfolioRealignEventAllOf
 */
export interface CreatePortfolioRealignEventAllOf {
    /**
     * Unique identifier for the client’s investment account
     * @type {string}
     * @memberof CreatePortfolioRealignEventAllOf
     */
    'accountId': string;
}
/**
 * 
 * @export
 * @interface CreatePortfolioTransaction
 */
export interface CreatePortfolioTransaction {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreatePortfolioTransaction
     */
    'firmId': string;
    /**
     * The unique identifier of the investment account to instruct the transfer
     * @type {string}
     * @memberof CreatePortfolioTransaction
     */
    'accountId': string;
    /**
     * The type of transaction – this should be set to the Product Transfer
     * @type {string}
     * @memberof CreatePortfolioTransaction
     */
    'transactionType': string;
    /**
     * 
     * @type {CreatePortfolioTransactionTransactionSubType}
     * @memberof CreatePortfolioTransaction
     */
    'transactionSubType': CreatePortfolioTransactionTransactionSubType;
    /**
     * The movement of the assets and/or cash (this should be set to In)
     * @type {string}
     * @memberof CreatePortfolioTransaction
     */
    'movementType': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof CreatePortfolioTransaction
     */
    'currency'?: string;
    /**
     * Amount of cash being transfered
     * @type {number}
     * @memberof CreatePortfolioTransaction
     */
    'amount'?: number;
    /**
     * details of the transfer method
     * @type {string}
     * @memberof CreatePortfolioTransaction
     */
    'method'?: string;
    /**
     * The unique identifier of transactions in the group
     * @type {string}
     * @memberof CreatePortfolioTransaction
     */
    'linkId'?: string;
}
/**
 * 
 * @export
 * @interface CreatePortfolioTransactionTransactionSubType
 */
export interface CreatePortfolioTransactionTransactionSubType {
}
/**
 * 
 * @export
 * @interface CreateProductIllustration
 */
export interface CreateProductIllustration {
    /**
     * 
     * @type {CreateProductIllustrationAdviserInfo}
     * @memberof CreateProductIllustration
     */
    'adviserInfo'?: CreateProductIllustrationAdviserInfo;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'calculating'?: string;
    /**
     * 
     * @type {CreateProductIllustrationCharges}
     * @memberof CreateProductIllustration
     */
    'charges'?: CreateProductIllustrationCharges;
    /**
     * 
     * @type {CreateProductIllustrationClientInfo}
     * @memberof CreateProductIllustration
     */
    'clientInfo'?: CreateProductIllustrationClientInfo;
    /**
     * 
     * @type {Array<CreateProductIllustrationClientInfo>}
     * @memberof CreateProductIllustration
     */
    'additionalClientsInfo'?: Array<CreateProductIllustrationClientInfo>;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'currency'?: string;
    /**
     * 
     * @type {CreateProductIllustrationDrawdown}
     * @memberof CreateProductIllustration
     */
    'drawdown'?: CreateProductIllustrationDrawdown;
    /**
     * 
     * @type {CreateProductIllustrationFees}
     * @memberof CreateProductIllustration
     */
    'fees'?: CreateProductIllustrationFees;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'illustrationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'modelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'nodeId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustration
     */
    'otherPlatformHoldings'?: number;
    /**
     * 
     * @type {CreateProductIllustrationPayments}
     * @memberof CreateProductIllustration
     */
    'payments'?: CreateProductIllustrationPayments;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'periodType'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustration
     */
    'periods'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustration
     */
    'retirementAge'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'schemeProductId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'startDate'?: string;
    /**
     * 
     * @type {Array<CreateProductIllustrationTransactionsInner>}
     * @memberof CreateProductIllustration
     */
    'transactions'?: Array<CreateProductIllustrationTransactionsInner>;
    /**
     * 
     * @type {CreateProductIllustrationWithdrawals}
     * @memberof CreateProductIllustration
     */
    'withdrawals'?: CreateProductIllustrationWithdrawals;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustration
     */
    'planLengthYears'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'wrapperStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'wrapperType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustration
     */
    'platformFeeStructureId'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationAdviserInfo
 */
export interface CreateProductIllustrationAdviserInfo {
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationAdviserInfo
     */
    'FCANumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationAdviserInfo
     */
    'adviserName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationAdviserInfo
     */
    'company'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationCharges
 */
export interface CreateProductIllustrationCharges {
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductIllustrationCharges
     */
    'platformCharge'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductIllustrationCharges
     */
    'productCharge'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductIllustrationCharges
     */
    'tradingCharge'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationClientInfo
 */
export interface CreateProductIllustrationClientInfo {
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'clientType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'middleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationClientInfo
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationDrawdown
 */
export interface CreateProductIllustrationDrawdown {
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationDrawdown
     */
    'drawdownMethod'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationDrawdown
     */
    'fundsNotInDrawdown'?: number;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationFees
 */
export interface CreateProductIllustrationFees {
    /**
     * 
     * @type {CreateProductIllustrationFeesAdviserTieredCharges}
     * @memberof CreateProductIllustrationFees
     */
    'adviserTieredCharges'?: CreateProductIllustrationFeesAdviserTieredCharges;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationFees
     */
    'adviserCharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationFees
     */
    'discretionaryManagementCharge'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductIllustrationFees
     */
    'enableTieredCharging'?: boolean;
    /**
     * 
     * @type {CreateProductIllustrationFeesInitialAdviserCharge}
     * @memberof CreateProductIllustrationFees
     */
    'initialAdviserCharge'?: CreateProductIllustrationFeesInitialAdviserCharge;
    /**
     * 
     * @type {CreateProductIllustrationFeesInitialAdviserCharge}
     * @memberof CreateProductIllustrationFees
     */
    'initialDiscretionaryManagementCharge'?: CreateProductIllustrationFeesInitialAdviserCharge;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductIllustrationFees
     */
    'applyAdviserChargeAcrossPortfolio'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationFees
     */
    'adviserFeeStructureId'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationFeesAdviserTieredCharges
 */
export interface CreateProductIllustrationFeesAdviserTieredCharges {
    /**
     * 
     * @type {Array<CreateProductIllustrationFeesAdviserTieredChargesTiersInner>}
     * @memberof CreateProductIllustrationFeesAdviserTieredCharges
     */
    'tiers'?: Array<CreateProductIllustrationFeesAdviserTieredChargesTiersInner>;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationFeesAdviserTieredChargesTiersInner
 */
export interface CreateProductIllustrationFeesAdviserTieredChargesTiersInner {
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationFeesAdviserTieredChargesTiersInner
     */
    'fromAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationFeesAdviserTieredChargesTiersInner
     */
    'rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationFeesAdviserTieredChargesTiersInner
     */
    'toAmount'?: number;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationFeesInitialAdviserCharge
 */
export interface CreateProductIllustrationFeesInitialAdviserCharge {
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationFeesInitialAdviserCharge
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationFeesInitialAdviserCharge
     */
    'percent'?: number;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationPayments
 */
export interface CreateProductIllustrationPayments {
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationPayments
     */
    'initialPayment'?: number;
    /**
     * 
     * @type {Array<CreateProductIllustrationPaymentsRegularPaymentsInner>}
     * @memberof CreateProductIllustrationPayments
     */
    'regularPayments'?: Array<CreateProductIllustrationPaymentsRegularPaymentsInner>;
    /**
     * 
     * @type {Array<CreateProductIllustrationPaymentsSinglePaymentsInner>}
     * @memberof CreateProductIllustrationPayments
     */
    'singlePayments'?: Array<CreateProductIllustrationPaymentsSinglePaymentsInner>;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationPaymentsRegularPaymentsInner
 */
export interface CreateProductIllustrationPaymentsRegularPaymentsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationPaymentsRegularPaymentsInner
     */
    'contributor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationPaymentsRegularPaymentsInner
     */
    'frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationPaymentsRegularPaymentsInner
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationPaymentsRegularPaymentsInner
     */
    'movementType'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationPaymentsRegularPaymentsInner
     */
    'paymentAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationPaymentsRegularPaymentsInner
     */
    'percentageGrowth'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationPaymentsRegularPaymentsInner
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationPaymentsSinglePaymentsInner
 */
export interface CreateProductIllustrationPaymentsSinglePaymentsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationPaymentsSinglePaymentsInner
     */
    'contributor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationPaymentsSinglePaymentsInner
     */
    'movementType'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationPaymentsSinglePaymentsInner
     */
    'paymentAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationPaymentsSinglePaymentsInner
     */
    'paymentDate'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationTransactionsInner
 */
export interface CreateProductIllustrationTransactionsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationTransactionsInner
     */
    'assetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationTransactionsInner
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationTransactionsInner
     */
    'percentage'?: number;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationWithdrawals
 */
export interface CreateProductIllustrationWithdrawals {
    /**
     * 
     * @type {Array<CreateProductIllustrationWithdrawalsRegularWithdrawalsInner>}
     * @memberof CreateProductIllustrationWithdrawals
     */
    'regularWithdrawals'?: Array<CreateProductIllustrationWithdrawalsRegularWithdrawalsInner>;
    /**
     * 
     * @type {Array<CreateProductIllustrationWithdrawalsSingleWithdrawalsInner>}
     * @memberof CreateProductIllustrationWithdrawals
     */
    'singleWithdrawals'?: Array<CreateProductIllustrationWithdrawalsSingleWithdrawalsInner>;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationWithdrawalsRegularWithdrawalsInner
 */
export interface CreateProductIllustrationWithdrawalsRegularWithdrawalsInner {
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationWithdrawalsRegularWithdrawalsInner
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationWithdrawalsRegularWithdrawalsInner
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationWithdrawalsRegularWithdrawalsInner
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationWithdrawalsRegularWithdrawalsInner
     */
    'frequency'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationWithdrawalsRegularWithdrawalsInner
     */
    'percentageGrowth'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationWithdrawalsRegularWithdrawalsInner
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductIllustrationWithdrawalsSingleWithdrawalsInner
 */
export interface CreateProductIllustrationWithdrawalsSingleWithdrawalsInner {
    /**
     * 
     * @type {number}
     * @memberof CreateProductIllustrationWithdrawalsSingleWithdrawalsInner
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationWithdrawalsSingleWithdrawalsInner
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationWithdrawalsSingleWithdrawalsInner
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductIllustrationWithdrawalsSingleWithdrawalsInner
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface CreateRebalanceEvent
 */
export interface CreateRebalanceEvent {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateRebalanceEvent
     */
    'firmId': string;
    /**
     * The type of event occurring on the account.
     * @type {string}
     * @memberof CreateRebalanceEvent
     */
    'eventType': string;
    /**
     * Unique identifier for the client’s investment account
     * @type {string}
     * @memberof CreateRebalanceEvent
     */
    'accountId'?: string;
    /**
     * Unique identifier for the client’s investment account
     * @type {string}
     * @memberof CreateRebalanceEvent
     */
    'assetAllocationId'?: string;
    /**
     * 
     * @type {CreateRebalanceEventAllOfConfirmedDetails}
     * @memberof CreateRebalanceEvent
     */
    'confirmedDetails'?: CreateRebalanceEventAllOfConfirmedDetails;
}
/**
 * 
 * @export
 * @interface CreateRebalanceEventAllOf
 */
export interface CreateRebalanceEventAllOf {
    /**
     * Unique identifier for the client’s investment account
     * @type {string}
     * @memberof CreateRebalanceEventAllOf
     */
    'accountId'?: string;
    /**
     * Unique identifier for the client’s investment account
     * @type {string}
     * @memberof CreateRebalanceEventAllOf
     */
    'assetAllocationId'?: string;
    /**
     * 
     * @type {CreateRebalanceEventAllOfConfirmedDetails}
     * @memberof CreateRebalanceEventAllOf
     */
    'confirmedDetails'?: CreateRebalanceEventAllOfConfirmedDetails;
}
/**
 * 
 * @export
 * @interface CreateRebalanceEventAllOfConfirmedDetails
 */
export interface CreateRebalanceEventAllOfConfirmedDetails {
    /**
     * The confirmed cash allocation for the model. This is automatically generated where asset allocations do not add up to 1 (100%) but can be specified.
     * @type {number}
     * @memberof CreateRebalanceEventAllOfConfirmedDetails
     */
    'confirmedCashAllocation'?: number;
    /**
     * 
     * @type {Array<CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations>}
     * @memberof CreateRebalanceEventAllOfConfirmedDetails
     */
    'confirmedAllocations'?: Array<CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations>;
}
/**
 * 
 * @export
 * @interface CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations
 */
export interface CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations {
    /**
     * The unique identifier for the asset in the model allocation
     * @type {string}
     * @memberof CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations
     */
    'assetId'?: string;
    /**
     * The currency of the asset in the model allocation
     * @type {string}
     * @memberof CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations
     */
    'currency'?: string;
    /**
     * The proportion of the asset in the model, where asset allocations total 1 (100%)
     * @type {number}
     * @memberof CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations
     */
    'percentage'?: number;
    /**
     * The buy price of the asset allocation
     * @type {number}
     * @memberof CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations
     */
    'buyPrice'?: number;
    /**
     * The sell price of the asset allocation
     * @type {number}
     * @memberof CreateRebalanceEventAllOfConfirmedDetailsConfirmedAllocations
     */
    'sellPrice'?: number;
}
/**
 * 
 * @export
 * @interface CreateTradeIllustration
 */
export interface CreateTradeIllustration {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateTradeIllustration
     */
    'firmId': string;
    /**
     * The unique identifier for a client\'s account.
     * @type {string}
     * @memberof CreateTradeIllustration
     */
    'accountId': string;
    /**
     * Should be set to 60, this equates to 60 months (5 year illustration).
     * @type {number}
     * @memberof CreateTradeIllustration
     */
    'period': number;
    /**
     * This should be 5% as per MiFID II requirements
     * @type {number}
     * @memberof CreateTradeIllustration
     */
    'growthPercentage': number;
    /**
     * This should be set to MIFID
     * @type {string}
     * @memberof CreateTradeIllustration
     */
    'illustrationType': CreateTradeIllustrationIllustrationTypeEnum;
    /**
     * This should be set to MONTHS
     * @type {string}
     * @memberof CreateTradeIllustration
     */
    'periodType': CreateTradeIllustrationPeriodTypeEnum;
    /**
     * Contains details of the trades to be submitted
     * @type {Array<CreateTradeIllustrationTransactionsInner>}
     * @memberof CreateTradeIllustration
     */
    'transactions': Array<CreateTradeIllustrationTransactionsInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateTradeIllustrationIllustrationTypeEnum {
    Mifid = 'MIFID'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateTradeIllustrationPeriodTypeEnum {
    Months = 'MONTHS'
}

/**
 * 
 * @export
 * @interface CreateTradeIllustrationTransactionsInner
 */
export interface CreateTradeIllustrationTransactionsInner {
    /**
     * The amount to be invested in the asset
     * @type {number}
     * @memberof CreateTradeIllustrationTransactionsInner
     */
    'amount': number;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof CreateTradeIllustrationTransactionsInner
     */
    'currency': string;
    /**
     * The unique identifier for the asset to be invested in
     * @type {string}
     * @memberof CreateTradeIllustrationTransactionsInner
     */
    'assetId': string;
}
/**
 * 
 * @export
 * @interface CreateTransfer
 */
export interface CreateTransfer {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateTransfer
     */
    'firmId': string;
    /**
     * The unique identifier of the investment account to instruct the transfer
     * @type {string}
     * @memberof CreateTransfer
     */
    'accountId': string;
    /**
     * Contains details of transactions
     * @type {Array<TransferTransaction>}
     * @memberof CreateTransfer
     */
    'transactions': Array<TransferTransaction>;
}
/**
 * 
 * @export
 * @interface CreateUser
 */
export interface CreateUser {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof CreateUser
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof CreateUser
     */
    'nodeId': Array<string>;
    /**
     * The first name of the user
     * @type {string}
     * @memberof CreateUser
     */
    'firstName': string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof CreateUser
     */
    'surname': string;
    /**
     * The email address of the user
     * @type {string}
     * @memberof CreateUser
     */
    'email': string;
    /**
     * 
     * @type {UserMachineType}
     * @memberof CreateUser
     */
    'userType': UserMachineType;
    /**
     * The levels of access a user has. These are read, read/write and action. The scopes can be implemented across different areas of the system outlined below
     * @type {Array<CreateUserScopesInner>}
     * @memberof CreateUser
     */
    'scopes': Array<CreateUserScopesInner>;
    /**
     * 
     * @type {CreateUserInvestmentDecision}
     * @memberof CreateUser
     */
    'investmentDecision'?: CreateUserInvestmentDecision;
}


/**
 * An object capturing all the national identifier information for the DFM - both the firm and the firm user. All fields are mandatory.
 * @export
 * @interface CreateUserInvestmentDecision
 */
export interface CreateUserInvestmentDecision {
    /**
     * A 20-digit numerical identifier assigned to a DFM
     * @type {string}
     * @memberof CreateUserInvestmentDecision
     */
    'firmLei': string;
    /**
     * A two-letter country code denoting the firm\'s location
     * @type {string}
     * @memberof CreateUserInvestmentDecision
     */
    'firmCountry': string;
    /**
     * The National Identifier for the firm user/decision maker. For 1 nationals this is in the format XX123456X
     * @type {string}
     * @memberof CreateUserInvestmentDecision
     */
    'personId': string;
    /**
     * 
     * @type {PersonalIdentifierType}
     * @memberof CreateUserInvestmentDecision
     */
    'personIdType': PersonalIdentifierType;
    /**
     * A two-letter country code denoting the firm user/decision maker\'s location
     * @type {string}
     * @memberof CreateUserInvestmentDecision
     */
    'personCountry': string;
}


/**
 * 
 * @export
 * @interface CreateUserResponse
 */
export interface CreateUserResponse {
    /**
     * 
     * @type {CreateUserResponseData}
     * @memberof CreateUserResponse
     */
    'data'?: CreateUserResponseData;
}
/**
 * 
 * @export
 * @interface CreateUserResponseData
 */
export interface CreateUserResponseData {
    /**
     * User id of newly created user
     * @type {string}
     * @memberof CreateUserResponseData
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface CreateUserScopesInner
 */
export interface CreateUserScopesInner {
    /**
     * 
     * @type {Array<Permission>}
     * @memberof CreateUserScopesInner
     */
    'ranges'?: Array<Permission>;
    /**
     * 
     * @type {Resource}
     * @memberof CreateUserScopesInner
     */
    'scope'?: Resource;
}


/**
 * 
 * @export
 * @interface CrystalliseAccountDetails
 */
export interface CrystalliseAccountDetails {
    /**
     * 
     * @type {string}
     * @memberof CrystalliseAccountDetails
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrystalliseAccountDetails
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CrystalliseCrystallisationDetails
 */
export interface CrystalliseCrystallisationDetails {
    /**
     * 
     * @type {TransactionSubType}
     * @memberof CrystalliseCrystallisationDetails
     */
    'type'?: TransactionSubType;
    /**
     * 
     * @type {Frequency}
     * @memberof CrystalliseCrystallisationDetails
     */
    'frequency'?: Frequency;
    /**
     * 
     * @type {boolean}
     * @memberof CrystalliseCrystallisationDetails
     */
    'fullCrystallisation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CrystalliseCrystallisationDetails
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrystalliseCrystallisationDetails
     */
    'crystallisationDay'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrystalliseCrystallisationDetails
     */
    'expiryDate'?: string;
}


/**
 * 
 * @export
 * @interface CrystalliseWithdrawalDetails
 */
export interface CrystalliseWithdrawalDetails {
    /**
     * 
     * @type {TransactionType}
     * @memberof CrystalliseWithdrawalDetails
     */
    'transactionType': TransactionType;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof CrystalliseWithdrawalDetails
     */
    'method': PaymentMethod;
    /**
     * 
     * @type {MovementType}
     * @memberof CrystalliseWithdrawalDetails
     */
    'movementType': MovementType;
    /**
     * 
     * @type {TransactionSubType}
     * @memberof CrystalliseWithdrawalDetails
     */
    'transactionSubType': TransactionSubType;
    /**
     * 
     * @type {Frequency}
     * @memberof CrystalliseWithdrawalDetails
     */
    'frequency': Frequency;
    /**
     * 
     * @type {number}
     * @memberof CrystalliseWithdrawalDetails
     */
    'paymentDay'?: number;
    /**
     * 
     * @type {SellDown}
     * @memberof CrystalliseWithdrawalDetails
     */
    'autoDisinvest'?: SellDown;
    /**
     * 
     * @type {boolean}
     * @memberof CrystalliseWithdrawalDetails
     */
    'fullWithdrawal'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CrystalliseWithdrawalDetails
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrystalliseWithdrawalDetails
     */
    'grossAmount'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum DisclaimerType {
    TransactionMissingBookCost = 'TRANSACTION_MISSING_BOOK_COST',
    AssetUnsupportedType = 'ASSET_UNSUPPORTED_TYPE',
    TransactionTransfer = 'TRANSACTION_TRANSFER',
    TransactionCorporateAction = 'TRANSACTION_CORPORATE_ACTION',
    TargetNotReached = 'TARGET_NOT_REACHED',
    TargetAdjustedForMtu = 'TARGET_ADJUSTED_FOR_MTU'
}


/**
 * 
 * @export
 * @interface DismissActionTagRequestBody
 */
export interface DismissActionTagRequestBody {
    /**
     * The reason for dismissing the action tag
     * @type {string}
     * @memberof DismissActionTagRequestBody
     */
    'actionReason': string;
}
/**
 * 
 * @export
 * @interface EmployersInner
 */
export interface EmployersInner {
    /**
     * 
     * @type {AddressDetail}
     * @memberof EmployersInner
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BankDetails}
     * @memberof EmployersInner
     */
    'bankDetails'?: BankDetails;
    /**
     * Name of the employers company
     * @type {string}
     * @memberof EmployersInner
     */
    'companyName'?: string;
    /**
     * The employers company registration number
     * @type {string}
     * @memberof EmployersInner
     */
    'companyRegNo'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EmploymentStatus {
    Employed = 'Employed',
    SelfEmployed = 'Self Employed',
    Unemployed = 'Unemployed',
    Retired = 'Retired',
    CareUnder16s = 'Care Under 16s',
    CareOver16s = 'Care Over 16s',
    Education = 'Education',
    Other = 'Other'
}


/**
 * 
 * @export
 * @interface EmptyResponse
 */
export interface EmptyResponse {
    /**
     * 
     * @type {object}
     * @memberof EmptyResponse
     */
    'data'?: object;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EntityClientType {
    Corporate = 'Corporate',
    Trust = 'Trust'
}


/**
 * 
 * @export
 * @interface EntityDetailsBase
 */
export interface EntityDetailsBase {
    /**
     * Legal entity identifer (LEI) number
     * @type {string}
     * @memberof EntityDetailsBase
     */
    'legalEntityIdentifier'?: string | null;
    /**
     * Requests specify a boolean when the decleration is accepted
     * @type {boolean}
     * @memberof EntityDetailsBase
     */
    'declarationAccepted'?: boolean;
    /**
     * Responses provide the date-time a declaration was saved
     * @type {string}
     * @memberof EntityDetailsBase
     */
    'declarationAcceptedDate'?: string;
    /**
     * 
     * @type {EntityDetailsBaseKnowYourBusiness}
     * @memberof EntityDetailsBase
     */
    'knowYourBusiness'?: EntityDetailsBaseKnowYourBusiness;
}
/**
 * KYB due diligence checks
 * @export
 * @interface EntityDetailsBaseKnowYourBusiness
 */
export interface EntityDetailsBaseKnowYourBusiness {
    /**
     * When these KYB checks were performed
     * @type {string}
     * @memberof EntityDetailsBaseKnowYourBusiness
     */
    'checksPerformed': string;
    /**
     * Flag that this entity is linked to a PEP
     * @type {boolean}
     * @memberof EntityDetailsBaseKnowYourBusiness
     */
    'pepOrPepAssociated'?: boolean;
    /**
     * Details of the linked PEP
     * @type {Array<EntityDetailsBaseKnowYourBusinessPepDetailsInner>}
     * @memberof EntityDetailsBaseKnowYourBusiness
     */
    'pepDetails'?: Array<EntityDetailsBaseKnowYourBusinessPepDetailsInner>;
}
/**
 * 
 * @export
 * @interface EntityDetailsBaseKnowYourBusinessPepDetailsInner
 */
export interface EntityDetailsBaseKnowYourBusinessPepDetailsInner {
    /**
     * Legal first name of the PEP
     * @type {string}
     * @memberof EntityDetailsBaseKnowYourBusinessPepDetailsInner
     */
    'firstName': string;
    /**
     * Legal surname name of the PEP
     * @type {string}
     * @memberof EntityDetailsBaseKnowYourBusinessPepDetailsInner
     */
    'surname': string;
    /**
     * How is this PEP connected to the entity
     * @type {string}
     * @memberof EntityDetailsBaseKnowYourBusinessPepDetailsInner
     */
    'relationshipToCompany': string;
}
/**
 * Additional properties for corporate clients
 * @export
 * @interface EntityDetailsCorporate
 */
export interface EntityDetailsCorporate {
    /**
     * Legal entity identifer (LEI) number
     * @type {string}
     * @memberof EntityDetailsCorporate
     */
    'legalEntityIdentifier'?: string | null;
    /**
     * Requests specify a boolean when the decleration is accepted
     * @type {boolean}
     * @memberof EntityDetailsCorporate
     */
    'declarationAccepted'?: boolean;
    /**
     * Responses provide the date-time a declaration was saved
     * @type {string}
     * @memberof EntityDetailsCorporate
     */
    'declarationAcceptedDate'?: string;
    /**
     * 
     * @type {EntityDetailsBaseKnowYourBusiness}
     * @memberof EntityDetailsCorporate
     */
    'knowYourBusiness'?: EntityDetailsBaseKnowYourBusiness;
    /**
     * Company registration number
     * @type {string}
     * @memberof EntityDetailsCorporate
     */
    'companyRegNo'?: string;
    /**
     * Details of individuals associated with this company
     * @type {Array<EntityDetailsCorporateSpecificsStakeholdersInner>}
     * @memberof EntityDetailsCorporate
     */
    'stakeholders'?: Array<EntityDetailsCorporateSpecificsStakeholdersInner>;
}
/**
 * 
 * @export
 * @interface EntityDetailsCorporateSpecifics
 */
export interface EntityDetailsCorporateSpecifics {
    /**
     * Company registration number
     * @type {string}
     * @memberof EntityDetailsCorporateSpecifics
     */
    'companyRegNo'?: string;
    /**
     * Details of individuals associated with this company
     * @type {Array<EntityDetailsCorporateSpecificsStakeholdersInner>}
     * @memberof EntityDetailsCorporateSpecifics
     */
    'stakeholders'?: Array<EntityDetailsCorporateSpecificsStakeholdersInner>;
}
/**
 * 
 * @export
 * @interface EntityDetailsCorporateSpecificsStakeholdersInner
 */
export interface EntityDetailsCorporateSpecificsStakeholdersInner {
    /**
     * Role of this stakeholder
     * @type {string}
     * @memberof EntityDetailsCorporateSpecificsStakeholdersInner
     */
    'role': EntityDetailsCorporateSpecificsStakeholdersInnerRoleEnum;
    /**
     * The ID of the client object representing this stakeholder
     * @type {string}
     * @memberof EntityDetailsCorporateSpecificsStakeholdersInner
     */
    'clientId': string;
    /**
     * Allowed management permissions
     * @type {boolean}
     * @memberof EntityDetailsCorporateSpecificsStakeholdersInner
     */
    'clientAndAccountManagement': boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityDetailsCorporateSpecificsStakeholdersInnerRoleEnum {
    Director = 'Director',
    SignificantShareholder = 'Significant Shareholder',
    PrincipalOrPartner = 'Principal Or Partner'
}

/**
 * @type EntityDetailsCorporateSpecificsStakeholdersInnerAllOf
 * @export
 */
export type EntityDetailsCorporateSpecificsStakeholdersInnerAllOf = CorporateStakeholderNonClient | object;

/**
 * Additional properties for trust clients
 * @export
 * @interface EntityDetailsTrust
 */
export interface EntityDetailsTrust {
    /**
     * Legal entity identifer (LEI) number
     * @type {string}
     * @memberof EntityDetailsTrust
     */
    'legalEntityIdentifier'?: string | null;
    /**
     * Requests specify a boolean when the decleration is accepted
     * @type {boolean}
     * @memberof EntityDetailsTrust
     */
    'declarationAccepted'?: boolean;
    /**
     * Responses provide the date-time a declaration was saved
     * @type {string}
     * @memberof EntityDetailsTrust
     */
    'declarationAcceptedDate'?: string;
    /**
     * 
     * @type {EntityDetailsBaseKnowYourBusiness}
     * @memberof EntityDetailsTrust
     */
    'knowYourBusiness'?: EntityDetailsBaseKnowYourBusiness;
    /**
     * Type of trust
     * @type {string}
     * @memberof EntityDetailsTrust
     */
    'type'?: EntityDetailsTrustTypeEnum;
    /**
     * Trust reference number
     * @type {string}
     * @memberof EntityDetailsTrust
     */
    'uniqueTrustReference'?: string;
    /**
     * Charity reference number
     * @type {string}
     * @memberof EntityDetailsTrust
     */
    'uniqueCharityReference'?: string;
    /**
     * Details of individuals associated with this trust
     * @type {Array<EntityDetailsTrustSpecificsStakeholdersInner>}
     * @memberof EntityDetailsTrust
     */
    'stakeholders'?: Array<EntityDetailsTrustSpecificsStakeholdersInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityDetailsTrustTypeEnum {
    Accumulation = 'Accumulation',
    Bare = 'Bare',
    Discretionary = 'Discretionary',
    InterestInPossession = 'Interest in possession',
    Mixed = 'Mixed',
    Other = 'Other',
    SettlorInterested = 'Settlor-interested',
    Charity = 'Charity'
}

/**
 * 
 * @export
 * @interface EntityDetailsTrustSpecifics
 */
export interface EntityDetailsTrustSpecifics {
    /**
     * Type of trust
     * @type {string}
     * @memberof EntityDetailsTrustSpecifics
     */
    'type'?: EntityDetailsTrustSpecificsTypeEnum;
    /**
     * Trust reference number
     * @type {string}
     * @memberof EntityDetailsTrustSpecifics
     */
    'uniqueTrustReference'?: string;
    /**
     * Charity reference number
     * @type {string}
     * @memberof EntityDetailsTrustSpecifics
     */
    'uniqueCharityReference'?: string;
    /**
     * Details of individuals associated with this trust
     * @type {Array<EntityDetailsTrustSpecificsStakeholdersInner>}
     * @memberof EntityDetailsTrustSpecifics
     */
    'stakeholders'?: Array<EntityDetailsTrustSpecificsStakeholdersInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityDetailsTrustSpecificsTypeEnum {
    Accumulation = 'Accumulation',
    Bare = 'Bare',
    Discretionary = 'Discretionary',
    InterestInPossession = 'Interest in possession',
    Mixed = 'Mixed',
    Other = 'Other',
    SettlorInterested = 'Settlor-interested',
    Charity = 'Charity'
}

/**
 * 
 * @export
 * @interface EntityDetailsTrustSpecificsStakeholdersInner
 */
export interface EntityDetailsTrustSpecificsStakeholdersInner {
    /**
     * Role of this stakeholder
     * @type {string}
     * @memberof EntityDetailsTrustSpecificsStakeholdersInner
     */
    'role': EntityDetailsTrustSpecificsStakeholdersInnerRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailsTrustSpecificsStakeholdersInner
     */
    'relationshipToBeneficiary'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityDetailsTrustSpecificsStakeholdersInner
     */
    'sourceOfWealth'?: string;
    /**
     * The ID of the client object representing this stakeholder
     * @type {string}
     * @memberof EntityDetailsTrustSpecificsStakeholdersInner
     */
    'clientId': string;
    /**
     * Allowed management permissions
     * @type {boolean}
     * @memberof EntityDetailsTrustSpecificsStakeholdersInner
     */
    'clientAndAccountManagement'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityDetailsTrustSpecificsStakeholdersInnerRoleEnum {
    Settlor = 'Settlor',
    Trustee = 'Trustee',
    Beneficiary = 'Beneficiary'
}

/**
 * @type EntityDetailsTrustSpecificsStakeholdersInnerAllOf
 * @export
 */
export type EntityDetailsTrustSpecificsStakeholdersInnerAllOf = TrustStakeholderNonClient | object;

/**
 * @type EventPostRequest
 * @export
 */
export type EventPostRequest = { eventType: 'Ad Hoc Valuation Statement' } & CreateAdHocValuationStatementEvent | { eventType: 'Portfolio Realign' } & CreatePortfolioRealignEvent | { eventType: 'Rebalance' } & CreateRebalanceEvent | { eventType: 'createAdHocValuationStatementEvent' } & CreateAdHocValuationStatementEvent | { eventType: 'createPortfolioRealignEvent' } & CreatePortfolioRealignEvent | { eventType: 'createRebalanceEvent' } & CreateRebalanceEvent;

/**
 * 
 * @export
 * @interface ExternalIdsInner
 */
export interface ExternalIdsInner {
    /**
     * The key describing the type of external identifier
     * @type {string}
     * @memberof ExternalIdsInner
     */
    'idType'?: string;
    /**
     * The value of the external identifier
     * @type {string}
     * @memberof ExternalIdsInner
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface FeatureFlagContent
 */
export interface FeatureFlagContent {
    /**
     * 
     * @type {Array<string>}
     * @memberof FeatureFlagContent
     */
    'data': Array<string>;
}
/**
 * 
 * @export
 * @interface FeeCoveredAccountsResponse
 */
export interface FeeCoveredAccountsResponse {
    /**
     * 
     * @type {Array<FeePayingAccountItem>}
     * @memberof FeeCoveredAccountsResponse
     */
    'data'?: Array<FeePayingAccountItem>;
}
/**
 * 
 * @export
 * @interface FeePayingAccountItem
 */
export interface FeePayingAccountItem {
    /**
     * 
     * @type {string}
     * @memberof FeePayingAccountItem
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof FeePayingAccountItem
     */
    'accountName': string;
}
/**
 * 
 * @export
 * @interface FeeStructureItem
 */
export interface FeeStructureItem {
    /**
     * 
     * @type {string}
     * @memberof FeeStructureItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FeeStructureItem
     */
    'type': FeeStructureItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeeStructureItem
     */
    'name': string;
    /**
     * 
     * @type {Array<FeeStructureItemTiersInner>}
     * @memberof FeeStructureItem
     */
    'tiers': Array<FeeStructureItemTiersInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum FeeStructureItemTypeEnum {
    AdviserFee = 'Adviser Fee',
    PlatformFee = 'Platform Fee'
}

/**
 * 
 * @export
 * @interface FeeStructureItemTiersInner
 */
export interface FeeStructureItemTiersInner {
    /**
     * 
     * @type {number}
     * @memberof FeeStructureItemTiersInner
     */
    'fromAmount': number;
    /**
     * 
     * @type {number}
     * @memberof FeeStructureItemTiersInner
     */
    'toAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof FeeStructureItemTiersInner
     */
    'rate': number;
}
/**
 * 
 * @export
 * @interface FeeStructuresResponse
 */
export interface FeeStructuresResponse {
    /**
     * 
     * @type {Array<FeeStructureItem>}
     * @memberof FeeStructuresResponse
     */
    'data'?: Array<FeeStructureItem>;
}
/**
 * 
 * @export
 * @interface FetchConfiguration
 */
export interface FetchConfiguration {
    /**
     * 
     * @type {FetchConfigurationData}
     * @memberof FetchConfiguration
     */
    'data': FetchConfigurationData;
}
/**
 * 
 * @export
 * @interface FetchConfigurationData
 */
export interface FetchConfigurationData {
    /**
     * 
     * @type {InvestorConfiguration}
     * @memberof FetchConfigurationData
     */
    'investor': InvestorConfiguration;
    /**
     * 
     * @type {CommunicationConfiguration}
     * @memberof FetchConfigurationData
     */
    'communication': CommunicationConfiguration;
    /**
     * 
     * @type {ProfessionalConfiguration}
     * @memberof FetchConfigurationData
     */
    'professional': ProfessionalConfiguration;
}
/**
 * 
 * @export
 * @interface FetchContent
 */
export interface FetchContent {
    /**
     * 
     * @type {FetchContentData}
     * @memberof FetchContent
     */
    'data': FetchContentData;
}
/**
 * 
 * @export
 * @interface FetchContentData
 */
export interface FetchContentData {
    /**
     * 
     * @type {InvestorContent}
     * @memberof FetchContentData
     */
    'investor'?: InvestorContent;
    /**
     * 
     * @type {ProfessionalContent}
     * @memberof FetchContentData
     */
    'professional'?: ProfessionalContent;
    /**
     * 
     * @type {CommunicationContent}
     * @memberof FetchContentData
     */
    'communication'?: CommunicationContent;
    /**
     * Temporary data to be returned in order to support unauthenticated branding
     * @type {Array<string>}
     * @memberof FetchContentData
     */
    'enabledFeatureFlags'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FetchSettings
 */
export interface FetchSettings {
    /**
     * The firm name that appears on the login page, email communications, PDF files, and in the Professional and Investor UIs.
     * @type {string}
     * @memberof FetchSettings
     */
    'firmName': string;
    /**
     * This is true if the firm the Professional UI is enabled for the firm.
     * @type {boolean}
     * @memberof FetchSettings
     */
    'hasProfessionalUI': boolean;
    /**
     * This is true if the firm the Professional UI is enabled for the firm.
     * @type {boolean}
     * @memberof FetchSettings
     */
    'hasInvestorUI': boolean;
}
/**
 * 
 * @export
 * @interface FetchTheme
 */
export interface FetchTheme {
    /**
     * 
     * @type {FetchThemeData}
     * @memberof FetchTheme
     */
    'data': FetchThemeData;
}
/**
 * 
 * @export
 * @interface FetchThemeData
 */
export interface FetchThemeData {
    /**
     * 
     * @type {InvestorTheme}
     * @memberof FetchThemeData
     */
    'investor': InvestorTheme;
    /**
     * 
     * @type {ProfessionalTheme}
     * @memberof FetchThemeData
     */
    'professional': ProfessionalTheme;
    /**
     * 
     * @type {CommunicationTheme}
     * @memberof FetchThemeData
     */
    'communication': CommunicationTheme;
    /**
     * 
     * @type {WealthsweetTheme}
     * @memberof FetchThemeData
     */
    'wealthsweet': WealthsweetTheme;
}
/**
 * 
 * @export
 * @interface FilesFileTypePost200Response
 */
export interface FilesFileTypePost200Response {
    /**
     * 
     * @type {FilesFileTypePost200ResponseData}
     * @memberof FilesFileTypePost200Response
     */
    'data'?: FilesFileTypePost200ResponseData;
}
/**
 * 
 * @export
 * @interface FilesFileTypePost200ResponseData
 */
export interface FilesFileTypePost200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof FilesFileTypePost200ResponseData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilesFileTypePost200ResponseData
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface FilestoreManualtransferinFirmidFileUploadIdGet200Response
 */
export interface FilestoreManualtransferinFirmidFileUploadIdGet200Response {
    /**
     * 
     * @type {FilestoreManualtransferinFirmidFileUploadIdGet200ResponseData}
     * @memberof FilestoreManualtransferinFirmidFileUploadIdGet200Response
     */
    'data'?: FilestoreManualtransferinFirmidFileUploadIdGet200ResponseData;
}
/**
 * 
 * @export
 * @interface FilestoreManualtransferinFirmidFileUploadIdGet200ResponseData
 */
export interface FilestoreManualtransferinFirmidFileUploadIdGet200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinFirmidFileUploadIdGet200ResponseData
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface FilestoreManualtransferinPost200Response
 */
export interface FilestoreManualtransferinPost200Response {
    /**
     * 
     * @type {FilestoreManualtransferinPost200ResponseData}
     * @memberof FilestoreManualtransferinPost200Response
     */
    'data'?: FilestoreManualtransferinPost200ResponseData;
}
/**
 * 
 * @export
 * @interface FilestoreManualtransferinPost200ResponseData
 */
export interface FilestoreManualtransferinPost200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseData
     */
    'url': string;
    /**
     * 
     * @type {FilestoreManualtransferinPost200ResponseDataFields}
     * @memberof FilestoreManualtransferinPost200ResponseData
     */
    'fields': FilestoreManualtransferinPost200ResponseDataFields;
}
/**
 * 
 * @export
 * @interface FilestoreManualtransferinPost200ResponseDataFields
 */
export interface FilestoreManualtransferinPost200ResponseDataFields {
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'Content-Type': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'bucket': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'X-Amz-Algorithm': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'X-Amz-Credential': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'X-Amz-Date': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'X-Amz-Security-Token': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'Policy': string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreManualtransferinPost200ResponseDataFields
     */
    'X-Amz-Signature': string;
}
/**
 * 
 * @export
 * @interface FilestoreManualtransferinPostRequest
 */
export interface FilestoreManualtransferinPostRequest {
    /**
     * Id of the Firm
     * @type {string}
     * @memberof FilestoreManualtransferinPostRequest
     */
    'firmId': string;
}
/**
 * 
 * @export
 * @interface FilestoreManualtransferinRefreshPostRequest
 */
export interface FilestoreManualtransferinRefreshPostRequest {
    /**
     * Id of the Firm
     * @type {string}
     * @memberof FilestoreManualtransferinRefreshPostRequest
     */
    'firmId': string;
    /**
     * Id of the File Upload record
     * @type {string}
     * @memberof FilestoreManualtransferinRefreshPostRequest
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface FirmBrandingContent
 */
export interface FirmBrandingContent {
    /**
     * 
     * @type {string}
     * @memberof FirmBrandingContent
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FirmBrandingContent
     */
    'locale': string;
    /**
     * 
     * @type {string}
     * @memberof FirmBrandingContent
     */
    'contentId': string;
    /**
     * 
     * @type {string}
     * @memberof FirmBrandingContent
     */
    'space': string;
    /**
     * 
     * @type {FirmBrandingContentData}
     * @memberof FirmBrandingContent
     */
    'data': FirmBrandingContentData;
}
/**
 * 
 * @export
 * @interface FirmBrandingContentData
 */
export interface FirmBrandingContentData {
    /**
     * 
     * @type {string}
     * @memberof FirmBrandingContentData
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof FirmBrandingContentData
     */
    'nodeId': string;
}
/**
 * Response containing presigned URL, AWS upload fields, and validation metadata for a new file upload
 * @export
 * @interface FirmFilesUploadResponse
 */
export interface FirmFilesUploadResponse {
    /**
     * 
     * @type {FirmFilesUploadResponseData}
     * @memberof FirmFilesUploadResponse
     */
    'data'?: FirmFilesUploadResponseData;
}
/**
 * 
 * @export
 * @interface FirmFilesUploadResponseData
 */
export interface FirmFilesUploadResponseData {
    /**
     * The presigned S3 upload URL
     * @type {string}
     * @memberof FirmFilesUploadResponseData
     */
    'url': string;
    /**
     * 
     * @type {FirmFilesUploadResponseDataFields}
     * @memberof FirmFilesUploadResponseData
     */
    'fields': FirmFilesUploadResponseDataFields;
    /**
     * Unique S3 object key / filename to be used when uploading the file
     * @type {string}
     * @memberof FirmFilesUploadResponseData
     */
    'key': string;
    /**
     * List of accepted MIME types for this upload
     * @type {Array<string>}
     * @memberof FirmFilesUploadResponseData
     */
    'allowedContentTypes': Array<string>;
    /**
     * Maximum allowed file size in bytes
     * @type {number}
     * @memberof FirmFilesUploadResponseData
     */
    'maxFileSize': number;
}
/**
 * AWS S3 upload form fields required by the client
 * @export
 * @interface FirmFilesUploadResponseDataFields
 */
export interface FirmFilesUploadResponseDataFields {
    /**
     * 
     * @type {string}
     * @memberof FirmFilesUploadResponseDataFields
     */
    'Content-Type': string;
    /**
     * 
     * @type {string}
     * @memberof FirmFilesUploadResponseDataFields
     */
    'x-amz-meta-firm-id': string;
    /**
     * 
     * @type {string}
     * @memberof FirmFilesUploadResponseDataFields
     */
    'x-amz-meta-node-id': string;
    /**
     * 
     * @type {string}
     * @memberof FirmFilesUploadResponseDataFields
     */
    'x-amz-meta-category': string;
}
/**
 * 
 * @export
 * @interface FirmHostname
 */
export interface FirmHostname {
    /**
     * 
     * @type {string}
     * @memberof FirmHostname
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirmHostname
     */
    'windowTitle'?: string;
    /**
     * 
     * @type {HostnameType}
     * @memberof FirmHostname
     */
    'type'?: HostnameType;
    /**
     * 
     * @type {string}
     * @memberof FirmHostname
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirmHostname
     */
    'nodeId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FirmHostname
     */
    'hosts'?: Array<string>;
}


/**
 * 
 * @export
 * @interface FlagWithSource
 */
export interface FlagWithSource {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof FlagWithSource
     */
    'sourceNodeId': string;
    /**
     * The property flag value.
     * @type {boolean}
     * @memberof FlagWithSource
     */
    'value': boolean;
}
/**
 * 
 * @export
 * @interface FlagWithSourceAllOf
 */
export interface FlagWithSourceAllOf {
    /**
     * The property flag value.
     * @type {boolean}
     * @memberof FlagWithSourceAllOf
     */
    'value': boolean;
}
/**
 * @type ForeignTaxResidency
 * @export
 */
export type ForeignTaxResidency = ForeignTaxResidencyWithTin | ForeignTaxResidencyWithoutTin;

/**
 * 
 * @export
 * @interface ForeignTaxResidencyWithTin
 */
export interface ForeignTaxResidencyWithTin {
    /**
     * ISO 3166-1 alpha-2 country code of the foreign tax residency. `US` is not accepted — clients with US tax residencies may not use the system.
     * @type {string}
     * @memberof ForeignTaxResidencyWithTin
     */
    'countryCode': string;
    /**
     * Discriminates the two cases. Must be `true` when a TIN is provided.
     * @type {boolean}
     * @memberof ForeignTaxResidencyWithTin
     */
    'taxIdentificationNumberIsAvailable': boolean;
    /**
     * The TIN type for the country (per-country enum, e.g. IE: `PPS`, `TRN`, `CHY`).
     * @type {string}
     * @memberof ForeignTaxResidencyWithTin
     */
    'taxIdentificationNumberType': string;
    /**
     * The tax identification number. Validated against the per-country / per-type format.
     * @type {string}
     * @memberof ForeignTaxResidencyWithTin
     */
    'taxIdentificationNumber': string;
}
/**
 * 
 * @export
 * @interface ForeignTaxResidencyWithoutTin
 */
export interface ForeignTaxResidencyWithoutTin {
    /**
     * ISO 3166-1 alpha-2 country code of the foreign tax residency. `US` is not accepted — clients with US tax residencies may not use the system.
     * @type {string}
     * @memberof ForeignTaxResidencyWithoutTin
     */
    'countryCode': string;
    /**
     * Discriminates the two cases. Must be `false` when no TIN is provided.
     * @type {boolean}
     * @memberof ForeignTaxResidencyWithoutTin
     */
    'taxIdentificationNumberIsAvailable': boolean;
    /**
     * Free-text reason why no tax identification number is available.
     * @type {string}
     * @memberof ForeignTaxResidencyWithoutTin
     */
    'reasonForNoTaxIdentificationNumber': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum Frequency {
    Single = 'Single',
    Regular = 'Regular'
}


/**
 * 
 * @export
 * @interface GenerateDocument
 */
export interface GenerateDocument {
    /**
     * The unique identifier of the client that the illustration was generated for
     * @type {string}
     * @memberof GenerateDocument
     */
    'clientId'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GenerateDocument
     */
    'firmId'?: string;
    /**
     * The unique identifier of the illustration
     * @type {string}
     * @memberof GenerateDocument
     */
    'id'?: string;
    /**
     * Required for creating product illustrations.
     * @type {string}
     * @memberof GenerateDocument
     */
    'fileType'?: string;
    /**
     * Required for creating retirement packs
     * @type {boolean}
     * @memberof GenerateDocument
     */
    'isPublic'?: boolean;
}
/**
 * 
 * @export
 * @interface GenerateDocumentResponse
 */
export interface GenerateDocumentResponse {
    /**
     * 
     * @type {GenerateDocumentResponseData}
     * @memberof GenerateDocumentResponse
     */
    'data'?: GenerateDocumentResponseData;
}
/**
 * 
 * @export
 * @interface GenerateDocumentResponseData
 */
export interface GenerateDocumentResponseData {
    /**
     * User id of newly created document
     * @type {string}
     * @memberof GenerateDocumentResponseData
     */
    'id'?: string;
    /**
     * Url of generated document used to initate download to UI
     * @type {string}
     * @memberof GenerateDocumentResponseData
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface GenerateFile
 */
export interface GenerateFile {
    /**
     * The unique identifier of your platform
     * @type {string}
     * @memberof GenerateFile
     */
    'firmId'?: string;
    /**
     * The unique identifier of the illustration
     * @type {string}
     * @memberof GenerateFile
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateFile
     */
    'fileType'?: GenerateFileFileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenerateFile
     */
    'type'?: GenerateFileTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GenerateFileFileTypeEnum {
    Illustration = 'ILLUSTRATION'
}
/**
    * @export
    * @enum {string}
    */
export enum GenerateFileTypeEnum {
    GenerateIllustrationDoc = 'GENERATE_ILLUSTRATION_DOC'
}

/**
 * 
 * @export
 * @interface GenericValueFields
 */
export interface GenericValueFields {
    /**
     * The opening value of the current record - if no date parameters are provided, this will show as 0 
     * @type {number}
     * @memberof GenericValueFields
     */
    'openingValue'?: number;
    /**
     * The current total value at the current record level - if no date parameters are provided, this will show as at today\'s date 
     * @type {number}
     * @memberof GenericValueFields
     */
    'currentValue'?: number;
    /**
     * The value of the transfer onto the platform at the current record level
     * @type {number}
     * @memberof GenericValueFields
     */
    'transferValue'?: number;
}
/**
 * 
 * @export
 * @interface GetAbridgedIllustrationsList
 */
export interface GetAbridgedIllustrationsList {
    /**
     * 
     * @type {Array<GetAbridgedIllustrationsListDataInner>}
     * @memberof GetAbridgedIllustrationsList
     */
    'data'?: Array<GetAbridgedIllustrationsListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetAbridgedIllustrationsList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetAbridgedIllustrationsListDataInner
 */
export interface GetAbridgedIllustrationsListDataInner {
    /**
     * 
     * @type {GetAbridgedIllustrationsListDataInnerClientInfo}
     * @memberof GetAbridgedIllustrationsListDataInner
     */
    'clientInfo': GetAbridgedIllustrationsListDataInnerClientInfo;
    /**
     * The name of the illustration
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInner
     */
    'illustrationName': string;
    /**
     * The illustration reference
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInner
     */
    'reference': string;
    /**
     * The date the illustration was produced
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInner
     */
    'illustrationDate'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetAbridgedIllustrationsListDataInner
     */
    'wrapperType': WrapperType;
    /**
     * Additional client details object
     * @type {Array<GetAbridgedIllustrationsListDataInnerAdditionalClientsInfoInner>}
     * @memberof GetAbridgedIllustrationsListDataInner
     */
    'additionalClientsInfo'?: Array<GetAbridgedIllustrationsListDataInnerAdditionalClientsInfoInner>;
    /**
     * Async calculation status of the illustration
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInner
     */
    'status'?: GetAbridgedIllustrationsListDataInnerStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GetAbridgedIllustrationsListDataInnerStatusEnum {
    Pending = 'Pending',
    Calculating = 'Calculating',
    Error = 'Error',
    Removed = 'Removed'
}

/**
 * 
 * @export
 * @interface GetAbridgedIllustrationsListDataInnerAdditionalClientsInfoInner
 */
export interface GetAbridgedIllustrationsListDataInnerAdditionalClientsInfoInner {
    /**
     * Client ID
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInnerAdditionalClientsInfoInner
     */
    'id': string;
    /**
     * Client first name
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInnerAdditionalClientsInfoInner
     */
    'firstName': string;
    /**
     * Client surname
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInnerAdditionalClientsInfoInner
     */
    'surname': string;
}
/**
 * Client details object
 * @export
 * @interface GetAbridgedIllustrationsListDataInnerClientInfo
 */
export interface GetAbridgedIllustrationsListDataInnerClientInfo {
    /**
     * TBD
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInnerClientInfo
     */
    'firstName': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInnerClientInfo
     */
    'id': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInnerClientInfo
     */
    'middleName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAbridgedIllustrationsListDataInnerClientInfo
     */
    'surname': string;
}
/**
 * 
 * @export
 * @interface GetAccount
 */
export interface GetAccount {
    /**
     * 
     * @type {Account}
     * @memberof GetAccount
     */
    'data'?: Account;
}
/**
 * 
 * @export
 * @interface GetAccountFees
 */
export interface GetAccountFees {
    /**
     * 
     * @type {GetAccountFeesData}
     * @memberof GetAccountFees
     */
    'data'?: GetAccountFeesData;
}
/**
 * 
 * @export
 * @interface GetAccountFeesData
 */
export interface GetAccountFeesData {
    /**
     * 
     * @type {GetAccountFeesDataAdviserFee}
     * @memberof GetAccountFeesData
     */
    'adviserFee': GetAccountFeesDataAdviserFee;
    /**
     * 
     * @type {GetAccountFeesDataPlatformFee}
     * @memberof GetAccountFeesData
     */
    'platformFee': GetAccountFeesDataPlatformFee;
}
/**
 * @type GetAccountFeesDataAdviserFee
 * @export
 */
export type GetAccountFeesDataAdviserFee = AccountAdviserFee | object;

/**
 * @type GetAccountFeesDataPlatformFee
 * @export
 */
export type GetAccountFeesDataPlatformFee = AccountPlatformFee | object;

/**
 * 
 * @export
 * @interface GetAccountReport
 */
export interface GetAccountReport {
    /**
     * 
     * @type {GetAccountReportData}
     * @memberof GetAccountReport
     */
    'data'?: GetAccountReportData;
}
/**
 * 
 * @export
 * @interface GetAccountReportData
 */
export interface GetAccountReportData {
    /**
     * The unique identifier of the investment account
     * @type {string}
     * @memberof GetAccountReportData
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetAccountReportData
     */
    'firmId'?: string;
    /**
     * The full name of the client, including title, first name and surname
     * @type {string}
     * @memberof GetAccountReportData
     */
    'name'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetAccountReportData
     */
    'currency'?: string;
    /**
     * The type of account
     * @type {string}
     * @memberof GetAccountReportData
     */
    'accountType'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetAccountReportData
     */
    'wrapperType'?: WrapperType;
    /**
     * 
     * @type {GetAccountReportDataPositions}
     * @memberof GetAccountReportData
     */
    'positions'?: GetAccountReportDataPositions;
    /**
     * 
     * @type {ReportPayments}
     * @memberof GetAccountReportData
     */
    'payments'?: ReportPayments;
    /**
     * 
     * @type {ReportCharges}
     * @memberof GetAccountReportData
     */
    'charges'?: ReportCharges;
    /**
     * 
     * @type {ReportIncome}
     * @memberof GetAccountReportData
     */
    'income'?: ReportIncome;
    /**
     * 
     * @type {ReportTransfers}
     * @memberof GetAccountReportData
     */
    'transfers'?: ReportTransfers;
    /**
     * 
     * @type {ReportInternalTransfers}
     * @memberof GetAccountReportData
     */
    'internalTransfers'?: ReportInternalTransfers;
    /**
     * 
     * @type {ReportPerformance}
     * @memberof GetAccountReportData
     */
    'performance'?: ReportPerformance;
    /**
     * The closing value of the account. If no date parameters are provided, this will show as of today\'s date
     * @type {number}
     * @memberof GetAccountReportData
     */
    'closingValue'?: number;
    /**
     * The opening value of the account. If no date parameters are provided, this will show as 0
     * @type {number}
     * @memberof GetAccountReportData
     */
    'openingValue'?: number;
}


/**
 * @type GetAccountReportDataPositions
 * Contains a summary of the individual cash and asset positions within the portfolio
 * @export
 */
export type GetAccountReportDataPositions = Array<any> | GetAccountSummaryListDataInnerPositionsInner;

/**
 * 
 * @export
 * @interface GetAccountSummary
 */
export interface GetAccountSummary {
    /**
     * 
     * @type {GetAccountSummaryData}
     * @memberof GetAccountSummary
     */
    'data'?: GetAccountSummaryData;
}
/**
 * 
 * @export
 * @interface GetAccountSummaryData
 */
export interface GetAccountSummaryData {
    /**
     * The unique identifier of the investment account
     * @type {string}
     * @memberof GetAccountSummaryData
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetAccountSummaryData
     */
    'firmId'?: string;
    /**
     * The unique node identifier that the client record is attached to
     * @type {string}
     * @memberof GetAccountSummaryData
     */
    'nodeId'?: string;
    /**
     * The full name of the client, including title, first name and surname
     * @type {string}
     * @memberof GetAccountSummaryData
     */
    'name'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetAccountSummaryData
     */
    'currency'?: string;
    /**
     * The type of account
     * @type {string}
     * @memberof GetAccountSummaryData
     */
    'accountType'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetAccountSummaryData
     */
    'wrapperType'?: WrapperType;
    /**
     * 
     * @type {GetAccountSummaryDataWrapperDetail}
     * @memberof GetAccountSummaryData
     */
    'wrapperDetail'?: GetAccountSummaryDataWrapperDetail;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetAccountSummaryData
     */
    'recurringPayment'?: boolean;
    /**
     * 
     * @type {GetAccountSummaryDataRecurringOrders}
     * @memberof GetAccountSummaryData
     */
    'recurringOrders'?: GetAccountSummaryDataRecurringOrders;
    /**
     * The status of the account
     * @type {string}
     * @memberof GetAccountSummaryData
     */
    'status'?: string;
    /**
     * The unique identifier of the client account
     * @type {string}
     * @memberof GetAccountSummaryData
     */
    'clientId'?: string;
    /**
     * Contains a summary of the individual cash and asset positions within the portfolio
     * @type {Array<AccountPosition>}
     * @memberof GetAccountSummaryData
     */
    'positions'?: Array<AccountPosition>;
    /**
     * The current value of the account. If no date parameters are provided, this will show as of today\'s date
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'currentValue'?: number;
    /**
     * The opening value of the account. If no date parameters are provided, this will show as 0
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'openingValue'?: number;
    /**
     * TBD
     * @type {any}
     * @memberof GetAccountSummaryData
     */
    'openingStockValue'?: any;
    /**
     * TBD
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'openingCashValue'?: number;
    /**
     * The sum of the positions.bookValue in the positions array
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'bookValue'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'transferBookValue'?: number;
    /**
     * The sum of the positions.nonTransferBookValue in the positions array
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'nonTransferBookValue'?: number;
    /**
     * The growth since book costs
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'growth'?: number;
    /**
     * The growth since assets on platform
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'adjustedGrowth'?: number;
    /**
     * The amount of cash in the account
     * @type {any}
     * @memberof GetAccountSummaryData
     */
    'closingCashValue'?: any;
    /**
     * The amount of cash in the account
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'uninvestedCash'?: number;
    /**
     * 
     * @type {PendingDeposits}
     * @memberof GetAccountSummaryData
     */
    'pendingDeposits'?: PendingDeposits;
    /**
     * Settled cash that can be withdrawn now (uninvested cash less any unsettled sells)
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'withdrawableCash'?: number;
    /**
     * Completed sell orders whose cash has executed but not yet settled
     * @type {Array<UnsettledSell>}
     * @memberof GetAccountSummaryData
     */
    'unsettledSells'?: Array<UnsettledSell>;
    /**
     * 
     * @type {RingfencedCashBreakdown}
     * @memberof GetAccountSummaryData
     */
    'ringfencedCashBreakdown'?: RingfencedCashBreakdown;
    /**
     * TBD
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'closingStockValue'?: number;
    /**
     * The growth since book costs as percentage
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'growthPercent'?: number;
    /**
     * The growth since assets on platform as percentage
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The sum of the transferValue within the positions array
     * @type {number}
     * @memberof GetAccountSummaryData
     */
    'transferValue'?: number;
    /**
     * 
     * @type {GetAccountSummaryDataBankDetails}
     * @memberof GetAccountSummaryData
     */
    'bankDetails'?: GetAccountSummaryDataBankDetails;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof GetAccountSummaryData
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}


/**
 * The account\'s bank details
 * @export
 * @interface GetAccountSummaryDataBankDetails
 */
export interface GetAccountSummaryDataBankDetails {
    /**
     * 
     * @type {string}
     * @memberof GetAccountSummaryDataBankDetails
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetAccountSummaryDataBankDetails
     */
    'sortCode': string;
    /**
     * verification status of the bank details
     * @type {string}
     * @memberof GetAccountSummaryDataBankDetails
     */
    'verificationStatus'?: GetAccountSummaryDataBankDetailsVerificationStatusEnum;
    /**
     * 
     * @type {BankDetailsVerificationCreatedBy}
     * @memberof GetAccountSummaryDataBankDetails
     */
    'createdBy'?: BankDetailsVerificationCreatedBy;
    /**
     * date on which the bank details were created
     * @type {string}
     * @memberof GetAccountSummaryDataBankDetails
     */
    'createdOn'?: string;
    /**
     * 
     * @type {BankDetailsVerificationVerificationInfo}
     * @memberof GetAccountSummaryDataBankDetails
     */
    'verificationInfo'?: BankDetailsVerificationVerificationInfo;
}

/**
    * @export
    * @enum {string}
    */
export enum GetAccountSummaryDataBankDetailsVerificationStatusEnum {
    Active = 'Active',
    Pending = 'Pending',
    Bypassed = 'Bypassed'
}

/**
 * Contains details of any recurring order allocation on the account
 * @export
 * @interface GetAccountSummaryDataRecurringOrders
 */
export interface GetAccountSummaryDataRecurringOrders {
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataRecurringOrders
     */
    'movementType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataRecurringOrders
     */
    'investmentType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataRecurringOrders
     */
    'orderDay'?: string;
    /**
     * TBD
     * @type {Array<GetAccountSummaryDataRecurringOrdersDetailsInner>}
     * @memberof GetAccountSummaryDataRecurringOrders
     */
    'details'?: Array<GetAccountSummaryDataRecurringOrdersDetailsInner>;
}
/**
 * 
 * @export
 * @interface GetAccountSummaryDataRecurringOrdersDetailsInner
 */
export interface GetAccountSummaryDataRecurringOrdersDetailsInner {
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataRecurringOrdersDetailsInner
     */
    'assetId'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetAccountSummaryDataRecurringOrdersDetailsInner
     */
    'percentage'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataRecurringOrdersDetailsInner
     */
    'assetName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataRecurringOrdersDetailsInner
     */
    'currency'?: string;
}
/**
 * Contains details of the investment account
 * @export
 * @interface GetAccountSummaryDataWrapperDetail
 */
export interface GetAccountSummaryDataWrapperDetail {
    /**
     * 
     * @type {WrapperType}
     * @memberof GetAccountSummaryDataWrapperDetail
     */
    'wrapperType'?: WrapperType;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetAccountSummaryDataWrapperDetail
     */
    'discretionary'?: boolean;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetAccountSummaryDataWrapperDetail
     */
    'advised'?: boolean;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetAccountSummaryDataWrapperDetail
     */
    'trust'?: boolean;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataWrapperDetail
     */
    'assetAllocationId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataWrapperDetail
     */
    'assetAllocationName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataWrapperDetail
     */
    'clientProductId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryDataWrapperDetail
     */
    'providerId'?: string;
}


/**
 * 
 * @export
 * @interface GetAccountSummaryList
 */
export interface GetAccountSummaryList {
    /**
     * 
     * @type {Array<GetAccountSummaryListDataInner>}
     * @memberof GetAccountSummaryList
     */
    'data'?: Array<GetAccountSummaryListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetAccountSummaryList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetAccountSummaryListDataInner
 */
export interface GetAccountSummaryListDataInner {
    /**
     * The unique identifier of the investment account
     * @type {string}
     * @memberof GetAccountSummaryListDataInner
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetAccountSummaryListDataInner
     */
    'firmId': string;
    /**
     * The unique node identifier that the client record is attached to
     * @type {string}
     * @memberof GetAccountSummaryListDataInner
     */
    'nodeId': string;
    /**
     * The unique name of the node that the client should be attached to
     * @type {string}
     * @memberof GetAccountSummaryListDataInner
     */
    'nodeName'?: string;
    /**
     * The full name of the client, including title, first name and surname
     * @type {string}
     * @memberof GetAccountSummaryListDataInner
     */
    'name': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetAccountSummaryListDataInner
     */
    'currency'?: string;
    /**
     * The type of account
     * @type {string}
     * @memberof GetAccountSummaryListDataInner
     */
    'accountType': string;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetAccountSummaryListDataInner
     */
    'wrapperType': WrapperType;
    /**
     * 
     * @type {GetAccountSummaryListDataInnerWrapperDetail}
     * @memberof GetAccountSummaryListDataInner
     */
    'wrapperDetail'?: GetAccountSummaryListDataInnerWrapperDetail;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetAccountSummaryListDataInner
     */
    'recurringPayment'?: boolean;
    /**
     * 
     * @type {GetAccountSummaryListDataInnerRecurringOrders}
     * @memberof GetAccountSummaryListDataInner
     */
    'recurringOrders'?: GetAccountSummaryListDataInnerRecurringOrders;
    /**
     * The status of the account
     * @type {string}
     * @memberof GetAccountSummaryListDataInner
     */
    'status': string;
    /**
     * The names of the client account
     * @type {Array<string>}
     * @memberof GetAccountSummaryListDataInner
     */
    'clientNames': Array<string>;
    /**
     * The unique identifier of the client account
     * @type {Array<string>}
     * @memberof GetAccountSummaryListDataInner
     */
    'clients': Array<string>;
    /**
     * Contains a summary of the individual cash and asset positions within the portfolio
     * @type {Array<GetAccountSummaryListDataInnerPositionsInner>}
     * @memberof GetAccountSummaryListDataInner
     */
    'positions'?: Array<GetAccountSummaryListDataInnerPositionsInner>;
    /**
     * The current value of the account. If no date parameters are provided, this will show as of today\'s date
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'currentValue'?: number;
    /**
     * The opening value of the account. If no date parameters are provided, this will show as 0
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'openingValue'?: number;
    /**
     * TBD
     * @type {any}
     * @memberof GetAccountSummaryListDataInner
     */
    'openingStockValue'?: any;
    /**
     * TBD
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'openingCashValue'?: number;
    /**
     * The sum of the positions.bookValue in the positions array
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'bookValue'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'transferBookValue'?: number;
    /**
     * The sum of the positions.nonTransferBookValue in the positions array
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'nonTransferBookValue'?: number;
    /**
     * The growth since book costs
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'growth'?: number;
    /**
     * The growth since assets on platform
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'adjustedGrowth'?: number;
    /**
     * The amount of cash in the account
     * @type {any}
     * @memberof GetAccountSummaryListDataInner
     */
    'closingCashValue'?: any;
    /**
     * The amount of cash in the account
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'uninvestedCash'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'closingStockValue'?: number;
    /**
     * The growth since book costs as percentage
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'growthPercent'?: number;
    /**
     * The growth since assets on platform as percentage
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The sum of the transferValue within the positions array
     * @type {number}
     * @memberof GetAccountSummaryListDataInner
     */
    'transferValue'?: number;
}


/**
 * 
 * @export
 * @interface GetAccountSummaryListDataInnerPositionsInner
 */
export interface GetAccountSummaryListDataInnerPositionsInner {
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'id'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'accountId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'accountName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'accountType'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'amount'?: number;
    /**
     * 
     * @type {AccountAuditDetails}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'auditDetails'?: AccountAuditDetails;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'currency'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'firmId'?: string;
    /**
     * The unique identifier of the node that the client is attached to
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'nodeId'?: string;
    /**
     * 
     * @type {PositionType}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'positionType'?: PositionType;
    /**
     * The unique identifier of the update
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'updateId'?: string;
    /**
     * The current value of the account. If no date parameters are provided, this will show as today\'s date
     * @type {number}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'currentValue'?: number;
    /**
     * The growth since the book cost
     * @type {number}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'growth'?: number;
    /**
     * The growth since the book cost as percentage
     * @type {any}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'growthPercent'?: any;
    /**
     * The growth since assets on the platform
     * @type {number}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'adjustedGrowth'?: number;
    /**
     * The growth since assets on the platform as percentage
     * @type {number}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The opening value of the account. If no date parameters are provided, this will show as 0
     * @type {number}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'openingValue'?: number;
    /**
     * The percentage allocation of the holding within the investment account
     * @type {number}
     * @memberof GetAccountSummaryListDataInnerPositionsInner
     */
    'allocation'?: number;
}


/**
 * Contains details of any recurring order allocation on the account
 * @export
 * @interface GetAccountSummaryListDataInnerRecurringOrders
 */
export interface GetAccountSummaryListDataInnerRecurringOrders {
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerRecurringOrders
     */
    'movementType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerRecurringOrders
     */
    'investmentType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerRecurringOrders
     */
    'orderDay'?: string;
}
/**
 * Contains details of the investment account
 * @export
 * @interface GetAccountSummaryListDataInnerWrapperDetail
 */
export interface GetAccountSummaryListDataInnerWrapperDetail {
    /**
     * 
     * @type {WrapperType}
     * @memberof GetAccountSummaryListDataInnerWrapperDetail
     */
    'wrapperType'?: WrapperType;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetAccountSummaryListDataInnerWrapperDetail
     */
    'discretionary'?: boolean;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetAccountSummaryListDataInnerWrapperDetail
     */
    'advised'?: boolean;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetAccountSummaryListDataInnerWrapperDetail
     */
    'trust'?: boolean;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerWrapperDetail
     */
    'assetAllocationId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerWrapperDetail
     */
    'assetAllocationName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetAccountSummaryListDataInnerWrapperDetail
     */
    'clientProductId'?: string;
    /**
     * 
     * @type {ClientProductStatus}
     * @memberof GetAccountSummaryListDataInnerWrapperDetail
     */
    'productStatus'?: ClientProductStatus;
}


/**
 * 
 * @export
 * @interface GetAsset
 */
export interface GetAsset {
    /**
     * 
     * @type {Asset}
     * @memberof GetAsset
     */
    'data'?: Asset;
}
/**
 * 
 * @export
 * @interface GetAssetFromUniverse
 */
export interface GetAssetFromUniverse {
    /**
     * 
     * @type {MasterAsset}
     * @memberof GetAssetFromUniverse
     */
    'data'?: MasterAsset;
}
/**
 * 
 * @export
 * @interface GetAssetPrice
 */
export interface GetAssetPrice {
    /**
     * 
     * @type {Array<GetAssetPriceDataInner>}
     * @memberof GetAssetPrice
     */
    'data'?: Array<GetAssetPriceDataInner>;
}
/**
 * 
 * @export
 * @interface GetAssetPriceDataInner
 */
export interface GetAssetPriceDataInner {
    /**
     * The unique identifier of the price record
     * @type {string}
     * @memberof GetAssetPriceDataInner
     */
    'id'?: string;
    /**
     * The date the price was added to Seccl\'s system
     * @type {string}
     * @memberof GetAssetPriceDataInner
     */
    'insertDate'?: string;
    /**
     * The date of the price
     * @type {string}
     * @memberof GetAssetPriceDataInner
     */
    'priceDate'?: string;
    /**
     * The maximum price that a buyer is willing to pay for an asset
     * @type {number}
     * @memberof GetAssetPriceDataInner
     */
    'bid'?: number;
    /**
     * The minimum price that a seller is willing to pay for an asset
     * @type {number}
     * @memberof GetAssetPriceDataInner
     */
    'mid'?: number;
    /**
     * The midpoint between the bid and ask prices
     * @type {number}
     * @memberof GetAssetPriceDataInner
     */
    'ask'?: number;
    /**
     * The unique identifier of the asset
     * @type {string}
     * @memberof GetAssetPriceDataInner
     */
    'assetId'?: string;
    /**
     * This indicates the number of units for the quote or price. For example, if the asset is £10 and the quoteUnit is 1, then £10 is the quote for a single unit. If the asset is £100 and the quoteUnit is 100, then £100 is the quote for 100 units
     * @type {number}
     * @memberof GetAssetPriceDataInner
     */
    'quoteUnit'?: number;
    /**
     * The number of decimal places that the asset can be held. For example, 0.0001 means the asset can be held to 4 decimal places. This is asset specific and varies between a value of 0.0001 and 1
     * @type {number}
     * @memberof GetAssetPriceDataInner
     */
    'minimumTransferUnit'?: number;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetAssetPriceDataInner
     */
    'currency'?: string;
    /**
     * This details the exchange rate of the asset, where the currency is non-GBP
     * @type {Array<any>}
     * @memberof GetAssetPriceDataInner
     */
    'exchangeRates'?: Array<any>;
    /**
     * The type of instrument
     * @type {string}
     * @memberof GetAssetPriceDataInner
     */
    'instrumentType'?: string;
}
/**
 * 
 * @export
 * @interface GetAssetUniverse
 */
export interface GetAssetUniverse {
    /**
     * 
     * @type {Array<MasterAsset>}
     * @memberof GetAssetUniverse
     */
    'data'?: Array<MasterAsset>;
    /**
     * 
     * @type {GetAssetUniverseMeta}
     * @memberof GetAssetUniverse
     */
    'meta'?: GetAssetUniverseMeta;
}
/**
 * 
 * @export
 * @interface GetAssetUniverseMeta
 */
export interface GetAssetUniverseMeta {
    /**
     * TBD
     * @type {number}
     * @memberof GetAssetUniverseMeta
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface GetAssets
 */
export interface GetAssets {
    /**
     * 
     * @type {Array<Asset>}
     * @memberof GetAssets
     */
    'data'?: Array<Asset>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetAssets
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetCapitalGainsTaxReport
 */
export interface GetCapitalGainsTaxReport {
    /**
     * 
     * @type {PortfolioCapitalGainsTaxReport}
     * @memberof GetCapitalGainsTaxReport
     */
    'data'?: PortfolioCapitalGainsTaxReport;
}
/**
 * 
 * @export
 * @interface GetCapitalGainsTaxReportSpreadsheetLink
 */
export interface GetCapitalGainsTaxReportSpreadsheetLink {
    /**
     * 
     * @type {FilesFileTypePost200ResponseData}
     * @memberof GetCapitalGainsTaxReportSpreadsheetLink
     */
    'data'?: FilesFileTypePost200ResponseData;
}
/**
 * 
 * @export
 * @interface GetCedingProviders
 */
export interface GetCedingProviders {
    /**
     * 
     * @type {Array<CedingProvider>}
     * @memberof GetCedingProviders
     */
    'data'?: Array<CedingProvider>;
}
/**
 * 
 * @export
 * @interface GetClient
 */
export interface GetClient {
    /**
     * 
     * @type {PersistedClient}
     * @memberof GetClient
     */
    'data'?: PersistedClient;
}
/**
 * 
 * @export
 * @interface GetClientEmailMessageDetails
 */
export interface GetClientEmailMessageDetails {
    /**
     * 
     * @type {PostmarkMessageDetails}
     * @memberof GetClientEmailMessageDetails
     */
    'data'?: PostmarkMessageDetails;
}
/**
 * 
 * @export
 * @interface GetClientEmailMessages
 */
export interface GetClientEmailMessages {
    /**
     * 
     * @type {GetClientEmailMessagesData}
     * @memberof GetClientEmailMessages
     */
    'data'?: GetClientEmailMessagesData;
}
/**
 * 
 * @export
 * @interface GetClientEmailMessagesData
 */
export interface GetClientEmailMessagesData {
    /**
     * Total count of outbound messages
     * @type {number}
     * @memberof GetClientEmailMessagesData
     */
    'totalCount': number;
    /**
     * List of outbound messages
     * @type {Array<PostmarkMessage>}
     * @memberof GetClientEmailMessagesData
     */
    'messages': Array<PostmarkMessage>;
}
/**
 * 
 * @export
 * @interface GetClientList
 */
export interface GetClientList {
    /**
     * 
     * @type {Array<PersistedClient>}
     * @memberof GetClientList
     */
    'data'?: Array<PersistedClient>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetClientList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetClientNationalities
 */
export interface GetClientNationalities {
    /**
     * 
     * @type {GetClientNationalitiesData}
     * @memberof GetClientNationalities
     */
    'data'?: GetClientNationalitiesData;
}
/**
 * 
 * @export
 * @interface GetClientNationalitiesData
 */
export interface GetClientNationalitiesData {
    /**
     * 
     * @type {GetClientNationalitiesDataNationality}
     * @memberof GetClientNationalitiesData
     */
    'nationality'?: GetClientNationalitiesDataNationality;
    /**
     * 
     * @type {Pagination}
     * @memberof GetClientNationalitiesData
     */
    'meta'?: Pagination;
}
/**
 * Contains details of the relevant nationality
 * @export
 * @interface GetClientNationalitiesDataNationality
 */
export interface GetClientNationalitiesDataNationality {
    /**
     * The unique two-letter identifier for the nationality. This is case sensitive
     * @type {string}
     * @memberof GetClientNationalitiesDataNationality
     */
    'id'?: string;
    /**
     * A two-letter country code
     * @type {string}
     * @memberof GetClientNationalitiesDataNationality
     */
    'code'?: string;
    /**
     * The name of the country
     * @type {string}
     * @memberof GetClientNationalitiesDataNationality
     */
    'name'?: string;
    /**
     * The country descriptor
     * @type {string}
     * @memberof GetClientNationalitiesDataNationality
     */
    'adjective'?: string;
    /**
     * This confirms whether or not a country is in the European Economic Area (EEA). Although the UK is not in the EU anymore, it is still reported as inEEA true as per MiFIR/MiFID II rules
     * @type {boolean}
     * @memberof GetClientNationalitiesDataNationality
     */
    'inEEA'?: boolean;
    /**
     * An array which captures all forms of national identifiers for the chosen country
     * @type {Array<GetNationalitiesDataInnerIdentifiersInner>}
     * @memberof GetClientNationalitiesDataNationality
     */
    'identifiers'?: Array<GetNationalitiesDataInnerIdentifiersInner>;
}
/**
 * 
 * @export
 * @interface GetClientProduct
 */
export interface GetClientProduct {
    /**
     * 
     * @type {GetClientProductData}
     * @memberof GetClientProduct
     */
    'data'?: GetClientProductData;
}
/**
 * 
 * @export
 * @interface GetClientProductData
 */
export interface GetClientProductData {
    /**
     * The unique identifier of the client product
     * @type {string}
     * @memberof GetClientProductData
     */
    'id'?: string;
    /**
     * The unique identifier of your firm
     * @type {string}
     * @memberof GetClientProductData
     */
    'firmId'?: string;
    /**
     * The node Id that the client record is attached to
     * @type {string}
     * @memberof GetClientProductData
     */
    'nodeId'?: string;
    /**
     * Contains the associated client Ids
     * @type {Array<string>}
     * @memberof GetClientProductData
     */
    'clientIds'?: Array<string>;
    /**
     * 
     * @type {Array<GetClientProductDataBenefitCrystallisationEventsInner>}
     * @memberof GetClientProductData
     */
    'benefitCrystallisationEvents'?: Array<GetClientProductDataBenefitCrystallisationEventsInner>;
    /**
     * 
     * @type {Array<GetClientProductDataRelevantBenefitCrystallisationEventsInner>}
     * @memberof GetClientProductData
     */
    'relevantBenefitCrystallisationEvents'?: Array<GetClientProductDataRelevantBenefitCrystallisationEventsInner>;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetClientProductData
     */
    'wrapperType'?: WrapperType;
    /**
     * The scheme product Id of the product – this is relevant for pension products
     * @type {string}
     * @memberof GetClientProductData
     */
    'schemeProductId'?: string;
    /**
     * The date the client accepted the ISA terms
     * @type {string}
     * @memberof GetClientProductData
     */
    'declarationAcceptedDate'?: string;
    /**
     * The date the ISA declaration expires – if the client opens an ISA, accepts the declaration and doesn\'t contribute for an entire tax year, they will be required to re-accept the ISA declaration in order to contribute
     * @type {string}
     * @memberof GetClientProductData
     */
    'declarationExpiryDate'?: string;
    /**
     * Contains details of the client\'s nominated beneficiaries for their pension
     * @type {Array<GetClientProductDataExpressionOfWishNominationsInner>}
     * @memberof GetClientProductData
     */
    'expressionOfWishNominations'?: Array<GetClientProductDataExpressionOfWishNominationsInner>;
    /**
     * Name of the product
     * @type {string}
     * @memberof GetClientProductData
     */
    'productName'?: string;
    /**
     * 
     * @type {GetClientProductDataProductDetail}
     * @memberof GetClientProductData
     */
    'productDetail'?: GetClientProductDataProductDetail;
    /**
     * Contains details of external account Ids of the product provider
     * @type {Array<GetClientProductDataExternalIdsInner>}
     * @memberof GetClientProductData
     */
    'externalIds'?: Array<GetClientProductDataExternalIdsInner>;
    /**
     * Indicates that the client has accepted the pension terms
     * @type {boolean}
     * @memberof GetClientProductData
     */
    'acceptedProviderTerms'?: boolean;
    /**
     * The date the client accepted the pension terms
     * @type {string}
     * @memberof GetClientProductData
     */
    'acceptedProviderTermsDate'?: string;
    /**
     * 
     * @type {ClientProductStatus}
     * @memberof GetClientProductData
     */
    'productStatus'?: ClientProductStatus;
    /**
     * The unique identifier of the investment account that the client wishes to take income from – this is relevant for Gaudi pensions only
     * @type {string}
     * @memberof GetClientProductData
     */
    'incomeAccountId'?: string;
    /**
     * 
     * @type {UserAuditDetails}
     * @memberof GetClientProductData
     */
    'auditDetails'?: UserAuditDetails;
    /**
     * The unique identifier assigned to the record the last time it was updated
     * @type {string}
     * @memberof GetClientProductData
     */
    'updateId'?: string;
    /**
     * Contains details of updates made to the client record
     * @type {Array<GetClientProductDataUpdateHistoryInner>}
     * @memberof GetClientProductData
     */
    'updateHistory'?: Array<GetClientProductDataUpdateHistoryInner>;
}


/**
 * 
 * @export
 * @interface GetClientProductDataBenefitCrystallisationEventsInner
 */
export interface GetClientProductDataBenefitCrystallisationEventsInner {
    /**
     * The date of the BCE
     * @type {string}
     * @memberof GetClientProductDataBenefitCrystallisationEventsInner
     */
    'date': string;
    /**
     * The type of the BCE
     * @type {string}
     * @memberof GetClientProductDataBenefitCrystallisationEventsInner
     */
    'type': string;
    /**
     * The amount of the BCE
     * @type {number}
     * @memberof GetClientProductDataBenefitCrystallisationEventsInner
     */
    'amount': number;
    /**
     * The amount of the lifetime allowance used by the BCE
     * @type {number}
     * @memberof GetClientProductDataBenefitCrystallisationEventsInner
     */
    'lifetimeAllowanceUsed': number;
    /**
     * The account Id that the BCE is associated with
     * @type {string}
     * @memberof GetClientProductDataBenefitCrystallisationEventsInner
     */
    'accountId': string;
    /**
     * The account group Id that the BCE is associated with
     * @type {string}
     * @memberof GetClientProductDataBenefitCrystallisationEventsInner
     */
    'accountGroupId'?: string;
}
/**
 * 
 * @export
 * @interface GetClientProductDataExpressionOfWishNominationsInner
 */
export interface GetClientProductDataExpressionOfWishNominationsInner {
    /**
     * 
     * @type {BeneficiaryTitle}
     * @memberof GetClientProductDataExpressionOfWishNominationsInner
     */
    'title'?: BeneficiaryTitle;
    /**
     * TBD
     * @type {string}
     * @memberof GetClientProductDataExpressionOfWishNominationsInner
     */
    'surname'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetClientProductDataExpressionOfWishNominationsInner
     */
    'firstName'?: string;
    /**
     * 
     * @type {BeneficiaryRelationship}
     * @memberof GetClientProductDataExpressionOfWishNominationsInner
     */
    'beneficiaryRelationship'?: BeneficiaryRelationship;
    /**
     * TBD
     * @type {number}
     * @memberof GetClientProductDataExpressionOfWishNominationsInner
     */
    'beneficiaryProportion'?: number;
}


/**
 * 
 * @export
 * @interface GetClientProductDataExternalIdsInner
 */
export interface GetClientProductDataExternalIdsInner {
    /**
     * TBD
     * @type {string}
     * @memberof GetClientProductDataExternalIdsInner
     */
    'value'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetClientProductDataExternalIdsInner
     */
    'idType'?: string;
}
/**
 * Name of the product
 * @export
 * @interface GetClientProductDataProductDetail
 */
export interface GetClientProductDataProductDetail {
    /**
     * TBD
     * @type {boolean}
     * @memberof GetClientProductDataProductDetail
     */
    'flexibleBenefitsAccessed'?: boolean;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetClientProductDataProductDetail
     */
    'pensionOptOut'?: boolean;
    /**
     * TBD
     * @type {number}
     * @memberof GetClientProductDataProductDetail
     */
    'lifetimeAllowanceTransferredIn'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetClientProductDataProductDetail
     */
    'lifetimeAllowanceUsedElsewhere'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetClientProductDataProductDetail
     */
    'lifetimeAllowanceUsedPreADay'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetClientProductDataProductDetail
     */
    'flexiAccessDate'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetClientProductDataProductDetail
     */
    'lumpSumAllowanceUsedElsewhere'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetClientProductDataProductDetail
     */
    'lumpSumAllowanceUsedPreApril2024'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetClientProductDataProductDetail
     */
    'transitionalTaxFreeAmount'?: number;
}
/**
 * 
 * @export
 * @interface GetClientProductDataRelevantBenefitCrystallisationEventsInner
 */
export interface GetClientProductDataRelevantBenefitCrystallisationEventsInner {
    /**
     * The date of the RBCE
     * @type {string}
     * @memberof GetClientProductDataRelevantBenefitCrystallisationEventsInner
     */
    'date': string;
    /**
     * The type of the RBCE
     * @type {string}
     * @memberof GetClientProductDataRelevantBenefitCrystallisationEventsInner
     */
    'rbceType': string;
    /**
     * The amount of the RBCE
     * @type {number}
     * @memberof GetClientProductDataRelevantBenefitCrystallisationEventsInner
     */
    'amount': number;
    /**
     * The non-taxable amount of the RBCE
     * @type {number}
     * @memberof GetClientProductDataRelevantBenefitCrystallisationEventsInner
     */
    'nonTaxableAmount': number;
    /**
     * The account Id that the RBCE is associated with
     * @type {string}
     * @memberof GetClientProductDataRelevantBenefitCrystallisationEventsInner
     */
    'accountId': string;
    /**
     * The account group Id that the RBCE is associated with
     * @type {string}
     * @memberof GetClientProductDataRelevantBenefitCrystallisationEventsInner
     */
    'accountGroupId': string;
}
/**
 * 
 * @export
 * @interface GetClientProductDataUpdateHistoryInner
 */
export interface GetClientProductDataUpdateHistoryInner {
    /**
     * Id of the update
     * @type {number}
     * @memberof GetClientProductDataUpdateHistoryInner
     */
    'updateId'?: number;
    /**
     * Date upldate was applied
     * @type {string}
     * @memberof GetClientProductDataUpdateHistoryInner
     */
    'updateDate'?: string;
    /**
     * 
     * @type {BasePersistedClientUpdateHistoryInnerUpdateData}
     * @memberof GetClientProductDataUpdateHistoryInner
     */
    'updateData'?: BasePersistedClientUpdateHistoryInnerUpdateData;
    /**
     * array containing parentID and fieldID of updated field
     * @type {Array<string>}
     * @memberof GetClientProductDataUpdateHistoryInner
     */
    'updatedFields'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetClientProductList
 */
export interface GetClientProductList {
    /**
     * 
     * @type {Array<GetClientProductListDataInner>}
     * @memberof GetClientProductList
     */
    'data'?: Array<GetClientProductListDataInner>;
    /**
     * 
     * @type {GetAssetUniverseMeta}
     * @memberof GetClientProductList
     */
    'meta'?: GetAssetUniverseMeta;
}
/**
 * 
 * @export
 * @interface GetClientProductListDataInner
 */
export interface GetClientProductListDataInner {
    /**
     * The unique identifier of the client product
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'firmId': string;
    /**
     * The node Id that the client record is attached to
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'nodeId'?: string;
    /**
     * Contains the associated client Ids
     * @type {Array<string>}
     * @memberof GetClientProductListDataInner
     */
    'clientIds'?: Array<string>;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetClientProductListDataInner
     */
    'wrapperType'?: WrapperType;
    /**
     * The scheme product Id of the product – this is relevant for pension products
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'schemeProductId'?: string;
    /**
     * The date the client accepted the ISA terms
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'declarationAcceptedDate'?: string;
    /**
     * The date the ISA declaration expires – if the client opens an ISA, accepts the declaration and doesn\'t contribute for an entire tax year, they will be required to re-accept the ISA declaration in order to contribute
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'declarationExpiryDate'?: string;
    /**
     * Contains details of the client\'s nominated beneficiaries for their pension
     * @type {Array<GetClientProductDataExpressionOfWishNominationsInner>}
     * @memberof GetClientProductListDataInner
     */
    'expressionOfWishNominations'?: Array<GetClientProductDataExpressionOfWishNominationsInner>;
    /**
     * Name of the product
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'productName': string;
    /**
     * 
     * @type {CreateAccountProductDetail}
     * @memberof GetClientProductListDataInner
     */
    'productDetail'?: CreateAccountProductDetail;
    /**
     * Contains details of external account Ids of the product provider
     * @type {Array<GetClientProductDataExternalIdsInner>}
     * @memberof GetClientProductListDataInner
     */
    'externalIds'?: Array<GetClientProductDataExternalIdsInner>;
    /**
     * identifier of the provider
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'providerId'?: string;
    /**
     * Indicates that the client has accepted the pension terms
     * @type {boolean}
     * @memberof GetClientProductListDataInner
     */
    'acceptedProviderTerms'?: boolean;
    /**
     * The date the client accepted the pension terms
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'acceptedProviderTermsDate'?: string;
    /**
     * 
     * @type {ClientProductStatus}
     * @memberof GetClientProductListDataInner
     */
    'productStatus'?: ClientProductStatus;
    /**
     * The unique identifier of the investment account that the client wishes to take income from – this is relevant for Gaudi pensions only
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'incomeAccountId'?: string;
    /**
     * 
     * @type {UserAuditDetails}
     * @memberof GetClientProductListDataInner
     */
    'auditDetails'?: UserAuditDetails;
    /**
     * The unique identifier assigned to the record the last time it was updated
     * @type {string}
     * @memberof GetClientProductListDataInner
     */
    'updateId'?: string;
    /**
     * Contains details of updates made to the client record
     * @type {Array<GetClientProductDataUpdateHistoryInner>}
     * @memberof GetClientProductListDataInner
     */
    'updateHistory'?: Array<GetClientProductDataUpdateHistoryInner>;
}


/**
 * 
 * @export
 * @interface GetClientSearch
 */
export interface GetClientSearch {
    /**
     * 
     * @type {Array<PersistedClient>}
     * @memberof GetClientSearch
     */
    'data'?: Array<PersistedClient>;
    /**
     * 
     * @type {AtlasSearchMeta}
     * @memberof GetClientSearch
     */
    'meta'?: AtlasSearchMeta;
}
/**
 * 
 * @export
 * @interface GetCrystalliseGetData
 */
export interface GetCrystalliseGetData {
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetData
     */
    'firmId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetData
     */
    'accountId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCrystalliseGetData
     */
    'benefitsTakenBefore2006': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetData
     */
    'fcaIndividualReference': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCrystalliseGetData
     */
    'protectedRetirementAgeOrLumpSum': boolean;
    /**
     * 
     * @type {GetCrystalliseGetDataAccountDetails}
     * @memberof GetCrystalliseGetData
     */
    'accountDetails': GetCrystalliseGetDataAccountDetails;
    /**
     * 
     * @type {boolean}
     * @memberof GetCrystalliseGetData
     */
    'advised': boolean;
    /**
     * 
     * @type {GetCrystalliseGetDataCrystallisationDetails}
     * @memberof GetCrystalliseGetData
     */
    'crystallisationDetails': GetCrystalliseGetDataCrystallisationDetails;
    /**
     * 
     * @type {boolean}
     * @memberof GetCrystalliseGetData
     */
    'guidance': boolean;
    /**
     * 
     * @type {Array<GetCrystalliseGetDataWithdrawalDetails>}
     * @memberof GetCrystalliseGetData
     */
    'withdrawalDetails': Array<GetCrystalliseGetDataWithdrawalDetails>;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetData
     */
    'clientProductId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCrystalliseGetData
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetData
     */
    'status': GetCrystalliseGetDataStatusEnum;
    /**
     * 
     * @type {GetCrystalliseGetDataAuditDetails}
     * @memberof GetCrystalliseGetData
     */
    'auditDetails': GetCrystalliseGetDataAuditDetails;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetData
     */
    'updateId': string;
    /**
     * 
     * @type {Array<GetCrystalliseGetDataBenefitCrystallisationEvents>}
     * @memberof GetCrystalliseGetData
     */
    'benefitCrystallisationEvents'?: Array<GetCrystalliseGetDataBenefitCrystallisationEvents>;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetData
     */
    'processAction'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GetCrystalliseGetDataStatusEnum {
    Active = 'Active',
    Expired = 'Expired',
    Cancelled = 'Cancelled',
    Pending = 'Pending',
    Waiting = 'Waiting',
    Calculated = 'Calculated',
    Completed = 'Completed',
    Deleted = 'Deleted',
    Rejected = 'Rejected'
}

/**
 * 
 * @export
 * @interface GetCrystalliseGetDataAccountDetails
 */
export interface GetCrystalliseGetDataAccountDetails {
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataAccountDetails
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GetCrystalliseGetDataAuditDetails
 */
export interface GetCrystalliseGetDataAuditDetails {
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataAuditDetails
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataAuditDetails
     */
    'userFirmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataAuditDetails
     */
    'userId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataAuditDetails
     */
    'version'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataAuditDetails
     */
    'application'?: string;
}
/**
 * 
 * @export
 * @interface GetCrystalliseGetDataBenefitCrystallisationEvents
 */
export interface GetCrystalliseGetDataBenefitCrystallisationEvents {
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEvents
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEvents
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEvents
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEvents
     */
    'lifetimeAllowanceUsed': number;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEvents
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEvents
     */
    'accountGroupId': string;
    /**
     * 
     * @type {GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEvents
     */
    'relevantBenefitCrystallisationEvent'?: GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent;
}
/**
 * 
 * @export
 * @interface GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
 */
export interface GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent {
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'nonTaxableAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'accountGroupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'destinationAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'destinationAccountGroupId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'pensionCommencementExcessLumpSum'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'rbceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataBenefitCrystallisationEventsRelevantBenefitCrystallisationEvent
     */
    'protectionReliedOn'?: string;
}
/**
 * 
 * @export
 * @interface GetCrystalliseGetDataCrystallisationDetails
 */
export interface GetCrystalliseGetDataCrystallisationDetails {
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataCrystallisationDetails
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataCrystallisationDetails
     */
    'frequency'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCrystalliseGetDataCrystallisationDetails
     */
    'fullCrystallisation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataCrystallisationDetails
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface GetCrystalliseGetDataWithdrawalDetails
 */
export interface GetCrystalliseGetDataWithdrawalDetails {
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataWithdrawalDetails
     */
    'transactionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataWithdrawalDetails
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataWithdrawalDetails
     */
    'movementType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataWithdrawalDetails
     */
    'transactionSubType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCrystalliseGetDataWithdrawalDetails
     */
    'frequency'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataWithdrawalDetails
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetDataWithdrawalDetails
     */
    'grossAmount'?: number;
}
/**
 * 
 * @export
 * @interface GetCrystalliseGetMeta
 */
export interface GetCrystalliseGetMeta {
    /**
     * 
     * @type {number}
     * @memberof GetCrystalliseGetMeta
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface GetDashboardExceptions
 */
export interface GetDashboardExceptions {
    /**
     * 
     * @type {Array<GetDashboardExceptionsDataInner>}
     * @memberof GetDashboardExceptions
     */
    'data'?: Array<GetDashboardExceptionsDataInner>;
}
/**
 * 
 * @export
 * @interface GetDashboardExceptionsDataInner
 */
export interface GetDashboardExceptionsDataInner {
    /**
     * Enum type of information
     * @type {string}
     * @memberof GetDashboardExceptionsDataInner
     */
    'type': GetDashboardExceptionsDataInnerTypeEnum;
    /**
     * The number of the specified type
     * @type {number}
     * @memberof GetDashboardExceptionsDataInner
     */
    'total': number;
}

/**
    * @export
    * @enum {string}
    */
export enum GetDashboardExceptionsDataInnerTypeEnum {
    SuspiciousTransactions = 'Suspicious Transactions',
    UnpaidDeposits = 'Unpaid Deposits',
    UnexecutedOrders = 'Unexecuted Orders',
    AccountsFallen10 = 'Accounts Fallen 10%'
}

/**
 * 
 * @export
 * @interface GetDashboardInfo
 */
export interface GetDashboardInfo {
    /**
     * 
     * @type {Array<GetDashboardInfoDataInner>}
     * @memberof GetDashboardInfo
     */
    'data'?: Array<GetDashboardInfoDataInner>;
}
/**
 * 
 * @export
 * @interface GetDashboardInfoDataInner
 */
export interface GetDashboardInfoDataInner {
    /**
     * Enum type of information
     * @type {string}
     * @memberof GetDashboardInfoDataInner
     */
    'type': GetDashboardInfoDataInnerTypeEnum;
    /**
     * The number of the specified type
     * @type {number}
     * @memberof GetDashboardInfoDataInner
     */
    'total': number;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetDashboardInfoDataInner
     */
    'currency'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GetDashboardInfoDataInnerTypeEnum {
    NumberOfClients = 'Number Of Clients',
    NumberOfAccounts = 'Number Of Accounts',
    NumberOfInstruments = 'Number Of Instruments',
    TotalAssetsUnderAdministration = 'Total Assets Under Administration'
}

/**
 * 
 * @export
 * @interface GetDashboardTransfers
 */
export interface GetDashboardTransfers {
    /**
     * 
     * @type {GetDashboardTransfersData}
     * @memberof GetDashboardTransfers
     */
    'data'?: GetDashboardTransfersData;
}
/**
 * 
 * @export
 * @interface GetDashboardTransfersData
 */
export interface GetDashboardTransfersData {
    /**
     * Count of rejected transfers awaiting resubmission
     * @type {number}
     * @memberof GetDashboardTransfersData
     */
    'countTransfersWithResubmit'?: number;
    /**
     * Count of transfers awaiting client action
     * @type {number}
     * @memberof GetDashboardTransfersData
     */
    'countTransfersWithClientActionRequired'?: number;
    /**
     * Count fo transfers updated in the last seven days
     * @type {number}
     * @memberof GetDashboardTransfersData
     */
    'countTransfersLastUpdatedIn7Days'?: number;
}
/**
 * 
 * @export
 * @interface GetFirmBrandingList
 */
export interface GetFirmBrandingList {
    /**
     * List of users
     * @type {Array<FirmBrandingContent>}
     * @memberof GetFirmBrandingList
     */
    'data'?: Array<FirmBrandingContent>;
}
/**
 * 
 * @export
 * @interface GetFirmConfig
 */
export interface GetFirmConfig {
    /**
     * 
     * @type {boolean}
     * @memberof GetFirmConfig
     */
    'data'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof GetFirmConfig
     */
    'meta'?: object;
}
/**
 * 
 * @export
 * @interface GetFirmHostnameList
 */
export interface GetFirmHostnameList {
    /**
     * List of users
     * @type {Array<FirmHostname>}
     * @memberof GetFirmHostnameList
     */
    'data'?: Array<FirmHostname>;
}
/**
 * 
 * @export
 * @interface GetFirmSettings
 */
export interface GetFirmSettings {
    /**
     * 
     * @type {GetFirmSettingsData}
     * @memberof GetFirmSettings
     */
    'data'?: GetFirmSettingsData;
}
/**
 * 
 * @export
 * @interface GetFirmSettingsData
 */
export interface GetFirmSettingsData {
    /**
     * User id of the firm
     * @type {string}
     * @memberof GetFirmSettingsData
     */
    'id'?: string;
    /**
     * Firm id of the firm
     * @type {string}
     * @memberof GetFirmSettingsData
     */
    'firmId'?: string;
    /**
     * Status of the firm
     * @type {string}
     * @memberof GetFirmSettingsData
     */
    'status'?: string;
    /**
     * List of markets
     * @type {Array<string>}
     * @memberof GetFirmSettingsData
     */
    'markets'?: Array<string>;
    /**
     * List of products
     * @type {Array<string>}
     * @memberof GetFirmSettingsData
     */
    'products'?: Array<string>;
    /**
     * Indicates if digital custody is enabled
     * @type {boolean}
     * @memberof GetFirmSettingsData
     */
    'digitalCustody'?: boolean;
    /**
     * Firm id for digital custody
     * @type {string}
     * @memberof GetFirmSettingsData
     */
    'digitalCustodyFirm'?: string;
    /**
     * Indicates if AML is enabled
     * @type {boolean}
     * @memberof GetFirmSettingsData
     */
    'aml'?: boolean;
    /**
     * Indicates if bulk messages are enabled
     * @type {boolean}
     * @memberof GetFirmSettingsData
     */
    'bulkMessages'?: boolean;
    /**
     * Indicates if fractional trading is enabled
     * @type {boolean}
     * @memberof GetFirmSettingsData
     */
    'fractionalTrading'?: boolean;
}
/**
 * 
 * @export
 * @interface GetIllustrationById
 */
export interface GetIllustrationById {
    /**
     * 
     * @type {GetIllustrationByIdData}
     * @memberof GetIllustrationById
     */
    'data': GetIllustrationByIdData;
}
/**
 * 
 * @export
 * @interface GetIllustrationByIdData
 */
export interface GetIllustrationByIdData {
    /**
     * The unique identifier for the illustration
     * @type {string}
     * @memberof GetIllustrationByIdData
     */
    'id': string;
    /**
     * The unique identifier for the firm
     * @type {string}
     * @memberof GetIllustrationByIdData
     */
    'firmId': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdData
     */
    'assetAllocationName': string;
    /**
     * 
     * @type {GetIllustrationByIdDataAdviserInfo}
     * @memberof GetIllustrationByIdData
     */
    'adviserInfo'?: GetIllustrationByIdDataAdviserInfo;
    /**
     * 
     * @type {GetIllustrationsListDataInnerAuditDetails}
     * @memberof GetIllustrationByIdData
     */
    'auditDetails'?: GetIllustrationsListDataInnerAuditDetails;
    /**
     * 
     * @type {GetIllustrationByIdDataClientInfo}
     * @memberof GetIllustrationByIdData
     */
    'clientInfo': GetIllustrationByIdDataClientInfo;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdData
     */
    'currency': string;
    /**
     * 
     * @type {GetIllustrationByIdDataData}
     * @memberof GetIllustrationByIdData
     */
    'data': GetIllustrationByIdDataData;
    /**
     * 
     * @type {GetIllustrationsListDataInnerFirmCharges}
     * @memberof GetIllustrationByIdData
     */
    'firmCharges'?: GetIllustrationsListDataInnerFirmCharges;
    /**
     * 
     * @type {CreateProductIllustration}
     * @memberof GetIllustrationByIdData
     */
    'initialRequest': CreateProductIllustration;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdData
     */
    'investmentAmount'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdData
     */
    'nodeId'?: string;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetIllustrationByIdData
     */
    'productChargeTaxIndicator'?: boolean;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdData
     */
    'status'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdData
     */
    'updateId'?: string;
}
/**
 * 
 * @export
 * @interface GetIllustrationByIdDataAdviserInfo
 */
export interface GetIllustrationByIdDataAdviserInfo {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataAdviserInfo
     */
    'FCANumber'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataAdviserInfo
     */
    'adviserName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataAdviserInfo
     */
    'company'?: string;
}
/**
 * Client details object
 * @export
 * @interface GetIllustrationByIdDataClientInfo
 */
export interface GetIllustrationByIdDataClientInfo {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'clientType': string;
    /**
     * Client currency
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'currency': string;
    /**
     * client date of birth
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'dateOfBirth': string;
    /**
     * Client email
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'email': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'firstName': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'id': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'language': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'middleName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataClientInfo
     */
    'surname': string;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataData
 */
export interface GetIllustrationByIdDataData {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationByIdDataData
     */
    'annuityRate'?: number;
    /**
     * 
     * @type {GetIllustrationByIdDataDataClient}
     * @memberof GetIllustrationByIdDataData
     */
    'client'?: GetIllustrationByIdDataDataClient;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataFirmCharges}
     * @memberof GetIllustrationByIdDataData
     */
    'firmCharges'?: GetIllustrationsListDataInnerDataFirmCharges;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthPercentage}
     * @memberof GetIllustrationByIdDataData
     */
    'growthPercentage'?: GetIllustrationsListDataInnerDataGrowthPercentage;
    /**
     * 
     * @type {GetIllustrationByIdDataDataGrowthRates}
     * @memberof GetIllustrationByIdDataData
     */
    'growthRates'?: GetIllustrationByIdDataDataGrowthRates;
    /**
     * 
     * @type {GetIllustrationByIdDataDataInitialRequest}
     * @memberof GetIllustrationByIdDataData
     */
    'initialRequest'?: GetIllustrationByIdDataDataInitialRequest;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationByIdDataData
     */
    'period'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataData
     */
    'periodType'?: string;
    /**
     * 
     * @type {GetIllustrationByIdDataDataRequest}
     * @memberof GetIllustrationByIdDataData
     */
    'request'?: GetIllustrationByIdDataDataRequest;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataClient
 */
export interface GetIllustrationByIdDataDataClient {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'clientType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'dateOfBirth'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'email'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'firstName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'language'?: string;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'nodeId'?: Array<string>;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'surname'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataClient
     */
    'title'?: string;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataGrowthRates
 */
export interface GetIllustrationByIdDataDataGrowthRates {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExempt}
     * @memberof GetIllustrationByIdDataDataGrowthRates
     */
    'taxExempt'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExempt;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxable}
     * @memberof GetIllustrationByIdDataDataGrowthRates
     */
    'taxable'?: GetIllustrationsListDataInnerDataGrowthRatesTaxable;
    /**
     * 
     * @type {GetIllustrationByIdDataDataGrowthRatesInitialRequest}
     * @memberof GetIllustrationByIdDataDataGrowthRates
     */
    'initialRequest'?: GetIllustrationByIdDataDataGrowthRatesInitialRequest;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataGrowthRatesInitialRequest
 */
export interface GetIllustrationByIdDataDataGrowthRatesInitialRequest {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequest
     */
    'application'?: string;
    /**
     * 
     * @type {GetIllustrationByIdDataDataGrowthRatesInitialRequestData}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequest
     */
    'data'?: GetIllustrationByIdDataDataGrowthRatesInitialRequestData;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataGrowthRatesInitialRequestData
 */
export interface GetIllustrationByIdDataDataGrowthRatesInitialRequestData {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'calculating'?: string;
    /**
     * 
     * @type {GetIllustrationByIdDataDataGrowthRatesInitialRequestDataCharges}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'charges'?: GetIllustrationByIdDataDataGrowthRatesInitialRequestDataCharges;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'clientInfo'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'currency'?: string;
    /**
     * 
     * @type {GetIllustrationByIdDataDataGrowthRatesInitialRequestDataFees}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'fees'?: GetIllustrationByIdDataDataGrowthRatesInitialRequestDataFees;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'illustrationName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'nodeId'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'payments'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'periodType'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'periods'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'retirementAge'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'startDate'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestData
     */
    'wrapperType'?: WrapperType;
}


/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataGrowthRatesInitialRequestDataCharges
 */
export interface GetIllustrationByIdDataDataGrowthRatesInitialRequestDataCharges {
    /**
     * TBD
     * @type {boolean}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestDataCharges
     */
    'productCharge'?: boolean;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataGrowthRatesInitialRequestDataFees
 */
export interface GetIllustrationByIdDataDataGrowthRatesInitialRequestDataFees {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestDataFees
     */
    'adviserCharge'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestDataFees
     */
    'discretionaryManagementCharge'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFeesInitialAdviserCharge}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestDataFees
     */
    'initialAdviserCharge'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFeesInitialAdviserCharge;
    /**
     * indicates whether the otherPlatformHoldings should be included in adviser charge calculations
     * @type {boolean}
     * @memberof GetIllustrationByIdDataDataGrowthRatesInitialRequestDataFees
     */
    'applyAdviserChargeAcrossPortfolio'?: boolean;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataInitialRequest
 */
export interface GetIllustrationByIdDataDataInitialRequest {
    /**
     * 
     * @type {GetIllustrationByIdDataDataInitialRequestData}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'data'?: GetIllustrationByIdDataDataInitialRequestData;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'expiry'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataInitialRequestScopesInner>}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'scopes'?: Array<GetIllustrationsListDataInnerDataInitialRequestScopesInner>;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'services'?: Array<string>;
    /**
     * TBD
     * @type {Array<GetIllustrationByIdDataDataInitialRequestUserFirmsInner>}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'userFirms'?: Array<GetIllustrationByIdDataDataInitialRequestUserFirmsInner>;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'userId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'userName'?: string;
    /**
     * 
     * @type {UserMachineType}
     * @memberof GetIllustrationByIdDataDataInitialRequest
     */
    'userType'?: UserMachineType;
}


/**
 * 
 * @export
 * @interface GetIllustrationByIdDataDataInitialRequestData
 */
export interface GetIllustrationByIdDataDataInitialRequestData {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataInitialRequestDataDrawdown}
     * @memberof GetIllustrationByIdDataDataInitialRequestData
     */
    'drawdown'?: GetIllustrationsListDataInnerDataInitialRequestDataDrawdown;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataInitialRequestData
     */
    'wrapperStatus'?: GetIllustrationByIdDataDataInitialRequestDataWrapperStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GetIllustrationByIdDataDataInitialRequestDataWrapperStatusEnum {
    Accumulation = 'ACCUMULATION',
    Drawdown = 'DRAWDOWN'
}

/**
 * 
 * @export
 * @interface GetIllustrationByIdDataDataInitialRequestUserFirmsInner
 */
export interface GetIllustrationByIdDataDataInitialRequestUserFirmsInner {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataInitialRequestUserFirmsInner
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataInitialRequestUserFirmsInner
     */
    'firmType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataInitialRequestUserFirmsInner
     */
    'name'?: string;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationByIdDataDataInitialRequestUserFirmsInner
     */
    'nodeIds'?: Array<string>;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetIllustrationByIdDataDataInitialRequestUserFirmsInner
     */
    'trades'?: boolean;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataRequest
 */
export interface GetIllustrationByIdDataDataRequest {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataRequest
     */
    'application'?: string;
    /**
     * 
     * @type {GetIllustrationByIdDataDataRequestData}
     * @memberof GetIllustrationByIdDataDataRequest
     */
    'data'?: GetIllustrationByIdDataDataRequestData;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataRequestData
 */
export interface GetIllustrationByIdDataDataRequestData {
    /**
     * 
     * @type {GetIllustrationByIdDataDataRequestDataSessionData}
     * @memberof GetIllustrationByIdDataDataRequestData
     */
    'sessionData'?: GetIllustrationByIdDataDataRequestDataSessionData;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationByIdDataDataRequestData
     */
    'services'?: Array<string>;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataRequestData
     */
    'userFirms'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataRequestData
     */
    'userId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataRequestData
     */
    'userName'?: string;
    /**
     * 
     * @type {UserMachineType}
     * @memberof GetIllustrationByIdDataDataRequestData
     */
    'userType'?: UserMachineType;
}


/**
 * TBD
 * @export
 * @interface GetIllustrationByIdDataDataRequestDataSessionData
 */
export interface GetIllustrationByIdDataDataRequestDataSessionData {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataRequestDataSessionData
     */
    'expiry'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationByIdDataDataRequestDataSessionData
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataInitialRequestScopesInner>}
     * @memberof GetIllustrationByIdDataDataRequestDataSessionData
     */
    'scopes'?: Array<GetIllustrationsListDataInnerDataInitialRequestScopesInner>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsList
 */
export interface GetIllustrationsList {
    /**
     * 
     * @type {Array<GetIllustrationsListDataInner>}
     * @memberof GetIllustrationsList
     */
    'data'?: Array<GetIllustrationsListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetIllustrationsList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInner
 */
export interface GetIllustrationsListDataInner {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetIllustrationsListDataInner
     */
    'firmId': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInner
     */
    'assetAllocationName': string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerAuditDetails}
     * @memberof GetIllustrationsListDataInner
     */
    'auditDetails'?: GetIllustrationsListDataInnerAuditDetails;
    /**
     * 
     * @type {GetIllustrationsListDataInnerClientInfo}
     * @memberof GetIllustrationsListDataInner
     */
    'clientInfo': GetIllustrationsListDataInnerClientInfo;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetIllustrationsListDataInner
     */
    'currency': string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerData}
     * @memberof GetIllustrationsListDataInner
     */
    'data': GetIllustrationsListDataInnerData;
    /**
     * 
     * @type {GetIllustrationsListDataInnerFirmCharges}
     * @memberof GetIllustrationsListDataInner
     */
    'firmCharges'?: GetIllustrationsListDataInnerFirmCharges;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInner
     */
    'id': string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerInitialRequest}
     * @memberof GetIllustrationsListDataInner
     */
    'initialRequest': GetIllustrationsListDataInnerInitialRequest;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInner
     */
    'investmentAmount'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInner
     */
    'nodeId'?: string;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetIllustrationsListDataInner
     */
    'productChargeTaxIndicator'?: boolean;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInner
     */
    'status'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInner
     */
    'updateId'?: string;
}
/**
 * object containing audit trail details
 * @export
 * @interface GetIllustrationsListDataInnerAuditDetails
 */
export interface GetIllustrationsListDataInnerAuditDetails {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof GetIllustrationsListDataInnerAuditDetails
     */
    'updateDate'?: string;
    /**
     * Firm Id of user that implemented update
     * @type {string}
     * @memberof GetIllustrationsListDataInnerAuditDetails
     */
    'userFirmId': string;
    /**
     * Id of user that implemented update
     * @type {string}
     * @memberof GetIllustrationsListDataInnerAuditDetails
     */
    'userId': string;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerAuditDetails
     */
    'version': number;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerAuditDetails
     */
    'application': string;
}
/**
 * Client details object
 * @export
 * @interface GetIllustrationsListDataInnerClientInfo
 */
export interface GetIllustrationsListDataInnerClientInfo {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'clientType': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'currency': string;
    /**
     * client date of birth
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'dateOfBirth': string;
    /**
     * Client email
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'email': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'firstName': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'id': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'language': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'middleName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerClientInfo
     */
    'surname': string;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerData
 */
export interface GetIllustrationsListDataInnerData {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerData
     */
    'annuityRate'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataClient}
     * @memberof GetIllustrationsListDataInnerData
     */
    'client'?: GetIllustrationsListDataInnerDataClient;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataFirmCharges}
     * @memberof GetIllustrationsListDataInnerData
     */
    'firmCharges'?: GetIllustrationsListDataInnerDataFirmCharges;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthPercentage}
     * @memberof GetIllustrationsListDataInnerData
     */
    'growthPercentage'?: GetIllustrationsListDataInnerDataGrowthPercentage;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRates}
     * @memberof GetIllustrationsListDataInnerData
     */
    'growthRates'?: GetIllustrationsListDataInnerDataGrowthRates;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataInitialRequest}
     * @memberof GetIllustrationsListDataInnerData
     */
    'initialRequest'?: GetIllustrationsListDataInnerDataInitialRequest;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerData
     */
    'period'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerData
     */
    'periodType'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataRequest}
     * @memberof GetIllustrationsListDataInnerData
     */
    'request'?: GetIllustrationsListDataInnerDataRequest;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataClient
 */
export interface GetIllustrationsListDataInnerDataClient {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'clientType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'dateOfBirth'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'email'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'firstName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'language'?: string;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'nodeId'?: Array<string>;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'surname'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataClient
     */
    'title'?: string;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataFirmCharges
 */
export interface GetIllustrationsListDataInnerDataFirmCharges {
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInner>}
     * @memberof GetIllustrationsListDataInnerDataFirmCharges
     */
    'platformCharge'?: Array<GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInner>;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataFirmChargesProductChargeInner>}
     * @memberof GetIllustrationsListDataInnerDataFirmCharges
     */
    'productCharge'?: Array<GetIllustrationsListDataInnerDataFirmChargesProductChargeInner>;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner>}
     * @memberof GetIllustrationsListDataInnerDataFirmCharges
     */
    'tradingCharge'?: Array<GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInner
 */
export interface GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInner {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInner
     */
    'minimumAmount'?: number;
    /**
     * 
     * @type {Array<GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner>}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInner
     */
    'tiers'?: Array<GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner
 */
export interface GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner
     */
    'fromAmount'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner
     */
    'rate'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner
     */
    'toAmount'?: number;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataFirmChargesProductChargeInner
 */
export interface GetIllustrationsListDataInnerDataFirmChargesProductChargeInner {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesProductChargeInner
     */
    'maximumAmount'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesProductChargeInner
     */
    'minimumAmount'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataFirmChargesProductChargeInnerTaxIndicators}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesProductChargeInner
     */
    'taxIndicators'?: GetIllustrationsListDataInnerDataFirmChargesProductChargeInnerTaxIndicators;
    /**
     * 
     * @type {Array<GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner>}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesProductChargeInner
     */
    'tiers'?: Array<GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner>;
    /**
     * 
     * @type {Array<WrapperType>}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesProductChargeInner
     */
    'wrapperType'?: Array<WrapperType>;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataFirmChargesProductChargeInnerTaxIndicators
 */
export interface GetIllustrationsListDataInnerDataFirmChargesProductChargeInnerTaxIndicators {
    /**
     * TBD
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesProductChargeInnerTaxIndicators
     */
    'VAT'?: boolean;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner
 */
export interface GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner {
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner
     */
    'instrumentTypes'?: Array<string>;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner
     */
    'maximumAmount'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner
     */
    'minimumAmount'?: number;
    /**
     * 
     * @type {Array<GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner>}
     * @memberof GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner
     */
    'tiers'?: Array<GetIllustrationsListDataInnerDataFirmChargesPlatformChargeInnerTiersInner>;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthPercentage
 */
export interface GetIllustrationsListDataInnerDataGrowthPercentage {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthPercentage
     */
    'high'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthPercentage
     */
    'low'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthPercentage
     */
    'medium'?: number;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRates
 */
export interface GetIllustrationsListDataInnerDataGrowthRates {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExempt}
     * @memberof GetIllustrationsListDataInnerDataGrowthRates
     */
    'taxExempt'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExempt;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxable}
     * @memberof GetIllustrationsListDataInnerDataGrowthRates
     */
    'taxable'?: GetIllustrationsListDataInnerDataGrowthRatesTaxable;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequest}
     * @memberof GetIllustrationsListDataInnerDataGrowthRates
     */
    'initialRequest'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequest;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequest
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequest {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequest
     */
    'application'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequest
     */
    'data'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'calculating'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'charges'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'clientInfo'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'currency'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFees}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'fees'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFees;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'illustrationName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'nodeId'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'payments'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'periodType'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'periods'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'retirementAge'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'startDate'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestData
     */
    'wrapperType'?: WrapperType;
}


/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges {
    /**
     * 
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges
     */
    'productCharge'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges
     */
    'platformCharge'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges
     */
    'tradingCharge'?: boolean;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo
     */
    'clientType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo
     */
    'dateOfBirth'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo
     */
    'email'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo
     */
    'firstName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo
     */
    'language'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo
     */
    'surname'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataClientInfo
     */
    'title'?: string;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFees
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFees {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFees
     */
    'adviserCharge'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFees
     */
    'discretionaryManagementCharge'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFeesInitialAdviserCharge}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFees
     */
    'initialAdviserCharge'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFeesInitialAdviserCharge;
    /**
     * indicates whether the otherPlatformHoldings should be included in adviser charge calculations
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFees
     */
    'applyAdviserChargeAcrossPortfolio'?: boolean;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFeesInitialAdviserCharge
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFeesInitialAdviserCharge {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataFeesInitialAdviserCharge
     */
    'percent'?: number;
}
/**
 * details of payments
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments {
    /**
     * amount of inital payment
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments
     */
    'initialPayment'?: number;
    /**
     * details of regular payments
     * @type {Array<GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner>}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments
     */
    'regularPayments'?: Array<GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner>;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsSinglePaymentsInner>}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPayments
     */
    'singlePayments'?: Array<GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsSinglePaymentsInner>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner {
    /**
     * 
     * @type {ContributionType}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner
     */
    'contributor'?: ContributionType;
    /**
     * frequency
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner
     */
    'frequency'?: string;
    /**
     * date started
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner
     */
    'fromDate'?: string;
    /**
     * Type of movement
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner
     */
    'movementType'?: string;
    /**
     * Payment amount
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner
     */
    'paymentAmount'?: number;
    /**
     * Growth percentage
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner
     */
    'percentageGrowth'?: number;
    /**
     * date
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsRegularPaymentsInner
     */
    'toDate'?: string;
}


/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsSinglePaymentsInner
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsSinglePaymentsInner {
    /**
     * 
     * @type {ContributionType}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsSinglePaymentsInner
     */
    'contributor'?: ContributionType;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsSinglePaymentsInner
     */
    'movementType'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsSinglePaymentsInner
     */
    'paymentAmount'?: number;
    /**
     * tbd TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataPaymentsSinglePaymentsInner
     */
    'percentageGrowth'?: number;
}


/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesTaxExempt
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesTaxExempt {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExempt
     */
    'afterInflation'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExempt
     */
    'beforeInflation'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation
     */
    'cash'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation
     */
    'corporateBonds'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation
     */
    'equity'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation
     */
    'gilts'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation
     */
    'other'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash
     */
    'high'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash
     */
    'low'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash
     */
    'medium'?: number;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds
     */
    'high'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds
     */
    'low'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds
     */
    'medium'?: number;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity
     */
    'high'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity
     */
    'low'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity
     */
    'medium'?: number;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesTaxable
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesTaxable {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxable
     */
    'afterInflation'?: GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxable
     */
    'beforeInflation'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflation;
}
/**
 * tbd
 * @export
 * @interface GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation
 */
export interface GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation
     */
    'cash'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation
     */
    'corporateBonds'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation
     */
    'equity'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationEquity;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation
     */
    'gilts'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCash;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds}
     * @memberof GetIllustrationsListDataInnerDataGrowthRatesTaxableAfterInflation
     */
    'other'?: GetIllustrationsListDataInnerDataGrowthRatesTaxExemptAfterInflationCorporateBonds;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataInitialRequest
 */
export interface GetIllustrationsListDataInnerDataInitialRequest {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataInitialRequestData}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'data'?: GetIllustrationsListDataInnerDataInitialRequestData;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'expiry'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataInitialRequestScopesInner>}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'scopes'?: Array<GetIllustrationsListDataInnerDataInitialRequestScopesInner>;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'services'?: Array<string>;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner>}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'userFirms'?: Array<GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner>;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'userId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'userName'?: string;
    /**
     * 
     * @type {UserMachineType}
     * @memberof GetIllustrationsListDataInnerDataInitialRequest
     */
    'userType'?: UserMachineType;
}


/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataInitialRequestData
 */
export interface GetIllustrationsListDataInnerDataInitialRequestData {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataInitialRequestDataDrawdown}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestData
     */
    'drawdown'?: GetIllustrationsListDataInnerDataInitialRequestDataDrawdown;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestData
     */
    'wrapperStatus'?: GetIllustrationsListDataInnerDataInitialRequestDataWrapperStatusEnum;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestData
     */
    'wrapperType'?: WrapperType;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestData
     */
    'illustrationName'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GetIllustrationsListDataInnerDataInitialRequestDataWrapperStatusEnum {
    Accumulation = 'ACCUMULATION',
    Drawdown = 'DRAWDOWN'
}

/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataInitialRequestDataDrawdown
 */
export interface GetIllustrationsListDataInnerDataInitialRequestDataDrawdown {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestDataDrawdown
     */
    'drawdownMethod'?: GetIllustrationsListDataInnerDataInitialRequestDataDrawdownDrawdownMethodEnum;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestDataDrawdown
     */
    'fundsNotInDrawdown'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum GetIllustrationsListDataInnerDataInitialRequestDataDrawdownDrawdownMethodEnum {
    Fad = 'FAD',
    Ufpls = 'UFPLS'
}

/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataInitialRequestScopesInner
 */
export interface GetIllustrationsListDataInnerDataInitialRequestScopesInner {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestScopesInner
     */
    'scope'?: string;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestScopesInner
     */
    'ranges'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner
 */
export interface GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner
     */
    'firmType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner
     */
    'name'?: string;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner
     */
    'nodeIds'?: Array<string>;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerDataInitialRequestUserFirmsInner
     */
    'trades'?: boolean;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataRequest
 */
export interface GetIllustrationsListDataInnerDataRequest {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataRequest
     */
    'application'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataRequestData}
     * @memberof GetIllustrationsListDataInnerDataRequest
     */
    'data'?: GetIllustrationsListDataInnerDataRequestData;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataRequestData
 */
export interface GetIllustrationsListDataInnerDataRequestData {
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataRequestDataSessionData}
     * @memberof GetIllustrationsListDataInnerDataRequestData
     */
    'sessionData'?: GetIllustrationsListDataInnerDataRequestDataSessionData;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof GetIllustrationsListDataInnerDataRequestData
     */
    'services'?: Array<string>;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataRequestData
     */
    'userFirms'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataRequestData
     */
    'userId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataRequestData
     */
    'userName'?: string;
    /**
     * 
     * @type {UserMachineType}
     * @memberof GetIllustrationsListDataInnerDataRequestData
     */
    'userType'?: UserMachineType;
}


/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerDataRequestDataSessionData
 */
export interface GetIllustrationsListDataInnerDataRequestDataSessionData {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataRequestDataSessionData
     */
    'expiry'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetIllustrationsListDataInnerDataRequestDataSessionData
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerDataInitialRequestScopesInner>}
     * @memberof GetIllustrationsListDataInnerDataRequestDataSessionData
     */
    'scopes'?: Array<GetIllustrationsListDataInnerDataInitialRequestScopesInner>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerFirmCharges
 */
export interface GetIllustrationsListDataInnerFirmCharges {
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerFirmChargesPlatformChargeInner>}
     * @memberof GetIllustrationsListDataInnerFirmCharges
     */
    'platformCharge': Array<GetIllustrationsListDataInnerFirmChargesPlatformChargeInner>;
    /**
     * details of the product charge
     * @type {Array<GetIllustrationsListDataInnerFirmChargesProductChargeInner>}
     * @memberof GetIllustrationsListDataInnerFirmCharges
     */
    'productCharge': Array<GetIllustrationsListDataInnerFirmChargesProductChargeInner>;
    /**
     * Details of trading charges
     * @type {Array<GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner>}
     * @memberof GetIllustrationsListDataInnerFirmCharges
     */
    'tradingCharge': Array<GetIllustrationsListDataInnerDataFirmChargesTradingChargeInner>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerFirmChargesPlatformChargeInner
 */
export interface GetIllustrationsListDataInnerFirmChargesPlatformChargeInner {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerFirmChargesPlatformChargeInner
     */
    'minimumAmount'?: number;
    /**
     * 
     * @type {Array<GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner>}
     * @memberof GetIllustrationsListDataInnerFirmChargesPlatformChargeInner
     */
    'tiers'?: Array<GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner
 */
export interface GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner {
    /**
     * Starting amount for tier
     * @type {number}
     * @memberof GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner
     */
    'fromAmount'?: number;
    /**
     * Rate for tier
     * @type {number}
     * @memberof GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner
     */
    'rate'?: number;
    /**
     * Top amount for tier
     * @type {number}
     * @memberof GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner
     */
    'toAmount'?: number;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerFirmChargesProductChargeInner
 */
export interface GetIllustrationsListDataInnerFirmChargesProductChargeInner {
    /**
     * maximum amount for product charge
     * @type {number}
     * @memberof GetIllustrationsListDataInnerFirmChargesProductChargeInner
     */
    'maximumAmount'?: number;
    /**
     * minimum amount for product charge
     * @type {number}
     * @memberof GetIllustrationsListDataInnerFirmChargesProductChargeInner
     */
    'minimumAmount'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerFirmChargesProductChargeInnerTaxIndicators}
     * @memberof GetIllustrationsListDataInnerFirmChargesProductChargeInner
     */
    'taxIndicators'?: GetIllustrationsListDataInnerFirmChargesProductChargeInnerTaxIndicators;
    /**
     * 
     * @type {Array<GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner>}
     * @memberof GetIllustrationsListDataInnerFirmChargesProductChargeInner
     */
    'tiers'?: Array<GetIllustrationsListDataInnerFirmChargesPlatformChargeInnerTiersInner>;
    /**
     * 
     * @type {Array<WrapperType>}
     * @memberof GetIllustrationsListDataInnerFirmChargesProductChargeInner
     */
    'wrapperType'?: Array<WrapperType>;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerFirmChargesProductChargeInner
     */
    'wrapperStatus'?: GetIllustrationsListDataInnerFirmChargesProductChargeInnerWrapperStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GetIllustrationsListDataInnerFirmChargesProductChargeInnerWrapperStatusEnum {
    Accumulation = 'ACCUMULATION',
    Drawdown = 'DRAWDOWN'
}

/**
 * details of tax indicators
 * @export
 * @interface GetIllustrationsListDataInnerFirmChargesProductChargeInnerTaxIndicators
 */
export interface GetIllustrationsListDataInnerFirmChargesProductChargeInnerTaxIndicators {
    /**
     * is vatable
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerFirmChargesProductChargeInnerTaxIndicators
     */
    'VAT'?: boolean;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequest
 */
export interface GetIllustrationsListDataInnerInitialRequest {
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'calculating'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'charges'?: GetIllustrationsListDataInnerDataGrowthRatesInitialRequestDataCharges;
    /**
     * 
     * @type {GetIllustrationsListDataInnerInitialRequestAdviserInfo}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'adviserInfo'?: GetIllustrationsListDataInnerInitialRequestAdviserInfo;
    /**
     * 
     * @type {GetIllustrationsListDataInnerInitialRequestClientInfo}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'clientInfo'?: GetIllustrationsListDataInnerInitialRequestClientInfo;
    /**
     * 
     * @type {Array<GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner>}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'additionalClientsInfo'?: Array<GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner>;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {GetIllustrationsListDataInnerDataInitialRequestDataDrawdown}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'drawdown'?: GetIllustrationsListDataInnerDataInitialRequestDataDrawdown;
    /**
     * 
     * @type {GetIllustrationsListDataInnerInitialRequestFees}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'fees'?: GetIllustrationsListDataInnerInitialRequestFees;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'firmId'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'firstPeriodSinglePayments'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'illustrationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'modelId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'nodeId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'otherPlatformHoldings'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerInitialRequestPayments}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'payments'?: GetIllustrationsListDataInnerInitialRequestPayments;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'periodType'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'periods'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'retirementAge'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'schemeProductId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {Array<GetIllustrationsListDataInnerInitialRequestTransactionsInner>}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'transactions'?: Array<GetIllustrationsListDataInnerInitialRequestTransactionsInner>;
    /**
     * 
     * @type {CreateProductIllustrationWithdrawals}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'withdrawals'?: CreateProductIllustrationWithdrawals;
    /**
     * 
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'planLengthYears'?: number;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'wrapperType'?: WrapperType;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'wrapperStatus'?: GetIllustrationsListDataInnerInitialRequestWrapperStatusEnum;
    /**
     * Platform fee structure ID used when creating the illustration
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequest
     */
    'platformFeeStructureId'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GetIllustrationsListDataInnerInitialRequestWrapperStatusEnum {
    Accumulation = 'ACCUMULATION',
    Drawdown = 'DRAWDOWN'
}

/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
 */
export interface GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'clientType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'dateOfBirth'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'email'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'middleName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'language'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'surname'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdditionalClientsInfoInner
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequestAdviserInfo
 */
export interface GetIllustrationsListDataInnerInitialRequestAdviserInfo {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdviserInfo
     */
    'FCANumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdviserInfo
     */
    'adviserName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestAdviserInfo
     */
    'company'?: string;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequestClientInfo
 */
export interface GetIllustrationsListDataInnerInitialRequestClientInfo {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestClientInfo
     */
    'clientType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestClientInfo
     */
    'dateOfBirth'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestClientInfo
     */
    'email'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestClientInfo
     */
    'firstName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestClientInfo
     */
    'language'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestClientInfo
     */
    'surname'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestClientInfo
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequestFees
 */
export interface GetIllustrationsListDataInnerInitialRequestFees {
    /**
     * 
     * @type {CreateProductIllustrationFeesAdviserTieredCharges}
     * @memberof GetIllustrationsListDataInnerInitialRequestFees
     */
    'adviserTieredCharges'?: CreateProductIllustrationFeesAdviserTieredCharges;
    /**
     * 
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestFees
     */
    'adviserCharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestFees
     */
    'discretionaryManagementCharge'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerInitialRequestFees
     */
    'enableTieredCharging'?: boolean;
    /**
     * 
     * @type {CreateProductIllustrationFeesInitialAdviserCharge}
     * @memberof GetIllustrationsListDataInnerInitialRequestFees
     */
    'initialAdviserCharge'?: CreateProductIllustrationFeesInitialAdviserCharge;
    /**
     * 
     * @type {CreateProductIllustrationFeesInitialAdviserCharge}
     * @memberof GetIllustrationsListDataInnerInitialRequestFees
     */
    'initialDiscretionaryManagementCharge'?: CreateProductIllustrationFeesInitialAdviserCharge;
    /**
     * 
     * @type {boolean}
     * @memberof GetIllustrationsListDataInnerInitialRequestFees
     */
    'applyAdviserChargeAcrossPortfolio'?: boolean;
    /**
     * Adviser fee structure ID used when creating the illustration
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestFees
     */
    'adviserFeeStructureId'?: string;
}
/**
 * TBD
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequestPayments
 */
export interface GetIllustrationsListDataInnerInitialRequestPayments {
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestPayments
     */
    'initialPayment'?: number;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner>}
     * @memberof GetIllustrationsListDataInnerInitialRequestPayments
     */
    'regularPayments'?: Array<GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner>;
    /**
     * TBD
     * @type {Array<GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner>}
     * @memberof GetIllustrationsListDataInnerInitialRequestPayments
     */
    'singlePayments'?: Array<GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner>;
}
/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner
 */
export interface GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner {
    /**
     * 
     * @type {ContributionType}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner
     */
    'contributor'?: ContributionType;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner
     */
    'frequency'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner
     */
    'fromDate'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner
     */
    'movementType'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner
     */
    'paymentAmount'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner
     */
    'percentageGrowth'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsRegularPaymentsInner
     */
    'toDate'?: string;
}


/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner
 */
export interface GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner {
    /**
     * 
     * @type {ContributionType}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner
     */
    'contributor'?: ContributionType;
    /**
     * TBD
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner
     */
    'movementType'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner
     */
    'paymentAmount'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner
     */
    'percentageGrowth'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestPaymentsSinglePaymentsInner
     */
    'paymentDate'?: string;
}


/**
 * 
 * @export
 * @interface GetIllustrationsListDataInnerInitialRequestTransactionsInner
 */
export interface GetIllustrationsListDataInnerInitialRequestTransactionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestTransactionsInner
     */
    'assetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetIllustrationsListDataInnerInitialRequestTransactionsInner
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestTransactionsInner
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetIllustrationsListDataInnerInitialRequestTransactionsInner
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface GetLiveAccountSummary
 */
export interface GetLiveAccountSummary {
    /**
     * 
     * @type {LiveAccountSummaryData}
     * @memberof GetLiveAccountSummary
     */
    'data'?: LiveAccountSummaryData;
}
/**
 * 
 * @export
 * @interface GetMessage
 */
export interface GetMessage {
    /**
     * 
     * @type {ClientMessage}
     * @memberof GetMessage
     */
    'data'?: ClientMessage;
}
/**
 * 
 * @export
 * @interface GetMessages
 */
export interface GetMessages {
    /**
     * 
     * @type {Array<ClientMessage>}
     * @memberof GetMessages
     */
    'data'?: Array<ClientMessage>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetMessages
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetModel
 */
export interface GetModel {
    /**
     * 
     * @type {GetModelData}
     * @memberof GetModel
     */
    'data'?: GetModelData;
}
/**
 * 
 * @export
 * @interface GetModelData
 */
export interface GetModelData {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetModelData
     */
    'firmId': string;
    /**
     * The unique identifier for the model
     * @type {string}
     * @memberof GetModelData
     */
    'id': string;
    /**
     * assiotated node ID\'s array
     * @type {Array<string>}
     * @memberof GetModelData
     */
    'nodeIds'?: Array<string>;
    /**
     * The name of the mode
     * @type {string}
     * @memberof GetModelData
     */
    'name': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetModelData
     */
    'lei': string;
    /**
     * The type of account
     * @type {string}
     * @memberof GetModelData
     */
    'accountType': string;
    /**
     * A summary or information about the model
     * @type {string}
     * @memberof GetModelData
     */
    'commentary': string;
    /**
     * TBD The risk rating of the model on a scale of 1-10
     * @type {number}
     * @memberof GetModelData
     */
    'riskRating': number;
    /**
     * The url to the Key Features document for the model
     * @type {string}
     * @memberof GetModelData
     */
    'url'?: string;
    /**
     * The type of products the model can be used with
     * @type {Array<string>}
     * @memberof GetModelData
     */
    'productType': Array<string>;
    /**
     * The aim of the model
     * @type {string}
     * @memberof GetModelData
     */
    'aim': string;
    /**
     * status of the model
     * @type {string}
     * @memberof GetModelData
     */
    'status'?: string;
    /**
     * The charge percentage of the model
     * @type {number}
     * @memberof GetModelData
     */
    'modelCharge': number;
    /**
     * 
     * @type {ModelType}
     * @memberof GetModelData
     */
    'modelType'?: ModelType;
    /**
     * Whether VAT can be applied to the model
     * @type {boolean}
     * @memberof GetModelData
     */
    'vatable'?: boolean;
    /**
     * Whether this model should have rebalances suspended
     * @type {boolean}
     * @memberof GetModelData
     */
    'suspendRebalances': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetModelData
     */
    'availableToNodeId'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetModelData
     */
    'nodeId'?: Array<string>;
    /**
     * Array containing names of avalable nodes
     * @type {Array<string>}
     * @memberof GetModelData
     */
    'availableToNodeName'?: Array<string>;
    /**
     * TBD
     * @type {Array<GetModelDataAllocationsInner>}
     * @memberof GetModelData
     */
    'allocations': Array<GetModelDataAllocationsInner>;
    /**
     * The cash allocation for the model. This is automatically generated where asset allocations do not add up to 1 (100%) but can be specified.
     * @type {number}
     * @memberof GetModelData
     */
    'cashAllocation'?: number;
    /**
     * 
     * @type {GetModelDataInvestmentDecision}
     * @memberof GetModelData
     */
    'investmentDecision'?: GetModelDataInvestmentDecision;
    /**
     * 
     * @type {Array<GetModelDataAssetMixInner>}
     * @memberof GetModelData
     */
    'assetMix'?: Array<GetModelDataAssetMixInner>;
    /**
     * Unique hash for previous change
     * @type {string}
     * @memberof GetModelData
     */
    'updateId': string;
    /**
     * 
     * @type {GetModelDataAuditDetails}
     * @memberof GetModelData
     */
    'auditDetails'?: GetModelDataAuditDetails;
}


/**
 * 
 * @export
 * @interface GetModelDataAllocationsInner
 */
export interface GetModelDataAllocationsInner {
    /**
     * The unique identifier for the asset in the model allocation
     * @type {string}
     * @memberof GetModelDataAllocationsInner
     */
    'assetId': string;
    /**
     * The name of the asset in the model allocation
     * @type {string}
     * @memberof GetModelDataAllocationsInner
     */
    'assetName': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetModelDataAllocationsInner
     */
    'currency': string;
    /**
     * he proportion of the asset in the model, where asset allocations total 1 (100%)
     * @type {number}
     * @memberof GetModelDataAllocationsInner
     */
    'percentage': number;
    /**
     * The status of the asset in the model allocation
     * @type {string}
     * @memberof GetModelDataAllocationsInner
     */
    'status': string;
}
/**
 * The proportion held of each asset class and cash in the model. This is required for producing growth rates for product illustrations where the wrapper is using a model portfolio investment strategy.
 * @export
 * @interface GetModelDataAssetMixInner
 */
export interface GetModelDataAssetMixInner {
    /**
     * The type of instrument/asset. The system accounts for Equity, Gilts, Corporate bonds, Cash and Other asset classes.
     * @type {string}
     * @memberof GetModelDataAssetMixInner
     */
    'instrumentType'?: string;
    /**
     * The proportion of each asset class in the model, where asset allocations total 1 (100%). Please note the cash allocation is generated as the remaining proportion of assets not accounted for. For example, a model made up of 70% equities and 28% bonds will have a 2% cash allocation.
     * @type {number}
     * @memberof GetModelDataAssetMixInner
     */
    'instrumentRateType'?: number;
}
/**
 * object containing audit trail details
 * @export
 * @interface GetModelDataAuditDetails
 */
export interface GetModelDataAuditDetails {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof GetModelDataAuditDetails
     */
    'updateDate'?: string;
    /**
     * Firm Id of user that implemented update
     * @type {string}
     * @memberof GetModelDataAuditDetails
     */
    'userFirmId': string;
    /**
     * Id of user that implemented update
     * @type {string}
     * @memberof GetModelDataAuditDetails
     */
    'userId': string;
    /**
     * TBD
     * @type {number}
     * @memberof GetModelDataAuditDetails
     */
    'version': number;
    /**
     * TBD
     * @type {string}
     * @memberof GetModelDataAuditDetails
     */
    'application': string;
}
/**
 * 
 * @export
 * @interface GetModelDataInvestmentDecision
 */
export interface GetModelDataInvestmentDecision {
    /**
     * A 20-digit numerical identifier assigned to a DFM
     * @type {string}
     * @memberof GetModelDataInvestmentDecision
     */
    'firmLei': string;
    /**
     * A two-letter country code denoting the firm\'s location
     * @type {string}
     * @memberof GetModelDataInvestmentDecision
     */
    'firmCountry': string;
    /**
     * The National Identifier for the firm user/decision maker. For 1 nationals this is in the format XX123456X
     * @type {string}
     * @memberof GetModelDataInvestmentDecision
     */
    'personId': string;
    /**
     * 
     * @type {PersonalIdentifierType}
     * @memberof GetModelDataInvestmentDecision
     */
    'personIdType': PersonalIdentifierType;
    /**
     * A two-letter country code denoting the firm user/decision maker\'s location
     * @type {string}
     * @memberof GetModelDataInvestmentDecision
     */
    'personCountry': string;
}


/**
 * 
 * @export
 * @interface GetModelsList
 */
export interface GetModelsList {
    /**
     * 
     * @type {Array<GetModelsListDataInner>}
     * @memberof GetModelsList
     */
    'data'?: Array<GetModelsListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetModelsList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetModelsListDataInner
 */
export interface GetModelsListDataInner {
    /**
     * The unique identifier for the model
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'id': string;
    /**
     * 
     * @type {ModelType}
     * @memberof GetModelsListDataInner
     */
    'modelType'?: ModelType;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'firmId': string;
    /**
     * The name of the mode
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'name': string;
    /**
     * tbd
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'lei': string;
    /**
     * The type of account
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'accountType': string;
    /**
     * A summary or information about the model
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'commentary': string;
    /**
     * tbd The risk rating of the model on a scale of 1-10
     * @type {number}
     * @memberof GetModelsListDataInner
     */
    'riskRating': number;
    /**
     * The url to the Key Features document for the model
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'url'?: string;
    /**
     * The type of products the model can be used with
     * @type {Array<string>}
     * @memberof GetModelsListDataInner
     */
    'productType': Array<string>;
    /**
     * The status of the model
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'status': GetModelsListDataInnerStatusEnum;
    /**
     * The aim of the model
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'aim': string;
    /**
     * The charge percentage of the model
     * @type {number}
     * @memberof GetModelsListDataInner
     */
    'modelCharge'?: number;
    /**
     * Whether VAT can be applied to the model
     * @type {boolean}
     * @memberof GetModelsListDataInner
     */
    'vatable'?: boolean;
    /**
     * Whether this model should have rebalances suspended
     * @type {boolean}
     * @memberof GetModelsListDataInner
     */
    'suspendRebalances': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetModelsListDataInner
     */
    'availableToNodeId': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetModelsListDataInner
     */
    'nodeId'?: Array<string>;
    /**
     * tbd
     * @type {Array<GetModelsListDataInnerAllocationsInner>}
     * @memberof GetModelsListDataInner
     */
    'allocations': Array<GetModelsListDataInnerAllocationsInner>;
    /**
     * The cash allocation for the model. This is automatically generated where asset allocations do not add up to 1 (100%) but can be specified.
     * @type {number}
     * @memberof GetModelsListDataInner
     */
    'cashAllocation'?: number;
    /**
     * tbd
     * @type {Array<GetModelDataInvestmentDecision>}
     * @memberof GetModelsListDataInner
     */
    'investmentDecision'?: Array<GetModelDataInvestmentDecision>;
    /**
     * 
     * @type {GetModelDataAssetMixInner}
     * @memberof GetModelsListDataInner
     */
    'assetMix'?: GetModelDataAssetMixInner;
    /**
     * Unique hash for previous change
     * @type {string}
     * @memberof GetModelsListDataInner
     */
    'updateId': string;
    /**
     * 
     * @type {GetModelsListDataInnerAuditDetails}
     * @memberof GetModelsListDataInner
     */
    'auditDetails': GetModelsListDataInnerAuditDetails;
}

/**
    * @export
    * @enum {string}
    */
export enum GetModelsListDataInnerStatusEnum {
    Active = 'Active',
    Pending = 'Pending',
    Deleted = 'Deleted'
}

/**
 * 
 * @export
 * @interface GetModelsListDataInnerAllocationsInner
 */
export interface GetModelsListDataInnerAllocationsInner {
    /**
     * The unique identifier for the asset in the model allocation
     * @type {string}
     * @memberof GetModelsListDataInnerAllocationsInner
     */
    'assetId': string;
    /**
     * The name of the asset in the model allocation
     * @type {string}
     * @memberof GetModelsListDataInnerAllocationsInner
     */
    'assetName': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetModelsListDataInnerAllocationsInner
     */
    'currency': string;
    /**
     * The proportion of the asset in the model, where asset allocations total 1 (100%)
     * @type {number}
     * @memberof GetModelsListDataInnerAllocationsInner
     */
    'percentage': number;
    /**
     * The status of the asset in the model allocation
     * @type {string}
     * @memberof GetModelsListDataInnerAllocationsInner
     */
    'status': string;
}
/**
 * object containing audit trail details
 * @export
 * @interface GetModelsListDataInnerAuditDetails
 */
export interface GetModelsListDataInnerAuditDetails {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof GetModelsListDataInnerAuditDetails
     */
    'updateDate': string;
    /**
     * Firm Id of user that implemented update
     * @type {string}
     * @memberof GetModelsListDataInnerAuditDetails
     */
    'userFirmId': string;
    /**
     * Id of user that implemented update
     * @type {string}
     * @memberof GetModelsListDataInnerAuditDetails
     */
    'userId': string;
    /**
     * TBD
     * @type {number}
     * @memberof GetModelsListDataInnerAuditDetails
     */
    'version': number;
    /**
     * TBD
     * @type {string}
     * @memberof GetModelsListDataInnerAuditDetails
     */
    'application': string;
}
/**
 * 
 * @export
 * @interface GetNationalities
 */
export interface GetNationalities {
    /**
     * 
     * @type {Array<GetNationalitiesDataInner>}
     * @memberof GetNationalities
     */
    'data'?: Array<GetNationalitiesDataInner>;
}
/**
 * 
 * @export
 * @interface GetNationalitiesDataInner
 */
export interface GetNationalitiesDataInner {
    /**
     * The unique two-letter identifier for the nationality. This is case sensitive
     * @type {string}
     * @memberof GetNationalitiesDataInner
     */
    'id'?: string;
    /**
     * A two-letter country code
     * @type {string}
     * @memberof GetNationalitiesDataInner
     */
    'code'?: string;
    /**
     * The name of the country
     * @type {string}
     * @memberof GetNationalitiesDataInner
     */
    'name'?: string;
    /**
     * The country descriptor
     * @type {string}
     * @memberof GetNationalitiesDataInner
     */
    'adjective'?: string;
    /**
     * This confirms whether or not a country is in the European Economic Area (EEA). Although the UK is not in the EU anymore, it is still reported as inEEA true as per MiFIR/MiFID II rules
     * @type {boolean}
     * @memberof GetNationalitiesDataInner
     */
    'inEEA'?: boolean;
    /**
     * An array which captures all forms of national identifiers for the chosen country
     * @type {Array<GetNationalitiesDataInnerIdentifiersInner>}
     * @memberof GetNationalitiesDataInner
     */
    'identifiers'?: Array<GetNationalitiesDataInnerIdentifiersInner>;
}
/**
 * 
 * @export
 * @interface GetNationalitiesDataInnerIdentifiersInner
 */
export interface GetNationalitiesDataInnerIdentifiersInner {
    /**
     * The name of the national identifier. This will be National Insurance Number for British nationals and National Passport Number for all other nationalities
     * @type {string}
     * @memberof GetNationalitiesDataInnerIdentifiersInner
     */
    'name'?: string;
    /**
     * A regular expression denoting validation for the national identifier
     * @type {Array<string>}
     * @memberof GetNationalitiesDataInnerIdentifiersInner
     */
    'regex'?: Array<string>;
    /**
     * The name of the national identifier
     * @type {string}
     * @memberof GetNationalitiesDataInnerIdentifiersInner
     */
    'localeName'?: string;
    /**
     * An example of the alphanumeric national identifier format
     * @type {string}
     * @memberof GetNationalitiesDataInnerIdentifiersInner
     */
    'example'?: string;
    /**
     * The national identifier priority score
     * @type {number}
     * @memberof GetNationalitiesDataInnerIdentifiersInner
     */
    'priority'?: number;
}
/**
 * 
 * @export
 * @interface GetNode
 */
export interface GetNode {
    /**
     * 
     * @type {Array<Node>}
     * @memberof GetNode
     */
    'data'?: Array<Node>;
    /**
     * 
     * @type {GetAssetUniverseMeta}
     * @memberof GetNode
     */
    'meta'?: GetAssetUniverseMeta;
}
/**
 * 
 * @export
 * @interface GetOrder
 */
export interface GetOrder {
    /**
     * 
     * @type {Array<GetOrderDataInner>}
     * @memberof GetOrder
     */
    'data'?: Array<GetOrderDataInner>;
}
/**
 * 
 * @export
 * @interface GetOrderDataInner
 */
export interface GetOrderDataInner {
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof GetOrderDataInner
     */
    'accountId'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetOrderDataInner
     */
    'firmId'?: string;
    /**
     * The type of transaction taking place
     * @type {string}
     * @memberof GetOrderDataInner
     */
    'transactionType'?: string;
    /**
     * The action performed on the account
     * @type {string}
     * @memberof GetOrderDataInner
     */
    'transactionSubType'?: string;
    /**
     * 
     * @type {MovementType}
     * @memberof GetOrderDataInner
     */
    'movementType'?: MovementType;
    /**
     * 
     * @type {GetOrderDataInnerTransactions}
     * @memberof GetOrderDataInner
     */
    'transactions'?: GetOrderDataInnerTransactions;
}


/**
 * TBD
 * @export
 * @interface GetOrderDataInnerTransactions
 */
export interface GetOrderDataInnerTransactions {
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetOrderDataInnerTransactions
     */
    'currency'?: string;
    /**
     * The amount in pounds paid in or out of the accoun
     * @type {number}
     * @memberof GetOrderDataInnerTransactions
     */
    'amount'?: number;
    /**
     * Unique identifier for a type of asset
     * @type {string}
     * @memberof GetOrderDataInnerTransactions
     */
    'assetId'?: string;
}
/**
 * 
 * @export
 * @interface GetPortfolioClientGroupSummary
 */
export interface GetPortfolioClientGroupSummary {
    /**
     * 
     * @type {GetPortfolioClientGroupSummaryData}
     * @memberof GetPortfolioClientGroupSummary
     */
    'data'?: GetPortfolioClientGroupSummaryData;
}
/**
 * 
 * @export
 * @interface GetPortfolioClientGroupSummaryData
 */
export interface GetPortfolioClientGroupSummaryData {
    /**
     * The name of the client group
     * @type {string}
     * @memberof GetPortfolioClientGroupSummaryData
     */
    'name': string;
    /**
     * The unique identifier of the client group
     * @type {string}
     * @memberof GetPortfolioClientGroupSummaryData
     */
    'id': string;
    /**
     * The number of clients in the group
     * @type {number}
     * @memberof GetPortfolioClientGroupSummaryData
     */
    'noOfClients': number;
    /**
     * The total value of the group\'s portfolio
     * @type {number}
     * @memberof GetPortfolioClientGroupSummaryData
     */
    'groupValue': number;
    /**
     * 
     * @type {Array<GetPortfolioClientGroupSummaryDataClientsInner>}
     * @memberof GetPortfolioClientGroupSummaryData
     */
    'clients': Array<GetPortfolioClientGroupSummaryDataClientsInner>;
}
/**
 * 
 * @export
 * @interface GetPortfolioClientGroupSummaryDataClientsInner
 */
export interface GetPortfolioClientGroupSummaryDataClientsInner {
    /**
     * The name of the client
     * @type {string}
     * @memberof GetPortfolioClientGroupSummaryDataClientsInner
     */
    'name': string;
    /**
     * The unique identifier of the client
     * @type {string}
     * @memberof GetPortfolioClientGroupSummaryDataClientsInner
     */
    'clientId': string;
    /**
     * The number of accounts the client has
     * @type {number}
     * @memberof GetPortfolioClientGroupSummaryDataClientsInner
     */
    'noOfAccounts': number;
    /**
     * The total value of the client\'s portfolio
     * @type {number}
     * @memberof GetPortfolioClientGroupSummaryDataClientsInner
     */
    'totalValue': number;
}
/**
 * 
 * @export
 * @interface GetPortfolioGroup
 */
export interface GetPortfolioGroup {
    /**
     * 
     * @type {GetPortfolioGroupData}
     * @memberof GetPortfolioGroup
     */
    'data': GetPortfolioGroupData;
}
/**
 * 
 * @export
 * @interface GetPortfolioGroupData
 */
export interface GetPortfolioGroupData {
    /**
     * unique identifier of a client fee group
     * @type {string}
     * @memberof GetPortfolioGroupData
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetPortfolioGroupData
     */
    'firmId': string;
    /**
     * The unique node identifier that the client record is attached to
     * @type {string}
     * @memberof GetPortfolioGroupData
     */
    'nodeId': string;
    /**
     * The full name of the client, including title, first name and surname
     * @type {string}
     * @memberof GetPortfolioGroupData
     */
    'name': string;
    /**
     * the intent of the group
     * @type {string}
     * @memberof GetPortfolioGroupData
     */
    'groupIntent': string;
    /**
     * 
     * @type {GetPortfolioGroupDataIntentDetails}
     * @memberof GetPortfolioGroupData
     */
    'intentDetails': GetPortfolioGroupDataIntentDetails;
    /**
     * 
     * @type {Array<NominatedAccountsInner>}
     * @memberof GetPortfolioGroupData
     */
    'nominatedAccounts'?: Array<NominatedAccountsInner>;
    /**
     * details of audits
     * @type {object}
     * @memberof GetPortfolioGroupData
     */
    'auditDetails': object;
    /**
     * update ID for the portfolio group
     * @type {string}
     * @memberof GetPortfolioGroupData
     */
    'updateId': string;
}
/**
 * The details of the client fee group
 * @export
 * @interface GetPortfolioGroupDataIntentDetails
 */
export interface GetPortfolioGroupDataIntentDetails {
    /**
     * 
     * @type {boolean}
     * @memberof GetPortfolioGroupDataIntentDetails
     */
    'platformFee': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPortfolioGroupDataIntentDetails
     */
    'adviserFee': boolean;
    /**
     * The status of the client fee group
     * @type {string}
     * @memberof GetPortfolioGroupDataIntentDetails
     */
    'status'?: GetPortfolioGroupDataIntentDetailsStatusEnum;
    /**
     * True if there are outstanding transfer actions
     * @type {boolean}
     * @memberof GetPortfolioGroupDataIntentDetails
     */
    'outstandingTransferActions'?: boolean;
    /**
     * 
     * @type {GetPortfolioGroupDataIntentDetailsFeeStructures}
     * @memberof GetPortfolioGroupDataIntentDetails
     */
    'feeStructures'?: GetPortfolioGroupDataIntentDetailsFeeStructures;
}

/**
    * @export
    * @enum {string}
    */
export enum GetPortfolioGroupDataIntentDetailsStatusEnum {
    Active = 'Active',
    Archived = 'Archived'
}

/**
 * 
 * @export
 * @interface GetPortfolioGroupDataIntentDetailsFeeStructures
 */
export interface GetPortfolioGroupDataIntentDetailsFeeStructures {
    /**
     * 
     * @type {string}
     * @memberof GetPortfolioGroupDataIntentDetailsFeeStructures
     */
    'platformFeeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPortfolioGroupDataIntentDetailsFeeStructures
     */
    'adviserFeeId'?: string;
}
/**
 * 
 * @export
 * @interface GetPortfolioGroupList
 */
export interface GetPortfolioGroupList {
    /**
     * 
     * @type {Array<GetPortfolioGroupListDataInner>}
     * @memberof GetPortfolioGroupList
     */
    'data'?: Array<GetPortfolioGroupListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetPortfolioGroupList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetPortfolioGroupListDataInner
 */
export interface GetPortfolioGroupListDataInner {
    /**
     * unique identifier of a portfolio group
     * @type {string}
     * @memberof GetPortfolioGroupListDataInner
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetPortfolioGroupListDataInner
     */
    'firmId': string;
    /**
     * The unique node identifier that the client record is attached to
     * @type {string}
     * @memberof GetPortfolioGroupListDataInner
     */
    'nodeId': string;
    /**
     * The name of the portfolio group
     * @type {string}
     * @memberof GetPortfolioGroupListDataInner
     */
    'name': string;
    /**
     * the intent of the group
     * @type {string}
     * @memberof GetPortfolioGroupListDataInner
     */
    'groupIntent': string;
    /**
     * 
     * @type {GetPortfolioGroupListDataInnerIntentDetails}
     * @memberof GetPortfolioGroupListDataInner
     */
    'intentDetails': GetPortfolioGroupListDataInnerIntentDetails;
    /**
     * details of audits
     * @type {object}
     * @memberof GetPortfolioGroupListDataInner
     */
    'auditDetails': object;
    /**
     * update ID for the portfolio group
     * @type {string}
     * @memberof GetPortfolioGroupListDataInner
     */
    'updateId': string;
}
/**
 * The details of the portfolio group
 * @export
 * @interface GetPortfolioGroupListDataInnerIntentDetails
 */
export interface GetPortfolioGroupListDataInnerIntentDetails {
    /**
     * 
     * @type {boolean}
     * @memberof GetPortfolioGroupListDataInnerIntentDetails
     */
    'platformFee'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPortfolioGroupListDataInnerIntentDetails
     */
    'adviserFee'?: boolean;
    /**
     * The status of the client fee group
     * @type {string}
     * @memberof GetPortfolioGroupListDataInnerIntentDetails
     */
    'status'?: GetPortfolioGroupListDataInnerIntentDetailsStatusEnum;
    /**
     * The unique identifier of the client product of which this group is a part
     * @type {string}
     * @memberof GetPortfolioGroupListDataInnerIntentDetails
     */
    'clientProductId'?: string;
    /**
     * 
     * @type {PensionAccountGroupType}
     * @memberof GetPortfolioGroupListDataInnerIntentDetails
     */
    'groupType'?: PensionAccountGroupType;
    /**
     * 
     * @type {Array<GetPortfolioGroupListDataInnerIntentDetailsCrystallisationHistoryInner>}
     * @memberof GetPortfolioGroupListDataInnerIntentDetails
     */
    'crystallisationHistory'?: Array<GetPortfolioGroupListDataInnerIntentDetailsCrystallisationHistoryInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum GetPortfolioGroupListDataInnerIntentDetailsStatusEnum {
    Active = 'Active',
    Archived = 'Archived'
}

/**
 * 
 * @export
 * @interface GetPortfolioGroupListDataInnerIntentDetailsCrystallisationHistoryInner
 */
export interface GetPortfolioGroupListDataInnerIntentDetailsCrystallisationHistoryInner {
    /**
     * 
     * @type {number}
     * @memberof GetPortfolioGroupListDataInnerIntentDetailsCrystallisationHistoryInner
     */
    'lifetimeAllowanceUsed'?: number;
}
/**
 * 
 * @export
 * @interface GetPortfolioList
 */
export interface GetPortfolioList {
    /**
     * 
     * @type {Array<GetPortfolioListDataInner>}
     * @memberof GetPortfolioList
     */
    'data'?: Array<GetPortfolioListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetPortfolioList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetPortfolioListDataInner
 */
export interface GetPortfolioListDataInner {
    /**
     * The unique identifier of the client
     * @type {string}
     * @memberof GetPortfolioListDataInner
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetPortfolioListDataInner
     */
    'firmId'?: string;
    /**
     * The full name of the client
     * @type {string}
     * @memberof GetPortfolioListDataInner
     */
    'name'?: string;
    /**
     * The status of the client account
     * @type {string}
     * @memberof GetPortfolioListDataInner
     */
    'status'?: GetPortfolioListDataInnerStatusEnum;
    /**
     * The unique identifier of the node that the client is attached to
     * @type {Array<string>}
     * @memberof GetPortfolioListDataInner
     */
    'nodeId'?: Array<string>;
    /**
     * The name of the node that the client is attached to
     * @type {Array<string>}
     * @memberof GetPortfolioListDataInner
     */
    'nodeName'?: Array<string>;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetPortfolioListDataInner
     */
    'currency'?: string;
    /**
     * The current value of the portfolio. If no date parameters are provided, this will show as of today\'s date
     * @type {number}
     * @memberof GetPortfolioListDataInner
     */
    'currentValue'?: number;
    /**
     * The number of investment accounts in the client\'s portfolio
     * @type {any}
     * @memberof GetPortfolioListDataInner
     */
    'accounts'?: any;
    /**
     * The total value of uninvested cash in the portfolio
     * @type {number}
     * @memberof GetPortfolioListDataInner
     */
    'uninvestedCash'?: number;
    /**
     * The portfolio\'s growth since book costs
     * @type {number}
     * @memberof GetPortfolioListDataInner
     */
    'growth'?: number;
    /**
     * The type of instrumentThe portfolio\'s growth since book costs as a percentage
     * @type {any}
     * @memberof GetPortfolioListDataInner
     */
    'growthPercent'?: any;
    /**
     * The portfolio\'s growth since assets on the platform
     * @type {number}
     * @memberof GetPortfolioListDataInner
     */
    'adjustedGrowth'?: number;
    /**
     * The portfolio\'s growth since assets on the platform as a percentage
     * @type {number}
     * @memberof GetPortfolioListDataInner
     */
    'adjustedGrowthPercent'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum GetPortfolioListDataInnerStatusEnum {
    Registered = 'Registered',
    Pending = 'Pending',
    Active = 'Active',
    Suspended = 'Suspended',
    Closed = 'Closed',
    Closing = 'Closing'
}

/**
 * 
 * @export
 * @interface GetPortfolioReport
 */
export interface GetPortfolioReport {
    /**
     * 
     * @type {GetPortfolioReportData}
     * @memberof GetPortfolioReport
     */
    'data'?: GetPortfolioReportData;
}
/**
 * 
 * @export
 * @interface GetPortfolioReportData
 */
export interface GetPortfolioReportData {
    /**
     * The unique identifier of the portfolio
     * @type {string}
     * @memberof GetPortfolioReportData
     */
    'id'?: string;
    /**
     * The full name of the client
     * @type {string}
     * @memberof GetPortfolioReportData
     */
    'name'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetPortfolioReportData
     */
    'firmId'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetPortfolioReportData
     */
    'currency'?: string;
    /**
     * 
     * @type {ReportPayments}
     * @memberof GetPortfolioReportData
     */
    'payments'?: ReportPayments;
    /**
     * 
     * @type {ReportCharges}
     * @memberof GetPortfolioReportData
     */
    'charges'?: ReportCharges;
    /**
     * 
     * @type {ReportIncome}
     * @memberof GetPortfolioReportData
     */
    'income'?: ReportIncome;
    /**
     * 
     * @type {ReportTransfers}
     * @memberof GetPortfolioReportData
     */
    'transfers'?: ReportTransfers;
    /**
     * 
     * @type {ReportInternalTransfers}
     * @memberof GetPortfolioReportData
     */
    'internalTransfers'?: ReportInternalTransfers;
    /**
     * 
     * @type {ReportPerformance}
     * @memberof GetPortfolioReportData
     */
    'performance'?: ReportPerformance;
    /**
     * The opening value of the portfolio – if no date parameters are provided, this will show as 0
     * @type {number}
     * @memberof GetPortfolioReportData
     */
    'openingValue'?: number;
    /**
     * The closing value of the portfolio – if no date parameters are provided, this will show as of today\'s date
     * @type {number}
     * @memberof GetPortfolioReportData
     */
    'closingValue'?: number;
}
/**
 * 
 * @export
 * @interface GetPortfolioSearch
 */
export interface GetPortfolioSearch {
    /**
     * 
     * @type {Array<PortfolioSearchResult>}
     * @memberof GetPortfolioSearch
     */
    'data'?: Array<PortfolioSearchResult>;
    /**
     * 
     * @type {PortfolioSearchMeta}
     * @memberof GetPortfolioSearch
     */
    'meta'?: PortfolioSearchMeta;
}
/**
 * 
 * @export
 * @interface GetPortfolioSummary
 */
export interface GetPortfolioSummary {
    /**
     * 
     * @type {PortfolioSummaryData}
     * @memberof GetPortfolioSummary
     */
    'data'?: PortfolioSummaryData;
}
/**
 * 
 * @export
 * @interface GetPosition
 */
export interface GetPosition {
    /**
     * 
     * @type {GetPositionData}
     * @memberof GetPosition
     */
    'data'?: GetPositionData;
}
/**
 * 
 * @export
 * @interface GetPositionData
 */
export interface GetPositionData {
    /**
     * The unique identifier for the position.
     * @type {string}
     * @memberof GetPositionData
     */
    'id'?: string;
    /**
     * The ID of the account associated with the position.
     * @type {string}
     * @memberof GetPositionData
     */
    'accountId'?: string;
    /**
     * The name of the account associated with the position.
     * @type {string}
     * @memberof GetPositionData
     */
    'accountName'?: string;
    /**
     * The type of account associated with the position.
     * @type {string}
     * @memberof GetPositionData
     */
    'accountType'?: string;
    /**
     * The unique identifier for the asset.
     * @type {string}
     * @memberof GetPositionData
     */
    'assetId'?: string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof GetPositionData
     */
    'assetName'?: string;
    /**
     * 
     * @type {AuditDetails}
     * @memberof GetPositionData
     */
    'auditDetails'?: AuditDetails;
    /**
     * The currency of the position.
     * @type {string}
     * @memberof GetPositionData
     */
    'currency'?: string;
    /**
     * The ID of the firm associated with the position.
     * @type {string}
     * @memberof GetPositionData
     */
    'firmId'?: string;
    /**
     * The ISIN of the position.
     * @type {string}
     * @memberof GetPositionData
     */
    'isin'?: string;
    /**
     * The node ID associated with the position.
     * @type {string}
     * @memberof GetPositionData
     */
    'nodeId'?: string;
    /**
     * The type of the position (e.g., Stock).
     * @type {string}
     * @memberof GetPositionData
     */
    'positionType'?: string;
    /**
     * The quantity of the position.
     * @type {number}
     * @memberof GetPositionData
     */
    'quantity'?: number;
    /**
     * The list of transactions associated with the position.
     * @type {Array<PositionTransaction>}
     * @memberof GetPositionData
     */
    'transactions'?: Array<PositionTransaction>;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof GetPositionData
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}
/**
 * 
 * @export
 * @interface GetRegularCrystalliseGetData
 */
export interface GetRegularCrystalliseGetData {
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetData
     */
    'firmId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetData
     */
    'accountId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetRegularCrystalliseGetData
     */
    'benefitsTakenBefore2006': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetData
     */
    'fcaIndividualReference': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetRegularCrystalliseGetData
     */
    'protectedRetirementAgeOrLumpSum': boolean;
    /**
     * 
     * @type {GetCrystalliseGetDataAccountDetails}
     * @memberof GetRegularCrystalliseGetData
     */
    'accountDetails': GetCrystalliseGetDataAccountDetails;
    /**
     * 
     * @type {boolean}
     * @memberof GetRegularCrystalliseGetData
     */
    'advised': boolean;
    /**
     * 
     * @type {GetRegularCrystalliseGetDataCrystallisationDetails}
     * @memberof GetRegularCrystalliseGetData
     */
    'crystallisationDetails': GetRegularCrystalliseGetDataCrystallisationDetails;
    /**
     * 
     * @type {boolean}
     * @memberof GetRegularCrystalliseGetData
     */
    'guidance': boolean;
    /**
     * 
     * @type {Array<GetRegularCrystalliseGetDataWithdrawalDetailsInner>}
     * @memberof GetRegularCrystalliseGetData
     */
    'withdrawalDetails': Array<GetRegularCrystalliseGetDataWithdrawalDetailsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetData
     */
    'clientProductId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetRegularCrystalliseGetData
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetData
     */
    'status': GetRegularCrystalliseGetDataStatusEnum;
    /**
     * 
     * @type {GetCrystalliseGetDataAuditDetails}
     * @memberof GetRegularCrystalliseGetData
     */
    'auditDetails': GetCrystalliseGetDataAuditDetails;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetData
     */
    'updateId': string;
    /**
     * 
     * @type {Array<GetCrystalliseGetDataBenefitCrystallisationEvents>}
     * @memberof GetRegularCrystalliseGetData
     */
    'benefitCrystallisationEvents'?: Array<GetCrystalliseGetDataBenefitCrystallisationEvents>;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetData
     */
    'processAction'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GetRegularCrystalliseGetDataStatusEnum {
    Active = 'Active',
    Expired = 'Expired',
    Cancelled = 'Cancelled'
}

/**
 * 
 * @export
 * @interface GetRegularCrystalliseGetDataCrystallisationDetails
 */
export interface GetRegularCrystalliseGetDataCrystallisationDetails {
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataCrystallisationDetails
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataCrystallisationDetails
     */
    'frequency'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetRegularCrystalliseGetDataCrystallisationDetails
     */
    'fullCrystallisation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetRegularCrystalliseGetDataCrystallisationDetails
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataCrystallisationDetails
     */
    'expiryDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataCrystallisationDetails
     */
    'nextCrystallisationDate'?: string;
}
/**
 * 
 * @export
 * @interface GetRegularCrystalliseGetDataCrystallisationDetailsAllOf
 */
export interface GetRegularCrystalliseGetDataCrystallisationDetailsAllOf {
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataCrystallisationDetailsAllOf
     */
    'expiryDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataCrystallisationDetailsAllOf
     */
    'nextCrystallisationDate'?: string;
}
/**
 * 
 * @export
 * @interface GetRegularCrystalliseGetDataWithdrawalDetailsInner
 */
export interface GetRegularCrystalliseGetDataWithdrawalDetailsInner {
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataWithdrawalDetailsInner
     */
    'transactionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataWithdrawalDetailsInner
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataWithdrawalDetailsInner
     */
    'movementType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataWithdrawalDetailsInner
     */
    'transactionSubType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegularCrystalliseGetDataWithdrawalDetailsInner
     */
    'frequency'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetRegularCrystalliseGetDataWithdrawalDetailsInner
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRegularCrystalliseGetDataWithdrawalDetailsInner
     */
    'grossAmount'?: number;
}
/**
 * 
 * @export
 * @interface GetRegularCrystalliseGetDataWithdrawalDetailsInnerAllOf
 */
export interface GetRegularCrystalliseGetDataWithdrawalDetailsInnerAllOf {
    /**
     * 
     * @type {number}
     * @memberof GetRegularCrystalliseGetDataWithdrawalDetailsInnerAllOf
     */
    'grossAmount'?: number;
}
/**
 * 
 * @export
 * @interface GetReportList
 */
export interface GetReportList {
    /**
     * 
     * @type {Array<GetReportListDataInner>}
     * @memberof GetReportList
     */
    'data'?: Array<GetReportListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetReportList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetReportListDataInner
 */
export interface GetReportListDataInner {
    /**
     * The unique identifier for the client’s investment account
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'accountId': string;
    /**
     * The name of the investment account
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'accountName': string;
    /**
     * The amount that the investor is contributing to their investment account
     * @type {number}
     * @memberof GetReportListDataInner
     */
    'amount': number;
    /**
     * 
     * @type {Array<GetReportListDataInnerClientsInner>}
     * @memberof GetReportListDataInner
     */
    'clients': Array<GetReportListDataInnerClientsInner>;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'currency': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'firmId': string;
    /**
     * The description of the transaction
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'narrative': string;
    /**
     * The unique identifier of the node attached to the client account
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'nodeId': string;
    /**
     * 
     * @type {PositionType}
     * @memberof GetReportListDataInner
     */
    'positionType': PositionType;
    /**
     * The date the transaction completed
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'postDate': string;
    /**
     * The transaction code of the transaction
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'transactionCode': string;
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'transactionId': string;
    /**
     * The date the transaction was created
     * @type {string}
     * @memberof GetReportListDataInner
     */
    'valueDate': string;
}


/**
 * 
 * @export
 * @interface GetReportListDataInnerClientsInner
 */
export interface GetReportListDataInnerClientsInner {
    /**
     * 
     * @type {string}
     * @memberof GetReportListDataInnerClientsInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportListDataInnerClientsInner
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface GetSchemaProductGetData
 */
export interface GetSchemaProductGetData {
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'firmId': string;
    /**
     * 
     * @type {GetSchemaProductGetDataAuditDetails}
     * @memberof GetSchemaProductGetData
     */
    'auditDetails'?: GetSchemaProductGetDataAuditDetails;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'updateId'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof GetSchemaProductGetData
     */
    'availableToNodeId'?: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    '_productName'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetSchemaProductGetData
     */
    'wrapperType'?: WrapperType;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'schemeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'pensionSchemeTaxReference'?: string;
    /**
     * 
     * @type {GetSchemaProductGetDataSchemeBankDetails}
     * @memberof GetSchemaProductGetData
     */
    'schemeBankDetails'?: GetSchemaProductGetDataSchemeBankDetails;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'contactName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'contactNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'taxWrapperAdministrator'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'reliefAtSourceReferenceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'schemeFCAReferenceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'uniqueTaxPayerReference'?: string;
    /**
     * 
     * @type {GetSchemaProductGetDataSchemeAdministratorAddress}
     * @memberof GetSchemaProductGetData
     */
    'schemeAdministratorAddress'?: GetSchemaProductGetDataSchemeAdministratorAddress;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'declarationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    '_schemeName'?: string;
    /**
     * 
     * @type {GetSchemaProductGetDataOrigoIdentifiers}
     * @memberof GetSchemaProductGetData
     */
    'origoIdentifiers'?: GetSchemaProductGetDataOrigoIdentifiers;
    /**
     * 
     * @type {GetSchemaProductGetDataCounterParties}
     * @memberof GetSchemaProductGetData
     */
    'counterParties'?: GetSchemaProductGetDataCounterParties;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'schemeFirmId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetData
     */
    'schemeId': string;
    /**
     * 
     * @type {GetSchemaProductGetDataExternalSystem}
     * @memberof GetSchemaProductGetData
     */
    'externalSystem'?: GetSchemaProductGetDataExternalSystem;
}


/**
 * 
 * @export
 * @interface GetSchemaProductGetDataAuditDetails
 */
export interface GetSchemaProductGetDataAuditDetails {
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataAuditDetails
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataAuditDetails
     */
    'userFirmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataAuditDetails
     */
    'userId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSchemaProductGetDataAuditDetails
     */
    'version'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataAuditDetails
     */
    'application'?: string;
}
/**
 * 
 * @export
 * @interface GetSchemaProductGetDataCounterParties
 */
export interface GetSchemaProductGetDataCounterParties {
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataCounterParties
     */
    'incomeTaxPartyId'?: string;
}
/**
 * 
 * @export
 * @interface GetSchemaProductGetDataExternalSystem
 */
export interface GetSchemaProductGetDataExternalSystem {
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataExternalSystem
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetSchemaProductGetDataOrigoIdentifiers
 */
export interface GetSchemaProductGetDataOrigoIdentifiers {
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataOrigoIdentifiers
     */
    'caseContactId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataOrigoIdentifiers
     */
    'paymentAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataOrigoIdentifiers
     */
    'schemeReferenceId'?: string;
}
/**
 * 
 * @export
 * @interface GetSchemaProductGetDataSchemeAdministratorAddress
 */
export interface GetSchemaProductGetDataSchemeAdministratorAddress {
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataSchemeAdministratorAddress
     */
    'buildingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataSchemeAdministratorAddress
     */
    'address1'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataSchemeAdministratorAddress
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataSchemeAdministratorAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataSchemeAdministratorAddress
     */
    'postCode'?: string;
}
/**
 * 
 * @export
 * @interface GetSchemaProductGetDataSchemeBankDetails
 */
export interface GetSchemaProductGetDataSchemeBankDetails {
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataSchemeBankDetails
     */
    'sortCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataSchemeBankDetails
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSchemaProductGetDataSchemeBankDetails
     */
    'accountName'?: string;
}
/**
 * 
 * @export
 * @interface GetSchemaProductGetMeta
 */
export interface GetSchemaProductGetMeta {
    /**
     * 
     * @type {number}
     * @memberof GetSchemaProductGetMeta
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface GetTransactionCodesList
 */
export interface GetTransactionCodesList {
    /**
     * 
     * @type {Array<GetTransactionCodesListDataInner>}
     * @memberof GetTransactionCodesList
     */
    'data'?: Array<GetTransactionCodesListDataInner>;
}
/**
 * 
 * @export
 * @interface GetTransactionCodesListDataInner
 */
export interface GetTransactionCodesListDataInner {
    /**
     * The transaction code
     * @type {string}
     * @memberof GetTransactionCodesListDataInner
     */
    'id': string;
    /**
     * The name of the transaction
     * @type {string}
     * @memberof GetTransactionCodesListDataInner
     */
    'name'?: string;
    /**
     * 
     * @type {TransactionType}
     * @memberof GetTransactionCodesListDataInner
     */
    'transactionType'?: TransactionType;
    /**
     * The subtype of transaction
     * @type {string}
     * @memberof GetTransactionCodesListDataInner
     */
    'transactionSubType'?: string;
    /**
     * 
     * @type {TransferMovementType}
     * @memberof GetTransactionCodesListDataInner
     */
    'movementType'?: TransferMovementType;
    /**
     * Indicates what category the transaction relates
     * @type {string}
     * @memberof GetTransactionCodesListDataInner
     */
    'accountReportGroup'?: string;
    /**
     * Specifies which wrapper types can support the transaction
     * @type {Array<string>}
     * @memberof GetTransactionCodesListDataInner
     */
    'products'?: Array<string>;
    /**
     * Indicates whether the transaction could impact the client\'s capital gains tax
     * @type {boolean}
     * @memberof GetTransactionCodesListDataInner
     */
    'cgt'?: boolean;
    /**
     * Indicates whether the transaction impacts the client\'s annual subscription allowance
     * @type {boolean}
     * @memberof GetTransactionCodesListDataInner
     */
    'subscription'?: boolean;
    /**
     * Indicates whether the transaction can be withdrawn. This only shows on withdrawal transactions
     * @type {boolean}
     * @memberof GetTransactionCodesListDataInner
     */
    'allowWithdrawal'?: boolean;
}


/**
 * 
 * @export
 * @interface GetTransactionsList
 */
export interface GetTransactionsList {
    /**
     * 
     * @type {Array<GetTransactionsListDataInner>}
     * @memberof GetTransactionsList
     */
    'data'?: Array<GetTransactionsListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetTransactionsList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetTransactionsListDataInner
 */
export interface GetTransactionsListDataInner {
    /**
     * The number of units of the asset being traded
     * @type {number}
     * @memberof GetTransactionsListDataInner
     */
    'quantity'?: number;
    /**
     * The number of units of the asset being traded
     * @type {number}
     * @memberof GetTransactionsListDataInner
     */
    'executedQuantity'?: number;
    /**
     * The book value of the asset being traded
     * @type {number}
     * @memberof GetTransactionsListDataInner
     */
    'bookValue'?: number;
    /**
     * The amount of the asset being traded
     * @type {number}
     * @memberof GetTransactionsListDataInner
     */
    'executedAmount'?: number;
    /**
     * The unique identifier for the client’s investment account
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'accountId': string;
    /**
     * The name of the investment account
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'accountName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'assetId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'assetName'?: string;
    /**
     * The type of account
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'accountType'?: string;
    /**
     * The amount that the investor is contributing to their investment account
     * @type {number}
     * @memberof GetTransactionsListDataInner
     */
    'amount'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerAuditDetails}
     * @memberof GetTransactionsListDataInner
     */
    'auditDetails'?: GetIllustrationsListDataInnerAuditDetails;
    /**
     * TBD
     * @type {boolean}
     * @memberof GetTransactionsListDataInner
     */
    'autoSetBookValue'?: boolean;
    /**
     * The date the transaction was created
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'createdDate': string;
    /**
     * The date the transaction switched to Completed
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'completedDate'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'currency'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'firmId': string;
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'id': string;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'instrumentType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'intendedSettlementDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetTransactionsListDataInner
     */
    'isPensionTransfer'?: boolean;
    /**
     * Is this a manual transfer
     * @type {boolean}
     * @memberof GetTransactionsListDataInner
     */
    'isManual'?: boolean;
    /**
     * 
     * @type {ActionTag}
     * @memberof GetTransactionsListDataInner
     */
    'actionTag'?: ActionTag;
    /**
     * 
     * @type {UserInvestmentDecision}
     * @memberof GetTransactionsListDataInner
     */
    'investmentDecision'?: UserInvestmentDecision;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'isin'?: string;
    /**
     * The unique identifier that is contained in all the transactions within that portfolio transaction group
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'linkId': string;
    /**
     * The payment method facilitating the withdrawal
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'mic'?: string;
    /**
     * The unique identifier of the node attached to the client account
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'nodeId': string;
    /**
     * The payment method facilitating the withdrawal
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'method'?: string;
    /**
     * 
     * @type {MovementType}
     * @memberof GetTransactionsListDataInner
     */
    'movementType': MovementType;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'previousProvider'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'previousProviderName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'previousProviderRef'?: string;
    /**
     * 
     * @type {PreviousProviderAccountType}
     * @memberof GetTransactionsListDataInner
     */
    'previousProviderAccountType'?: PreviousProviderAccountType;
    /**
     * TBD
     * @type {number}
     * @memberof GetTransactionsListDataInner
     */
    'percentage'?: number;
    /**
     * Type of manual signature required for the transfer
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'signatureType'?: GetTransactionsListDataInnerSignatureTypeEnum;
    /**
     * 
     * @type {TransactionStatus}
     * @memberof GetTransactionsListDataInner
     */
    'status': TransactionStatus;
    /**
     * Contains an object to detail the change in statuses of the transaction
     * @type {Array<TransactionStatusChange>}
     * @memberof GetTransactionsListDataInner
     */
    'statusChanges'?: Array<TransactionStatusChange>;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'ticker'?: string;
    /**
     * The date the payment transaction was instructed
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'transactionDate': string;
    /**
     * 
     * @type {TransactionType}
     * @memberof GetTransactionsListDataInner
     */
    'transactionType': TransactionType;
    /**
     * The subtype of transaction (In Specie, Cash)
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'transactionSubType': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof GetTransactionsListDataInner
     */
    'transferAccountAddress'?: AddressDetail;
    /**
     * 
     * @type {TransferStatus}
     * @memberof GetTransactionsListDataInner
     */
    'transferStatus'?: TransferStatus;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'rejectionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'rejectionNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'transferSystem'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof GetTransactionsListDataInner
     */
    'transferValue'?: number;
    /**
     * Unique hash for previous change
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'updateId': string;
    /**
     * The unique identifier for the attached file upload
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'uploadedFileDetailsId'?: string;
    /**
     * 
     * @type {GetTransactionsListDataInnerInformation}
     * @memberof GetTransactionsListDataInner
     */
    'information'?: GetTransactionsListDataInnerInformation;
    /**
     * The id of the account held by the receiving provider
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'receivingProvider'?: string;
    /**
     * The id of the account held by the receiving provider
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'receivingProviderId'?: string;
    /**
     * The account reference of the account held by the receiving provider
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'receivingProviderRef'?: string;
    /**
     * The name of the receiving provider
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'receivingProviderName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'bankRef'?: string;
    /**
     * 
     * @type {AutoDisinvest}
     * @memberof GetTransactionsListDataInner
     */
    'autoDisinvest'?: AutoDisinvest;
    /**
     * 
     * @type {string}
     * @memberof GetTransactionsListDataInner
     */
    'primaryClientId'?: string;
    /**
     * 
     * @type {Array<TransferUpdateEvent>}
     * @memberof GetTransactionsListDataInner
     */
    'transferUpdateEvents'?: Array<TransferUpdateEvent>;
}

/**
    * @export
    * @enum {string}
    */
export enum GetTransactionsListDataInnerSignatureTypeEnum {
    Scanned = 'Scanned',
    Electronic = 'Electronic',
    Wet = 'Wet'
}

/**
 * TBD
 * @export
 * @interface GetTransactionsListDataInnerInformation
 */
export interface GetTransactionsListDataInnerInformation {
    /**
     * TBD
     * @type {number}
     * @memberof GetTransactionsListDataInnerInformation
     */
    'bookCostAmount'?: number;
}
/**
 * 
 * @export
 * @interface GetTransfersList
 */
export interface GetTransfersList {
    /**
     * 
     * @type {Array<GetTransfersListDataInner>}
     * @memberof GetTransfersList
     */
    'data'?: Array<GetTransfersListDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetTransfersList
     */
    'meta'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetTransfersListDataInner
 */
export interface GetTransfersListDataInner {
    /**
     * The unique identifier for the client’s investment account
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'accountId': string;
    /**
     * 
     * @type {ActionTag}
     * @memberof GetTransfersListDataInner
     */
    'actionTag'?: ActionTag;
    /**
     * The amount that the investor is contributing to their investment account
     * @type {number}
     * @memberof GetTransfersListDataInner
     */
    'amount'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerAuditDetails}
     * @memberof GetTransfersListDataInner
     */
    'auditDetails'?: GetIllustrationsListDataInnerAuditDetails;
    /**
     * Applies to cash transfers with movement type \'in\'
     * @type {boolean}
     * @memberof GetTransfersListDataInner
     */
    'autoInvest'?: boolean;
    /**
     * Type of manual signature required for the transfer
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'signatureType'?: GetTransfersListDataInnerSignatureTypeEnum;
    /**
     * Is this a manual transfer
     * @type {boolean}
     * @memberof GetTransfersListDataInner
     */
    'isManual'?: boolean;
    /**
     * The date and time the transaction was instructed
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'createdDate': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'firmId': string;
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'id': string;
    /**
     * Indicates whether the transaction is a pension transfer
     * @type {boolean}
     * @memberof GetTransfersListDataInner
     */
    'isPensionTransfer'?: boolean;
    /**
     * The unique identifier that is contained in all the transactions within that portfolio transaction group
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'linkId': string;
    /**
     * The unique identifier of the node attached to the client
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'nodeId': string;
    /**
     * 
     * @type {TransferMovementType}
     * @memberof GetTransfersListDataInner
     */
    'movementType': TransferMovementType;
    /**
     * The unique code for the ceding provider as stored in Seccl\'s system
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'previousProvider'?: string;
    /**
     * The account reference of the account held by the ceding provider
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'previousProviderRef'?: string;
    /**
     * The name of the ceding provider
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'previousProviderName'?: string;
    /**
     * 
     * @type {PreviousProviderAccountType}
     * @memberof GetTransfersListDataInner
     */
    'previousProviderAccountType'?: PreviousProviderAccountType;
    /**
     * The ID of another product transfer that can be used to link previously failed transfers together
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'previousTransferId'?: string;
    /**
     * The account id of the account held by the receiving provider
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'receivingProvider'?: string;
    /**
     * The account reference of the account held by the receiving provider
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'receivingProviderRef'?: string;
    /**
     * The name of the receiving provider
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'receivingProviderName'?: string;
    /**
     * 
     * @type {TransferStatus}
     * @memberof GetTransfersListDataInner
     */
    'status': TransferStatus;
    /**
     * Contains an object to detail the change in statuses of the transaction
     * @type {Array<TransferStatusChange>}
     * @memberof GetTransfersListDataInner
     */
    'statusChanges'?: Array<TransferStatusChange>;
    /**
     * The date the payment transaction was instructed
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'transactionDate': string;
    /**
     * The type of transaction (Product Transfer, Payment)
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'transactionType': string;
    /**
     * The subtype of transaction (In Specie, Cash)
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'transactionSubType': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof GetTransfersListDataInner
     */
    'transferAccountAddress'?: AddressDetail;
    /**
     * 
     * @type {TransferStatus}
     * @memberof GetTransfersListDataInner
     */
    'transferStatus'?: TransferStatus;
    /**
     * 
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'transferSystem'?: string;
    /**
     * The estimated value of the transfer as entered by the user instructing it
     * @type {number}
     * @memberof GetTransfersListDataInner
     */
    'transferValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'rejectionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'rejectionNote'?: string;
    /**
     * Unique hash for previous change
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'updateId': string;
    /**
     * 
     * @type {WrapperType}
     * @memberof GetTransfersListDataInner
     */
    'wrapperType': WrapperType;
    /**
     * The name of the client
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'clientName': string;
    /**
     * The unique identifier of the client
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'clientId': string;
    /**
     * Indicates whether book costs need to be added This will have a value of true when there are anyStock Transfers In (either transactionSubTypeExternal or Migration) linked to the Product Transfer by a linkId, that meet both of the following criteria: The bookValue is 0.00 The autoSetBookValue is either false or null In all other scenarios this will have a value of false 
     * @type {boolean}
     * @memberof GetTransfersListDataInner
     */
    'actionRequired': boolean;
    /**
     * The estimated value based on the valuation provided by the ceding provider
     * @type {number}
     * @memberof GetTransfersListDataInner
     */
    'estimatedValue': number;
    /**
     * 
     * @type {AutoDisinvest}
     * @memberof GetTransfersListDataInner
     */
    'autoDisinvest'?: AutoDisinvest;
    /**
     * The FCA refence number for the transfer
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'fcaReference'?: string;
    /**
     * The estimated value of the transfer
     * @type {number}
     * @memberof GetTransfersListDataInner
     */
    'amountToTake'?: number;
    /**
     * The remaining balance at the ceding scheme after the transfer has completed
     * @type {number}
     * @memberof GetTransfersListDataInner
     */
    'amountToLeave'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'primaryClientId'?: string;
    /**
     * The unique identifier for the attached file upload
     * @type {string}
     * @memberof GetTransfersListDataInner
     */
    'uploadedFileDetailsId'?: string;
    /**
     * 
     * @type {TransferTransactionTransferFee}
     * @memberof GetTransfersListDataInner
     */
    'transferFee'?: TransferTransactionTransferFee;
    /**
     * 
     * @type {PayUkDetails}
     * @memberof GetTransfersListDataInner
     */
    'payUkDetails'?: PayUkDetails;
    /**
     * 
     * @type {SubscriptionYearType}
     * @memberof GetTransfersListDataInner
     */
    'subscriptionAppliesTo'?: SubscriptionYearType;
}

/**
    * @export
    * @enum {string}
    */
export enum GetTransfersListDataInnerSignatureTypeEnum {
    Scanned = 'Scanned',
    Electronic = 'Electronic',
    Wet = 'Wet'
}

/**
 * 
 * @export
 * @interface GetUnreadMessageCount
 */
export interface GetUnreadMessageCount {
    /**
     * 
     * @type {GetUnreadMessageCountData}
     * @memberof GetUnreadMessageCount
     */
    'data'?: GetUnreadMessageCountData;
}
/**
 * 
 * @export
 * @interface GetUnreadMessageCountData
 */
export interface GetUnreadMessageCountData {
    /**
     * Number of un read messages for a firm
     * @type {number}
     * @memberof GetUnreadMessageCountData
     */
    'unreadMessageCount'?: number;
}
/**
 * 
 * @export
 * @interface GetUser
 */
export interface GetUser {
    /**
     * 
     * @type {User}
     * @memberof GetUser
     */
    'data'?: User;
}
/**
 * 
 * @export
 * @interface GetUserList
 */
export interface GetUserList {
    /**
     * List of users
     * @type {Array<User>}
     * @memberof GetUserList
     */
    'data'?: Array<User>;
}
/**
 * 
 * @export
 * @interface GrowthFields
 */
export interface GrowthFields {
    /**
     * The on platform growth value of an investment (the growth since arrival on the platform) 
     * @type {number}
     * @memberof GrowthFields
     */
    'adjustedGrowth'?: number;
    /**
     * The percentage adjusted growth at the current record level
     * @type {number}
     * @memberof GrowthFields
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The growth value since the book cost at the current record level
     * @type {number}
     * @memberof GrowthFields
     */
    'growth'?: number;
    /**
     * The percentage growth since the book cost at the current record level
     * @type {number}
     * @memberof GrowthFields
     */
    'growthPercent'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum HostnameType {
    Investor = 'Investor',
    Professional = 'Professional'
}


/**
 * 
 * @export
 * @interface HtmlWithSource
 */
export interface HtmlWithSource {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof HtmlWithSource
     */
    'sourceNodeId': string;
    /**
     * The html value.
     * @type {string}
     * @memberof HtmlWithSource
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface HtmlWithSourceAllOf
 */
export interface HtmlWithSourceAllOf {
    /**
     * The html value.
     * @type {string}
     * @memberof HtmlWithSourceAllOf
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface IllustrationDownload
 */
export interface IllustrationDownload {
    /**
     * 
     * @type {IllustrationDownloadData}
     * @memberof IllustrationDownload
     */
    'data'?: IllustrationDownloadData;
}
/**
 * 
 * @export
 * @interface IllustrationDownloadData
 */
export interface IllustrationDownloadData {
    /**
     * The unique identifier of the illustration
     * @type {string}
     * @memberof IllustrationDownloadData
     */
    'id'?: string;
    /**
     * The url of the illustration
     * @type {string}
     * @memberof IllustrationDownloadData
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface IllustrationProduct
 */
export interface IllustrationProduct {
    /**
     * 
     * @type {IllustrationProductData}
     * @memberof IllustrationProduct
     */
    'data'?: IllustrationProductData;
}
/**
 * 
 * @export
 * @interface IllustrationProductData
 */
export interface IllustrationProductData {
    /**
     * The unique identifier of the client
     * @type {string}
     * @memberof IllustrationProductData
     */
    'clientId'?: string;
    /**
     * The unique identifier of your platform
     * @type {string}
     * @memberof IllustrationProductData
     */
    'firmId'?: string;
    /**
     * The unique identifier of the illustration
     * @type {string}
     * @memberof IllustrationProductData
     */
    'id'?: string;
    /**
     * The status of the illustration
     * @type {string}
     * @memberof IllustrationProductData
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface IndividualClient
 */
export interface IndividualClient {
    /**
     * 
     * @type {string}
     * @memberof IndividualClient
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof IndividualClient
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof IndividualClient
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IndividualClient
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof IndividualClient
     */
    'status': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof IndividualClient
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof IndividualClient
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof IndividualClient
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof IndividualClient
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof IndividualClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof IndividualClient
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof IndividualClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof IndividualClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof IndividualClient
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof IndividualClient
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof IndividualClient
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof IndividualClient
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof IndividualClient
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof IndividualClient
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof IndividualClient
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof IndividualClient
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof IndividualClient
     */
    'phone'?: Telephone;
    /**
     * The age the client is expected to retire
     * @type {number}
     * @memberof IndividualClient
     */
    'retirementAge'?: number;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof IndividualClient
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof IndividualClient
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof IndividualClient
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof IndividualClient
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * The client\'s foreign (non-UK) tax residencies. Each entry either provides a tax identification number (TIN) or a reason why one is not available.
     * @type {Array<ForeignTaxResidency>}
     * @memberof IndividualClient
     */
    'foreignTaxResidencies'?: Array<ForeignTaxResidency>;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof IndividualClient
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof IndividualClient
     */
    'dateOfBirth'?: string;
    /**
     * Contains details of the client\'s employer – only required where the client is making employer payments to their pension
     * @type {Array<EmployersInner>}
     * @memberof IndividualClient
     */
    'employers'?: Array<EmployersInner>;
    /**
     * 
     * @type {EmploymentStatus}
     * @memberof IndividualClient
     */
    'employmentStatus'?: EmploymentStatus;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof IndividualClient
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof IndividualClient
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof IndividualClient
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof IndividualClient
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof IndividualClient
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof IndividualClient
     */
    'kycData'?: ClientKycData;
    /**
     * 
     * @type {ClientMigration}
     * @memberof IndividualClient
     */
    'migration'?: ClientMigration;
}


/**
 * 
 * @export
 * @interface IndividualClientSpecifics
 */
export interface IndividualClientSpecifics {
    /**
     * 
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'clientType'?: string;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof IndividualClientSpecifics
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'currency'?: string;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof IndividualClientSpecifics
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof IndividualClientSpecifics
     */
    'phone'?: Telephone;
    /**
     * The age the client is expected to retire
     * @type {number}
     * @memberof IndividualClientSpecifics
     */
    'retirementAge'?: number;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof IndividualClientSpecifics
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof IndividualClientSpecifics
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * The client\'s foreign (non-UK) tax residencies. Each entry either provides a tax identification number (TIN) or a reason why one is not available.
     * @type {Array<ForeignTaxResidency>}
     * @memberof IndividualClientSpecifics
     */
    'foreignTaxResidencies'?: Array<ForeignTaxResidency>;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof IndividualClientSpecifics
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof IndividualClientSpecifics
     */
    'dateOfBirth'?: string;
    /**
     * Contains details of the client\'s employer – only required where the client is making employer payments to their pension
     * @type {Array<EmployersInner>}
     * @memberof IndividualClientSpecifics
     */
    'employers'?: Array<EmployersInner>;
    /**
     * 
     * @type {EmploymentStatus}
     * @memberof IndividualClientSpecifics
     */
    'employmentStatus'?: EmploymentStatus;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof IndividualClientSpecifics
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof IndividualClientSpecifics
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof IndividualClientSpecifics
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof IndividualClientSpecifics
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof IndividualClientSpecifics
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof IndividualClientSpecifics
     */
    'kycData'?: ClientKycData;
    /**
     * 
     * @type {ClientMigration}
     * @memberof IndividualClientSpecifics
     */
    'migration'?: ClientMigration;
}


/**
 * 
 * @export
 * @interface IndividualMinorClient
 */
export interface IndividualMinorClient {
    /**
     * 
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof IndividualMinorClient
     */
    'nodeId'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'status': string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof IndividualMinorClient
     */
    'addressDetail': AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof IndividualMinorClient
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof IndividualMinorClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof IndividualMinorClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof IndividualMinorClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The parent client ID for the child client being created
     * @type {Array<string>}
     * @memberof IndividualMinorClient
     */
    'parentId'?: Array<string>;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof IndividualMinorClient
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof IndividualMinorClient
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof IndividualMinorClient
     */
    'phone'?: Telephone;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof IndividualMinorClient
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof IndividualMinorClient
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof IndividualMinorClient
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof IndividualMinorClient
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof IndividualMinorClient
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof IndividualMinorClient
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof IndividualMinorClient
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof IndividualMinorClient
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof IndividualMinorClient
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof IndividualMinorClient
     */
    'kycData'?: ClientKycData;
}


/**
 * 
 * @export
 * @interface IndividualMinorSpecific
 */
export interface IndividualMinorSpecific {
    /**
     * 
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'clientType'?: string;
    /**
     * The parent client ID for the child client being created
     * @type {Array<string>}
     * @memberof IndividualMinorSpecific
     */
    'parentId'?: Array<string>;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'firstName'?: string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'surname'?: string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof IndividualMinorSpecific
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'currency'?: string;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof IndividualMinorSpecific
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof IndividualMinorSpecific
     */
    'phone'?: Telephone;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<ClientNationalitiesInner>}
     * @memberof IndividualMinorSpecific
     */
    'nationalities'?: Array<ClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof IndividualMinorSpecific
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof IndividualMinorSpecific
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in the format YYYY-MM-DD
     * @type {string}
     * @memberof IndividualMinorSpecific
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {ClientAmlData}
     * @memberof IndividualMinorSpecific
     */
    'amlData'?: ClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof IndividualMinorSpecific
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof IndividualMinorSpecific
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof IndividualMinorSpecific
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof IndividualMinorSpecific
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof IndividualMinorSpecific
     */
    'kycData'?: ClientKycData;
}


/**
 * An object capturing all the national identifier information for the DFM - both the firm and the firm user. All fields are mandatory.
 * @export
 * @interface InvestmentDecision
 */
export interface InvestmentDecision {
    /**
     * A 20-digit numerical identifier assigned to a DFM
     * @type {string}
     * @memberof InvestmentDecision
     */
    'firmLei': string;
    /**
     * A two-letter country code denoting the firm\'s location
     * @type {string}
     * @memberof InvestmentDecision
     */
    'firmCountry': string;
    /**
     * The National Identifier for the firm user/decision maker. For 1 nationals this is in the format XX123456X
     * @type {string}
     * @memberof InvestmentDecision
     */
    'personId': string;
    /**
     * 
     * @type {PersonalIdentifierType}
     * @memberof InvestmentDecision
     */
    'personIdType': PersonalIdentifierType;
    /**
     * A two-letter country code denoting the firm user/decision maker\'s location
     * @type {string}
     * @memberof InvestmentDecision
     */
    'personCountry': string;
}


/**
 * 
 * @export
 * @interface InvestorConfiguration
 */
export interface InvestorConfiguration {
    /**
     * 
     * @type {InvestorConfigurationAllowClientToCreateAccount}
     * @memberof InvestorConfiguration
     */
    'allowClientToCreateAccount': InvestorConfigurationAllowClientToCreateAccount;
    /**
     * 
     * @type {InvestorConfigurationAllowClientToUpdateBankDetails}
     * @memberof InvestorConfiguration
     */
    'allowClientToUpdateBankDetails': InvestorConfigurationAllowClientToUpdateBankDetails;
    /**
     * 
     * @type {InvestorConfigurationRequireClientToProvideBankDetails}
     * @memberof InvestorConfiguration
     */
    'requireClientToProvideBankDetails': InvestorConfigurationRequireClientToProvideBankDetails;
    /**
     * 
     * @type {InvestorConfigurationWindowTitle}
     * @memberof InvestorConfiguration
     */
    'windowTitle': InvestorConfigurationWindowTitle;
}
/**
 * True if the client can create an account
 * @export
 * @interface InvestorConfigurationAllowClientToCreateAccount
 */
export interface InvestorConfigurationAllowClientToCreateAccount {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorConfigurationAllowClientToCreateAccount
     */
    'sourceNodeId': string;
    /**
     * The property flag value.
     * @type {boolean}
     * @memberof InvestorConfigurationAllowClientToCreateAccount
     */
    'value': boolean;
}
/**
 * True if the client can update bank details
 * @export
 * @interface InvestorConfigurationAllowClientToUpdateBankDetails
 */
export interface InvestorConfigurationAllowClientToUpdateBankDetails {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorConfigurationAllowClientToUpdateBankDetails
     */
    'sourceNodeId': string;
    /**
     * The property flag value.
     * @type {boolean}
     * @memberof InvestorConfigurationAllowClientToUpdateBankDetails
     */
    'value': boolean;
}
/**
 * True if the client must provide bank details before accepting terms and conditions
 * @export
 * @interface InvestorConfigurationRequireClientToProvideBankDetails
 */
export interface InvestorConfigurationRequireClientToProvideBankDetails {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorConfigurationRequireClientToProvideBankDetails
     */
    'sourceNodeId': string;
    /**
     * The property flag value.
     * @type {boolean}
     * @memberof InvestorConfigurationRequireClientToProvideBankDetails
     */
    'value': boolean;
}
/**
 * The page title for the Investor UI
 * @export
 * @interface InvestorConfigurationWindowTitle
 */
export interface InvestorConfigurationWindowTitle {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorConfigurationWindowTitle
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof InvestorConfigurationWindowTitle
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface InvestorContent
 */
export interface InvestorContent {
    /**
     * 
     * @type {InvestorContentClientRegOffice}
     * @memberof InvestorContent
     */
    'clientRegOffice'?: InvestorContentClientRegOffice;
    /**
     * 
     * @type {ProfessionalContentOrderUrl}
     * @memberof InvestorContent
     */
    'orderUrl'?: ProfessionalContentOrderUrl;
    /**
     * 
     * @type {InvestorContentPensionKfdUrl}
     * @memberof InvestorContent
     */
    'pensionKfdUrl'?: InvestorContentPensionKfdUrl;
    /**
     * 
     * @type {InvestorContentIsaKfdUrl}
     * @memberof InvestorContent
     */
    'isaKfdUrl'?: InvestorContentIsaKfdUrl;
    /**
     * 
     * @type {InvestorContentJisaKfdUrl}
     * @memberof InvestorContent
     */
    'jisaKfdUrl'?: InvestorContentJisaKfdUrl;
    /**
     * 
     * @type {InvestorContentFaqUrl}
     * @memberof InvestorContent
     */
    'faqUrl'?: InvestorContentFaqUrl;
    /**
     * 
     * @type {InvestorContentFeesUrl}
     * @memberof InvestorContent
     */
    'feesUrl'?: InvestorContentFeesUrl;
    /**
     * 
     * @type {InvestorContentPrivacyPolicyUrl}
     * @memberof InvestorContent
     */
    'privacyPolicyUrl'?: InvestorContentPrivacyPolicyUrl;
    /**
     * 
     * @type {InvestorContentTermsUrl}
     * @memberof InvestorContent
     */
    'termsUrl'?: InvestorContentTermsUrl;
    /**
     * 
     * @type {InvestorContentClientFcaNotice}
     * @memberof InvestorContent
     */
    'clientFcaNotice'?: InvestorContentClientFcaNotice;
}
/**
 * the FCA notice
 * @export
 * @interface InvestorContentClientFcaNotice
 */
export interface InvestorContentClientFcaNotice {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentClientFcaNotice
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof InvestorContentClientFcaNotice
     */
    'value': string;
}
/**
 * The firm\'s registered office address.
 * @export
 * @interface InvestorContentClientRegOffice
 */
export interface InvestorContentClientRegOffice {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentClientRegOffice
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof InvestorContentClientRegOffice
     */
    'value': string;
}
/**
 * the URL for FAQ
 * @export
 * @interface InvestorContentFaqUrl
 */
export interface InvestorContentFaqUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentFaqUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof InvestorContentFaqUrl
     */
    'value': string;
}
/**
 * the URL for fees
 * @export
 * @interface InvestorContentFeesUrl
 */
export interface InvestorContentFeesUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentFeesUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof InvestorContentFeesUrl
     */
    'value': string;
}
/**
 * the URL for ISA KFD
 * @export
 * @interface InvestorContentIsaKfdUrl
 */
export interface InvestorContentIsaKfdUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentIsaKfdUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof InvestorContentIsaKfdUrl
     */
    'value': string;
}
/**
 * the URL for JISA KFD
 * @export
 * @interface InvestorContentJisaKfdUrl
 */
export interface InvestorContentJisaKfdUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentJisaKfdUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof InvestorContentJisaKfdUrl
     */
    'value': string;
}
/**
 * The URL for pension KFD
 * @export
 * @interface InvestorContentPensionKfdUrl
 */
export interface InvestorContentPensionKfdUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentPensionKfdUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof InvestorContentPensionKfdUrl
     */
    'value': string;
}
/**
 * the URL for the privacy policy
 * @export
 * @interface InvestorContentPrivacyPolicyUrl
 */
export interface InvestorContentPrivacyPolicyUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentPrivacyPolicyUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof InvestorContentPrivacyPolicyUrl
     */
    'value': string;
}
/**
 * the URL for the terms and conditions
 * @export
 * @interface InvestorContentTermsUrl
 */
export interface InvestorContentTermsUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorContentTermsUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof InvestorContentTermsUrl
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface InvestorTheme
 */
export interface InvestorTheme {
    /**
     * 
     * @type {InvestorThemePrimaryColour}
     * @memberof InvestorTheme
     */
    'primaryColour': InvestorThemePrimaryColour;
    /**
     * 
     * @type {InvestorThemeBackgroundPrimaryColour}
     * @memberof InvestorTheme
     */
    'backgroundPrimaryColour': InvestorThemeBackgroundPrimaryColour;
    /**
     * 
     * @type {InvestorThemeBackgroundSecondaryColour}
     * @memberof InvestorTheme
     */
    'backgroundSecondaryColour': InvestorThemeBackgroundSecondaryColour;
    /**
     * 
     * @type {InvestorThemeFooterBackgroundPrimaryColour}
     * @memberof InvestorTheme
     */
    'footerBackgroundPrimaryColour': InvestorThemeFooterBackgroundPrimaryColour;
    /**
     * 
     * @type {InvestorThemeFooterBackgroundSecondaryColour}
     * @memberof InvestorTheme
     */
    'footerBackgroundSecondaryColour': InvestorThemeFooterBackgroundSecondaryColour;
}
/**
 * The hexcode representation of the primary background colour gradient (left side) for the Investor UI.
 * @export
 * @interface InvestorThemeBackgroundPrimaryColour
 */
export interface InvestorThemeBackgroundPrimaryColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorThemeBackgroundPrimaryColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof InvestorThemeBackgroundPrimaryColour
     */
    'value': string;
}
/**
 * The hexcode representation of the secondary background colour gradient (right side) for the Investor UI.
 * @export
 * @interface InvestorThemeBackgroundSecondaryColour
 */
export interface InvestorThemeBackgroundSecondaryColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorThemeBackgroundSecondaryColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof InvestorThemeBackgroundSecondaryColour
     */
    'value': string;
}
/**
 * The hexcode representation of the background primary colour for the footer in the Investor UI.
 * @export
 * @interface InvestorThemeFooterBackgroundPrimaryColour
 */
export interface InvestorThemeFooterBackgroundPrimaryColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorThemeFooterBackgroundPrimaryColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof InvestorThemeFooterBackgroundPrimaryColour
     */
    'value': string;
}
/**
 * The hexcode representation of the background secondary colour for the footer in the Investor UI.
 * @export
 * @interface InvestorThemeFooterBackgroundSecondaryColour
 */
export interface InvestorThemeFooterBackgroundSecondaryColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorThemeFooterBackgroundSecondaryColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof InvestorThemeFooterBackgroundSecondaryColour
     */
    'value': string;
}
/**
 * The hexcode representation of the primary colour for the Investor UI.
 * @export
 * @interface InvestorThemePrimaryColour
 */
export interface InvestorThemePrimaryColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof InvestorThemePrimaryColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof InvestorThemePrimaryColour
     */
    'value': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum LTAEnhancementFactorType {
    NonResidenceFactor = 'Non-Residence Factor',
    RecognisedOverseasSchemeTransfer = 'Recognised Overseas Scheme Transfer',
    PensionCredit = 'Pension Credit'
}


/**
 * 
 * @export
 * @interface LiveAccountSummaryAuditDetails
 */
export interface LiveAccountSummaryAuditDetails {
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryAuditDetails
     */
    'application'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryAuditDetails
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryAuditDetails
     */
    'userFirmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryAuditDetails
     */
    'userId'?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveAccountSummaryAuditDetails
     */
    'version'?: number;
}
/**
 * 
 * @export
 * @interface LiveAccountSummaryData
 */
export interface LiveAccountSummaryData {
    /**
     * The unique identifier of the investment account
     * @type {string}
     * @memberof LiveAccountSummaryData
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof LiveAccountSummaryData
     */
    'firmId'?: string;
    /**
     * The unique node identifier that the account is attached to
     * @type {string}
     * @memberof LiveAccountSummaryData
     */
    'nodeId'?: string;
    /**
     * The name of the account
     * @type {string}
     * @memberof LiveAccountSummaryData
     */
    'name'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof LiveAccountSummaryData
     */
    'currency'?: string;
    /**
     * The type of account
     * @type {string}
     * @memberof LiveAccountSummaryData
     */
    'accountType'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof LiveAccountSummaryData
     */
    'wrapperType'?: WrapperType;
    /**
     * 
     * @type {LiveAccountSummaryDataWrapperDetail}
     * @memberof LiveAccountSummaryData
     */
    'wrapperDetail'?: LiveAccountSummaryDataWrapperDetail;
    /**
     * 
     * @type {boolean}
     * @memberof LiveAccountSummaryData
     */
    'recurringPayment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryData
     */
    'status'?: string;
    /**
     * The unique identifier of the client
     * @type {string}
     * @memberof LiveAccountSummaryData
     */
    'clientId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveAccountSummaryData
     */
    'clientNames'?: Array<string>;
    /**
     * 
     * @type {Array<LiveAccountSummaryPosition>}
     * @memberof LiveAccountSummaryData
     */
    'positions'?: Array<LiveAccountSummaryPosition>;
    /**
     * 
     * @type {Array<object>}
     * @memberof LiveAccountSummaryData
     */
    'completeTransactions'?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof LiveAccountSummaryData
     */
    'currentValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveAccountSummaryData
     */
    'uninvestedCash'?: number;
    /**
     * 
     * @type {LiveAccountSummaryPendingDeposits}
     * @memberof LiveAccountSummaryData
     */
    'pendingDeposits'?: LiveAccountSummaryPendingDeposits;
    /**
     * The amount of settled, non-ringfenced cash currently available to withdraw
     * @type {number}
     * @memberof LiveAccountSummaryData
     */
    'withdrawableCash'?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof LiveAccountSummaryData
     */
    'unsettledSells'?: Array<object>;
    /**
     * 
     * @type {LiveAccountSummaryRingfencedCashBreakdown}
     * @memberof LiveAccountSummaryData
     */
    'ringfencedCashBreakdown'?: LiveAccountSummaryRingfencedCashBreakdown;
}


/**
 * 
 * @export
 * @interface LiveAccountSummaryDataWrapperDetail
 */
export interface LiveAccountSummaryDataWrapperDetail {
    /**
     * 
     * @type {WrapperType}
     * @memberof LiveAccountSummaryDataWrapperDetail
     */
    'wrapperType'?: WrapperType;
    /**
     * 
     * @type {boolean}
     * @memberof LiveAccountSummaryDataWrapperDetail
     */
    'discretionary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveAccountSummaryDataWrapperDetail
     */
    'advised'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveAccountSummaryDataWrapperDetail
     */
    'trust'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryDataWrapperDetail
     */
    'clientProductId'?: string;
}


/**
 * 
 * @export
 * @interface LiveAccountSummaryPendingDeposits
 */
export interface LiveAccountSummaryPendingDeposits {
    /**
     * 
     * @type {number}
     * @memberof LiveAccountSummaryPendingDeposits
     */
    'amount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveAccountSummaryPendingDeposits
     */
    'transactionIds'?: Array<string>;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof LiveAccountSummaryPendingDeposits
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface LiveAccountSummaryPosition
 */
export interface LiveAccountSummaryPosition {
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'accountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'accountType'?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveAccountSummaryPosition
     */
    'amount'?: number;
    /**
     * 
     * @type {LiveAccountSummaryAuditDetails}
     * @memberof LiveAccountSummaryPosition
     */
    'auditDetails'?: LiveAccountSummaryAuditDetails;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'currency'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'nodeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'positionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'updateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveAccountSummaryPosition
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveAccountSummaryPosition
     */
    'currentValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveAccountSummaryPosition
     */
    'withdrawableCash'?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof LiveAccountSummaryPosition
     */
    'ringfenceContributions'?: Array<object>;
}
/**
 * 
 * @export
 * @interface LiveAccountSummaryRingfencedCashBreakdown
 */
export interface LiveAccountSummaryRingfencedCashBreakdown {
    /**
     * 
     * @type {Array<object>}
     * @memberof LiveAccountSummaryRingfencedCashBreakdown
     */
    'contributions'?: Array<object>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum MaritalStatus {
    Single = 'Single',
    Married = 'Married',
    Divorced = 'Divorced',
    Widowed = 'Widowed'
}


/**
 * 
 * @export
 * @interface MasterAsset
 */
export interface MasterAsset {
    /**
     * The unique identifier of the asset
     * @type {string}
     * @memberof MasterAsset
     */
    'id': string;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAsset
     */
    'firmId': string;
    /**
     * The short name of the asset
     * @type {string}
     * @memberof MasterAsset
     */
    'shortName'?: string;
    /**
     * The long name of the asset
     * @type {string}
     * @memberof MasterAsset
     */
    'longName'?: string;
    /**
     * The description of the asset
     * @type {string}
     * @memberof MasterAsset
     */
    'description'?: string;
    /**
     * The type of instrument
     * @type {string}
     * @memberof MasterAsset
     */
    'instrumentType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAsset
     */
    'isin'?: string;
    /**
     * The Market Identifier Code (MIC), which is an international indicator that identifies security trading exchanges
     * @type {string}
     * @memberof MasterAsset
     */
    'mic'?: string;
    /**
     * Report transactions and price data for a Security using a ticker symbol
     * @type {string}
     * @memberof MasterAsset
     */
    'ticker'?: string;
    /**
     * This indicates whether the mic is the market where the asset was created and first issued
     * @type {boolean}
     * @memberof MasterAsset
     */
    'primaryMarket'?: boolean;
    /**
     * The currency the asset trades in
     * @type {string}
     * @memberof MasterAsset
     */
    'currency'?: string;
    /**
     * The country where the asset was first issued
     * @type {string}
     * @memberof MasterAsset
     */
    'countryOfIssue'?: string;
    /**
     * The country where the asset was incorporated
     * @type {string}
     * @memberof MasterAsset
     */
    'countryOfIncorporation'?: string;
    /**
     * Date of issue
     * @type {string}
     * @memberof MasterAsset
     */
    'issueDate'?: string;
    /**
     * The status of the asset. They are the following
     * @type {string}
     * @memberof MasterAsset
     */
    'status'?: string;
    /**
     * 
     * @type {MasterAssetCurrentPrice}
     * @memberof MasterAsset
     */
    'currentPrice'?: MasterAssetCurrentPrice;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAsset
     */
    'defaultDepot'?: string;
    /**
     * This indicates the number of units for the quote, or price. For example, if the asset is £10 and the quoteUnit is 1, then £10 is the quote for a single unit; if the asset is £100 and the quoteUnit is 100, then £100 is the quote for 100 units
     * @type {number}
     * @memberof MasterAsset
     */
    'quoteUnit'?: number;
    /**
     * The number of decimal places that the asset can be held. For example, 0.0001 means the asset can be held to 4 decimal places. This is driven by the fund manager or instrument type
     * @type {number}
     * @memberof MasterAsset
     */
    'minimumTransferUnit'?: number;
    /**
     * The number of days the asset takes to settle upon order execution
     * @type {number}
     * @memberof MasterAsset
     */
    'settlementPeriod'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAsset
     */
    'incomeCurrency'?: string;
    /**
     * TBD
     * @type {Array<MasterAssetClassificationsInner>}
     * @memberof MasterAsset
     */
    'classifications'?: Array<MasterAssetClassificationsInner>;
    /**
     * 
     * @type {MasterAssetFundDetail}
     * @memberof MasterAsset
     */
    'fundDetail'?: MasterAssetFundDetail;
    /**
     * 
     * @type {AssetAuditDetails}
     * @memberof MasterAsset
     */
    'auditDetails'?: AssetAuditDetails;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAsset
     */
    'updateId'?: string;
    /**
     * Custom Identifier for Asset
     * @type {string}
     * @memberof MasterAsset
     */
    'customName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAsset
     */
    'executionMethod'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAsset
     */
    'defaultSettlementCurrency'?: string;
    /**
     * Estimated percentage OCF
     * @type {number}
     * @memberof MasterAsset
     */
    'ocfEstimated'?: number;
    /**
     * Link to KIID document
     * @type {string}
     * @memberof MasterAsset
     */
    'kiidDocumentUrl'?: string;
    /**
     * true if the instrument is restricted to SECCL
     * @type {boolean}
     * @memberof MasterAsset
     */
    'firmAccessProhibited'?: boolean;
}
/**
 * 
 * @export
 * @interface MasterAssetClassificationsInner
 */
export interface MasterAssetClassificationsInner {
    /**
     * TBD
     * @type {string}
     * @memberof MasterAssetClassificationsInner
     */
    'classificationType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAssetClassificationsInner
     */
    'value'?: string;
}
/**
 * An array capturing the latest price of the asset in the system
 * @export
 * @interface MasterAssetCurrentPrice
 */
export interface MasterAssetCurrentPrice {
    /**
     * The date the of the latest price value in Seccl\'s system
     * @type {string}
     * @memberof MasterAssetCurrentPrice
     */
    'priceDate'?: string;
    /**
     * The maximum that a buyer is willing to pay for the asset
     * @type {number}
     * @memberof MasterAssetCurrentPrice
     */
    'bid'?: number;
    /**
     * The minimum that a seller is willing to pay for the asset
     * @type {number}
     * @memberof MasterAssetCurrentPrice
     */
    'ask'?: number;
    /**
     * The midpoint of the bid and ask prices
     * @type {number}
     * @memberof MasterAssetCurrentPrice
     */
    'mid'?: number;
}
/**
 * An array capturing details of the fund
 * @export
 * @interface MasterAssetFundDetail
 */
export interface MasterAssetFundDetail {
    /**
     * TBD
     * @type {string}
     * @memberof MasterAssetFundDetail
     */
    'citiCode'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof MasterAssetFundDetail
     */
    'mexId'?: string;
}
/**
 * The type of message
 * @export
 * @enum {string}
 */

export enum MessageType {
    AccountUpdate = 'ACCOUNT_UPDATE',
    AdvanceDirectDebitMandateConfirmation = 'ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION',
    AdvanceDirectDebitMandateNotice = 'ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE',
    AmlResendData = 'AML_RESEND_DATA',
    BenefitCrystallisationEventStatement = 'BENEFIT_CRYSTALLISATION_EVENT_STATEMENT',
    ChangePassword = 'CHANGE_PASSWORD',
    ClientUpdate = 'CLIENT_UPDATE',
    ContractNote = 'CONTRACT_NOTE',
    GaudiComms = 'GAUDI_COMMS',
    NewAccount = 'NEW_ACCOUNT',
    NewAccountReplay = 'NEW_ACCOUNT_REPLAY',
    PensionCancellationLetter = 'PENSION_CANCELLATION_LETTER',
    PensionPayslipNotification = 'PENSION_PAYSLIP_NOTIFICATION',
    PensionSavingsStatement = 'PENSION_SAVINGS_STATEMENT',
    PensionTransferCancellationLetter = 'PENSION_TRANSFER_CANCELLATION_LETTER',
    QuarterlyStatement = 'QUARTERLY_STATEMENT',
    RetirementPack = 'RETIREMENT_PACK',
    TaxStatement = 'TAX_STATEMENT',
    ValuationStatement = 'VALUATION_STATEMENT',
    Withdrawal = 'WITHDRAWAL',
    FlexiAccessNotification = 'FLEXI_ACCESS_NOTIFICATION',
    SmpiAnnualStatement = 'SMPI_ANNUAL_STATEMENT',
    TaxPack = 'TAX_PACK'
}


/**
 * 
 * @export
 * @interface ModelPost201Response
 */
export interface ModelPost201Response {
    /**
     * 
     * @type {ModelPost201ResponseData}
     * @memberof ModelPost201Response
     */
    'data': ModelPost201ResponseData;
}
/**
 * 
 * @export
 * @interface ModelPost201ResponseData
 */
export interface ModelPost201ResponseData {
    /**
     * The unique ID of the model
     * @type {string}
     * @memberof ModelPost201ResponseData
     */
    'id': string;
    /**
     * The url of te model
     * @type {string}
     * @memberof ModelPost201ResponseData
     */
    'url'?: string;
}
/**
 * The type of model
 * @export
 * @enum {string}
 */

export enum ModelType {
    Advisory = 'Advisory',
    Discretionary = 'Discretionary'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum MovementType {
    In = 'In',
    Out = 'Out',
    Buy = 'Buy',
    Sell = 'Sell',
    Invest = 'Invest',
    Raise = 'Raise',
    Net = 'Net',
    Credit = 'Credit',
    Debit = 'Debit',
    Cash = 'Cash'
}


/**
 * 
 * @export
 * @interface NextPaymentDateResponse
 */
export interface NextPaymentDateResponse {
    /**
     * 
     * @type {NextPaymentDateResponseData}
     * @memberof NextPaymentDateResponse
     */
    'data'?: NextPaymentDateResponseData;
}
/**
 * 
 * @export
 * @interface NextPaymentDateResponseData
 */
export interface NextPaymentDateResponseData {
    /**
     * ISO date-time of the earliest date the recurring payment on the chosen day of month can be paid.
     * @type {string}
     * @memberof NextPaymentDateResponseData
     */
    'nextPaymentDate': string;
}
/**
 * 
 * @export
 * @interface Node
 */
export interface Node {
    /**
     * The unique identifier for the node
     * @type {string}
     * @memberof Node
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof Node
     */
    'firmId': string;
    /**
     * TBD
     * @type {string}
     * @memberof Node
     */
    'name'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof Node
     */
    'parentNodeId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof Node
     */
    'nodeType'?: NodeNodeTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum NodeNodeTypeEnum {
    Default = 'Default',
    BusinessStream = 'Business Stream',
    ClientFirm = 'Client Firm',
    ClientBank = 'Client Bank'
}

/**
 * Returned when a node switch request fails validation (HTTP 422). The `errors` array lists the specific reasons the switch could not be processed so they can be surfaced to the user.
 * @export
 * @interface NodeSwitchUnprocessableError
 */
export interface NodeSwitchUnprocessableError {
    /**
     * 
     * @type {NodeSwitchUnprocessableErrorError}
     * @memberof NodeSwitchUnprocessableError
     */
    'error': NodeSwitchUnprocessableErrorError;
}
/**
 * 
 * @export
 * @interface NodeSwitchUnprocessableErrorError
 */
export interface NodeSwitchUnprocessableErrorError {
    /**
     * The error type identifier
     * @type {string}
     * @memberof NodeSwitchUnprocessableErrorError
     */
    'type': string;
    /**
     * A human-readable summary of the failure
     * @type {string}
     * @memberof NodeSwitchUnprocessableErrorError
     */
    'errorMessage': string;
    /**
     * The HTTP status code
     * @type {number}
     * @memberof NodeSwitchUnprocessableErrorError
     */
    'statusCode': number;
    /**
     * The list of specific validation failures
     * @type {Array<string>}
     * @memberof NodeSwitchUnprocessableErrorError
     */
    'errors': Array<string>;
}
/**
 * 
 * @export
 * @interface NominatedAccountItem
 */
export interface NominatedAccountItem {
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountItem
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountItem
     */
    'accountName': string;
    /**
     * 
     * @type {boolean}
     * @memberof NominatedAccountItem
     */
    'nominated': boolean;
    /**
     * 
     * @type {WrapperType}
     * @memberof NominatedAccountItem
     */
    'wrapperType'?: WrapperType;
}


/**
 * 
 * @export
 * @interface NominatedAccountsInner
 */
export interface NominatedAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountsInner
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountsInner
     */
    'clientId'?: string;
    /**
     * 
     * @type {Array<NominatedAccountsInnerClientsInner>}
     * @memberof NominatedAccountsInner
     */
    'clients'?: Array<NominatedAccountsInnerClientsInner>;
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountsInner
     */
    'accountName': string;
    /**
     * 
     * @type {Array<NominatedAccountsInnerFeeCoveredAccountsInner>}
     * @memberof NominatedAccountsInner
     */
    'feeCoveredAccounts': Array<NominatedAccountsInnerFeeCoveredAccountsInner>;
}
/**
 * 
 * @export
 * @interface NominatedAccountsInnerClientsInner
 */
export interface NominatedAccountsInnerClientsInner {
    /**
     * 
     * @type {boolean}
     * @memberof NominatedAccountsInnerClientsInner
     */
    'decisionMaker'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NominatedAccountsInnerClientsInner
     */
    'isLeadClient'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NominatedAccountsInnerClientsInner
     */
    'owner'?: number;
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountsInnerClientsInner
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface NominatedAccountsInnerFeeCoveredAccountsInner
 */
export interface NominatedAccountsInnerFeeCoveredAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountsInnerFeeCoveredAccountsInner
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountsInnerFeeCoveredAccountsInner
     */
    'clientId'?: string;
    /**
     * 
     * @type {Array<NominatedAccountsInnerClientsInner>}
     * @memberof NominatedAccountsInnerFeeCoveredAccountsInner
     */
    'clients'?: Array<NominatedAccountsInnerClientsInner>;
    /**
     * 
     * @type {string}
     * @memberof NominatedAccountsInnerFeeCoveredAccountsInner
     */
    'accountName': string;
}
/**
 * 
 * @export
 * @interface NominatedAccountsResponse
 */
export interface NominatedAccountsResponse {
    /**
     * 
     * @type {Array<NominatedAccountItem>}
     * @memberof NominatedAccountsResponse
     */
    'data'?: Array<NominatedAccountItem>;
}
/**
 * The response object containing pagination details
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * The total returned records count
     * @type {number}
     * @memberof Pagination
     */
    'count': number;
    /**
     * The index of pagination
     * @type {number}
     * @memberof Pagination
     */
    'page': number;
    /**
     * The amount of records per index
     * @type {number}
     * @memberof Pagination
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PartialTransferWithdrawalType {
    Withdraw = 'Withdraw',
    RemainingBalance = 'Remaining balance'
}


/**
 * 
 * @export
 * @interface PatchAccount
 */
export interface PatchAccount {
    /**
     * 
     * @type {SellDown}
     * @memberof PatchAccount
     */
    'autoDisinvest'?: SellDown | null;
    /**
     * 
     * @type {SellDownSellType}
     * @memberof PatchAccount
     */
    'autoDisinvestSellType'?: SellDownSellType | null;
    /**
     * 
     * @type {PatchAccountRecurringOrders}
     * @memberof PatchAccount
     */
    'recurringOrders'?: PatchAccountRecurringOrders | null;
    /**
     * The object holding your client\'s regular payment.
     * @type {Array<PatchAccountRecurringPaymentsInner>}
     * @memberof PatchAccount
     */
    'recurringPayments'?: Array<PatchAccountRecurringPaymentsInner>;
    /**
     * The unique identifier assigned to the record when it was last updated
     * @type {string}
     * @memberof PatchAccount
     */
    'updateId'?: string;
    /**
     * 
     * @type {PatchAccountNominatedForAccounts}
     * @memberof PatchAccount
     */
    'nominatedForAccounts'?: PatchAccountNominatedForAccounts;
}


/**
 * Accounts whose fees will be covered by this account
 * @export
 * @interface PatchAccountNominatedForAccounts
 */
export interface PatchAccountNominatedForAccounts {
    /**
     * Array of account IDs whose fees will be covered
     * @type {Array<string>}
     * @memberof PatchAccountNominatedForAccounts
     */
    'group'?: Array<string>;
}
/**
 * Contains details of the recurringOrders allocation
 * @export
 * @interface PatchAccountRecurringOrders
 */
export interface PatchAccountRecurringOrders {
    /**
     * The movement of cash or assets – this should be set to Invest
     * @type {string}
     * @memberof PatchAccountRecurringOrders
     */
    'movementType'?: string;
    /**
     * The type of investment strategy – this should be set to Bespoke
     * @type {string}
     * @memberof PatchAccountRecurringOrders
     */
    'investmentType'?: string;
    /**
     * Contains details of the asset allocation
     * @type {Array<PatchAccountRecurringOrdersDetailsInner>}
     * @memberof PatchAccountRecurringOrders
     */
    'details'?: Array<PatchAccountRecurringOrdersDetailsInner> | null;
    /**
     * This should be set to 1
     * @type {number}
     * @memberof PatchAccountRecurringOrders
     */
    'orderDay'?: number;
}
/**
 * 
 * @export
 * @interface PatchAccountRecurringOrdersDetailsInner
 */
export interface PatchAccountRecurringOrdersDetailsInner {
    /**
     * The unique identifier of the asset
     * @type {string}
     * @memberof PatchAccountRecurringOrdersDetailsInner
     */
    'assetId'?: string;
    /**
     * The percentage allocation of the asset
     * @type {number}
     * @memberof PatchAccountRecurringOrdersDetailsInner
     */
    'percentage'?: number;
}
/**
 * 
 * @export
 * @interface PatchAccountRecurringPaymentsInner
 */
export interface PatchAccountRecurringPaymentsInner {
    /**
     * 
     * @type {PaymentDate}
     * @memberof PatchAccountRecurringPaymentsInner
     */
    'paymentDay': PaymentDate;
    /**
     * A recurring amount which will be requested as a bank transfer into the investment account.
     * @type {number}
     * @memberof PatchAccountRecurringPaymentsInner
     */
    'amount': number;
    /**
     * 
     * @type {MovementType}
     * @memberof PatchAccountRecurringPaymentsInner
     */
    'movementType'?: MovementType;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof PatchAccountRecurringPaymentsInner
     */
    'method'?: PaymentMethod;
    /**
     * auto invest flag
     * @type {boolean}
     * @memberof PatchAccountRecurringPaymentsInner
     */
    'autoInvest'?: boolean;
    /**
     * 
     * @type {PaymentType}
     * @memberof PatchAccountRecurringPaymentsInner
     */
    'paymentType'?: PaymentType;
    /**
     * The employers company registration number
     * @type {string}
     * @memberof PatchAccountRecurringPaymentsInner
     */
    'companyRegNo'?: string;
}


/**
 * @type PatchClient
 * Patch request body for client updates
 * @export
 */
export type PatchClient = ClientCorporateOptional | ClientIndividualMinorOptional | ClientIndividualOptional | ClientTrustOptional;

/**
 * 
 * @export
 * @interface PatchClientFeeGroup
 */
export interface PatchClientFeeGroup {
    /**
     * 
     * @type {PatchClientFeeGroupIntentDetails}
     * @memberof PatchClientFeeGroup
     */
    'intentDetails'?: PatchClientFeeGroupIntentDetails;
    /**
     * The display name of the group
     * @type {string}
     * @memberof PatchClientFeeGroup
     */
    'name'?: string;
    /**
     * updateId returned from fetching the existing client fee group
     * @type {string}
     * @memberof PatchClientFeeGroup
     */
    'updateId'?: string;
    /**
     * 
     * @type {Array<PatchClientFeeGroupNominatedAccountsInner>}
     * @memberof PatchClientFeeGroup
     */
    'nominatedAccounts'?: Array<PatchClientFeeGroupNominatedAccountsInner>;
}
/**
 * The details of the client fee group
 * @export
 * @interface PatchClientFeeGroupIntentDetails
 */
export interface PatchClientFeeGroupIntentDetails {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchClientFeeGroupIntentDetails
     */
    'addMembers': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchClientFeeGroupIntentDetails
     */
    'removeMembers': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchClientFeeGroupIntentDetails
     */
    'platformFee'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchClientFeeGroupIntentDetails
     */
    'adviserFee'?: boolean;
    /**
     * 
     * @type {GetPortfolioGroupDataIntentDetailsFeeStructures}
     * @memberof PatchClientFeeGroupIntentDetails
     */
    'feeStructures'?: GetPortfolioGroupDataIntentDetailsFeeStructures;
}
/**
 * 
 * @export
 * @interface PatchClientFeeGroupNominatedAccountsInner
 */
export interface PatchClientFeeGroupNominatedAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof PatchClientFeeGroupNominatedAccountsInner
     */
    'accountId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchClientFeeGroupNominatedAccountsInner
     */
    'feeCoveredAccounts': Array<string>;
}
/**
 * Patch request body for updating a client\'s migration details. Migration fields are provided directly rather than nested under a `migration` object.
 * @export
 * @interface PatchClientMigration
 */
export interface PatchClientMigration {
    /**
     * 
     * @type {string}
     * @memberof PatchClientMigration
     */
    'updateId': string;
    /**
     * 
     * @type {ClientMigrationStatus}
     * @memberof PatchClientMigration
     */
    'status'?: ClientMigrationStatus;
    /**
     * List of illustration IDs associated with the migration
     * @type {Array<string>}
     * @memberof PatchClientMigration
     */
    'illustrationIds'?: Array<string>;
    /**
     * 
     * @type {Suitability}
     * @memberof PatchClientMigration
     */
    'suitability'?: Suitability;
}


/**
 * 
 * @export
 * @interface PatchCommunicationConfiguration
 */
export interface PatchCommunicationConfiguration {
    /**
     * The platform email address for the node
     * @type {string}
     * @memberof PatchCommunicationConfiguration
     */
    'fromEmail'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchCommunicationContent
 */
export interface PatchCommunicationContent {
    /**
     * the terms URL
     * @type {string}
     * @memberof PatchCommunicationContent
     */
    'emailTermsUrl'?: string | null;
    /**
     * the terms in the email footer
     * @type {string}
     * @memberof PatchCommunicationContent
     */
    'emailFooter'?: string | null;
    /**
     * the footer text in PDFs
     * @type {string}
     * @memberof PatchCommunicationContent
     */
    'pdfFooter'?: string | null;
    /**
     * the footer text in pension PDFs
     * @type {string}
     * @memberof PatchCommunicationContent
     */
    'pensionPdfFooter'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchCommunicationTheme
 */
export interface PatchCommunicationTheme {
    /**
     * The branding colour that adds theming to PDFs.
     * @type {string}
     * @memberof PatchCommunicationTheme
     */
    'illustrationBrandingColour'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchConfiguration
 */
export interface PatchConfiguration {
    /**
     * The node to apply the configuration changes to
     * @type {string}
     * @memberof PatchConfiguration
     */
    'nodeId': string;
    /**
     * 
     * @type {PatchInvestorConfiguration}
     * @memberof PatchConfiguration
     */
    'investor'?: PatchInvestorConfiguration | null;
    /**
     * 
     * @type {PatchCommunicationConfiguration}
     * @memberof PatchConfiguration
     */
    'communication'?: PatchCommunicationConfiguration | null;
    /**
     * 
     * @type {PatchProfessionalConfiguration}
     * @memberof PatchConfiguration
     */
    'professional'?: PatchProfessionalConfiguration | null;
}
/**
 * 
 * @export
 * @interface PatchContent
 */
export interface PatchContent {
    /**
     * The node to apply the theme changes to.
     * @type {string}
     * @memberof PatchContent
     */
    'nodeId': string;
    /**
     * 
     * @type {PatchProfessionalContent}
     * @memberof PatchContent
     */
    'professional'?: PatchProfessionalContent | null;
    /**
     * 
     * @type {PatchInvestorContent}
     * @memberof PatchContent
     */
    'investor'?: PatchInvestorContent | null;
    /**
     * 
     * @type {PatchCommunicationContent}
     * @memberof PatchContent
     */
    'communication'?: PatchCommunicationContent | null;
}
/**
 * 
 * @export
 * @interface PatchInvestorConfiguration
 */
export interface PatchInvestorConfiguration {
    /**
     * True if the client can create an account
     * @type {boolean}
     * @memberof PatchInvestorConfiguration
     */
    'allowClientToCreateAccount'?: boolean | null;
    /**
     * True if the client can update bank details
     * @type {boolean}
     * @memberof PatchInvestorConfiguration
     */
    'allowClientToUpdateBankDetails'?: boolean | null;
    /**
     * True if the client must provide bank details before accepting terms and conditions
     * @type {boolean}
     * @memberof PatchInvestorConfiguration
     */
    'requireClientToProvideBankDetails'?: boolean | null;
    /**
     * The page title for the Investor UI
     * @type {string}
     * @memberof PatchInvestorConfiguration
     */
    'windowTitle'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchInvestorContent
 */
export interface PatchInvestorContent {
    /**
     * The firm\'s registered office address.
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'clientRegOffice'?: string | null;
    /**
     * The URL for order execution.
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'orderUrl'?: string | null;
    /**
     * The URL for pension KFD
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'pensionKfdUrl'?: string | null;
    /**
     * the URL for ISA KFD
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'isaKfdUrl'?: string | null;
    /**
     * the URL for JISA KFD
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'jisaKfdUrl'?: string | null;
    /**
     * the URL for FAQ
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'faqUrl'?: string | null;
    /**
     * the URL for fees
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'feesUrl'?: string | null;
    /**
     * the URL for the privacy policy
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'privacyPolicyUrl'?: string | null;
    /**
     * the URL for the terms and conditions
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'termsUrl'?: string | null;
    /**
     * the FCA notice
     * @type {string}
     * @memberof PatchInvestorContent
     */
    'clientFcaNotice'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchInvestorTheme
 */
export interface PatchInvestorTheme {
    /**
     * The hexcode representation of the primary colour for the Investor UI.
     * @type {string}
     * @memberof PatchInvestorTheme
     */
    'primaryColour'?: string | null;
    /**
     * The hexcode representation of the secondary colour for the Investor UI.
     * @type {string}
     * @memberof PatchInvestorTheme
     */
    'secondaryColour'?: string | null;
    /**
     * The hexcode representation of the left side background colour gradient for the Investor UI.
     * @type {string}
     * @memberof PatchInvestorTheme
     */
    'backgroundPrimaryColour'?: string | null;
    /**
     * The hexcode representation of the right side background colour gradient for the Investor UI.
     * @type {string}
     * @memberof PatchInvestorTheme
     */
    'backgroundSecondaryColour'?: string | null;
    /**
     * The hexcode representation of the background primary colour for the footer in the Investor UI.
     * @type {string}
     * @memberof PatchInvestorTheme
     */
    'footerBackgroundPrimaryColour'?: string | null;
    /**
     * The hexcode representation of the background secondary colour for the footer in the Investor UI.
     * @type {string}
     * @memberof PatchInvestorTheme
     */
    'footerBackgroundSecondaryColour'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchProfessionalConfiguration
 */
export interface PatchProfessionalConfiguration {
    /**
     * The page title for the Pro UI
     * @type {string}
     * @memberof PatchProfessionalConfiguration
     */
    'windowTitle'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchProfessionalContent
 */
export interface PatchProfessionalContent {
    /**
     * The URL for order execution.
     * @type {string}
     * @memberof PatchProfessionalContent
     */
    'orderUrl'?: string | null;
    /**
     * HTML content to be rendered in the footer. Allowed tags: <p>, <a>, <strong>, <em>. Scripts and inline styles are removed. 
     * @type {string}
     * @memberof PatchProfessionalContent
     */
    'clientFooterCopyrightMarkdown'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchProfessionalTheme
 */
export interface PatchProfessionalTheme {
    /**
     * The hexcode representation of the primary colour for the Advisor UI.
     * @type {string}
     * @memberof PatchProfessionalTheme
     */
    'primaryColour'?: string | null;
    /**
     * The hexcode representation of the background colour for the Advisor UI.
     * @type {string}
     * @memberof PatchProfessionalTheme
     */
    'backgroundColour'?: string | null;
    /**
     * The hexcode representation of the background colour contrast for the Advisor UI.
     * @type {string}
     * @memberof PatchProfessionalTheme
     */
    'backgroundColourContrast'?: string | null;
    /**
     * The hexcode representation of the call to action colour for the Advisor UI.
     * @type {string}
     * @memberof PatchProfessionalTheme
     */
    'ctaColour'?: string | null;
    /**
     * The hexcode representation of the call to action colour contrast for the Advisor UI.
     * @type {string}
     * @memberof PatchProfessionalTheme
     */
    'ctaColourContrast'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchResponse
 */
export interface PatchResponse {
    /**
     * Empty object returned from a successful patch request
     * @type {object}
     * @memberof PatchResponse
     */
    'data': object;
}
/**
 * 
 * @export
 * @interface PatchTheme
 */
export interface PatchTheme {
    /**
     * The node to apply the theme changes to.
     * @type {string}
     * @memberof PatchTheme
     */
    'nodeId': string;
    /**
     * 
     * @type {PatchInvestorTheme}
     * @memberof PatchTheme
     */
    'investor'?: PatchInvestorTheme | null;
    /**
     * 
     * @type {PatchProfessionalTheme}
     * @memberof PatchTheme
     */
    'professional'?: PatchProfessionalTheme | null;
    /**
     * 
     * @type {PatchCommunicationTheme}
     * @memberof PatchTheme
     */
    'communication'?: PatchCommunicationTheme | null;
    /**
     * 
     * @type {PatchWealthsweetTheme}
     * @memberof PatchTheme
     */
    'wealthsweet'?: PatchWealthsweetTheme | null;
}
/**
 * 
 * @export
 * @interface PatchWealthsweetTheme
 */
export interface PatchWealthsweetTheme {
    /**
     * The hexcode representation of the balance colour for the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'balanceColor'?: string | null;
    /**
     * The hexcode representation of the time weighted performance colour for the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'timeWeightedPerformanceColor'?: string | null;
    /**
     * The hexcode representation of the money weighted performance colour for the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'moneyWeightedPerformanceColor'?: string | null;
    /**
     * The hexcode representation of the positive capital movement colour for the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'positiveCapitalMovementColor'?: string | null;
    /**
     * The hexcode representation of the negative capital movement colour for the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'negativeCapitalMovementColor'?: string | null;
    /**
     * The hexcode representation of the primary colour for the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'primaryColor'?: string | null;
    /**
     * The hexcode representation of the secondary colour for the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'secondaryColor'?: string | null;
    /**
     * The hexcode representation of the secondary foreground colour for the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'secondaryForegroundColor'?: string | null;
    /**
     * The hexcode representation of the balance colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfBalanceColor'?: string | null;
    /**
     * The hexcode representation of the time weighted performance colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfTimeWeightedPerformanceColor'?: string | null;
    /**
     * The hexcode representation of the money weighted performance colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfMoneyWeightedPerformanceColor'?: string | null;
    /**
     * The hexcode representation of the positive capital movement colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfPositiveCapitalMovementColor'?: string | null;
    /**
     * The hexcode representation of the negative capital movement colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfNegativeCapitalMovementColor'?: string | null;
    /**
     * The hexcode representation of the text colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfTextColor'?: string | null;
    /**
     * The hexcode representation of the banner colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfBannerColor'?: string | null;
    /**
     * The hexcode representation of the page colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfPageColor'?: string | null;
    /**
     * The hexcode representation of the banner contrast colour for PDFs in the Wealthsweet theme.
     * @type {string}
     * @memberof PatchWealthsweetTheme
     */
    'pdfBannerContrastColor'?: string | null;
}
/**
 * Details for PayUK transfers
 * @export
 * @interface PayUkDetails
 */
export interface PayUkDetails {
    /**
     * Indicates whether the client accepts early closure penalties
     * @type {boolean}
     * @memberof PayUkDetails
     */
    'earlyClosureWaiver'?: boolean;
    /**
     * The sort code of the ceding provider account
     * @type {string}
     * @memberof PayUkDetails
     */
    'sortCode'?: string;
    /**
     * The account identification number at the ceding provider
     * @type {string}
     * @memberof PayUkDetails
     */
    'accountIdentification'?: string;
    /**
     * The account designation (roll number) at the ceding provider
     * @type {string}
     * @memberof PayUkDetails
     */
    'accountDesignation'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PaymentDate {
    NUMBER_1 = 1,
    NUMBER_7 = 7,
    NUMBER_14 = 14,
    NUMBER_21 = 21,
    NUMBER_28 = 28
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum PaymentMethod {
    BankTransfer = 'Bank Transfer',
    DirectDebit = 'Direct Debit',
    BacsCredit = 'BACS Credit',
    Transfer = 'Transfer'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum PaymentType {
    Employee = 'Employee',
    Employer = 'Employer',
    Withdrawal = 'Withdrawal'
}


/**
 * Pending payment-in deposits that have not yet settled. Reported separately; not part of the settled cash, and not yet available for trading or withdrawal.
 * @export
 * @interface PendingDeposits
 */
export interface PendingDeposits {
    /**
     * The total value of pending deposits
     * @type {number}
     * @memberof PendingDeposits
     */
    'amount'?: number;
    /**
     * The ids of the pending deposit transactions
     * @type {Array<string>}
     * @memberof PendingDeposits
     */
    'transactionIds'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PendingTransactionSubType {
    ExternalTransfer = 'External Transfer',
    UnallocatedCash = 'Unallocated Cash',
    UnidentifiedCash = 'Unidentified Cash',
    NegativeCash = 'Negative Cash',
    Interest = 'Interest',
    AssetInterest = 'Asset Interest',
    Dividend = 'Dividend',
    TaxReclaim = 'Tax Reclaim',
    Employee = 'Employee',
    Employer = 'Employer'
}


/**
 * 
 * @export
 * @interface PensionAccountGroup
 */
export interface PensionAccountGroup {
    /**
     * 
     * @type {PensionAccountGroupIntent}
     * @memberof PensionAccountGroup
     */
    'groupIntent'?: PensionAccountGroupIntent;
    /**
     * 
     * @type {PensionAccountGroupType}
     * @memberof PensionAccountGroup
     */
    'groupType': PensionAccountGroupType;
    /**
     * 
     * @type {string}
     * @memberof PensionAccountGroup
     */
    'name'?: string;
    /**
     * The unique identifier for the portfolio group
     * @type {string}
     * @memberof PensionAccountGroup
     */
    'id': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum PensionAccountGroupIntent {
    PensionAccountGroup = 'Pension Account Group',
    AdvisorCharges = 'Advisor Charges'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum PensionAccountGroupType {
    Uncrystallised = 'Uncrystallised',
    Crystallised = 'Crystallised',
    CrystallisedTransfer = 'CrystallisedTransfer',
    Beneficiary = 'Beneficiary'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum Permission {
    Read = 'read',
    ReadWrite = 'readWrite',
    Action = 'action',
    WriteClient = 'writeClient'
}


/**
 * @type PersistedClient
 * @export
 */
export type PersistedClient = { clientType: 'Corporate' } & PersistedCorporateClient | { clientType: 'Individual' } & PersistedIndividualClient | { clientType: 'Individual Minor' } & PersistedIndividualMinorClient | { clientType: 'PersistedIndividualClient' } & PersistedIndividualClient | { clientType: 'Trust' } & PersistedTrustClient;

/**
 * @type PersistedClientEntity
 * @export
 */
export type PersistedClientEntity = PersistedCorporateClient | PersistedTrustClient;

/**
 * @type PersistedClientPerson
 * @export
 */
export type PersistedClientPerson = PersistedIndividualClient | PersistedIndividualMinorClient;

/**
 * Represents a corporate client after it\'s been saved to the database
 * @export
 * @interface PersistedCorporateClient
 */
export interface PersistedCorporateClient {
    /**
     * 
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof PersistedCorporateClient
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'clientType': string;
    /**
     * 
     * @type {ClientStatusEnum}
     * @memberof PersistedCorporateClient
     */
    'status': ClientStatusEnum;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof PersistedCorporateClient
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BasePersistedClientBankDetails}
     * @memberof PersistedCorporateClient
     */
    'bankDetails'?: BasePersistedClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof PersistedCorporateClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof PersistedCorporateClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof PersistedCorporateClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered company name
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'entityName': string;
    /**
     * 
     * @type {EntityDetailsCorporate}
     * @memberof PersistedCorporateClient
     */
    'entityDetails': EntityDetailsCorporate;
    /**
     * 
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'emailToken'?: string;
    /**
     * expiry date/ time
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'emailTokenExpiry'?: string;
    /**
     * Flag signifing if the client has completed the email verification flow
     * @type {boolean}
     * @memberof PersistedCorporateClient
     */
    'emailVerified'?: boolean;
    /**
     * Flag signifing if the clients mobile number has been verifed
     * @type {boolean}
     * @memberof PersistedCorporateClient
     */
    'mobileVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'smsToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'smsTokenExpiry'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersistedCorporateClient
     */
    'smsTokenVerified'?: boolean;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<BasePersistedClientNationalitiesInner>}
     * @memberof PersistedCorporateClient
     */
    'nationalities'?: Array<BasePersistedClientNationalitiesInner>;
    /**
     * The client\'s birth date in iso date time format
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'dateOfBirth'?: string;
    /**
     * Before creating a client record, you must carry out necessary AML/KYC checks – this should be set to Approved
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'amlStatus'?: string;
    /**
     * 
     * @type {BasePersistedClientAmlData}
     * @memberof PersistedCorporateClient
     */
    'amlData'?: BasePersistedClientAmlData;
    /**
     * The date time stamp of when the T&C\'s were accepted by the client
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'termsAcceptedDate'?: string;
    /**
     * 
     * @type {BasePersistedClientCommsStatus}
     * @memberof PersistedCorporateClient
     */
    'commsStatus'?: BasePersistedClientCommsStatus;
    /**
     * 
     * @type {Array<BasePersistedClientExternalIdsInner>}
     * @memberof PersistedCorporateClient
     */
    'externalIds'?: Array<BasePersistedClientExternalIdsInner>;
    /**
     * The date the client record was created in ISO format (YYYY-MM-DD)
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'recordCreationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersistedCorporateClient
     */
    'updateId': string;
    /**
     * Contains details of updates made to the client record
     * @type {Array<BasePersistedClientUpdateHistoryInner>}
     * @memberof PersistedCorporateClient
     */
    'updateHistory'?: Array<BasePersistedClientUpdateHistoryInner>;
    /**
     * 
     * @type {BasePersistedClientAuditDetails}
     * @memberof PersistedCorporateClient
     */
    'auditDetails'?: BasePersistedClientAuditDetails;
}


/**
 * Represents an individual client after it\'s been saved to the database
 * @export
 * @interface PersistedIndividualClient
 */
export interface PersistedIndividualClient {
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof PersistedIndividualClient
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'clientType': string;
    /**
     * 
     * @type {ClientStatusEnum}
     * @memberof PersistedIndividualClient
     */
    'status': ClientStatusEnum;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof PersistedIndividualClient
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BasePersistedClientBankDetails}
     * @memberof PersistedIndividualClient
     */
    'bankDetails'?: BasePersistedClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof PersistedIndividualClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof PersistedIndividualClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof PersistedIndividualClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'firstName': string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'surname': string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof PersistedIndividualClient
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof PersistedIndividualClient
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof PersistedIndividualClient
     */
    'phone'?: Telephone;
    /**
     * The age the client is expected to retire
     * @type {number}
     * @memberof PersistedIndividualClient
     */
    'retirementAge'?: number;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<BasePersistedClientNationalitiesInner>}
     * @memberof PersistedIndividualClient
     */
    'nationalities'?: Array<BasePersistedClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof PersistedIndividualClient
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * The client\'s foreign (non-UK) tax residencies. Each entry either provides a tax identification number (TIN) or a reason why one is not available.
     * @type {Array<ForeignTaxResidency>}
     * @memberof PersistedIndividualClient
     */
    'foreignTaxResidencies'?: Array<ForeignTaxResidency>;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof PersistedIndividualClient
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in iso date time format
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'dateOfBirth': string;
    /**
     * Contains details of the client\'s employer – only required where the client is making employer payments to their pension
     * @type {Array<EmployersInner>}
     * @memberof PersistedIndividualClient
     */
    'employers'?: Array<EmployersInner>;
    /**
     * 
     * @type {EmploymentStatus}
     * @memberof PersistedIndividualClient
     */
    'employmentStatus'?: EmploymentStatus;
    /**
     * 
     * @type {BasePersistedClientAmlData}
     * @memberof PersistedIndividualClient
     */
    'amlData'?: BasePersistedClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof PersistedIndividualClient
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof PersistedIndividualClient
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof PersistedIndividualClient
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof PersistedIndividualClient
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof PersistedIndividualClient
     */
    'kycData'?: ClientKycData;
    /**
     * 
     * @type {ClientMigration}
     * @memberof PersistedIndividualClient
     */
    'migration'?: ClientMigration;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'emailToken'?: string;
    /**
     * expiry date/ time
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'emailTokenExpiry'?: string;
    /**
     * Flag signifing if the client has completed the email verification flow
     * @type {boolean}
     * @memberof PersistedIndividualClient
     */
    'emailVerified'?: boolean;
    /**
     * Flag signifing if the clients mobile number has been verifed
     * @type {boolean}
     * @memberof PersistedIndividualClient
     */
    'mobileVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'smsToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'smsTokenExpiry'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersistedIndividualClient
     */
    'smsTokenVerified'?: boolean;
    /**
     * Before creating a client record, you must carry out necessary AML/KYC checks – this should be set to Approved
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'amlStatus'?: string;
    /**
     * The date time stamp of when the T&C\'s were accepted by the client
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'termsAcceptedDate'?: string;
    /**
     * 
     * @type {BasePersistedClientCommsStatus}
     * @memberof PersistedIndividualClient
     */
    'commsStatus'?: BasePersistedClientCommsStatus;
    /**
     * 
     * @type {Array<BasePersistedClientExternalIdsInner>}
     * @memberof PersistedIndividualClient
     */
    'externalIds'?: Array<BasePersistedClientExternalIdsInner>;
    /**
     * The date the client record was created in ISO format (YYYY-MM-DD)
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'recordCreationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualClient
     */
    'updateId': string;
    /**
     * Contains details of updates made to the client record
     * @type {Array<BasePersistedClientUpdateHistoryInner>}
     * @memberof PersistedIndividualClient
     */
    'updateHistory'?: Array<BasePersistedClientUpdateHistoryInner>;
    /**
     * 
     * @type {BasePersistedClientAuditDetails}
     * @memberof PersistedIndividualClient
     */
    'auditDetails'?: BasePersistedClientAuditDetails;
}


/**
 * Represents an individual minor client after it\'s been saved to the database
 * @export
 * @interface PersistedIndividualMinorClient
 */
export interface PersistedIndividualMinorClient {
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof PersistedIndividualMinorClient
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'clientType': string;
    /**
     * 
     * @type {ClientStatusEnum}
     * @memberof PersistedIndividualMinorClient
     */
    'status': ClientStatusEnum;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof PersistedIndividualMinorClient
     */
    'addressDetail': AddressDetail;
    /**
     * 
     * @type {BasePersistedClientBankDetails}
     * @memberof PersistedIndividualMinorClient
     */
    'bankDetails'?: BasePersistedClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof PersistedIndividualMinorClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof PersistedIndividualMinorClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof PersistedIndividualMinorClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The parent client ID for the child client being created
     * @type {Array<string>}
     * @memberof PersistedIndividualMinorClient
     */
    'parentId': Array<string>;
    /**
     * TBD The legal title of the client
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'title'?: string;
    /**
     * The legal first name/s of the client
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'firstName': string;
    /**
     * The legal middle name/s of the client
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'middleName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'surname': string;
    /**
     * The legal gender of the client
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'gender'?: string;
    /**
     * 
     * @type {MaritalStatus}
     * @memberof PersistedIndividualMinorClient
     */
    'maritalStatus'?: MaritalStatus;
    /**
     * The client\'s email address. This will be used to log into their investor portal
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'email'?: string;
    /**
     * 
     * @type {Telephone}
     * @memberof PersistedIndividualMinorClient
     */
    'mobile'?: Telephone;
    /**
     * 
     * @type {Telephone}
     * @memberof PersistedIndividualMinorClient
     */
    'phone'?: Telephone;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<BasePersistedClientNationalitiesInner>}
     * @memberof PersistedIndividualMinorClient
     */
    'nationalities'?: Array<BasePersistedClientNationalitiesInner>;
    /**
     * Flag signifying whether the client has any foreign (non-UK) tax residencies
     * @type {boolean}
     * @memberof PersistedIndividualMinorClient
     */
    'hasForeignTaxResidency'?: boolean;
    /**
     * 
     * @type {ClientVulnerability}
     * @memberof PersistedIndividualMinorClient
     */
    'vulnerability'?: ClientVulnerability;
    /**
     * The client\'s birth date in iso date time format
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'dateOfBirth': string;
    /**
     * 
     * @type {BasePersistedClientAmlData}
     * @memberof PersistedIndividualMinorClient
     */
    'amlData'?: BasePersistedClientAmlData;
    /**
     * Northrow AML vendor checks
     * @type {Array<ClientAmlCheck>}
     * @memberof PersistedIndividualMinorClient
     */
    'amlChecks'?: Array<ClientAmlCheck>;
    /**
     * Flag to show if client has been seen in person
     * @type {boolean}
     * @memberof PersistedIndividualMinorClient
     */
    'clientSeenFaceToFace'?: boolean;
    /**
     * Flag signifing if the client requires the direct debit mandate
     * @type {boolean}
     * @memberof PersistedIndividualMinorClient
     */
    'requiresDebitMandate'?: boolean;
    /**
     * Flag signifing if the client has consented to marketing emails
     * @type {boolean}
     * @memberof PersistedIndividualMinorClient
     */
    'marketingConsent'?: boolean;
    /**
     * 
     * @type {ClientKycData}
     * @memberof PersistedIndividualMinorClient
     */
    'kycData'?: ClientKycData;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'emailToken'?: string;
    /**
     * expiry date/ time
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'emailTokenExpiry'?: string;
    /**
     * Flag signifing if the client has completed the email verification flow
     * @type {boolean}
     * @memberof PersistedIndividualMinorClient
     */
    'emailVerified'?: boolean;
    /**
     * Flag signifing if the clients mobile number has been verifed
     * @type {boolean}
     * @memberof PersistedIndividualMinorClient
     */
    'mobileVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'smsToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'smsTokenExpiry'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersistedIndividualMinorClient
     */
    'smsTokenVerified'?: boolean;
    /**
     * Before creating a client record, you must carry out necessary AML/KYC checks – this should be set to Approved
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'amlStatus'?: string;
    /**
     * The date time stamp of when the T&C\'s were accepted by the client
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'termsAcceptedDate'?: string;
    /**
     * 
     * @type {BasePersistedClientCommsStatus}
     * @memberof PersistedIndividualMinorClient
     */
    'commsStatus'?: BasePersistedClientCommsStatus;
    /**
     * 
     * @type {Array<BasePersistedClientExternalIdsInner>}
     * @memberof PersistedIndividualMinorClient
     */
    'externalIds'?: Array<BasePersistedClientExternalIdsInner>;
    /**
     * The date the client record was created in ISO format (YYYY-MM-DD)
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'recordCreationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersistedIndividualMinorClient
     */
    'updateId': string;
    /**
     * Contains details of updates made to the client record
     * @type {Array<BasePersistedClientUpdateHistoryInner>}
     * @memberof PersistedIndividualMinorClient
     */
    'updateHistory'?: Array<BasePersistedClientUpdateHistoryInner>;
    /**
     * 
     * @type {BasePersistedClientAuditDetails}
     * @memberof PersistedIndividualMinorClient
     */
    'auditDetails'?: BasePersistedClientAuditDetails;
}


/**
 * Represents a trust client after it\'s been saved to the database
 * @export
 * @interface PersistedTrustClient
 */
export interface PersistedTrustClient {
    /**
     * 
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof PersistedTrustClient
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'clientType': string;
    /**
     * 
     * @type {ClientStatusEnum}
     * @memberof PersistedTrustClient
     */
    'status': ClientStatusEnum;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof PersistedTrustClient
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BasePersistedClientBankDetails}
     * @memberof PersistedTrustClient
     */
    'bankDetails'?: BasePersistedClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof PersistedTrustClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof PersistedTrustClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof PersistedTrustClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered trust name
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'entityName': string;
    /**
     * 
     * @type {EntityDetailsTrust}
     * @memberof PersistedTrustClient
     */
    'entityDetails': EntityDetailsTrust;
    /**
     * 
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'emailToken'?: string;
    /**
     * expiry date/ time
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'emailTokenExpiry'?: string;
    /**
     * Flag signifing if the client has completed the email verification flow
     * @type {boolean}
     * @memberof PersistedTrustClient
     */
    'emailVerified'?: boolean;
    /**
     * Flag signifing if the clients mobile number has been verifed
     * @type {boolean}
     * @memberof PersistedTrustClient
     */
    'mobileVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'smsToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'smsTokenExpiry'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersistedTrustClient
     */
    'smsTokenVerified'?: boolean;
    /**
     * The client\'s nationality
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'nationality'?: string;
    /**
     * The client\'s National Insurance Number – this is required for clients opening an ISA, JISA or SIPP
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'nationalInsuranceNo'?: string;
    /**
     * Contains details of the client\'s nationality/s and the relevant national identifier
     * @type {Array<BasePersistedClientNationalitiesInner>}
     * @memberof PersistedTrustClient
     */
    'nationalities'?: Array<BasePersistedClientNationalitiesInner>;
    /**
     * The client\'s birth date in iso date time format
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'dateOfBirth'?: string;
    /**
     * Before creating a client record, you must carry out necessary AML/KYC checks – this should be set to Approved
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'amlStatus'?: string;
    /**
     * 
     * @type {BasePersistedClientAmlData}
     * @memberof PersistedTrustClient
     */
    'amlData'?: BasePersistedClientAmlData;
    /**
     * The date time stamp of when the T&C\'s were accepted by the client
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'termsAcceptedDate'?: string;
    /**
     * 
     * @type {BasePersistedClientCommsStatus}
     * @memberof PersistedTrustClient
     */
    'commsStatus'?: BasePersistedClientCommsStatus;
    /**
     * 
     * @type {Array<BasePersistedClientExternalIdsInner>}
     * @memberof PersistedTrustClient
     */
    'externalIds'?: Array<BasePersistedClientExternalIdsInner>;
    /**
     * The date the client record was created in ISO format (YYYY-MM-DD)
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'recordCreationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersistedTrustClient
     */
    'updateId': string;
    /**
     * Contains details of updates made to the client record
     * @type {Array<BasePersistedClientUpdateHistoryInner>}
     * @memberof PersistedTrustClient
     */
    'updateHistory'?: Array<BasePersistedClientUpdateHistoryInner>;
    /**
     * 
     * @type {BasePersistedClientAuditDetails}
     * @memberof PersistedTrustClient
     */
    'auditDetails'?: BasePersistedClientAuditDetails;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum PersonClientType {
    Individual = 'Individual',
    IndividualMinor = 'Individual Minor'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum PersonalIdentifierType {
    Nino = 'NINO',
    Ccpt = 'CCPT',
    Concat = 'CONCAT',
    Nidn = 'NIDN'
}


/**
 * 
 * @export
 * @interface PlatformFeeSource
 */
export interface PlatformFeeSource {
    /**
     * Where the platform fee structure is inherited from
     * @type {string}
     * @memberof PlatformFeeSource
     */
    'sourceType': PlatformFeeSourceSourceTypeEnum;
    /**
     * ID of the entity holding the fee structure
     * @type {string}
     * @memberof PlatformFeeSource
     */
    'sourceId': string;
}

/**
    * @export
    * @enum {string}
    */
export enum PlatformFeeSourceSourceTypeEnum {
    Account = 'Account',
    Client = 'Client',
    ClientFeeGroup = 'Client Fee Group',
    Firm = 'Firm'
}

/**
 * 
 * @export
 * @interface PortfolioCapitalGainsTaxReport
 */
export interface PortfolioCapitalGainsTaxReport {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'firmId'?: string;
    /**
     * The unique identifier of the client
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'id': string;
    /**
     * An array of parent ids
     * @type {Array<string>}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'parentId'?: Array<string>;
    /**
     * The full name of the client
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'name': string;
    /**
     * The first name of the client
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'firstName': string;
    /**
     * The surname of the client
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'surname': string;
    /**
     * The language set at the client record
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'language'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'currency'?: string;
    /**
     * The unique identifier of the node that the client is attached to
     * @type {Array<string>}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'nodeId'?: Array<string>;
    /**
     * The name of the node that the client is attached to
     * @type {Array<string>}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'nodeName'?: Array<string>;
    /**
     * The status of the client record
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'status'?: string;
    /**
     * List of associated client stakeholders
     * @type {Array<PortfolioSummaryDataStakeholdersInner>}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'stakeholders'?: Array<PortfolioSummaryDataStakeholdersInner>;
    /**
     * List of associated entity clients
     * @type {Array<PortfolioSummaryDataLinkedEntityClientsInner>}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'linkedEntityClients'?: Array<PortfolioSummaryDataLinkedEntityClientsInner>;
    /**
     * Contains details on the individual investment accounts of the client portfolio
     * @type {Array<PortfolioCapitalGainsTaxReportAccount>}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'accounts'?: Array<PortfolioCapitalGainsTaxReportAccount>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'clientType'?: string;
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'bookValue'?: number;
    /**
     * The book cost since the transfer settled
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'nonTransferBookValue'?: number;
    /**
     * The number of units multiplied by the price on the day the transfer settled. This will be the same as the bookValue if there\'s been no in-specie transfer 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'transferBookValue'?: number;
    /**
     * The opening value of the current record - if no date parameters are provided, this will show as 0 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'openingValue'?: number;
    /**
     * The current total value at the current record level - if no date parameters are provided, this will show as at today\'s date 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'currentValue'?: number;
    /**
     * The value of available cash held by the record that is not currently invested
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'uninvestedCash'?: number;
    /**
     * The value of cash held by the record at the end of the specified period (if not specified this would be now) 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'closingCashValue'?: number;
    /**
     * The growth value since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'growth'?: number;
    /**
     * The percentage growth since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'growthPercent'?: number;
    /**
     * The on platform growth value of an investment (the growth since arrival on the platform) 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'adjustedGrowth'?: number;
    /**
     * The percentage adjusted growth at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The value of the transfer onto the platform at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'transferValue'?: number;
    /**
     * 
     * @type {Array<PortfolioCapitalGainsTaxReportProductsInner>}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'products'?: Array<PortfolioCapitalGainsTaxReportProductsInner>;
    /**
     * 
     * @type {CgtData}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PortfolioCapitalGainsTaxReport
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}
/**
 * 
 * @export
 * @interface PortfolioCapitalGainsTaxReportAccount
 */
export interface PortfolioCapitalGainsTaxReportAccount {
    /**
     * The on platform growth value of an investment (the growth since arrival on the platform) 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'adjustedGrowth'?: number;
    /**
     * The percentage adjusted growth at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The growth value since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'growth'?: number;
    /**
     * The percentage growth since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'growthPercent'?: number;
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'bookValue'?: number;
    /**
     * The book cost since the transfer settled
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'nonTransferBookValue'?: number;
    /**
     * The number of units multiplied by the price on the day the transfer settled. This will be the same as the bookValue if there\'s been no in-specie transfer 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'transferBookValue'?: number;
    /**
     * The value of cash held by the record at the end of the specified period (if not specified this would be now) 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'closingCashValue'?: number;
    /**
     * The value of stock held by the record at the end of the specified period (if not specified this as at the most recent close of market) 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'closingStockValue'?: number;
    /**
     * The value of cash held at the current record level at the start of the specified period (if not specified this would be record creation) 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'openingCashValue'?: number;
    /**
     * The value of stock held at the current record level at the start of the specified period (if not specified this would be record creation) 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'openingStockValue'?: number;
    /**
     * The opening value of the current record - if no date parameters are provided, this will show as 0 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'openingValue'?: number;
    /**
     * The current total value at the current record level - if no date parameters are provided, this will show as at today\'s date 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'currentValue'?: number;
    /**
     * The value of the transfer onto the platform at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'transferValue'?: number;
    /**
     * The value of available cash held by the record that is not currently invested
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'uninvestedCash'?: number;
    /**
     * 
     * @type {PendingDeposits}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'pendingDeposits'?: PendingDeposits;
    /**
     * Settled cash that can be withdrawn now (uninvested cash less any unsettled sells)
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'withdrawableCash'?: number;
    /**
     * Completed sell orders whose cash has executed but not yet settled
     * @type {Array<UnsettledSell>}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'unsettledSells'?: Array<UnsettledSell>;
    /**
     * 
     * @type {RingfencedCashBreakdown}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'ringfencedCashBreakdown'?: RingfencedCashBreakdown;
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'id': string;
    /**
     * The name of the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'name'?: string;
    /**
     * 
     * @type {AccountType}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'accountType'?: AccountType;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'currency'?: string;
    /**
     * The name of the asset allocation in which the current record is invested
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the asset allocation in which the current record is invested
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'assetAllocationId'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'wrapperType'?: WrapperType;
    /**
     * The unique identifier of the node which manages this record
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'nodeId'?: string;
    /**
     * The name of the node within which the current record is held
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'nodeName'?: string;
    /**
     * 
     * @type {AccountStatus}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'status'?: AccountStatus;
    /**
     * tbd
     * @type {boolean}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'recurringPayment'?: boolean;
    /**
     * 
     * @type {WrapperDetail}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'wrapperDetail'?: WrapperDetail;
    /**
     * A percentage value
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'allocation'?: number;
    /**
     * 
     * @type {CgtData}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
    /**
     * The individual cash and asset positions within the portfolio
     * @type {Array<PortfolioCapitalGainsTaxReportAccountPosition>}
     * @memberof PortfolioCapitalGainsTaxReportAccount
     */
    'positions'?: Array<PortfolioCapitalGainsTaxReportAccountPosition>;
}


/**
 * 
 * @export
 * @interface PortfolioCapitalGainsTaxReportAccountAllOf
 */
export interface PortfolioCapitalGainsTaxReportAccountAllOf {
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'id': string;
    /**
     * The name of the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'name'?: string;
    /**
     * 
     * @type {AccountType}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'accountType'?: AccountType;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'currency'?: string;
    /**
     * The name of the asset allocation in which the current record is invested
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the asset allocation in which the current record is invested
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'assetAllocationId'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'wrapperType'?: WrapperType;
    /**
     * The unique identifier of the node which manages this record
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'nodeId'?: string;
    /**
     * The name of the node within which the current record is held
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'nodeName'?: string;
    /**
     * 
     * @type {AccountStatus}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'status'?: AccountStatus;
    /**
     * tbd
     * @type {boolean}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'recurringPayment'?: boolean;
    /**
     * 
     * @type {WrapperDetail}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'wrapperDetail'?: WrapperDetail;
    /**
     * A percentage value
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'allocation'?: number;
    /**
     * 
     * @type {CgtData}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
    /**
     * The individual cash and asset positions within the portfolio
     * @type {Array<PortfolioCapitalGainsTaxReportAccountPosition>}
     * @memberof PortfolioCapitalGainsTaxReportAccountAllOf
     */
    'positions'?: Array<PortfolioCapitalGainsTaxReportAccountPosition>;
}


/**
 * 
 * @export
 * @interface PortfolioCapitalGainsTaxReportAccountPosition
 */
export interface PortfolioCapitalGainsTaxReportAccountPosition {
    /**
     * The on platform growth value of an investment (the growth since arrival on the platform) 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'adjustedGrowth'?: number;
    /**
     * The percentage adjusted growth at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The growth value since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'growth'?: number;
    /**
     * The percentage growth since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'growthPercent'?: number;
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'bookValue'?: number;
    /**
     * The book cost since the transfer settled
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'nonTransferBookValue'?: number;
    /**
     * The number of units multiplied by the price on the day the transfer settled. This will be the same as the bookValue if there\'s been no in-specie transfer 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'transferBookValue'?: number;
    /**
     * The opening value of the current record - if no date parameters are provided, this will show as 0 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'openingValue'?: number;
    /**
     * The current total value at the current record level - if no date parameters are provided, this will show as at today\'s date 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'currentValue'?: number;
    /**
     * The value of the transfer onto the platform at the current record level
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'transferValue'?: number;
    /**
     * 
     * @type {PositionType}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'positionType'?: PositionType;
    /**
     * International Securities Identification Number (ISIN). A 12-digit alphanumeric code that uniquely identifies a specific security 
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'isin'?: string;
    /**
     * The unique identifier of the asset
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'assetId'?: string;
    /**
     * The short name of the asset
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'assetName'?: string;
    /**
     * The number of units in the holding
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'quantity'?: number;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'currency'?: string;
    /**
     * The current price of the asset – this is the ask of the latest price in the system
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'currentPrice'?: number;
    /**
     * The date of the current price in the system
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'currentPriceDate'?: string;
    /**
     * The number of decimal places that the asset can be held. For example, 0.0001 means the asset can be held to 4 decimal places. This is driven by the fund manager or instrument type 
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'minimumTransferUnit'?: number;
    /**
     * The percentage allocation of the holding within the investment account
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'allocation'?: number;
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'accountId'?: string;
    /**
     * The name of the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'accountName'?: string;
    /**
     * 
     * @type {AccountType}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'accountType'?: AccountType;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'accountWrapperType'?: WrapperType;
    /**
     * The country where the asset was first issued
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'assetCountryOfIssue'?: string;
    /**
     * The type of instrument/asset. The system accounts for Equity, Gilts, Corporate bonds, Cash and Other asset classes. 
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'assetInstrumentType'?: string;
    /**
     * 
     * @type {CgtData}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
    /**
     * The type of instrument/asset. The system accounts for Equity, Gilts, Corporate bonds, Cash and Other asset classes. 
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'instrumentType'?: string;
    /**
     * The unique identifier of the node which manages this record
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'nodeId'?: string;
    /**
     * Calculated percentage OCF
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'ocfCalculated'?: number;
    /**
     * Estimated percentage OCF
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'ocfEstimated'?: number;
    /**
     * The list of prices associated with the position\'s asset
     * @type {Array<GetAssetPrice>}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'prices'?: Array<GetAssetPrice>;
    /**
     * The list of transactions associated with the position.
     * @type {Array<PositionTransaction>}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'transactions'?: Array<PositionTransaction>;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioCapitalGainsTaxReportAccountPosition
     */
    'wrapperType'?: WrapperType;
}


/**
 * 
 * @export
 * @interface PortfolioCapitalGainsTaxReportAccountPositionAllOf
 */
export interface PortfolioCapitalGainsTaxReportAccountPositionAllOf {
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'accountId'?: string;
    /**
     * The name of the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'accountName'?: string;
    /**
     * 
     * @type {AccountType}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'accountType'?: AccountType;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'accountWrapperType'?: WrapperType;
    /**
     * The country where the asset was first issued
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'assetCountryOfIssue'?: string;
    /**
     * The type of instrument/asset. The system accounts for Equity, Gilts, Corporate bonds, Cash and Other asset classes. 
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'assetInstrumentType'?: string;
    /**
     * 
     * @type {CgtData}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
    /**
     * The type of instrument/asset. The system accounts for Equity, Gilts, Corporate bonds, Cash and Other asset classes. 
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'instrumentType'?: string;
    /**
     * The unique identifier of the node which manages this record
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'nodeId'?: string;
    /**
     * Calculated percentage OCF
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'ocfCalculated'?: number;
    /**
     * Estimated percentage OCF
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'ocfEstimated'?: number;
    /**
     * The list of prices associated with the position\'s asset
     * @type {Array<GetAssetPrice>}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'prices'?: Array<GetAssetPrice>;
    /**
     * The list of transactions associated with the position.
     * @type {Array<PositionTransaction>}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'transactions'?: Array<PositionTransaction>;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioCapitalGainsTaxReportAccountPositionAllOf
     */
    'wrapperType'?: WrapperType;
}


/**
 * 
 * @export
 * @interface PortfolioCapitalGainsTaxReportProductsInner
 */
export interface PortfolioCapitalGainsTaxReportProductsInner {
    /**
     * Unique id of the account
     * @type {string}
     * @memberof PortfolioCapitalGainsTaxReportProductsInner
     */
    'accountId'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioCapitalGainsTaxReportProductsInner
     */
    'wrapperType'?: WrapperType;
    /**
     * Unique id of last update
     * @type {number}
     * @memberof PortfolioCapitalGainsTaxReportProductsInner
     */
    'remainingSubscriptionAmount'?: number;
}


/**
 * 
 * @export
 * @interface PortfolioCharge
 */
export interface PortfolioCharge {
    /**
     * 
     * @type {ChargeType}
     * @memberof PortfolioCharge
     */
    'chargeType'?: ChargeType;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioCharge
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioCharge
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioCharge
     */
    'fee'?: number;
}


/**
 * @type PortfolioFirmIdGetClientTypeParameter
 * @export
 */
export type PortfolioFirmIdGetClientTypeParameter = Array<string> | string;

/**
 * 
 * @export
 * @interface PortfolioFirmIdGetIntentDetailsParameter
 */
export interface PortfolioFirmIdGetIntentDetailsParameter {
    /**
     * 
     * @type {string}
     * @memberof PortfolioFirmIdGetIntentDetailsParameter
     */
    'clientProductId'?: string;
}
/**
 * 
 * @export
 * @interface PortfolioGroupFeeCoveredAccountItem
 */
export interface PortfolioGroupFeeCoveredAccountItem {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupFeeCoveredAccountItem
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupFeeCoveredAccountItem
     */
    'accountName': string;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioGroupFeeCoveredAccountItem
     */
    'wrapperType': WrapperType;
}


/**
 * 
 * @export
 * @interface PortfolioGroupFeeCoveredAccountsResponse
 */
export interface PortfolioGroupFeeCoveredAccountsResponse {
    /**
     * 
     * @type {Array<PortfolioGroupFeeCoveredAccountItem>}
     * @memberof PortfolioGroupFeeCoveredAccountsResponse
     */
    'data'?: Array<PortfolioGroupFeeCoveredAccountItem>;
}
/**
 * 
 * @export
 * @interface PortfolioGroupNominatedAccountItem
 */
export interface PortfolioGroupNominatedAccountItem {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupNominatedAccountItem
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupNominatedAccountItem
     */
    'accountName': string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioGroupNominatedAccountItem
     */
    'nominated': boolean;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioGroupNominatedAccountItem
     */
    'wrapperType': WrapperType;
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupNominatedAccountItem
     */
    'clientId': string;
}


/**
 * 
 * @export
 * @interface PortfolioGroupNominatedAccountsResponse
 */
export interface PortfolioGroupNominatedAccountsResponse {
    /**
     * 
     * @type {Array<PortfolioGroupNominatedAccountItem>}
     * @memberof PortfolioGroupNominatedAccountsResponse
     */
    'data'?: Array<PortfolioGroupNominatedAccountItem>;
}
/**
 * 
 * @export
 * @interface PortfolioGroupPost201Response
 */
export interface PortfolioGroupPost201Response {
    /**
     * 
     * @type {PortfolioGroupPost201ResponseData}
     * @memberof PortfolioGroupPost201Response
     */
    'data': PortfolioGroupPost201ResponseData;
}
/**
 * 
 * @export
 * @interface PortfolioGroupPost201ResponseData
 */
export interface PortfolioGroupPost201ResponseData {
    /**
     * The unique ID of the portfolio group
     * @type {string}
     * @memberof PortfolioGroupPost201ResponseData
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PortfolioReportTransaction
 */
export interface PortfolioReportTransaction {
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof PortfolioReportTransaction
     */
    'transactionId'?: string;
    /**
     * The transaction code of the transaction
     * @type {string}
     * @memberof PortfolioReportTransaction
     */
    'transactionCode'?: string;
    /**
     * The description of the transaction
     * @type {string}
     * @memberof PortfolioReportTransaction
     */
    'narrative'?: string;
    /**
     * The date the transaction completed
     * @type {string}
     * @memberof PortfolioReportTransaction
     */
    'postDate'?: string;
    /**
     * The date the transaction was created
     * @type {string}
     * @memberof PortfolioReportTransaction
     */
    'valueDate'?: string;
    /**
     * The amount the transaction impacted the client\'s subscription allowance for JISAs or ISAs
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'subscriptionAmount'?: number;
    /**
     * The value of the transaction
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'adjustedProfitLoss'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'bookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'nonTransferBookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'profitLoss'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'transferBookValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'transferValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioReportTransaction
     */
    'value'?: number;
    /**
     * 
     * @type {PortfolioReportTransactionInformation}
     * @memberof PortfolioReportTransaction
     */
    'information'?: PortfolioReportTransactionInformation;
}
/**
 * 
 * @export
 * @interface PortfolioReportTransactionInformation
 */
export interface PortfolioReportTransactionInformation {
    /**
     * The original name of the instrument
     * @type {string}
     * @memberof PortfolioReportTransactionInformation
     */
    'originalInstrumentName'?: string;
    /**
     * The original ISIN of the instrument
     * @type {string}
     * @memberof PortfolioReportTransactionInformation
     */
    'originalIsin'?: string;
    /**
     * The date the dividend payment was paid out
     * @type {string}
     * @memberof PortfolioReportTransactionInformation
     */
    'eventExDate'?: string;
    /**
     * The amount of equalisation payment
     * @type {number}
     * @memberof PortfolioReportTransactionInformation
     */
    'equalisationAmountPayCy'?: number;
}
/**
 * 
 * @export
 * @interface PortfolioSearchMeta
 */
export interface PortfolioSearchMeta {
    /**
     * Total number of results found.
     * @type {number}
     * @memberof PortfolioSearchMeta
     */
    'count'?: number;
    /**
     * 
     * @type {PortfolioSearchPagination}
     * @memberof PortfolioSearchMeta
     */
    'pagination'?: PortfolioSearchPagination;
}
/**
 * 
 * @export
 * @interface PortfolioSearchPagination
 */
export interface PortfolioSearchPagination {
    /**
     * 
     * @type {string}
     * @memberof PortfolioSearchPagination
     */
    'nextToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSearchPagination
     */
    'prevToken'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchPagination
     */
    'pageSize'?: number;
}
/**
 * 
 * @export
 * @interface PortfolioSearchResult
 */
export interface PortfolioSearchResult {
    /**
     * 
     * @type {string}
     * @memberof PortfolioSearchResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSearchResult
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSearchResult
     */
    'status': PortfolioSearchResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSearchResult
     */
    'clientType'?: PortfolioSearchResultClientTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioSearchResult
     */
    'nodeId'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioSearchResult
     */
    'nodeName'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSearchResult
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'currentValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'accounts'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'uninvestedCash'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'growth'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'growthPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'adjustedGrowth'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'adjustedGrowthPercent'?: number;
    /**
     * 
     * @type {PortfolioSummaryData}
     * @memberof PortfolioSearchResult
     */
    'portfolio'?: PortfolioSummaryData;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'maxScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSearchResult
     */
    'normalisedScore'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PortfolioSearchResultStatusEnum {
    Active = 'Active',
    Closed = 'Closed',
    Closing = 'Closing',
    Pending = 'Pending',
    Registered = 'Registered',
    Suspended = 'Suspended'
}
/**
    * @export
    * @enum {string}
    */
export enum PortfolioSearchResultClientTypeEnum {
    Individual = 'Individual',
    IndividualMinor = 'Individual Minor',
    Corporate = 'Corporate',
    Trust = 'Trust'
}

/**
 * 
 * @export
 * @interface PortfolioSummaryAccount
 */
export interface PortfolioSummaryAccount {
    /**
     * The on platform growth value of an investment (the growth since arrival on the platform) 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'adjustedGrowth'?: number;
    /**
     * The percentage adjusted growth at the current record level
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The growth value since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'growth'?: number;
    /**
     * The percentage growth since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'growthPercent'?: number;
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'bookValue'?: number;
    /**
     * The book cost since the transfer settled
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'nonTransferBookValue'?: number;
    /**
     * The number of units multiplied by the price on the day the transfer settled. This will be the same as the bookValue if there\'s been no in-specie transfer 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'transferBookValue'?: number;
    /**
     * The value of cash held by the record at the end of the specified period (if not specified this would be now) 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'closingCashValue'?: number;
    /**
     * The value of stock held by the record at the end of the specified period (if not specified this as at the most recent close of market) 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'closingStockValue'?: number;
    /**
     * The value of cash held at the current record level at the start of the specified period (if not specified this would be record creation) 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'openingCashValue'?: number;
    /**
     * The value of stock held at the current record level at the start of the specified period (if not specified this would be record creation) 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'openingStockValue'?: number;
    /**
     * The opening value of the current record - if no date parameters are provided, this will show as 0 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'openingValue'?: number;
    /**
     * The current total value at the current record level - if no date parameters are provided, this will show as at today\'s date 
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'currentValue'?: number;
    /**
     * The value of the transfer onto the platform at the current record level
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'transferValue'?: number;
    /**
     * The value of available cash held by the record that is not currently invested
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'uninvestedCash'?: number;
    /**
     * 
     * @type {PendingDeposits}
     * @memberof PortfolioSummaryAccount
     */
    'pendingDeposits'?: PendingDeposits;
    /**
     * Settled cash that can be withdrawn now (uninvested cash less any unsettled sells)
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'withdrawableCash'?: number;
    /**
     * Completed sell orders whose cash has executed but not yet settled
     * @type {Array<UnsettledSell>}
     * @memberof PortfolioSummaryAccount
     */
    'unsettledSells'?: Array<UnsettledSell>;
    /**
     * 
     * @type {RingfencedCashBreakdown}
     * @memberof PortfolioSummaryAccount
     */
    'ringfencedCashBreakdown'?: RingfencedCashBreakdown;
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof PortfolioSummaryAccount
     */
    'id': string;
    /**
     * The ID of the client. If the account is a JISA or joint GIA, this field will not be there and there will be a clients field instead
     * @type {string}
     * @memberof PortfolioSummaryAccount
     */
    'clientId'?: string;
    /**
     * 
     * @type {Array<PortfolioSummaryAccountAllOfClients>}
     * @memberof PortfolioSummaryAccount
     */
    'clients'?: Array<PortfolioSummaryAccountAllOfClients>;
    /**
     * The name of the account
     * @type {string}
     * @memberof PortfolioSummaryAccount
     */
    'name'?: string;
    /**
     * 
     * @type {AccountType}
     * @memberof PortfolioSummaryAccount
     */
    'accountType'?: AccountType;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioSummaryAccount
     */
    'currency'?: string;
    /**
     * The name of the asset allocation in which the current record is invested
     * @type {string}
     * @memberof PortfolioSummaryAccount
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the asset allocation in which the current record is invested
     * @type {string}
     * @memberof PortfolioSummaryAccount
     */
    'assetAllocationId'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioSummaryAccount
     */
    'wrapperType'?: WrapperType;
    /**
     * The unique identifier of the node which manages this record
     * @type {string}
     * @memberof PortfolioSummaryAccount
     */
    'nodeId'?: string;
    /**
     * The name of the node within which the current record is held
     * @type {string}
     * @memberof PortfolioSummaryAccount
     */
    'nodeName'?: string;
    /**
     * 
     * @type {AccountStatus}
     * @memberof PortfolioSummaryAccount
     */
    'status'?: AccountStatus;
    /**
     * tbd
     * @type {boolean}
     * @memberof PortfolioSummaryAccount
     */
    'recurringPayment'?: boolean;
    /**
     * 
     * @type {WrapperDetail}
     * @memberof PortfolioSummaryAccount
     */
    'wrapperDetail'?: WrapperDetail;
    /**
     * A percentage value
     * @type {number}
     * @memberof PortfolioSummaryAccount
     */
    'allocation'?: number;
    /**
     * 
     * @type {Array<AccountPortfolioGroup>}
     * @memberof PortfolioSummaryAccount
     */
    'portfolioGroups'?: Array<AccountPortfolioGroup>;
    /**
     * 
     * @type {CgtData}
     * @memberof PortfolioSummaryAccount
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PortfolioSummaryAccount
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}


/**
 * 
 * @export
 * @interface PortfolioSummaryAccountAllOf
 */
export interface PortfolioSummaryAccountAllOf {
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'id': string;
    /**
     * The ID of the client. If the account is a JISA or joint GIA, this field will not be there and there will be a clients field instead
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'clientId'?: string;
    /**
     * 
     * @type {Array<PortfolioSummaryAccountAllOfClients>}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'clients'?: Array<PortfolioSummaryAccountAllOfClients>;
    /**
     * The name of the account
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'name'?: string;
    /**
     * 
     * @type {AccountType}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'accountType'?: AccountType;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'currency'?: string;
    /**
     * The name of the asset allocation in which the current record is invested
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the asset allocation in which the current record is invested
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'assetAllocationId'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'wrapperType'?: WrapperType;
    /**
     * The unique identifier of the node which manages this record
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'nodeId'?: string;
    /**
     * The name of the node within which the current record is held
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'nodeName'?: string;
    /**
     * 
     * @type {AccountStatus}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'status'?: AccountStatus;
    /**
     * tbd
     * @type {boolean}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'recurringPayment'?: boolean;
    /**
     * 
     * @type {WrapperDetail}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'wrapperDetail'?: WrapperDetail;
    /**
     * A percentage value
     * @type {number}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'allocation'?: number;
    /**
     * 
     * @type {Array<AccountPortfolioGroup>}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'portfolioGroups'?: Array<AccountPortfolioGroup>;
    /**
     * 
     * @type {CgtData}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PortfolioSummaryAccountAllOf
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}


/**
 * 
 * @export
 * @interface PortfolioSummaryAccountAllOfClients
 */
export interface PortfolioSummaryAccountAllOfClients {
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioSummaryAccountAllOfClients
     */
    'decisionMaker'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioSummaryAccountAllOfClients
     */
    'isLeadClient'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryAccountAllOfClients
     */
    'owner'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryAccountAllOfClients
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface PortfolioSummaryData
 */
export interface PortfolioSummaryData {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'firmId'?: string;
    /**
     * The unique identifier of the client
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'id': string;
    /**
     * An array of parent ids
     * @type {Array<string>}
     * @memberof PortfolioSummaryData
     */
    'parentId'?: Array<string>;
    /**
     * The full name of the client
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'name': string;
    /**
     * The first name of the client
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'firstName': string;
    /**
     * The surname of the client
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'surname': string;
    /**
     * The language set at the client record
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'language'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'currency'?: string;
    /**
     * The unique identifier of the node that the client is attached to
     * @type {Array<string>}
     * @memberof PortfolioSummaryData
     */
    'nodeId': Array<string>;
    /**
     * The name of the node that the client is attached to
     * @type {Array<string>}
     * @memberof PortfolioSummaryData
     */
    'nodeName'?: Array<string>;
    /**
     * The status of the client record
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'status'?: string;
    /**
     * List of associated client stakeholders
     * @type {Array<PortfolioSummaryDataStakeholdersInner>}
     * @memberof PortfolioSummaryData
     */
    'stakeholders'?: Array<PortfolioSummaryDataStakeholdersInner>;
    /**
     * List of associated entity clients
     * @type {Array<PortfolioSummaryDataLinkedEntityClientsInner>}
     * @memberof PortfolioSummaryData
     */
    'linkedEntityClients'?: Array<PortfolioSummaryDataLinkedEntityClientsInner>;
    /**
     * Contains a summary of the individual cash and asset positions within the portfolio
     * @type {Array<PortfolioSummaryPosition>}
     * @memberof PortfolioSummaryData
     */
    'positions'?: Array<PortfolioSummaryPosition>;
    /**
     * tbd
     * @type {Array<string>}
     * @memberof PortfolioSummaryData
     */
    'completeTransactions'?: Array<string>;
    /**
     * Contains details on the individual investment accounts of the client portfolio
     * @type {Array<PortfolioSummaryAccount>}
     * @memberof PortfolioSummaryData
     */
    'accounts'?: Array<PortfolioSummaryAccount>;
    /**
     * The book value of the asset
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'bookValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryData
     */
    'clientType'?: PortfolioSummaryDataClientTypeEnum;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'nonTransferBookValue'?: number;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'transferBookValue'?: number;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'openingValue'?: number;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'currentValue'?: number;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'uninvestedCash'?: number;
    /**
     * Settled cash that can be withdrawn now (uninvested cash less any unsettled sells)
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'withdrawableCash'?: number;
    /**
     * Completed sell orders whose cash has executed but not yet settled
     * @type {Array<UnsettledSell>}
     * @memberof PortfolioSummaryData
     */
    'unsettledSells'?: Array<UnsettledSell>;
    /**
     * 
     * @type {RingfencedCashBreakdown}
     * @memberof PortfolioSummaryData
     */
    'ringfencedCashBreakdown'?: RingfencedCashBreakdown;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'closingCashValue'?: number;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'growth'?: number;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'growthPercent'?: number;
    /**
     * Amount of adjusted growth
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'adjustedGrowth'?: number;
    /**
     * Percent of the adjust growth
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'adjustedGrowthPercent'?: number;
    /**
     * TBC
     * @type {number}
     * @memberof PortfolioSummaryData
     */
    'transferValue'?: number;
    /**
     * 
     * @type {Array<PortfolioSummaryDataProductsInner>}
     * @memberof PortfolioSummaryData
     */
    'products'?: Array<PortfolioSummaryDataProductsInner>;
    /**
     * 
     * @type {CgtData}
     * @memberof PortfolioSummaryData
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PortfolioSummaryData
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum PortfolioSummaryDataClientTypeEnum {
    Individual = 'Individual',
    IndividualMinor = 'Individual Minor',
    Corporate = 'Corporate',
    Trust = 'Trust'
}

/**
 * 
 * @export
 * @interface PortfolioSummaryDataLinkedEntityClientsInner
 */
export interface PortfolioSummaryDataLinkedEntityClientsInner {
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryDataLinkedEntityClientsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryDataLinkedEntityClientsInner
     */
    'name': string;
    /**
     * Role of this client as a stakeholder
     * @type {string}
     * @memberof PortfolioSummaryDataLinkedEntityClientsInner
     */
    'role': PortfolioSummaryDataLinkedEntityClientsInnerRoleEnum;
    /**
     * Can this client perform client and account management at the entity?
     * @type {boolean}
     * @memberof PortfolioSummaryDataLinkedEntityClientsInner
     */
    'clientAndAccountManagement'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum PortfolioSummaryDataLinkedEntityClientsInnerRoleEnum {
    Director = 'Director',
    SignificantShareholder = 'Significant Shareholder',
    PrincipalOrPartner = 'Principal Or Partner',
    Settlor = 'Settlor',
    Trustee = 'Trustee',
    Beneficiary = 'Beneficiary'
}

/**
 * 
 * @export
 * @interface PortfolioSummaryDataProductsInner
 */
export interface PortfolioSummaryDataProductsInner {
    /**
     * Unique id of the account
     * @type {string}
     * @memberof PortfolioSummaryDataProductsInner
     */
    'accountId'?: string;
    /**
     * Unique id of the client product
     * @type {string}
     * @memberof PortfolioSummaryDataProductsInner
     */
    'clientProductId'?: string;
    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioSummaryDataProductsInner
     */
    'wrapperType'?: WrapperType;
    /**
     * Unique id of last update
     * @type {number}
     * @memberof PortfolioSummaryDataProductsInner
     */
    'remainingSubscriptionAmount'?: number;
}


/**
 * 
 * @export
 * @interface PortfolioSummaryDataStakeholdersInner
 */
export interface PortfolioSummaryDataStakeholdersInner {
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryDataStakeholdersInner
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioSummaryDataStakeholdersInner
     */
    'name': string;
    /**
     * Can this stakeholder perform account management?
     * @type {boolean}
     * @memberof PortfolioSummaryDataStakeholdersInner
     */
    'clientAndAccountManagement'?: boolean;
    /**
     * Role of this stakeholder
     * @type {string}
     * @memberof PortfolioSummaryDataStakeholdersInner
     */
    'role': PortfolioSummaryDataStakeholdersInnerRoleEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PortfolioSummaryDataStakeholdersInnerRoleEnum {
    Director = 'Director',
    SignificantShareholder = 'Significant Shareholder',
    PrincipalOrPartner = 'Principal Or Partner',
    Settlor = 'Settlor',
    Trustee = 'Trustee',
    Beneficiary = 'Beneficiary'
}

/**
 * 
 * @export
 * @interface PortfolioSummaryPosition
 */
export interface PortfolioSummaryPosition {
    /**
     * The on platform growth value of an investment (the growth since arrival on the platform) 
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'adjustedGrowth'?: number;
    /**
     * The percentage adjusted growth at the current record level
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'adjustedGrowthPercent'?: number;
    /**
     * The growth value since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'growth'?: number;
    /**
     * The percentage growth since the book cost at the current record level
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'growthPercent'?: number;
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'bookValue'?: number;
    /**
     * The book cost since the transfer settled
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'nonTransferBookValue'?: number;
    /**
     * The number of units multiplied by the price on the day the transfer settled. This will be the same as the bookValue if there\'s been no in-specie transfer 
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'transferBookValue'?: number;
    /**
     * The opening value of the current record - if no date parameters are provided, this will show as 0 
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'openingValue'?: number;
    /**
     * The current total value at the current record level - if no date parameters are provided, this will show as at today\'s date 
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'currentValue'?: number;
    /**
     * The value of the transfer onto the platform at the current record level
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'transferValue'?: number;
    /**
     * 
     * @type {PositionType}
     * @memberof PortfolioSummaryPosition
     */
    'positionType'?: PositionType;
    /**
     * International Securities Identification Number (ISIN). A 12-digit alphanumeric code that uniquely identifies a specific security 
     * @type {string}
     * @memberof PortfolioSummaryPosition
     */
    'isin'?: string;
    /**
     * The unique identifier of the asset
     * @type {string}
     * @memberof PortfolioSummaryPosition
     */
    'assetId'?: string;
    /**
     * The short name of the asset
     * @type {string}
     * @memberof PortfolioSummaryPosition
     */
    'assetName'?: string;
    /**
     * The number of units in the holding
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'quantity'?: number;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioSummaryPosition
     */
    'currency'?: string;
    /**
     * The current price of the asset – this is the ask of the latest price in the system
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'currentPrice'?: number;
    /**
     * The date of the current price in the system
     * @type {string}
     * @memberof PortfolioSummaryPosition
     */
    'currentPriceDate'?: string;
    /**
     * The number of decimal places that the asset can be held. For example, 0.0001 means the asset can be held to 4 decimal places. This is driven by the fund manager or instrument type 
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'minimumTransferUnit'?: number;
    /**
     * The percentage allocation of the holding within the investment account
     * @type {number}
     * @memberof PortfolioSummaryPosition
     */
    'allocation'?: number;
}


/**
 * 
 * @export
 * @interface PortfolioSummaryPositionAllOf
 */
export interface PortfolioSummaryPositionAllOf {
    /**
     * 
     * @type {PositionType}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'positionType'?: PositionType;
    /**
     * International Securities Identification Number (ISIN). A 12-digit alphanumeric code that uniquely identifies a specific security 
     * @type {string}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'isin'?: string;
    /**
     * The unique identifier of the asset
     * @type {string}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'assetId'?: string;
    /**
     * The short name of the asset
     * @type {string}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'assetName'?: string;
    /**
     * The number of units in the holding
     * @type {number}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'quantity'?: number;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'currency'?: string;
    /**
     * The current price of the asset – this is the ask of the latest price in the system
     * @type {number}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'currentPrice'?: number;
    /**
     * The date of the current price in the system
     * @type {string}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'currentPriceDate'?: string;
    /**
     * The number of decimal places that the asset can be held. For example, 0.0001 means the asset can be held to 4 decimal places. This is driven by the fund manager or instrument type 
     * @type {number}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'minimumTransferUnit'?: number;
    /**
     * The percentage allocation of the holding within the investment account
     * @type {number}
     * @memberof PortfolioSummaryPositionAllOf
     */
    'allocation'?: number;
}


/**
 * 
 * @export
 * @interface PortfolioTransactionGroupPost200Response
 */
export interface PortfolioTransactionGroupPost200Response {
    /**
     * 
     * @type {PortfolioTransactionGroupPost200ResponseData}
     * @memberof PortfolioTransactionGroupPost200Response
     */
    'data'?: PortfolioTransactionGroupPost200ResponseData;
}
/**
 * 
 * @export
 * @interface PortfolioTransactionGroupPost200ResponseData
 */
export interface PortfolioTransactionGroupPost200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionGroupPost200ResponseData
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PortfolioTransactionSubType {
    AccumulationDividend = 'Accumulation Dividend',
    Cash = 'Cash',
    InSpecie = 'In Specie'
}


/**
 * @type PortfoliotransactionFirmIdGetAccountIdParameter
 * @export
 */
export type PortfoliotransactionFirmIdGetAccountIdParameter = Array<string> | string;

/**
 * @type PortfoliotransactionFirmIdGetMethodParameter
 * @export
 */
export type PortfoliotransactionFirmIdGetMethodParameter = Array<string> | string;

/**
 * @type PortfoliotransactionFirmIdGetTransactionSubTypeParameter
 * @export
 */
export type PortfoliotransactionFirmIdGetTransactionSubTypeParameter = Array<string> | string;

/**
 * 
 * @export
 * @interface PortfoliotransactionPost200Response
 */
export interface PortfoliotransactionPost200Response {
    /**
     * 
     * @type {PortfoliotransactionPost200ResponseData}
     * @memberof PortfoliotransactionPost200Response
     */
    'data': PortfoliotransactionPost200ResponseData;
}
/**
 * 
 * @export
 * @interface PortfoliotransactionPost200ResponseData
 */
export interface PortfoliotransactionPost200ResponseData {
    /**
     * The unique ID of the portfolio transaction
     * @type {string}
     * @memberof PortfoliotransactionPost200ResponseData
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PositionTransaction
 */
export interface PositionTransaction {
    /**
     * The book value of the holding (cost of purchasing the holding) since inception. The value at the current record level reflecting the acquisition cost of an investment in order to both show the on-going performance whilst it is still held, and any capital gain or loss following a sale, or corporate action. 
     * @type {number}
     * @memberof PositionTransaction
     */
    'bookValue'?: number;
    /**
     * The book cost since the transfer settled
     * @type {number}
     * @memberof PositionTransaction
     */
    'nonTransferBookValue'?: number;
    /**
     * The number of units multiplied by the price on the day the transfer settled. This will be the same as the bookValue if there\'s been no in-specie transfer 
     * @type {number}
     * @memberof PositionTransaction
     */
    'transferBookValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionTransaction
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTransaction
     */
    'transactionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTransaction
     */
    'narrative'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTransaction
     */
    'postDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTransaction
     */
    'valueDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionTransaction
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionTransaction
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionTransaction
     */
    'executionTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionTransaction
     */
    'profitLoss'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionTransaction
     */
    'adjustedProfitLoss'?: number;
    /**
     * 
     * @type {CgtData}
     * @memberof PositionTransaction
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PositionTransaction
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}
/**
 * 
 * @export
 * @interface PositionTransactionAllOf
 */
export interface PositionTransactionAllOf {
    /**
     * 
     * @type {string}
     * @memberof PositionTransactionAllOf
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTransactionAllOf
     */
    'transactionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTransactionAllOf
     */
    'narrative'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTransactionAllOf
     */
    'postDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTransactionAllOf
     */
    'valueDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionTransactionAllOf
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionTransactionAllOf
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionTransactionAllOf
     */
    'executionTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionTransactionAllOf
     */
    'profitLoss'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionTransactionAllOf
     */
    'adjustedProfitLoss'?: number;
    /**
     * 
     * @type {CgtData}
     * @memberof PositionTransactionAllOf
     */
    'cgtData'?: CgtData;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof PositionTransactionAllOf
     */
    'disclaimers'?: Array<CgtDisclaimersInner>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum PositionType {
    Stock = 'Stock',
    Cash = 'Cash'
}


/**
 * 
 * @export
 * @interface PostmarkMessage
 */
export interface PostmarkMessage {
    /**
     * Unique ID of the message
     * @type {string}
     * @memberof PostmarkMessage
     */
    'messageId': string;
    /**
     * Timestamp of when the message was sent by Postmark
     * @type {string}
     * @memberof PostmarkMessage
     */
    'receivedAt': string;
    /**
     * Email subject
     * @type {string}
     * @memberof PostmarkMessage
     */
    'subject': string;
    /**
     * 
     * @type {PostmarkMessageStatus}
     * @memberof PostmarkMessage
     */
    'status': PostmarkMessageStatus;
}


/**
 * 
 * @export
 * @interface PostmarkMessageDetails
 */
export interface PostmarkMessageDetails {
    /**
     * Unique ID of the message
     * @type {string}
     * @memberof PostmarkMessageDetails
     */
    'messageId': string;
    /**
     * Timestamp of when the message was sent by Postmark
     * @type {string}
     * @memberof PostmarkMessageDetails
     */
    'receivedAt': string;
    /**
     * Email subject
     * @type {string}
     * @memberof PostmarkMessageDetails
     */
    'subject': string;
    /**
     * 
     * @type {PostmarkMessageStatus}
     * @memberof PostmarkMessageDetails
     */
    'status': PostmarkMessageStatus;
    /**
     * List of events that have happened to this message
     * @type {Array<PostmarkMessageEvent>}
     * @memberof PostmarkMessageDetails
     */
    'messageEvents'?: Array<PostmarkMessageEvent>;
}


/**
 * 
 * @export
 * @interface PostmarkMessageDetailsAllOf
 */
export interface PostmarkMessageDetailsAllOf {
    /**
     * List of events that have happened to this message
     * @type {Array<PostmarkMessageEvent>}
     * @memberof PostmarkMessageDetailsAllOf
     */
    'messageEvents'?: Array<PostmarkMessageEvent>;
}
/**
 * 
 * @export
 * @interface PostmarkMessageEvent
 */
export interface PostmarkMessageEvent {
    /**
     * 
     * @type {PostmarkMessageEventType}
     * @memberof PostmarkMessageEvent
     */
    'type': PostmarkMessageEventType;
    /**
     * The recipient email address
     * @type {string}
     * @memberof PostmarkMessageEvent
     */
    'recipient': string;
    /**
     * Timestamp of when the event occurred
     * @type {string}
     * @memberof PostmarkMessageEvent
     */
    'receivedAt': string;
    /**
     * 
     * @type {PostmarkMessageEventDetails}
     * @memberof PostmarkMessageEvent
     */
    'details'?: PostmarkMessageEventDetails;
}


/**
 * Event-specific details
 * @export
 * @interface PostmarkMessageEventDetails
 */
export interface PostmarkMessageEventDetails {
    /**
     * 
     * @type {string}
     * @memberof PostmarkMessageEventDetails
     */
    'deliveryMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostmarkMessageEventDetails
     */
    'summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostmarkMessageEventDetails
     */
    'bounceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostmarkMessageEventDetails
     */
    'origin'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostmarkMessageEventDetails
     */
    'suppressSending'?: string;
}
/**
 * Event types that can occur for a message
 * @export
 * @enum {string}
 */

export enum PostmarkMessageEventType {
    Delivered = 'Delivered',
    Transient = 'Transient',
    Bounced = 'Bounced',
    SubscriptionChanged = 'SubscriptionChanged',
    Opened = 'Opened',
    LinkClicked = 'LinkClicked'
}


/**
 * Status of message in Postmark activity
 * @export
 * @enum {string}
 */

export enum PostmarkMessageStatus {
    Queued = 'Queued',
    Sent = 'Sent',
    Processed = 'Processed'
}


/**
 * The type of ISA account held with the ceding provider
 * @export
 * @enum {string}
 */

export enum PreviousProviderAccountType {
    Cash = 'Cash',
    StocksAndShares = 'Stocks and Shares'
}


/**
 * The details of the pension product
 * @export
 * @interface ProductDetail
 */
export interface ProductDetail {
    /**
     * The amount of the account which has been crystallised
     * @type {number}
     * @memberof ProductDetail
     */
    'crystallisedAmount'?: number;
    /**
     * The date on which the pension was transitioned to a flexi-access drawdown
     * @type {string}
     * @memberof ProductDetail
     */
    'flexiAccessDate'?: string;
    /**
     * Whether the pension\'s flexible benefits have been accessed
     * @type {boolean}
     * @memberof ProductDetail
     */
    'flexibleBenefitsAccessed'?: boolean;
    /**
     * Whether the pension has been opted out of
     * @type {boolean}
     * @memberof ProductDetail
     */
    'pensionOptOut'?: boolean;
}
/**
 * 
 * @export
 * @interface ProfessionalConfiguration
 */
export interface ProfessionalConfiguration {
    /**
     * 
     * @type {ProfessionalConfigurationWindowTitle}
     * @memberof ProfessionalConfiguration
     */
    'windowTitle': ProfessionalConfigurationWindowTitle;
}
/**
 * The page title for the Pro UI
 * @export
 * @interface ProfessionalConfigurationWindowTitle
 */
export interface ProfessionalConfigurationWindowTitle {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ProfessionalConfigurationWindowTitle
     */
    'sourceNodeId': string;
    /**
     * The value of the content.
     * @type {string}
     * @memberof ProfessionalConfigurationWindowTitle
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ProfessionalContent
 */
export interface ProfessionalContent {
    /**
     * 
     * @type {ProfessionalContentOrderUrl}
     * @memberof ProfessionalContent
     */
    'orderUrl'?: ProfessionalContentOrderUrl;
    /**
     * 
     * @type {ProfessionalContentClientFooterCopyright}
     * @memberof ProfessionalContent
     */
    'clientFooterCopyright'?: ProfessionalContentClientFooterCopyright;
}
/**
 * HTML content to be rendered in the footer. Allowed tags: <p>, <a>, <strong>, <em>. Scripts and inline styles are removed. 
 * @export
 * @interface ProfessionalContentClientFooterCopyright
 */
export interface ProfessionalContentClientFooterCopyright {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ProfessionalContentClientFooterCopyright
     */
    'sourceNodeId': string;
    /**
     * The html value.
     * @type {string}
     * @memberof ProfessionalContentClientFooterCopyright
     */
    'value': string;
}
/**
 * The URL for order execution.
 * @export
 * @interface ProfessionalContentOrderUrl
 */
export interface ProfessionalContentOrderUrl {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ProfessionalContentOrderUrl
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof ProfessionalContentOrderUrl
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ProfessionalTheme
 */
export interface ProfessionalTheme {
    /**
     * 
     * @type {ProfessionalThemePrimaryColour}
     * @memberof ProfessionalTheme
     */
    'primaryColour': ProfessionalThemePrimaryColour;
    /**
     * 
     * @type {ProfessionalThemeBackgroundColour}
     * @memberof ProfessionalTheme
     */
    'backgroundColour': ProfessionalThemeBackgroundColour;
    /**
     * 
     * @type {ProfessionalThemeBackgroundColourContrast}
     * @memberof ProfessionalTheme
     */
    'backgroundColourContrast': ProfessionalThemeBackgroundColourContrast;
    /**
     * 
     * @type {ProfessionalThemeCtaColour}
     * @memberof ProfessionalTheme
     */
    'ctaColour': ProfessionalThemeCtaColour;
    /**
     * 
     * @type {ProfessionalThemeCtaColourContrast}
     * @memberof ProfessionalTheme
     */
    'ctaColourContrast': ProfessionalThemeCtaColourContrast;
}
/**
 * The hexcode representation of the background colour for the Advisor UI.
 * @export
 * @interface ProfessionalThemeBackgroundColour
 */
export interface ProfessionalThemeBackgroundColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ProfessionalThemeBackgroundColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof ProfessionalThemeBackgroundColour
     */
    'value': string;
}
/**
 * The hexcode representation of the background colour contrast for the Advisor UI.
 * @export
 * @interface ProfessionalThemeBackgroundColourContrast
 */
export interface ProfessionalThemeBackgroundColourContrast {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ProfessionalThemeBackgroundColourContrast
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof ProfessionalThemeBackgroundColourContrast
     */
    'value': string;
}
/**
 * The hexcode representation of the call to action colour for the Advisor UI.
 * @export
 * @interface ProfessionalThemeCtaColour
 */
export interface ProfessionalThemeCtaColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ProfessionalThemeCtaColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof ProfessionalThemeCtaColour
     */
    'value': string;
}
/**
 * The hexcode representation of the call to action colour contrast for the Advisor UI.
 * @export
 * @interface ProfessionalThemeCtaColourContrast
 */
export interface ProfessionalThemeCtaColourContrast {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ProfessionalThemeCtaColourContrast
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof ProfessionalThemeCtaColourContrast
     */
    'value': string;
}
/**
 * The hexcode representation of the primary colour for the Advisor UI.
 * @export
 * @interface ProfessionalThemePrimaryColour
 */
export interface ProfessionalThemePrimaryColour {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof ProfessionalThemePrimaryColour
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof ProfessionalThemePrimaryColour
     */
    'value': string;
}
/**
 * @type PutClientUpdateData
 * @export
 */
export type PutClientUpdateData = ClientCorporateOptional1 | ClientIndividualMinorOptional1 | ClientIndividualOptional1 | ClientTrustOptional1;

/**
 * Contains details of charges taken in the portfolio
 * @export
 * @interface ReportCharges
 */
export interface ReportCharges {
    /**
     * Contains details of charge transactions taken in the portfolio
     * @type {Array<ReportChargesTransactionsInner>}
     * @memberof ReportCharges
     */
    'transactions'?: Array<ReportChargesTransactionsInner>;
    /**
     * The total value of the charge amounts deducted from the portfolio
     * @type {number}
     * @memberof ReportCharges
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ReportChargesTransactionsInner
 */
export interface ReportChargesTransactionsInner {
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof ReportChargesTransactionsInner
     */
    'transactionId'?: string;
    /**
     * The transaction code of the transaction
     * @type {string}
     * @memberof ReportChargesTransactionsInner
     */
    'transactionCode'?: string;
    /**
     * The description of the transaction
     * @type {string}
     * @memberof ReportChargesTransactionsInner
     */
    'narrative'?: string;
    /**
     * The date the transaction completed
     * @type {string}
     * @memberof ReportChargesTransactionsInner
     */
    'postDate'?: string;
    /**
     * The date the transaction was created
     * @type {string}
     * @memberof ReportChargesTransactionsInner
     */
    'valueDate'?: string;
    /**
     * The value of the transaction - this will show as a negative value for charges
     * @type {number}
     * @memberof ReportChargesTransactionsInner
     */
    'amount'?: number;
}
/**
 * Contains details of income on the portfolio, which includes dividends and interest
 * @export
 * @interface ReportIncome
 */
export interface ReportIncome {
    /**
     * Contains details of income transactions
     * @type {Array<ReportIncomeTransactionsInner>}
     * @memberof ReportIncome
     */
    'transactions'?: Array<ReportIncomeTransactionsInner>;
    /**
     * The amount of income transactions
     * @type {number}
     * @memberof ReportIncome
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ReportIncomeTransactionsInner
 */
export interface ReportIncomeTransactionsInner {
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof ReportIncomeTransactionsInner
     */
    'transactionId'?: string;
    /**
     * The transaction code of the transaction
     * @type {string}
     * @memberof ReportIncomeTransactionsInner
     */
    'transactionCode'?: string;
    /**
     * The description of the transaction
     * @type {string}
     * @memberof ReportIncomeTransactionsInner
     */
    'narrative'?: string;
    /**
     * The date the transaction completed
     * @type {string}
     * @memberof ReportIncomeTransactionsInner
     */
    'postDate'?: string;
    /**
     * The date the transaction was created
     * @type {string}
     * @memberof ReportIncomeTransactionsInner
     */
    'valueDate'?: string;
    /**
     * 
     * @type {ReportIncomeTransactionsInnerInformation}
     * @memberof ReportIncomeTransactionsInner
     */
    'information'?: ReportIncomeTransactionsInnerInformation;
    /**
     * The value of the transaction
     * @type {number}
     * @memberof ReportIncomeTransactionsInner
     */
    'amount'?: number;
    /**
     * Used to provide net value of dividend transaction i.e (gross - equalisation payment)
     * @type {number}
     * @memberof ReportIncomeTransactionsInner
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface ReportIncomeTransactionsInnerInformation
 */
export interface ReportIncomeTransactionsInnerInformation {
    /**
     * The original name of the instrument
     * @type {string}
     * @memberof ReportIncomeTransactionsInnerInformation
     */
    'originalInstrumentName'?: string;
    /**
     * The original ISIN of the instrument
     * @type {string}
     * @memberof ReportIncomeTransactionsInnerInformation
     */
    'originalIsin'?: string;
    /**
     * The date the dividend payment was paid out
     * @type {string}
     * @memberof ReportIncomeTransactionsInnerInformation
     */
    'eventPayDate'?: string;
}
/**
 * Contains details of internal cash transfers between investment accounts
 * @export
 * @interface ReportInternalTransfers
 */
export interface ReportInternalTransfers {
    /**
     * Contains details of internal cash transfers in
     * @type {Array<PortfolioReportTransaction>}
     * @memberof ReportInternalTransfers
     */
    'transactionsIn'?: Array<PortfolioReportTransaction>;
    /**
     * Contains details of internal cash transfers out
     * @type {Array<PortfolioReportTransaction>}
     * @memberof ReportInternalTransfers
     */
    'transactionsOut'?: Array<PortfolioReportTransaction>;
    /**
     * The total value of the transfer in transactions
     * @type {number}
     * @memberof ReportInternalTransfers
     */
    'totalIn'?: number;
    /**
     * The total value of the transfer out transactions
     * @type {number}
     * @memberof ReportInternalTransfers
     */
    'totalOut'?: number;
}
/**
 * Contains details of payments in and out of the portfolio
 * @export
 * @interface ReportPayments
 */
export interface ReportPayments {
    /**
     * Contains details of payments in
     * @type {Array<PortfolioReportTransaction>}
     * @memberof ReportPayments
     */
    'transactionsIn'?: Array<PortfolioReportTransaction>;
    /**
     * Contains details of payments out
     * @type {Array<PortfolioReportTransaction>}
     * @memberof ReportPayments
     */
    'transactionsOut'?: Array<PortfolioReportTransaction>;
    /**
     * The total amount of the payment in transactions
     * @type {number}
     * @memberof ReportPayments
     */
    'totalIn'?: number;
    /**
     * The total amount of the payment out transactions
     * @type {number}
     * @memberof ReportPayments
     */
    'totalOut'?: number;
}
/**
 * Contains details of asset holdings in the portfolio
 * @export
 * @interface ReportPerformance
 */
export interface ReportPerformance {
    /**
     * Contains details of transactions realised in the portfolio
     * @type {Array<ReportPerformanceTransactionsRealisedInner>}
     * @memberof ReportPerformance
     */
    'transactionsRealised'?: Array<ReportPerformanceTransactionsRealisedInner>;
    /**
     * Contains a summary of positions retained within the portfolio
     * @type {Array<ReportPerformancePositionsRetainedInner>}
     * @memberof ReportPerformance
     */
    'positionsRetained'?: Array<ReportPerformancePositionsRetainedInner>;
    /**
     * The sum of the value of realised holdings
     * @type {number}
     * @memberof ReportPerformance
     */
    'totalRealised'?: number;
    /**
     * The sum of the current value of retained holdings
     * @type {number}
     * @memberof ReportPerformance
     */
    'totalRetained'?: number;
}
/**
 * 
 * @export
 * @interface ReportPerformancePositionsRetainedInner
 */
export interface ReportPerformancePositionsRetainedInner {
    /**
     * The ISIN of the asset
     * @type {string}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'isin'?: string;
    /**
     * The name of the asset
     * @type {string}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'assetName'?: string;
    /**
     * The number of units held in the asset
     * @type {number}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'quantity'?: number;
    /**
     * The book cost of the holding
     * @type {number}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'bookValue'?: number;
    /**
     * The book cost of the holding since the transfer settled
     * @type {number}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'transferBookValue'?: number;
    /**
     * The book cost since the in-specie transfer settled
     * @type {number}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'nonTransferBookValue'?: number;
    /**
     * The value of the holding
     * @type {number}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'currentValue'?: number;
    /**
     * The growth of the holding since on the platform
     * @type {number}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'growth'?: number;
    /**
     * The growth of the holding since the book cost
     * @type {number}
     * @memberof ReportPerformancePositionsRetainedInner
     */
    'adjustedGrowth'?: number;
}
/**
 * 
 * @export
 * @interface ReportPerformanceTransactionsRealisedInner
 */
export interface ReportPerformanceTransactionsRealisedInner {
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'transactionId'?: string;
    /**
     * The transaction code of the transaction
     * @type {string}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'transactionCode'?: string;
    /**
     * The description of the transaction
     * @type {string}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'narrative'?: string;
    /**
     * The completed date of the transaction
     * @type {string}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'postDate'?: string;
    /**
     * The created date of the transaction
     * @type {string}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'valueDate'?: string;
    /**
     * The number of units transacted
     * @type {number}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'quantity'?: number;
    /**
     * The value of the transaction
     * @type {number}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'value'?: number;
    /**
     * The value of the profit or loss since book cost
     * @type {number}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'profitLoss'?: number;
    /**
     * The value of the profit or loss since asset on platform
     * @type {number}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'adjustedProfitLoss'?: number;
    /**
     * The book value of the holding (cost of purchasing the holding) since inception
     * @type {number}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'bookValue'?: number;
    /**
     * The book cost since the in-specie transfer settled
     * @type {number}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'transferBookValue'?: number;
    /**
     * The book cost since the in-specie transfer settled
     * @type {number}
     * @memberof ReportPerformanceTransactionsRealisedInner
     */
    'nonTransferBookValue'?: number;
}
/**
 * Contains details of transfers in the portfolio
 * @export
 * @interface ReportTransfers
 */
export interface ReportTransfers {
    /**
     * Contains details of transfers in transactions
     * @type {Array<ReportTransfersTransactionsInInner>}
     * @memberof ReportTransfers
     */
    'transactionsIn'?: Array<ReportTransfersTransactionsInInner>;
    /**
     * Contains details of transfers out transactions
     * @type {Array<ReportTransfersTransactionsOutInner>}
     * @memberof ReportTransfers
     */
    'transactionsOut'?: Array<ReportTransfersTransactionsOutInner>;
    /**
     * The total value of the transfer in transactions
     * @type {number}
     * @memberof ReportTransfers
     */
    'totalIn'?: number;
    /**
     * The total value of the transfer out transactions
     * @type {number}
     * @memberof ReportTransfers
     */
    'totalOut'?: number;
}
/**
 * 
 * @export
 * @interface ReportTransfersTransactionsInInner
 */
export interface ReportTransfersTransactionsInInner {
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsInInner
     */
    'transactionId': string;
    /**
     * The transaction code of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsInInner
     */
    'transactionCode'?: string;
    /**
     * The description of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsInInner
     */
    'narrative': string;
    /**
     * The completed date of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsInInner
     */
    'postDate'?: string;
    /**
     * The created date of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsInInner
     */
    'valueDate'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof ReportTransfersTransactionsInInner
     */
    'quantity'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof ReportTransfersTransactionsInInner
     */
    'transferValue'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof ReportTransfersTransactionsInInner
     */
    'bookValue'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof ReportTransfersTransactionsInInner
     */
    'transferBookValue'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof ReportTransfersTransactionsInInner
     */
    'nonTransferBookValue'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof ReportTransfersTransactionsInInner
     */
    'profitLoss'?: number;
    /**
     * TBD
     * @type {number}
     * @memberof ReportTransfersTransactionsInInner
     */
    'adjustedProfitLoss'?: number;
    /**
     * The value of the transaction. Used for Transfer In transactions
     * @type {number}
     * @memberof ReportTransfersTransactionsInInner
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface ReportTransfersTransactionsOutInner
 */
export interface ReportTransfersTransactionsOutInner {
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsOutInner
     */
    'transactionId': string;
    /**
     * The transaction code of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsOutInner
     */
    'transactionCode'?: string;
    /**
     * The description of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsOutInner
     */
    'narrative': string;
    /**
     * The completed date of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsOutInner
     */
    'postDate'?: string;
    /**
     * The created date of the transaction
     * @type {string}
     * @memberof ReportTransfersTransactionsOutInner
     */
    'valueDate'?: string;
    /**
     * The amount the transaction impacted the client\'s subscription allowance for JISAs or ISAs
     * @type {number}
     * @memberof ReportTransfersTransactionsOutInner
     */
    'subscriptionAmount'?: number;
    /**
     * The value of the transaction. Used on historic Stock Transfers
     * @type {number}
     * @memberof ReportTransfersTransactionsOutInner
     */
    'transferValue'?: number;
    /**
     * The value of the transaction
     * @type {number}
     * @memberof ReportTransfersTransactionsOutInner
     */
    'amount': number;
}
/**
 * Reset password object
 * @export
 * @interface ResetPassword
 */
export interface ResetPassword {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ResetPassword
     */
    'firmId'?: string;
    /**
     * Surname of the User
     * @type {string}
     * @memberof ResetPassword
     */
    'surname'?: string;
    /**
     * The unique id of the user or the email address of the user
     * @type {string}
     * @memberof ResetPassword
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface ResetPost200Response
 */
export interface ResetPost200Response {
    /**
     * 
     * @type {object}
     * @memberof ResetPost200Response
     */
    'data'?: object;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum Resource {
    Client = 'Client',
    Account = 'Account',
    Model = 'Model',
    AdvisoryModel = 'Advisory Model',
    Transaction = 'Transaction',
    User = 'User',
    Recommendation = 'Recommendation',
    Instrument = 'Instrument',
    ClientEnhanced = 'Client Enhanced',
    ClientFeeGroup = 'Client Fee Group',
    KnowYourBusiness = 'Know Your Business',
    BankDetails = 'Bank Details',
    FirmManagement = 'Firm Management',
    NodeSwitch = 'Node Switch',
    Notifications = 'Notifications',
    PortfolioAnalysis = 'Portfolio Analysis'
}


/**
 * The transactions responsible for cash being ring-fenced (reserved)
 * @export
 * @interface RingfencedCashBreakdown
 */
export interface RingfencedCashBreakdown {
    /**
     * 
     * @type {Array<RingfencedCashContribution>}
     * @memberof RingfencedCashBreakdown
     */
    'contributions'?: Array<RingfencedCashContribution>;
}
/**
 * A single cause of cash being ring-fenced (reserved) against a pending transaction, identifying the transaction(s) responsible so consumers can navigate to the activity, and the amount this cause reserves. The reserved balance is the sum of the contribution amounts, so the settled total can be reconstructed as uninvestedCash + the summed amounts.
 * @export
 * @interface RingfencedCashContribution
 */
export interface RingfencedCashContribution {
    /**
     * The portfolio transaction group (linkId) when the cause is a linked group
     * @type {string}
     * @memberof RingfencedCashContribution
     */
    'transactionGroupId'?: string;
    /**
     * Every transaction id participating in this cause
     * @type {Array<string>}
     * @memberof RingfencedCashContribution
     */
    'transactionIds'?: Array<string>;
    /**
     * The amount of cash this cause reserves (a positive figure)
     * @type {number}
     * @memberof RingfencedCashContribution
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface SchemeProductFirmIdGet200Response
 */
export interface SchemeProductFirmIdGet200Response {
    /**
     * 
     * @type {Array<GetSchemaProductGetData>}
     * @memberof SchemeProductFirmIdGet200Response
     */
    'data'?: Array<GetSchemaProductGetData>;
    /**
     * 
     * @type {GetSchemaProductGetMeta}
     * @memberof SchemeProductFirmIdGet200Response
     */
    'meta'?: GetSchemaProductGetMeta;
}
/**
 * 
 * @export
 * @interface SearchScores
 */
export interface SearchScores {
    /**
     * 
     * @type {number}
     * @memberof SearchScores
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchScores
     */
    'maxScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchScores
     */
    'normalisedScore'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SellDown {
    Full = 'Full',
    Largest = 'Largest',
    Proportional = 'Proportional'
}


/**
 * The type of sells to create for sell downs.
 * @export
 * @enum {string}
 */

export enum SellDownSellType {
    Amount = 'Amount',
    AmountFirst = 'AmountFirst',
    Quantity = 'Quantity'
}


/**
 * Set password object
 * @export
 * @interface SetPassword
 */
export interface SetPassword {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof SetPassword
     */
    'firmId'?: string;
    /**
     * Unique identifer for the user
     * @type {string}
     * @memberof SetPassword
     */
    'id'?: string;
    /**
     * Password for the user
     * @type {string}
     * @memberof SetPassword
     */
    'password'?: string;
    /**
     * The password token provided by Seccl
     * @type {string}
     * @memberof SetPassword
     */
    'passwordToken'?: string;
}
/**
 * 
 * @export
 * @interface SigningDetails
 */
export interface SigningDetails {
    /**
     * Hash of the signed document for integrity verification
     * @type {string}
     * @memberof SigningDetails
     */
    'documentHash': string;
    /**
     * Timestamp when the document was signed
     * @type {string}
     * @memberof SigningDetails
     */
    'signedOn': string;
    /**
     * IP address of the user who signed
     * @type {string}
     * @memberof SigningDetails
     */
    'userIP': string;
    /**
     * User agent string of the browser used for signing
     * @type {string}
     * @memberof SigningDetails
     */
    'userAgent': string;
    /**
     * Session ID associated with the signing action
     * @type {string}
     * @memberof SigningDetails
     */
    'sessionId': string;
}
/**
 * 
 * @export
 * @interface SimulateCapitalGainsScenario
 */
export interface SimulateCapitalGainsScenario {
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof SimulateCapitalGainsScenario
     */
    'accountId': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof SimulateCapitalGainsScenario
     */
    'firmId': string;
    /**
     * A map of asset IDs to simulated order details
     * @type {{ [key: string]: CapitalGainsScenarioSimulatedOrder; }}
     * @memberof SimulateCapitalGainsScenario
     */
    'simulatedOrders'?: { [key: string]: CapitalGainsScenarioSimulatedOrder; };
}
/**
 * 
 * @export
 * @interface SimulateCapitalGainsScenarioResponse
 */
export interface SimulateCapitalGainsScenarioResponse {
    /**
     * 
     * @type {SimulateCapitalGainsScenarioResponseData}
     * @memberof SimulateCapitalGainsScenarioResponse
     */
    'data': SimulateCapitalGainsScenarioResponseData;
}
/**
 * 
 * @export
 * @interface SimulateCapitalGainsScenarioResponseData
 */
export interface SimulateCapitalGainsScenarioResponseData {
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'accountId': string;
    /**
     * 
     * @type {WrapperType}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'wrapperType': WrapperType;
    /**
     * 
     * @type {AccountStatus}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'status': AccountStatus;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'currency': string;
    /**
     * The start date of the simulation period
     * @type {string}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'fromDate': string;
    /**
     * The end date of the simulation period
     * @type {string}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'toDate': string;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'disclaimers': Array<CgtDisclaimersInner>;
    /**
     * List of investments with their CGT simulation data
     * @type {Array<CapitalGainsScenarioSimulatedInvestment>}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'investments': Array<CapitalGainsScenarioSimulatedInvestment>;
    /**
     * 
     * @type {CapitalGainsScenarioSimulatedTotals}
     * @memberof SimulateCapitalGainsScenarioResponseData
     */
    'totals': CapitalGainsScenarioSimulatedTotals;
}


/**
 * 
 * @export
 * @interface SimulateCapitalGainsTarget
 */
export interface SimulateCapitalGainsTarget {
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof SimulateCapitalGainsTarget
     */
    'accountId': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof SimulateCapitalGainsTarget
     */
    'firmId': string;
    /**
     * 
     * @type {CgtTarget}
     * @memberof SimulateCapitalGainsTarget
     */
    'target': CgtTarget;
}
/**
 * 
 * @export
 * @interface SimulateCapitalGainsTargetResponse
 */
export interface SimulateCapitalGainsTargetResponse {
    /**
     * 
     * @type {SimulateCapitalGainsTargetResponseData}
     * @memberof SimulateCapitalGainsTargetResponse
     */
    'data': SimulateCapitalGainsTargetResponseData;
}
/**
 * 
 * @export
 * @interface SimulateCapitalGainsTargetResponseData
 */
export interface SimulateCapitalGainsTargetResponseData {
    /**
     * The unique identifier for the account
     * @type {string}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'accountId': string;
    /**
     * 
     * @type {WrapperType}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'wrapperType': WrapperType;
    /**
     * 
     * @type {AccountStatus}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'status': AccountStatus;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'currency': string;
    /**
     * The start date of the simulation period
     * @type {string}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'fromDate': string;
    /**
     * The end date of the simulation period
     * @type {string}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'toDate': string;
    /**
     * The list of disclaimers at the current record level
     * @type {Array<CgtDisclaimersInner>}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'disclaimers': Array<CgtDisclaimersInner>;
    /**
     * List of investments with their CGT simulation data
     * @type {Array<CapitalGainsScenarioSimulatedInvestment>}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'investments': Array<CapitalGainsScenarioSimulatedInvestment>;
    /**
     * 
     * @type {CapitalGainsScenarioSimulatedTotals}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'totals': CapitalGainsScenarioSimulatedTotals;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'firmId': string;
    /**
     * 
     * @type {CgtTarget}
     * @memberof SimulateCapitalGainsTargetResponseData
     */
    'target': CgtTarget;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum SubscriptionYearType {
    CurrentYear = 'Current Year',
    PreviousYear = 'Previous Year'
}


/**
 * 
 * @export
 * @interface Suitability
 */
export interface Suitability {
    /**
     * 
     * @type {SuitabilityDocument}
     * @memberof Suitability
     */
    'document': SuitabilityDocument;
    /**
     * 
     * @type {SuitabilityStatus}
     * @memberof Suitability
     */
    'status'?: SuitabilityStatus;
    /**
     * 
     * @type {SigningDetails}
     * @memberof Suitability
     */
    'signingDetails'?: SigningDetails;
}


/**
 * 
 * @export
 * @interface SuitabilityDocument
 */
export interface SuitabilityDocument {
    /**
     * Unique identifier for the suitability document
     * @type {string}
     * @memberof SuitabilityDocument
     */
    'id': string;
    /**
     * Timestamp when the document was uploaded
     * @type {string}
     * @memberof SuitabilityDocument
     */
    'uploadedOn': string;
    /**
     * 
     * @type {SuitabilityDocumentUploadedBy}
     * @memberof SuitabilityDocument
     */
    'uploadedBy': SuitabilityDocumentUploadedBy;
    /**
     * Hash of the document for integrity verification
     * @type {string}
     * @memberof SuitabilityDocument
     */
    'documentHash': string;
}
/**
 * 
 * @export
 * @interface SuitabilityDocumentUploadedBy
 */
export interface SuitabilityDocumentUploadedBy {
    /**
     * ID of the user who uploaded the document
     * @type {string}
     * @memberof SuitabilityDocumentUploadedBy
     */
    'userId': string;
    /**
     * Firm ID of the user who uploaded the document
     * @type {string}
     * @memberof SuitabilityDocumentUploadedBy
     */
    'userFirmId': string;
    /**
     * Type of the user who uploaded the document
     * @type {string}
     * @memberof SuitabilityDocumentUploadedBy
     */
    'userType': SuitabilityDocumentUploadedByUserTypeEnum;
    /**
     * Name of the user who uploaded the document
     * @type {string}
     * @memberof SuitabilityDocumentUploadedBy
     */
    'userName'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SuitabilityDocumentUploadedByUserTypeEnum {
    Client = 'Client',
    User = 'User',
    Machine = 'Machine'
}

/**
 * The status of suitability assessment
 * @export
 * @enum {string}
 */

export enum SuitabilityStatus {
    Accepted = 'Accepted',
    Rejected = 'Rejected'
}


/**
 * Details capturing the client\'s mobile phone number
 * @export
 * @interface Telephone
 */
export interface Telephone {
    /**
     * The client\'s mobile phone number
     * @type {string}
     * @memberof Telephone
     */
    'number'?: string;
    /**
     * The geographical location of the client\'s mobile phone number
     * @type {string}
     * @memberof Telephone
     */
    'locale'?: string;
    /**
     * Confirms the client\'s phone number is a mobile phone number
     * @type {boolean}
     * @memberof Telephone
     */
    'isMobile'?: boolean;
}
/**
 * 
 * @export
 * @interface TradeIllustration
 */
export interface TradeIllustration {
    /**
     * 
     * @type {TradeIllustrationData}
     * @memberof TradeIllustration
     */
    'data'?: TradeIllustrationData;
}
/**
 * 
 * @export
 * @interface TradeIllustrationData
 */
export interface TradeIllustrationData {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof TradeIllustrationData
     */
    'firmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeIllustrationData
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TradeIllustrationData
     */
    'accountName'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof TradeIllustrationData
     */
    'currency'?: string;
    /**
     * 
     * @type {Array<AssetCharge>}
     * @memberof TradeIllustrationData
     */
    'initialCharges'?: Array<AssetCharge>;
    /**
     * 
     * @type {TradeIllustrationDataOngoingCharges}
     * @memberof TradeIllustrationData
     */
    'ongoingCharges'?: TradeIllustrationDataOngoingCharges;
    /**
     * 
     * @type {Array<TradeIllustrationDataCalculationsAfterEachPeriodInner>}
     * @memberof TradeIllustrationData
     */
    'calculationsAfterEachPeriod'?: Array<TradeIllustrationDataCalculationsAfterEachPeriodInner>;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationData
     */
    'investmentAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationData
     */
    'finalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationData
     */
    'totalInitialCharges': number | null;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationData
     */
    'totalOngoingCharges': number | null;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationData
     */
    'totalTransactionCharges'?: number;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationData
     */
    'totalCharges': number | null;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationData
     */
    'totalChargesPercent': number | null;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationData
     */
    'totalGrowth': number | null;
}
/**
 * 
 * @export
 * @interface TradeIllustrationDataCalculationsAfterEachPeriodInner
 */
export interface TradeIllustrationDataCalculationsAfterEachPeriodInner {
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInner
     */
    'periodIndex'?: number;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInner
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInner
     */
    'openingAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInner
     */
    'growthAmount'?: number;
    /**
     * 
     * @type {TradeIllustrationDataOngoingCharges}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInner
     */
    'ongoingCharges'?: TradeIllustrationDataOngoingCharges;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInner
     */
    'totalCharges'?: number;
    /**
     * 
     * @type {number}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInner
     */
    'closingAmount'?: number;
    /**
     * 
     * @type {TradeIllustrationDataCalculationsAfterEachPeriodInnerTransactionCharges}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInner
     */
    'transactionCharges'?: TradeIllustrationDataCalculationsAfterEachPeriodInnerTransactionCharges;
}
/**
 * 
 * @export
 * @interface TradeIllustrationDataCalculationsAfterEachPeriodInnerTransactionCharges
 */
export interface TradeIllustrationDataCalculationsAfterEachPeriodInnerTransactionCharges {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInnerTransactionCharges
     */
    'Stamp'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInnerTransactionCharges
     */
    'Dealing'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInnerTransactionCharges
     */
    'PTM'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TradeIllustrationDataCalculationsAfterEachPeriodInnerTransactionCharges
     */
    'total'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface TradeIllustrationDataOngoingCharges
 */
export interface TradeIllustrationDataOngoingCharges {
    /**
     * 
     * @type {Array<PortfolioCharge>}
     * @memberof TradeIllustrationDataOngoingCharges
     */
    'portfolioCharges'?: Array<PortfolioCharge>;
    /**
     * 
     * @type {Array<AssetCharge>}
     * @memberof TradeIllustrationDataOngoingCharges
     */
    'assetCharges'?: Array<AssetCharge>;
}
/**
 * 
 * @export
 * @interface TradingCharges
 */
export interface TradingCharges {
    /**
     * 
     * @type {Array<string>}
     * @memberof TradingCharges
     */
    'instrumentTypes'?: Array<string>;
    /**
     * 
     * @type {Array<TradingChargesTiers>}
     * @memberof TradingCharges
     */
    'tiers'?: Array<TradingChargesTiers>;
    /**
     * 
     * @type {number}
     * @memberof TradingCharges
     */
    'minimumAmount'?: number;
}
/**
 * 
 * @export
 * @interface TradingChargesResponse
 */
export interface TradingChargesResponse {
    /**
     * 
     * @type {Array<TradingCharges>}
     * @memberof TradingChargesResponse
     */
    'data'?: Array<TradingCharges>;
}
/**
 * 
 * @export
 * @interface TradingChargesTiers
 */
export interface TradingChargesTiers {
    /**
     * 
     * @type {number}
     * @memberof TradingChargesTiers
     */
    'rate'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TransactionStatus {
    Completed = 'Completed',
    Deleted = 'Deleted',
    Pending = 'Pending',
    Placed = 'Placed',
    Waiting = 'Waiting',
    Checking = 'Checking',
    Error = 'Error'
}


/**
 * 
 * @export
 * @interface TransactionStatusChange
 */
export interface TransactionStatusChange {
    /**
     * 
     * @type {string}
     * @memberof TransactionStatusChange
     */
    'description'?: string;
    /**
     * 
     * @type {TransactionStatus}
     * @memberof TransactionStatusChange
     */
    'status'?: TransactionStatus;
    /**
     * 
     * @type {TransferStatus}
     * @memberof TransactionStatusChange
     */
    'transferStatus'?: TransferStatus;
    /**
     * 
     * @type {string}
     * @memberof TransactionStatusChange
     */
    'statusDate': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum TransactionSubType {
    Withdrawal = 'Withdrawal',
    Deposit = 'Deposit',
    AtBest = 'At Best',
    Internal = 'Internal',
    Stock = 'Stock',
    AdviserAdhocFee = 'Adviser Adhoc Fee',
    Employer = 'Employer',
    Employee = 'Employee',
    Pcls = 'PCLS',
    Fad = 'FAD',
    FadGrossWithdrawal = 'FAD Gross Withdrawal',
    Ufpls = 'UFPLS',
    UfplsGrossWithdrawal = 'UFPLS Gross Withdrawal',
    Transfer = 'Transfer'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum TransactionType {
    Payment = 'Payment',
    Order = 'Order',
    ProductTransfer = 'Product Transfer',
    StockTransfer = 'Stock Transfer',
    Stock = 'Stock',
    CashTransfer = 'Cash Transfer',
    Cash = 'Cash',
    Notional = 'Notional',
    Expectation = 'Expectation'
}


/**
 * 
 * @export
 * @interface TransactionsV2Pagination
 */
export interface TransactionsV2Pagination {
    /**
     * 
     * @type {TransactionsV2PaginationPagination}
     * @memberof TransactionsV2Pagination
     */
    'pagination'?: TransactionsV2PaginationPagination;
}
/**
 * 
 * @export
 * @interface TransactionsV2PaginationPagination
 */
export interface TransactionsV2PaginationPagination {
    /**
     * 
     * @type {string}
     * @memberof TransactionsV2PaginationPagination
     */
    'nextToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionsV2PaginationPagination
     */
    'prevToken'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransactionsV2PaginationPagination
     */
    'pageSize'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TransferMovementType {
    In = 'In',
    Out = 'Out'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum TransferStatus {
    Completed = 'Completed',
    WithPreviousProvider = 'With Previous Provider',
    AwaitingCrystallisationInformation = 'Awaiting Crystallisation Information',
    AwaitingSellDown = 'Awaiting sell down',
    OnboardingAssets = 'Onboarding Assets',
    Pending = 'Pending',
    Rejected = 'Rejected',
    Deleted = 'Deleted',
    AwaitingDocumentation = 'Awaiting Documentation',
    VerifyingDocumentation = 'Verifying Documentation',
    ReviewingDocumentation = 'Reviewing Documentation',
    Cancelled = 'Cancelled',
    PendingCancellation = 'Pending Cancellation'
}


/**
 * 
 * @export
 * @interface TransferStatusChange
 */
export interface TransferStatusChange {
    /**
     * 
     * @type {string}
     * @memberof TransferStatusChange
     */
    'description'?: string;
    /**
     * 
     * @type {TransferStatus}
     * @memberof TransferStatusChange
     */
    'status'?: TransferStatus;
    /**
     * 
     * @type {TransferStatus}
     * @memberof TransferStatusChange
     */
    'transferStatus'?: TransferStatus;
    /**
     * 
     * @type {string}
     * @memberof TransferStatusChange
     */
    'statusDate': string;
}


/**
 * 
 * @export
 * @interface TransferTransaction
 */
export interface TransferTransaction {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof TransferTransaction
     */
    'firmId': string;
    /**
     * The unique identifier of the investment account to instruct the transfer
     * @type {string}
     * @memberof TransferTransaction
     */
    'accountId': string;
    /**
     * The quantity of the asset to be transferred
     * @type {number}
     * @memberof TransferTransaction
     */
    'quantity'?: number;
    /**
     * 
     * @type {TransactionType}
     * @memberof TransferTransaction
     */
    'transactionType': TransactionType;
    /**
     * 
     * @type {TransferTransactionTransactionSubType}
     * @memberof TransferTransaction
     */
    'transactionSubType': TransferTransactionTransactionSubType;
    /**
     * 
     * @type {MovementType}
     * @memberof TransferTransaction
     */
    'movementType': MovementType;
    /**
     * A boolean value to indicate whether the transaction is to invest to model
     * @type {boolean}
     * @memberof TransferTransaction
     */
    'investToModel'?: boolean;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof TransferTransaction
     */
    'method'?: PaymentMethod;
    /**
     * Whether to forward date a withdrawal until sufficient cash is withdrawable
     * @type {boolean}
     * @memberof TransferTransaction
     */
    'forwardDate'?: boolean;
    /**
     * The employer\'s registration number
     * @type {string}
     * @memberof TransferTransaction
     */
    'companyRegNo'?: string;
    /**
     * Three-letter ISO code for the currency paid in or out of the account
     * @type {string}
     * @memberof TransferTransaction
     */
    'currency'?: string;
    /**
     * The amount of the transaction
     * @type {number}
     * @memberof TransferTransaction
     */
    'amount'?: number;
    /**
     * The percentage of the transaction
     * @type {number}
     * @memberof TransferTransaction
     */
    'percentage'?: number;
    /**
     * The unique identifier for the asset
     * @type {string}
     * @memberof TransferTransaction
     */
    'assetId'?: string;
    /**
     * 
     * @type {SellDown}
     * @memberof TransferTransaction
     */
    'autoDisinvest'?: SellDown;
    /**
     * 
     * @type {SellDownSellType}
     * @memberof TransferTransaction
     */
    'autoDisinvestSellType'?: SellDownSellType;
    /**
     * The previousProviderId of the ceding provider – this should be retrieved from the masterparty/platform endpoint
     * @type {string}
     * @memberof TransferTransaction
     */
    'previousProvider'?: string;
    /**
     * The account reference number held by the ceding provider
     * @type {string}
     * @memberof TransferTransaction
     */
    'previousProviderRef'?: string;
    /**
     * 
     * @type {PreviousProviderAccountType}
     * @memberof TransferTransaction
     */
    'previousProviderAccountType'?: PreviousProviderAccountType;
    /**
     * The unique identifier of the investment account where the cash is being transferred to
     * @type {string}
     * @memberof TransferTransaction
     */
    'destinationAccount'?: string;
    /**
     * Indicates whether the money should be auto-invested to the model attached to the destinationAccount
     * @type {boolean}
     * @memberof TransferTransaction
     */
    'autoInvest'?: boolean;
    /**
     * 
     * @type {AddressDetail}
     * @memberof TransferTransaction
     */
    'transferAccountAddress'?: AddressDetail;
    /**
     * Indicates whether the pension being transferred contains Safeguarded Rights - Required for Seccl pension only
     * @type {boolean}
     * @memberof TransferTransaction
     */
    'isPensionTransfer'?: boolean;
    /**
     * The estimated value of the transfer
     * @type {number}
     * @memberof TransferTransaction
     */
    'transferValue'?: number;
    /**
     * The part of the pension account to be transferred – No Drawdown is the only option available for accumulation pensions
     * @type {string}
     * @memberof TransferTransaction
     */
    'productDrawdownStatus'?: TransferTransactionProductDrawdownStatusEnum;
    /**
     * The FCA reference number of the advice firm that provided the advice around transferring the pension with Safeguarded Rights.
     * @type {string}
     * @memberof TransferTransaction
     */
    'fcaReference'?: string;
    /**
     * 
     * @type {PensionAccountGroupType}
     * @memberof TransferTransaction
     */
    'pensionAccountGroupType'?: PensionAccountGroupType;
    /**
     * Indicates w hether the pension being transferred is a partial cash transfer
     * @type {boolean}
     * @memberof TransferTransaction
     */
    'partialTransfer'?: boolean;
    /**
     * The estimated value of the transfer
     * @type {number}
     * @memberof TransferTransaction
     */
    'amountToTake'?: number;
    /**
     * The remaining balance at the ceding scheme after the transfer has completed
     * @type {number}
     * @memberof TransferTransaction
     */
    'amountToLeave'?: number;
    /**
     * The ID of another product transfer that be used to link previously failed transfers together
     * @type {string}
     * @memberof TransferTransaction
     */
    'previousTransferId'?: string;
    /**
     * The unique identifier of the primary client
     * @type {string}
     * @memberof TransferTransaction
     */
    'primaryClientId'?: string;
    /**
     * The unique identifier for the attached file upload
     * @type {string}
     * @memberof TransferTransaction
     */
    'uploadedFileDetailsId'?: string;
    /**
     * 
     * @type {TransferTransactionTransferFee}
     * @memberof TransferTransaction
     */
    'transferFee'?: TransferTransactionTransferFee;
    /**
     * 
     * @type {PayUkDetails}
     * @memberof TransferTransaction
     */
    'payUkDetails'?: PayUkDetails;
    /**
     * 
     * @type {SubscriptionYearType}
     * @memberof TransferTransaction
     */
    'subscriptionAppliesTo'?: SubscriptionYearType;
}

/**
    * @export
    * @enum {string}
    */
export enum TransferTransactionProductDrawdownStatusEnum {
    NoDrawdown = 'No Drawdown',
    PartialDrawdown = 'Partial Drawdown',
    FullDrawdown = 'Full Drawdown'
}

/**
 * 
 * @export
 * @interface TransferTransactionTransactionSubType
 */
export interface TransferTransactionTransactionSubType {
}
/**
 * The transfer fee charged by the ceding provider
 * @export
 * @interface TransferTransactionTransferFee
 */
export interface TransferTransactionTransferFee {
    /**
     * The percentage rate of the transfer fee
     * @type {number}
     * @memberof TransferTransactionTransferFee
     */
    'ratePercentage'?: number;
    /**
     * The Adviser fee type
     * @type {string}
     * @memberof TransferTransactionTransferFee
     */
    'feeType'?: TransferTransactionTransferFeeFeeTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TransferTransactionTransferFeeFeeTypeEnum {
    InitialFee = 'Adviser Initial Fee',
    AdhocFee = 'Adviser Adhoc Fee'
}

/**
 * 
 * @export
 * @interface TransferUpdateEvent
 */
export interface TransferUpdateEvent {
    /**
     * The ID of the firm who createx the note
     * @type {string}
     * @memberof TransferUpdateEvent
     */
    'createdByFirm': string;
    /**
     * 
     * @type {TransferUpdateEventType}
     * @memberof TransferUpdateEvent
     */
    'historyType': TransferUpdateEventType;
    /**
     * Human readable update code (restricted values)
     * @type {string}
     * @memberof TransferUpdateEvent
     */
    'updateCode': string;
    /**
     * Optional additional information
     * @type {string}
     * @memberof TransferUpdateEvent
     */
    'updateNote'?: string;
    /**
     * Date note was created
     * @type {string}
     * @memberof TransferUpdateEvent
     */
    'createdAt': string;
    /**
     * Date note is effective from
     * @type {string}
     * @memberof TransferUpdateEvent
     */
    'effectiveFrom': string;
}


/**
 * 
 * @export
 * @interface TransferUpdateEventRequest
 */
export interface TransferUpdateEventRequest {
    /**
     * 
     * @type {TransferUpdateEventType}
     * @memberof TransferUpdateEventRequest
     */
    'historyType': TransferUpdateEventType;
    /**
     * Human readable update code (restricted values)
     * @type {string}
     * @memberof TransferUpdateEventRequest
     */
    'updateCode': string;
    /**
     * Optional additional information
     * @type {string}
     * @memberof TransferUpdateEventRequest
     */
    'updateNote'?: string;
    /**
     * Date note is effective from
     * @type {string}
     * @memberof TransferUpdateEventRequest
     */
    'effectiveFrom'?: string;
}


/**
 * Type of the update
 * @export
 * @enum {string}
 */

export enum TransferUpdateEventType {
    Info = 'INFO',
    ClientAction = 'CLIENT_ACTION',
    InternalNote = 'INTERNAL_NOTE'
}


/**
 * 
 * @export
 * @interface TrustClient
 */
export interface TrustClient {
    /**
     * 
     * @type {string}
     * @memberof TrustClient
     */
    'id'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof TrustClient
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof TrustClient
     */
    'nodeId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrustClient
     */
    'clientType': string;
    /**
     * The status of the client
     * @type {string}
     * @memberof TrustClient
     */
    'status'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof TrustClient
     */
    'currency': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof TrustClient
     */
    'addressDetail'?: AddressDetail;
    /**
     * 
     * @type {BaseCreateClientBankDetails}
     * @memberof TrustClient
     */
    'bankDetails'?: BaseCreateClientBankDetails;
    /**
     * The client\'s preferred language of communication
     * @type {string}
     * @memberof TrustClient
     */
    'language': string;
    /**
     * Whether or not the client has accepted the platform terms and conditions – this should be set to true
     * @type {boolean}
     * @memberof TrustClient
     */
    'termsAccepted'?: boolean;
    /**
     * The client\'s current place of residence
     * @type {string}
     * @memberof TrustClient
     */
    'taxDomicile': string;
    /**
     * 
     * @type {BaseCreateClientClientGroups}
     * @memberof TrustClient
     */
    'clientGroups'?: BaseCreateClientClientGroups;
    /**
     * 
     * @type {BaseCreateClientFeeStructures}
     * @memberof TrustClient
     */
    'feeStructures'?: BaseCreateClientFeeStructures;
    /**
     * The registered trust name
     * @type {string}
     * @memberof TrustClient
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsTrust}
     * @memberof TrustClient
     */
    'entityDetails'?: EntityDetailsTrust;
}
/**
 * 
 * @export
 * @interface TrustClientSpecifics
 */
export interface TrustClientSpecifics {
    /**
     * 
     * @type {string}
     * @memberof TrustClientSpecifics
     */
    'clientType'?: string;
    /**
     * The registered trust name
     * @type {string}
     * @memberof TrustClientSpecifics
     */
    'entityName'?: string;
    /**
     * 
     * @type {EntityDetailsTrust}
     * @memberof TrustClientSpecifics
     */
    'entityDetails'?: EntityDetailsTrust;
}
/**
 * Object representing an entity client stakeholders who is not already a client
 * @export
 * @interface TrustStakeholderNonClient
 */
export interface TrustStakeholderNonClient {
    /**
     * The ID of the client object representing this stakeholder
     * @type {string}
     * @memberof TrustStakeholderNonClient
     */
    'clientId': string;
    /**
     * Allowed management permissions
     * @type {boolean}
     * @memberof TrustStakeholderNonClient
     */
    'clientAndAccountManagement'?: boolean;
}
/**
 * 
 * @export
 * @interface TrustStakeholderRole
 */
export interface TrustStakeholderRole {
    /**
     * Role of this stakeholder
     * @type {string}
     * @memberof TrustStakeholderRole
     */
    'role'?: TrustStakeholderRoleRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof TrustStakeholderRole
     */
    'relationshipToBeneficiary'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrustStakeholderRole
     */
    'sourceOfWealth'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum TrustStakeholderRoleRoleEnum {
    Settlor = 'Settlor',
    Trustee = 'Trustee',
    Beneficiary = 'Beneficiary'
}

/**
 * A completed sell order whose cash has not yet settled
 * @export
 * @interface UnsettledSell
 */
export interface UnsettledSell {
    /**
     * The identifier of the unsettled sell transaction
     * @type {string}
     * @memberof UnsettledSell
     */
    'transactionId'?: string;
    /**
     * The date the sell is expected to settle
     * @type {string}
     * @memberof UnsettledSell
     */
    'intendedSettlementDate'?: string;
}
/**
 * 
 * @export
 * @interface UpdateAsset
 */
export interface UpdateAsset {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAsset
     */
    'availableToNodeId'?: Array<string>;
    /**
     * 
     * @type {Array<AssetClassificationsInner>}
     * @memberof UpdateAsset
     */
    'classifications'?: Array<AssetClassificationsInner>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAsset
     */
    'customName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAsset
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAsset
     */
    'updateId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateBookValues
 */
export interface UpdateBookValues {
    /**
     * Contains details of the stock transfer transactions to updated
     * @type {Array<UpdateBookValuesTransactionsInner>}
     * @memberof UpdateBookValues
     */
    'transactions'?: Array<UpdateBookValuesTransactionsInner>;
}
/**
 * 
 * @export
 * @interface UpdateBookValuesTransactionsInner
 */
export interface UpdateBookValuesTransactionsInner {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof UpdateBookValuesTransactionsInner
     */
    'firmId': string;
    /**
     * The unique identifier of the stock transaction
     * @type {string}
     * @memberof UpdateBookValuesTransactionsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookValuesTransactionsInner
     */
    'assetName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookValuesTransactionsInner
     */
    'isin': string;
    /**
     * The updated book value of the asset
     * @type {number}
     * @memberof UpdateBookValuesTransactionsInner
     */
    'bookValue': number;
    /**
     * The number of units of the asset currently owned
     * @type {number}
     * @memberof UpdateBookValuesTransactionsInner
     */
    'quantity': number;
    /**
     * The current transfer (estimated) value of the asset
     * @type {number}
     * @memberof UpdateBookValuesTransactionsInner
     */
    'transferValue': number;
    /**
     * The unique identifier of the last update from the transfer
     * @type {string}
     * @memberof UpdateBookValuesTransactionsInner
     */
    'updateId': string;
}
/**
 * 
 * @export
 * @interface UpdateClientProduct
 */
export interface UpdateClientProduct {
    /**
     * The unique identifier of your firm
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'firmId'?: string;
    /**
     * The node Id that the client record is attached to
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'nodeId'?: string;
    /**
     * Contains the associated client Ids
     * @type {Array<string>}
     * @memberof UpdateClientProduct
     */
    'clientIds'?: Array<string>;
    /**
     * 
     * @type {WrapperType}
     * @memberof UpdateClientProduct
     */
    'wrapperType'?: WrapperType;
    /**
     * The scheme product Id of the product – this is relevant for pension products
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'schemeProductId'?: string;
    /**
     * The date the client accepted the ISA terms
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'declarationAcceptedDate'?: string;
    /**
     * The date the ISA declaration expires – if the client opens an ISA, accepts the declaration and doesn\'t contribute for an entire tax year, they will be required to re-accept the ISA declaration in order to contribute
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'declarationExpiryDate'?: string;
    /**
     * Contains details of the client\'s nominated beneficiaries for their pension
     * @type {Array<UpdateClientProductExpressionOfWishNominationsInner>}
     * @memberof UpdateClientProduct
     */
    'expressionOfWishNominations'?: Array<UpdateClientProductExpressionOfWishNominationsInner>;
    /**
     * Name of the product
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'productName'?: string;
    /**
     * Contains details of external account Ids of the product provider
     * @type {Array<UpdateClientProductExternalIdsInner>}
     * @memberof UpdateClientProduct
     */
    'externalIds'?: Array<UpdateClientProductExternalIdsInner>;
    /**
     * Indicates that the client has accepted the pension terms
     * @type {boolean}
     * @memberof UpdateClientProduct
     */
    'acceptedProviderTerms'?: boolean;
    /**
     * The date the client accepted the pension terms
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'acceptedProviderTermsDate'?: string;
    /**
     * 
     * @type {ClientProductStatus}
     * @memberof UpdateClientProduct
     */
    'productStatus'?: ClientProductStatus;
    /**
     * The unique identifier of the investment account that the client wishes to take income from – this is relevant for Gaudi pensions only
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'incomeAccountId'?: string;
    /**
     * The unique identifier assigned to the record the last time it was updated
     * @type {string}
     * @memberof UpdateClientProduct
     */
    'updateId'?: string;
    /**
     * 
     * @type {Array<UpdateClientProductLifetimeAllowanceEnhancementFactorsInner>}
     * @memberof UpdateClientProduct
     */
    'lifetimeAllowanceEnhancementFactors'?: Array<UpdateClientProductLifetimeAllowanceEnhancementFactorsInner>;
    /**
     * 
     * @type {UpdateClientProductProductDetail}
     * @memberof UpdateClientProduct
     */
    'productDetail'?: UpdateClientProductProductDetail;
}


/**
 * 
 * @export
 * @interface UpdateClientProductExpressionOfWishNominationsInner
 */
export interface UpdateClientProductExpressionOfWishNominationsInner {
    /**
     * 
     * @type {BeneficiaryTitle}
     * @memberof UpdateClientProductExpressionOfWishNominationsInner
     */
    'title'?: BeneficiaryTitle;
    /**
     * Surname of beneficiary
     * @type {string}
     * @memberof UpdateClientProductExpressionOfWishNominationsInner
     */
    'surname'?: string;
    /**
     * First name of beneficiary
     * @type {string}
     * @memberof UpdateClientProductExpressionOfWishNominationsInner
     */
    'firstName'?: string;
    /**
     * 
     * @type {BeneficiaryRelationship}
     * @memberof UpdateClientProductExpressionOfWishNominationsInner
     */
    'beneficiaryRelationship'?: BeneficiaryRelationship;
    /**
     * propertion of beneficiary
     * @type {number}
     * @memberof UpdateClientProductExpressionOfWishNominationsInner
     */
    'beneficiaryProportion'?: number;
}


/**
 * 
 * @export
 * @interface UpdateClientProductExternalIdsInner
 */
export interface UpdateClientProductExternalIdsInner {
    /**
     * Value of external Id
     * @type {string}
     * @memberof UpdateClientProductExternalIdsInner
     */
    'value'?: string;
    /**
     * Type of external ID
     * @type {string}
     * @memberof UpdateClientProductExternalIdsInner
     */
    'idType'?: string;
}
/**
 * 
 * @export
 * @interface UpdateClientProductLifetimeAllowanceEnhancementFactorsInner
 */
export interface UpdateClientProductLifetimeAllowanceEnhancementFactorsInner {
    /**
     * 
     * @type {LTAEnhancementFactorType}
     * @memberof UpdateClientProductLifetimeAllowanceEnhancementFactorsInner
     */
    'type'?: LTAEnhancementFactorType;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientProductLifetimeAllowanceEnhancementFactorsInner
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateClientProductLifetimeAllowanceEnhancementFactorsInner
     */
    'rate'?: number;
}


/**
 * 
 * @export
 * @interface UpdateClientProductProductDetail
 */
export interface UpdateClientProductProductDetail {
    /**
     * 
     * @type {Array<UpdateClientProductProductDetailProtectionInner>}
     * @memberof UpdateClientProductProductDetail
     */
    'protection'?: Array<UpdateClientProductProductDetailProtectionInner>;
    /**
     * 
     * @type {number}
     * @memberof UpdateClientProductProductDetail
     */
    'lifetimeAllowanceUsedElsewhere'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateClientProductProductDetail
     */
    'lumpSumAllowanceUsedElsewhere'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateClientProductProductDetail
     */
    'lumpSumAllowanceUsedPreApril2024'?: number;
    /**
     * Name of the product
     * @type {string}
     * @memberof UpdateClientProductProductDetail
     */
    'productName'?: string;
    /**
     * Contains details of external account Ids of the product provider
     * @type {Array<UpdateClientProductExternalIdsInner>}
     * @memberof UpdateClientProductProductDetail
     */
    'externalIds'?: Array<UpdateClientProductExternalIdsInner>;
    /**
     * Indicates that the client has accepted the pension terms
     * @type {boolean}
     * @memberof UpdateClientProductProductDetail
     */
    'acceptedProviderTerms'?: boolean;
    /**
     * The date the client accepted the pension terms
     * @type {string}
     * @memberof UpdateClientProductProductDetail
     */
    'acceptedProviderTermsDate'?: string;
    /**
     * 
     * @type {ClientProductStatus}
     * @memberof UpdateClientProductProductDetail
     */
    'productStatus'?: ClientProductStatus;
    /**
     * The unique identifier of the investment account that the client wishes to take income from – this is relevant for Gaudi pensions only
     * @type {string}
     * @memberof UpdateClientProductProductDetail
     */
    'incomeAccountId'?: string;
    /**
     * The unique identifier assigned to the record the last time it was updated
     * @type {string}
     * @memberof UpdateClientProductProductDetail
     */
    'updateId'?: string;
}


/**
 * 
 * @export
 * @interface UpdateClientProductProductDetailProtectionInner
 */
export interface UpdateClientProductProductDetailProtectionInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientProductProductDetailProtectionInner
     */
    'protectionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientProductProductDetailProtectionInner
     */
    'certificateReferenceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientProductProductDetailProtectionInner
     */
    'schemeAdminReferenceNumber'?: string;
    /**
     * 
     * @type {BeneficiaryRelationship}
     * @memberof UpdateClientProductProductDetailProtectionInner
     */
    'beneficiaryRelationship'?: BeneficiaryRelationship;
    /**
     * propertion of beneficiary
     * @type {number}
     * @memberof UpdateClientProductProductDetailProtectionInner
     */
    'beneficiaryProportion'?: number;
}


/**
 * 
 * @export
 * @interface UpdateClientStatus
 */
export interface UpdateClientStatus {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStatus
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStatus
     */
    'updateAction': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStatus
     */
    'updateReason': string;
    /**
     * 
     * @type {PutClientUpdateData}
     * @memberof UpdateClientStatus
     */
    'updateData'?: PutClientUpdateData;
}
/**
 * 
 * @export
 * @interface UpdateMessageStatus
 */
export interface UpdateMessageStatus {
    /**
     * 
     * @type {UpdateMessageStatusData}
     * @memberof UpdateMessageStatus
     */
    'data'?: UpdateMessageStatusData;
}
/**
 * 
 * @export
 * @interface UpdateMessageStatusData
 */
export interface UpdateMessageStatusData {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof UpdateMessageStatusData
     */
    'firmId': string;
    /**
     * id of the message
     * @type {string}
     * @memberof UpdateMessageStatusData
     */
    'id': string;
    /**
     * Action to be updated
     * @type {string}
     * @memberof UpdateMessageStatusData
     */
    'updateAction': string;
    /**
     * reason message
     * @type {string}
     * @memberof UpdateMessageStatusData
     */
    'updateReason': string;
    /**
     * 
     * @type {UpdateMessageStatusDataUpdateData}
     * @memberof UpdateMessageStatusData
     */
    'updateData': UpdateMessageStatusDataUpdateData;
    /**
     * Unique hash for previous change
     * @type {string}
     * @memberof UpdateMessageStatusData
     */
    'updateId': string;
}
/**
 * Data to be updated
 * @export
 * @interface UpdateMessageStatusDataUpdateData
 */
export interface UpdateMessageStatusDataUpdateData {
    /**
     * updated status to read
     * @type {boolean}
     * @memberof UpdateMessageStatusDataUpdateData
     */
    'read'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateModel
 */
export interface UpdateModel {
    /**
     * The unique guid of the last update
     * @type {string}
     * @memberof UpdateModel
     */
    'updateId': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof UpdateModel
     */
    'firmId': string;
    /**
     * The name of the mode
     * @type {string}
     * @memberof UpdateModel
     */
    'name': string;
    /**
     * A summary or information about the model
     * @type {string}
     * @memberof UpdateModel
     */
    'commentary': string;
    /**
     * TBD The risk rating of the model on a scale of 1-10
     * @type {number}
     * @memberof UpdateModel
     */
    'riskRating': number;
    /**
     * The url to the Key Features document for the model
     * @type {string}
     * @memberof UpdateModel
     */
    'url'?: string;
    /**
     * The Legal Entity Identifier of the firm who made the investment decision of the assets in the model
     * @type {string}
     * @memberof UpdateModel
     */
    'lei'?: string;
    /**
     * The aim of the model
     * @type {string}
     * @memberof UpdateModel
     */
    'aim': string;
    /**
     * The charge percentage of the model
     * @type {number}
     * @memberof UpdateModel
     */
    'modelCharge'?: number;
    /**
     * Whether VAT can be applied to the model
     * @type {boolean}
     * @memberof UpdateModel
     */
    'vatable'?: boolean;
    /**
     * Whether this model should have rebalances suspended
     * @type {boolean}
     * @memberof UpdateModel
     */
    'suspendRebalances': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateModel
     */
    'availableToNodeId': Array<string>;
    /**
     * details of the alocations
     * @type {Array<UpdateModelAllocationsInner>}
     * @memberof UpdateModel
     */
    'allocations': Array<UpdateModelAllocationsInner>;
}
/**
 * 
 * @export
 * @interface UpdateModelAllocationsInner
 */
export interface UpdateModelAllocationsInner {
    /**
     * The cash allocation for the model. This is automatically generated where asset allocations do not add up to 1 (100%) but can be specified.
     * @type {number}
     * @memberof UpdateModelAllocationsInner
     */
    'cashAllocation'?: number;
    /**
     * The type of products the model can be used with
     * @type {Array<string>}
     * @memberof UpdateModelAllocationsInner
     */
    'productType': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateUser
 */
export interface UpdateUser {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof UpdateUser
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user should be attached to
     * @type {Array<string>}
     * @memberof UpdateUser
     */
    'nodeId': Array<string>;
    /**
     * The first name of the user
     * @type {string}
     * @memberof UpdateUser
     */
    'firstName': string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof UpdateUser
     */
    'surname': string;
    /**
     * The email address of the user
     * @type {string}
     * @memberof UpdateUser
     */
    'email': string;
    /**
     * 
     * @type {UserMachineType}
     * @memberof UpdateUser
     */
    'userType': UserMachineType;
    /**
     * The levels of access a user has. These are read, read/write and action. The scopes can be implemented across different areas of the system outlined below
     * @type {Array<UpdateUserScopesInner>}
     * @memberof UpdateUser
     */
    'scopes': Array<UpdateUserScopesInner>;
    /**
     * 
     * @type {CreateUserInvestmentDecision}
     * @memberof UpdateUser
     */
    'investmentDecision': CreateUserInvestmentDecision;
}


/**
 * 
 * @export
 * @interface UpdateUserScopesInner
 */
export interface UpdateUserScopesInner {
    /**
     * 
     * @type {Array<Permission>}
     * @memberof UpdateUserScopesInner
     */
    'ranges': Array<Permission>;
    /**
     * 
     * @type {Resource}
     * @memberof UpdateUserScopesInner
     */
    'scope': Resource;
}


/**
 * 
 * @export
 * @interface UrlWithSource
 */
export interface UrlWithSource {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof UrlWithSource
     */
    'sourceNodeId': string;
    /**
     * The URL value.
     * @type {string}
     * @memberof UrlWithSource
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface UrlWithSourceAllOf
 */
export interface UrlWithSourceAllOf {
    /**
     * The URL value.
     * @type {string}
     * @memberof UrlWithSourceAllOf
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * The unique identifier for the user
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof User
     */
    'firmId': string;
    /**
     * The unique identifier of the node that the user is attached to
     * @type {Array<string>}
     * @memberof User
     */
    'nodeId': Array<string>;
    /**
     * TBD
     * @type {Array<string>}
     * @memberof User
     */
    'nodeName'?: Array<string>;
    /**
     * The first name of the user
     * @type {string}
     * @memberof User
     */
    'firstName': string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof User
     */
    'surname': string;
    /**
     * The email address of the user
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * The first name of the user
     * @type {string}
     * @memberof User
     */
    '_firstName'?: string;
    /**
     * The surname of the user
     * @type {string}
     * @memberof User
     */
    '_surname'?: string;
    /**
     * 
     * @type {UserMachineType}
     * @memberof User
     */
    'userType': UserMachineType;
    /**
     * 
     * @type {UserAuditDetails}
     * @memberof User
     */
    'auditDetails': UserAuditDetails;
    /**
     * Unique id of last update
     * @type {string}
     * @memberof User
     */
    'updateId'?: string;
    /**
     * 
     * @type {UserInvestmentDecision}
     * @memberof User
     */
    'investmentDecision'?: UserInvestmentDecision;
    /**
     * The levels of access a user has. These are read, read/write and action. The scopes can be implemented across different areas of the system outlined below
     * @type {Array<UserScopesInner>}
     * @memberof User
     */
    'scopes'?: Array<UserScopesInner>;
}


/**
 * object containing audit trail details
 * @export
 * @interface UserAuditDetails
 */
export interface UserAuditDetails {
    /**
     * Timestamp of update
     * @type {string}
     * @memberof UserAuditDetails
     */
    'updateDate'?: string;
    /**
     * Firm Id of user that implemented update
     * @type {string}
     * @memberof UserAuditDetails
     */
    'userFirmId'?: string;
    /**
     * Id of user that implemented update
     * @type {string}
     * @memberof UserAuditDetails
     */
    'userId'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof UserAuditDetails
     */
    'version'?: number;
    /**
     * TBD
     * @type {string}
     * @memberof UserAuditDetails
     */
    'application'?: string;
}
/**
 * TBD
 * @export
 * @interface UserInvestmentDecision
 */
export interface UserInvestmentDecision {
    /**
     * TBD
     * @type {string}
     * @memberof UserInvestmentDecision
     */
    'firmCountry': string;
    /**
     * TBD
     * @type {string}
     * @memberof UserInvestmentDecision
     */
    'firmLei'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof UserInvestmentDecision
     */
    'personCountry': string;
    /**
     * TBD
     * @type {string}
     * @memberof UserInvestmentDecision
     */
    'personId': string;
    /**
     * 
     * @type {PersonalIdentifierType}
     * @memberof UserInvestmentDecision
     */
    'personIdType': PersonalIdentifierType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum UserMachineType {
    Machine = 'Machine',
    User = 'User'
}


/**
 * 
 * @export
 * @interface UserScopesInner
 */
export interface UserScopesInner {
    /**
     * 
     * @type {Array<Permission>}
     * @memberof UserScopesInner
     */
    'ranges': Array<Permission>;
    /**
     * 
     * @type {Resource}
     * @memberof UserScopesInner
     */
    'scope'?: Resource;
}


/**
 * 
 * @export
 * @interface V1ClientNodeFirmIdBatchIdGet200Response
 */
export interface V1ClientNodeFirmIdBatchIdGet200Response {
    /**
     * 
     * @type {V1ClientNodeFirmIdBatchIdGet200ResponseData}
     * @memberof V1ClientNodeFirmIdBatchIdGet200Response
     */
    'data'?: V1ClientNodeFirmIdBatchIdGet200ResponseData;
}
/**
 * 
 * @export
 * @interface V1ClientNodeFirmIdBatchIdGet200ResponseData
 */
export interface V1ClientNodeFirmIdBatchIdGet200ResponseData {
    /**
     * The unique identifier for the node switch batch
     * @type {string}
     * @memberof V1ClientNodeFirmIdBatchIdGet200ResponseData
     */
    'batchId'?: string;
    /**
     * The current status of the node switch batch
     * @type {string}
     * @memberof V1ClientNodeFirmIdBatchIdGet200ResponseData
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface V1ClientNodeFirmIdPatch202Response
 */
export interface V1ClientNodeFirmIdPatch202Response {
    /**
     * 
     * @type {V1ClientNodeFirmIdPatch202ResponseData}
     * @memberof V1ClientNodeFirmIdPatch202Response
     */
    'data'?: V1ClientNodeFirmIdPatch202ResponseData;
}
/**
 * 
 * @export
 * @interface V1ClientNodeFirmIdPatch202ResponseData
 */
export interface V1ClientNodeFirmIdPatch202ResponseData {
    /**
     * The unique identifier for the node switch batch
     * @type {string}
     * @memberof V1ClientNodeFirmIdPatch202ResponseData
     */
    'batchId'?: string;
}
/**
 * 
 * @export
 * @interface V1ClientNodeFirmIdPatchRequest
 */
export interface V1ClientNodeFirmIdPatchRequest {
    /**
     * The ids of the clients to switch to the target node
     * @type {Array<string>}
     * @memberof V1ClientNodeFirmIdPatchRequest
     */
    'clients': Array<string>;
    /**
     * The id of the node the clients will be switched to
     * @type {string}
     * @memberof V1ClientNodeFirmIdPatchRequest
     */
    'targetNode': string;
    /**
     * The id of the node the clients are currently held under
     * @type {string}
     * @memberof V1ClientNodeFirmIdPatchRequest
     */
    'sourceNode': string;
}
/**
 * @type V2PortfoliotransactionFirmIdGetStatusParameter
 * @export
 */
export type V2PortfoliotransactionFirmIdGetStatusParameter = Array<string> | string;

/**
 * 
 * @export
 * @interface V2getTransactionsList
 */
export interface V2getTransactionsList {
    /**
     * 
     * @type {Array<V2getTransactionsListDataInner>}
     * @memberof V2getTransactionsList
     */
    'data'?: Array<V2getTransactionsListDataInner>;
    /**
     * 
     * @type {TransactionsV2Pagination}
     * @memberof V2getTransactionsList
     */
    'meta'?: TransactionsV2Pagination;
}
/**
 * 
 * @export
 * @interface V2getTransactionsListDataInner
 */
export interface V2getTransactionsListDataInner {
    /**
     * The number of units of the asset being traded
     * @type {number}
     * @memberof V2getTransactionsListDataInner
     */
    'quantity'?: number;
    /**
     * The number of units of the asset being traded
     * @type {number}
     * @memberof V2getTransactionsListDataInner
     */
    'executedQuantity'?: number;
    /**
     * The book value of the asset being traded
     * @type {number}
     * @memberof V2getTransactionsListDataInner
     */
    'bookValue'?: number;
    /**
     * The amount of the asset being traded
     * @type {number}
     * @memberof V2getTransactionsListDataInner
     */
    'executedAmount'?: number;
    /**
     * The unique identifier for the client’s investment account
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'accountId': string;
    /**
     * The name of the investment account
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'accountName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'assetId'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'assetName'?: string;
    /**
     * The type of account
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'accountType'?: string;
    /**
     * The amount that the investor is contributing to their investment account
     * @type {number}
     * @memberof V2getTransactionsListDataInner
     */
    'amount'?: number;
    /**
     * 
     * @type {GetIllustrationsListDataInnerAuditDetails}
     * @memberof V2getTransactionsListDataInner
     */
    'auditDetails'?: GetIllustrationsListDataInnerAuditDetails;
    /**
     * TBD
     * @type {boolean}
     * @memberof V2getTransactionsListDataInner
     */
    'autoSetBookValue'?: boolean;
    /**
     * Applies to cash transfers with movement type \'in\'
     * @type {boolean}
     * @memberof V2getTransactionsListDataInner
     */
    'autoInvest'?: boolean;
    /**
     * The date the transaction was created
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'createdDate': string;
    /**
     * The date the transaction switched to Completed
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'completedDate'?: string;
    /**
     * The three-letter ISO currency code
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'currency'?: string;
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'firmId': string;
    /**
     * The unique identifier of the transaction
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'id': string;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'instrumentType'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'intendedSettlementDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof V2getTransactionsListDataInner
     */
    'isPensionTransfer'?: boolean;
    /**
     * Is this a manual transfer
     * @type {boolean}
     * @memberof V2getTransactionsListDataInner
     */
    'isManual'?: boolean;
    /**
     * 
     * @type {ActionTag}
     * @memberof V2getTransactionsListDataInner
     */
    'actionTag'?: ActionTag;
    /**
     * 
     * @type {UserInvestmentDecision}
     * @memberof V2getTransactionsListDataInner
     */
    'investmentDecision'?: UserInvestmentDecision;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'isin'?: string;
    /**
     * The unique identifier that is contained in all the transactions within that portfolio transaction group
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'linkId': string;
    /**
     * The payment method facilitating the withdrawal
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'mic'?: string;
    /**
     * The unique identifier of the node attached to the client account
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'nodeId': string;
    /**
     * The payment method facilitating the withdrawal
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'method'?: string;
    /**
     * 
     * @type {MovementType}
     * @memberof V2getTransactionsListDataInner
     */
    'movementType': MovementType;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'previousProvider'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'previousProviderName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'previousProviderRef'?: string;
    /**
     * 
     * @type {PreviousProviderAccountType}
     * @memberof V2getTransactionsListDataInner
     */
    'previousProviderAccountType'?: PreviousProviderAccountType;
    /**
     * TBD
     * @type {number}
     * @memberof V2getTransactionsListDataInner
     */
    'percentage'?: number;
    /**
     * Type of manual signature required for the transfer
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'signatureType'?: V2getTransactionsListDataInnerSignatureTypeEnum;
    /**
     * 
     * @type {TransactionStatus}
     * @memberof V2getTransactionsListDataInner
     */
    'status': TransactionStatus;
    /**
     * Contains an object to detail the change in statuses of the transaction
     * @type {Array<TransactionStatusChange>}
     * @memberof V2getTransactionsListDataInner
     */
    'statusChanges'?: Array<TransactionStatusChange>;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'ticker'?: string;
    /**
     * The date the payment transaction was instructed
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'transactionDate': string;
    /**
     * 
     * @type {TransactionType}
     * @memberof V2getTransactionsListDataInner
     */
    'transactionType': TransactionType;
    /**
     * The subtype of transaction (In Specie, Cash)
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'transactionSubType': string;
    /**
     * 
     * @type {AddressDetail}
     * @memberof V2getTransactionsListDataInner
     */
    'transferAccountAddress'?: AddressDetail;
    /**
     * 
     * @type {TransferStatus}
     * @memberof V2getTransactionsListDataInner
     */
    'transferStatus'?: TransferStatus;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'rejectionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'rejectionNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'transferSystem'?: string;
    /**
     * TBD
     * @type {number}
     * @memberof V2getTransactionsListDataInner
     */
    'transferValue'?: number;
    /**
     * Unique hash for previous change
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'updateId': string;
    /**
     * The unique identifier for the attached file upload
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'uploadedFileDetailsId'?: string;
    /**
     * 
     * @type {GetTransactionsListDataInnerInformation}
     * @memberof V2getTransactionsListDataInner
     */
    'information'?: GetTransactionsListDataInnerInformation;
    /**
     * The id of the account held by the receiving provider
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'receivingProvider'?: string;
    /**
     * The id of the account held by the receiving provider
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'receivingProviderId'?: string;
    /**
     * The account reference of the account held by the receiving provider
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'receivingProviderRef'?: string;
    /**
     * The name of the receiving provider
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'receivingProviderName'?: string;
    /**
     * TBD
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'bankRef'?: string;
    /**
     * 
     * @type {AutoDisinvest}
     * @memberof V2getTransactionsListDataInner
     */
    'autoDisinvest'?: AutoDisinvest;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'primaryClientId'?: string;
    /**
     * 
     * @type {Array<TransferUpdateEvent>}
     * @memberof V2getTransactionsListDataInner
     */
    'transferUpdateEvents'?: Array<TransferUpdateEvent>;
    /**
     * 
     * @type {V2getTransactionsListDataInnerTradingChargeData}
     * @memberof V2getTransactionsListDataInner
     */
    'tradingChargeData'?: V2getTransactionsListDataInnerTradingChargeData;
    /**
     * The unique identifier for the client’s investment account
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'tradingChargeAccount'?: string;
    /**
     * 
     * @type {number}
     * @memberof V2getTransactionsListDataInner
     */
    'consideration'?: number;
    /**
     * 
     * @type {V2getTransactionsListDataInnerExecutionDetails}
     * @memberof V2getTransactionsListDataInner
     */
    'executionDetails'?: V2getTransactionsListDataInnerExecutionDetails;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInner
     */
    'clientName'?: string;
    /**
     * 
     * @type {Array<V2getTransactionsListDataInnerClientsInner>}
     * @memberof V2getTransactionsListDataInner
     */
    'clients'?: Array<V2getTransactionsListDataInnerClientsInner>;
    /**
     * 
     * @type {V2getTransactionsListDataInnerLastStatusChange}
     * @memberof V2getTransactionsListDataInner
     */
    'lastStatusChange'?: V2getTransactionsListDataInnerLastStatusChange;
}

/**
    * @export
    * @enum {string}
    */
export enum V2getTransactionsListDataInnerSignatureTypeEnum {
    Scanned = 'Scanned',
    Electronic = 'Electronic',
    Wet = 'Wet'
}

/**
 * 
 * @export
 * @interface V2getTransactionsListDataInnerClientsInner
 */
export interface V2getTransactionsListDataInnerClientsInner {
    /**
     * 
     * @type {boolean}
     * @memberof V2getTransactionsListDataInnerClientsInner
     */
    'decisionMaker'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof V2getTransactionsListDataInnerClientsInner
     */
    'isLeadClient'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof V2getTransactionsListDataInnerClientsInner
     */
    'owner'?: number;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInnerClientsInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInnerClientsInner
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface V2getTransactionsListDataInnerExecutionDetails
 */
export interface V2getTransactionsListDataInnerExecutionDetails {
    /**
     * 
     * @type {number}
     * @memberof V2getTransactionsListDataInnerExecutionDetails
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInnerExecutionDetails
     */
    'transactionTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInnerExecutionDetails
     */
    'venue'?: string;
}
/**
 * 
 * @export
 * @interface V2getTransactionsListDataInnerLastStatusChange
 */
export interface V2getTransactionsListDataInnerLastStatusChange {
    /**
     * 
     * @type {TransactionStatus}
     * @memberof V2getTransactionsListDataInnerLastStatusChange
     */
    'status'?: TransactionStatus;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInnerLastStatusChange
     */
    'statusDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof V2getTransactionsListDataInnerLastStatusChange
     */
    'description'?: string;
}


/**
 * The amount that the investor is contributing to their investment account
 * @export
 * @interface V2getTransactionsListDataInnerTradingChargeData
 */
export interface V2getTransactionsListDataInnerTradingChargeData {
    /**
     * 
     * @type {Array<string>}
     * @memberof V2getTransactionsListDataInnerTradingChargeData
     */
    'instrumentTypes'?: Array<string>;
    /**
     * 
     * @type {Array<V2getTransactionsListDataInnerTradingChargeDataTiersInner>}
     * @memberof V2getTransactionsListDataInnerTradingChargeData
     */
    'tiers'?: Array<V2getTransactionsListDataInnerTradingChargeDataTiersInner>;
    /**
     * 
     * @type {number}
     * @memberof V2getTransactionsListDataInnerTradingChargeData
     */
    'minimumAmount'?: number;
}
/**
 * 
 * @export
 * @interface V2getTransactionsListDataInnerTradingChargeDataTiersInner
 */
export interface V2getTransactionsListDataInnerTradingChargeDataTiersInner {
    /**
     * 
     * @type {number}
     * @memberof V2getTransactionsListDataInnerTradingChargeDataTiersInner
     */
    'rate'?: number;
}
/**
 * 
 * @export
 * @interface ValidatedAccountPaymentMethod
 */
export interface ValidatedAccountPaymentMethod {
    /**
     * Unique firm identifier.
     * @type {string}
     * @memberof ValidatedAccountPaymentMethod
     */
    'firmId': string;
    /**
     * The unique identifier of the investment account to instruct the transfer
     * @type {string}
     * @memberof ValidatedAccountPaymentMethod
     */
    'accountId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidatedAccountPaymentMethod
     */
    'paymentMethods': Array<string>;
}
/**
 * 
 * @export
 * @interface ValidatedAccountPaymentMethodResponse
 */
export interface ValidatedAccountPaymentMethodResponse {
    /**
     * 
     * @type {object}
     * @memberof ValidatedAccountPaymentMethodResponse
     */
    'data': object;
}
/**
 * 
 * @export
 * @interface ValidatedAccountPaymentMethodResponseError
 */
export interface ValidatedAccountPaymentMethodResponseError {
    /**
     * 
     * @type {object}
     * @memberof ValidatedAccountPaymentMethodResponseError
     */
    'error': object;
}
/**
 * 
 * @export
 * @interface ValueByTypeFields
 */
export interface ValueByTypeFields {
    /**
     * The value of cash held by the record at the end of the specified period (if not specified this would be now) 
     * @type {number}
     * @memberof ValueByTypeFields
     */
    'closingCashValue'?: number;
    /**
     * The value of stock held by the record at the end of the specified period (if not specified this as at the most recent close of market) 
     * @type {number}
     * @memberof ValueByTypeFields
     */
    'closingStockValue'?: number;
    /**
     * The value of cash held at the current record level at the start of the specified period (if not specified this would be record creation) 
     * @type {number}
     * @memberof ValueByTypeFields
     */
    'openingCashValue'?: number;
    /**
     * The value of stock held at the current record level at the start of the specified period (if not specified this would be record creation) 
     * @type {number}
     * @memberof ValueByTypeFields
     */
    'openingStockValue'?: number;
}
/**
 * 
 * @export
 * @interface WealthsweetTheme
 */
export interface WealthsweetTheme {
    /**
     * 
     * @type {WealthsweetThemeBalanceColor}
     * @memberof WealthsweetTheme
     */
    'balanceColor': WealthsweetThemeBalanceColor;
    /**
     * 
     * @type {WealthsweetThemeTimeWeightedPerformanceColor}
     * @memberof WealthsweetTheme
     */
    'timeWeightedPerformanceColor': WealthsweetThemeTimeWeightedPerformanceColor;
    /**
     * 
     * @type {WealthsweetThemeMoneyWeightedPerformanceColor}
     * @memberof WealthsweetTheme
     */
    'moneyWeightedPerformanceColor': WealthsweetThemeMoneyWeightedPerformanceColor;
    /**
     * 
     * @type {WealthsweetThemePositiveCapitalMovementColor}
     * @memberof WealthsweetTheme
     */
    'positiveCapitalMovementColor': WealthsweetThemePositiveCapitalMovementColor;
    /**
     * 
     * @type {WealthsweetThemeNegativeCapitalMovementColor}
     * @memberof WealthsweetTheme
     */
    'negativeCapitalMovementColor': WealthsweetThemeNegativeCapitalMovementColor;
    /**
     * 
     * @type {WealthsweetThemePrimaryColor}
     * @memberof WealthsweetTheme
     */
    'primaryColor': WealthsweetThemePrimaryColor;
    /**
     * 
     * @type {WealthsweetThemeSecondaryColor}
     * @memberof WealthsweetTheme
     */
    'secondaryColor': WealthsweetThemeSecondaryColor;
    /**
     * 
     * @type {WealthsweetThemeSecondaryForegroundColor}
     * @memberof WealthsweetTheme
     */
    'secondaryForegroundColor': WealthsweetThemeSecondaryForegroundColor;
    /**
     * 
     * @type {WealthsweetThemePdfBalanceColor}
     * @memberof WealthsweetTheme
     */
    'pdfBalanceColor': WealthsweetThemePdfBalanceColor;
    /**
     * 
     * @type {WealthsweetThemePdfTimeWeightedPerformanceColor}
     * @memberof WealthsweetTheme
     */
    'pdfTimeWeightedPerformanceColor': WealthsweetThemePdfTimeWeightedPerformanceColor;
    /**
     * 
     * @type {WealthsweetThemePdfMoneyWeightedPerformanceColor}
     * @memberof WealthsweetTheme
     */
    'pdfMoneyWeightedPerformanceColor': WealthsweetThemePdfMoneyWeightedPerformanceColor;
    /**
     * 
     * @type {WealthsweetThemePdfPositiveCapitalMovementColor}
     * @memberof WealthsweetTheme
     */
    'pdfPositiveCapitalMovementColor': WealthsweetThemePdfPositiveCapitalMovementColor;
    /**
     * 
     * @type {WealthsweetThemePdfNegativeCapitalMovementColor}
     * @memberof WealthsweetTheme
     */
    'pdfNegativeCapitalMovementColor': WealthsweetThemePdfNegativeCapitalMovementColor;
    /**
     * 
     * @type {WealthsweetThemePdfTextColor}
     * @memberof WealthsweetTheme
     */
    'pdfTextColor': WealthsweetThemePdfTextColor;
    /**
     * 
     * @type {WealthsweetThemePdfBannerColor}
     * @memberof WealthsweetTheme
     */
    'pdfBannerColor': WealthsweetThemePdfBannerColor;
    /**
     * 
     * @type {WealthsweetThemePdfPageColor}
     * @memberof WealthsweetTheme
     */
    'pdfPageColor': WealthsweetThemePdfPageColor;
    /**
     * 
     * @type {WealthsweetThemePdfBannerContrastColor}
     * @memberof WealthsweetTheme
     */
    'pdfBannerContrastColor': WealthsweetThemePdfBannerContrastColor;
}
/**
 * The hexcode representation of the balance colour for the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemeBalanceColor
 */
export interface WealthsweetThemeBalanceColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemeBalanceColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemeBalanceColor
     */
    'value': string;
}
/**
 * The hexcode representation of the money weighted performance colour for the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemeMoneyWeightedPerformanceColor
 */
export interface WealthsweetThemeMoneyWeightedPerformanceColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemeMoneyWeightedPerformanceColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemeMoneyWeightedPerformanceColor
     */
    'value': string;
}
/**
 * The hexcode representation of the negative capital movement colour for the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemeNegativeCapitalMovementColor
 */
export interface WealthsweetThemeNegativeCapitalMovementColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemeNegativeCapitalMovementColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemeNegativeCapitalMovementColor
     */
    'value': string;
}
/**
 * The hexcode representation of the balance colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfBalanceColor
 */
export interface WealthsweetThemePdfBalanceColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfBalanceColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfBalanceColor
     */
    'value': string;
}
/**
 * The hexcode representation of the banner colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfBannerColor
 */
export interface WealthsweetThemePdfBannerColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfBannerColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfBannerColor
     */
    'value': string;
}
/**
 * The hexcode representation of the banner contrast colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfBannerContrastColor
 */
export interface WealthsweetThemePdfBannerContrastColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfBannerContrastColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfBannerContrastColor
     */
    'value': string;
}
/**
 * The hexcode representation of the money weighted performance colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfMoneyWeightedPerformanceColor
 */
export interface WealthsweetThemePdfMoneyWeightedPerformanceColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfMoneyWeightedPerformanceColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfMoneyWeightedPerformanceColor
     */
    'value': string;
}
/**
 * The hexcode representation of the negative capital movement colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfNegativeCapitalMovementColor
 */
export interface WealthsweetThemePdfNegativeCapitalMovementColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfNegativeCapitalMovementColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfNegativeCapitalMovementColor
     */
    'value': string;
}
/**
 * The hexcode representation of the page colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfPageColor
 */
export interface WealthsweetThemePdfPageColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfPageColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfPageColor
     */
    'value': string;
}
/**
 * The hexcode representation of the positive capital movement colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfPositiveCapitalMovementColor
 */
export interface WealthsweetThemePdfPositiveCapitalMovementColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfPositiveCapitalMovementColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfPositiveCapitalMovementColor
     */
    'value': string;
}
/**
 * The hexcode representation of the text colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfTextColor
 */
export interface WealthsweetThemePdfTextColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfTextColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfTextColor
     */
    'value': string;
}
/**
 * The hexcode representation of the time weighted performance colour for PDFs in the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePdfTimeWeightedPerformanceColor
 */
export interface WealthsweetThemePdfTimeWeightedPerformanceColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePdfTimeWeightedPerformanceColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePdfTimeWeightedPerformanceColor
     */
    'value': string;
}
/**
 * The hexcode representation of the positive capital movement colour for the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePositiveCapitalMovementColor
 */
export interface WealthsweetThemePositiveCapitalMovementColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePositiveCapitalMovementColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePositiveCapitalMovementColor
     */
    'value': string;
}
/**
 * The hexcode representation of the primary colour for the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemePrimaryColor
 */
export interface WealthsweetThemePrimaryColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemePrimaryColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemePrimaryColor
     */
    'value': string;
}
/**
 * The hexcode representation of the secondary colour for the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemeSecondaryColor
 */
export interface WealthsweetThemeSecondaryColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemeSecondaryColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemeSecondaryColor
     */
    'value': string;
}
/**
 * The hexcode representation of the secondary foreground colour for the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemeSecondaryForegroundColor
 */
export interface WealthsweetThemeSecondaryForegroundColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemeSecondaryForegroundColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemeSecondaryForegroundColor
     */
    'value': string;
}
/**
 * The hexcode representation of the time weighted performance colour for the Wealthsweet theme.
 * @export
 * @interface WealthsweetThemeTimeWeightedPerformanceColor
 */
export interface WealthsweetThemeTimeWeightedPerformanceColor {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WealthsweetThemeTimeWeightedPerformanceColor
     */
    'sourceNodeId': string;
    /**
     * The hexcode colour value.
     * @type {string}
     * @memberof WealthsweetThemeTimeWeightedPerformanceColor
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface WithSourceNode
 */
export interface WithSourceNode {
    /**
     * The ID of the node the value was inherited from. This will be the current node if the value is not inherited.
     * @type {string}
     * @memberof WithSourceNode
     */
    'sourceNodeId': string;
}
/**
 * @type WrapperDetail
 * @export
 */
export type WrapperDetail = WrapperDetailGIA | WrapperDetailISA | WrapperDetailJISA | WrapperDetailPENSION | WrapperDetailSSAS | WrapperDetailTPOFFBOND | WrapperDetailTPPENSION;

/**
 * Data concerning the account\'s tax wrapper e.g. ISA, GIA, SIPP
 * @export
 * @interface WrapperDetailGIA
 */
export interface WrapperDetailGIA {
    /**
     * 
     * @type {WrapperType}
     * @memberof WrapperDetailGIA
     */
    'wrapperType': WrapperType;
    /**
     * Whether the account is managed on an advised basis; the adviser provides advice to the client but the client makes the final decision
     * @type {boolean}
     * @memberof WrapperDetailGIA
     */
    'advised'?: boolean;
    /**
     * The unique identifier of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailGIA
     */
    'assetAllocationId'?: string;
    /**
     * The name of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailGIA
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the client product of which this account is a part; represents the client\'s investment product e.g. GIA, ISA, SIPP
     * @type {string}
     * @memberof WrapperDetailGIA
     */
    'clientProductId': string;
    /**
     * The unique identifier of the decision maker for the account (if different from the client, typically an adviser)
     * @type {string}
     * @memberof WrapperDetailGIA
     */
    'decisionMakerId'?: string;
    /**
     * Whether the account is managed on a discretionary basis; the adviser can make decisions on behalf of the client
     * @type {boolean}
     * @memberof WrapperDetailGIA
     */
    'discretionary'?: boolean;
    /**
     * Legacy property to indicate whether the account is a trust, please use a trust client type instead
     * @type {boolean}
     * @memberof WrapperDetailGIA
     */
    'trust'?: boolean;
    /**
     * The unique identifier of the scheme product. This ultimately points to the scheme registered with HMRC.
     * @type {string}
     * @memberof WrapperDetailGIA
     */
    'schemeProductId'?: string;
    /**
     * The legacy unique identifier of the wrapper provider (prefer schemeProductId)
     * @type {string}
     * @memberof WrapperDetailGIA
     */
    'providerId'?: string;
}


/**
 * 
 * @export
 * @interface WrapperDetailISA
 */
export interface WrapperDetailISA {
    /**
     * 
     * @type {WrapperType}
     * @memberof WrapperDetailISA
     */
    'wrapperType': WrapperType;
    /**
     * Whether the account is managed on an advised basis; the adviser provides advice to the client but the client makes the final decision
     * @type {boolean}
     * @memberof WrapperDetailISA
     */
    'advised'?: boolean;
    /**
     * The unique identifier of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailISA
     */
    'assetAllocationId'?: string;
    /**
     * The name of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailISA
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the client product of which this account is a part; represents the client\'s investment product e.g. GIA, ISA, SIPP
     * @type {string}
     * @memberof WrapperDetailISA
     */
    'clientProductId': string;
    /**
     * The unique identifier of the decision maker for the account (if different from the client, typically an adviser)
     * @type {string}
     * @memberof WrapperDetailISA
     */
    'decisionMakerId'?: string;
    /**
     * Whether the account is managed on a discretionary basis; the adviser can make decisions on behalf of the client
     * @type {boolean}
     * @memberof WrapperDetailISA
     */
    'discretionary'?: boolean;
    /**
     * Legacy property to indicate whether the account is a trust, please use a trust client type instead
     * @type {boolean}
     * @memberof WrapperDetailISA
     */
    'trust'?: boolean;
    /**
     * The unique identifier of the scheme product. This ultimately points to the scheme registered with HMRC.
     * @type {string}
     * @memberof WrapperDetailISA
     */
    'schemeProductId'?: string;
    /**
     * The legacy unique identifier of the wrapper provider (prefer schemeProductId)
     * @type {string}
     * @memberof WrapperDetailISA
     */
    'providerId'?: string;
    /**
     * The date on which this account was transitioned from a JISA to an ISA
     * @type {string}
     * @memberof WrapperDetailISA
     */
    'jisaGraduationDate'?: string;
}


/**
 * 
 * @export
 * @interface WrapperDetailISAAllOf
 */
export interface WrapperDetailISAAllOf {
    /**
     * The date on which this account was transitioned from a JISA to an ISA
     * @type {string}
     * @memberof WrapperDetailISAAllOf
     */
    'jisaGraduationDate'?: string;
}
/**
 * 
 * @export
 * @interface WrapperDetailJISA
 */
export interface WrapperDetailJISA {
    /**
     * 
     * @type {WrapperType}
     * @memberof WrapperDetailJISA
     */
    'wrapperType': WrapperType;
    /**
     * Whether the account is managed on an advised basis; the adviser provides advice to the client but the client makes the final decision
     * @type {boolean}
     * @memberof WrapperDetailJISA
     */
    'advised'?: boolean;
    /**
     * The unique identifier of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailJISA
     */
    'assetAllocationId'?: string;
    /**
     * The name of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailJISA
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the client product of which this account is a part; represents the client\'s investment product e.g. GIA, ISA, SIPP
     * @type {string}
     * @memberof WrapperDetailJISA
     */
    'clientProductId': string;
    /**
     * The unique identifier of the decision maker for the account (if different from the client, typically an adviser)
     * @type {string}
     * @memberof WrapperDetailJISA
     */
    'decisionMakerId'?: string;
    /**
     * Whether the account is managed on a discretionary basis; the adviser can make decisions on behalf of the client
     * @type {boolean}
     * @memberof WrapperDetailJISA
     */
    'discretionary'?: boolean;
    /**
     * Legacy property to indicate whether the account is a trust, please use a trust client type instead
     * @type {boolean}
     * @memberof WrapperDetailJISA
     */
    'trust'?: boolean;
    /**
     * The unique identifier of the scheme product. This ultimately points to the scheme registered with HMRC.
     * @type {string}
     * @memberof WrapperDetailJISA
     */
    'schemeProductId'?: string;
    /**
     * The legacy unique identifier of the wrapper provider (prefer schemeProductId)
     * @type {string}
     * @memberof WrapperDetailJISA
     */
    'providerId'?: string;
}


/**
 * 
 * @export
 * @interface WrapperDetailPENSION
 */
export interface WrapperDetailPENSION {
    /**
     * 
     * @type {WrapperType}
     * @memberof WrapperDetailPENSION
     */
    'wrapperType': WrapperType;
    /**
     * Whether the account is managed on an advised basis; the adviser provides advice to the client but the client makes the final decision
     * @type {boolean}
     * @memberof WrapperDetailPENSION
     */
    'advised'?: boolean;
    /**
     * The unique identifier of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailPENSION
     */
    'assetAllocationId'?: string;
    /**
     * The name of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailPENSION
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the client product of which this account is a part; represents the client\'s investment product e.g. GIA, ISA, SIPP
     * @type {string}
     * @memberof WrapperDetailPENSION
     */
    'clientProductId': string;
    /**
     * The unique identifier of the decision maker for the account (if different from the client, typically an adviser)
     * @type {string}
     * @memberof WrapperDetailPENSION
     */
    'decisionMakerId'?: string;
    /**
     * Whether the account is managed on a discretionary basis; the adviser can make decisions on behalf of the client
     * @type {boolean}
     * @memberof WrapperDetailPENSION
     */
    'discretionary'?: boolean;
    /**
     * Legacy property to indicate whether the account is a trust, please use a trust client type instead
     * @type {boolean}
     * @memberof WrapperDetailPENSION
     */
    'trust'?: boolean;
    /**
     * The unique identifier of the scheme product. This ultimately points to the scheme registered with HMRC.
     * @type {string}
     * @memberof WrapperDetailPENSION
     */
    'schemeProductId'?: string;
    /**
     * The legacy unique identifier of the wrapper provider (prefer schemeProductId)
     * @type {string}
     * @memberof WrapperDetailPENSION
     */
    'providerId'?: string;
    /**
     * Legacy external references for the pension used for integration with third party systems
     * @type {Array<ExternalIdsInner>}
     * @memberof WrapperDetailPENSION
     */
    'externalIds'?: Array<ExternalIdsInner>;
    /**
     * 
     * @type {ProductDetail}
     * @memberof WrapperDetailPENSION
     */
    'productDetail'?: ProductDetail;
    /**
     * 
     * @type {ClientProductStatus}
     * @memberof WrapperDetailPENSION
     */
    'productStatus'?: ClientProductStatus;
}


/**
 * 
 * @export
 * @interface WrapperDetailPENSIONAllOf
 */
export interface WrapperDetailPENSIONAllOf {
    /**
     * Legacy external references for the pension used for integration with third party systems
     * @type {Array<ExternalIdsInner>}
     * @memberof WrapperDetailPENSIONAllOf
     */
    'externalIds'?: Array<ExternalIdsInner>;
    /**
     * 
     * @type {ProductDetail}
     * @memberof WrapperDetailPENSIONAllOf
     */
    'productDetail'?: ProductDetail;
    /**
     * 
     * @type {ClientProductStatus}
     * @memberof WrapperDetailPENSIONAllOf
     */
    'productStatus'?: ClientProductStatus;
}


/**
 * 
 * @export
 * @interface WrapperDetailSSAS
 */
export interface WrapperDetailSSAS {
    /**
     * 
     * @type {WrapperType}
     * @memberof WrapperDetailSSAS
     */
    'wrapperType': WrapperType;
    /**
     * Whether the account is managed on an advised basis; the adviser provides advice to the client but the client makes the final decision
     * @type {boolean}
     * @memberof WrapperDetailSSAS
     */
    'advised'?: boolean;
    /**
     * The unique identifier of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailSSAS
     */
    'assetAllocationId'?: string;
    /**
     * The name of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailSSAS
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the client product of which this account is a part; represents the client\'s investment product e.g. GIA, ISA, SIPP
     * @type {string}
     * @memberof WrapperDetailSSAS
     */
    'clientProductId': string;
    /**
     * The unique identifier of the decision maker for the account (if different from the client, typically an adviser)
     * @type {string}
     * @memberof WrapperDetailSSAS
     */
    'decisionMakerId'?: string;
    /**
     * Whether the account is managed on a discretionary basis; the adviser can make decisions on behalf of the client
     * @type {boolean}
     * @memberof WrapperDetailSSAS
     */
    'discretionary'?: boolean;
    /**
     * Legacy property to indicate whether the account is a trust, please use a trust client type instead
     * @type {boolean}
     * @memberof WrapperDetailSSAS
     */
    'trust'?: boolean;
    /**
     * The unique identifier of the scheme product. This ultimately points to the scheme registered with HMRC.
     * @type {string}
     * @memberof WrapperDetailSSAS
     */
    'schemeProductId'?: string;
    /**
     * The legacy unique identifier of the wrapper provider (prefer schemeProductId)
     * @type {string}
     * @memberof WrapperDetailSSAS
     */
    'providerId'?: string;
}


/**
 * 
 * @export
 * @interface WrapperDetailTPOFFBOND
 */
export interface WrapperDetailTPOFFBOND {
    /**
     * 
     * @type {WrapperType}
     * @memberof WrapperDetailTPOFFBOND
     */
    'wrapperType': WrapperType;
    /**
     * Whether the account is managed on an advised basis; the adviser provides advice to the client but the client makes the final decision
     * @type {boolean}
     * @memberof WrapperDetailTPOFFBOND
     */
    'advised'?: boolean;
    /**
     * The unique identifier of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailTPOFFBOND
     */
    'assetAllocationId'?: string;
    /**
     * The name of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailTPOFFBOND
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the client product of which this account is a part; represents the client\'s investment product e.g. GIA, ISA, SIPP
     * @type {string}
     * @memberof WrapperDetailTPOFFBOND
     */
    'clientProductId': string;
    /**
     * The unique identifier of the decision maker for the account (if different from the client, typically an adviser)
     * @type {string}
     * @memberof WrapperDetailTPOFFBOND
     */
    'decisionMakerId'?: string;
    /**
     * Whether the account is managed on a discretionary basis; the adviser can make decisions on behalf of the client
     * @type {boolean}
     * @memberof WrapperDetailTPOFFBOND
     */
    'discretionary'?: boolean;
    /**
     * Legacy property to indicate whether the account is a trust, please use a trust client type instead
     * @type {boolean}
     * @memberof WrapperDetailTPOFFBOND
     */
    'trust'?: boolean;
    /**
     * The unique identifier of the scheme product. This ultimately points to the scheme registered with HMRC.
     * @type {string}
     * @memberof WrapperDetailTPOFFBOND
     */
    'schemeProductId'?: string;
    /**
     * The legacy unique identifier of the wrapper provider (prefer schemeProductId)
     * @type {string}
     * @memberof WrapperDetailTPOFFBOND
     */
    'providerId'?: string;
}


/**
 * 
 * @export
 * @interface WrapperDetailTPPENSION
 */
export interface WrapperDetailTPPENSION {
    /**
     * 
     * @type {WrapperType}
     * @memberof WrapperDetailTPPENSION
     */
    'wrapperType': WrapperType;
    /**
     * Whether the account is managed on an advised basis; the adviser provides advice to the client but the client makes the final decision
     * @type {boolean}
     * @memberof WrapperDetailTPPENSION
     */
    'advised'?: boolean;
    /**
     * The unique identifier of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailTPPENSION
     */
    'assetAllocationId'?: string;
    /**
     * The name of the asset allocation in which the account is invested
     * @type {string}
     * @memberof WrapperDetailTPPENSION
     */
    'assetAllocationName'?: string;
    /**
     * The unique identifier of the client product of which this account is a part; represents the client\'s investment product e.g. GIA, ISA, SIPP
     * @type {string}
     * @memberof WrapperDetailTPPENSION
     */
    'clientProductId': string;
    /**
     * The unique identifier of the decision maker for the account (if different from the client, typically an adviser)
     * @type {string}
     * @memberof WrapperDetailTPPENSION
     */
    'decisionMakerId'?: string;
    /**
     * Whether the account is managed on a discretionary basis; the adviser can make decisions on behalf of the client
     * @type {boolean}
     * @memberof WrapperDetailTPPENSION
     */
    'discretionary'?: boolean;
    /**
     * Legacy property to indicate whether the account is a trust, please use a trust client type instead
     * @type {boolean}
     * @memberof WrapperDetailTPPENSION
     */
    'trust'?: boolean;
    /**
     * The unique identifier of the scheme product. This ultimately points to the scheme registered with HMRC.
     * @type {string}
     * @memberof WrapperDetailTPPENSION
     */
    'schemeProductId'?: string;
    /**
     * The legacy unique identifier of the wrapper provider (prefer schemeProductId)
     * @type {string}
     * @memberof WrapperDetailTPPENSION
     */
    'providerId'?: string;
    /**
     * Legacy external references for the pension used for integration with third party systems
     * @type {Array<ExternalIdsInner>}
     * @memberof WrapperDetailTPPENSION
     */
    'externalIds'?: Array<ExternalIdsInner>;
}


/**
 * 
 * @export
 * @interface WrapperDetailTPPENSIONAllOf
 */
export interface WrapperDetailTPPENSIONAllOf {
    /**
     * Legacy external references for the pension used for integration with third party systems
     * @type {Array<ExternalIdsInner>}
     * @memberof WrapperDetailTPPENSIONAllOf
     */
    'externalIds'?: Array<ExternalIdsInner>;
}
/**
 * The type of wrapper that the client product relates
 * @export
 * @enum {string}
 */

export enum WrapperType {
    Gia = 'GIA',
    Isa = 'ISA',
    Jisa = 'JISA',
    Cash = 'CASH',
    Pension = 'PENSION',
    Tppension = 'TPPENSION',
    Sipp = 'SIPP',
    Ssas = 'SSAS',
    Tpoffbond = 'TPOFFBOND'
}



/**
 * AccessAndAuthenticationApi - axios parameter creator
 * @export
 */
export const AccessAndAuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Firstly, you will need an access token as a machine user. This will allow you to log into the Seccl sandbox environment.
         * @summary Generate an access token
         * @param {AuthRequest} [authRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticatePost: async (authRequest?: AuthRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authenticate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This action allows the user to change their password once they have already set one up on the system.
         * @summary Change your password
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {ChangePassword} [changePassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changepasswordPost: async (contentType?: string, apiToken?: string, changePassword?: ChangePassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/changepassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [nodeId] 
         * @param {string} [space] 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentFirmIdGet: async (firmId: string, contentType?: string, nodeId?: string, space?: string, locale?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('contentFirmIdGet', 'firmId', firmId)
            const localVarPath = `/content/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (space !== undefined) {
                localVarQueryParameter['space'] = space;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xSecclClientAuth 
         * @param {string} [id] 
         * @param {string} [host] 
         * @param {string} [nodeId] 
         * @param {HostnameType} [type] 
         * @param {string} [firmId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmHostnameGet: async (xSecclClientAuth: string, id?: string, host?: string, nodeId?: string, type?: HostnameType, firmId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xSecclClientAuth' is not null or undefined
            assertParamExists('firmHostnameGet', 'xSecclClientAuth', xSecclClientAuth)
            const localVarPath = `/firm/hostname`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (host !== undefined) {
                localVarQueryParameter['host'] = host;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (firmId !== undefined) {
                localVarQueryParameter['firmId'] = firmId;
            }

            if (xSecclClientAuth != null) {
                localVarHeaderParameter['x-seccl-client-auth'] = String(xSecclClientAuth);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This triggers a password reset email to be sent to the user. This email has a 30-minute timeout from the point of instruction.
         * @summary Generate set password email
         * @param {string} [contentType] 
         * @param {ResetPassword} [resetPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPost: async (contentType?: string, resetPassword?: ResetPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionGet: async (contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This action creates a new password using the access token.
         * @summary Set password using access token
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {SetPassword} [setPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setpasswordPost: async (contentType?: string, apiToken?: string, setPassword?: SetPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setpassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessAndAuthenticationApi - functional programming interface
 * @export
 */
export const AccessAndAuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessAndAuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Firstly, you will need an access token as a machine user. This will allow you to log into the Seccl sandbox environment.
         * @summary Generate an access token
         * @param {AuthRequest} [authRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticatePost(authRequest?: AuthRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticatePost(authRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This action allows the user to change their password once they have already set one up on the system.
         * @summary Change your password
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {ChangePassword} [changePassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changepasswordPost(contentType?: string, apiToken?: string, changePassword?: ChangePassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changepasswordPost(contentType, apiToken, changePassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [nodeId] 
         * @param {string} [space] 
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentFirmIdGet(firmId: string, contentType?: string, nodeId?: string, space?: string, locale?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFirmBrandingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentFirmIdGet(firmId, contentType, nodeId, space, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} xSecclClientAuth 
         * @param {string} [id] 
         * @param {string} [host] 
         * @param {string} [nodeId] 
         * @param {HostnameType} [type] 
         * @param {string} [firmId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmHostnameGet(xSecclClientAuth: string, id?: string, host?: string, nodeId?: string, type?: HostnameType, firmId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFirmHostnameList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmHostnameGet(xSecclClientAuth, id, host, nodeId, type, firmId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This triggers a password reset email to be sent to the user. This email has a 30-minute timeout from the point of instruction.
         * @summary Generate set password email
         * @param {string} [contentType] 
         * @param {ResetPassword} [resetPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPost(contentType?: string, resetPassword?: ResetPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPost(contentType, resetPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionGet(contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionGet(contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This action creates a new password using the access token.
         * @summary Set password using access token
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {SetPassword} [setPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setpasswordPost(contentType?: string, apiToken?: string, setPassword?: SetPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setpasswordPost(contentType, apiToken, setPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccessAndAuthenticationApi - factory interface
 * @export
 */
export const AccessAndAuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessAndAuthenticationApiFp(configuration)
    return {
        /**
         * Firstly, you will need an access token as a machine user. This will allow you to log into the Seccl sandbox environment.
         * @summary Generate an access token
         * @param {AccessAndAuthenticationApiAuthenticatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticatePost(requestParameters: AccessAndAuthenticationApiAuthenticatePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.authenticatePost(requestParameters.authRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This action allows the user to change their password once they have already set one up on the system.
         * @summary Change your password
         * @param {AccessAndAuthenticationApiChangepasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changepasswordPost(requestParameters: AccessAndAuthenticationApiChangepasswordPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changepasswordPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.changePassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessAndAuthenticationApiContentFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentFirmIdGet(requestParameters: AccessAndAuthenticationApiContentFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetFirmBrandingList> {
            return localVarFp.contentFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.nodeId, requestParameters.space, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessAndAuthenticationApiFirmHostnameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmHostnameGet(requestParameters: AccessAndAuthenticationApiFirmHostnameGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetFirmHostnameList> {
            return localVarFp.firmHostnameGet(requestParameters.xSecclClientAuth, requestParameters.id, requestParameters.host, requestParameters.nodeId, requestParameters.type, requestParameters.firmId, options).then((request) => request(axios, basePath));
        },
        /**
         * This triggers a password reset email to be sent to the user. This email has a 30-minute timeout from the point of instruction.
         * @summary Generate set password email
         * @param {AccessAndAuthenticationApiResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPost(requestParameters: AccessAndAuthenticationApiResetPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ResetPost200Response> {
            return localVarFp.resetPost(requestParameters.contentType, requestParameters.resetPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccessAndAuthenticationApiSessionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionGet(requestParameters: AccessAndAuthenticationApiSessionGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.sessionGet(requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This action creates a new password using the access token.
         * @summary Set password using access token
         * @param {AccessAndAuthenticationApiSetpasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setpasswordPost(requestParameters: AccessAndAuthenticationApiSetpasswordPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setpasswordPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.setPassword, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for authenticatePost operation in AccessAndAuthenticationApi.
 * @export
 * @interface AccessAndAuthenticationApiAuthenticatePostRequest
 */
export interface AccessAndAuthenticationApiAuthenticatePostRequest {
    /**
     * 
     * @type {AuthRequest}
     * @memberof AccessAndAuthenticationApiAuthenticatePost
     */
    readonly authRequest?: AuthRequest
}

/**
 * Request parameters for changepasswordPost operation in AccessAndAuthenticationApi.
 * @export
 * @interface AccessAndAuthenticationApiChangepasswordPostRequest
 */
export interface AccessAndAuthenticationApiChangepasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiChangepasswordPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiChangepasswordPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {ChangePassword}
     * @memberof AccessAndAuthenticationApiChangepasswordPost
     */
    readonly changePassword?: ChangePassword
}

/**
 * Request parameters for contentFirmIdGet operation in AccessAndAuthenticationApi.
 * @export
 * @interface AccessAndAuthenticationApiContentFirmIdGetRequest
 */
export interface AccessAndAuthenticationApiContentFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiContentFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiContentFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiContentFirmIdGet
     */
    readonly nodeId?: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiContentFirmIdGet
     */
    readonly space?: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiContentFirmIdGet
     */
    readonly locale?: string
}

/**
 * Request parameters for firmHostnameGet operation in AccessAndAuthenticationApi.
 * @export
 * @interface AccessAndAuthenticationApiFirmHostnameGetRequest
 */
export interface AccessAndAuthenticationApiFirmHostnameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiFirmHostnameGet
     */
    readonly xSecclClientAuth: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiFirmHostnameGet
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiFirmHostnameGet
     */
    readonly host?: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiFirmHostnameGet
     */
    readonly nodeId?: string

    /**
     * 
     * @type {HostnameType}
     * @memberof AccessAndAuthenticationApiFirmHostnameGet
     */
    readonly type?: HostnameType

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiFirmHostnameGet
     */
    readonly firmId?: string
}

/**
 * Request parameters for resetPost operation in AccessAndAuthenticationApi.
 * @export
 * @interface AccessAndAuthenticationApiResetPostRequest
 */
export interface AccessAndAuthenticationApiResetPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiResetPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {ResetPassword}
     * @memberof AccessAndAuthenticationApiResetPost
     */
    readonly resetPassword?: ResetPassword
}

/**
 * Request parameters for sessionGet operation in AccessAndAuthenticationApi.
 * @export
 * @interface AccessAndAuthenticationApiSessionGetRequest
 */
export interface AccessAndAuthenticationApiSessionGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiSessionGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiSessionGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for setpasswordPost operation in AccessAndAuthenticationApi.
 * @export
 * @interface AccessAndAuthenticationApiSetpasswordPostRequest
 */
export interface AccessAndAuthenticationApiSetpasswordPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiSetpasswordPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccessAndAuthenticationApiSetpasswordPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {SetPassword}
     * @memberof AccessAndAuthenticationApiSetpasswordPost
     */
    readonly setPassword?: SetPassword
}

/**
 * AccessAndAuthenticationApi - object-oriented interface
 * @export
 * @class AccessAndAuthenticationApi
 * @extends {BaseAPI}
 */
export class AccessAndAuthenticationApi extends BaseAPI {
    /**
     * Firstly, you will need an access token as a machine user. This will allow you to log into the Seccl sandbox environment.
     * @summary Generate an access token
     * @param {AccessAndAuthenticationApiAuthenticatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessAndAuthenticationApi
     */
    public authenticatePost(requestParameters: AccessAndAuthenticationApiAuthenticatePostRequest = {}, options?: AxiosRequestConfig) {
        return AccessAndAuthenticationApiFp(this.configuration).authenticatePost(requestParameters.authRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This action allows the user to change their password once they have already set one up on the system.
     * @summary Change your password
     * @param {AccessAndAuthenticationApiChangepasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessAndAuthenticationApi
     */
    public changepasswordPost(requestParameters: AccessAndAuthenticationApiChangepasswordPostRequest = {}, options?: AxiosRequestConfig) {
        return AccessAndAuthenticationApiFp(this.configuration).changepasswordPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.changePassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessAndAuthenticationApiContentFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessAndAuthenticationApi
     */
    public contentFirmIdGet(requestParameters: AccessAndAuthenticationApiContentFirmIdGetRequest, options?: AxiosRequestConfig) {
        return AccessAndAuthenticationApiFp(this.configuration).contentFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.nodeId, requestParameters.space, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessAndAuthenticationApiFirmHostnameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessAndAuthenticationApi
     */
    public firmHostnameGet(requestParameters: AccessAndAuthenticationApiFirmHostnameGetRequest, options?: AxiosRequestConfig) {
        return AccessAndAuthenticationApiFp(this.configuration).firmHostnameGet(requestParameters.xSecclClientAuth, requestParameters.id, requestParameters.host, requestParameters.nodeId, requestParameters.type, requestParameters.firmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This triggers a password reset email to be sent to the user. This email has a 30-minute timeout from the point of instruction.
     * @summary Generate set password email
     * @param {AccessAndAuthenticationApiResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessAndAuthenticationApi
     */
    public resetPost(requestParameters: AccessAndAuthenticationApiResetPostRequest = {}, options?: AxiosRequestConfig) {
        return AccessAndAuthenticationApiFp(this.configuration).resetPost(requestParameters.contentType, requestParameters.resetPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccessAndAuthenticationApiSessionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessAndAuthenticationApi
     */
    public sessionGet(requestParameters: AccessAndAuthenticationApiSessionGetRequest = {}, options?: AxiosRequestConfig) {
        return AccessAndAuthenticationApiFp(this.configuration).sessionGet(requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This action creates a new password using the access token.
     * @summary Set password using access token
     * @param {AccessAndAuthenticationApiSetpasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessAndAuthenticationApi
     */
    public setpasswordPost(requestParameters: AccessAndAuthenticationApiSetpasswordPostRequest = {}, options?: AxiosRequestConfig) {
        return AccessAndAuthenticationApiFp(this.configuration).setpasswordPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.setPassword, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AccountManagementApi - axios parameter creator
 * @export
 */
export const AccountManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This command returns the account object.  This includes the `clientproduct` Id.
         * @summary Retrieve an account
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountFirmIdAccountIdGet: async (firmId: string, accountId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('accountFirmIdAccountIdGet', 'firmId', firmId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountFirmIdAccountIdGet', 'accountId', accountId)
            const localVarPath = `/account/{firmId}/{accountId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This flow updates an existing investment account and creates a regular bank transfer expectation.  The investor will need to set up a standing order for the relevant payment date and include the correct payment reference.  When you create a recurring payment on an investment account, the payment expectation is generated at 8:00 am in the morning with a status of `Pending`. The `Pending` expectation remains until the money is allocated or it is manually deleted by Seccl on request.  A single investment account can have multiple recurring payments within the `recurringPayment` array.  This returns a successful array.
         * @summary Update account with a recurring withdrawal / Order allocation
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {PatchAccount} [patchAccount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountFirmIdAccountIdPatch: async (firmId: string, accountId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, patchAccount?: PatchAccount, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('accountFirmIdAccountIdPatch', 'firmId', firmId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountFirmIdAccountIdPatch', 'accountId', accountId)
            const localVarPath = `/account/{firmId}/{accountId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchAccount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the status of the account to `Suspended` or `Active`  Any attempts to instruct a transaction on a `Suspended` investment account will fall to exceptions and will not be processed  This functionality could be used where a wrapper is voided, cancelled, or closed
         * @summary Update the status of an account
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountFirmIdAccountIdPut: async (firmId: string, accountId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('accountFirmIdAccountIdPut', 'firmId', firmId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountFirmIdAccountIdPut', 'accountId', accountId)
            const localVarPath = `/account/{firmId}/{accountId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a list of account objects for the specified firm. Results can be filtered by one or more client IDs and wrapperType.
         * @summary List accounts for a firm
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {Array<string>} [clientId] Comma-separated list of client IDs to filter accounts by (e.g. &#x60;clientId&#x3D;one,two,three&#x60;).
         * @param {WrapperType} [wrapperType] Filter accounts by wrapper type (e.g. &#x60;ISA&#x60;, &#x60;SIPP&#x60;, &#x60;GIA&#x60;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, clientId?: Array<string>, wrapperType?: WrapperType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('accountFirmIdGet', 'firmId', firmId)
            const localVarPath = `/account/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (clientId) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (wrapperType !== undefined) {
                localVarQueryParameter['wrapperType'] = wrapperType;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the account objects for all investment accounts on the platform
         * @summary List account summaries
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountListFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, name?: string, id?: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('accountListFirmIdGet', 'firmId', firmId)
            const localVarPath = `/account/list/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an account
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateAccount} [createAccount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, createAccount?: CreateAccount, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a summary of transactions that have taken place in an investment account. This includes: - Payments - Charges - Income (dividends and cash interest) - Transfers - Internal cash movements - Sell and invest orders 
         * @summary Retrieve the account report
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountReportFirmIdAccountIdGet: async (firmId: string, accountId: string, contentType?: string, apiToken?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('accountReportFirmIdAccountIdGet', 'firmId', firmId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountReportFirmIdAccountIdGet', 'accountId', accountId)
            const localVarPath = `/account/report/{firmId}/{accountId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns the account summary object for the specified account
         * @summary Retrieve the account summary
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountSummaryFirmIdAccountIdGet: async (firmId: string, accountId: string, contentType?: string, apiToken?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('accountSummaryFirmIdAccountIdGet', 'firmId', firmId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountSummaryFirmIdAccountIdGet', 'accountId', accountId)
            const localVarPath = `/account/summary/{firmId}/{accountId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns the live account summary object for the specified account
         * @summary Retrieve the live account summary
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountSummaryLiveFirmIdAccountIdGet: async (firmId: string, accountId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('accountSummaryLiveFirmIdAccountIdGet', 'firmId', firmId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountSummaryLiveFirmIdAccountIdGet', 'accountId', accountId)
            const localVarPath = `/account/summary/live/{firmId}/{accountId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attempts to validate the payment type for an account, rejecting if the direct debit mandate has not been signed
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {ValidatedAccountPaymentMethod} [validatedAccountPaymentMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountValidatePaymentMethodPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, validatedAccountPaymentMethod?: ValidatedAccountPaymentMethod, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/validatePaymentMethod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validatedAccountPaymentMethod, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the adviser fee and platform fee configuration for the specified account, including fee tiers and any fixed fees.
         * @summary Retrieve fee details for an account
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountFeesFirmIdAccountIdGet: async (firmId: string, accountId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('v1AccountFeesFirmIdAccountIdGet', 'firmId', firmId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('v1AccountFeesFirmIdAccountIdGet', 'accountId', accountId)
            const localVarPath = `/v1/account/fees/{firmId}/{accountId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountManagementApi - functional programming interface
 * @export
 */
export const AccountManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * This command returns the account object.  This includes the `clientproduct` Id.
         * @summary Retrieve an account
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountFirmIdAccountIdGet(firmId: string, accountId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountFirmIdAccountIdGet(firmId, accountId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This flow updates an existing investment account and creates a regular bank transfer expectation.  The investor will need to set up a standing order for the relevant payment date and include the correct payment reference.  When you create a recurring payment on an investment account, the payment expectation is generated at 8:00 am in the morning with a status of `Pending`. The `Pending` expectation remains until the money is allocated or it is manually deleted by Seccl on request.  A single investment account can have multiple recurring payments within the `recurringPayment` array.  This returns a successful array.
         * @summary Update account with a recurring withdrawal / Order allocation
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {PatchAccount} [patchAccount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountFirmIdAccountIdPatch(firmId: string, accountId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, patchAccount?: PatchAccount, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountFirmIdAccountIdPatch(firmId, accountId, contentType, apiToken, idempotencyKey, patchAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the status of the account to `Suspended` or `Active`  Any attempts to instruct a transaction on a `Suspended` investment account will fall to exceptions and will not be processed  This functionality could be used where a wrapper is voided, cancelled, or closed
         * @summary Update the status of an account
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountFirmIdAccountIdPut(firmId: string, accountId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountFirmIdAccountIdPut(firmId, accountId, contentType, apiToken, idempotencyKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a list of account objects for the specified firm. Results can be filtered by one or more client IDs and wrapperType.
         * @summary List accounts for a firm
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {Array<string>} [clientId] Comma-separated list of client IDs to filter accounts by (e.g. &#x60;clientId&#x3D;one,two,three&#x60;).
         * @param {WrapperType} [wrapperType] Filter accounts by wrapper type (e.g. &#x60;ISA&#x60;, &#x60;SIPP&#x60;, &#x60;GIA&#x60;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountFirmIdGet(firmId: string, contentType?: string, apiToken?: string, clientId?: Array<string>, wrapperType?: WrapperType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountSummaryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountFirmIdGet(firmId, contentType, apiToken, clientId, wrapperType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the account objects for all investment accounts on the platform
         * @summary List account summaries
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountListFirmIdGet(firmId: string, contentType?: string, apiToken?: string, name?: string, id?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountSummaryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountListFirmIdGet(firmId, contentType, apiToken, name, id, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create an account
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateAccount} [createAccount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountPost(contentType?: string, apiToken?: string, idempotencyKey?: string, createAccount?: CreateAccount, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountPost(contentType, apiToken, idempotencyKey, createAccount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a summary of transactions that have taken place in an investment account. This includes: - Payments - Charges - Income (dividends and cash interest) - Transfers - Internal cash movements - Sell and invest orders 
         * @summary Retrieve the account report
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountReportFirmIdAccountIdGet(firmId: string, accountId: string, contentType?: string, apiToken?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountReportFirmIdAccountIdGet(firmId, accountId, contentType, apiToken, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns the account summary object for the specified account
         * @summary Retrieve the account summary
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountSummaryFirmIdAccountIdGet(firmId: string, accountId: string, contentType?: string, apiToken?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountSummaryFirmIdAccountIdGet(firmId, accountId, contentType, apiToken, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns the live account summary object for the specified account
         * @summary Retrieve the live account summary
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountSummaryLiveFirmIdAccountIdGet(firmId: string, accountId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLiveAccountSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountSummaryLiveFirmIdAccountIdGet(firmId, accountId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Attempts to validate the payment type for an account, rejecting if the direct debit mandate has not been signed
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {ValidatedAccountPaymentMethod} [validatedAccountPaymentMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountValidatePaymentMethodPost(contentType?: string, apiToken?: string, idempotencyKey?: string, validatedAccountPaymentMethod?: ValidatedAccountPaymentMethod, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountValidatePaymentMethodPost(contentType, apiToken, idempotencyKey, validatedAccountPaymentMethod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the adviser fee and platform fee configuration for the specified account, including fee tiers and any fixed fees.
         * @summary Retrieve fee details for an account
         * @param {string} firmId 
         * @param {string} accountId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AccountFeesFirmIdAccountIdGet(firmId: string, accountId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountFees>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1AccountFeesFirmIdAccountIdGet(firmId, accountId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountManagementApi - factory interface
 * @export
 */
export const AccountManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountManagementApiFp(configuration)
    return {
        /**
         * This command returns the account object.  This includes the `clientproduct` Id.
         * @summary Retrieve an account
         * @param {AccountManagementApiAccountFirmIdAccountIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountFirmIdAccountIdGet(requestParameters: AccountManagementApiAccountFirmIdAccountIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAccount> {
            return localVarFp.accountFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This flow updates an existing investment account and creates a regular bank transfer expectation.  The investor will need to set up a standing order for the relevant payment date and include the correct payment reference.  When you create a recurring payment on an investment account, the payment expectation is generated at 8:00 am in the morning with a status of `Pending`. The `Pending` expectation remains until the money is allocated or it is manually deleted by Seccl on request.  A single investment account can have multiple recurring payments within the `recurringPayment` array.  This returns a successful array.
         * @summary Update account with a recurring withdrawal / Order allocation
         * @param {AccountManagementApiAccountFirmIdAccountIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountFirmIdAccountIdPatch(requestParameters: AccountManagementApiAccountFirmIdAccountIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<EmptyResponse> {
            return localVarFp.accountFirmIdAccountIdPatch(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.patchAccount, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the status of the account to `Suspended` or `Active`  Any attempts to instruct a transaction on a `Suspended` investment account will fall to exceptions and will not be processed  This functionality could be used where a wrapper is voided, cancelled, or closed
         * @summary Update the status of an account
         * @param {AccountManagementApiAccountFirmIdAccountIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountFirmIdAccountIdPut(requestParameters: AccountManagementApiAccountFirmIdAccountIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountFirmIdAccountIdPut(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a list of account objects for the specified firm. Results can be filtered by one or more client IDs and wrapperType.
         * @summary List accounts for a firm
         * @param {AccountManagementApiAccountFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountFirmIdGet(requestParameters: AccountManagementApiAccountFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAccountSummaryList> {
            return localVarFp.accountFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.clientId, requestParameters.wrapperType, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the account objects for all investment accounts on the platform
         * @summary List account summaries
         * @param {AccountManagementApiAccountListFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountListFirmIdGet(requestParameters: AccountManagementApiAccountListFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAccountSummaryList> {
            return localVarFp.accountListFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.name, requestParameters.id, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an account
         * @param {AccountManagementApiAccountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountPost(requestParameters: AccountManagementApiAccountPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<AccountPost200Response> {
            return localVarFp.accountPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createAccount, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a summary of transactions that have taken place in an investment account. This includes: - Payments - Charges - Income (dividends and cash interest) - Transfers - Internal cash movements - Sell and invest orders 
         * @summary Retrieve the account report
         * @param {AccountManagementApiAccountReportFirmIdAccountIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountReportFirmIdAccountIdGet(requestParameters: AccountManagementApiAccountReportFirmIdAccountIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAccountReport> {
            return localVarFp.accountReportFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns the account summary object for the specified account
         * @summary Retrieve the account summary
         * @param {AccountManagementApiAccountSummaryFirmIdAccountIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountSummaryFirmIdAccountIdGet(requestParameters: AccountManagementApiAccountSummaryFirmIdAccountIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAccountSummary> {
            return localVarFp.accountSummaryFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns the live account summary object for the specified account
         * @summary Retrieve the live account summary
         * @param {AccountManagementApiAccountSummaryLiveFirmIdAccountIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountSummaryLiveFirmIdAccountIdGet(requestParameters: AccountManagementApiAccountSummaryLiveFirmIdAccountIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetLiveAccountSummary> {
            return localVarFp.accountSummaryLiveFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attempts to validate the payment type for an account, rejecting if the direct debit mandate has not been signed
         * @param {AccountManagementApiAccountValidatePaymentMethodPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountValidatePaymentMethodPost(requestParameters: AccountManagementApiAccountValidatePaymentMethodPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountValidatePaymentMethodPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.validatedAccountPaymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the adviser fee and platform fee configuration for the specified account, including fee tiers and any fixed fees.
         * @summary Retrieve fee details for an account
         * @param {AccountManagementApiV1AccountFeesFirmIdAccountIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountFeesFirmIdAccountIdGet(requestParameters: AccountManagementApiV1AccountFeesFirmIdAccountIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAccountFees> {
            return localVarFp.v1AccountFeesFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for accountFirmIdAccountIdGet operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountFirmIdAccountIdGetRequest
 */
export interface AccountManagementApiAccountFirmIdAccountIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdGet
     */
    readonly accountId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for accountFirmIdAccountIdPatch operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountFirmIdAccountIdPatchRequest
 */
export interface AccountManagementApiAccountFirmIdAccountIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPatch
     */
    readonly accountId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPatch
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {PatchAccount}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPatch
     */
    readonly patchAccount?: PatchAccount
}

/**
 * Request parameters for accountFirmIdAccountIdPut operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountFirmIdAccountIdPutRequest
 */
export interface AccountManagementApiAccountFirmIdAccountIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPut
     */
    readonly accountId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdAccountIdPut
     */
    readonly idempotencyKey?: string
}

/**
 * Request parameters for accountFirmIdGet operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountFirmIdGetRequest
 */
export interface AccountManagementApiAccountFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountFirmIdGet
     */
    readonly apiToken?: string

    /**
     * Comma-separated list of client IDs to filter accounts by (e.g. &#x60;clientId&#x3D;one,two,three&#x60;).
     * @type {Array<string>}
     * @memberof AccountManagementApiAccountFirmIdGet
     */
    readonly clientId?: Array<string>

    /**
     * Filter accounts by wrapper type (e.g. &#x60;ISA&#x60;, &#x60;SIPP&#x60;, &#x60;GIA&#x60;)
     * @type {WrapperType}
     * @memberof AccountManagementApiAccountFirmIdGet
     */
    readonly wrapperType?: WrapperType
}

/**
 * Request parameters for accountListFirmIdGet operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountListFirmIdGetRequest
 */
export interface AccountManagementApiAccountListFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountListFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountListFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountListFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountListFirmIdGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountListFirmIdGet
     */
    readonly id?: string

    /**
     * 
     * @type {number}
     * @memberof AccountManagementApiAccountListFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AccountManagementApiAccountListFirmIdGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for accountPost operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountPostRequest
 */
export interface AccountManagementApiAccountPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreateAccount}
     * @memberof AccountManagementApiAccountPost
     */
    readonly createAccount?: CreateAccount
}

/**
 * Request parameters for accountReportFirmIdAccountIdGet operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountReportFirmIdAccountIdGetRequest
 */
export interface AccountManagementApiAccountReportFirmIdAccountIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountReportFirmIdAccountIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountReportFirmIdAccountIdGet
     */
    readonly accountId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountReportFirmIdAccountIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountReportFirmIdAccountIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountReportFirmIdAccountIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountReportFirmIdAccountIdGet
     */
    readonly toDate?: string
}

/**
 * Request parameters for accountSummaryFirmIdAccountIdGet operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountSummaryFirmIdAccountIdGetRequest
 */
export interface AccountManagementApiAccountSummaryFirmIdAccountIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryFirmIdAccountIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryFirmIdAccountIdGet
     */
    readonly accountId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryFirmIdAccountIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryFirmIdAccountIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryFirmIdAccountIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryFirmIdAccountIdGet
     */
    readonly toDate?: string
}

/**
 * Request parameters for accountSummaryLiveFirmIdAccountIdGet operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountSummaryLiveFirmIdAccountIdGetRequest
 */
export interface AccountManagementApiAccountSummaryLiveFirmIdAccountIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryLiveFirmIdAccountIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryLiveFirmIdAccountIdGet
     */
    readonly accountId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryLiveFirmIdAccountIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountSummaryLiveFirmIdAccountIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for accountValidatePaymentMethodPost operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiAccountValidatePaymentMethodPostRequest
 */
export interface AccountManagementApiAccountValidatePaymentMethodPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountValidatePaymentMethodPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountValidatePaymentMethodPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiAccountValidatePaymentMethodPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {ValidatedAccountPaymentMethod}
     * @memberof AccountManagementApiAccountValidatePaymentMethodPost
     */
    readonly validatedAccountPaymentMethod?: ValidatedAccountPaymentMethod
}

/**
 * Request parameters for v1AccountFeesFirmIdAccountIdGet operation in AccountManagementApi.
 * @export
 * @interface AccountManagementApiV1AccountFeesFirmIdAccountIdGetRequest
 */
export interface AccountManagementApiV1AccountFeesFirmIdAccountIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiV1AccountFeesFirmIdAccountIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiV1AccountFeesFirmIdAccountIdGet
     */
    readonly accountId: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiV1AccountFeesFirmIdAccountIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AccountManagementApiV1AccountFeesFirmIdAccountIdGet
     */
    readonly apiToken?: string
}

/**
 * AccountManagementApi - object-oriented interface
 * @export
 * @class AccountManagementApi
 * @extends {BaseAPI}
 */
export class AccountManagementApi extends BaseAPI {
    /**
     * This command returns the account object.  This includes the `clientproduct` Id.
     * @summary Retrieve an account
     * @param {AccountManagementApiAccountFirmIdAccountIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountFirmIdAccountIdGet(requestParameters: AccountManagementApiAccountFirmIdAccountIdGetRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This flow updates an existing investment account and creates a regular bank transfer expectation.  The investor will need to set up a standing order for the relevant payment date and include the correct payment reference.  When you create a recurring payment on an investment account, the payment expectation is generated at 8:00 am in the morning with a status of `Pending`. The `Pending` expectation remains until the money is allocated or it is manually deleted by Seccl on request.  A single investment account can have multiple recurring payments within the `recurringPayment` array.  This returns a successful array.
     * @summary Update account with a recurring withdrawal / Order allocation
     * @param {AccountManagementApiAccountFirmIdAccountIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountFirmIdAccountIdPatch(requestParameters: AccountManagementApiAccountFirmIdAccountIdPatchRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountFirmIdAccountIdPatch(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.patchAccount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the status of the account to `Suspended` or `Active`  Any attempts to instruct a transaction on a `Suspended` investment account will fall to exceptions and will not be processed  This functionality could be used where a wrapper is voided, cancelled, or closed
     * @summary Update the status of an account
     * @param {AccountManagementApiAccountFirmIdAccountIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountFirmIdAccountIdPut(requestParameters: AccountManagementApiAccountFirmIdAccountIdPutRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountFirmIdAccountIdPut(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a list of account objects for the specified firm. Results can be filtered by one or more client IDs and wrapperType.
     * @summary List accounts for a firm
     * @param {AccountManagementApiAccountFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountFirmIdGet(requestParameters: AccountManagementApiAccountFirmIdGetRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.clientId, requestParameters.wrapperType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the account objects for all investment accounts on the platform
     * @summary List account summaries
     * @param {AccountManagementApiAccountListFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountListFirmIdGet(requestParameters: AccountManagementApiAccountListFirmIdGetRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountListFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.name, requestParameters.id, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an account
     * @param {AccountManagementApiAccountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountPost(requestParameters: AccountManagementApiAccountPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createAccount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a summary of transactions that have taken place in an investment account. This includes: - Payments - Charges - Income (dividends and cash interest) - Transfers - Internal cash movements - Sell and invest orders 
     * @summary Retrieve the account report
     * @param {AccountManagementApiAccountReportFirmIdAccountIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountReportFirmIdAccountIdGet(requestParameters: AccountManagementApiAccountReportFirmIdAccountIdGetRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountReportFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns the account summary object for the specified account
     * @summary Retrieve the account summary
     * @param {AccountManagementApiAccountSummaryFirmIdAccountIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountSummaryFirmIdAccountIdGet(requestParameters: AccountManagementApiAccountSummaryFirmIdAccountIdGetRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountSummaryFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns the live account summary object for the specified account
     * @summary Retrieve the live account summary
     * @param {AccountManagementApiAccountSummaryLiveFirmIdAccountIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountSummaryLiveFirmIdAccountIdGet(requestParameters: AccountManagementApiAccountSummaryLiveFirmIdAccountIdGetRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountSummaryLiveFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attempts to validate the payment type for an account, rejecting if the direct debit mandate has not been signed
     * @param {AccountManagementApiAccountValidatePaymentMethodPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public accountValidatePaymentMethodPost(requestParameters: AccountManagementApiAccountValidatePaymentMethodPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).accountValidatePaymentMethodPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.validatedAccountPaymentMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the adviser fee and platform fee configuration for the specified account, including fee tiers and any fixed fees.
     * @summary Retrieve fee details for an account
     * @param {AccountManagementApiV1AccountFeesFirmIdAccountIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountManagementApi
     */
    public v1AccountFeesFirmIdAccountIdGet(requestParameters: AccountManagementApiV1AccountFeesFirmIdAccountIdGetRequest, options?: AxiosRequestConfig) {
        return AccountManagementApiFp(this.configuration).v1AccountFeesFirmIdAccountIdGet(requestParameters.firmId, requestParameters.accountId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AddressLookupApi - axios parameter creator
 * @export
 */
export const AddressLookupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Address lookup with postcode
         * @param {AddresslookupPostRequest} [addresslookupPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addresslookupPost: async (addresslookupPostRequest?: AddresslookupPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/addresslookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addresslookupPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressLookupApi - functional programming interface
 * @export
 */
export const AddressLookupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressLookupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Address lookup with postcode
         * @param {AddresslookupPostRequest} [addresslookupPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addresslookupPost(addresslookupPostRequest?: AddresslookupPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddresslookupPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addresslookupPost(addresslookupPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AddressLookupApi - factory interface
 * @export
 */
export const AddressLookupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressLookupApiFp(configuration)
    return {
        /**
         * 
         * @summary Address lookup with postcode
         * @param {AddressLookupApiAddresslookupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addresslookupPost(requestParameters: AddressLookupApiAddresslookupPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<AddresslookupPost200Response> {
            return localVarFp.addresslookupPost(requestParameters.addresslookupPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addresslookupPost operation in AddressLookupApi.
 * @export
 * @interface AddressLookupApiAddresslookupPostRequest
 */
export interface AddressLookupApiAddresslookupPostRequest {
    /**
     * 
     * @type {AddresslookupPostRequest}
     * @memberof AddressLookupApiAddresslookupPost
     */
    readonly addresslookupPostRequest?: AddresslookupPostRequest
}

/**
 * AddressLookupApi - object-oriented interface
 * @export
 * @class AddressLookupApi
 * @extends {BaseAPI}
 */
export class AddressLookupApi extends BaseAPI {
    /**
     * 
     * @summary Address lookup with postcode
     * @param {AddressLookupApiAddresslookupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressLookupApi
     */
    public addresslookupPost(requestParameters: AddressLookupApiAddresslookupPostRequest = {}, options?: AxiosRequestConfig) {
        return AddressLookupApiFp(this.configuration).addresslookupPost(requestParameters.addresslookupPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This retrieves a single asset object of the specified `assetId`.
         * @summary Retrieve single asset in platform universe
         * @param {string} firmId 
         * @param {string} assetId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [convertTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetFirmIdAssetIdGet: async (firmId: string, assetId: string, contentType?: string, apiToken?: string, convertTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('assetFirmIdAssetIdGet', 'firmId', firmId)
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetFirmIdAssetIdGet', 'assetId', assetId)
            const localVarPath = `/asset/{firmId}/{assetId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (convertTo !== undefined) {
                localVarQueryParameter['convertTo'] = convertTo;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This Flow edits the asset in the platform asset universe
         * @summary edit a firms asset
         * @param {string} firmId 
         * @param {string} assetId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateAsset} [updateAsset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetFirmIdAssetIdPut: async (firmId: string, assetId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateAsset?: UpdateAsset, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('assetFirmIdAssetIdPut', 'firmId', firmId)
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('assetFirmIdAssetIdPut', 'assetId', assetId)
            const localVarPath = `/asset/{firmId}/{assetId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAsset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This flow allows you to retrieve assets in your platform asset universe.
         * @summary Retrieve platform asset universe
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [idOrName] 
         * @param {string} [longName] 
         * @param {string} [isin] 
         * @param {string} [instrumentType] 
         * @param {string} [currency] 
         * @param {string} [ticker] 
         * @param {string} [convertTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, page?: number, pageSize?: number, idOrName?: string, longName?: string, isin?: string, instrumentType?: string, currency?: string, ticker?: string, convertTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('assetFirmIdGet', 'firmId', firmId)
            const localVarPath = `/asset/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (idOrName !== undefined) {
                localVarQueryParameter['idOrName'] = idOrName;
            }

            if (longName !== undefined) {
                localVarQueryParameter['longName'] = longName;
            }

            if (isin !== undefined) {
                localVarQueryParameter['isin'] = isin;
            }

            if (instrumentType !== undefined) {
                localVarQueryParameter['instrumentType'] = instrumentType;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (ticker !== undefined) {
                localVarQueryParameter['ticker'] = ticker;
            }

            if (convertTo !== undefined) {
                localVarQueryParameter['convertTo'] = convertTo;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This flow adds an asset to the platform asset universe, making it available to trade, or to add to a `model` or `recurringOrders` allocation. To add an asset to your asset universe, send a `POST` request to the `/asset` endpoint. This makes the asset available to trade.
         * @summary Add asset to firm
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {AssetPostRequest} [assetPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, assetPostRequest?: AssetPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves a single Master asset object of the specified `assetId`.
         * @summary Retrieve single Master asset in platform universe
         * @param {string} firmId 
         * @param {string} assetId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [convertTo] 
         * @param {boolean} [includeFirmAssetRestrictions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterinstrumentFirmIdAssetIdGet: async (firmId: string, assetId: string, contentType?: string, apiToken?: string, convertTo?: string, includeFirmAssetRestrictions?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('masterinstrumentFirmIdAssetIdGet', 'firmId', firmId)
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('masterinstrumentFirmIdAssetIdGet', 'assetId', assetId)
            const localVarPath = `/masterinstrument/{firmId}/{assetId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (convertTo !== undefined) {
                localVarQueryParameter['convertTo'] = convertTo;
            }

            if (includeFirmAssetRestrictions !== undefined) {
                localVarQueryParameter['includeFirmAssetRestrictions'] = includeFirmAssetRestrictions;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * These list assets are available from Seccl\'s Master Universe and are available to add to your platform\'s asset universe.  **Please note: the Master Universe asset list in the staging environment differs to the Master Universe asset list in the production environment.**
         * @summary Retrieve master asset universe
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [isin] 
         * @param {string} [instrumentType] 
         * @param {string} [currency] 
         * @param {string} [ticker] 
         * @param {boolean} [includeFirmAssetRestrictions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterinstrumentFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, page?: number, pageSize?: number, isin?: string, instrumentType?: string, currency?: string, ticker?: string, includeFirmAssetRestrictions?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('masterinstrumentFirmIdGet', 'firmId', firmId)
            const localVarPath = `/masterinstrument/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (isin !== undefined) {
                localVarQueryParameter['isin'] = isin;
            }

            if (instrumentType !== undefined) {
                localVarQueryParameter['instrumentType'] = instrumentType;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (ticker !== undefined) {
                localVarQueryParameter['ticker'] = ticker;
            }

            if (includeFirmAssetRestrictions !== undefined) {
                localVarQueryParameter['includeFirmAssetRestrictions'] = includeFirmAssetRestrictions;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * This retrieves a single asset object of the specified `assetId`.
         * @summary Retrieve single asset in platform universe
         * @param {string} firmId 
         * @param {string} assetId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [convertTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetFirmIdAssetIdGet(firmId: string, assetId: string, contentType?: string, apiToken?: string, convertTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetFirmIdAssetIdGet(firmId, assetId, contentType, apiToken, convertTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This Flow edits the asset in the platform asset universe
         * @summary edit a firms asset
         * @param {string} firmId 
         * @param {string} assetId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateAsset} [updateAsset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetFirmIdAssetIdPut(firmId: string, assetId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateAsset?: UpdateAsset, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetFirmIdAssetIdPut(firmId, assetId, contentType, apiToken, idempotencyKey, updateAsset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This flow allows you to retrieve assets in your platform asset universe.
         * @summary Retrieve platform asset universe
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [idOrName] 
         * @param {string} [longName] 
         * @param {string} [isin] 
         * @param {string} [instrumentType] 
         * @param {string} [currency] 
         * @param {string} [ticker] 
         * @param {string} [convertTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetFirmIdGet(firmId: string, contentType?: string, apiToken?: string, page?: number, pageSize?: number, idOrName?: string, longName?: string, isin?: string, instrumentType?: string, currency?: string, ticker?: string, convertTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssets>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetFirmIdGet(firmId, contentType, apiToken, page, pageSize, idOrName, longName, isin, instrumentType, currency, ticker, convertTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This flow adds an asset to the platform asset universe, making it available to trade, or to add to a `model` or `recurringOrders` allocation. To add an asset to your asset universe, send a `POST` request to the `/asset` endpoint. This makes the asset available to trade.
         * @summary Add asset to firm
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {AssetPostRequest} [assetPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetPost(contentType?: string, apiToken?: string, idempotencyKey?: string, assetPostRequest?: AssetPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetPost(contentType, apiToken, idempotencyKey, assetPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves a single Master asset object of the specified `assetId`.
         * @summary Retrieve single Master asset in platform universe
         * @param {string} firmId 
         * @param {string} assetId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [convertTo] 
         * @param {boolean} [includeFirmAssetRestrictions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterinstrumentFirmIdAssetIdGet(firmId: string, assetId: string, contentType?: string, apiToken?: string, convertTo?: string, includeFirmAssetRestrictions?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssetFromUniverse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterinstrumentFirmIdAssetIdGet(firmId, assetId, contentType, apiToken, convertTo, includeFirmAssetRestrictions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * These list assets are available from Seccl\'s Master Universe and are available to add to your platform\'s asset universe.  **Please note: the Master Universe asset list in the staging environment differs to the Master Universe asset list in the production environment.**
         * @summary Retrieve master asset universe
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [isin] 
         * @param {string} [instrumentType] 
         * @param {string} [currency] 
         * @param {string} [ticker] 
         * @param {boolean} [includeFirmAssetRestrictions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterinstrumentFirmIdGet(firmId: string, contentType?: string, apiToken?: string, page?: number, pageSize?: number, isin?: string, instrumentType?: string, currency?: string, ticker?: string, includeFirmAssetRestrictions?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssetUniverse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterinstrumentFirmIdGet(firmId, contentType, apiToken, page, pageSize, isin, instrumentType, currency, ticker, includeFirmAssetRestrictions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetsApiFp(configuration)
    return {
        /**
         * This retrieves a single asset object of the specified `assetId`.
         * @summary Retrieve single asset in platform universe
         * @param {AssetsApiAssetFirmIdAssetIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetFirmIdAssetIdGet(requestParameters: AssetsApiAssetFirmIdAssetIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAsset> {
            return localVarFp.assetFirmIdAssetIdGet(requestParameters.firmId, requestParameters.assetId, requestParameters.contentType, requestParameters.apiToken, requestParameters.convertTo, options).then((request) => request(axios, basePath));
        },
        /**
         * This Flow edits the asset in the platform asset universe
         * @summary edit a firms asset
         * @param {AssetsApiAssetFirmIdAssetIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetFirmIdAssetIdPut(requestParameters: AssetsApiAssetFirmIdAssetIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetFirmIdAssetIdPut(requestParameters.firmId, requestParameters.assetId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateAsset, options).then((request) => request(axios, basePath));
        },
        /**
         * This flow allows you to retrieve assets in your platform asset universe.
         * @summary Retrieve platform asset universe
         * @param {AssetsApiAssetFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetFirmIdGet(requestParameters: AssetsApiAssetFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAssets> {
            return localVarFp.assetFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.page, requestParameters.pageSize, requestParameters.idOrName, requestParameters.longName, requestParameters.isin, requestParameters.instrumentType, requestParameters.currency, requestParameters.ticker, requestParameters.convertTo, options).then((request) => request(axios, basePath));
        },
        /**
         * This flow adds an asset to the platform asset universe, making it available to trade, or to add to a `model` or `recurringOrders` allocation. To add an asset to your asset universe, send a `POST` request to the `/asset` endpoint. This makes the asset available to trade.
         * @summary Add asset to firm
         * @param {AssetsApiAssetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetPost(requestParameters: AssetsApiAssetPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.assetPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves a single Master asset object of the specified `assetId`.
         * @summary Retrieve single Master asset in platform universe
         * @param {AssetsApiMasterinstrumentFirmIdAssetIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterinstrumentFirmIdAssetIdGet(requestParameters: AssetsApiMasterinstrumentFirmIdAssetIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAssetFromUniverse> {
            return localVarFp.masterinstrumentFirmIdAssetIdGet(requestParameters.firmId, requestParameters.assetId, requestParameters.contentType, requestParameters.apiToken, requestParameters.convertTo, requestParameters.includeFirmAssetRestrictions, options).then((request) => request(axios, basePath));
        },
        /**
         * These list assets are available from Seccl\'s Master Universe and are available to add to your platform\'s asset universe.  **Please note: the Master Universe asset list in the staging environment differs to the Master Universe asset list in the production environment.**
         * @summary Retrieve master asset universe
         * @param {AssetsApiMasterinstrumentFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterinstrumentFirmIdGet(requestParameters: AssetsApiMasterinstrumentFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAssetUniverse> {
            return localVarFp.masterinstrumentFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.page, requestParameters.pageSize, requestParameters.isin, requestParameters.instrumentType, requestParameters.currency, requestParameters.ticker, requestParameters.includeFirmAssetRestrictions, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assetFirmIdAssetIdGet operation in AssetsApi.
 * @export
 * @interface AssetsApiAssetFirmIdAssetIdGetRequest
 */
export interface AssetsApiAssetFirmIdAssetIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdGet
     */
    readonly assetId: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdGet
     */
    readonly convertTo?: string
}

/**
 * Request parameters for assetFirmIdAssetIdPut operation in AssetsApi.
 * @export
 * @interface AssetsApiAssetFirmIdAssetIdPutRequest
 */
export interface AssetsApiAssetFirmIdAssetIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdPut
     */
    readonly assetId: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdAssetIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {UpdateAsset}
     * @memberof AssetsApiAssetFirmIdAssetIdPut
     */
    readonly updateAsset?: UpdateAsset
}

/**
 * Request parameters for assetFirmIdGet operation in AssetsApi.
 * @export
 * @interface AssetsApiAssetFirmIdGetRequest
 */
export interface AssetsApiAssetFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {number}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly idOrName?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly longName?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly isin?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly instrumentType?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly currency?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly ticker?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetFirmIdGet
     */
    readonly convertTo?: string
}

/**
 * Request parameters for assetPost operation in AssetsApi.
 * @export
 * @interface AssetsApiAssetPostRequest
 */
export interface AssetsApiAssetPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiAssetPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {AssetPostRequest}
     * @memberof AssetsApiAssetPost
     */
    readonly assetPostRequest?: AssetPostRequest
}

/**
 * Request parameters for masterinstrumentFirmIdAssetIdGet operation in AssetsApi.
 * @export
 * @interface AssetsApiMasterinstrumentFirmIdAssetIdGetRequest
 */
export interface AssetsApiMasterinstrumentFirmIdAssetIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdAssetIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdAssetIdGet
     */
    readonly assetId: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdAssetIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdAssetIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdAssetIdGet
     */
    readonly convertTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof AssetsApiMasterinstrumentFirmIdAssetIdGet
     */
    readonly includeFirmAssetRestrictions?: boolean
}

/**
 * Request parameters for masterinstrumentFirmIdGet operation in AssetsApi.
 * @export
 * @interface AssetsApiMasterinstrumentFirmIdGetRequest
 */
export interface AssetsApiMasterinstrumentFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {number}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly isin?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly instrumentType?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly currency?: string

    /**
     * 
     * @type {string}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly ticker?: string

    /**
     * 
     * @type {boolean}
     * @memberof AssetsApiMasterinstrumentFirmIdGet
     */
    readonly includeFirmAssetRestrictions?: boolean
}

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI {
    /**
     * This retrieves a single asset object of the specified `assetId`.
     * @summary Retrieve single asset in platform universe
     * @param {AssetsApiAssetFirmIdAssetIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetFirmIdAssetIdGet(requestParameters: AssetsApiAssetFirmIdAssetIdGetRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetFirmIdAssetIdGet(requestParameters.firmId, requestParameters.assetId, requestParameters.contentType, requestParameters.apiToken, requestParameters.convertTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This Flow edits the asset in the platform asset universe
     * @summary edit a firms asset
     * @param {AssetsApiAssetFirmIdAssetIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetFirmIdAssetIdPut(requestParameters: AssetsApiAssetFirmIdAssetIdPutRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetFirmIdAssetIdPut(requestParameters.firmId, requestParameters.assetId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateAsset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This flow allows you to retrieve assets in your platform asset universe.
     * @summary Retrieve platform asset universe
     * @param {AssetsApiAssetFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetFirmIdGet(requestParameters: AssetsApiAssetFirmIdGetRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.page, requestParameters.pageSize, requestParameters.idOrName, requestParameters.longName, requestParameters.isin, requestParameters.instrumentType, requestParameters.currency, requestParameters.ticker, requestParameters.convertTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This flow adds an asset to the platform asset universe, making it available to trade, or to add to a `model` or `recurringOrders` allocation. To add an asset to your asset universe, send a `POST` request to the `/asset` endpoint. This makes the asset available to trade.
     * @summary Add asset to firm
     * @param {AssetsApiAssetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public assetPost(requestParameters: AssetsApiAssetPostRequest = {}, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).assetPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.assetPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves a single Master asset object of the specified `assetId`.
     * @summary Retrieve single Master asset in platform universe
     * @param {AssetsApiMasterinstrumentFirmIdAssetIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public masterinstrumentFirmIdAssetIdGet(requestParameters: AssetsApiMasterinstrumentFirmIdAssetIdGetRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).masterinstrumentFirmIdAssetIdGet(requestParameters.firmId, requestParameters.assetId, requestParameters.contentType, requestParameters.apiToken, requestParameters.convertTo, requestParameters.includeFirmAssetRestrictions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * These list assets are available from Seccl\'s Master Universe and are available to add to your platform\'s asset universe.  **Please note: the Master Universe asset list in the staging environment differs to the Master Universe asset list in the production environment.**
     * @summary Retrieve master asset universe
     * @param {AssetsApiMasterinstrumentFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public masterinstrumentFirmIdGet(requestParameters: AssetsApiMasterinstrumentFirmIdGetRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).masterinstrumentFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.page, requestParameters.pageSize, requestParameters.isin, requestParameters.instrumentType, requestParameters.currency, requestParameters.ticker, requestParameters.includeFirmAssetRestrictions, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BalancesAndValuationsCashAndStockPostingsApi - axios parameter creator
 * @export
 */
export const BalancesAndValuationsCashAndStockPostingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This command returns the cash posting objects.
         * @summary List cash postings
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [postDateFrom] 
         * @param {string} [postDateTo] 
         * @param {number} [page] 
         * @param {number} [nodeId] 
         * @param {Array<string>} [transactionCode] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postingCashFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, postDateFrom?: string, postDateTo?: string, page?: number, nodeId?: number, transactionCode?: Array<string>, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('postingCashFirmIdGet', 'firmId', firmId)
            const localVarPath = `/posting/cash/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (postDateFrom !== undefined) {
                localVarQueryParameter['postDateFrom'] = postDateFrom;
            }

            if (postDateTo !== undefined) {
                localVarQueryParameter['postDateTo'] = postDateTo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (transactionCode) {
                localVarQueryParameter['transactionCode'] = transactionCode;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List stock postings
         * @summary List stock postings
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postingStockFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('postingStockFirmIdGet', 'firmId', firmId)
            const localVarPath = `/posting/stock/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BalancesAndValuationsCashAndStockPostingsApi - functional programming interface
 * @export
 */
export const BalancesAndValuationsCashAndStockPostingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BalancesAndValuationsCashAndStockPostingsApiAxiosParamCreator(configuration)
    return {
        /**
         * This command returns the cash posting objects.
         * @summary List cash postings
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [postDateFrom] 
         * @param {string} [postDateTo] 
         * @param {number} [page] 
         * @param {number} [nodeId] 
         * @param {Array<string>} [transactionCode] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postingCashFirmIdGet(firmId: string, contentType?: string, apiToken?: string, postDateFrom?: string, postDateTo?: string, page?: number, nodeId?: number, transactionCode?: Array<string>, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postingCashFirmIdGet(firmId, contentType, apiToken, postDateFrom, postDateTo, page, nodeId, transactionCode, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List stock postings
         * @summary List stock postings
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postingStockFirmIdGet(firmId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postingStockFirmIdGet(firmId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BalancesAndValuationsCashAndStockPostingsApi - factory interface
 * @export
 */
export const BalancesAndValuationsCashAndStockPostingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BalancesAndValuationsCashAndStockPostingsApiFp(configuration)
    return {
        /**
         * This command returns the cash posting objects.
         * @summary List cash postings
         * @param {BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postingCashFirmIdGet(requestParameters: BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetReportList> {
            return localVarFp.postingCashFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.postDateFrom, requestParameters.postDateTo, requestParameters.page, requestParameters.nodeId, requestParameters.transactionCode, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * List stock postings
         * @summary List stock postings
         * @param {BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postingStockFirmIdGet(requestParameters: BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postingStockFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postingCashFirmIdGet operation in BalancesAndValuationsCashAndStockPostingsApi.
 * @export
 * @interface BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGetRequest
 */
export interface BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly postDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly postDateTo?: string

    /**
     * 
     * @type {number}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly nodeId?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly transactionCode?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for postingStockFirmIdGet operation in BalancesAndValuationsCashAndStockPostingsApi.
 * @export
 * @interface BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGetRequest
 */
export interface BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGet
     */
    readonly apiToken?: string
}

/**
 * BalancesAndValuationsCashAndStockPostingsApi - object-oriented interface
 * @export
 * @class BalancesAndValuationsCashAndStockPostingsApi
 * @extends {BaseAPI}
 */
export class BalancesAndValuationsCashAndStockPostingsApi extends BaseAPI {
    /**
     * This command returns the cash posting objects.
     * @summary List cash postings
     * @param {BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalancesAndValuationsCashAndStockPostingsApi
     */
    public postingCashFirmIdGet(requestParameters: BalancesAndValuationsCashAndStockPostingsApiPostingCashFirmIdGetRequest, options?: AxiosRequestConfig) {
        return BalancesAndValuationsCashAndStockPostingsApiFp(this.configuration).postingCashFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.postDateFrom, requestParameters.postDateTo, requestParameters.page, requestParameters.nodeId, requestParameters.transactionCode, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List stock postings
     * @summary List stock postings
     * @param {BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalancesAndValuationsCashAndStockPostingsApi
     */
    public postingStockFirmIdGet(requestParameters: BalancesAndValuationsCashAndStockPostingsApiPostingStockFirmIdGetRequest, options?: AxiosRequestConfig) {
        return BalancesAndValuationsCashAndStockPostingsApiFp(this.configuration).postingStockFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CapitalGainsTaxApi - axios parameter creator
 * @export
 */
export const CapitalGainsTaxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This commands returns the accounts current positions and the simulated gains/losses depending on what the user requests to simulate
         * @summary Simulate Capital Gains from the disposal of different assets
         * @param {SimulateCapitalGainsScenario} [simulateCapitalGainsScenario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cgtsimulatorOrdersPost: async (simulateCapitalGainsScenario?: SimulateCapitalGainsScenario, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cgtsimulator/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulateCapitalGainsScenario, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This commands returns a spreadsheet download representing accounts current positions and the simulated gains/losses depending on what the user requests to simulate
         * @summary Simulate Capital Gains spreadsheet from the disposal of different assets
         * @param {SimulateCapitalGainsScenario} [simulateCapitalGainsScenario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cgtsimulatorOrdersSpreadsheetPost: async (simulateCapitalGainsScenario?: SimulateCapitalGainsScenario, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cgtsimulator/orders/spreadsheet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulateCapitalGainsScenario, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns the accounts current positions and simulated gains/losses based on a target raise amount, type and strategy. The response shares the same shape as the /cgtsimulator/orders endpoint.
         * @summary Simulate Capital Gains from a target raise amount
         * @param {SimulateCapitalGainsTarget} [simulateCapitalGainsTarget] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cgtsimulatorTargetPost: async (simulateCapitalGainsTarget?: SimulateCapitalGainsTarget, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cgtsimulator/target`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulateCapitalGainsTarget, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a capital gains tax report with disclaimers.
         * @summary Retrieve a capital gains tax report
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioCgtReportFirmIdClientIdGet: async (firmId: string, clientId: string, apiToken?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioCgtReportFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('portfolioCgtReportFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/portfolio/cgtReport/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a link to a capital gains tax report with disclaimers as a spreadsheet.
         * @summary Retrieve a capital gains tax report spreadsheet link
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioCgtReportSpreadsheetFirmIdClientIdGet: async (firmId: string, clientId: string, apiToken?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioCgtReportSpreadsheetFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('portfolioCgtReportSpreadsheetFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/portfolio/cgtReport/spreadsheet/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CapitalGainsTaxApi - functional programming interface
 * @export
 */
export const CapitalGainsTaxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CapitalGainsTaxApiAxiosParamCreator(configuration)
    return {
        /**
         * This commands returns the accounts current positions and the simulated gains/losses depending on what the user requests to simulate
         * @summary Simulate Capital Gains from the disposal of different assets
         * @param {SimulateCapitalGainsScenario} [simulateCapitalGainsScenario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cgtsimulatorOrdersPost(simulateCapitalGainsScenario?: SimulateCapitalGainsScenario, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulateCapitalGainsScenarioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cgtsimulatorOrdersPost(simulateCapitalGainsScenario, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This commands returns a spreadsheet download representing accounts current positions and the simulated gains/losses depending on what the user requests to simulate
         * @summary Simulate Capital Gains spreadsheet from the disposal of different assets
         * @param {SimulateCapitalGainsScenario} [simulateCapitalGainsScenario] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cgtsimulatorOrdersSpreadsheetPost(simulateCapitalGainsScenario?: SimulateCapitalGainsScenario, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CapitalGainsScenarioSpreadsheetLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cgtsimulatorOrdersSpreadsheetPost(simulateCapitalGainsScenario, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns the accounts current positions and simulated gains/losses based on a target raise amount, type and strategy. The response shares the same shape as the /cgtsimulator/orders endpoint.
         * @summary Simulate Capital Gains from a target raise amount
         * @param {SimulateCapitalGainsTarget} [simulateCapitalGainsTarget] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cgtsimulatorTargetPost(simulateCapitalGainsTarget?: SimulateCapitalGainsTarget, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulateCapitalGainsTargetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cgtsimulatorTargetPost(simulateCapitalGainsTarget, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a capital gains tax report with disclaimers.
         * @summary Retrieve a capital gains tax report
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioCgtReportFirmIdClientIdGet(firmId: string, clientId: string, apiToken?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCapitalGainsTaxReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioCgtReportFirmIdClientIdGet(firmId, clientId, apiToken, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a link to a capital gains tax report with disclaimers as a spreadsheet.
         * @summary Retrieve a capital gains tax report spreadsheet link
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioCgtReportSpreadsheetFirmIdClientIdGet(firmId: string, clientId: string, apiToken?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCapitalGainsTaxReportSpreadsheetLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioCgtReportSpreadsheetFirmIdClientIdGet(firmId, clientId, apiToken, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CapitalGainsTaxApi - factory interface
 * @export
 */
export const CapitalGainsTaxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CapitalGainsTaxApiFp(configuration)
    return {
        /**
         * This commands returns the accounts current positions and the simulated gains/losses depending on what the user requests to simulate
         * @summary Simulate Capital Gains from the disposal of different assets
         * @param {CapitalGainsTaxApiCgtsimulatorOrdersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cgtsimulatorOrdersPost(requestParameters: CapitalGainsTaxApiCgtsimulatorOrdersPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SimulateCapitalGainsScenarioResponse> {
            return localVarFp.cgtsimulatorOrdersPost(requestParameters.simulateCapitalGainsScenario, options).then((request) => request(axios, basePath));
        },
        /**
         * This commands returns a spreadsheet download representing accounts current positions and the simulated gains/losses depending on what the user requests to simulate
         * @summary Simulate Capital Gains spreadsheet from the disposal of different assets
         * @param {CapitalGainsTaxApiCgtsimulatorOrdersSpreadsheetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cgtsimulatorOrdersSpreadsheetPost(requestParameters: CapitalGainsTaxApiCgtsimulatorOrdersSpreadsheetPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<CapitalGainsScenarioSpreadsheetLinkResponse> {
            return localVarFp.cgtsimulatorOrdersSpreadsheetPost(requestParameters.simulateCapitalGainsScenario, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns the accounts current positions and simulated gains/losses based on a target raise amount, type and strategy. The response shares the same shape as the /cgtsimulator/orders endpoint.
         * @summary Simulate Capital Gains from a target raise amount
         * @param {CapitalGainsTaxApiCgtsimulatorTargetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cgtsimulatorTargetPost(requestParameters: CapitalGainsTaxApiCgtsimulatorTargetPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SimulateCapitalGainsTargetResponse> {
            return localVarFp.cgtsimulatorTargetPost(requestParameters.simulateCapitalGainsTarget, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a capital gains tax report with disclaimers.
         * @summary Retrieve a capital gains tax report
         * @param {CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioCgtReportFirmIdClientIdGet(requestParameters: CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetCapitalGainsTaxReport> {
            return localVarFp.portfolioCgtReportFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a link to a capital gains tax report with disclaimers as a spreadsheet.
         * @summary Retrieve a capital gains tax report spreadsheet link
         * @param {CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioCgtReportSpreadsheetFirmIdClientIdGet(requestParameters: CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetCapitalGainsTaxReportSpreadsheetLink> {
            return localVarFp.portfolioCgtReportSpreadsheetFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cgtsimulatorOrdersPost operation in CapitalGainsTaxApi.
 * @export
 * @interface CapitalGainsTaxApiCgtsimulatorOrdersPostRequest
 */
export interface CapitalGainsTaxApiCgtsimulatorOrdersPostRequest {
    /**
     * 
     * @type {SimulateCapitalGainsScenario}
     * @memberof CapitalGainsTaxApiCgtsimulatorOrdersPost
     */
    readonly simulateCapitalGainsScenario?: SimulateCapitalGainsScenario
}

/**
 * Request parameters for cgtsimulatorOrdersSpreadsheetPost operation in CapitalGainsTaxApi.
 * @export
 * @interface CapitalGainsTaxApiCgtsimulatorOrdersSpreadsheetPostRequest
 */
export interface CapitalGainsTaxApiCgtsimulatorOrdersSpreadsheetPostRequest {
    /**
     * 
     * @type {SimulateCapitalGainsScenario}
     * @memberof CapitalGainsTaxApiCgtsimulatorOrdersSpreadsheetPost
     */
    readonly simulateCapitalGainsScenario?: SimulateCapitalGainsScenario
}

/**
 * Request parameters for cgtsimulatorTargetPost operation in CapitalGainsTaxApi.
 * @export
 * @interface CapitalGainsTaxApiCgtsimulatorTargetPostRequest
 */
export interface CapitalGainsTaxApiCgtsimulatorTargetPostRequest {
    /**
     * 
     * @type {SimulateCapitalGainsTarget}
     * @memberof CapitalGainsTaxApiCgtsimulatorTargetPost
     */
    readonly simulateCapitalGainsTarget?: SimulateCapitalGainsTarget
}

/**
 * Request parameters for portfolioCgtReportFirmIdClientIdGet operation in CapitalGainsTaxApi.
 * @export
 * @interface CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGetRequest
 */
export interface CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly toDate?: string
}

/**
 * Request parameters for portfolioCgtReportSpreadsheetFirmIdClientIdGet operation in CapitalGainsTaxApi.
 * @export
 * @interface CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest
 */
export interface CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly toDate?: string
}

/**
 * CapitalGainsTaxApi - object-oriented interface
 * @export
 * @class CapitalGainsTaxApi
 * @extends {BaseAPI}
 */
export class CapitalGainsTaxApi extends BaseAPI {
    /**
     * This commands returns the accounts current positions and the simulated gains/losses depending on what the user requests to simulate
     * @summary Simulate Capital Gains from the disposal of different assets
     * @param {CapitalGainsTaxApiCgtsimulatorOrdersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapitalGainsTaxApi
     */
    public cgtsimulatorOrdersPost(requestParameters: CapitalGainsTaxApiCgtsimulatorOrdersPostRequest = {}, options?: AxiosRequestConfig) {
        return CapitalGainsTaxApiFp(this.configuration).cgtsimulatorOrdersPost(requestParameters.simulateCapitalGainsScenario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This commands returns a spreadsheet download representing accounts current positions and the simulated gains/losses depending on what the user requests to simulate
     * @summary Simulate Capital Gains spreadsheet from the disposal of different assets
     * @param {CapitalGainsTaxApiCgtsimulatorOrdersSpreadsheetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapitalGainsTaxApi
     */
    public cgtsimulatorOrdersSpreadsheetPost(requestParameters: CapitalGainsTaxApiCgtsimulatorOrdersSpreadsheetPostRequest = {}, options?: AxiosRequestConfig) {
        return CapitalGainsTaxApiFp(this.configuration).cgtsimulatorOrdersSpreadsheetPost(requestParameters.simulateCapitalGainsScenario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns the accounts current positions and simulated gains/losses based on a target raise amount, type and strategy. The response shares the same shape as the /cgtsimulator/orders endpoint.
     * @summary Simulate Capital Gains from a target raise amount
     * @param {CapitalGainsTaxApiCgtsimulatorTargetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapitalGainsTaxApi
     */
    public cgtsimulatorTargetPost(requestParameters: CapitalGainsTaxApiCgtsimulatorTargetPostRequest = {}, options?: AxiosRequestConfig) {
        return CapitalGainsTaxApiFp(this.configuration).cgtsimulatorTargetPost(requestParameters.simulateCapitalGainsTarget, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a capital gains tax report with disclaimers.
     * @summary Retrieve a capital gains tax report
     * @param {CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapitalGainsTaxApi
     */
    public portfolioCgtReportFirmIdClientIdGet(requestParameters: CapitalGainsTaxApiPortfolioCgtReportFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return CapitalGainsTaxApiFp(this.configuration).portfolioCgtReportFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a link to a capital gains tax report with disclaimers as a spreadsheet.
     * @summary Retrieve a capital gains tax report spreadsheet link
     * @param {CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapitalGainsTaxApi
     */
    public portfolioCgtReportSpreadsheetFirmIdClientIdGet(requestParameters: CapitalGainsTaxApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return CapitalGainsTaxApiFp(this.configuration).portfolioCgtReportSpreadsheetFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ClientManagementApi - axios parameter creator
 * @export
 */
export const ClientManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update registered client to active - TODO is this the correct path
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientClientIdPut: async (clientId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientClientIdPut', 'clientId', clientId)
            const localVarPath = `/client/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of fee covered accounts for a client.
         * @summary Get Fee Covered Accounts For Client
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFeecoveredaccountsFirmIdClientIdGet: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientFeecoveredaccountsFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientFeecoveredaccountsFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/client/feecoveredaccounts/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the client object – you can use this request to retrieve the `updateId` of the record
         * @summary Retrieve a client
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFirmIdClientIdGet: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/client/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This updates an existing client record to indicate that they need to complete mandate OR have accepted the direct debit mandate,
         * @summary Update a client details
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {PatchClient} [patchClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFirmIdClientIdPatch: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, patchClient?: PatchClient, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientFirmIdClientIdPatch', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientFirmIdClientIdPatch', 'clientId', clientId)
            const localVarPath = `/client/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchClient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the client record with accepted terms and sets account status to active.
         * @summary Update client status
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateClientStatus} [updateClientStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFirmIdClientIdPut: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateClientStatus?: UpdateClientStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientFirmIdClientIdPut', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientFirmIdClientIdPut', 'clientId', clientId)
            const localVarPath = `/client/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all client records on the platform
         * @summary List clients
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [name] 
         * @param {string} [parentId] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {ClientFirmIdGetIdParameter} [id] 
         * @param {string} [idOrName] 
         * @param {string} [clientGroupsClientFeeGroupId] 
         * @param {ClientFirmIdGetStatusParameter} [status] 
         * @param {ClientFirmIdGetClientTypeParameter} [clientType] 
         * @param {Array<string>} [nodeId] 
         * @param {ClientSearchFirmIdGetMigrationStatusParameter} [migrationStatus] Status of the client migration record
         * @param {ClientSearchFirmIdGetMigrationSuitabilityStatusParameter} [migrationSuitabilityStatus] Status of the migration suitability assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, name?: string, parentId?: string, pageSize?: number, page?: number, id?: ClientFirmIdGetIdParameter, idOrName?: string, clientGroupsClientFeeGroupId?: string, status?: ClientFirmIdGetStatusParameter, clientType?: ClientFirmIdGetClientTypeParameter, nodeId?: Array<string>, migrationStatus?: ClientSearchFirmIdGetMigrationStatusParameter, migrationSuitabilityStatus?: ClientSearchFirmIdGetMigrationSuitabilityStatusParameter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientFirmIdGet', 'firmId', firmId)
            const localVarPath = `/client/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (parentId !== undefined) {
                localVarQueryParameter['parentId'] = parentId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (idOrName !== undefined) {
                localVarQueryParameter['idOrName'] = idOrName;
            }

            if (clientGroupsClientFeeGroupId !== undefined) {
                localVarQueryParameter['clientGroups[clientFeeGroupId]'] = clientGroupsClientFeeGroupId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['clientType'] = clientType;
            }

            if (nodeId) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (migrationStatus !== undefined) {
                localVarQueryParameter['migration[status]'] = migrationStatus;
            }

            if (migrationSuitabilityStatus !== undefined) {
                localVarQueryParameter['migration[suitability][status]'] = migrationSuitabilityStatus;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resets all multifactor authorisations for an investor client. They will be required to re-enroll on next login.
         * @summary Delete all MFA factors for a client
         * @param {string} firmId Id of the firm
         * @param {string} clientId The unique identifier for the client
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientMfaFirmIdClientIdDelete: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientMfaFirmIdClientIdDelete', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientMfaFirmIdClientIdDelete', 'clientId', clientId)
            const localVarPath = `/client/mfa/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the priority order of the required national identifiers for the nationality or nationalities provided
         * @summary Check multiple nationalities
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [countryCodes] A comma seperated list of the client\&#39;s nationalities represented by an array of ISO 3166 ALPHA-2 country codes. More information on these can be found at https://www.iso.org/iso-3166-country-codes.html.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientNationalityFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, countryCodes?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientNationalityFirmIdGet', 'firmId', firmId)
            const localVarPath = `/client/nationality/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (countryCodes !== undefined) {
                localVarQueryParameter['countryCodes'] = countryCodes;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of nominatable accounts for a client.
         * @summary Get Nominatable Accounts For Client
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientNominatableaccountsFirmIdClientIdGet: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientNominatableaccountsFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientNominatableaccountsFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/client/nominatableaccounts/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This creates a client record where they have viewed and accepted the direct debit mandate, and returns a `clientId`.
         * @summary Create a client with mandate accepted
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateClient} [createClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, createClient?: CreateClient, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClient, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full text search for clients, using full name, email, NINO or clientId. Filterable by  clientType, nodeId and status.
         * @summary Search clients
         * @param {string} firmId 
         * @param {string} [query] Free-text search (e.g. partial name, email, national insurance no). UTF-8, trimmed, case-insensitive.
         * @param {'Individual' | 'Individual Minor' | 'Corporate' | 'Trust'} [clientType] Filter by client type. If omitted, all supported types considered.
         * @param {'Active' | 'Closed' | 'Pending' | 'Registered' | 'Suspended'} [status] Filter by lifecycle status.
         * @param {string} [searchAfter] Opaque cursor for forward pagination. Obtained from &#x60;paginationToken&#x60; in prior response. Base64 URL-safe (padding permitted). If present, returns the next page after the referenced record set. 
         * @param {string} [searchBefore] Opaque cursor for backward pagination. Obtained from &#x60;paginationToken&#x60; in prior response. Base64 URL-safe (padding permitted). If present, returns the next page after the referenced record set. 
         * @param {string} [sort] Comma-separated list of field:direction pairs. Direction is asc or desc. Supported sortable fields assumed: surname, givenName, createdAt. If omitted defaults to surname:asc,givenName:asc. 
         * @param {boolean} [includePortfolioData] When true, enrich each client with summary portfolio metrics (adds latency; cache recommended).
         * @param {number} [nodeId] Filter clients belonging to a specific organisational node / region / branch identifier. Must be a positive integer. 
         * @param {number} [pageSize] Number of records to return (page size). Defaults to 20. Upper bound enforced to protect performance. 
         * @param {ClientSearchFirmIdGetMigrationStatusParameter} [migrationStatus] Status of the client migration record
         * @param {ClientSearchFirmIdGetMigrationSuitabilityStatusParameter} [migrationSuitabilityStatus] Status of the migration suitability assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSearchFirmIdGet: async (firmId: string, query?: string, clientType?: 'Individual' | 'Individual Minor' | 'Corporate' | 'Trust', status?: 'Active' | 'Closed' | 'Pending' | 'Registered' | 'Suspended', searchAfter?: string, searchBefore?: string, sort?: string, includePortfolioData?: boolean, nodeId?: number, pageSize?: number, migrationStatus?: ClientSearchFirmIdGetMigrationStatusParameter, migrationSuitabilityStatus?: ClientSearchFirmIdGetMigrationSuitabilityStatusParameter, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientSearchFirmIdGet', 'firmId', firmId)
            const localVarPath = `/client/search/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['clientType'] = clientType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (searchAfter !== undefined) {
                localVarQueryParameter['searchAfter'] = searchAfter;
            }

            if (searchBefore !== undefined) {
                localVarQueryParameter['searchBefore'] = searchBefore;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (includePortfolioData !== undefined) {
                localVarQueryParameter['includePortfolioData'] = includePortfolioData;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (migrationStatus !== undefined) {
                localVarQueryParameter['migration[status]'] = migrationStatus;
            }

            if (migrationSuitabilityStatus !== undefined) {
                localVarQueryParameter['migration[suitability][status]'] = migrationSuitabilityStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of nationalities and the relevant identifiers  The `static` nationality endpoint provides a list of nationalities, the ISO country codes and the national identifier that the FCA requires for reporting when trading ETIs  ##### Understanding the priority  This is logic used to determine which identifier is appropriate to report on any transactions under your client\'s name. Priority is scored and the relevant identifiers are listed in this order under the array.  The rules for the FCA-preferred nationality are:  1.  An EEA (European Economic Area) nationality takes priority over a non-EEA nationality 2.  The nationality that comes first when the list of the client\'s nationalities is sorted alphabetically by the country code takes priority 3.  CONCAT is, in most cases, a last resort identifier that if required will be generated by Seccl in accordance with MiFIR/MiFID guidelines  **Please note: CONCAT – a combination of the client\'s date of birth, first name, and surname – may only be used if the Priority 1 identifier shown in the nationalities checker is not applicable to the client**  #### **Attributes**  * * *  `id` string The unique two-letter identifier for the nationality. This is case sensitive.=  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `code` string A two-letter country code  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `name` string The name of the country  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `adjective` string The country descriptor  | **Enum values** | | --- | | United Kingdom = British |  * * *  `inEEA` boolean This confirms whether or not a country is in the European Economic Area (EEA). Although the UK is not in the EU anymore, it is still reported as `inEEA: true` as per MiFIR/MiFID II rules  * * *  `identifiers` array An array which captures all forms of national identifiers for the chosen country  * * *  `identifiers.name` string The name of the national identifier. This will be National Insurance Number for British nationals and National Passport Number for all other nationalities  * * *  `identifiers.regex` string A regular expression denoting validation for the national identifier  * * *  `identifiers.localeName` string The name of the national identifier  | **Enum values** | | --- | | United Kingdom = British |  * * *  `identifiers.example` string An example of the alphanumeric national identifier format  * * *  `identifiers.priority` number  The national identifier priority score  * * *
         * @summary List nationalities
         * @param {string} [contentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staticNationalityGet: async (contentType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/static/nationality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the migration details for an existing client. Accepts the migration fields directly (not nested under a `migration` object).
         * @summary Update a client\'s migration details
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {PatchClientMigration} [patchClientMigration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClientMigrationFirmIdClientIdPatch: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, patchClientMigration?: PatchClientMigration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('v1ClientMigrationFirmIdClientIdPatch', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('v1ClientMigrationFirmIdClientIdPatch', 'clientId', clientId)
            const localVarPath = `/v1/client/migration/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchClientMigration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the earliest date a recurring payment on the chosen day of month can be paid, after applying the lead time required to initiate that payment type. The standard lead time counts forward in UK working days (bank holidays are skipped). For auto-disinvest withdrawals at firms opted into extended selldown a longer lead time is applied so the date reflects the time required to sell investments; this window counts forward in weekdays only (Monday to Friday, with UK bank holidays treated as ordinary weekdays). Eligibility and any read-safe fallback are resolved server side; the caller only supplies the firm, chosen day and payment type.
         * @summary Get the next payment date for a recurring payment day
         * @param {string} firmId The firm the request is scoped to.
         * @param {string} dayOfMonth Day of month which can be used every month.
         * @param {'Recurring Auto-Disinvest Withdrawal' | 'Recurring Direct Debit Payment In' | 'Recurring Payment In' | 'Recurring Withdrawal' | 'Regular Crystallisation'} paymentType The type of recurring payment the date is being calculated for.
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [currentDate] Optional ISO date (YYYY-MM-DD) to count from. Defaults to the API\&#39;s own next day.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1NextpaymentdateFirmIdGet: async (firmId: string, dayOfMonth: string, paymentType: 'Recurring Auto-Disinvest Withdrawal' | 'Recurring Direct Debit Payment In' | 'Recurring Payment In' | 'Recurring Withdrawal' | 'Regular Crystallisation', contentType?: string, apiToken?: string, currentDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('v1NextpaymentdateFirmIdGet', 'firmId', firmId)
            // verify required parameter 'dayOfMonth' is not null or undefined
            assertParamExists('v1NextpaymentdateFirmIdGet', 'dayOfMonth', dayOfMonth)
            // verify required parameter 'paymentType' is not null or undefined
            assertParamExists('v1NextpaymentdateFirmIdGet', 'paymentType', paymentType)
            const localVarPath = `/v1/nextpaymentdate/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (dayOfMonth !== undefined) {
                localVarQueryParameter['dayOfMonth'] = dayOfMonth;
            }

            if (paymentType !== undefined) {
                localVarQueryParameter['paymentType'] = paymentType;
            }

            if (currentDate !== undefined) {
                localVarQueryParameter['currentDate'] = (currentDate as any instanceof Date) ?
                    (currentDate as any).toISOString().substr(0,10) :
                    currentDate;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientManagementApi - functional programming interface
 * @export
 */
export const ClientManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update registered client to active - TODO is this the correct path
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientClientIdPut(clientId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientClientIdPut(clientId, contentType, apiToken, idempotencyKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of fee covered accounts for a client.
         * @summary Get Fee Covered Accounts For Client
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientFeecoveredaccountsFirmIdClientIdGet(firmId: string, clientId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeeCoveredAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientFeecoveredaccountsFirmIdClientIdGet(firmId, clientId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the client object – you can use this request to retrieve the `updateId` of the record
         * @summary Retrieve a client
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientFirmIdClientIdGet(firmId: string, clientId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClient>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientFirmIdClientIdGet(firmId, clientId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This updates an existing client record to indicate that they need to complete mandate OR have accepted the direct debit mandate,
         * @summary Update a client details
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {PatchClient} [patchClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientFirmIdClientIdPatch(firmId: string, clientId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, patchClient?: PatchClient, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientFirmIdClientIdPatch(firmId, clientId, contentType, apiToken, idempotencyKey, patchClient, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the client record with accepted terms and sets account status to active.
         * @summary Update client status
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateClientStatus} [updateClientStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientFirmIdClientIdPut(firmId: string, clientId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateClientStatus?: UpdateClientStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientFirmIdClientIdPut(firmId, clientId, contentType, apiToken, idempotencyKey, updateClientStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves all client records on the platform
         * @summary List clients
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [name] 
         * @param {string} [parentId] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {ClientFirmIdGetIdParameter} [id] 
         * @param {string} [idOrName] 
         * @param {string} [clientGroupsClientFeeGroupId] 
         * @param {ClientFirmIdGetStatusParameter} [status] 
         * @param {ClientFirmIdGetClientTypeParameter} [clientType] 
         * @param {Array<string>} [nodeId] 
         * @param {ClientSearchFirmIdGetMigrationStatusParameter} [migrationStatus] Status of the client migration record
         * @param {ClientSearchFirmIdGetMigrationSuitabilityStatusParameter} [migrationSuitabilityStatus] Status of the migration suitability assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientFirmIdGet(firmId: string, contentType?: string, apiToken?: string, name?: string, parentId?: string, pageSize?: number, page?: number, id?: ClientFirmIdGetIdParameter, idOrName?: string, clientGroupsClientFeeGroupId?: string, status?: ClientFirmIdGetStatusParameter, clientType?: ClientFirmIdGetClientTypeParameter, nodeId?: Array<string>, migrationStatus?: ClientSearchFirmIdGetMigrationStatusParameter, migrationSuitabilityStatus?: ClientSearchFirmIdGetMigrationSuitabilityStatusParameter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientFirmIdGet(firmId, contentType, apiToken, name, parentId, pageSize, page, id, idOrName, clientGroupsClientFeeGroupId, status, clientType, nodeId, migrationStatus, migrationSuitabilityStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resets all multifactor authorisations for an investor client. They will be required to re-enroll on next login.
         * @summary Delete all MFA factors for a client
         * @param {string} firmId Id of the firm
         * @param {string} clientId The unique identifier for the client
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientMfaFirmIdClientIdDelete(firmId: string, clientId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientMfaFirmIdClientIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientMfaFirmIdClientIdDelete(firmId, clientId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the priority order of the required national identifiers for the nationality or nationalities provided
         * @summary Check multiple nationalities
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [countryCodes] A comma seperated list of the client\&#39;s nationalities represented by an array of ISO 3166 ALPHA-2 country codes. More information on these can be found at https://www.iso.org/iso-3166-country-codes.html.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientNationalityFirmIdGet(firmId: string, contentType?: string, apiToken?: string, countryCodes?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientNationalities>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientNationalityFirmIdGet(firmId, contentType, apiToken, countryCodes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of nominatable accounts for a client.
         * @summary Get Nominatable Accounts For Client
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientNominatableaccountsFirmIdClientIdGet(firmId: string, clientId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NominatedAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientNominatableaccountsFirmIdClientIdGet(firmId, clientId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This creates a client record where they have viewed and accepted the direct debit mandate, and returns a `clientId`.
         * @summary Create a client with mandate accepted
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateClient} [createClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientPost(contentType?: string, apiToken?: string, idempotencyKey?: string, createClient?: CreateClient, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientPost(contentType, apiToken, idempotencyKey, createClient, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Full text search for clients, using full name, email, NINO or clientId. Filterable by  clientType, nodeId and status.
         * @summary Search clients
         * @param {string} firmId 
         * @param {string} [query] Free-text search (e.g. partial name, email, national insurance no). UTF-8, trimmed, case-insensitive.
         * @param {'Individual' | 'Individual Minor' | 'Corporate' | 'Trust'} [clientType] Filter by client type. If omitted, all supported types considered.
         * @param {'Active' | 'Closed' | 'Pending' | 'Registered' | 'Suspended'} [status] Filter by lifecycle status.
         * @param {string} [searchAfter] Opaque cursor for forward pagination. Obtained from &#x60;paginationToken&#x60; in prior response. Base64 URL-safe (padding permitted). If present, returns the next page after the referenced record set. 
         * @param {string} [searchBefore] Opaque cursor for backward pagination. Obtained from &#x60;paginationToken&#x60; in prior response. Base64 URL-safe (padding permitted). If present, returns the next page after the referenced record set. 
         * @param {string} [sort] Comma-separated list of field:direction pairs. Direction is asc or desc. Supported sortable fields assumed: surname, givenName, createdAt. If omitted defaults to surname:asc,givenName:asc. 
         * @param {boolean} [includePortfolioData] When true, enrich each client with summary portfolio metrics (adds latency; cache recommended).
         * @param {number} [nodeId] Filter clients belonging to a specific organisational node / region / branch identifier. Must be a positive integer. 
         * @param {number} [pageSize] Number of records to return (page size). Defaults to 20. Upper bound enforced to protect performance. 
         * @param {ClientSearchFirmIdGetMigrationStatusParameter} [migrationStatus] Status of the client migration record
         * @param {ClientSearchFirmIdGetMigrationSuitabilityStatusParameter} [migrationSuitabilityStatus] Status of the migration suitability assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSearchFirmIdGet(firmId: string, query?: string, clientType?: 'Individual' | 'Individual Minor' | 'Corporate' | 'Trust', status?: 'Active' | 'Closed' | 'Pending' | 'Registered' | 'Suspended', searchAfter?: string, searchBefore?: string, sort?: string, includePortfolioData?: boolean, nodeId?: number, pageSize?: number, migrationStatus?: ClientSearchFirmIdGetMigrationStatusParameter, migrationSuitabilityStatus?: ClientSearchFirmIdGetMigrationSuitabilityStatusParameter, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientSearch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientSearchFirmIdGet(firmId, query, clientType, status, searchAfter, searchBefore, sort, includePortfolioData, nodeId, pageSize, migrationStatus, migrationSuitabilityStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a list of nationalities and the relevant identifiers  The `static` nationality endpoint provides a list of nationalities, the ISO country codes and the national identifier that the FCA requires for reporting when trading ETIs  ##### Understanding the priority  This is logic used to determine which identifier is appropriate to report on any transactions under your client\'s name. Priority is scored and the relevant identifiers are listed in this order under the array.  The rules for the FCA-preferred nationality are:  1.  An EEA (European Economic Area) nationality takes priority over a non-EEA nationality 2.  The nationality that comes first when the list of the client\'s nationalities is sorted alphabetically by the country code takes priority 3.  CONCAT is, in most cases, a last resort identifier that if required will be generated by Seccl in accordance with MiFIR/MiFID guidelines  **Please note: CONCAT – a combination of the client\'s date of birth, first name, and surname – may only be used if the Priority 1 identifier shown in the nationalities checker is not applicable to the client**  #### **Attributes**  * * *  `id` string The unique two-letter identifier for the nationality. This is case sensitive.=  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `code` string A two-letter country code  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `name` string The name of the country  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `adjective` string The country descriptor  | **Enum values** | | --- | | United Kingdom = British |  * * *  `inEEA` boolean This confirms whether or not a country is in the European Economic Area (EEA). Although the UK is not in the EU anymore, it is still reported as `inEEA: true` as per MiFIR/MiFID II rules  * * *  `identifiers` array An array which captures all forms of national identifiers for the chosen country  * * *  `identifiers.name` string The name of the national identifier. This will be National Insurance Number for British nationals and National Passport Number for all other nationalities  * * *  `identifiers.regex` string A regular expression denoting validation for the national identifier  * * *  `identifiers.localeName` string The name of the national identifier  | **Enum values** | | --- | | United Kingdom = British |  * * *  `identifiers.example` string An example of the alphanumeric national identifier format  * * *  `identifiers.priority` number  The national identifier priority score  * * *
         * @summary List nationalities
         * @param {string} [contentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staticNationalityGet(contentType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNationalities>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staticNationalityGet(contentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the migration details for an existing client. Accepts the migration fields directly (not nested under a `migration` object).
         * @summary Update a client\'s migration details
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {PatchClientMigration} [patchClientMigration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1ClientMigrationFirmIdClientIdPatch(firmId: string, clientId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, patchClientMigration?: PatchClientMigration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1ClientMigrationFirmIdClientIdPatch(firmId, clientId, contentType, apiToken, idempotencyKey, patchClientMigration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the earliest date a recurring payment on the chosen day of month can be paid, after applying the lead time required to initiate that payment type. The standard lead time counts forward in UK working days (bank holidays are skipped). For auto-disinvest withdrawals at firms opted into extended selldown a longer lead time is applied so the date reflects the time required to sell investments; this window counts forward in weekdays only (Monday to Friday, with UK bank holidays treated as ordinary weekdays). Eligibility and any read-safe fallback are resolved server side; the caller only supplies the firm, chosen day and payment type.
         * @summary Get the next payment date for a recurring payment day
         * @param {string} firmId The firm the request is scoped to.
         * @param {string} dayOfMonth Day of month which can be used every month.
         * @param {'Recurring Auto-Disinvest Withdrawal' | 'Recurring Direct Debit Payment In' | 'Recurring Payment In' | 'Recurring Withdrawal' | 'Regular Crystallisation'} paymentType The type of recurring payment the date is being calculated for.
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [currentDate] Optional ISO date (YYYY-MM-DD) to count from. Defaults to the API\&#39;s own next day.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1NextpaymentdateFirmIdGet(firmId: string, dayOfMonth: string, paymentType: 'Recurring Auto-Disinvest Withdrawal' | 'Recurring Direct Debit Payment In' | 'Recurring Payment In' | 'Recurring Withdrawal' | 'Regular Crystallisation', contentType?: string, apiToken?: string, currentDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextPaymentDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1NextpaymentdateFirmIdGet(firmId, dayOfMonth, paymentType, contentType, apiToken, currentDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientManagementApi - factory interface
 * @export
 */
export const ClientManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Update registered client to active - TODO is this the correct path
         * @param {ClientManagementApiClientClientIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientClientIdPut(requestParameters: ClientManagementApiClientClientIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clientClientIdPut(requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of fee covered accounts for a client.
         * @summary Get Fee Covered Accounts For Client
         * @param {ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFeecoveredaccountsFirmIdClientIdGet(requestParameters: ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FeeCoveredAccountsResponse> {
            return localVarFp.clientFeecoveredaccountsFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the client object – you can use this request to retrieve the `updateId` of the record
         * @summary Retrieve a client
         * @param {ClientManagementApiClientFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFirmIdClientIdGet(requestParameters: ClientManagementApiClientFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetClient> {
            return localVarFp.clientFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This updates an existing client record to indicate that they need to complete mandate OR have accepted the direct debit mandate,
         * @summary Update a client details
         * @param {ClientManagementApiClientFirmIdClientIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFirmIdClientIdPatch(requestParameters: ClientManagementApiClientFirmIdClientIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<EmptyResponse> {
            return localVarFp.clientFirmIdClientIdPatch(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.patchClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the client record with accepted terms and sets account status to active.
         * @summary Update client status
         * @param {ClientManagementApiClientFirmIdClientIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFirmIdClientIdPut(requestParameters: ClientManagementApiClientFirmIdClientIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clientFirmIdClientIdPut(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateClientStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all client records on the platform
         * @summary List clients
         * @param {ClientManagementApiClientFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientFirmIdGet(requestParameters: ClientManagementApiClientFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetClientList> {
            return localVarFp.clientFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.name, requestParameters.parentId, requestParameters.pageSize, requestParameters.page, requestParameters.id, requestParameters.idOrName, requestParameters.clientGroupsClientFeeGroupId, requestParameters.status, requestParameters.clientType, requestParameters.nodeId, requestParameters.migrationStatus, requestParameters.migrationSuitabilityStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Resets all multifactor authorisations for an investor client. They will be required to re-enroll on next login.
         * @summary Delete all MFA factors for a client
         * @param {ClientManagementApiClientMfaFirmIdClientIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientMfaFirmIdClientIdDelete(requestParameters: ClientManagementApiClientMfaFirmIdClientIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<ClientMfaFirmIdClientIdDelete200Response> {
            return localVarFp.clientMfaFirmIdClientIdDelete(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the priority order of the required national identifiers for the nationality or nationalities provided
         * @summary Check multiple nationalities
         * @param {ClientManagementApiClientNationalityFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientNationalityFirmIdGet(requestParameters: ClientManagementApiClientNationalityFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetClientNationalities> {
            return localVarFp.clientNationalityFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.countryCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of nominatable accounts for a client.
         * @summary Get Nominatable Accounts For Client
         * @param {ClientManagementApiClientNominatableaccountsFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientNominatableaccountsFirmIdClientIdGet(requestParameters: ClientManagementApiClientNominatableaccountsFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<NominatedAccountsResponse> {
            return localVarFp.clientNominatableaccountsFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This creates a client record where they have viewed and accepted the direct debit mandate, and returns a `clientId`.
         * @summary Create a client with mandate accepted
         * @param {ClientManagementApiClientPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientPost(requestParameters: ClientManagementApiClientPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ClientPost201Response> {
            return localVarFp.clientPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Full text search for clients, using full name, email, NINO or clientId. Filterable by  clientType, nodeId and status.
         * @summary Search clients
         * @param {ClientManagementApiClientSearchFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSearchFirmIdGet(requestParameters: ClientManagementApiClientSearchFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetClientSearch> {
            return localVarFp.clientSearchFirmIdGet(requestParameters.firmId, requestParameters.query, requestParameters.clientType, requestParameters.status, requestParameters.searchAfter, requestParameters.searchBefore, requestParameters.sort, requestParameters.includePortfolioData, requestParameters.nodeId, requestParameters.pageSize, requestParameters.migrationStatus, requestParameters.migrationSuitabilityStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of nationalities and the relevant identifiers  The `static` nationality endpoint provides a list of nationalities, the ISO country codes and the national identifier that the FCA requires for reporting when trading ETIs  ##### Understanding the priority  This is logic used to determine which identifier is appropriate to report on any transactions under your client\'s name. Priority is scored and the relevant identifiers are listed in this order under the array.  The rules for the FCA-preferred nationality are:  1.  An EEA (European Economic Area) nationality takes priority over a non-EEA nationality 2.  The nationality that comes first when the list of the client\'s nationalities is sorted alphabetically by the country code takes priority 3.  CONCAT is, in most cases, a last resort identifier that if required will be generated by Seccl in accordance with MiFIR/MiFID guidelines  **Please note: CONCAT – a combination of the client\'s date of birth, first name, and surname – may only be used if the Priority 1 identifier shown in the nationalities checker is not applicable to the client**  #### **Attributes**  * * *  `id` string The unique two-letter identifier for the nationality. This is case sensitive.=  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `code` string A two-letter country code  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `name` string The name of the country  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `adjective` string The country descriptor  | **Enum values** | | --- | | United Kingdom = British |  * * *  `inEEA` boolean This confirms whether or not a country is in the European Economic Area (EEA). Although the UK is not in the EU anymore, it is still reported as `inEEA: true` as per MiFIR/MiFID II rules  * * *  `identifiers` array An array which captures all forms of national identifiers for the chosen country  * * *  `identifiers.name` string The name of the national identifier. This will be National Insurance Number for British nationals and National Passport Number for all other nationalities  * * *  `identifiers.regex` string A regular expression denoting validation for the national identifier  * * *  `identifiers.localeName` string The name of the national identifier  | **Enum values** | | --- | | United Kingdom = British |  * * *  `identifiers.example` string An example of the alphanumeric national identifier format  * * *  `identifiers.priority` number  The national identifier priority score  * * *
         * @summary List nationalities
         * @param {ClientManagementApiStaticNationalityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staticNationalityGet(requestParameters: ClientManagementApiStaticNationalityGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetNationalities> {
            return localVarFp.staticNationalityGet(requestParameters.contentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the migration details for an existing client. Accepts the migration fields directly (not nested under a `migration` object).
         * @summary Update a client\'s migration details
         * @param {ClientManagementApiV1ClientMigrationFirmIdClientIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClientMigrationFirmIdClientIdPatch(requestParameters: ClientManagementApiV1ClientMigrationFirmIdClientIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<EmptyResponse> {
            return localVarFp.v1ClientMigrationFirmIdClientIdPatch(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.patchClientMigration, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the earliest date a recurring payment on the chosen day of month can be paid, after applying the lead time required to initiate that payment type. The standard lead time counts forward in UK working days (bank holidays are skipped). For auto-disinvest withdrawals at firms opted into extended selldown a longer lead time is applied so the date reflects the time required to sell investments; this window counts forward in weekdays only (Monday to Friday, with UK bank holidays treated as ordinary weekdays). Eligibility and any read-safe fallback are resolved server side; the caller only supplies the firm, chosen day and payment type.
         * @summary Get the next payment date for a recurring payment day
         * @param {ClientManagementApiV1NextpaymentdateFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1NextpaymentdateFirmIdGet(requestParameters: ClientManagementApiV1NextpaymentdateFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<NextPaymentDateResponse> {
            return localVarFp.v1NextpaymentdateFirmIdGet(requestParameters.firmId, requestParameters.dayOfMonth, requestParameters.paymentType, requestParameters.contentType, requestParameters.apiToken, requestParameters.currentDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for clientClientIdPut operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientClientIdPutRequest
 */
export interface ClientManagementApiClientClientIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientClientIdPut
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientClientIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientClientIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientClientIdPut
     */
    readonly idempotencyKey?: string
}

/**
 * Request parameters for clientFeecoveredaccountsFirmIdClientIdGet operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGetRequest
 */
export interface ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for clientFirmIdClientIdGet operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientFirmIdClientIdGetRequest
 */
export interface ClientManagementApiClientFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for clientFirmIdClientIdPatch operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientFirmIdClientIdPatchRequest
 */
export interface ClientManagementApiClientFirmIdClientIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPatch
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPatch
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {PatchClient}
     * @memberof ClientManagementApiClientFirmIdClientIdPatch
     */
    readonly patchClient?: PatchClient
}

/**
 * Request parameters for clientFirmIdClientIdPut operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientFirmIdClientIdPutRequest
 */
export interface ClientManagementApiClientFirmIdClientIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPut
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdClientIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {UpdateClientStatus}
     * @memberof ClientManagementApiClientFirmIdClientIdPut
     */
    readonly updateClientStatus?: UpdateClientStatus
}

/**
 * Request parameters for clientFirmIdGet operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientFirmIdGetRequest
 */
export interface ClientManagementApiClientFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly parentId?: string

    /**
     * 
     * @type {number}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {ClientFirmIdGetIdParameter}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly id?: ClientFirmIdGetIdParameter

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly idOrName?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly clientGroupsClientFeeGroupId?: string

    /**
     * 
     * @type {ClientFirmIdGetStatusParameter}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly status?: ClientFirmIdGetStatusParameter

    /**
     * 
     * @type {ClientFirmIdGetClientTypeParameter}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly clientType?: ClientFirmIdGetClientTypeParameter

    /**
     * 
     * @type {Array<string>}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly nodeId?: Array<string>

    /**
     * Status of the client migration record
     * @type {ClientSearchFirmIdGetMigrationStatusParameter}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly migrationStatus?: ClientSearchFirmIdGetMigrationStatusParameter

    /**
     * Status of the migration suitability assessment
     * @type {ClientSearchFirmIdGetMigrationSuitabilityStatusParameter}
     * @memberof ClientManagementApiClientFirmIdGet
     */
    readonly migrationSuitabilityStatus?: ClientSearchFirmIdGetMigrationSuitabilityStatusParameter
}

/**
 * Request parameters for clientMfaFirmIdClientIdDelete operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientMfaFirmIdClientIdDeleteRequest
 */
export interface ClientManagementApiClientMfaFirmIdClientIdDeleteRequest {
    /**
     * Id of the firm
     * @type {string}
     * @memberof ClientManagementApiClientMfaFirmIdClientIdDelete
     */
    readonly firmId: string

    /**
     * The unique identifier for the client
     * @type {string}
     * @memberof ClientManagementApiClientMfaFirmIdClientIdDelete
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientMfaFirmIdClientIdDelete
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientMfaFirmIdClientIdDelete
     */
    readonly apiToken?: string
}

/**
 * Request parameters for clientNationalityFirmIdGet operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientNationalityFirmIdGetRequest
 */
export interface ClientManagementApiClientNationalityFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientNationalityFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientNationalityFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientNationalityFirmIdGet
     */
    readonly apiToken?: string

    /**
     * A comma seperated list of the client\&#39;s nationalities represented by an array of ISO 3166 ALPHA-2 country codes. More information on these can be found at https://www.iso.org/iso-3166-country-codes.html.
     * @type {string}
     * @memberof ClientManagementApiClientNationalityFirmIdGet
     */
    readonly countryCodes?: string
}

/**
 * Request parameters for clientNominatableaccountsFirmIdClientIdGet operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientNominatableaccountsFirmIdClientIdGetRequest
 */
export interface ClientManagementApiClientNominatableaccountsFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientNominatableaccountsFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientNominatableaccountsFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientNominatableaccountsFirmIdClientIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientNominatableaccountsFirmIdClientIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for clientPost operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientPostRequest
 */
export interface ClientManagementApiClientPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreateClient}
     * @memberof ClientManagementApiClientPost
     */
    readonly createClient?: CreateClient
}

/**
 * Request parameters for clientSearchFirmIdGet operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiClientSearchFirmIdGetRequest
 */
export interface ClientManagementApiClientSearchFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly firmId: string

    /**
     * Free-text search (e.g. partial name, email, national insurance no). UTF-8, trimmed, case-insensitive.
     * @type {string}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly query?: string

    /**
     * Filter by client type. If omitted, all supported types considered.
     * @type {'Individual' | 'Individual Minor' | 'Corporate' | 'Trust'}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly clientType?: 'Individual' | 'Individual Minor' | 'Corporate' | 'Trust'

    /**
     * Filter by lifecycle status.
     * @type {'Active' | 'Closed' | 'Pending' | 'Registered' | 'Suspended'}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly status?: 'Active' | 'Closed' | 'Pending' | 'Registered' | 'Suspended'

    /**
     * Opaque cursor for forward pagination. Obtained from &#x60;paginationToken&#x60; in prior response. Base64 URL-safe (padding permitted). If present, returns the next page after the referenced record set. 
     * @type {string}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly searchAfter?: string

    /**
     * Opaque cursor for backward pagination. Obtained from &#x60;paginationToken&#x60; in prior response. Base64 URL-safe (padding permitted). If present, returns the next page after the referenced record set. 
     * @type {string}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly searchBefore?: string

    /**
     * Comma-separated list of field:direction pairs. Direction is asc or desc. Supported sortable fields assumed: surname, givenName, createdAt. If omitted defaults to surname:asc,givenName:asc. 
     * @type {string}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly sort?: string

    /**
     * When true, enrich each client with summary portfolio metrics (adds latency; cache recommended).
     * @type {boolean}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly includePortfolioData?: boolean

    /**
     * Filter clients belonging to a specific organisational node / region / branch identifier. Must be a positive integer. 
     * @type {number}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly nodeId?: number

    /**
     * Number of records to return (page size). Defaults to 20. Upper bound enforced to protect performance. 
     * @type {number}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly pageSize?: number

    /**
     * Status of the client migration record
     * @type {ClientSearchFirmIdGetMigrationStatusParameter}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly migrationStatus?: ClientSearchFirmIdGetMigrationStatusParameter

    /**
     * Status of the migration suitability assessment
     * @type {ClientSearchFirmIdGetMigrationSuitabilityStatusParameter}
     * @memberof ClientManagementApiClientSearchFirmIdGet
     */
    readonly migrationSuitabilityStatus?: ClientSearchFirmIdGetMigrationSuitabilityStatusParameter
}

/**
 * Request parameters for staticNationalityGet operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiStaticNationalityGetRequest
 */
export interface ClientManagementApiStaticNationalityGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiStaticNationalityGet
     */
    readonly contentType?: string
}

/**
 * Request parameters for v1ClientMigrationFirmIdClientIdPatch operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiV1ClientMigrationFirmIdClientIdPatchRequest
 */
export interface ClientManagementApiV1ClientMigrationFirmIdClientIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiV1ClientMigrationFirmIdClientIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiV1ClientMigrationFirmIdClientIdPatch
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiV1ClientMigrationFirmIdClientIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiV1ClientMigrationFirmIdClientIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiV1ClientMigrationFirmIdClientIdPatch
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {PatchClientMigration}
     * @memberof ClientManagementApiV1ClientMigrationFirmIdClientIdPatch
     */
    readonly patchClientMigration?: PatchClientMigration
}

/**
 * Request parameters for v1NextpaymentdateFirmIdGet operation in ClientManagementApi.
 * @export
 * @interface ClientManagementApiV1NextpaymentdateFirmIdGetRequest
 */
export interface ClientManagementApiV1NextpaymentdateFirmIdGetRequest {
    /**
     * The firm the request is scoped to.
     * @type {string}
     * @memberof ClientManagementApiV1NextpaymentdateFirmIdGet
     */
    readonly firmId: string

    /**
     * Day of month which can be used every month.
     * @type {string}
     * @memberof ClientManagementApiV1NextpaymentdateFirmIdGet
     */
    readonly dayOfMonth: string

    /**
     * The type of recurring payment the date is being calculated for.
     * @type {'Recurring Auto-Disinvest Withdrawal' | 'Recurring Direct Debit Payment In' | 'Recurring Payment In' | 'Recurring Withdrawal' | 'Regular Crystallisation'}
     * @memberof ClientManagementApiV1NextpaymentdateFirmIdGet
     */
    readonly paymentType: 'Recurring Auto-Disinvest Withdrawal' | 'Recurring Direct Debit Payment In' | 'Recurring Payment In' | 'Recurring Withdrawal' | 'Regular Crystallisation'

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiV1NextpaymentdateFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientManagementApiV1NextpaymentdateFirmIdGet
     */
    readonly apiToken?: string

    /**
     * Optional ISO date (YYYY-MM-DD) to count from. Defaults to the API\&#39;s own next day.
     * @type {string}
     * @memberof ClientManagementApiV1NextpaymentdateFirmIdGet
     */
    readonly currentDate?: string
}

/**
 * ClientManagementApi - object-oriented interface
 * @export
 * @class ClientManagementApi
 * @extends {BaseAPI}
 */
export class ClientManagementApi extends BaseAPI {
    /**
     * 
     * @summary Update registered client to active - TODO is this the correct path
     * @param {ClientManagementApiClientClientIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientClientIdPut(requestParameters: ClientManagementApiClientClientIdPutRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientClientIdPut(requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of fee covered accounts for a client.
     * @summary Get Fee Covered Accounts For Client
     * @param {ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientFeecoveredaccountsFirmIdClientIdGet(requestParameters: ClientManagementApiClientFeecoveredaccountsFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientFeecoveredaccountsFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the client object – you can use this request to retrieve the `updateId` of the record
     * @summary Retrieve a client
     * @param {ClientManagementApiClientFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientFirmIdClientIdGet(requestParameters: ClientManagementApiClientFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This updates an existing client record to indicate that they need to complete mandate OR have accepted the direct debit mandate,
     * @summary Update a client details
     * @param {ClientManagementApiClientFirmIdClientIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientFirmIdClientIdPatch(requestParameters: ClientManagementApiClientFirmIdClientIdPatchRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientFirmIdClientIdPatch(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.patchClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the client record with accepted terms and sets account status to active.
     * @summary Update client status
     * @param {ClientManagementApiClientFirmIdClientIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientFirmIdClientIdPut(requestParameters: ClientManagementApiClientFirmIdClientIdPutRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientFirmIdClientIdPut(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateClientStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all client records on the platform
     * @summary List clients
     * @param {ClientManagementApiClientFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientFirmIdGet(requestParameters: ClientManagementApiClientFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.name, requestParameters.parentId, requestParameters.pageSize, requestParameters.page, requestParameters.id, requestParameters.idOrName, requestParameters.clientGroupsClientFeeGroupId, requestParameters.status, requestParameters.clientType, requestParameters.nodeId, requestParameters.migrationStatus, requestParameters.migrationSuitabilityStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resets all multifactor authorisations for an investor client. They will be required to re-enroll on next login.
     * @summary Delete all MFA factors for a client
     * @param {ClientManagementApiClientMfaFirmIdClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientMfaFirmIdClientIdDelete(requestParameters: ClientManagementApiClientMfaFirmIdClientIdDeleteRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientMfaFirmIdClientIdDelete(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the priority order of the required national identifiers for the nationality or nationalities provided
     * @summary Check multiple nationalities
     * @param {ClientManagementApiClientNationalityFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientNationalityFirmIdGet(requestParameters: ClientManagementApiClientNationalityFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientNationalityFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.countryCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of nominatable accounts for a client.
     * @summary Get Nominatable Accounts For Client
     * @param {ClientManagementApiClientNominatableaccountsFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientNominatableaccountsFirmIdClientIdGet(requestParameters: ClientManagementApiClientNominatableaccountsFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientNominatableaccountsFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This creates a client record where they have viewed and accepted the direct debit mandate, and returns a `clientId`.
     * @summary Create a client with mandate accepted
     * @param {ClientManagementApiClientPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientPost(requestParameters: ClientManagementApiClientPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full text search for clients, using full name, email, NINO or clientId. Filterable by  clientType, nodeId and status.
     * @summary Search clients
     * @param {ClientManagementApiClientSearchFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public clientSearchFirmIdGet(requestParameters: ClientManagementApiClientSearchFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).clientSearchFirmIdGet(requestParameters.firmId, requestParameters.query, requestParameters.clientType, requestParameters.status, requestParameters.searchAfter, requestParameters.searchBefore, requestParameters.sort, requestParameters.includePortfolioData, requestParameters.nodeId, requestParameters.pageSize, requestParameters.migrationStatus, requestParameters.migrationSuitabilityStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of nationalities and the relevant identifiers  The `static` nationality endpoint provides a list of nationalities, the ISO country codes and the national identifier that the FCA requires for reporting when trading ETIs  ##### Understanding the priority  This is logic used to determine which identifier is appropriate to report on any transactions under your client\'s name. Priority is scored and the relevant identifiers are listed in this order under the array.  The rules for the FCA-preferred nationality are:  1.  An EEA (European Economic Area) nationality takes priority over a non-EEA nationality 2.  The nationality that comes first when the list of the client\'s nationalities is sorted alphabetically by the country code takes priority 3.  CONCAT is, in most cases, a last resort identifier that if required will be generated by Seccl in accordance with MiFIR/MiFID guidelines  **Please note: CONCAT – a combination of the client\'s date of birth, first name, and surname – may only be used if the Priority 1 identifier shown in the nationalities checker is not applicable to the client**  #### **Attributes**  * * *  `id` string The unique two-letter identifier for the nationality. This is case sensitive.=  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `code` string A two-letter country code  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `name` string The name of the country  | **Enum values** | | --- | | United Kingdom = GB |  * * *  `adjective` string The country descriptor  | **Enum values** | | --- | | United Kingdom = British |  * * *  `inEEA` boolean This confirms whether or not a country is in the European Economic Area (EEA). Although the UK is not in the EU anymore, it is still reported as `inEEA: true` as per MiFIR/MiFID II rules  * * *  `identifiers` array An array which captures all forms of national identifiers for the chosen country  * * *  `identifiers.name` string The name of the national identifier. This will be National Insurance Number for British nationals and National Passport Number for all other nationalities  * * *  `identifiers.regex` string A regular expression denoting validation for the national identifier  * * *  `identifiers.localeName` string The name of the national identifier  | **Enum values** | | --- | | United Kingdom = British |  * * *  `identifiers.example` string An example of the alphanumeric national identifier format  * * *  `identifiers.priority` number  The national identifier priority score  * * *
     * @summary List nationalities
     * @param {ClientManagementApiStaticNationalityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public staticNationalityGet(requestParameters: ClientManagementApiStaticNationalityGetRequest = {}, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).staticNationalityGet(requestParameters.contentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the migration details for an existing client. Accepts the migration fields directly (not nested under a `migration` object).
     * @summary Update a client\'s migration details
     * @param {ClientManagementApiV1ClientMigrationFirmIdClientIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public v1ClientMigrationFirmIdClientIdPatch(requestParameters: ClientManagementApiV1ClientMigrationFirmIdClientIdPatchRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).v1ClientMigrationFirmIdClientIdPatch(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.patchClientMigration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the earliest date a recurring payment on the chosen day of month can be paid, after applying the lead time required to initiate that payment type. The standard lead time counts forward in UK working days (bank holidays are skipped). For auto-disinvest withdrawals at firms opted into extended selldown a longer lead time is applied so the date reflects the time required to sell investments; this window counts forward in weekdays only (Monday to Friday, with UK bank holidays treated as ordinary weekdays). Eligibility and any read-safe fallback are resolved server side; the caller only supplies the firm, chosen day and payment type.
     * @summary Get the next payment date for a recurring payment day
     * @param {ClientManagementApiV1NextpaymentdateFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public v1NextpaymentdateFirmIdGet(requestParameters: ClientManagementApiV1NextpaymentdateFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).v1NextpaymentdateFirmIdGet(requestParameters.firmId, requestParameters.dayOfMonth, requestParameters.paymentType, requestParameters.contentType, requestParameters.apiToken, requestParameters.currentDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ClientProductManagementApi - axios parameter creator
 * @export
 */
export const ClientProductManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} firmId 
         * @param {string} [apiToken] 
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionCrystallisationFirmIdGet: async (firmId: string, apiToken?: string, accountId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientproductActionCrystallisationFirmIdGet', 'firmId', firmId)
            const localVarPath = `/clientproduct/action/crystallisation/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {ClientproductActionCrystallisationPostRequest} [clientproductActionCrystallisationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionCrystallisationPost: async (apiToken?: string, idempotencyKey?: string, clientproductActionCrystallisationPostRequest?: ClientproductActionCrystallisationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/clientproduct/action/crystallisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientproductActionCrystallisationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} firmId 
         * @param {string} [apiToken] 
         * @param {string} [accountId] 
         * @param {string} [clientProductId] 
         * @param {string} [clientProductActionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionFirmIdGet: async (firmId: string, apiToken?: string, accountId?: string, clientProductId?: string, clientProductActionType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientproductActionFirmIdGet', 'firmId', firmId)
            const localVarPath = `/clientproduct/action/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (clientProductId !== undefined) {
                localVarQueryParameter['clientProductId'] = clientProductId;
            }

            if (clientProductActionType !== undefined) {
                localVarQueryParameter['clientProductActionType'] = clientProductActionType;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a regular crystallisation
         * @param {string} firmId 
         * @param {string} bciId 
         * @param {string} [idempotencyKey] 
         * @param {ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest} [clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionRegularcrystallisationFirmIdBciIdPatch: async (firmId: string, bciId: string, idempotencyKey?: string, clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest?: ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientproductActionRegularcrystallisationFirmIdBciIdPatch', 'firmId', firmId)
            // verify required parameter 'bciId' is not null or undefined
            assertParamExists('clientproductActionRegularcrystallisationFirmIdBciIdPatch', 'bciId', bciId)
            const localVarPath = `/clientproduct/action/regularcrystallisation/{firmId}/{bciId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"bciId"}}`, encodeURIComponent(String(bciId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {ClientproductActionCrystallisationPostRequest} [clientproductActionCrystallisationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionRegularcrystallisationPost: async (apiToken?: string, idempotencyKey?: string, clientproductActionCrystallisationPostRequest?: ClientproductActionCrystallisationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/clientproduct/action/regularcrystallisation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientproductActionCrystallisationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the clientproduct object of the specified `clientproductId`
         * @summary Retrieve client product
         * @param {string} firmId 
         * @param {string} clientProductId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductFirmIdClientProductIdGet: async (firmId: string, clientProductId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientproductFirmIdClientProductIdGet', 'firmId', firmId)
            // verify required parameter 'clientProductId' is not null or undefined
            assertParamExists('clientproductFirmIdClientProductIdGet', 'clientProductId', clientProductId)
            const localVarPath = `/clientproduct/{firmId}/{clientProductId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientProductId"}}`, encodeURIComponent(String(clientProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the clientproduct
         * @param {string} firmId 
         * @param {string} clientProductId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateClientProduct} [updateClientProduct] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductFirmIdClientProductIdPatch: async (firmId: string, clientProductId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateClientProduct?: UpdateClientProduct, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientproductFirmIdClientProductIdPatch', 'firmId', firmId)
            // verify required parameter 'clientProductId' is not null or undefined
            assertParamExists('clientproductFirmIdClientProductIdPatch', 'clientProductId', clientProductId)
            const localVarPath = `/clientproduct/{firmId}/{clientProductId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientProductId"}}`, encodeURIComponent(String(clientProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientProduct, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of clientproduct objects
         * @summary Retrieve client product list
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [clientId] 
         * @param {WrapperType} [wrapperType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, clientId?: string, wrapperType?: WrapperType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientproductFirmIdGet', 'firmId', firmId)
            const localVarPath = `/clientproduct/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (wrapperType !== undefined) {
                localVarQueryParameter['wrapperType'] = wrapperType;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientProductManagementApi - functional programming interface
 * @export
 */
export const ClientProductManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientProductManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} firmId 
         * @param {string} [apiToken] 
         * @param {string} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientproductActionCrystallisationFirmIdGet(firmId: string, apiToken?: string, accountId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientproductActionCrystallisationFirmIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientproductActionCrystallisationFirmIdGet(firmId, apiToken, accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {ClientproductActionCrystallisationPostRequest} [clientproductActionCrystallisationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientproductActionCrystallisationPost(apiToken?: string, idempotencyKey?: string, clientproductActionCrystallisationPostRequest?: ClientproductActionCrystallisationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientproductActionCrystallisationPost(apiToken, idempotencyKey, clientproductActionCrystallisationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} firmId 
         * @param {string} [apiToken] 
         * @param {string} [accountId] 
         * @param {string} [clientProductId] 
         * @param {string} [clientProductActionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientproductActionFirmIdGet(firmId: string, apiToken?: string, accountId?: string, clientProductId?: string, clientProductActionType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientproductActionFirmIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientproductActionFirmIdGet(firmId, apiToken, accountId, clientProductId, clientProductActionType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a regular crystallisation
         * @param {string} firmId 
         * @param {string} bciId 
         * @param {string} [idempotencyKey] 
         * @param {ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest} [clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientproductActionRegularcrystallisationFirmIdBciIdPatch(firmId: string, bciId: string, idempotencyKey?: string, clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest?: ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientproductActionRegularcrystallisationFirmIdBciIdPatch(firmId, bciId, idempotencyKey, clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {ClientproductActionCrystallisationPostRequest} [clientproductActionCrystallisationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientproductActionRegularcrystallisationPost(apiToken?: string, idempotencyKey?: string, clientproductActionCrystallisationPostRequest?: ClientproductActionCrystallisationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientproductActionRegularcrystallisationPost(apiToken, idempotencyKey, clientproductActionCrystallisationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the clientproduct object of the specified `clientproductId`
         * @summary Retrieve client product
         * @param {string} firmId 
         * @param {string} clientProductId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientproductFirmIdClientProductIdGet(firmId: string, clientProductId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientproductFirmIdClientProductIdGet(firmId, clientProductId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the clientproduct
         * @param {string} firmId 
         * @param {string} clientProductId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateClientProduct} [updateClientProduct] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientproductFirmIdClientProductIdPatch(firmId: string, clientProductId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateClientProduct?: UpdateClientProduct, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientproductFirmIdClientProductIdPatch(firmId, clientProductId, contentType, apiToken, idempotencyKey, updateClientProduct, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of clientproduct objects
         * @summary Retrieve client product list
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [clientId] 
         * @param {WrapperType} [wrapperType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientproductFirmIdGet(firmId: string, contentType?: string, apiToken?: string, clientId?: string, wrapperType?: WrapperType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientProductList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientproductFirmIdGet(firmId, contentType, apiToken, clientId, wrapperType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientProductManagementApi - factory interface
 * @export
 */
export const ClientProductManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientProductManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientProductManagementApiClientproductActionCrystallisationFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionCrystallisationFirmIdGet(requestParameters: ClientProductManagementApiClientproductActionCrystallisationFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ClientproductActionCrystallisationFirmIdGet200Response> {
            return localVarFp.clientproductActionCrystallisationFirmIdGet(requestParameters.firmId, requestParameters.apiToken, requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientProductManagementApiClientproductActionCrystallisationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionCrystallisationPost(requestParameters: ClientProductManagementApiClientproductActionCrystallisationPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clientproductActionCrystallisationPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.clientproductActionCrystallisationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientProductManagementApiClientproductActionFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionFirmIdGet(requestParameters: ClientProductManagementApiClientproductActionFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ClientproductActionFirmIdGet200Response> {
            return localVarFp.clientproductActionFirmIdGet(requestParameters.firmId, requestParameters.apiToken, requestParameters.accountId, requestParameters.clientProductId, requestParameters.clientProductActionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a regular crystallisation
         * @param {ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionRegularcrystallisationFirmIdBciIdPatch(requestParameters: ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clientproductActionRegularcrystallisationFirmIdBciIdPatch(requestParameters.firmId, requestParameters.bciId, requestParameters.idempotencyKey, requestParameters.clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientProductManagementApiClientproductActionRegularcrystallisationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductActionRegularcrystallisationPost(requestParameters: ClientProductManagementApiClientproductActionRegularcrystallisationPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clientproductActionRegularcrystallisationPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.clientproductActionCrystallisationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the clientproduct object of the specified `clientproductId`
         * @summary Retrieve client product
         * @param {ClientProductManagementApiClientproductFirmIdClientProductIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductFirmIdClientProductIdGet(requestParameters: ClientProductManagementApiClientproductFirmIdClientProductIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetClientProduct> {
            return localVarFp.clientproductFirmIdClientProductIdGet(requestParameters.firmId, requestParameters.clientProductId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the clientproduct
         * @param {ClientProductManagementApiClientproductFirmIdClientProductIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductFirmIdClientProductIdPatch(requestParameters: ClientProductManagementApiClientproductFirmIdClientProductIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clientproductFirmIdClientProductIdPatch(requestParameters.firmId, requestParameters.clientProductId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateClientProduct, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of clientproduct objects
         * @summary Retrieve client product list
         * @param {ClientProductManagementApiClientproductFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientproductFirmIdGet(requestParameters: ClientProductManagementApiClientproductFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetClientProductList> {
            return localVarFp.clientproductFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.clientId, requestParameters.wrapperType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for clientproductActionCrystallisationFirmIdGet operation in ClientProductManagementApi.
 * @export
 * @interface ClientProductManagementApiClientproductActionCrystallisationFirmIdGetRequest
 */
export interface ClientProductManagementApiClientproductActionCrystallisationFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionCrystallisationFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionCrystallisationFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionCrystallisationFirmIdGet
     */
    readonly accountId?: string
}

/**
 * Request parameters for clientproductActionCrystallisationPost operation in ClientProductManagementApi.
 * @export
 * @interface ClientProductManagementApiClientproductActionCrystallisationPostRequest
 */
export interface ClientProductManagementApiClientproductActionCrystallisationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionCrystallisationPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionCrystallisationPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {ClientproductActionCrystallisationPostRequest}
     * @memberof ClientProductManagementApiClientproductActionCrystallisationPost
     */
    readonly clientproductActionCrystallisationPostRequest?: ClientproductActionCrystallisationPostRequest
}

/**
 * Request parameters for clientproductActionFirmIdGet operation in ClientProductManagementApi.
 * @export
 * @interface ClientProductManagementApiClientproductActionFirmIdGetRequest
 */
export interface ClientProductManagementApiClientproductActionFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionFirmIdGet
     */
    readonly accountId?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionFirmIdGet
     */
    readonly clientProductId?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionFirmIdGet
     */
    readonly clientProductActionType?: string
}

/**
 * Request parameters for clientproductActionRegularcrystallisationFirmIdBciIdPatch operation in ClientProductManagementApi.
 * @export
 * @interface ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest
 */
export interface ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatch
     */
    readonly bciId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatch
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest}
     * @memberof ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatch
     */
    readonly clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest?: ClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest
}

/**
 * Request parameters for clientproductActionRegularcrystallisationPost operation in ClientProductManagementApi.
 * @export
 * @interface ClientProductManagementApiClientproductActionRegularcrystallisationPostRequest
 */
export interface ClientProductManagementApiClientproductActionRegularcrystallisationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionRegularcrystallisationPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductActionRegularcrystallisationPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {ClientproductActionCrystallisationPostRequest}
     * @memberof ClientProductManagementApiClientproductActionRegularcrystallisationPost
     */
    readonly clientproductActionCrystallisationPostRequest?: ClientproductActionCrystallisationPostRequest
}

/**
 * Request parameters for clientproductFirmIdClientProductIdGet operation in ClientProductManagementApi.
 * @export
 * @interface ClientProductManagementApiClientproductFirmIdClientProductIdGetRequest
 */
export interface ClientProductManagementApiClientproductFirmIdClientProductIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdGet
     */
    readonly clientProductId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for clientproductFirmIdClientProductIdPatch operation in ClientProductManagementApi.
 * @export
 * @interface ClientProductManagementApiClientproductFirmIdClientProductIdPatchRequest
 */
export interface ClientProductManagementApiClientproductFirmIdClientProductIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdPatch
     */
    readonly clientProductId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdPatch
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {UpdateClientProduct}
     * @memberof ClientProductManagementApiClientproductFirmIdClientProductIdPatch
     */
    readonly updateClientProduct?: UpdateClientProduct
}

/**
 * Request parameters for clientproductFirmIdGet operation in ClientProductManagementApi.
 * @export
 * @interface ClientProductManagementApiClientproductFirmIdGetRequest
 */
export interface ClientProductManagementApiClientproductFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientProductManagementApiClientproductFirmIdGet
     */
    readonly clientId?: string

    /**
     * 
     * @type {WrapperType}
     * @memberof ClientProductManagementApiClientproductFirmIdGet
     */
    readonly wrapperType?: WrapperType
}

/**
 * ClientProductManagementApi - object-oriented interface
 * @export
 * @class ClientProductManagementApi
 * @extends {BaseAPI}
 */
export class ClientProductManagementApi extends BaseAPI {
    /**
     * 
     * @param {ClientProductManagementApiClientproductActionCrystallisationFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductManagementApi
     */
    public clientproductActionCrystallisationFirmIdGet(requestParameters: ClientProductManagementApiClientproductActionCrystallisationFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientProductManagementApiFp(this.configuration).clientproductActionCrystallisationFirmIdGet(requestParameters.firmId, requestParameters.apiToken, requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientProductManagementApiClientproductActionCrystallisationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductManagementApi
     */
    public clientproductActionCrystallisationPost(requestParameters: ClientProductManagementApiClientproductActionCrystallisationPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientProductManagementApiFp(this.configuration).clientproductActionCrystallisationPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.clientproductActionCrystallisationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientProductManagementApiClientproductActionFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductManagementApi
     */
    public clientproductActionFirmIdGet(requestParameters: ClientProductManagementApiClientproductActionFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientProductManagementApiFp(this.configuration).clientproductActionFirmIdGet(requestParameters.firmId, requestParameters.apiToken, requestParameters.accountId, requestParameters.clientProductId, requestParameters.clientProductActionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a regular crystallisation
     * @param {ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductManagementApi
     */
    public clientproductActionRegularcrystallisationFirmIdBciIdPatch(requestParameters: ClientProductManagementApiClientproductActionRegularcrystallisationFirmIdBciIdPatchRequest, options?: AxiosRequestConfig) {
        return ClientProductManagementApiFp(this.configuration).clientproductActionRegularcrystallisationFirmIdBciIdPatch(requestParameters.firmId, requestParameters.bciId, requestParameters.idempotencyKey, requestParameters.clientproductActionRegularcrystallisationFirmIdBciIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientProductManagementApiClientproductActionRegularcrystallisationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductManagementApi
     */
    public clientproductActionRegularcrystallisationPost(requestParameters: ClientProductManagementApiClientproductActionRegularcrystallisationPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientProductManagementApiFp(this.configuration).clientproductActionRegularcrystallisationPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.clientproductActionCrystallisationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the clientproduct object of the specified `clientproductId`
     * @summary Retrieve client product
     * @param {ClientProductManagementApiClientproductFirmIdClientProductIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductManagementApi
     */
    public clientproductFirmIdClientProductIdGet(requestParameters: ClientProductManagementApiClientproductFirmIdClientProductIdGetRequest, options?: AxiosRequestConfig) {
        return ClientProductManagementApiFp(this.configuration).clientproductFirmIdClientProductIdGet(requestParameters.firmId, requestParameters.clientProductId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the clientproduct
     * @param {ClientProductManagementApiClientproductFirmIdClientProductIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductManagementApi
     */
    public clientproductFirmIdClientProductIdPatch(requestParameters: ClientProductManagementApiClientproductFirmIdClientProductIdPatchRequest, options?: AxiosRequestConfig) {
        return ClientProductManagementApiFp(this.configuration).clientproductFirmIdClientProductIdPatch(requestParameters.firmId, requestParameters.clientProductId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateClientProduct, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of clientproduct objects
     * @summary Retrieve client product list
     * @param {ClientProductManagementApiClientproductFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProductManagementApi
     */
    public clientproductFirmIdGet(requestParameters: ClientProductManagementApiClientproductFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientProductManagementApiFp(this.configuration).clientproductFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.clientId, requestParameters.wrapperType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ClientReportingApi - axios parameter creator
 * @export
 */
export const ClientReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves detailed information about a specific email message, including the full event history (sent, delivered, opened, bounced, etc).
         * @summary Get client email message details
         * @param {string} firmId 
         * @param {string} messageId 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEmailsDetailsFirmIdMessageIdGet: async (firmId: string, messageId: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientEmailsDetailsFirmIdMessageIdGet', 'firmId', firmId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('clientEmailsDetailsFirmIdMessageIdGet', 'messageId', messageId)
            const localVarPath = `/client/emails/details/{firmId}/{messageId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a paginated list of outbound email messages sent to a client. This endpoint queries the email service provider to return message history including subject, recipients, and delivery status.
         * @summary Get client email messages
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEmailsFirmIdClientIdGet: async (firmId: string, clientId: string, apiToken?: string, pageSize?: number, pageNumber?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('clientEmailsFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientEmailsFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/client/emails/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Generate mandate confirmation URL
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesAdvancedirectdebitmandateconfirmationPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/advancedirectdebitmandateconfirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Generate a contract note URL
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesContractnotePost: async (apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/contractnote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command generates a fileURL for a given message type. Message types correspond to the messageType enum returned via the getMessage endpoint, all lowercase with underscores removed.
         * @summary Generate a file url
         * @param {'accountupdate' | 'advancedirectdebitmandateconfirmation' | 'advancedirectdebitmandatenotice' | 'amlresenddata' | 'benefitcrystallisationeventstatement' | 'bcestatement' | 'changepassword' | 'clientupdate' | 'contractnote' | 'gaudicomms' | 'newaccount' | 'newaccountreplay' | 'pensioncancellationletter' | 'pensionpayslip' | 'pensionsavingsstatement' | 'pensiontransfercancellationletter' | 'quarterlystatement' | 'retirementpack' | 'taxstatement' | 'valuationstatement' | 'withdrawal' | 'flexiaccessnotification' | 'smpiannualstatement' | 'illustration' | 'taxpack' | 'pensionchoices'} fileType 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesFileTypePost: async (fileType: 'accountupdate' | 'advancedirectdebitmandateconfirmation' | 'advancedirectdebitmandatenotice' | 'amlresenddata' | 'benefitcrystallisationeventstatement' | 'bcestatement' | 'changepassword' | 'clientupdate' | 'contractnote' | 'gaudicomms' | 'newaccount' | 'newaccountreplay' | 'pensioncancellationletter' | 'pensionpayslip' | 'pensionsavingsstatement' | 'pensiontransfercancellationletter' | 'quarterlystatement' | 'retirementpack' | 'taxstatement' | 'valuationstatement' | 'withdrawal' | 'flexiaccessnotification' | 'smpiannualstatement' | 'illustration' | 'taxpack' | 'pensionchoices', contentType?: string, apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileType' is not null or undefined
            assertParamExists('filesFileTypePost', 'fileType', fileType)
            const localVarPath = `/files/{fileType}`
                .replace(`{${"fileType"}}`, encodeURIComponent(String(fileType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a successful array. It converts the projections calculated by the provided information into a PDF document that you can make available to the client or include in their suitability pack.
         * @summary Generate the illustration PDF
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateFile} [generateFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesGeneratePost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, generateFile?: GenerateFile, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateFile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns the `illustrationId` and the link to the PDF URL.  **Please note: This should only be requested AFTER the \"generate illustration\" request has been made.**
         * @summary Download the illustration PDF
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIllustrationPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/illustration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates the pension cancellation letter PDF URL
         * @summary Retrieve pension cancellation letter PDF
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesPensioncancellationletterPost: async (apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/pensioncancellationletter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a Consolidated Tax Voucher (CTV) document URL
         * @summary Generate a document URL
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesTaxstatementPost: async (apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/taxstatement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Retrieve document URL
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesValuationstatementPost: async (apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/valuationstatement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command will retrieve all illustrations generated on the firm node.  **Please note: We have paginated this response to avoid the request from retrieving a large number of illustrations all at once.**
         * @summary Retrieve all illustrations
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationProductFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, page?: number, pageSize?: number, name?: string, id?: string, status?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('illustrationProductFirmIdGet', 'firmId', firmId)
            const localVarPath = `/illustration/product/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command will retrieve an illustration generated on the firm node.
         * @summary Retrieve illustration details
         * @param {string} firmId 
         * @param {string} illustrationId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationProductFirmIdIllustrationIdGet: async (firmId: string, illustrationId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('illustrationProductFirmIdIllustrationIdGet', 'firmId', firmId)
            // verify required parameter 'illustrationId' is not null or undefined
            assertParamExists('illustrationProductFirmIdIllustrationIdGet', 'illustrationId', illustrationId)
            const localVarPath = `/illustration/product/{firmId}/{illustrationId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"illustrationId"}}`, encodeURIComponent(String(illustrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Product description 
         * @summary Drawdown illustration
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateProductIllustration} [createProductIllustration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationProductPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, createProductIllustration?: CreateProductIllustration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/illustration/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductIllustration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command will retrieve all illustrations exluding SMPIs generated on the firm node.  **Please note: We have paginated this response to avoid the request from retrieving a large number of illustrations all at once.**
         * @summary Retrieve all illustrations excluding SMPIs
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {string} [status] 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationProductabridgedFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, page?: number, pageSize?: number, name?: string, id?: string, status?: string, clientId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('illustrationProductabridgedFirmIdGet', 'firmId', firmId)
            const localVarPath = `/illustration/productabridged/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command creates a trade illustration, and returns the following data that can be made available in your application:  - Summary of initial charges - Summary of charges for each period - Final amount at end of period - Total initial charges - Total ongoing charges - Total transaction charges - Total overall charges
         * @summary Create a trade illustration
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateTradeIllustration} [createTradeIllustration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationTradePost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, createTradeIllustration?: CreateTradeIllustration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/illustration/trade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTradeIllustration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Client messages are used to inform the investor about changes to their platform user account and to their wrapper accounts.  Messages might also confirm a change to a client\'s personal information, such as an address update or change of contact details. Equally some regulatory documents are shared via these messages, as well as reports and valuation statements.
         * @summary Search for messages
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [clientId] 
         * @param {string} [messageType] 
         * @param {string} [status] 
         * @param {string} [accountId] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, pageSize?: number, page?: number, clientId?: string, messageType?: string, status?: string, accountId?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('messageFirmIdGet', 'firmId', firmId)
            const localVarPath = `/message/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (messageType !== undefined) {
                localVarQueryParameter['messageType'] = messageType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * You can use this endpoint to retrieve a specific message for your client. Generally you would use the **GET** list call to list all messages in a client\'s message hub.  Then, when they click into a specific message, they will be presented with the message data from this single message **GET** request.  If the message is a certain document type (see the request below this one), then you can use the following request to retrieve that document, based on the payload in this message.
         * @summary Retrieve specific message
         * @param {string} firmId 
         * @param {string} messageId 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageFirmIdMessageIdGet: async (firmId: string, messageId: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('messageFirmIdMessageIdGet', 'firmId', firmId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('messageFirmIdMessageIdGet', 'messageId', messageId)
            const localVarPath = `/message/{firmId}/{messageId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command allows you to update the read or archived status of a message.
         * @summary Update message status
         * @param {string} firmId 
         * @param {string} messageId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateMessageStatus} [updateMessageStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageFirmIdMessageIdPut: async (firmId: string, messageId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateMessageStatus?: UpdateMessageStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('messageFirmIdMessageIdPut', 'firmId', firmId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('messageFirmIdMessageIdPut', 'messageId', messageId)
            const localVarPath = `/message/{firmId}/{messageId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMessageStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command retrieves the number of unread messages for a firm. You can use the `clientId` query parameter to filter the unread message count for a client.
         * @summary Retreive unread message count
         * @param {string} firmId 
         * @param {any} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageStatsFirmIdGet: async (firmId: string, clientId?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('messageStatsFirmIdGet', 'firmId', firmId)
            const localVarPath = `/message/stats/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientReportingApi - functional programming interface
 * @export
 */
export const ClientReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves detailed information about a specific email message, including the full event history (sent, delivered, opened, bounced, etc).
         * @summary Get client email message details
         * @param {string} firmId 
         * @param {string} messageId 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientEmailsDetailsFirmIdMessageIdGet(firmId: string, messageId: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientEmailMessageDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientEmailsDetailsFirmIdMessageIdGet(firmId, messageId, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a paginated list of outbound email messages sent to a client. This endpoint queries the email service provider to return message history including subject, recipients, and delivery status.
         * @summary Get client email messages
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientEmailsFirmIdClientIdGet(firmId: string, clientId: string, apiToken?: string, pageSize?: number, pageNumber?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientEmailMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientEmailsFirmIdClientIdGet(firmId, clientId, apiToken, pageSize, pageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Generate mandate confirmation URL
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesAdvancedirectdebitmandateconfirmationPost(contentType?: string, apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesAdvancedirectdebitmandateconfirmationPost(contentType, apiToken, idempotencyKey, generateDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Generate a contract note URL
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesContractnotePost(apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesContractnotePost(apiToken, idempotencyKey, generateDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command generates a fileURL for a given message type. Message types correspond to the messageType enum returned via the getMessage endpoint, all lowercase with underscores removed.
         * @summary Generate a file url
         * @param {'accountupdate' | 'advancedirectdebitmandateconfirmation' | 'advancedirectdebitmandatenotice' | 'amlresenddata' | 'benefitcrystallisationeventstatement' | 'bcestatement' | 'changepassword' | 'clientupdate' | 'contractnote' | 'gaudicomms' | 'newaccount' | 'newaccountreplay' | 'pensioncancellationletter' | 'pensionpayslip' | 'pensionsavingsstatement' | 'pensiontransfercancellationletter' | 'quarterlystatement' | 'retirementpack' | 'taxstatement' | 'valuationstatement' | 'withdrawal' | 'flexiaccessnotification' | 'smpiannualstatement' | 'illustration' | 'taxpack' | 'pensionchoices'} fileType 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesFileTypePost(fileType: 'accountupdate' | 'advancedirectdebitmandateconfirmation' | 'advancedirectdebitmandatenotice' | 'amlresenddata' | 'benefitcrystallisationeventstatement' | 'bcestatement' | 'changepassword' | 'clientupdate' | 'contractnote' | 'gaudicomms' | 'newaccount' | 'newaccountreplay' | 'pensioncancellationletter' | 'pensionpayslip' | 'pensionsavingsstatement' | 'pensiontransfercancellationletter' | 'quarterlystatement' | 'retirementpack' | 'taxstatement' | 'valuationstatement' | 'withdrawal' | 'flexiaccessnotification' | 'smpiannualstatement' | 'illustration' | 'taxpack' | 'pensionchoices', contentType?: string, apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilesFileTypePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesFileTypePost(fileType, contentType, apiToken, idempotencyKey, generateDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a successful array. It converts the projections calculated by the provided information into a PDF document that you can make available to the client or include in their suitability pack.
         * @summary Generate the illustration PDF
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateFile} [generateFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesGeneratePost(contentType?: string, apiToken?: string, idempotencyKey?: string, generateFile?: GenerateFile, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesGeneratePost(contentType, apiToken, idempotencyKey, generateFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns the `illustrationId` and the link to the PDF URL.  **Please note: This should only be requested AFTER the \"generate illustration\" request has been made.**
         * @summary Download the illustration PDF
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesIllustrationPost(contentType?: string, apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IllustrationDownload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesIllustrationPost(contentType, apiToken, idempotencyKey, generateDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generates the pension cancellation letter PDF URL
         * @summary Retrieve pension cancellation letter PDF
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesPensioncancellationletterPost(apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesPensioncancellationletterPost(apiToken, idempotencyKey, generateDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generates a Consolidated Tax Voucher (CTV) document URL
         * @summary Generate a document URL
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesTaxstatementPost(apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesTaxstatementPost(apiToken, idempotencyKey, generateDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Retrieve document URL
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {GenerateDocument} [generateDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesValuationstatementPost(apiToken?: string, idempotencyKey?: string, generateDocument?: GenerateDocument, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesValuationstatementPost(apiToken, idempotencyKey, generateDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command will retrieve all illustrations generated on the firm node.  **Please note: We have paginated this response to avoid the request from retrieving a large number of illustrations all at once.**
         * @summary Retrieve all illustrations
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async illustrationProductFirmIdGet(firmId: string, contentType?: string, apiToken?: string, page?: number, pageSize?: number, name?: string, id?: string, status?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIllustrationsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.illustrationProductFirmIdGet(firmId, contentType, apiToken, page, pageSize, name, id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command will retrieve an illustration generated on the firm node.
         * @summary Retrieve illustration details
         * @param {string} firmId 
         * @param {string} illustrationId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async illustrationProductFirmIdIllustrationIdGet(firmId: string, illustrationId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIllustrationById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.illustrationProductFirmIdIllustrationIdGet(firmId, illustrationId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Product description 
         * @summary Drawdown illustration
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateProductIllustration} [createProductIllustration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async illustrationProductPost(contentType?: string, apiToken?: string, idempotencyKey?: string, createProductIllustration?: CreateProductIllustration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IllustrationProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.illustrationProductPost(contentType, apiToken, idempotencyKey, createProductIllustration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command will retrieve all illustrations exluding SMPIs generated on the firm node.  **Please note: We have paginated this response to avoid the request from retrieving a large number of illustrations all at once.**
         * @summary Retrieve all illustrations excluding SMPIs
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {string} [status] 
         * @param {string} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async illustrationProductabridgedFirmIdGet(firmId: string, contentType?: string, apiToken?: string, page?: number, pageSize?: number, name?: string, id?: string, status?: string, clientId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAbridgedIllustrationsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.illustrationProductabridgedFirmIdGet(firmId, contentType, apiToken, page, pageSize, name, id, status, clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command creates a trade illustration, and returns the following data that can be made available in your application:  - Summary of initial charges - Summary of charges for each period - Final amount at end of period - Total initial charges - Total ongoing charges - Total transaction charges - Total overall charges
         * @summary Create a trade illustration
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateTradeIllustration} [createTradeIllustration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async illustrationTradePost(contentType?: string, apiToken?: string, idempotencyKey?: string, createTradeIllustration?: CreateTradeIllustration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TradeIllustration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.illustrationTradePost(contentType, apiToken, idempotencyKey, createTradeIllustration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Client messages are used to inform the investor about changes to their platform user account and to their wrapper accounts.  Messages might also confirm a change to a client\'s personal information, such as an address update or change of contact details. Equally some regulatory documents are shared via these messages, as well as reports and valuation statements.
         * @summary Search for messages
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [clientId] 
         * @param {string} [messageType] 
         * @param {string} [status] 
         * @param {string} [accountId] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageFirmIdGet(firmId: string, contentType?: string, apiToken?: string, pageSize?: number, page?: number, clientId?: string, messageType?: string, status?: string, accountId?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageFirmIdGet(firmId, contentType, apiToken, pageSize, page, clientId, messageType, status, accountId, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * You can use this endpoint to retrieve a specific message for your client. Generally you would use the **GET** list call to list all messages in a client\'s message hub.  Then, when they click into a specific message, they will be presented with the message data from this single message **GET** request.  If the message is a certain document type (see the request below this one), then you can use the following request to retrieve that document, based on the payload in this message.
         * @summary Retrieve specific message
         * @param {string} firmId 
         * @param {string} messageId 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageFirmIdMessageIdGet(firmId: string, messageId: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageFirmIdMessageIdGet(firmId, messageId, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command allows you to update the read or archived status of a message.
         * @summary Update message status
         * @param {string} firmId 
         * @param {string} messageId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateMessageStatus} [updateMessageStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageFirmIdMessageIdPut(firmId: string, messageId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateMessageStatus?: UpdateMessageStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageFirmIdMessageIdPut(firmId, messageId, contentType, apiToken, idempotencyKey, updateMessageStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command retrieves the number of unread messages for a firm. You can use the `clientId` query parameter to filter the unread message count for a client.
         * @summary Retreive unread message count
         * @param {string} firmId 
         * @param {any} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageStatsFirmIdGet(firmId: string, clientId?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnreadMessageCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageStatsFirmIdGet(firmId, clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientReportingApi - factory interface
 * @export
 */
export const ClientReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientReportingApiFp(configuration)
    return {
        /**
         * Retrieves detailed information about a specific email message, including the full event history (sent, delivered, opened, bounced, etc).
         * @summary Get client email message details
         * @param {ClientReportingApiClientEmailsDetailsFirmIdMessageIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEmailsDetailsFirmIdMessageIdGet(requestParameters: ClientReportingApiClientEmailsDetailsFirmIdMessageIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetClientEmailMessageDetails> {
            return localVarFp.clientEmailsDetailsFirmIdMessageIdGet(requestParameters.firmId, requestParameters.messageId, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a paginated list of outbound email messages sent to a client. This endpoint queries the email service provider to return message history including subject, recipients, and delivery status.
         * @summary Get client email messages
         * @param {ClientReportingApiClientEmailsFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientEmailsFirmIdClientIdGet(requestParameters: ClientReportingApiClientEmailsFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetClientEmailMessages> {
            return localVarFp.clientEmailsFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.pageSize, requestParameters.pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Generate mandate confirmation URL
         * @param {ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesAdvancedirectdebitmandateconfirmationPost(requestParameters: ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesAdvancedirectdebitmandateconfirmationPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Generate a contract note URL
         * @param {ClientReportingApiFilesContractnotePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesContractnotePost(requestParameters: ClientReportingApiFilesContractnotePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GenerateDocument> {
            return localVarFp.filesContractnotePost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * This command generates a fileURL for a given message type. Message types correspond to the messageType enum returned via the getMessage endpoint, all lowercase with underscores removed.
         * @summary Generate a file url
         * @param {ClientReportingApiFilesFileTypePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesFileTypePost(requestParameters: ClientReportingApiFilesFileTypePostRequest, options?: AxiosRequestConfig): AxiosPromise<FilesFileTypePost200Response> {
            return localVarFp.filesFileTypePost(requestParameters.fileType, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a successful array. It converts the projections calculated by the provided information into a PDF document that you can make available to the client or include in their suitability pack.
         * @summary Generate the illustration PDF
         * @param {ClientReportingApiFilesGeneratePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesGeneratePost(requestParameters: ClientReportingApiFilesGeneratePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesGeneratePost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateFile, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns the `illustrationId` and the link to the PDF URL.  **Please note: This should only be requested AFTER the \"generate illustration\" request has been made.**
         * @summary Download the illustration PDF
         * @param {ClientReportingApiFilesIllustrationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesIllustrationPost(requestParameters: ClientReportingApiFilesIllustrationPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<IllustrationDownload> {
            return localVarFp.filesIllustrationPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates the pension cancellation letter PDF URL
         * @summary Retrieve pension cancellation letter PDF
         * @param {ClientReportingApiFilesPensioncancellationletterPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesPensioncancellationletterPost(requestParameters: ClientReportingApiFilesPensioncancellationletterPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GenerateDocument> {
            return localVarFp.filesPensioncancellationletterPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a Consolidated Tax Voucher (CTV) document URL
         * @summary Generate a document URL
         * @param {ClientReportingApiFilesTaxstatementPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesTaxstatementPost(requestParameters: ClientReportingApiFilesTaxstatementPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GenerateDocument> {
            return localVarFp.filesTaxstatementPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
         * @summary Retrieve document URL
         * @param {ClientReportingApiFilesValuationstatementPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesValuationstatementPost(requestParameters: ClientReportingApiFilesValuationstatementPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GenerateDocument> {
            return localVarFp.filesValuationstatementPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * This command will retrieve all illustrations generated on the firm node.  **Please note: We have paginated this response to avoid the request from retrieving a large number of illustrations all at once.**
         * @summary Retrieve all illustrations
         * @param {ClientReportingApiIllustrationProductFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationProductFirmIdGet(requestParameters: ClientReportingApiIllustrationProductFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetIllustrationsList> {
            return localVarFp.illustrationProductFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.page, requestParameters.pageSize, requestParameters.name, requestParameters.id, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * This command will retrieve an illustration generated on the firm node.
         * @summary Retrieve illustration details
         * @param {ClientReportingApiIllustrationProductFirmIdIllustrationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationProductFirmIdIllustrationIdGet(requestParameters: ClientReportingApiIllustrationProductFirmIdIllustrationIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetIllustrationById> {
            return localVarFp.illustrationProductFirmIdIllustrationIdGet(requestParameters.firmId, requestParameters.illustrationId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         *  Product description 
         * @summary Drawdown illustration
         * @param {ClientReportingApiIllustrationProductPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationProductPost(requestParameters: ClientReportingApiIllustrationProductPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<IllustrationProduct> {
            return localVarFp.illustrationProductPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createProductIllustration, options).then((request) => request(axios, basePath));
        },
        /**
         * This command will retrieve all illustrations exluding SMPIs generated on the firm node.  **Please note: We have paginated this response to avoid the request from retrieving a large number of illustrations all at once.**
         * @summary Retrieve all illustrations excluding SMPIs
         * @param {ClientReportingApiIllustrationProductabridgedFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationProductabridgedFirmIdGet(requestParameters: ClientReportingApiIllustrationProductabridgedFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAbridgedIllustrationsList> {
            return localVarFp.illustrationProductabridgedFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.page, requestParameters.pageSize, requestParameters.name, requestParameters.id, requestParameters.status, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * This command creates a trade illustration, and returns the following data that can be made available in your application:  - Summary of initial charges - Summary of charges for each period - Final amount at end of period - Total initial charges - Total ongoing charges - Total transaction charges - Total overall charges
         * @summary Create a trade illustration
         * @param {ClientReportingApiIllustrationTradePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        illustrationTradePost(requestParameters: ClientReportingApiIllustrationTradePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<TradeIllustration> {
            return localVarFp.illustrationTradePost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createTradeIllustration, options).then((request) => request(axios, basePath));
        },
        /**
         * Client messages are used to inform the investor about changes to their platform user account and to their wrapper accounts.  Messages might also confirm a change to a client\'s personal information, such as an address update or change of contact details. Equally some regulatory documents are shared via these messages, as well as reports and valuation statements.
         * @summary Search for messages
         * @param {ClientReportingApiMessageFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageFirmIdGet(requestParameters: ClientReportingApiMessageFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetMessages> {
            return localVarFp.messageFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.pageSize, requestParameters.page, requestParameters.clientId, requestParameters.messageType, requestParameters.status, requestParameters.accountId, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * You can use this endpoint to retrieve a specific message for your client. Generally you would use the **GET** list call to list all messages in a client\'s message hub.  Then, when they click into a specific message, they will be presented with the message data from this single message **GET** request.  If the message is a certain document type (see the request below this one), then you can use the following request to retrieve that document, based on the payload in this message.
         * @summary Retrieve specific message
         * @param {ClientReportingApiMessageFirmIdMessageIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageFirmIdMessageIdGet(requestParameters: ClientReportingApiMessageFirmIdMessageIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetMessage> {
            return localVarFp.messageFirmIdMessageIdGet(requestParameters.firmId, requestParameters.messageId, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This command allows you to update the read or archived status of a message.
         * @summary Update message status
         * @param {ClientReportingApiMessageFirmIdMessageIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageFirmIdMessageIdPut(requestParameters: ClientReportingApiMessageFirmIdMessageIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<EmptyResponse> {
            return localVarFp.messageFirmIdMessageIdPut(requestParameters.firmId, requestParameters.messageId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateMessageStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * This command retrieves the number of unread messages for a firm. You can use the `clientId` query parameter to filter the unread message count for a client.
         * @summary Retreive unread message count
         * @param {ClientReportingApiMessageStatsFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageStatsFirmIdGet(requestParameters: ClientReportingApiMessageStatsFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetUnreadMessageCount> {
            return localVarFp.messageStatsFirmIdGet(requestParameters.firmId, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for clientEmailsDetailsFirmIdMessageIdGet operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiClientEmailsDetailsFirmIdMessageIdGetRequest
 */
export interface ClientReportingApiClientEmailsDetailsFirmIdMessageIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiClientEmailsDetailsFirmIdMessageIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiClientEmailsDetailsFirmIdMessageIdGet
     */
    readonly messageId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiClientEmailsDetailsFirmIdMessageIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for clientEmailsFirmIdClientIdGet operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiClientEmailsFirmIdClientIdGetRequest
 */
export interface ClientReportingApiClientEmailsFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiClientEmailsFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiClientEmailsFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiClientEmailsFirmIdClientIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {number}
     * @memberof ClientReportingApiClientEmailsFirmIdClientIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof ClientReportingApiClientEmailsFirmIdClientIdGet
     */
    readonly pageNumber?: number
}

/**
 * Request parameters for filesAdvancedirectdebitmandateconfirmationPost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPostRequest
 */
export interface ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {GenerateDocument}
     * @memberof ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPost
     */
    readonly generateDocument?: GenerateDocument
}

/**
 * Request parameters for filesContractnotePost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiFilesContractnotePostRequest
 */
export interface ClientReportingApiFilesContractnotePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesContractnotePost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesContractnotePost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {GenerateDocument}
     * @memberof ClientReportingApiFilesContractnotePost
     */
    readonly generateDocument?: GenerateDocument
}

/**
 * Request parameters for filesFileTypePost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiFilesFileTypePostRequest
 */
export interface ClientReportingApiFilesFileTypePostRequest {
    /**
     * 
     * @type {'accountupdate' | 'advancedirectdebitmandateconfirmation' | 'advancedirectdebitmandatenotice' | 'amlresenddata' | 'benefitcrystallisationeventstatement' | 'bcestatement' | 'changepassword' | 'clientupdate' | 'contractnote' | 'gaudicomms' | 'newaccount' | 'newaccountreplay' | 'pensioncancellationletter' | 'pensionpayslip' | 'pensionsavingsstatement' | 'pensiontransfercancellationletter' | 'quarterlystatement' | 'retirementpack' | 'taxstatement' | 'valuationstatement' | 'withdrawal' | 'flexiaccessnotification' | 'smpiannualstatement' | 'illustration' | 'taxpack' | 'pensionchoices'}
     * @memberof ClientReportingApiFilesFileTypePost
     */
    readonly fileType: 'accountupdate' | 'advancedirectdebitmandateconfirmation' | 'advancedirectdebitmandatenotice' | 'amlresenddata' | 'benefitcrystallisationeventstatement' | 'bcestatement' | 'changepassword' | 'clientupdate' | 'contractnote' | 'gaudicomms' | 'newaccount' | 'newaccountreplay' | 'pensioncancellationletter' | 'pensionpayslip' | 'pensionsavingsstatement' | 'pensiontransfercancellationletter' | 'quarterlystatement' | 'retirementpack' | 'taxstatement' | 'valuationstatement' | 'withdrawal' | 'flexiaccessnotification' | 'smpiannualstatement' | 'illustration' | 'taxpack' | 'pensionchoices'

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesFileTypePost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesFileTypePost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesFileTypePost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {GenerateDocument}
     * @memberof ClientReportingApiFilesFileTypePost
     */
    readonly generateDocument?: GenerateDocument
}

/**
 * Request parameters for filesGeneratePost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiFilesGeneratePostRequest
 */
export interface ClientReportingApiFilesGeneratePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesGeneratePost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesGeneratePost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesGeneratePost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {GenerateFile}
     * @memberof ClientReportingApiFilesGeneratePost
     */
    readonly generateFile?: GenerateFile
}

/**
 * Request parameters for filesIllustrationPost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiFilesIllustrationPostRequest
 */
export interface ClientReportingApiFilesIllustrationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesIllustrationPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesIllustrationPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesIllustrationPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {GenerateDocument}
     * @memberof ClientReportingApiFilesIllustrationPost
     */
    readonly generateDocument?: GenerateDocument
}

/**
 * Request parameters for filesPensioncancellationletterPost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiFilesPensioncancellationletterPostRequest
 */
export interface ClientReportingApiFilesPensioncancellationletterPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesPensioncancellationletterPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesPensioncancellationletterPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {GenerateDocument}
     * @memberof ClientReportingApiFilesPensioncancellationletterPost
     */
    readonly generateDocument?: GenerateDocument
}

/**
 * Request parameters for filesTaxstatementPost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiFilesTaxstatementPostRequest
 */
export interface ClientReportingApiFilesTaxstatementPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesTaxstatementPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesTaxstatementPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {GenerateDocument}
     * @memberof ClientReportingApiFilesTaxstatementPost
     */
    readonly generateDocument?: GenerateDocument
}

/**
 * Request parameters for filesValuationstatementPost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiFilesValuationstatementPostRequest
 */
export interface ClientReportingApiFilesValuationstatementPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesValuationstatementPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiFilesValuationstatementPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {GenerateDocument}
     * @memberof ClientReportingApiFilesValuationstatementPost
     */
    readonly generateDocument?: GenerateDocument
}

/**
 * Request parameters for illustrationProductFirmIdGet operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiIllustrationProductFirmIdGetRequest
 */
export interface ClientReportingApiIllustrationProductFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {number}
     * @memberof ClientReportingApiIllustrationProductFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientReportingApiIllustrationProductFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdGet
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdGet
     */
    readonly status?: string
}

/**
 * Request parameters for illustrationProductFirmIdIllustrationIdGet operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiIllustrationProductFirmIdIllustrationIdGetRequest
 */
export interface ClientReportingApiIllustrationProductFirmIdIllustrationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdIllustrationIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdIllustrationIdGet
     */
    readonly illustrationId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdIllustrationIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductFirmIdIllustrationIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for illustrationProductPost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiIllustrationProductPostRequest
 */
export interface ClientReportingApiIllustrationProductPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreateProductIllustration}
     * @memberof ClientReportingApiIllustrationProductPost
     */
    readonly createProductIllustration?: CreateProductIllustration
}

/**
 * Request parameters for illustrationProductabridgedFirmIdGet operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiIllustrationProductabridgedFirmIdGetRequest
 */
export interface ClientReportingApiIllustrationProductabridgedFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {number}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationProductabridgedFirmIdGet
     */
    readonly clientId?: string
}

/**
 * Request parameters for illustrationTradePost operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiIllustrationTradePostRequest
 */
export interface ClientReportingApiIllustrationTradePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationTradePost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationTradePost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiIllustrationTradePost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreateTradeIllustration}
     * @memberof ClientReportingApiIllustrationTradePost
     */
    readonly createTradeIllustration?: CreateTradeIllustration
}

/**
 * Request parameters for messageFirmIdGet operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiMessageFirmIdGetRequest
 */
export interface ClientReportingApiMessageFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {number}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly clientId?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly messageType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly accountId?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdGet
     */
    readonly toDate?: string
}

/**
 * Request parameters for messageFirmIdMessageIdGet operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiMessageFirmIdMessageIdGetRequest
 */
export interface ClientReportingApiMessageFirmIdMessageIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdMessageIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdMessageIdGet
     */
    readonly messageId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdMessageIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for messageFirmIdMessageIdPut operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiMessageFirmIdMessageIdPutRequest
 */
export interface ClientReportingApiMessageFirmIdMessageIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdMessageIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdMessageIdPut
     */
    readonly messageId: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdMessageIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdMessageIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageFirmIdMessageIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {UpdateMessageStatus}
     * @memberof ClientReportingApiMessageFirmIdMessageIdPut
     */
    readonly updateMessageStatus?: UpdateMessageStatus
}

/**
 * Request parameters for messageStatsFirmIdGet operation in ClientReportingApi.
 * @export
 * @interface ClientReportingApiMessageStatsFirmIdGetRequest
 */
export interface ClientReportingApiMessageStatsFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientReportingApiMessageStatsFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {any}
     * @memberof ClientReportingApiMessageStatsFirmIdGet
     */
    readonly clientId?: any
}

/**
 * ClientReportingApi - object-oriented interface
 * @export
 * @class ClientReportingApi
 * @extends {BaseAPI}
 */
export class ClientReportingApi extends BaseAPI {
    /**
     * Retrieves detailed information about a specific email message, including the full event history (sent, delivered, opened, bounced, etc).
     * @summary Get client email message details
     * @param {ClientReportingApiClientEmailsDetailsFirmIdMessageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public clientEmailsDetailsFirmIdMessageIdGet(requestParameters: ClientReportingApiClientEmailsDetailsFirmIdMessageIdGetRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).clientEmailsDetailsFirmIdMessageIdGet(requestParameters.firmId, requestParameters.messageId, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a paginated list of outbound email messages sent to a client. This endpoint queries the email service provider to return message history including subject, recipients, and delivery status.
     * @summary Get client email messages
     * @param {ClientReportingApiClientEmailsFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public clientEmailsFirmIdClientIdGet(requestParameters: ClientReportingApiClientEmailsFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).clientEmailsFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.pageSize, requestParameters.pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
     * @summary Generate mandate confirmation URL
     * @param {ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public filesAdvancedirectdebitmandateconfirmationPost(requestParameters: ClientReportingApiFilesAdvancedirectdebitmandateconfirmationPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).filesAdvancedirectdebitmandateconfirmationPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
     * @summary Generate a contract note URL
     * @param {ClientReportingApiFilesContractnotePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public filesContractnotePost(requestParameters: ClientReportingApiFilesContractnotePostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).filesContractnotePost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command generates a fileURL for a given message type. Message types correspond to the messageType enum returned via the getMessage endpoint, all lowercase with underscores removed.
     * @summary Generate a file url
     * @param {ClientReportingApiFilesFileTypePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public filesFileTypePost(requestParameters: ClientReportingApiFilesFileTypePostRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).filesFileTypePost(requestParameters.fileType, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a successful array. It converts the projections calculated by the provided information into a PDF document that you can make available to the client or include in their suitability pack.
     * @summary Generate the illustration PDF
     * @param {ClientReportingApiFilesGeneratePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public filesGeneratePost(requestParameters: ClientReportingApiFilesGeneratePostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).filesGeneratePost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns the `illustrationId` and the link to the PDF URL.  **Please note: This should only be requested AFTER the \"generate illustration\" request has been made.**
     * @summary Download the illustration PDF
     * @param {ClientReportingApiFilesIllustrationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public filesIllustrationPost(requestParameters: ClientReportingApiFilesIllustrationPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).filesIllustrationPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates the pension cancellation letter PDF URL
     * @summary Retrieve pension cancellation letter PDF
     * @param {ClientReportingApiFilesPensioncancellationletterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public filesPensioncancellationletterPost(requestParameters: ClientReportingApiFilesPensioncancellationletterPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).filesPensioncancellationletterPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a Consolidated Tax Voucher (CTV) document URL
     * @summary Generate a document URL
     * @param {ClientReportingApiFilesTaxstatementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public filesTaxstatementPost(requestParameters: ClientReportingApiFilesTaxstatementPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).filesTaxstatementPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command generates an investor document URL for your client. This returns an `Id` and URL which can be downloaded to your document store (AWS).  **Please note: each document type has a specific** **`/files`** **endpoint. You will first have to generate a URL and then use this to download the document.**  Messages will have a `messageType`which will correspond to an endpoint that can be used to retrieve the document. These are formatted in the following way:  | **messageType** | **_/files endpoint URL format** | | --- | --- | | ADVANCE_DIRECT_DEBIT_MANDATE_NOTICE  <br> <br>ADVANCE_DIRECT_DEBIT_MANDATE_CONFIRMATION  <br>  <br>CONTRACT_NOTE <br>  <br>PENSION_PAYSLIP  <br>  <br>PENSION_CANCELLATION_LETTER  <br> <br>PENSION_TRANSFER_CANCELLATION_LETTER  <br>  <br>ILLUSTRATION  <br> <br>TAX_STATEMENT  <br>  <br>VALUATION_STATEMENT | advancedirectdebitmandatenotice  <br> <br>advancedirectdebitmandateconfirmation  <br>  <br>  <br>contractnote <br>  <br>pensionpayslip  <br>  <br>pensioncancellationletter  <br> <br>  <br>pensiontransfercancellationletter  <br>  <br>illustration <br>  <br>taxstatement  <br>  <br>valuationstatement |  You can get the specific `documentId` for the document you want from the \'id\' in the messages returned from the \'message\' endpoint (see **Retrieve client messages** below).
     * @summary Retrieve document URL
     * @param {ClientReportingApiFilesValuationstatementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public filesValuationstatementPost(requestParameters: ClientReportingApiFilesValuationstatementPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).filesValuationstatementPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.generateDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command will retrieve all illustrations generated on the firm node.  **Please note: We have paginated this response to avoid the request from retrieving a large number of illustrations all at once.**
     * @summary Retrieve all illustrations
     * @param {ClientReportingApiIllustrationProductFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public illustrationProductFirmIdGet(requestParameters: ClientReportingApiIllustrationProductFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).illustrationProductFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.page, requestParameters.pageSize, requestParameters.name, requestParameters.id, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command will retrieve an illustration generated on the firm node.
     * @summary Retrieve illustration details
     * @param {ClientReportingApiIllustrationProductFirmIdIllustrationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public illustrationProductFirmIdIllustrationIdGet(requestParameters: ClientReportingApiIllustrationProductFirmIdIllustrationIdGetRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).illustrationProductFirmIdIllustrationIdGet(requestParameters.firmId, requestParameters.illustrationId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Product description 
     * @summary Drawdown illustration
     * @param {ClientReportingApiIllustrationProductPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public illustrationProductPost(requestParameters: ClientReportingApiIllustrationProductPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).illustrationProductPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createProductIllustration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command will retrieve all illustrations exluding SMPIs generated on the firm node.  **Please note: We have paginated this response to avoid the request from retrieving a large number of illustrations all at once.**
     * @summary Retrieve all illustrations excluding SMPIs
     * @param {ClientReportingApiIllustrationProductabridgedFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public illustrationProductabridgedFirmIdGet(requestParameters: ClientReportingApiIllustrationProductabridgedFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).illustrationProductabridgedFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.page, requestParameters.pageSize, requestParameters.name, requestParameters.id, requestParameters.status, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command creates a trade illustration, and returns the following data that can be made available in your application:  - Summary of initial charges - Summary of charges for each period - Final amount at end of period - Total initial charges - Total ongoing charges - Total transaction charges - Total overall charges
     * @summary Create a trade illustration
     * @param {ClientReportingApiIllustrationTradePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public illustrationTradePost(requestParameters: ClientReportingApiIllustrationTradePostRequest = {}, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).illustrationTradePost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createTradeIllustration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Client messages are used to inform the investor about changes to their platform user account and to their wrapper accounts.  Messages might also confirm a change to a client\'s personal information, such as an address update or change of contact details. Equally some regulatory documents are shared via these messages, as well as reports and valuation statements.
     * @summary Search for messages
     * @param {ClientReportingApiMessageFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public messageFirmIdGet(requestParameters: ClientReportingApiMessageFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).messageFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.pageSize, requestParameters.page, requestParameters.clientId, requestParameters.messageType, requestParameters.status, requestParameters.accountId, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * You can use this endpoint to retrieve a specific message for your client. Generally you would use the **GET** list call to list all messages in a client\'s message hub.  Then, when they click into a specific message, they will be presented with the message data from this single message **GET** request.  If the message is a certain document type (see the request below this one), then you can use the following request to retrieve that document, based on the payload in this message.
     * @summary Retrieve specific message
     * @param {ClientReportingApiMessageFirmIdMessageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public messageFirmIdMessageIdGet(requestParameters: ClientReportingApiMessageFirmIdMessageIdGetRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).messageFirmIdMessageIdGet(requestParameters.firmId, requestParameters.messageId, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command allows you to update the read or archived status of a message.
     * @summary Update message status
     * @param {ClientReportingApiMessageFirmIdMessageIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public messageFirmIdMessageIdPut(requestParameters: ClientReportingApiMessageFirmIdMessageIdPutRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).messageFirmIdMessageIdPut(requestParameters.firmId, requestParameters.messageId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateMessageStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command retrieves the number of unread messages for a firm. You can use the `clientId` query parameter to filter the unread message count for a client.
     * @summary Retreive unread message count
     * @param {ClientReportingApiMessageStatsFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientReportingApi
     */
    public messageStatsFirmIdGet(requestParameters: ClientReportingApiMessageStatsFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ClientReportingApiFp(this.configuration).messageStatsFirmIdGet(requestParameters.firmId, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardInformationApi - axios parameter creator
 * @export
 */
export const DashboardInformationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This route returns dashboard exceptions.  These differ from asynchronous exceptions, and are raised by successful API instructions covered under the **Notifications** section.
         * @summary Get dashboard exceptions
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardExceptionFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, nodeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('dashboardExceptionFirmIdGet', 'firmId', firmId)
            const localVarPath = `/dashboard/exception/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns dashboard information.  When querying by `nodeId`, the data returned relates to the node specified and all sub-nodes. This allows you to retrieve information by business stream, proposition, or adviser, for example.
         * @summary Get dashboard information
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardInformationFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, nodeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('dashboardInformationFirmIdGet', 'firmId', firmId)
            const localVarPath = `/dashboard/information/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dashboard transfers metrics
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardTransfersFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, nodeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('dashboardTransfersFirmIdGet', 'firmId', firmId)
            const localVarPath = `/dashboard/transfers/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardInformationApi - functional programming interface
 * @export
 */
export const DashboardInformationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardInformationApiAxiosParamCreator(configuration)
    return {
        /**
         * This route returns dashboard exceptions.  These differ from asynchronous exceptions, and are raised by successful API instructions covered under the **Notifications** section.
         * @summary Get dashboard exceptions
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardExceptionFirmIdGet(firmId: string, contentType?: string, apiToken?: string, nodeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardExceptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardExceptionFirmIdGet(firmId, contentType, apiToken, nodeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns dashboard information.  When querying by `nodeId`, the data returned relates to the node specified and all sub-nodes. This allows you to retrieve information by business stream, proposition, or adviser, for example.
         * @summary Get dashboard information
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardInformationFirmIdGet(firmId: string, contentType?: string, apiToken?: string, nodeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardInformationFirmIdGet(firmId, contentType, apiToken, nodeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get dashboard transfers metrics
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardTransfersFirmIdGet(firmId: string, contentType?: string, apiToken?: string, nodeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardTransfers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardTransfersFirmIdGet(firmId, contentType, apiToken, nodeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardInformationApi - factory interface
 * @export
 */
export const DashboardInformationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardInformationApiFp(configuration)
    return {
        /**
         * This route returns dashboard exceptions.  These differ from asynchronous exceptions, and are raised by successful API instructions covered under the **Notifications** section.
         * @summary Get dashboard exceptions
         * @param {DashboardInformationApiDashboardExceptionFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardExceptionFirmIdGet(requestParameters: DashboardInformationApiDashboardExceptionFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetDashboardExceptions> {
            return localVarFp.dashboardExceptionFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns dashboard information.  When querying by `nodeId`, the data returned relates to the node specified and all sub-nodes. This allows you to retrieve information by business stream, proposition, or adviser, for example.
         * @summary Get dashboard information
         * @param {DashboardInformationApiDashboardInformationFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardInformationFirmIdGet(requestParameters: DashboardInformationApiDashboardInformationFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetDashboardInfo> {
            return localVarFp.dashboardInformationFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dashboard transfers metrics
         * @param {DashboardInformationApiDashboardTransfersFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardTransfersFirmIdGet(requestParameters: DashboardInformationApiDashboardTransfersFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetDashboardTransfers> {
            return localVarFp.dashboardTransfersFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.nodeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dashboardExceptionFirmIdGet operation in DashboardInformationApi.
 * @export
 * @interface DashboardInformationApiDashboardExceptionFirmIdGetRequest
 */
export interface DashboardInformationApiDashboardExceptionFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardExceptionFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardExceptionFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardExceptionFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardExceptionFirmIdGet
     */
    readonly nodeId?: string
}

/**
 * Request parameters for dashboardInformationFirmIdGet operation in DashboardInformationApi.
 * @export
 * @interface DashboardInformationApiDashboardInformationFirmIdGetRequest
 */
export interface DashboardInformationApiDashboardInformationFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardInformationFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardInformationFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardInformationFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardInformationFirmIdGet
     */
    readonly nodeId?: string
}

/**
 * Request parameters for dashboardTransfersFirmIdGet operation in DashboardInformationApi.
 * @export
 * @interface DashboardInformationApiDashboardTransfersFirmIdGetRequest
 */
export interface DashboardInformationApiDashboardTransfersFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardTransfersFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardTransfersFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardTransfersFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardInformationApiDashboardTransfersFirmIdGet
     */
    readonly nodeId?: string
}

/**
 * DashboardInformationApi - object-oriented interface
 * @export
 * @class DashboardInformationApi
 * @extends {BaseAPI}
 */
export class DashboardInformationApi extends BaseAPI {
    /**
     * This route returns dashboard exceptions.  These differ from asynchronous exceptions, and are raised by successful API instructions covered under the **Notifications** section.
     * @summary Get dashboard exceptions
     * @param {DashboardInformationApiDashboardExceptionFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardInformationApi
     */
    public dashboardExceptionFirmIdGet(requestParameters: DashboardInformationApiDashboardExceptionFirmIdGetRequest, options?: AxiosRequestConfig) {
        return DashboardInformationApiFp(this.configuration).dashboardExceptionFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns dashboard information.  When querying by `nodeId`, the data returned relates to the node specified and all sub-nodes. This allows you to retrieve information by business stream, proposition, or adviser, for example.
     * @summary Get dashboard information
     * @param {DashboardInformationApiDashboardInformationFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardInformationApi
     */
    public dashboardInformationFirmIdGet(requestParameters: DashboardInformationApiDashboardInformationFirmIdGetRequest, options?: AxiosRequestConfig) {
        return DashboardInformationApiFp(this.configuration).dashboardInformationFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dashboard transfers metrics
     * @param {DashboardInformationApiDashboardTransfersFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardInformationApi
     */
    public dashboardTransfersFirmIdGet(requestParameters: DashboardInformationApiDashboardTransfersFirmIdGetRequest, options?: AxiosRequestConfig) {
        return DashboardInformationApiFp(this.configuration).dashboardTransfersFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.nodeId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the rebalance event with the desired asset allocations created on the model.
         * @summary Retrieve rebalance event
         * @param {string} firmId 
         * @param {string} eventId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventFirmIdEventIdGet: async (firmId: string, eventId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('eventFirmIdEventIdGet', 'firmId', firmId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('eventFirmIdEventIdGet', 'eventId', eventId)
            const localVarPath = `/event/{firmId}/{eventId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * When a `Rebalance` is instructed, it Rebalances an investment account using a model. Returns an `linkId` for the background transactions on the account.  When a `Portfolio Realign` is instructed, it calculates the relevant buys and sells to bring the investment account holdings in line with the attached recurring orders allocation.  An example  Recurring orders allocation:  * 50% Asset A * 30% Asset B * 20% Asset C  Actual holdings:  * 60% Asset A * 15% Asset B * 25% Asset C  Portfolio realign would create the following orders:  * Sell 10% Asset A * Sell 5% Asset C * Buy 15% Asset B 
         * @summary Various events, including instructing an investment rebalance or portoflio realign, and creating valuation statements
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {EventPostRequest} [eventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, eventPostRequest?: EventPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the rebalance event with the desired asset allocations created on the model.
         * @summary Retrieve rebalance event
         * @param {string} firmId 
         * @param {string} eventId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventFirmIdEventIdGet(firmId: string, eventId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventFirmIdEventIdGet(firmId, eventId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * When a `Rebalance` is instructed, it Rebalances an investment account using a model. Returns an `linkId` for the background transactions on the account.  When a `Portfolio Realign` is instructed, it calculates the relevant buys and sells to bring the investment account holdings in line with the attached recurring orders allocation.  An example  Recurring orders allocation:  * 50% Asset A * 30% Asset B * 20% Asset C  Actual holdings:  * 60% Asset A * 15% Asset B * 25% Asset C  Portfolio realign would create the following orders:  * Sell 10% Asset A * Sell 5% Asset C * Buy 15% Asset B 
         * @summary Various events, including instructing an investment rebalance or portoflio realign, and creating valuation statements
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {EventPostRequest} [eventPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventPost(contentType?: string, apiToken?: string, idempotencyKey?: string, eventPostRequest?: EventPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioTransactionGroupPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventPost(contentType, apiToken, idempotencyKey, eventPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * Retrieves the rebalance event with the desired asset allocations created on the model.
         * @summary Retrieve rebalance event
         * @param {EventsApiEventFirmIdEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventFirmIdEventIdGet(requestParameters: EventsApiEventFirmIdEventIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.eventFirmIdEventIdGet(requestParameters.firmId, requestParameters.eventId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * When a `Rebalance` is instructed, it Rebalances an investment account using a model. Returns an `linkId` for the background transactions on the account.  When a `Portfolio Realign` is instructed, it calculates the relevant buys and sells to bring the investment account holdings in line with the attached recurring orders allocation.  An example  Recurring orders allocation:  * 50% Asset A * 30% Asset B * 20% Asset C  Actual holdings:  * 60% Asset A * 15% Asset B * 25% Asset C  Portfolio realign would create the following orders:  * Sell 10% Asset A * Sell 5% Asset C * Buy 15% Asset B 
         * @summary Various events, including instructing an investment rebalance or portoflio realign, and creating valuation statements
         * @param {EventsApiEventPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventPost(requestParameters: EventsApiEventPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PortfolioTransactionGroupPost200Response> {
            return localVarFp.eventPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.eventPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for eventFirmIdEventIdGet operation in EventsApi.
 * @export
 * @interface EventsApiEventFirmIdEventIdGetRequest
 */
export interface EventsApiEventFirmIdEventIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiEventFirmIdEventIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiEventFirmIdEventIdGet
     */
    readonly eventId: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiEventFirmIdEventIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiEventFirmIdEventIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for eventPost operation in EventsApi.
 * @export
 * @interface EventsApiEventPostRequest
 */
export interface EventsApiEventPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EventsApiEventPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiEventPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof EventsApiEventPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {EventPostRequest}
     * @memberof EventsApiEventPost
     */
    readonly eventPostRequest?: EventPostRequest
}

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * Retrieves the rebalance event with the desired asset allocations created on the model.
     * @summary Retrieve rebalance event
     * @param {EventsApiEventFirmIdEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public eventFirmIdEventIdGet(requestParameters: EventsApiEventFirmIdEventIdGetRequest, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventFirmIdEventIdGet(requestParameters.firmId, requestParameters.eventId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * When a `Rebalance` is instructed, it Rebalances an investment account using a model. Returns an `linkId` for the background transactions on the account.  When a `Portfolio Realign` is instructed, it calculates the relevant buys and sells to bring the investment account holdings in line with the attached recurring orders allocation.  An example  Recurring orders allocation:  * 50% Asset A * 30% Asset B * 20% Asset C  Actual holdings:  * 60% Asset A * 15% Asset B * 25% Asset C  Portfolio realign would create the following orders:  * Sell 10% Asset A * Sell 5% Asset C * Buy 15% Asset B 
     * @summary Various events, including instructing an investment rebalance or portoflio realign, and creating valuation statements
     * @param {EventsApiEventPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public eventPost(requestParameters: EventsApiEventPostRequest = {}, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.eventPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeatureFlagApi - axios parameter creator
 * @export
 */
export const FeatureFlagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmEnabledfeaturesFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('firmEnabledfeaturesFirmIdGet', 'firmId', firmId)
            const localVarPath = `/firm/enabledfeatures/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureFlagApi - functional programming interface
 * @export
 */
export const FeatureFlagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureFlagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmEnabledfeaturesFirmIdGet(firmId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureFlagContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmEnabledfeaturesFirmIdGet(firmId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeatureFlagApi - factory interface
 * @export
 */
export const FeatureFlagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureFlagApiFp(configuration)
    return {
        /**
         * 
         * @param {FeatureFlagApiFirmEnabledfeaturesFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmEnabledfeaturesFirmIdGet(requestParameters: FeatureFlagApiFirmEnabledfeaturesFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FeatureFlagContent> {
            return localVarFp.firmEnabledfeaturesFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for firmEnabledfeaturesFirmIdGet operation in FeatureFlagApi.
 * @export
 * @interface FeatureFlagApiFirmEnabledfeaturesFirmIdGetRequest
 */
export interface FeatureFlagApiFirmEnabledfeaturesFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FeatureFlagApiFirmEnabledfeaturesFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FeatureFlagApiFirmEnabledfeaturesFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FeatureFlagApiFirmEnabledfeaturesFirmIdGet
     */
    readonly apiToken?: string
}

/**
 * FeatureFlagApi - object-oriented interface
 * @export
 * @class FeatureFlagApi
 * @extends {BaseAPI}
 */
export class FeatureFlagApi extends BaseAPI {
    /**
     * 
     * @param {FeatureFlagApiFirmEnabledfeaturesFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagApi
     */
    public firmEnabledfeaturesFirmIdGet(requestParameters: FeatureFlagApiFirmEnabledfeaturesFirmIdGetRequest, options?: AxiosRequestConfig) {
        return FeatureFlagApiFp(this.configuration).firmEnabledfeaturesFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FileUploadApi - axios parameter creator
 * @export
 */
export const FileUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Requests a presigned S3 upload URL, form fields, and validation metadata for the given file. The client should call this endpoint before attempting to upload the file directly to S3. 
         * @summary Get a presigned upload URL for a file
         * @param {string} firmId ID of the firm associated with the file
         * @param {'logo' | 'favicon' | 'nav-logo' | 'professional-main-logo' | 'investor-logo' | 'template-logo'} category Category of the file (e.g., logo or favicon)
         * @param {string} nodeId Node ID associated with the file upload
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmFilesUploadFirmIdGet: async (firmId: string, category: 'logo' | 'favicon' | 'nav-logo' | 'professional-main-logo' | 'investor-logo' | 'template-logo', nodeId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('firmFilesUploadFirmIdGet', 'firmId', firmId)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('firmFilesUploadFirmIdGet', 'category', category)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('firmFilesUploadFirmIdGet', 'nodeId', nodeId)
            const localVarPath = `/firm/files/upload/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileUploadApi - functional programming interface
 * @export
 */
export const FileUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * Requests a presigned S3 upload URL, form fields, and validation metadata for the given file. The client should call this endpoint before attempting to upload the file directly to S3. 
         * @summary Get a presigned upload URL for a file
         * @param {string} firmId ID of the firm associated with the file
         * @param {'logo' | 'favicon' | 'nav-logo' | 'professional-main-logo' | 'investor-logo' | 'template-logo'} category Category of the file (e.g., logo or favicon)
         * @param {string} nodeId Node ID associated with the file upload
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmFilesUploadFirmIdGet(firmId: string, category: 'logo' | 'favicon' | 'nav-logo' | 'professional-main-logo' | 'investor-logo' | 'template-logo', nodeId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirmFilesUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmFilesUploadFirmIdGet(firmId, category, nodeId, contentType, apiToken, idempotencyKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FileUploadApi - factory interface
 * @export
 */
export const FileUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileUploadApiFp(configuration)
    return {
        /**
         * Requests a presigned S3 upload URL, form fields, and validation metadata for the given file. The client should call this endpoint before attempting to upload the file directly to S3. 
         * @summary Get a presigned upload URL for a file
         * @param {FileUploadApiFirmFilesUploadFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmFilesUploadFirmIdGet(requestParameters: FileUploadApiFirmFilesUploadFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FirmFilesUploadResponse> {
            return localVarFp.firmFilesUploadFirmIdGet(requestParameters.firmId, requestParameters.category, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for firmFilesUploadFirmIdGet operation in FileUploadApi.
 * @export
 * @interface FileUploadApiFirmFilesUploadFirmIdGetRequest
 */
export interface FileUploadApiFirmFilesUploadFirmIdGetRequest {
    /**
     * ID of the firm associated with the file
     * @type {string}
     * @memberof FileUploadApiFirmFilesUploadFirmIdGet
     */
    readonly firmId: string

    /**
     * Category of the file (e.g., logo or favicon)
     * @type {'logo' | 'favicon' | 'nav-logo' | 'professional-main-logo' | 'investor-logo' | 'template-logo'}
     * @memberof FileUploadApiFirmFilesUploadFirmIdGet
     */
    readonly category: 'logo' | 'favicon' | 'nav-logo' | 'professional-main-logo' | 'investor-logo' | 'template-logo'

    /**
     * Node ID associated with the file upload
     * @type {string}
     * @memberof FileUploadApiFirmFilesUploadFirmIdGet
     */
    readonly nodeId: string

    /**
     * 
     * @type {string}
     * @memberof FileUploadApiFirmFilesUploadFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FileUploadApiFirmFilesUploadFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof FileUploadApiFirmFilesUploadFirmIdGet
     */
    readonly idempotencyKey?: string
}

/**
 * FileUploadApi - object-oriented interface
 * @export
 * @class FileUploadApi
 * @extends {BaseAPI}
 */
export class FileUploadApi extends BaseAPI {
    /**
     * Requests a presigned S3 upload URL, form fields, and validation metadata for the given file. The client should call this endpoint before attempting to upload the file directly to S3. 
     * @summary Get a presigned upload URL for a file
     * @param {FileUploadApiFirmFilesUploadFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileUploadApi
     */
    public firmFilesUploadFirmIdGet(requestParameters: FileUploadApiFirmFilesUploadFirmIdGetRequest, options?: AxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).firmFilesUploadFirmIdGet(requestParameters.firmId, requestParameters.category, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FirmManagementApi - axios parameter creator
 * @export
 */
export const FirmManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This command returns firm config for the requested datatype
         * @summary Retrieve the firm config of the requested `dataType`
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [dataType] 
         * @param {string} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmConfigFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, dataType?: string, nodeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('firmConfigFirmIdGet', 'firmId', firmId)
            const localVarPath = `/firm/config/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (dataType !== undefined) {
                localVarQueryParameter['dataType'] = dataType;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the node configuration
         * @param {string} firmId 
         * @param {string} nodeId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeConfigFirmIdNodeIdGet: async (firmId: string, nodeId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('nodeConfigFirmIdNodeIdGet', 'firmId', firmId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('nodeConfigFirmIdNodeIdGet', 'nodeId', nodeId)
            const localVarPath = `/node/config/{firmId}/{nodeId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update node configuration
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {PatchConfiguration} [patchConfiguration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeConfigFirmIdPatch: async (firmId: string, contentType?: string, apiToken?: string, patchConfiguration?: PatchConfiguration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('nodeConfigFirmIdPatch', 'firmId', firmId)
            const localVarPath = `/node/config/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the text content for the node.
         * @param {string} firmId 
         * @param {string} nodeId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeContentFirmIdNodeIdGet: async (firmId: string, nodeId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('nodeContentFirmIdNodeIdGet', 'firmId', firmId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('nodeContentFirmIdNodeIdGet', 'nodeId', nodeId)
            const localVarPath = `/node/content/{firmId}/{nodeId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the text content for the node
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {PatchContent} [patchContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeContentFirmIdPatch: async (firmId: string, contentType?: string, apiToken?: string, patchContent?: PatchContent, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('nodeContentFirmIdPatch', 'firmId', firmId)
            const localVarPath = `/node/content/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchContent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the theme for the node.
         * @param {string} firmId 
         * @param {string} nodeId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeThemeFirmIdNodeIdGet: async (firmId: string, nodeId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('nodeThemeFirmIdNodeIdGet', 'firmId', firmId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('nodeThemeFirmIdNodeIdGet', 'nodeId', nodeId)
            const localVarPath = `/node/theme/{firmId}/{nodeId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the theme for the node
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {PatchTheme} [patchTheme] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeThemeFirmIdPatch: async (firmId: string, contentType?: string, apiToken?: string, patchTheme?: PatchTheme, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('nodeThemeFirmIdPatch', 'firmId', firmId)
            const localVarPath = `/node/theme/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchTheme, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the trading charges for the node.
         * @param {string} firmId 
         * @param {string} nodeId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTradingchargeFirmIdNodeIdGet: async (firmId: string, nodeId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('nodeTradingchargeFirmIdNodeIdGet', 'firmId', firmId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('nodeTradingchargeFirmIdNodeIdGet', 'nodeId', nodeId)
            const localVarPath = `/node/tradingcharge/{firmId}/{nodeId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['content-type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all contents of the firm_services pfolio document, excluding sensitive webhook information.
         * @summary Retrieve firm pfolio service details
         * @param {string} firmId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsFirmIdGet: async (firmId: string, apiToken?: string, contentType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('settingsFirmIdGet', 'firmId', firmId)
            const localVarPath = `/settings/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FirmManagementApi - functional programming interface
 * @export
 */
export const FirmManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FirmManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * This command returns firm config for the requested datatype
         * @summary Retrieve the firm config of the requested `dataType`
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [dataType] 
         * @param {string} [nodeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmConfigFirmIdGet(firmId: string, contentType?: string, apiToken?: string, dataType?: string, nodeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFirmConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmConfigFirmIdGet(firmId, contentType, apiToken, dataType, nodeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch the node configuration
         * @param {string} firmId 
         * @param {string} nodeId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeConfigFirmIdNodeIdGet(firmId: string, nodeId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeConfigFirmIdNodeIdGet(firmId, nodeId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update node configuration
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {PatchConfiguration} [patchConfiguration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeConfigFirmIdPatch(firmId: string, contentType?: string, apiToken?: string, patchConfiguration?: PatchConfiguration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeConfigFirmIdPatch(firmId, contentType, apiToken, patchConfiguration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch the text content for the node.
         * @param {string} firmId 
         * @param {string} nodeId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeContentFirmIdNodeIdGet(firmId: string, nodeId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeContentFirmIdNodeIdGet(firmId, nodeId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the text content for the node
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {PatchContent} [patchContent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeContentFirmIdPatch(firmId: string, contentType?: string, apiToken?: string, patchContent?: PatchContent, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeContentFirmIdPatch(firmId, contentType, apiToken, patchContent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch the theme for the node.
         * @param {string} firmId 
         * @param {string} nodeId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeThemeFirmIdNodeIdGet(firmId: string, nodeId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchTheme>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeThemeFirmIdNodeIdGet(firmId, nodeId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the theme for the node
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {PatchTheme} [patchTheme] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeThemeFirmIdPatch(firmId: string, contentType?: string, apiToken?: string, patchTheme?: PatchTheme, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeThemeFirmIdPatch(firmId, contentType, apiToken, patchTheme, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch the trading charges for the node.
         * @param {string} firmId 
         * @param {string} nodeId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeTradingchargeFirmIdNodeIdGet(firmId: string, nodeId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TradingChargesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeTradingchargeFirmIdNodeIdGet(firmId, nodeId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves all contents of the firm_services pfolio document, excluding sensitive webhook information.
         * @summary Retrieve firm pfolio service details
         * @param {string} firmId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingsFirmIdGet(firmId: string, apiToken?: string, contentType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFirmSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingsFirmIdGet(firmId, apiToken, contentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FirmManagementApi - factory interface
 * @export
 */
export const FirmManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FirmManagementApiFp(configuration)
    return {
        /**
         * This command returns firm config for the requested datatype
         * @summary Retrieve the firm config of the requested `dataType`
         * @param {FirmManagementApiFirmConfigFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmConfigFirmIdGet(requestParameters: FirmManagementApiFirmConfigFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetFirmConfig> {
            return localVarFp.firmConfigFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.dataType, requestParameters.nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the node configuration
         * @param {FirmManagementApiNodeConfigFirmIdNodeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeConfigFirmIdNodeIdGet(requestParameters: FirmManagementApiNodeConfigFirmIdNodeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FetchConfiguration> {
            return localVarFp.nodeConfigFirmIdNodeIdGet(requestParameters.firmId, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update node configuration
         * @param {FirmManagementApiNodeConfigFirmIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeConfigFirmIdPatch(requestParameters: FirmManagementApiNodeConfigFirmIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<PatchResponse> {
            return localVarFp.nodeConfigFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.patchConfiguration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the text content for the node.
         * @param {FirmManagementApiNodeContentFirmIdNodeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeContentFirmIdNodeIdGet(requestParameters: FirmManagementApiNodeContentFirmIdNodeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FetchContent> {
            return localVarFp.nodeContentFirmIdNodeIdGet(requestParameters.firmId, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the text content for the node
         * @param {FirmManagementApiNodeContentFirmIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeContentFirmIdPatch(requestParameters: FirmManagementApiNodeContentFirmIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<PatchResponse> {
            return localVarFp.nodeContentFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.patchContent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the theme for the node.
         * @param {FirmManagementApiNodeThemeFirmIdNodeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeThemeFirmIdNodeIdGet(requestParameters: FirmManagementApiNodeThemeFirmIdNodeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FetchTheme> {
            return localVarFp.nodeThemeFirmIdNodeIdGet(requestParameters.firmId, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the theme for the node
         * @param {FirmManagementApiNodeThemeFirmIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeThemeFirmIdPatch(requestParameters: FirmManagementApiNodeThemeFirmIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<PatchResponse> {
            return localVarFp.nodeThemeFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.patchTheme, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the trading charges for the node.
         * @param {FirmManagementApiNodeTradingchargeFirmIdNodeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTradingchargeFirmIdNodeIdGet(requestParameters: FirmManagementApiNodeTradingchargeFirmIdNodeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<TradingChargesResponse> {
            return localVarFp.nodeTradingchargeFirmIdNodeIdGet(requestParameters.firmId, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all contents of the firm_services pfolio document, excluding sensitive webhook information.
         * @summary Retrieve firm pfolio service details
         * @param {FirmManagementApiSettingsFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingsFirmIdGet(requestParameters: FirmManagementApiSettingsFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetFirmSettings> {
            return localVarFp.settingsFirmIdGet(requestParameters.firmId, requestParameters.apiToken, requestParameters.contentType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for firmConfigFirmIdGet operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiFirmConfigFirmIdGetRequest
 */
export interface FirmManagementApiFirmConfigFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiFirmConfigFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiFirmConfigFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiFirmConfigFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiFirmConfigFirmIdGet
     */
    readonly dataType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiFirmConfigFirmIdGet
     */
    readonly nodeId?: string
}

/**
 * Request parameters for nodeConfigFirmIdNodeIdGet operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiNodeConfigFirmIdNodeIdGetRequest
 */
export interface FirmManagementApiNodeConfigFirmIdNodeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeConfigFirmIdNodeIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeConfigFirmIdNodeIdGet
     */
    readonly nodeId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeConfigFirmIdNodeIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeConfigFirmIdNodeIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for nodeConfigFirmIdPatch operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiNodeConfigFirmIdPatchRequest
 */
export interface FirmManagementApiNodeConfigFirmIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeConfigFirmIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeConfigFirmIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeConfigFirmIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {PatchConfiguration}
     * @memberof FirmManagementApiNodeConfigFirmIdPatch
     */
    readonly patchConfiguration?: PatchConfiguration
}

/**
 * Request parameters for nodeContentFirmIdNodeIdGet operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiNodeContentFirmIdNodeIdGetRequest
 */
export interface FirmManagementApiNodeContentFirmIdNodeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeContentFirmIdNodeIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeContentFirmIdNodeIdGet
     */
    readonly nodeId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeContentFirmIdNodeIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeContentFirmIdNodeIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for nodeContentFirmIdPatch operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiNodeContentFirmIdPatchRequest
 */
export interface FirmManagementApiNodeContentFirmIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeContentFirmIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeContentFirmIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeContentFirmIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {PatchContent}
     * @memberof FirmManagementApiNodeContentFirmIdPatch
     */
    readonly patchContent?: PatchContent
}

/**
 * Request parameters for nodeThemeFirmIdNodeIdGet operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiNodeThemeFirmIdNodeIdGetRequest
 */
export interface FirmManagementApiNodeThemeFirmIdNodeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeThemeFirmIdNodeIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeThemeFirmIdNodeIdGet
     */
    readonly nodeId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeThemeFirmIdNodeIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeThemeFirmIdNodeIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for nodeThemeFirmIdPatch operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiNodeThemeFirmIdPatchRequest
 */
export interface FirmManagementApiNodeThemeFirmIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeThemeFirmIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeThemeFirmIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeThemeFirmIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {PatchTheme}
     * @memberof FirmManagementApiNodeThemeFirmIdPatch
     */
    readonly patchTheme?: PatchTheme
}

/**
 * Request parameters for nodeTradingchargeFirmIdNodeIdGet operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiNodeTradingchargeFirmIdNodeIdGetRequest
 */
export interface FirmManagementApiNodeTradingchargeFirmIdNodeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeTradingchargeFirmIdNodeIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeTradingchargeFirmIdNodeIdGet
     */
    readonly nodeId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeTradingchargeFirmIdNodeIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiNodeTradingchargeFirmIdNodeIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for settingsFirmIdGet operation in FirmManagementApi.
 * @export
 * @interface FirmManagementApiSettingsFirmIdGetRequest
 */
export interface FirmManagementApiSettingsFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiSettingsFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiSettingsFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof FirmManagementApiSettingsFirmIdGet
     */
    readonly contentType?: string
}

/**
 * FirmManagementApi - object-oriented interface
 * @export
 * @class FirmManagementApi
 * @extends {BaseAPI}
 */
export class FirmManagementApi extends BaseAPI {
    /**
     * This command returns firm config for the requested datatype
     * @summary Retrieve the firm config of the requested `dataType`
     * @param {FirmManagementApiFirmConfigFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public firmConfigFirmIdGet(requestParameters: FirmManagementApiFirmConfigFirmIdGetRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).firmConfigFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.dataType, requestParameters.nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the node configuration
     * @param {FirmManagementApiNodeConfigFirmIdNodeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public nodeConfigFirmIdNodeIdGet(requestParameters: FirmManagementApiNodeConfigFirmIdNodeIdGetRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).nodeConfigFirmIdNodeIdGet(requestParameters.firmId, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update node configuration
     * @param {FirmManagementApiNodeConfigFirmIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public nodeConfigFirmIdPatch(requestParameters: FirmManagementApiNodeConfigFirmIdPatchRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).nodeConfigFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.patchConfiguration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the text content for the node.
     * @param {FirmManagementApiNodeContentFirmIdNodeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public nodeContentFirmIdNodeIdGet(requestParameters: FirmManagementApiNodeContentFirmIdNodeIdGetRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).nodeContentFirmIdNodeIdGet(requestParameters.firmId, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the text content for the node
     * @param {FirmManagementApiNodeContentFirmIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public nodeContentFirmIdPatch(requestParameters: FirmManagementApiNodeContentFirmIdPatchRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).nodeContentFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.patchContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the theme for the node.
     * @param {FirmManagementApiNodeThemeFirmIdNodeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public nodeThemeFirmIdNodeIdGet(requestParameters: FirmManagementApiNodeThemeFirmIdNodeIdGetRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).nodeThemeFirmIdNodeIdGet(requestParameters.firmId, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the theme for the node
     * @param {FirmManagementApiNodeThemeFirmIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public nodeThemeFirmIdPatch(requestParameters: FirmManagementApiNodeThemeFirmIdPatchRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).nodeThemeFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.patchTheme, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the trading charges for the node.
     * @param {FirmManagementApiNodeTradingchargeFirmIdNodeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public nodeTradingchargeFirmIdNodeIdGet(requestParameters: FirmManagementApiNodeTradingchargeFirmIdNodeIdGetRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).nodeTradingchargeFirmIdNodeIdGet(requestParameters.firmId, requestParameters.nodeId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all contents of the firm_services pfolio document, excluding sensitive webhook information.
     * @summary Retrieve firm pfolio service details
     * @param {FirmManagementApiSettingsFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmManagementApi
     */
    public settingsFirmIdGet(requestParameters: FirmManagementApiSettingsFirmIdGetRequest, options?: AxiosRequestConfig) {
        return FirmManagementApiFp(this.configuration).settingsFirmIdGet(requestParameters.firmId, requestParameters.apiToken, requestParameters.contentType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ModelManagementApi - axios parameter creator
 * @export
 */
export const ModelManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a list of models for a firm Returns an array of the `model` object.
         * @summary List models
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, pageSize?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('modelFirmIdGet', 'firmId', firmId)
            const localVarPath = `/model/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific model. Returns the `models` object.
         * @summary Retrieve model
         * @param {string} firmId 
         * @param {string} modelId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelFirmIdModelIdGet: async (firmId: string, modelId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('modelFirmIdModelIdGet', 'firmId', firmId)
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('modelFirmIdModelIdGet', 'modelId', modelId)
            const localVarPath = `/model/{firmId}/{modelId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a model. Returns the `models` object.  **Please note the following:**  *   Assets must have a status of \'Active\' to be included in the model. *   You cannot change the product types for a model. In order to do this, you must create a new model and add in your chosen wrapper types in the `productType` field.
         * @summary Update model
         * @param {string} firmId 
         * @param {string} modelId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateModel} [updateModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelFirmIdModelIdPatch: async (firmId: string, modelId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateModel?: UpdateModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('modelFirmIdModelIdPatch', 'firmId', firmId)
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('modelFirmIdModelIdPatch', 'modelId', modelId)
            const localVarPath = `/model/{firmId}/{modelId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a model. Returns a `modelId`
         * @summary Create model
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateModel} [createModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, createModel?: CreateModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/model`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelManagementApi - functional programming interface
 * @export
 */
export const ModelManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a list of models for a firm Returns an array of the `model` object.
         * @summary List models
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelFirmIdGet(firmId: string, contentType?: string, apiToken?: string, pageSize?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModelsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelFirmIdGet(firmId, contentType, apiToken, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a specific model. Returns the `models` object.
         * @summary Retrieve model
         * @param {string} firmId 
         * @param {string} modelId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelFirmIdModelIdGet(firmId: string, modelId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelFirmIdModelIdGet(firmId, modelId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates a model. Returns the `models` object.  **Please note the following:**  *   Assets must have a status of \'Active\' to be included in the model. *   You cannot change the product types for a model. In order to do this, you must create a new model and add in your chosen wrapper types in the `productType` field.
         * @summary Update model
         * @param {string} firmId 
         * @param {string} modelId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateModel} [updateModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelFirmIdModelIdPatch(firmId: string, modelId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateModel?: UpdateModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelFirmIdModelIdPatch(firmId, modelId, contentType, apiToken, idempotencyKey, updateModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a model. Returns a `modelId`
         * @summary Create model
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateModel} [createModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelPost(contentType?: string, apiToken?: string, idempotencyKey?: string, createModel?: CreateModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelPost(contentType, apiToken, idempotencyKey, createModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ModelManagementApi - factory interface
 * @export
 */
export const ModelManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelManagementApiFp(configuration)
    return {
        /**
         * Retrieves a list of models for a firm Returns an array of the `model` object.
         * @summary List models
         * @param {ModelManagementApiModelFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelFirmIdGet(requestParameters: ModelManagementApiModelFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetModelsList> {
            return localVarFp.modelFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.pageSize, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific model. Returns the `models` object.
         * @summary Retrieve model
         * @param {ModelManagementApiModelFirmIdModelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelFirmIdModelIdGet(requestParameters: ModelManagementApiModelFirmIdModelIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetModel> {
            return localVarFp.modelFirmIdModelIdGet(requestParameters.firmId, requestParameters.modelId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a model. Returns the `models` object.  **Please note the following:**  *   Assets must have a status of \'Active\' to be included in the model. *   You cannot change the product types for a model. In order to do this, you must create a new model and add in your chosen wrapper types in the `productType` field.
         * @summary Update model
         * @param {ModelManagementApiModelFirmIdModelIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelFirmIdModelIdPatch(requestParameters: ModelManagementApiModelFirmIdModelIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<CreateModel> {
            return localVarFp.modelFirmIdModelIdPatch(requestParameters.firmId, requestParameters.modelId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a model. Returns a `modelId`
         * @summary Create model
         * @param {ModelManagementApiModelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelPost(requestParameters: ModelManagementApiModelPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ModelPost201Response> {
            return localVarFp.modelPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for modelFirmIdGet operation in ModelManagementApi.
 * @export
 * @interface ModelManagementApiModelFirmIdGetRequest
 */
export interface ModelManagementApiModelFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {number}
     * @memberof ModelManagementApiModelFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof ModelManagementApiModelFirmIdGet
     */
    readonly page?: number
}

/**
 * Request parameters for modelFirmIdModelIdGet operation in ModelManagementApi.
 * @export
 * @interface ModelManagementApiModelFirmIdModelIdGetRequest
 */
export interface ModelManagementApiModelFirmIdModelIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdGet
     */
    readonly modelId: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for modelFirmIdModelIdPatch operation in ModelManagementApi.
 * @export
 * @interface ModelManagementApiModelFirmIdModelIdPatchRequest
 */
export interface ModelManagementApiModelFirmIdModelIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdPatch
     */
    readonly modelId: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelFirmIdModelIdPatch
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {UpdateModel}
     * @memberof ModelManagementApiModelFirmIdModelIdPatch
     */
    readonly updateModel?: UpdateModel
}

/**
 * Request parameters for modelPost operation in ModelManagementApi.
 * @export
 * @interface ModelManagementApiModelPostRequest
 */
export interface ModelManagementApiModelPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof ModelManagementApiModelPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreateModel}
     * @memberof ModelManagementApiModelPost
     */
    readonly createModel?: CreateModel
}

/**
 * ModelManagementApi - object-oriented interface
 * @export
 * @class ModelManagementApi
 * @extends {BaseAPI}
 */
export class ModelManagementApi extends BaseAPI {
    /**
     * Retrieves a list of models for a firm Returns an array of the `model` object.
     * @summary List models
     * @param {ModelManagementApiModelFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelManagementApi
     */
    public modelFirmIdGet(requestParameters: ModelManagementApiModelFirmIdGetRequest, options?: AxiosRequestConfig) {
        return ModelManagementApiFp(this.configuration).modelFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.pageSize, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific model. Returns the `models` object.
     * @summary Retrieve model
     * @param {ModelManagementApiModelFirmIdModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelManagementApi
     */
    public modelFirmIdModelIdGet(requestParameters: ModelManagementApiModelFirmIdModelIdGetRequest, options?: AxiosRequestConfig) {
        return ModelManagementApiFp(this.configuration).modelFirmIdModelIdGet(requestParameters.firmId, requestParameters.modelId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a model. Returns the `models` object.  **Please note the following:**  *   Assets must have a status of \'Active\' to be included in the model. *   You cannot change the product types for a model. In order to do this, you must create a new model and add in your chosen wrapper types in the `productType` field.
     * @summary Update model
     * @param {ModelManagementApiModelFirmIdModelIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelManagementApi
     */
    public modelFirmIdModelIdPatch(requestParameters: ModelManagementApiModelFirmIdModelIdPatchRequest, options?: AxiosRequestConfig) {
        return ModelManagementApiFp(this.configuration).modelFirmIdModelIdPatch(requestParameters.firmId, requestParameters.modelId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a model. Returns a `modelId`
     * @summary Create model
     * @param {ModelManagementApiModelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelManagementApi
     */
    public modelPost(requestParameters: ModelManagementApiModelPostRequest = {}, options?: AxiosRequestConfig) {
        return ModelManagementApiFp(this.configuration).modelPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NodeSwitchApi - axios parameter creator
 * @export
 */
export const NodeSwitchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch the status of a node switch batch
         * @param {string} firmId 
         * @param {string} batchId 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClientNodeFirmIdBatchIdGet: async (firmId: string, batchId: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('v1ClientNodeFirmIdBatchIdGet', 'firmId', firmId)
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('v1ClientNodeFirmIdBatchIdGet', 'batchId', batchId)
            const localVarPath = `/v1/client/node/{firmId}/{batchId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates and moves clients from one node to another.  This is an asynchronous operation, and the response will contain  a batchId that can be used to check the status of the operation.
         * @summary Requests a node switch for clients
         * @param {string} firmId 
         * @param {V1ClientNodeFirmIdPatchRequest} v1ClientNodeFirmIdPatchRequest 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClientNodeFirmIdPatch: async (firmId: string, v1ClientNodeFirmIdPatchRequest: V1ClientNodeFirmIdPatchRequest, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('v1ClientNodeFirmIdPatch', 'firmId', firmId)
            // verify required parameter 'v1ClientNodeFirmIdPatchRequest' is not null or undefined
            assertParamExists('v1ClientNodeFirmIdPatch', 'v1ClientNodeFirmIdPatchRequest', v1ClientNodeFirmIdPatchRequest)
            const localVarPath = `/v1/client/node/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(v1ClientNodeFirmIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeSwitchApi - functional programming interface
 * @export
 */
export const NodeSwitchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeSwitchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Fetch the status of a node switch batch
         * @param {string} firmId 
         * @param {string} batchId 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1ClientNodeFirmIdBatchIdGet(firmId: string, batchId: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClientNodeFirmIdBatchIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1ClientNodeFirmIdBatchIdGet(firmId, batchId, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validates and moves clients from one node to another.  This is an asynchronous operation, and the response will contain  a batchId that can be used to check the status of the operation.
         * @summary Requests a node switch for clients
         * @param {string} firmId 
         * @param {V1ClientNodeFirmIdPatchRequest} v1ClientNodeFirmIdPatchRequest 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1ClientNodeFirmIdPatch(firmId: string, v1ClientNodeFirmIdPatchRequest: V1ClientNodeFirmIdPatchRequest, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ClientNodeFirmIdPatch202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1ClientNodeFirmIdPatch(firmId, v1ClientNodeFirmIdPatchRequest, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NodeSwitchApi - factory interface
 * @export
 */
export const NodeSwitchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeSwitchApiFp(configuration)
    return {
        /**
         * 
         * @summary Fetch the status of a node switch batch
         * @param {NodeSwitchApiV1ClientNodeFirmIdBatchIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClientNodeFirmIdBatchIdGet(requestParameters: NodeSwitchApiV1ClientNodeFirmIdBatchIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<V1ClientNodeFirmIdBatchIdGet200Response> {
            return localVarFp.v1ClientNodeFirmIdBatchIdGet(requestParameters.firmId, requestParameters.batchId, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates and moves clients from one node to another.  This is an asynchronous operation, and the response will contain  a batchId that can be used to check the status of the operation.
         * @summary Requests a node switch for clients
         * @param {NodeSwitchApiV1ClientNodeFirmIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClientNodeFirmIdPatch(requestParameters: NodeSwitchApiV1ClientNodeFirmIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<V1ClientNodeFirmIdPatch202Response> {
            return localVarFp.v1ClientNodeFirmIdPatch(requestParameters.firmId, requestParameters.v1ClientNodeFirmIdPatchRequest, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v1ClientNodeFirmIdBatchIdGet operation in NodeSwitchApi.
 * @export
 * @interface NodeSwitchApiV1ClientNodeFirmIdBatchIdGetRequest
 */
export interface NodeSwitchApiV1ClientNodeFirmIdBatchIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeSwitchApiV1ClientNodeFirmIdBatchIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof NodeSwitchApiV1ClientNodeFirmIdBatchIdGet
     */
    readonly batchId: string

    /**
     * 
     * @type {string}
     * @memberof NodeSwitchApiV1ClientNodeFirmIdBatchIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for v1ClientNodeFirmIdPatch operation in NodeSwitchApi.
 * @export
 * @interface NodeSwitchApiV1ClientNodeFirmIdPatchRequest
 */
export interface NodeSwitchApiV1ClientNodeFirmIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeSwitchApiV1ClientNodeFirmIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {V1ClientNodeFirmIdPatchRequest}
     * @memberof NodeSwitchApiV1ClientNodeFirmIdPatch
     */
    readonly v1ClientNodeFirmIdPatchRequest: V1ClientNodeFirmIdPatchRequest

    /**
     * 
     * @type {string}
     * @memberof NodeSwitchApiV1ClientNodeFirmIdPatch
     */
    readonly apiToken?: string
}

/**
 * NodeSwitchApi - object-oriented interface
 * @export
 * @class NodeSwitchApi
 * @extends {BaseAPI}
 */
export class NodeSwitchApi extends BaseAPI {
    /**
     * 
     * @summary Fetch the status of a node switch batch
     * @param {NodeSwitchApiV1ClientNodeFirmIdBatchIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeSwitchApi
     */
    public v1ClientNodeFirmIdBatchIdGet(requestParameters: NodeSwitchApiV1ClientNodeFirmIdBatchIdGetRequest, options?: AxiosRequestConfig) {
        return NodeSwitchApiFp(this.configuration).v1ClientNodeFirmIdBatchIdGet(requestParameters.firmId, requestParameters.batchId, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates and moves clients from one node to another.  This is an asynchronous operation, and the response will contain  a batchId that can be used to check the status of the operation.
     * @summary Requests a node switch for clients
     * @param {NodeSwitchApiV1ClientNodeFirmIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeSwitchApi
     */
    public v1ClientNodeFirmIdPatch(requestParameters: NodeSwitchApiV1ClientNodeFirmIdPatchRequest, options?: AxiosRequestConfig) {
        return NodeSwitchApiFp(this.configuration).v1ClientNodeFirmIdPatch(requestParameters.firmId, requestParameters.v1ClientNodeFirmIdPatchRequest, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NodesApi - axios parameter creator
 * @export
 */
export const NodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This request retrieves all node records from your platform.  The response only returns nodes that sit below the individual user requesting them. For example, if the user is assigned to `nodeId` 1, the request returns details of `nodeId` 1 and any nodes below it. When you create a client, you will need to specify the relevant node. This means that the client record is attached to that node, and all investment accounts and transactions attributed to that client are also attached to that node.  When you create a user, you\'ll also need to specify the relevant node. The user then has access to the data and functionality of clients attached to that node, and those attached to nodes below. We will create and update nodes for your platform.
         * @summary Retrieve firm nodes
         * @param {string} firmId Id of the firm
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [parentNodeId] The parent node ID
         * @param {string} [nodeType] The node type
         * @param {string} [name] Name of the node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmNodeListFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, parentNodeId?: string, nodeType?: string, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('firmNodeListFirmIdGet', 'firmId', firmId)
            const localVarPath = `/firm/node/list/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (parentNodeId !== undefined) {
                localVarQueryParameter['parentNodeId'] = parentNodeId;
            }

            if (nodeType !== undefined) {
                localVarQueryParameter['nodeType'] = nodeType;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodesApi - functional programming interface
 * @export
 */
export const NodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodesApiAxiosParamCreator(configuration)
    return {
        /**
         * This request retrieves all node records from your platform.  The response only returns nodes that sit below the individual user requesting them. For example, if the user is assigned to `nodeId` 1, the request returns details of `nodeId` 1 and any nodes below it. When you create a client, you will need to specify the relevant node. This means that the client record is attached to that node, and all investment accounts and transactions attributed to that client are also attached to that node.  When you create a user, you\'ll also need to specify the relevant node. The user then has access to the data and functionality of clients attached to that node, and those attached to nodes below. We will create and update nodes for your platform.
         * @summary Retrieve firm nodes
         * @param {string} firmId Id of the firm
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [parentNodeId] The parent node ID
         * @param {string} [nodeType] The node type
         * @param {string} [name] Name of the node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firmNodeListFirmIdGet(firmId: string, contentType?: string, apiToken?: string, parentNodeId?: string, nodeType?: string, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firmNodeListFirmIdGet(firmId, contentType, apiToken, parentNodeId, nodeType, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NodesApi - factory interface
 * @export
 */
export const NodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodesApiFp(configuration)
    return {
        /**
         * This request retrieves all node records from your platform.  The response only returns nodes that sit below the individual user requesting them. For example, if the user is assigned to `nodeId` 1, the request returns details of `nodeId` 1 and any nodes below it. When you create a client, you will need to specify the relevant node. This means that the client record is attached to that node, and all investment accounts and transactions attributed to that client are also attached to that node.  When you create a user, you\'ll also need to specify the relevant node. The user then has access to the data and functionality of clients attached to that node, and those attached to nodes below. We will create and update nodes for your platform.
         * @summary Retrieve firm nodes
         * @param {NodesApiFirmNodeListFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firmNodeListFirmIdGet(requestParameters: NodesApiFirmNodeListFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetNode> {
            return localVarFp.firmNodeListFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.parentNodeId, requestParameters.nodeType, requestParameters.name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for firmNodeListFirmIdGet operation in NodesApi.
 * @export
 * @interface NodesApiFirmNodeListFirmIdGetRequest
 */
export interface NodesApiFirmNodeListFirmIdGetRequest {
    /**
     * Id of the firm
     * @type {string}
     * @memberof NodesApiFirmNodeListFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof NodesApiFirmNodeListFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof NodesApiFirmNodeListFirmIdGet
     */
    readonly apiToken?: string

    /**
     * The parent node ID
     * @type {string}
     * @memberof NodesApiFirmNodeListFirmIdGet
     */
    readonly parentNodeId?: string

    /**
     * The node type
     * @type {string}
     * @memberof NodesApiFirmNodeListFirmIdGet
     */
    readonly nodeType?: string

    /**
     * Name of the node
     * @type {string}
     * @memberof NodesApiFirmNodeListFirmIdGet
     */
    readonly name?: string
}

/**
 * NodesApi - object-oriented interface
 * @export
 * @class NodesApi
 * @extends {BaseAPI}
 */
export class NodesApi extends BaseAPI {
    /**
     * This request retrieves all node records from your platform.  The response only returns nodes that sit below the individual user requesting them. For example, if the user is assigned to `nodeId` 1, the request returns details of `nodeId` 1 and any nodes below it. When you create a client, you will need to specify the relevant node. This means that the client record is attached to that node, and all investment accounts and transactions attributed to that client are also attached to that node.  When you create a user, you\'ll also need to specify the relevant node. The user then has access to the data and functionality of clients attached to that node, and those attached to nodes below. We will create and update nodes for your platform.
     * @summary Retrieve firm nodes
     * @param {NodesApiFirmNodeListFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    public firmNodeListFirmIdGet(requestParameters: NodesApiFirmNodeListFirmIdGetRequest, options?: AxiosRequestConfig) {
        return NodesApiFp(this.configuration).firmNodeListFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.parentNodeId, requestParameters.nodeType, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This updates the status of a notification.  This should be used once the notification has been investigated and actioned by the platform operations team.  #### Parameters  * * *  `exceptionAction` enum value **Required**  | **Enum value** | **Description** | | --- | --- | | Close | Closes the exception | | Reprocess | Attempts to reprocess the initial instruction. This should be used after the issue is resolved. If a notification is reprocessed and the error persists, it will generate a new exception notification |  * * *  `actionReason` string **Required**  This field should be used to add narrative around why the exception is closed or reprocessed  * * *
         * @summary Action a notification
         * @param {string} firmId 
         * @param {string} notificationId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exceptionactionFirmIdNotificationIdPut: async (firmId: string, notificationId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('exceptionactionFirmIdNotificationIdPut', 'firmId', firmId)
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('exceptionactionFirmIdNotificationIdPut', 'notificationId', notificationId)
            const localVarPath = `/exceptionaction/{firmId}/{notificationId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve ISA allowance exception
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [notificationType] The type of notification. This should be set to &#x60;Exception&#x60;
         * @param {string} [status] The status of the exception
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, notificationType?: string, status?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('notificationFirmIdGet', 'firmId', firmId)
            const localVarPath = `/notification/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (notificationType !== undefined) {
                localVarQueryParameter['notificationType'] = notificationType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This retrieves a single notification.
         * @summary Retrieve a notification
         * @param {string} firmId 
         * @param {string} notificationId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationFirmIdNotificationIdGet: async (firmId: string, notificationId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('notificationFirmIdNotificationIdGet', 'firmId', firmId)
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('notificationFirmIdNotificationIdGet', 'notificationId', notificationId)
            const localVarPath = `/notification/{firmId}/{notificationId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * This updates the status of a notification.  This should be used once the notification has been investigated and actioned by the platform operations team.  #### Parameters  * * *  `exceptionAction` enum value **Required**  | **Enum value** | **Description** | | --- | --- | | Close | Closes the exception | | Reprocess | Attempts to reprocess the initial instruction. This should be used after the issue is resolved. If a notification is reprocessed and the error persists, it will generate a new exception notification |  * * *  `actionReason` string **Required**  This field should be used to add narrative around why the exception is closed or reprocessed  * * *
         * @summary Action a notification
         * @param {string} firmId 
         * @param {string} notificationId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exceptionactionFirmIdNotificationIdPut(firmId: string, notificationId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exceptionactionFirmIdNotificationIdPut(firmId, notificationId, apiToken, contentType, idempotencyKey, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve ISA allowance exception
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [notificationType] The type of notification. This should be set to &#x60;Exception&#x60;
         * @param {string} [status] The status of the exception
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationFirmIdGet(firmId: string, contentType?: string, apiToken?: string, notificationType?: string, status?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationFirmIdGet(firmId, contentType, apiToken, notificationType, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This retrieves a single notification.
         * @summary Retrieve a notification
         * @param {string} firmId 
         * @param {string} notificationId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationFirmIdNotificationIdGet(firmId: string, notificationId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationFirmIdNotificationIdGet(firmId, notificationId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * This updates the status of a notification.  This should be used once the notification has been investigated and actioned by the platform operations team.  #### Parameters  * * *  `exceptionAction` enum value **Required**  | **Enum value** | **Description** | | --- | --- | | Close | Closes the exception | | Reprocess | Attempts to reprocess the initial instruction. This should be used after the issue is resolved. If a notification is reprocessed and the error persists, it will generate a new exception notification |  * * *  `actionReason` string **Required**  This field should be used to add narrative around why the exception is closed or reprocessed  * * *
         * @summary Action a notification
         * @param {NotificationsApiExceptionactionFirmIdNotificationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exceptionactionFirmIdNotificationIdPut(requestParameters: NotificationsApiExceptionactionFirmIdNotificationIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exceptionactionFirmIdNotificationIdPut(requestParameters.firmId, requestParameters.notificationId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve ISA allowance exception
         * @param {NotificationsApiNotificationFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationFirmIdGet(requestParameters: NotificationsApiNotificationFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.notificationType, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * This retrieves a single notification.
         * @summary Retrieve a notification
         * @param {NotificationsApiNotificationFirmIdNotificationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationFirmIdNotificationIdGet(requestParameters: NotificationsApiNotificationFirmIdNotificationIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationFirmIdNotificationIdGet(requestParameters.firmId, requestParameters.notificationId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for exceptionactionFirmIdNotificationIdPut operation in NotificationsApi.
 * @export
 * @interface NotificationsApiExceptionactionFirmIdNotificationIdPutRequest
 */
export interface NotificationsApiExceptionactionFirmIdNotificationIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsApiExceptionactionFirmIdNotificationIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiExceptionactionFirmIdNotificationIdPut
     */
    readonly notificationId: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiExceptionactionFirmIdNotificationIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiExceptionactionFirmIdNotificationIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiExceptionactionFirmIdNotificationIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiExceptionactionFirmIdNotificationIdPut
     */
    readonly body?: string
}

/**
 * Request parameters for notificationFirmIdGet operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationFirmIdGetRequest
 */
export interface NotificationsApiNotificationFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdGet
     */
    readonly apiToken?: string

    /**
     * The type of notification. This should be set to &#x60;Exception&#x60;
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdGet
     */
    readonly notificationType?: string

    /**
     * The status of the exception
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdGet
     */
    readonly status?: string
}

/**
 * Request parameters for notificationFirmIdNotificationIdGet operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationFirmIdNotificationIdGetRequest
 */
export interface NotificationsApiNotificationFirmIdNotificationIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdNotificationIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdNotificationIdGet
     */
    readonly notificationId: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdNotificationIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiNotificationFirmIdNotificationIdGet
     */
    readonly apiToken?: string
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * This updates the status of a notification.  This should be used once the notification has been investigated and actioned by the platform operations team.  #### Parameters  * * *  `exceptionAction` enum value **Required**  | **Enum value** | **Description** | | --- | --- | | Close | Closes the exception | | Reprocess | Attempts to reprocess the initial instruction. This should be used after the issue is resolved. If a notification is reprocessed and the error persists, it will generate a new exception notification |  * * *  `actionReason` string **Required**  This field should be used to add narrative around why the exception is closed or reprocessed  * * *
     * @summary Action a notification
     * @param {NotificationsApiExceptionactionFirmIdNotificationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public exceptionactionFirmIdNotificationIdPut(requestParameters: NotificationsApiExceptionactionFirmIdNotificationIdPutRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).exceptionactionFirmIdNotificationIdPut(requestParameters.firmId, requestParameters.notificationId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve ISA allowance exception
     * @param {NotificationsApiNotificationFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationFirmIdGet(requestParameters: NotificationsApiNotificationFirmIdGetRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.notificationType, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This retrieves a single notification.
     * @summary Retrieve a notification
     * @param {NotificationsApiNotificationFirmIdNotificationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationFirmIdNotificationIdGet(requestParameters: NotificationsApiNotificationFirmIdNotificationIdGetRequest, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationFirmIdNotificationIdGet(requestParameters.firmId, requestParameters.notificationId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OutgoingWebhooksApi - axios parameter creator
 * @export
 */
export const OutgoingWebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * You can use the below PATCH request to [https://pfolio-api-staging.seccl.tech/webhook/config/position/.](https://pfolio-api-staging.seccl.tech/webhook/config/position/.) This will set up your webhook URL and secret:  ``` {     \"url\": \"\",     \"secret\": \"\" }  ```  Then, you will need to create an endpoint with the URL used for the above PATCH request, which accepts HTTP POSTs. The format of the data posted will be as follows:  ``` {   \"events\": [{     \"id\": \"000043J|C|GBP\",  // ID of the position     \"firmId\": \"{{firmId}}\",  // firm of the position     \"positionType\": \"Cash\", //  position type     \"accountId\": \"000043J\", // account of the position update     \"updateDate\": \"2019-05-04T10:06:31.047Z\" // date of the last update   }] }  ```  Once you receive one of these data POSTs, you can then use the ID to query the relevant position and process.  To validate the message, we will include a header field called `webhook-signature`. The data will be a hash of the body data sent above. This will be a HMAC SHA256 hash. E.g. in node.js, `const hash = crypto.createHmac(\'sha256\', \'secret\').update(\'body data as a string\').digest(\'hex\')`, where the secret is what was set up in point 1.
         * @summary Position webhook URL
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookConfigPositionFirmIdPatch: async (firmId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('webhookConfigPositionFirmIdPatch', 'firmId', firmId)
            const localVarPath = `/webhook/config/position/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * You can use the below PATCH request to [https://pfolio-api-staging.seccl.tech/webhook/config/transaction/](https://pfolio-api-staging.seccl.tech/webhook/config/transaction/) This will set up your webhook URL and secret:  ``` {     \"url\": \"\",     \"secret\": \"\" }  ```  Then, you can create an endpoint with the URL used for the above PATCH request, which accepts HTTP POSTs. The format of the data posted will be as follows:  ``` {   \"events\": [{     \"id\": \"000002LS6\",  // ID of the transaction     \"firmId\": \"{{firmId}}\",  // firm of the transaction     \"transactionType\": \"Payment\", //  transaction type     \"status\": \"Completed\", // current status of the transaction     \"updateDate\": \"2019-05-04T10:06:31.047Z\" // date of the last update   }] }  ```  Once you receive one of these data POSTs, you can then use the Id to query the relevant transaction and process.  To validate the message, we will include a header field called `webhook-signature`. The data will be a hash of the body data sent above. This will be a HMAC SHA256 hash. E.g. in node.js, `const hash = crypto.createHmac(\'sha256\', \'secret\').update(\'body data as a string\').digest(\'hex\')`, where the secret is what was set up in point 1.
         * @summary Transaction webhook URL
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookConfigTransactionFirmIdPatch: async (firmId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('webhookConfigTransactionFirmIdPatch', 'firmId', firmId)
            const localVarPath = `/webhook/config/transaction/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutgoingWebhooksApi - functional programming interface
 * @export
 */
export const OutgoingWebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutgoingWebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * You can use the below PATCH request to [https://pfolio-api-staging.seccl.tech/webhook/config/position/.](https://pfolio-api-staging.seccl.tech/webhook/config/position/.) This will set up your webhook URL and secret:  ``` {     \"url\": \"\",     \"secret\": \"\" }  ```  Then, you will need to create an endpoint with the URL used for the above PATCH request, which accepts HTTP POSTs. The format of the data posted will be as follows:  ``` {   \"events\": [{     \"id\": \"000043J|C|GBP\",  // ID of the position     \"firmId\": \"{{firmId}}\",  // firm of the position     \"positionType\": \"Cash\", //  position type     \"accountId\": \"000043J\", // account of the position update     \"updateDate\": \"2019-05-04T10:06:31.047Z\" // date of the last update   }] }  ```  Once you receive one of these data POSTs, you can then use the ID to query the relevant position and process.  To validate the message, we will include a header field called `webhook-signature`. The data will be a hash of the body data sent above. This will be a HMAC SHA256 hash. E.g. in node.js, `const hash = crypto.createHmac(\'sha256\', \'secret\').update(\'body data as a string\').digest(\'hex\')`, where the secret is what was set up in point 1.
         * @summary Position webhook URL
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookConfigPositionFirmIdPatch(firmId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookConfigPositionFirmIdPatch(firmId, contentType, apiToken, idempotencyKey, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * You can use the below PATCH request to [https://pfolio-api-staging.seccl.tech/webhook/config/transaction/](https://pfolio-api-staging.seccl.tech/webhook/config/transaction/) This will set up your webhook URL and secret:  ``` {     \"url\": \"\",     \"secret\": \"\" }  ```  Then, you can create an endpoint with the URL used for the above PATCH request, which accepts HTTP POSTs. The format of the data posted will be as follows:  ``` {   \"events\": [{     \"id\": \"000002LS6\",  // ID of the transaction     \"firmId\": \"{{firmId}}\",  // firm of the transaction     \"transactionType\": \"Payment\", //  transaction type     \"status\": \"Completed\", // current status of the transaction     \"updateDate\": \"2019-05-04T10:06:31.047Z\" // date of the last update   }] }  ```  Once you receive one of these data POSTs, you can then use the Id to query the relevant transaction and process.  To validate the message, we will include a header field called `webhook-signature`. The data will be a hash of the body data sent above. This will be a HMAC SHA256 hash. E.g. in node.js, `const hash = crypto.createHmac(\'sha256\', \'secret\').update(\'body data as a string\').digest(\'hex\')`, where the secret is what was set up in point 1.
         * @summary Transaction webhook URL
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookConfigTransactionFirmIdPatch(firmId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookConfigTransactionFirmIdPatch(firmId, contentType, apiToken, idempotencyKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OutgoingWebhooksApi - factory interface
 * @export
 */
export const OutgoingWebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutgoingWebhooksApiFp(configuration)
    return {
        /**
         * You can use the below PATCH request to [https://pfolio-api-staging.seccl.tech/webhook/config/position/.](https://pfolio-api-staging.seccl.tech/webhook/config/position/.) This will set up your webhook URL and secret:  ``` {     \"url\": \"\",     \"secret\": \"\" }  ```  Then, you will need to create an endpoint with the URL used for the above PATCH request, which accepts HTTP POSTs. The format of the data posted will be as follows:  ``` {   \"events\": [{     \"id\": \"000043J|C|GBP\",  // ID of the position     \"firmId\": \"{{firmId}}\",  // firm of the position     \"positionType\": \"Cash\", //  position type     \"accountId\": \"000043J\", // account of the position update     \"updateDate\": \"2019-05-04T10:06:31.047Z\" // date of the last update   }] }  ```  Once you receive one of these data POSTs, you can then use the ID to query the relevant position and process.  To validate the message, we will include a header field called `webhook-signature`. The data will be a hash of the body data sent above. This will be a HMAC SHA256 hash. E.g. in node.js, `const hash = crypto.createHmac(\'sha256\', \'secret\').update(\'body data as a string\').digest(\'hex\')`, where the secret is what was set up in point 1.
         * @summary Position webhook URL
         * @param {OutgoingWebhooksApiWebhookConfigPositionFirmIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookConfigPositionFirmIdPatch(requestParameters: OutgoingWebhooksApiWebhookConfigPositionFirmIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webhookConfigPositionFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * You can use the below PATCH request to [https://pfolio-api-staging.seccl.tech/webhook/config/transaction/](https://pfolio-api-staging.seccl.tech/webhook/config/transaction/) This will set up your webhook URL and secret:  ``` {     \"url\": \"\",     \"secret\": \"\" }  ```  Then, you can create an endpoint with the URL used for the above PATCH request, which accepts HTTP POSTs. The format of the data posted will be as follows:  ``` {   \"events\": [{     \"id\": \"000002LS6\",  // ID of the transaction     \"firmId\": \"{{firmId}}\",  // firm of the transaction     \"transactionType\": \"Payment\", //  transaction type     \"status\": \"Completed\", // current status of the transaction     \"updateDate\": \"2019-05-04T10:06:31.047Z\" // date of the last update   }] }  ```  Once you receive one of these data POSTs, you can then use the Id to query the relevant transaction and process.  To validate the message, we will include a header field called `webhook-signature`. The data will be a hash of the body data sent above. This will be a HMAC SHA256 hash. E.g. in node.js, `const hash = crypto.createHmac(\'sha256\', \'secret\').update(\'body data as a string\').digest(\'hex\')`, where the secret is what was set up in point 1.
         * @summary Transaction webhook URL
         * @param {OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookConfigTransactionFirmIdPatch(requestParameters: OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.webhookConfigTransactionFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for webhookConfigPositionFirmIdPatch operation in OutgoingWebhooksApi.
 * @export
 * @interface OutgoingWebhooksApiWebhookConfigPositionFirmIdPatchRequest
 */
export interface OutgoingWebhooksApiWebhookConfigPositionFirmIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigPositionFirmIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigPositionFirmIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigPositionFirmIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigPositionFirmIdPatch
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigPositionFirmIdPatch
     */
    readonly body?: string
}

/**
 * Request parameters for webhookConfigTransactionFirmIdPatch operation in OutgoingWebhooksApi.
 * @export
 * @interface OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatchRequest
 */
export interface OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatch
     */
    readonly idempotencyKey?: string
}

/**
 * OutgoingWebhooksApi - object-oriented interface
 * @export
 * @class OutgoingWebhooksApi
 * @extends {BaseAPI}
 */
export class OutgoingWebhooksApi extends BaseAPI {
    /**
     * You can use the below PATCH request to [https://pfolio-api-staging.seccl.tech/webhook/config/position/.](https://pfolio-api-staging.seccl.tech/webhook/config/position/.) This will set up your webhook URL and secret:  ``` {     \"url\": \"\",     \"secret\": \"\" }  ```  Then, you will need to create an endpoint with the URL used for the above PATCH request, which accepts HTTP POSTs. The format of the data posted will be as follows:  ``` {   \"events\": [{     \"id\": \"000043J|C|GBP\",  // ID of the position     \"firmId\": \"{{firmId}}\",  // firm of the position     \"positionType\": \"Cash\", //  position type     \"accountId\": \"000043J\", // account of the position update     \"updateDate\": \"2019-05-04T10:06:31.047Z\" // date of the last update   }] }  ```  Once you receive one of these data POSTs, you can then use the ID to query the relevant position and process.  To validate the message, we will include a header field called `webhook-signature`. The data will be a hash of the body data sent above. This will be a HMAC SHA256 hash. E.g. in node.js, `const hash = crypto.createHmac(\'sha256\', \'secret\').update(\'body data as a string\').digest(\'hex\')`, where the secret is what was set up in point 1.
     * @summary Position webhook URL
     * @param {OutgoingWebhooksApiWebhookConfigPositionFirmIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutgoingWebhooksApi
     */
    public webhookConfigPositionFirmIdPatch(requestParameters: OutgoingWebhooksApiWebhookConfigPositionFirmIdPatchRequest, options?: AxiosRequestConfig) {
        return OutgoingWebhooksApiFp(this.configuration).webhookConfigPositionFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * You can use the below PATCH request to [https://pfolio-api-staging.seccl.tech/webhook/config/transaction/](https://pfolio-api-staging.seccl.tech/webhook/config/transaction/) This will set up your webhook URL and secret:  ``` {     \"url\": \"\",     \"secret\": \"\" }  ```  Then, you can create an endpoint with the URL used for the above PATCH request, which accepts HTTP POSTs. The format of the data posted will be as follows:  ``` {   \"events\": [{     \"id\": \"000002LS6\",  // ID of the transaction     \"firmId\": \"{{firmId}}\",  // firm of the transaction     \"transactionType\": \"Payment\", //  transaction type     \"status\": \"Completed\", // current status of the transaction     \"updateDate\": \"2019-05-04T10:06:31.047Z\" // date of the last update   }] }  ```  Once you receive one of these data POSTs, you can then use the Id to query the relevant transaction and process.  To validate the message, we will include a header field called `webhook-signature`. The data will be a hash of the body data sent above. This will be a HMAC SHA256 hash. E.g. in node.js, `const hash = crypto.createHmac(\'sha256\', \'secret\').update(\'body data as a string\').digest(\'hex\')`, where the secret is what was set up in point 1.
     * @summary Transaction webhook URL
     * @param {OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutgoingWebhooksApi
     */
    public webhookConfigTransactionFirmIdPatch(requestParameters: OutgoingWebhooksApiWebhookConfigTransactionFirmIdPatchRequest, options?: AxiosRequestConfig) {
        return OutgoingWebhooksApiFp(this.configuration).webhookConfigTransactionFirmIdPatch(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlatformUserManagementApi - axios parameter creator
 * @export
 */
export const PlatformUserManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This flow retrieves all user records, and returns all user objects.
         * @summary List firm users
         * @param {string} firmId Id of the firm
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFirmIdGet: async (firmId: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('userFirmIdGet', 'firmId', firmId)
            const localVarPath = `/user/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This request retrieves an individual platform user with discretionary (DFM) permissions using the `userId`.  Returns the body of the `user` otherwise known as the decision maker.
         * @summary Retrieve a firm user
         * @param {string} firmId Id of the firm
         * @param {string} userId The unique identifier for the user
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFirmIdUserIdGet: async (firmId: string, userId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('userFirmIdUserIdGet', 'firmId', firmId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userFirmIdUserIdGet', 'userId', userId)
            const localVarPath = `/user/{firmId}/{userId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This flow allows you to update the record of a user, and returns a successful array.  You can retrieve the latest `updateId` by performing a `GET` request on the relevant to be updated. Multiple fields can be updated at once. If the field to be updated is an array, the whole array will be overwritten.
         * @summary Update firm user
         * @param {string} firmId Id of the firm
         * @param {string} userId The unique identifier of the user
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateUser} [updateUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFirmIdUserIdPut: async (firmId: string, userId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateUser?: UpdateUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('userFirmIdUserIdPut', 'firmId', firmId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userFirmIdUserIdPut', 'userId', userId)
            const localVarPath = `/user/{firmId}/{userId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resets all multifactor authorisations for a user. They will be required to re-enroll on next login.
         * @summary Delete all MFA factors for a user
         * @param {string} firmId Id of the firm
         * @param {string} userId The unique identifier for the user
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMfaFirmIdUserIdDelete: async (firmId: string, userId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('userMfaFirmIdUserIdDelete', 'firmId', firmId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userMfaFirmIdUserIdDelete', 'userId', userId)
            const localVarPath = `/user/mfa/{firmId}/{userId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This flow creates an individual platform user. The request returns the userId. Returns the `userId`.
         * @summary Create a user
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateUser} [createUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, createUser?: CreateUser, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlatformUserManagementApi - functional programming interface
 * @export
 */
export const PlatformUserManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlatformUserManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * This flow retrieves all user records, and returns all user objects.
         * @summary List firm users
         * @param {string} firmId Id of the firm
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFirmIdGet(firmId: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFirmIdGet(firmId, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This request retrieves an individual platform user with discretionary (DFM) permissions using the `userId`.  Returns the body of the `user` otherwise known as the decision maker.
         * @summary Retrieve a firm user
         * @param {string} firmId Id of the firm
         * @param {string} userId The unique identifier for the user
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFirmIdUserIdGet(firmId: string, userId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFirmIdUserIdGet(firmId, userId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This flow allows you to update the record of a user, and returns a successful array.  You can retrieve the latest `updateId` by performing a `GET` request on the relevant to be updated. Multiple fields can be updated at once. If the field to be updated is an array, the whole array will be overwritten.
         * @summary Update firm user
         * @param {string} firmId Id of the firm
         * @param {string} userId The unique identifier of the user
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateUser} [updateUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFirmIdUserIdPut(firmId: string, userId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, updateUser?: UpdateUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFirmIdUserIdPut(firmId, userId, contentType, apiToken, idempotencyKey, updateUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resets all multifactor authorisations for a user. They will be required to re-enroll on next login.
         * @summary Delete all MFA factors for a user
         * @param {string} firmId Id of the firm
         * @param {string} userId The unique identifier for the user
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userMfaFirmIdUserIdDelete(firmId: string, userId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userMfaFirmIdUserIdDelete(firmId, userId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This flow creates an individual platform user. The request returns the userId. Returns the `userId`.
         * @summary Create a user
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateUser} [createUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPost(contentType?: string, apiToken?: string, idempotencyKey?: string, createUser?: CreateUser, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPost(contentType, apiToken, idempotencyKey, createUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlatformUserManagementApi - factory interface
 * @export
 */
export const PlatformUserManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlatformUserManagementApiFp(configuration)
    return {
        /**
         * This flow retrieves all user records, and returns all user objects.
         * @summary List firm users
         * @param {PlatformUserManagementApiUserFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFirmIdGet(requestParameters: PlatformUserManagementApiUserFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserList> {
            return localVarFp.userFirmIdGet(requestParameters.firmId, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This request retrieves an individual platform user with discretionary (DFM) permissions using the `userId`.  Returns the body of the `user` otherwise known as the decision maker.
         * @summary Retrieve a firm user
         * @param {PlatformUserManagementApiUserFirmIdUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFirmIdUserIdGet(requestParameters: PlatformUserManagementApiUserFirmIdUserIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetUser> {
            return localVarFp.userFirmIdUserIdGet(requestParameters.firmId, requestParameters.userId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This flow allows you to update the record of a user, and returns a successful array.  You can retrieve the latest `updateId` by performing a `GET` request on the relevant to be updated. Multiple fields can be updated at once. If the field to be updated is an array, the whole array will be overwritten.
         * @summary Update firm user
         * @param {PlatformUserManagementApiUserFirmIdUserIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFirmIdUserIdPut(requestParameters: PlatformUserManagementApiUserFirmIdUserIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<EmptyResponse> {
            return localVarFp.userFirmIdUserIdPut(requestParameters.firmId, requestParameters.userId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Resets all multifactor authorisations for a user. They will be required to re-enroll on next login.
         * @summary Delete all MFA factors for a user
         * @param {PlatformUserManagementApiUserMfaFirmIdUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMfaFirmIdUserIdDelete(requestParameters: PlatformUserManagementApiUserMfaFirmIdUserIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<EmptyResponse> {
            return localVarFp.userMfaFirmIdUserIdDelete(requestParameters.firmId, requestParameters.userId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This flow creates an individual platform user. The request returns the userId. Returns the `userId`.
         * @summary Create a user
         * @param {PlatformUserManagementApiUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPost(requestParameters: PlatformUserManagementApiUserPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<CreateUserResponse> {
            return localVarFp.userPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for userFirmIdGet operation in PlatformUserManagementApi.
 * @export
 * @interface PlatformUserManagementApiUserFirmIdGetRequest
 */
export interface PlatformUserManagementApiUserFirmIdGetRequest {
    /**
     * Id of the firm
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for userFirmIdUserIdGet operation in PlatformUserManagementApi.
 * @export
 * @interface PlatformUserManagementApiUserFirmIdUserIdGetRequest
 */
export interface PlatformUserManagementApiUserFirmIdUserIdGetRequest {
    /**
     * Id of the firm
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdGet
     */
    readonly firmId: string

    /**
     * The unique identifier for the user
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for userFirmIdUserIdPut operation in PlatformUserManagementApi.
 * @export
 * @interface PlatformUserManagementApiUserFirmIdUserIdPutRequest
 */
export interface PlatformUserManagementApiUserFirmIdUserIdPutRequest {
    /**
     * Id of the firm
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdPut
     */
    readonly firmId: string

    /**
     * The unique identifier of the user
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdPut
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {UpdateUser}
     * @memberof PlatformUserManagementApiUserFirmIdUserIdPut
     */
    readonly updateUser?: UpdateUser
}

/**
 * Request parameters for userMfaFirmIdUserIdDelete operation in PlatformUserManagementApi.
 * @export
 * @interface PlatformUserManagementApiUserMfaFirmIdUserIdDeleteRequest
 */
export interface PlatformUserManagementApiUserMfaFirmIdUserIdDeleteRequest {
    /**
     * Id of the firm
     * @type {string}
     * @memberof PlatformUserManagementApiUserMfaFirmIdUserIdDelete
     */
    readonly firmId: string

    /**
     * The unique identifier for the user
     * @type {string}
     * @memberof PlatformUserManagementApiUserMfaFirmIdUserIdDelete
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserMfaFirmIdUserIdDelete
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserMfaFirmIdUserIdDelete
     */
    readonly apiToken?: string
}

/**
 * Request parameters for userPost operation in PlatformUserManagementApi.
 * @export
 * @interface PlatformUserManagementApiUserPostRequest
 */
export interface PlatformUserManagementApiUserPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PlatformUserManagementApiUserPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreateUser}
     * @memberof PlatformUserManagementApiUserPost
     */
    readonly createUser?: CreateUser
}

/**
 * PlatformUserManagementApi - object-oriented interface
 * @export
 * @class PlatformUserManagementApi
 * @extends {BaseAPI}
 */
export class PlatformUserManagementApi extends BaseAPI {
    /**
     * This flow retrieves all user records, and returns all user objects.
     * @summary List firm users
     * @param {PlatformUserManagementApiUserFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformUserManagementApi
     */
    public userFirmIdGet(requestParameters: PlatformUserManagementApiUserFirmIdGetRequest, options?: AxiosRequestConfig) {
        return PlatformUserManagementApiFp(this.configuration).userFirmIdGet(requestParameters.firmId, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This request retrieves an individual platform user with discretionary (DFM) permissions using the `userId`.  Returns the body of the `user` otherwise known as the decision maker.
     * @summary Retrieve a firm user
     * @param {PlatformUserManagementApiUserFirmIdUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformUserManagementApi
     */
    public userFirmIdUserIdGet(requestParameters: PlatformUserManagementApiUserFirmIdUserIdGetRequest, options?: AxiosRequestConfig) {
        return PlatformUserManagementApiFp(this.configuration).userFirmIdUserIdGet(requestParameters.firmId, requestParameters.userId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This flow allows you to update the record of a user, and returns a successful array.  You can retrieve the latest `updateId` by performing a `GET` request on the relevant to be updated. Multiple fields can be updated at once. If the field to be updated is an array, the whole array will be overwritten.
     * @summary Update firm user
     * @param {PlatformUserManagementApiUserFirmIdUserIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformUserManagementApi
     */
    public userFirmIdUserIdPut(requestParameters: PlatformUserManagementApiUserFirmIdUserIdPutRequest, options?: AxiosRequestConfig) {
        return PlatformUserManagementApiFp(this.configuration).userFirmIdUserIdPut(requestParameters.firmId, requestParameters.userId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resets all multifactor authorisations for a user. They will be required to re-enroll on next login.
     * @summary Delete all MFA factors for a user
     * @param {PlatformUserManagementApiUserMfaFirmIdUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformUserManagementApi
     */
    public userMfaFirmIdUserIdDelete(requestParameters: PlatformUserManagementApiUserMfaFirmIdUserIdDeleteRequest, options?: AxiosRequestConfig) {
        return PlatformUserManagementApiFp(this.configuration).userMfaFirmIdUserIdDelete(requestParameters.firmId, requestParameters.userId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This flow creates an individual platform user. The request returns the userId. Returns the `userId`.
     * @summary Create a user
     * @param {PlatformUserManagementApiUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformUserManagementApi
     */
    public userPost(requestParameters: PlatformUserManagementApiUserPostRequest = {}, options?: AxiosRequestConfig) {
        return PlatformUserManagementApiFp(this.configuration).userPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createUser, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PortfolioGroupManagementApi - axios parameter creator
 * @export
 */
export const PortfolioGroupManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a list of fee covered accounts for a client group.
         * @summary Get Fee Covered Accounts
         * @param {string} firmId 
         * @param {string} portfolioGroupId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet: async (firmId: string, portfolioGroupId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet', 'firmId', firmId)
            // verify required parameter 'portfolioGroupId' is not null or undefined
            assertParamExists('portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet', 'portfolioGroupId', portfolioGroupId)
            const localVarPath = `/portfolioGroup/feecoveredaccounts/{firmId}/{portfolioGroupId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"portfolioGroupId"}}`, encodeURIComponent(String(portfolioGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a list of portfolio groups
         * @summary Retrieve the list of portfolio groups
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [groupIntent] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {string} [intentDetailsClientProductId] 
         * @param {string} [intentDetailsStatus] 
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, groupIntent?: string, page?: number, pageSize?: number, name?: string, id?: string, intentDetailsClientProductId?: string, intentDetailsStatus?: string, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioGroupFirmIdGet', 'firmId', firmId)
            const localVarPath = `/portfolioGroup/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (groupIntent !== undefined) {
                localVarQueryParameter['groupIntent'] = groupIntent;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (intentDetailsClientProductId !== undefined) {
                localVarQueryParameter['intentDetails[clientProductId]'] = intentDetailsClientProductId;
            }

            if (intentDetailsStatus !== undefined) {
                localVarQueryParameter['intentDetails[status]'] = intentDetailsStatus;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a specific group
         * @summary Retrieve a portfolio group
         * @param {string} firmId 
         * @param {string} id 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [groupIntent] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupFirmIdIdGet: async (firmId: string, id: string, contentType?: string, apiToken?: string, groupIntent?: string, page?: number, pageSize?: number, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioGroupFirmIdIdGet', 'firmId', firmId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('portfolioGroupFirmIdIdGet', 'id', id)
            const localVarPath = `/portfolioGroup/{firmId}/{id}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (groupIntent !== undefined) {
                localVarQueryParameter['groupIntent'] = groupIntent;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command patches a specific portfolio group
         * @summary Patch a portfolio group
         * @param {string} firmId 
         * @param {string} id 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {PatchClientFeeGroup} [patchClientFeeGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupFirmIdIdPatch: async (firmId: string, id: string, contentType?: string, apiToken?: string, idempotencyKey?: string, patchClientFeeGroup?: PatchClientFeeGroup, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioGroupFirmIdIdPatch', 'firmId', firmId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('portfolioGroupFirmIdIdPatch', 'id', id)
            const localVarPath = `/portfolioGroup/{firmId}/{id}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchClientFeeGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of nominatable accounts for a client group.
         * @summary Get Nominatable Accounts
         * @param {string} firmId 
         * @param {string} portfolioGroupId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet: async (firmId: string, portfolioGroupId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet', 'firmId', firmId)
            // verify required parameter 'portfolioGroupId' is not null or undefined
            assertParamExists('portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet', 'portfolioGroupId', portfolioGroupId)
            const localVarPath = `/portfolioGroup/nominatableaccounts/{firmId}/{portfolioGroupId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"portfolioGroupId"}}`, encodeURIComponent(String(portfolioGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command creates a portfolio group. A portfolio group is a an abstract grouping concept that can be used to for a number of purposes but always to link a set of other portfolio related data-structures together, the purpose is denoted by the `groupIntent` property. For example, a portfolio group with a `groupIntent` of \'Pension Account Group\' is used to link together different types of pension account within a single wrapper to ensure that securities are not moved between these groups in uncontrolled manners – securities from an account within an beneficiary group cannot be moved into any other group, securities from an uncrystallised group can only be moved to a crystallised group as part of a crystallisation event etc..
         * @summary Create a portfolio group
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateClientFeeGroup} [createClientFeeGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, createClientFeeGroup?: CreateClientFeeGroup, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolioGroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientFeeGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of fee structures for a client group.
         * @summary Get Fee structures for a firm
         * @param {string} firmId 
         * @param {'Adviser Fee' | 'Platform Fee'} type 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1FeeStructuresFirmIdGet: async (firmId: string, type: 'Adviser Fee' | 'Platform Fee', contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('v1FeeStructuresFirmIdGet', 'firmId', firmId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('v1FeeStructuresFirmIdGet', 'type', type)
            const localVarPath = `/v1/fee-structures/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioGroupManagementApi - functional programming interface
 * @export
 */
export const PortfolioGroupManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioGroupManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a list of fee covered accounts for a client group.
         * @summary Get Fee Covered Accounts
         * @param {string} firmId 
         * @param {string} portfolioGroupId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet(firmId: string, portfolioGroupId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioGroupFeeCoveredAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet(firmId, portfolioGroupId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a list of portfolio groups
         * @summary Retrieve the list of portfolio groups
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [groupIntent] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {string} [intentDetailsClientProductId] 
         * @param {string} [intentDetailsStatus] 
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioGroupFirmIdGet(firmId: string, contentType?: string, apiToken?: string, groupIntent?: string, page?: number, pageSize?: number, name?: string, id?: string, intentDetailsClientProductId?: string, intentDetailsStatus?: string, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfolioGroupList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioGroupFirmIdGet(firmId, contentType, apiToken, groupIntent, page, pageSize, name, id, intentDetailsClientProductId, intentDetailsStatus, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a specific group
         * @summary Retrieve a portfolio group
         * @param {string} firmId 
         * @param {string} id 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [groupIntent] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioGroupFirmIdIdGet(firmId: string, id: string, contentType?: string, apiToken?: string, groupIntent?: string, page?: number, pageSize?: number, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfolioGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioGroupFirmIdIdGet(firmId, id, contentType, apiToken, groupIntent, page, pageSize, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command patches a specific portfolio group
         * @summary Patch a portfolio group
         * @param {string} firmId 
         * @param {string} id 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {PatchClientFeeGroup} [patchClientFeeGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioGroupFirmIdIdPatch(firmId: string, id: string, contentType?: string, apiToken?: string, idempotencyKey?: string, patchClientFeeGroup?: PatchClientFeeGroup, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioGroupFirmIdIdPatch(firmId, id, contentType, apiToken, idempotencyKey, patchClientFeeGroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of nominatable accounts for a client group.
         * @summary Get Nominatable Accounts
         * @param {string} firmId 
         * @param {string} portfolioGroupId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet(firmId: string, portfolioGroupId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioGroupNominatedAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet(firmId, portfolioGroupId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command creates a portfolio group. A portfolio group is a an abstract grouping concept that can be used to for a number of purposes but always to link a set of other portfolio related data-structures together, the purpose is denoted by the `groupIntent` property. For example, a portfolio group with a `groupIntent` of \'Pension Account Group\' is used to link together different types of pension account within a single wrapper to ensure that securities are not moved between these groups in uncontrolled manners – securities from an account within an beneficiary group cannot be moved into any other group, securities from an uncrystallised group can only be moved to a crystallised group as part of a crystallisation event etc..
         * @summary Create a portfolio group
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateClientFeeGroup} [createClientFeeGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioGroupPost(contentType?: string, apiToken?: string, idempotencyKey?: string, createClientFeeGroup?: CreateClientFeeGroup, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioGroupPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioGroupPost(contentType, apiToken, idempotencyKey, createClientFeeGroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of fee structures for a client group.
         * @summary Get Fee structures for a firm
         * @param {string} firmId 
         * @param {'Adviser Fee' | 'Platform Fee'} type 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1FeeStructuresFirmIdGet(firmId: string, type: 'Adviser Fee' | 'Platform Fee', contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeeStructuresResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1FeeStructuresFirmIdGet(firmId, type, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortfolioGroupManagementApi - factory interface
 * @export
 */
export const PortfolioGroupManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioGroupManagementApiFp(configuration)
    return {
        /**
         * Retrieve a list of fee covered accounts for a client group.
         * @summary Get Fee Covered Accounts
         * @param {PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet(requestParameters: PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<PortfolioGroupFeeCoveredAccountsResponse> {
            return localVarFp.portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet(requestParameters.firmId, requestParameters.portfolioGroupId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a list of portfolio groups
         * @summary Retrieve the list of portfolio groups
         * @param {PortfolioGroupManagementApiPortfolioGroupFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupFirmIdGet(requestParameters: PortfolioGroupManagementApiPortfolioGroupFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetPortfolioGroupList> {
            return localVarFp.portfolioGroupFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.groupIntent, requestParameters.page, requestParameters.pageSize, requestParameters.name, requestParameters.id, requestParameters.intentDetailsClientProductId, requestParameters.intentDetailsStatus, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a specific group
         * @summary Retrieve a portfolio group
         * @param {PortfolioGroupManagementApiPortfolioGroupFirmIdIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupFirmIdIdGet(requestParameters: PortfolioGroupManagementApiPortfolioGroupFirmIdIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetPortfolioGroup> {
            return localVarFp.portfolioGroupFirmIdIdGet(requestParameters.firmId, requestParameters.id, requestParameters.contentType, requestParameters.apiToken, requestParameters.groupIntent, requestParameters.page, requestParameters.pageSize, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * This command patches a specific portfolio group
         * @summary Patch a portfolio group
         * @param {PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupFirmIdIdPatch(requestParameters: PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<PatchResponse> {
            return localVarFp.portfolioGroupFirmIdIdPatch(requestParameters.firmId, requestParameters.id, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.patchClientFeeGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of nominatable accounts for a client group.
         * @summary Get Nominatable Accounts
         * @param {PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet(requestParameters: PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<PortfolioGroupNominatedAccountsResponse> {
            return localVarFp.portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet(requestParameters.firmId, requestParameters.portfolioGroupId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This command creates a portfolio group. A portfolio group is a an abstract grouping concept that can be used to for a number of purposes but always to link a set of other portfolio related data-structures together, the purpose is denoted by the `groupIntent` property. For example, a portfolio group with a `groupIntent` of \'Pension Account Group\' is used to link together different types of pension account within a single wrapper to ensure that securities are not moved between these groups in uncontrolled manners – securities from an account within an beneficiary group cannot be moved into any other group, securities from an uncrystallised group can only be moved to a crystallised group as part of a crystallisation event etc..
         * @summary Create a portfolio group
         * @param {PortfolioGroupManagementApiPortfolioGroupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioGroupPost(requestParameters: PortfolioGroupManagementApiPortfolioGroupPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PortfolioGroupPost201Response> {
            return localVarFp.portfolioGroupPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createClientFeeGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of fee structures for a client group.
         * @summary Get Fee structures for a firm
         * @param {PortfolioGroupManagementApiV1FeeStructuresFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1FeeStructuresFirmIdGet(requestParameters: PortfolioGroupManagementApiV1FeeStructuresFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FeeStructuresResponse> {
            return localVarFp.v1FeeStructuresFirmIdGet(requestParameters.firmId, requestParameters.type, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet operation in PortfolioGroupManagementApi.
 * @export
 * @interface PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGetRequest
 */
export interface PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet
     */
    readonly portfolioGroupId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for portfolioGroupFirmIdGet operation in PortfolioGroupManagementApi.
 * @export
 * @interface PortfolioGroupManagementApiPortfolioGroupFirmIdGetRequest
 */
export interface PortfolioGroupManagementApiPortfolioGroupFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly groupIntent?: string

    /**
     * 
     * @type {number}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly intentDetailsClientProductId?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly intentDetailsStatus?: string

    /**
     * Comma-separated list of field:direction pairs (asc|desc)
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdGet
     */
    readonly sort?: string
}

/**
 * Request parameters for portfolioGroupFirmIdIdGet operation in PortfolioGroupManagementApi.
 * @export
 * @interface PortfolioGroupManagementApiPortfolioGroupFirmIdIdGetRequest
 */
export interface PortfolioGroupManagementApiPortfolioGroupFirmIdIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdGet
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdGet
     */
    readonly groupIntent?: string

    /**
     * 
     * @type {number}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdGet
     */
    readonly name?: string
}

/**
 * Request parameters for portfolioGroupFirmIdIdPatch operation in PortfolioGroupManagementApi.
 * @export
 * @interface PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatchRequest
 */
export interface PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatch
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatch
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatch
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatch
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatch
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {PatchClientFeeGroup}
     * @memberof PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatch
     */
    readonly patchClientFeeGroup?: PatchClientFeeGroup
}

/**
 * Request parameters for portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet operation in PortfolioGroupManagementApi.
 * @export
 * @interface PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGetRequest
 */
export interface PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet
     */
    readonly portfolioGroupId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for portfolioGroupPost operation in PortfolioGroupManagementApi.
 * @export
 * @interface PortfolioGroupManagementApiPortfolioGroupPostRequest
 */
export interface PortfolioGroupManagementApiPortfolioGroupPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiPortfolioGroupPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreateClientFeeGroup}
     * @memberof PortfolioGroupManagementApiPortfolioGroupPost
     */
    readonly createClientFeeGroup?: CreateClientFeeGroup
}

/**
 * Request parameters for v1FeeStructuresFirmIdGet operation in PortfolioGroupManagementApi.
 * @export
 * @interface PortfolioGroupManagementApiV1FeeStructuresFirmIdGetRequest
 */
export interface PortfolioGroupManagementApiV1FeeStructuresFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiV1FeeStructuresFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {'Adviser Fee' | 'Platform Fee'}
     * @memberof PortfolioGroupManagementApiV1FeeStructuresFirmIdGet
     */
    readonly type: 'Adviser Fee' | 'Platform Fee'

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiV1FeeStructuresFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioGroupManagementApiV1FeeStructuresFirmIdGet
     */
    readonly apiToken?: string
}

/**
 * PortfolioGroupManagementApi - object-oriented interface
 * @export
 * @class PortfolioGroupManagementApi
 * @extends {BaseAPI}
 */
export class PortfolioGroupManagementApi extends BaseAPI {
    /**
     * Retrieve a list of fee covered accounts for a client group.
     * @summary Get Fee Covered Accounts
     * @param {PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioGroupManagementApi
     */
    public portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet(requestParameters: PortfolioGroupManagementApiPortfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioGroupManagementApiFp(this.configuration).portfolioGroupFeecoveredaccountsFirmIdPortfolioGroupIdGet(requestParameters.firmId, requestParameters.portfolioGroupId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a list of portfolio groups
     * @summary Retrieve the list of portfolio groups
     * @param {PortfolioGroupManagementApiPortfolioGroupFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioGroupManagementApi
     */
    public portfolioGroupFirmIdGet(requestParameters: PortfolioGroupManagementApiPortfolioGroupFirmIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioGroupManagementApiFp(this.configuration).portfolioGroupFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.groupIntent, requestParameters.page, requestParameters.pageSize, requestParameters.name, requestParameters.id, requestParameters.intentDetailsClientProductId, requestParameters.intentDetailsStatus, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a specific group
     * @summary Retrieve a portfolio group
     * @param {PortfolioGroupManagementApiPortfolioGroupFirmIdIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioGroupManagementApi
     */
    public portfolioGroupFirmIdIdGet(requestParameters: PortfolioGroupManagementApiPortfolioGroupFirmIdIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioGroupManagementApiFp(this.configuration).portfolioGroupFirmIdIdGet(requestParameters.firmId, requestParameters.id, requestParameters.contentType, requestParameters.apiToken, requestParameters.groupIntent, requestParameters.page, requestParameters.pageSize, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command patches a specific portfolio group
     * @summary Patch a portfolio group
     * @param {PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioGroupManagementApi
     */
    public portfolioGroupFirmIdIdPatch(requestParameters: PortfolioGroupManagementApiPortfolioGroupFirmIdIdPatchRequest, options?: AxiosRequestConfig) {
        return PortfolioGroupManagementApiFp(this.configuration).portfolioGroupFirmIdIdPatch(requestParameters.firmId, requestParameters.id, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.patchClientFeeGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of nominatable accounts for a client group.
     * @summary Get Nominatable Accounts
     * @param {PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioGroupManagementApi
     */
    public portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet(requestParameters: PortfolioGroupManagementApiPortfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioGroupManagementApiFp(this.configuration).portfolioGroupNominatableaccountsFirmIdPortfolioGroupIdGet(requestParameters.firmId, requestParameters.portfolioGroupId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command creates a portfolio group. A portfolio group is a an abstract grouping concept that can be used to for a number of purposes but always to link a set of other portfolio related data-structures together, the purpose is denoted by the `groupIntent` property. For example, a portfolio group with a `groupIntent` of \'Pension Account Group\' is used to link together different types of pension account within a single wrapper to ensure that securities are not moved between these groups in uncontrolled manners – securities from an account within an beneficiary group cannot be moved into any other group, securities from an uncrystallised group can only be moved to a crystallised group as part of a crystallisation event etc..
     * @summary Create a portfolio group
     * @param {PortfolioGroupManagementApiPortfolioGroupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioGroupManagementApi
     */
    public portfolioGroupPost(requestParameters: PortfolioGroupManagementApiPortfolioGroupPostRequest = {}, options?: AxiosRequestConfig) {
        return PortfolioGroupManagementApiFp(this.configuration).portfolioGroupPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createClientFeeGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of fee structures for a client group.
     * @summary Get Fee structures for a firm
     * @param {PortfolioGroupManagementApiV1FeeStructuresFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioGroupManagementApi
     */
    public v1FeeStructuresFirmIdGet(requestParameters: PortfolioGroupManagementApiV1FeeStructuresFirmIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioGroupManagementApiFp(this.configuration).v1FeeStructuresFirmIdGet(requestParameters.firmId, requestParameters.type, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PortfolioTransactionManagementApi - axios parameter creator
 * @export
 */
export const PortfolioTransactionManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This command creates a transfer request and returns a `linkId.`  ---  **A note on the** **`isPensionTransfer`** **field**  This is a mandatory field. Please note, we will only accept transfers from pensions with Safeguarded Rights if a suitably qualified and authorised financial adviser has advised the client that the transfer is suitable for their personal circumstances.
         * @summary Create a transfer request for pension
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateTransfer} [createTransfer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioTransactionGroupPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, createTransfer?: CreateTransfer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolioTransactionGroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransfer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear suspicious transaction
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {AuthoriseTransaction} [authoriseTransaction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionAuthoriseFirmIdTransactionIdPut: async (firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, authoriseTransaction?: AuthoriseTransaction, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionActionAuthoriseFirmIdTransactionIdPut', 'firmId', firmId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('portfoliotransactionActionAuthoriseFirmIdTransactionIdPut', 'transactionId', transactionId)
            const localVarPath = `/portfoliotransaction/action/authorise/{firmId}/{transactionId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authoriseTransaction, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dismiss current action tag
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {DismissActionTagRequestBody} [dismissActionTagRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut: async (firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, dismissActionTagRequestBody?: DismissActionTagRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut', 'firmId', firmId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut', 'transactionId', transactionId)
            const localVarPath = `/portfoliotransaction/action/dismissActionTag/{firmId}/{transactionId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dismissActionTagRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Append transfer history update
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {TransferUpdateEventRequest} [transferUpdateEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut: async (firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, transferUpdateEventRequest?: TransferUpdateEventRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut', 'firmId', firmId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut', 'transactionId', transactionId)
            const localVarPath = `/portfoliotransaction/action/firmTransferHistoryUpdate/{firmId}/{transactionId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferUpdateEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request transaction cancellation
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut: async (firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut', 'firmId', firmId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut', 'transactionId', transactionId)
            const localVarPath = `/portfoliotransaction/action/requestCancellation/{firmId}/{transactionId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request transaction deletion
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut: async (firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut', 'firmId', firmId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut', 'transactionId', transactionId)
            const localVarPath = `/portfoliotransaction/action/requestdeletion/{firmId}/{transactionId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of underlying transactions created by a group.
         * @summary List transactions created by a group
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [linkId] 
         * @param {string} [transactionType] 
         * @param {PortfoliotransactionFirmIdGetTransactionSubTypeParameter} [transactionSubType] 
         * @param {PortfoliotransactionFirmIdGetMethodParameter} [method] 
         * @param {MovementType} [movementType] 
         * @param {string} [transactionDateFrom] 
         * @param {string} [transactionDateTo] 
         * @param {PortfoliotransactionFirmIdGetAccountIdParameter} [accountId] 
         * @param {string} [clientId] 
         * @param {string} [assetId] 
         * @param {string} [status] 
         * @param {string} [incomplete] 
         * @param {number} [nodeId] 
         * @param {boolean} [excludeDeleted] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, linkId?: string, transactionType?: string, transactionSubType?: PortfoliotransactionFirmIdGetTransactionSubTypeParameter, method?: PortfoliotransactionFirmIdGetMethodParameter, movementType?: MovementType, transactionDateFrom?: string, transactionDateTo?: string, accountId?: PortfoliotransactionFirmIdGetAccountIdParameter, clientId?: string, assetId?: string, status?: string, incomplete?: string, nodeId?: number, excludeDeleted?: boolean, pageSize?: number, page?: number, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionFirmIdGet', 'firmId', firmId)
            const localVarPath = `/portfoliotransaction/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (linkId !== undefined) {
                localVarQueryParameter['linkId'] = linkId;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            if (transactionSubType !== undefined) {
                localVarQueryParameter['transactionSubType'] = transactionSubType;
            }

            if (method !== undefined) {
                localVarQueryParameter['method'] = method;
            }

            if (movementType !== undefined) {
                localVarQueryParameter['movementType'] = movementType;
            }

            if (transactionDateFrom !== undefined) {
                localVarQueryParameter['transactionDateFrom'] = transactionDateFrom;
            }

            if (transactionDateTo !== undefined) {
                localVarQueryParameter['transactionDateTo'] = transactionDateTo;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (assetId !== undefined) {
                localVarQueryParameter['assetId'] = assetId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (incomplete !== undefined) {
                localVarQueryParameter['incomplete'] = incomplete;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (excludeDeleted !== undefined) {
                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific order using an `orderId`
         * @summary Retrieve order
         * @param {string} firmId 
         * @param {string} orderId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionFirmIdOrderIdGet: async (firmId: string, orderId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionFirmIdOrderIdGet', 'firmId', firmId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('portfoliotransactionFirmIdOrderIdGet', 'orderId', orderId)
            const localVarPath = `/portfoliotransaction/{firmId}/{orderId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a manual cash transfer expectation
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreatePortfolioTransaction} [createPortfolioTransaction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionPost: async (apiToken?: string, idempotencyKey?: string, createPortfolioTransaction?: CreatePortfolioTransaction, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfoliotransaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPortfolioTransaction, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns the product transfer object of all transfers processed on the platform.  The endpoint can be filtered by different parameters to allow you to build specific workflows to monitor transfers within your application.
         * @summary Retrieve all product transfers
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [clientName] 
         * @param {string} [clientId] 
         * @param {string} [accountId] 
         * @param {WrapperType} [wrapperType] 
         * @param {TransferMovementType} [movementType] 
         * @param {TransferStatus} [transferStatus] 
         * @param {boolean} [actionRequired] 
         * @param {string} [nodeId] 
         * @param {string} [linkId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [processingType] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {ActionTag} [actionTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionProducttransferFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, clientName?: string, clientId?: string, accountId?: string, wrapperType?: WrapperType, movementType?: TransferMovementType, transferStatus?: TransferStatus, actionRequired?: boolean, nodeId?: string, linkId?: string, page?: number, pageSize?: number, processingType?: string, lastUpdatedFrom?: string, lastUpdatedTo?: string, actionTag?: ActionTag, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionProducttransferFirmIdGet', 'firmId', firmId)
            const localVarPath = `/portfoliotransaction/producttransfer/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (clientName !== undefined) {
                localVarQueryParameter['clientName'] = clientName;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (wrapperType !== undefined) {
                localVarQueryParameter['wrapperType'] = wrapperType;
            }

            if (movementType !== undefined) {
                localVarQueryParameter['movementType'] = movementType;
            }

            if (transferStatus !== undefined) {
                localVarQueryParameter['transferStatus'] = transferStatus;
            }

            if (actionRequired !== undefined) {
                localVarQueryParameter['actionRequired'] = actionRequired;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (linkId !== undefined) {
                localVarQueryParameter['linkId'] = linkId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (processingType !== undefined) {
                localVarQueryParameter['processingType'] = processingType;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = lastUpdatedTo;
            }

            if (actionTag !== undefined) {
                localVarQueryParameter['actionTag'] = actionTag;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint lets you simulate a production environment by completing a payment. Completing a payment will allocate cash to the client account.
         * @summary Staging mock - complete a payment
         * @param {string} firmId 
         * @param {string} paymentId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionactionFirmIdPaymentIdPut: async (firmId: string, paymentId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfoliotransactionactionFirmIdPaymentIdPut', 'firmId', firmId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('portfoliotransactionactionFirmIdPaymentIdPut', 'paymentId', paymentId)
            const localVarPath = `/portfoliotransactionaction/{firmId}/{paymentId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns the transaction types. The transaction codes can be used to filter the `/posting/cash` and `/posting/stock` endpoints.
         * @summary List transaction codes
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staticTransactiontypeGet: async (contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/static/transactiontype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of underlying transactions and accounts created by a group.
         * @summary List transactions created by a group including accounts
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [linkId] 
         * @param {string} [transactionType] 
         * @param {string} [clientId] 
         * @param {PortfoliotransactionFirmIdGetTransactionSubTypeParameter} [transactionSubType] 
         * @param {PortfoliotransactionFirmIdGetMethodParameter} [method] 
         * @param {MovementType} [movementType] 
         * @param {string} [transactionDateFrom] 
         * @param {string} [transactionDateTo] 
         * @param {PortfoliotransactionFirmIdGetAccountIdParameter} [accountId] 
         * @param {string} [assetId] 
         * @param {V2PortfoliotransactionFirmIdGetStatusParameter} [status] 
         * @param {string} [incomplete] 
         * @param {number} [nodeId] 
         * @param {string} [createdDateFrom] 
         * @param {string} [createdDateTo] 
         * @param {string} [completedDateFrom] 
         * @param {string} [completedDateTo] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [id] transaction Id
         * @param {Array<string>} [ids] Filter to a specific set of transaction ids
         * @param {boolean} [excludeDeleted] 
         * @param {number} [pageSize] 
         * @param {string} [searchAfter] Cursor for forward pagination (next page)
         * @param {string} [searchBefore] Cursor for backward pagination (previous page)
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PortfoliotransactionFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, linkId?: string, transactionType?: string, clientId?: string, transactionSubType?: PortfoliotransactionFirmIdGetTransactionSubTypeParameter, method?: PortfoliotransactionFirmIdGetMethodParameter, movementType?: MovementType, transactionDateFrom?: string, transactionDateTo?: string, accountId?: PortfoliotransactionFirmIdGetAccountIdParameter, assetId?: string, status?: V2PortfoliotransactionFirmIdGetStatusParameter, incomplete?: string, nodeId?: number, createdDateFrom?: string, createdDateTo?: string, completedDateFrom?: string, completedDateTo?: string, lastUpdatedFrom?: string, lastUpdatedTo?: string, id?: string, ids?: Array<string>, excludeDeleted?: boolean, pageSize?: number, searchAfter?: string, searchBefore?: string, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('v2PortfoliotransactionFirmIdGet', 'firmId', firmId)
            const localVarPath = `/v2/portfoliotransaction/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (linkId !== undefined) {
                localVarQueryParameter['linkId'] = linkId;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (transactionSubType !== undefined) {
                localVarQueryParameter['transactionSubType'] = transactionSubType;
            }

            if (method !== undefined) {
                localVarQueryParameter['method'] = method;
            }

            if (movementType !== undefined) {
                localVarQueryParameter['movementType'] = movementType;
            }

            if (transactionDateFrom !== undefined) {
                localVarQueryParameter['transactionDateFrom'] = transactionDateFrom;
            }

            if (transactionDateTo !== undefined) {
                localVarQueryParameter['transactionDateTo'] = transactionDateTo;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (assetId !== undefined) {
                localVarQueryParameter['assetId'] = assetId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (incomplete !== undefined) {
                localVarQueryParameter['incomplete'] = incomplete;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (createdDateFrom !== undefined) {
                localVarQueryParameter['createdDateFrom'] = createdDateFrom;
            }

            if (createdDateTo !== undefined) {
                localVarQueryParameter['createdDateTo'] = createdDateTo;
            }

            if (completedDateFrom !== undefined) {
                localVarQueryParameter['completedDateFrom'] = completedDateFrom;
            }

            if (completedDateTo !== undefined) {
                localVarQueryParameter['completedDateTo'] = completedDateTo;
            }

            if (lastUpdatedFrom !== undefined) {
                localVarQueryParameter['lastUpdatedFrom'] = lastUpdatedFrom;
            }

            if (lastUpdatedTo !== undefined) {
                localVarQueryParameter['lastUpdatedTo'] = lastUpdatedTo;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (excludeDeleted !== undefined) {
                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchAfter !== undefined) {
                localVarQueryParameter['searchAfter'] = searchAfter;
            }

            if (searchBefore !== undefined) {
                localVarQueryParameter['searchBefore'] = searchBefore;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioTransactionManagementApi - functional programming interface
 * @export
 */
export const PortfolioTransactionManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioTransactionManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * This command creates a transfer request and returns a `linkId.`  ---  **A note on the** **`isPensionTransfer`** **field**  This is a mandatory field. Please note, we will only accept transfers from pensions with Safeguarded Rights if a suitably qualified and authorised financial adviser has advised the client that the transfer is suitable for their personal circumstances.
         * @summary Create a transfer request for pension
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreateTransfer} [createTransfer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioTransactionGroupPost(contentType?: string, apiToken?: string, idempotencyKey?: string, createTransfer?: CreateTransfer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioTransactionGroupPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioTransactionGroupPost(contentType, apiToken, idempotencyKey, createTransfer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Clear suspicious transaction
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {AuthoriseTransaction} [authoriseTransaction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionActionAuthoriseFirmIdTransactionIdPut(firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, authoriseTransaction?: AuthoriseTransaction, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionActionAuthoriseFirmIdTransactionIdPut(firmId, transactionId, apiToken, contentType, idempotencyKey, authoriseTransaction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Dismiss current action tag
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {DismissActionTagRequestBody} [dismissActionTagRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut(firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, dismissActionTagRequestBody?: DismissActionTagRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut(firmId, transactionId, apiToken, contentType, idempotencyKey, dismissActionTagRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Append transfer history update
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {TransferUpdateEventRequest} [transferUpdateEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut(firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, transferUpdateEventRequest?: TransferUpdateEventRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut(firmId, transactionId, apiToken, contentType, idempotencyKey, transferUpdateEventRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request transaction cancellation
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut(firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut(firmId, transactionId, apiToken, contentType, idempotencyKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request transaction deletion
         * @param {string} firmId 
         * @param {string} transactionId 
         * @param {string} [apiToken] 
         * @param {string} [contentType] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut(firmId: string, transactionId: string, apiToken?: string, contentType?: string, idempotencyKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut(firmId, transactionId, apiToken, contentType, idempotencyKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a list of underlying transactions created by a group.
         * @summary List transactions created by a group
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [linkId] 
         * @param {string} [transactionType] 
         * @param {PortfoliotransactionFirmIdGetTransactionSubTypeParameter} [transactionSubType] 
         * @param {PortfoliotransactionFirmIdGetMethodParameter} [method] 
         * @param {MovementType} [movementType] 
         * @param {string} [transactionDateFrom] 
         * @param {string} [transactionDateTo] 
         * @param {PortfoliotransactionFirmIdGetAccountIdParameter} [accountId] 
         * @param {string} [clientId] 
         * @param {string} [assetId] 
         * @param {string} [status] 
         * @param {string} [incomplete] 
         * @param {number} [nodeId] 
         * @param {boolean} [excludeDeleted] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionFirmIdGet(firmId: string, contentType?: string, apiToken?: string, linkId?: string, transactionType?: string, transactionSubType?: PortfoliotransactionFirmIdGetTransactionSubTypeParameter, method?: PortfoliotransactionFirmIdGetMethodParameter, movementType?: MovementType, transactionDateFrom?: string, transactionDateTo?: string, accountId?: PortfoliotransactionFirmIdGetAccountIdParameter, clientId?: string, assetId?: string, status?: string, incomplete?: string, nodeId?: number, excludeDeleted?: boolean, pageSize?: number, page?: number, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactionsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionFirmIdGet(firmId, contentType, apiToken, linkId, transactionType, transactionSubType, method, movementType, transactionDateFrom, transactionDateTo, accountId, clientId, assetId, status, incomplete, nodeId, excludeDeleted, pageSize, page, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a specific order using an `orderId`
         * @summary Retrieve order
         * @param {string} firmId 
         * @param {string} orderId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionFirmIdOrderIdGet(firmId: string, orderId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionFirmIdOrderIdGet(firmId, orderId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a manual cash transfer expectation
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {CreatePortfolioTransaction} [createPortfolioTransaction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionPost(apiToken?: string, idempotencyKey?: string, createPortfolioTransaction?: CreatePortfolioTransaction, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfoliotransactionPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionPost(apiToken, idempotencyKey, createPortfolioTransaction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns the product transfer object of all transfers processed on the platform.  The endpoint can be filtered by different parameters to allow you to build specific workflows to monitor transfers within your application.
         * @summary Retrieve all product transfers
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [clientName] 
         * @param {string} [clientId] 
         * @param {string} [accountId] 
         * @param {WrapperType} [wrapperType] 
         * @param {TransferMovementType} [movementType] 
         * @param {TransferStatus} [transferStatus] 
         * @param {boolean} [actionRequired] 
         * @param {string} [nodeId] 
         * @param {string} [linkId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [processingType] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {ActionTag} [actionTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionProducttransferFirmIdGet(firmId: string, contentType?: string, apiToken?: string, clientName?: string, clientId?: string, accountId?: string, wrapperType?: WrapperType, movementType?: TransferMovementType, transferStatus?: TransferStatus, actionRequired?: boolean, nodeId?: string, linkId?: string, page?: number, pageSize?: number, processingType?: string, lastUpdatedFrom?: string, lastUpdatedTo?: string, actionTag?: ActionTag, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransfersList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionProducttransferFirmIdGet(firmId, contentType, apiToken, clientName, clientId, accountId, wrapperType, movementType, transferStatus, actionRequired, nodeId, linkId, page, pageSize, processingType, lastUpdatedFrom, lastUpdatedTo, actionTag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint lets you simulate a production environment by completing a payment. Completing a payment will allocate cash to the client account.
         * @summary Staging mock - complete a payment
         * @param {string} firmId 
         * @param {string} paymentId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfoliotransactionactionFirmIdPaymentIdPut(firmId: string, paymentId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfoliotransactionactionFirmIdPaymentIdPut(firmId, paymentId, contentType, apiToken, idempotencyKey, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns the transaction types. The transaction codes can be used to filter the `/posting/cash` and `/posting/stock` endpoints.
         * @summary List transaction codes
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async staticTransactiontypeGet(contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactionCodesList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.staticTransactiontypeGet(contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a list of underlying transactions and accounts created by a group.
         * @summary List transactions created by a group including accounts
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [linkId] 
         * @param {string} [transactionType] 
         * @param {string} [clientId] 
         * @param {PortfoliotransactionFirmIdGetTransactionSubTypeParameter} [transactionSubType] 
         * @param {PortfoliotransactionFirmIdGetMethodParameter} [method] 
         * @param {MovementType} [movementType] 
         * @param {string} [transactionDateFrom] 
         * @param {string} [transactionDateTo] 
         * @param {PortfoliotransactionFirmIdGetAccountIdParameter} [accountId] 
         * @param {string} [assetId] 
         * @param {V2PortfoliotransactionFirmIdGetStatusParameter} [status] 
         * @param {string} [incomplete] 
         * @param {number} [nodeId] 
         * @param {string} [createdDateFrom] 
         * @param {string} [createdDateTo] 
         * @param {string} [completedDateFrom] 
         * @param {string} [completedDateTo] 
         * @param {string} [lastUpdatedFrom] 
         * @param {string} [lastUpdatedTo] 
         * @param {string} [id] transaction Id
         * @param {Array<string>} [ids] Filter to a specific set of transaction ids
         * @param {boolean} [excludeDeleted] 
         * @param {number} [pageSize] 
         * @param {string} [searchAfter] Cursor for forward pagination (next page)
         * @param {string} [searchBefore] Cursor for backward pagination (previous page)
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2PortfoliotransactionFirmIdGet(firmId: string, contentType?: string, apiToken?: string, linkId?: string, transactionType?: string, clientId?: string, transactionSubType?: PortfoliotransactionFirmIdGetTransactionSubTypeParameter, method?: PortfoliotransactionFirmIdGetMethodParameter, movementType?: MovementType, transactionDateFrom?: string, transactionDateTo?: string, accountId?: PortfoliotransactionFirmIdGetAccountIdParameter, assetId?: string, status?: V2PortfoliotransactionFirmIdGetStatusParameter, incomplete?: string, nodeId?: number, createdDateFrom?: string, createdDateTo?: string, completedDateFrom?: string, completedDateTo?: string, lastUpdatedFrom?: string, lastUpdatedTo?: string, id?: string, ids?: Array<string>, excludeDeleted?: boolean, pageSize?: number, searchAfter?: string, searchBefore?: string, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2getTransactionsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2PortfoliotransactionFirmIdGet(firmId, contentType, apiToken, linkId, transactionType, clientId, transactionSubType, method, movementType, transactionDateFrom, transactionDateTo, accountId, assetId, status, incomplete, nodeId, createdDateFrom, createdDateTo, completedDateFrom, completedDateTo, lastUpdatedFrom, lastUpdatedTo, id, ids, excludeDeleted, pageSize, searchAfter, searchBefore, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortfolioTransactionManagementApi - factory interface
 * @export
 */
export const PortfolioTransactionManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioTransactionManagementApiFp(configuration)
    return {
        /**
         * This command creates a transfer request and returns a `linkId.`  ---  **A note on the** **`isPensionTransfer`** **field**  This is a mandatory field. Please note, we will only accept transfers from pensions with Safeguarded Rights if a suitably qualified and authorised financial adviser has advised the client that the transfer is suitable for their personal circumstances.
         * @summary Create a transfer request for pension
         * @param {PortfolioTransactionManagementApiPortfolioTransactionGroupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioTransactionGroupPost(requestParameters: PortfolioTransactionManagementApiPortfolioTransactionGroupPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PortfolioTransactionGroupPost200Response> {
            return localVarFp.portfolioTransactionGroupPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createTransfer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clear suspicious transaction
         * @param {PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionAuthoriseFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.portfoliotransactionActionAuthoriseFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, requestParameters.authoriseTransaction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dismiss current action tag
         * @param {PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, requestParameters.dismissActionTagRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Append transfer history update
         * @param {PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<ResetPost200Response> {
            return localVarFp.portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, requestParameters.transferUpdateEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request transaction cancellation
         * @param {PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request transaction deletion
         * @param {PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of underlying transactions created by a group.
         * @summary List transactions created by a group
         * @param {PortfolioTransactionManagementApiPortfoliotransactionFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionFirmIdGet(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetTransactionsList> {
            return localVarFp.portfoliotransactionFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.linkId, requestParameters.transactionType, requestParameters.transactionSubType, requestParameters.method, requestParameters.movementType, requestParameters.transactionDateFrom, requestParameters.transactionDateTo, requestParameters.accountId, requestParameters.clientId, requestParameters.assetId, requestParameters.status, requestParameters.incomplete, requestParameters.nodeId, requestParameters.excludeDeleted, requestParameters.pageSize, requestParameters.page, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific order using an `orderId`
         * @summary Retrieve order
         * @param {PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionFirmIdOrderIdGet(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrder> {
            return localVarFp.portfoliotransactionFirmIdOrderIdGet(requestParameters.firmId, requestParameters.orderId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a manual cash transfer expectation
         * @param {PortfolioTransactionManagementApiPortfoliotransactionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionPost(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PortfoliotransactionPost200Response> {
            return localVarFp.portfoliotransactionPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createPortfolioTransaction, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns the product transfer object of all transfers processed on the platform.  The endpoint can be filtered by different parameters to allow you to build specific workflows to monitor transfers within your application.
         * @summary Retrieve all product transfers
         * @param {PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionProducttransferFirmIdGet(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetTransfersList> {
            return localVarFp.portfoliotransactionProducttransferFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.clientName, requestParameters.clientId, requestParameters.accountId, requestParameters.wrapperType, requestParameters.movementType, requestParameters.transferStatus, requestParameters.actionRequired, requestParameters.nodeId, requestParameters.linkId, requestParameters.page, requestParameters.pageSize, requestParameters.processingType, requestParameters.lastUpdatedFrom, requestParameters.lastUpdatedTo, requestParameters.actionTag, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint lets you simulate a production environment by completing a payment. Completing a payment will allocate cash to the client account.
         * @summary Staging mock - complete a payment
         * @param {PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfoliotransactionactionFirmIdPaymentIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.portfoliotransactionactionFirmIdPaymentIdPut(requestParameters.firmId, requestParameters.paymentId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns the transaction types. The transaction codes can be used to filter the `/posting/cash` and `/posting/stock` endpoints.
         * @summary List transaction codes
         * @param {PortfolioTransactionManagementApiStaticTransactiontypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        staticTransactiontypeGet(requestParameters: PortfolioTransactionManagementApiStaticTransactiontypeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetTransactionCodesList> {
            return localVarFp.staticTransactiontypeGet(requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of underlying transactions and accounts created by a group.
         * @summary List transactions created by a group including accounts
         * @param {PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PortfoliotransactionFirmIdGet(requestParameters: PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<V2getTransactionsList> {
            return localVarFp.v2PortfoliotransactionFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.linkId, requestParameters.transactionType, requestParameters.clientId, requestParameters.transactionSubType, requestParameters.method, requestParameters.movementType, requestParameters.transactionDateFrom, requestParameters.transactionDateTo, requestParameters.accountId, requestParameters.assetId, requestParameters.status, requestParameters.incomplete, requestParameters.nodeId, requestParameters.createdDateFrom, requestParameters.createdDateTo, requestParameters.completedDateFrom, requestParameters.completedDateTo, requestParameters.lastUpdatedFrom, requestParameters.lastUpdatedTo, requestParameters.id, requestParameters.ids, requestParameters.excludeDeleted, requestParameters.pageSize, requestParameters.searchAfter, requestParameters.searchBefore, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for portfolioTransactionGroupPost operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfolioTransactionGroupPostRequest
 */
export interface PortfolioTransactionManagementApiPortfolioTransactionGroupPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfolioTransactionGroupPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfolioTransactionGroupPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfolioTransactionGroupPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreateTransfer}
     * @memberof PortfolioTransactionManagementApiPortfolioTransactionGroupPost
     */
    readonly createTransfer?: CreateTransfer
}

/**
 * Request parameters for portfoliotransactionActionAuthoriseFirmIdTransactionIdPut operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPutRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPut
     */
    readonly transactionId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {AuthoriseTransaction}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPut
     */
    readonly authoriseTransaction?: AuthoriseTransaction
}

/**
 * Request parameters for portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPutRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPut
     */
    readonly transactionId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {DismissActionTagRequestBody}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPut
     */
    readonly dismissActionTagRequestBody?: DismissActionTagRequestBody
}

/**
 * Request parameters for portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPutRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut
     */
    readonly transactionId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {TransferUpdateEventRequest}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut
     */
    readonly transferUpdateEventRequest?: TransferUpdateEventRequest
}

/**
 * Request parameters for portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPutRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPut
     */
    readonly transactionId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPut
     */
    readonly idempotencyKey?: string
}

/**
 * Request parameters for portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPutRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPut
     */
    readonly transactionId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPut
     */
    readonly idempotencyKey?: string
}

/**
 * Request parameters for portfoliotransactionFirmIdGet operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionFirmIdGetRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly linkId?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly transactionType?: string

    /**
     * 
     * @type {PortfoliotransactionFirmIdGetTransactionSubTypeParameter}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly transactionSubType?: PortfoliotransactionFirmIdGetTransactionSubTypeParameter

    /**
     * 
     * @type {PortfoliotransactionFirmIdGetMethodParameter}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly method?: PortfoliotransactionFirmIdGetMethodParameter

    /**
     * 
     * @type {MovementType}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly movementType?: MovementType

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly transactionDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly transactionDateTo?: string

    /**
     * 
     * @type {PortfoliotransactionFirmIdGetAccountIdParameter}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly accountId?: PortfoliotransactionFirmIdGetAccountIdParameter

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly clientId?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly assetId?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly incomplete?: string

    /**
     * 
     * @type {number}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly nodeId?: number

    /**
     * 
     * @type {boolean}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly excludeDeleted?: boolean

    /**
     * 
     * @type {number}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly page?: number

    /**
     * Comma-separated list of field:direction pairs (asc|desc)
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdGet
     */
    readonly sort?: string
}

/**
 * Request parameters for portfoliotransactionFirmIdOrderIdGet operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGetRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGet
     */
    readonly orderId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for portfoliotransactionPost operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionPostRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {CreatePortfolioTransaction}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionPost
     */
    readonly createPortfolioTransaction?: CreatePortfolioTransaction
}

/**
 * Request parameters for portfoliotransactionProducttransferFirmIdGet operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGetRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly clientName?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly clientId?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly accountId?: string

    /**
     * 
     * @type {WrapperType}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly wrapperType?: WrapperType

    /**
     * 
     * @type {TransferMovementType}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly movementType?: TransferMovementType

    /**
     * 
     * @type {TransferStatus}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly transferStatus?: TransferStatus

    /**
     * 
     * @type {boolean}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly actionRequired?: boolean

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly nodeId?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly linkId?: string

    /**
     * 
     * @type {number}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly processingType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly lastUpdatedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly lastUpdatedTo?: string

    /**
     * 
     * @type {ActionTag}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGet
     */
    readonly actionTag?: ActionTag
}

/**
 * Request parameters for portfoliotransactionactionFirmIdPaymentIdPut operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPutRequest
 */
export interface PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPut
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPut
     */
    readonly paymentId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPut
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPut
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPut
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPut
     */
    readonly body?: string
}

/**
 * Request parameters for staticTransactiontypeGet operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiStaticTransactiontypeGetRequest
 */
export interface PortfolioTransactionManagementApiStaticTransactiontypeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiStaticTransactiontypeGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiStaticTransactiontypeGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for v2PortfoliotransactionFirmIdGet operation in PortfolioTransactionManagementApi.
 * @export
 * @interface PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGetRequest
 */
export interface PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly linkId?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly transactionType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly clientId?: string

    /**
     * 
     * @type {PortfoliotransactionFirmIdGetTransactionSubTypeParameter}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly transactionSubType?: PortfoliotransactionFirmIdGetTransactionSubTypeParameter

    /**
     * 
     * @type {PortfoliotransactionFirmIdGetMethodParameter}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly method?: PortfoliotransactionFirmIdGetMethodParameter

    /**
     * 
     * @type {MovementType}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly movementType?: MovementType

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly transactionDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly transactionDateTo?: string

    /**
     * 
     * @type {PortfoliotransactionFirmIdGetAccountIdParameter}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly accountId?: PortfoliotransactionFirmIdGetAccountIdParameter

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly assetId?: string

    /**
     * 
     * @type {V2PortfoliotransactionFirmIdGetStatusParameter}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly status?: V2PortfoliotransactionFirmIdGetStatusParameter

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly incomplete?: string

    /**
     * 
     * @type {number}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly nodeId?: number

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly createdDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly createdDateTo?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly completedDateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly completedDateTo?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly lastUpdatedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly lastUpdatedTo?: string

    /**
     * transaction Id
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly id?: string

    /**
     * Filter to a specific set of transaction ids
     * @type {Array<string>}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly ids?: Array<string>

    /**
     * 
     * @type {boolean}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly excludeDeleted?: boolean

    /**
     * 
     * @type {number}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly pageSize?: number

    /**
     * Cursor for forward pagination (next page)
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly searchAfter?: string

    /**
     * Cursor for backward pagination (previous page)
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly searchBefore?: string

    /**
     * Comma-separated list of field:direction pairs (asc|desc)
     * @type {string}
     * @memberof PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGet
     */
    readonly sort?: string
}

/**
 * PortfolioTransactionManagementApi - object-oriented interface
 * @export
 * @class PortfolioTransactionManagementApi
 * @extends {BaseAPI}
 */
export class PortfolioTransactionManagementApi extends BaseAPI {
    /**
     * This command creates a transfer request and returns a `linkId.`  ---  **A note on the** **`isPensionTransfer`** **field**  This is a mandatory field. Please note, we will only accept transfers from pensions with Safeguarded Rights if a suitably qualified and authorised financial adviser has advised the client that the transfer is suitable for their personal circumstances.
     * @summary Create a transfer request for pension
     * @param {PortfolioTransactionManagementApiPortfolioTransactionGroupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfolioTransactionGroupPost(requestParameters: PortfolioTransactionManagementApiPortfolioTransactionGroupPostRequest = {}, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfolioTransactionGroupPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createTransfer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clear suspicious transaction
     * @param {PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionActionAuthoriseFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionAuthoriseFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionActionAuthoriseFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, requestParameters.authoriseTransaction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dismiss current action tag
     * @param {PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionDismissActionTagFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionActionDismissActionTagFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, requestParameters.dismissActionTagRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Append transfer history update
     * @param {PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionActionFirmTransferHistoryUpdateFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, requestParameters.transferUpdateEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request transaction cancellation
     * @param {PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionRequestCancellationFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionActionRequestCancellationFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request transaction deletion
     * @param {PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionActionRequestdeletionFirmIdTransactionIdPutRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionActionRequestdeletionFirmIdTransactionIdPut(requestParameters.firmId, requestParameters.transactionId, requestParameters.apiToken, requestParameters.contentType, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of underlying transactions created by a group.
     * @summary List transactions created by a group
     * @param {PortfolioTransactionManagementApiPortfoliotransactionFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionFirmIdGet(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionFirmIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.linkId, requestParameters.transactionType, requestParameters.transactionSubType, requestParameters.method, requestParameters.movementType, requestParameters.transactionDateFrom, requestParameters.transactionDateTo, requestParameters.accountId, requestParameters.clientId, requestParameters.assetId, requestParameters.status, requestParameters.incomplete, requestParameters.nodeId, requestParameters.excludeDeleted, requestParameters.pageSize, requestParameters.page, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific order using an `orderId`
     * @summary Retrieve order
     * @param {PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionFirmIdOrderIdGet(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionFirmIdOrderIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionFirmIdOrderIdGet(requestParameters.firmId, requestParameters.orderId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a manual cash transfer expectation
     * @param {PortfolioTransactionManagementApiPortfoliotransactionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionPost(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionPostRequest = {}, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.createPortfolioTransaction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns the product transfer object of all transfers processed on the platform.  The endpoint can be filtered by different parameters to allow you to build specific workflows to monitor transfers within your application.
     * @summary Retrieve all product transfers
     * @param {PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionProducttransferFirmIdGet(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionProducttransferFirmIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionProducttransferFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.clientName, requestParameters.clientId, requestParameters.accountId, requestParameters.wrapperType, requestParameters.movementType, requestParameters.transferStatus, requestParameters.actionRequired, requestParameters.nodeId, requestParameters.linkId, requestParameters.page, requestParameters.pageSize, requestParameters.processingType, requestParameters.lastUpdatedFrom, requestParameters.lastUpdatedTo, requestParameters.actionTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint lets you simulate a production environment by completing a payment. Completing a payment will allocate cash to the client account.
     * @summary Staging mock - complete a payment
     * @param {PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public portfoliotransactionactionFirmIdPaymentIdPut(requestParameters: PortfolioTransactionManagementApiPortfoliotransactionactionFirmIdPaymentIdPutRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).portfoliotransactionactionFirmIdPaymentIdPut(requestParameters.firmId, requestParameters.paymentId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns the transaction types. The transaction codes can be used to filter the `/posting/cash` and `/posting/stock` endpoints.
     * @summary List transaction codes
     * @param {PortfolioTransactionManagementApiStaticTransactiontypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public staticTransactiontypeGet(requestParameters: PortfolioTransactionManagementApiStaticTransactiontypeGetRequest = {}, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).staticTransactiontypeGet(requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of underlying transactions and accounts created by a group.
     * @summary List transactions created by a group including accounts
     * @param {PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioTransactionManagementApi
     */
    public v2PortfoliotransactionFirmIdGet(requestParameters: PortfolioTransactionManagementApiV2PortfoliotransactionFirmIdGetRequest, options?: AxiosRequestConfig) {
        return PortfolioTransactionManagementApiFp(this.configuration).v2PortfoliotransactionFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.linkId, requestParameters.transactionType, requestParameters.clientId, requestParameters.transactionSubType, requestParameters.method, requestParameters.movementType, requestParameters.transactionDateFrom, requestParameters.transactionDateTo, requestParameters.accountId, requestParameters.assetId, requestParameters.status, requestParameters.incomplete, requestParameters.nodeId, requestParameters.createdDateFrom, requestParameters.createdDateTo, requestParameters.completedDateFrom, requestParameters.completedDateTo, requestParameters.lastUpdatedFrom, requestParameters.lastUpdatedTo, requestParameters.id, requestParameters.ids, requestParameters.excludeDeleted, requestParameters.pageSize, requestParameters.searchAfter, requestParameters.searchBefore, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PortfoliosApi - axios parameter creator
 * @export
 */
export const PortfoliosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This command returns a capital gains tax report with disclaimers.
         * @summary Retrieve a capital gains tax report
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioCgtReportFirmIdClientIdGet: async (firmId: string, clientId: string, apiToken?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioCgtReportFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('portfolioCgtReportFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/portfolio/cgtReport/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a link to a capital gains tax report with disclaimers as a spreadsheet.
         * @summary Retrieve a capital gains tax report spreadsheet link
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioCgtReportSpreadsheetFirmIdClientIdGet: async (firmId: string, clientId: string, apiToken?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioCgtReportSpreadsheetFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('portfolioCgtReportSpreadsheetFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/portfolio/cgtReport/spreadsheet/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a summary of the client group within the portfolio.
         * @summary Retrieve the portfolio client group summary
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioClientgroupsummaryFirmIdClientIdGet: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioClientgroupsummaryFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('portfolioClientgroupsummaryFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/portfolio/clientgroupsummary/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns the portfolio objects for all clients on the platform
         * @summary List portfolio summaries
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {string} [nodeId] 
         * @param {ClientFirmIdGetStatusParameter} [status] 
         * @param {PortfolioFirmIdGetClientTypeParameter} [clientType] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {PortfolioFirmIdGetIntentDetailsParameter} [intentDetails] 
         * @param {string} [idOrName] 
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, name?: string, id?: string, nodeId?: string, status?: ClientFirmIdGetStatusParameter, clientType?: PortfolioFirmIdGetClientTypeParameter, pageSize?: number, page?: number, intentDetails?: PortfolioFirmIdGetIntentDetailsParameter, idOrName?: string, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioFirmIdGet', 'firmId', firmId)
            const localVarPath = `/portfolio/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['clientType'] = clientType;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (intentDetails !== undefined) {
                localVarQueryParameter['intentDetails'] = intentDetails;
            }

            if (idOrName !== undefined) {
                localVarQueryParameter['idOrName'] = idOrName;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a summary of transactions that have taken place in the client portfolio. This includes:  *   Payments *   Charges *   Income (dividends and cash interest) *   Transfers *   Internal cash movements *   Sell and invest orders
         * @summary Retrieve the portfolio report
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioReportFirmIdClientIdGet: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioReportFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('portfolioReportFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/portfolio/report/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full text search for clients/portfolios using name, email, NINO, or clientId.  Filterable by clientType, nodeId, and status. Optionally includes portfolio summary metrics. 
         * @summary Search portfolios
         * @param {string} firmId 
         * @param {string} query Free-text search (partial name, email, NINO, clientId)
         * @param {string} [apiToken] 
         * @param {'Individual' | 'Individual Minor' | 'Corporate' | 'Trust'} [clientType] 
         * @param {'Active' | 'Closed' | 'Closing' | 'Pending' | 'Registered' | 'Suspended'} [status] 
         * @param {string} [nodeId] 
         * @param {string} [searchAfter] Cursor for forward pagination (next page)
         * @param {string} [searchBefore] Cursor for backward pagination (previous page)
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSearchFirmIdGet: async (firmId: string, query: string, apiToken?: string, clientType?: 'Individual' | 'Individual Minor' | 'Corporate' | 'Trust', status?: 'Active' | 'Closed' | 'Closing' | 'Pending' | 'Registered' | 'Suspended', nodeId?: string, searchAfter?: string, searchBefore?: string, sort?: string, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioSearchFirmIdGet', 'firmId', firmId)
            // verify required parameter 'query' is not null or undefined
            assertParamExists('portfolioSearchFirmIdGet', 'query', query)
            const localVarPath = `/portfolio/search/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['clientType'] = clientType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (searchAfter !== undefined) {
                localVarQueryParameter['searchAfter'] = searchAfter;
            }

            if (searchBefore !== undefined) {
                localVarQueryParameter['searchBefore'] = searchBefore;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a summary of the positions and investment accounts within the portfolio, as well as information on the portfolio as a whole.
         * @summary Retrieve the portfolio summary
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSummaryFirmIdClientIdGet: async (firmId: string, clientId: string, contentType?: string, apiToken?: string, fromDate?: string, toDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('portfolioSummaryFirmIdClientIdGet', 'firmId', firmId)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('portfolioSummaryFirmIdClientIdGet', 'clientId', clientId)
            const localVarPath = `/portfolio/summary/{firmId}/{clientId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfoliosApi - functional programming interface
 * @export
 */
export const PortfoliosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfoliosApiAxiosParamCreator(configuration)
    return {
        /**
         * This command returns a capital gains tax report with disclaimers.
         * @summary Retrieve a capital gains tax report
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioCgtReportFirmIdClientIdGet(firmId: string, clientId: string, apiToken?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCapitalGainsTaxReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioCgtReportFirmIdClientIdGet(firmId, clientId, apiToken, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a link to a capital gains tax report with disclaimers as a spreadsheet.
         * @summary Retrieve a capital gains tax report spreadsheet link
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioCgtReportSpreadsheetFirmIdClientIdGet(firmId: string, clientId: string, apiToken?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCapitalGainsTaxReportSpreadsheetLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioCgtReportSpreadsheetFirmIdClientIdGet(firmId, clientId, apiToken, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a summary of the client group within the portfolio.
         * @summary Retrieve the portfolio client group summary
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioClientgroupsummaryFirmIdClientIdGet(firmId: string, clientId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfolioClientGroupSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioClientgroupsummaryFirmIdClientIdGet(firmId, clientId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns the portfolio objects for all clients on the platform
         * @summary List portfolio summaries
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {string} [nodeId] 
         * @param {ClientFirmIdGetStatusParameter} [status] 
         * @param {PortfolioFirmIdGetClientTypeParameter} [clientType] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {PortfolioFirmIdGetIntentDetailsParameter} [intentDetails] 
         * @param {string} [idOrName] 
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioFirmIdGet(firmId: string, contentType?: string, apiToken?: string, name?: string, id?: string, nodeId?: string, status?: ClientFirmIdGetStatusParameter, clientType?: PortfolioFirmIdGetClientTypeParameter, pageSize?: number, page?: number, intentDetails?: PortfolioFirmIdGetIntentDetailsParameter, idOrName?: string, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfolioList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioFirmIdGet(firmId, contentType, apiToken, name, id, nodeId, status, clientType, pageSize, page, intentDetails, idOrName, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a summary of transactions that have taken place in the client portfolio. This includes:  *   Payments *   Charges *   Income (dividends and cash interest) *   Transfers *   Internal cash movements *   Sell and invest orders
         * @summary Retrieve the portfolio report
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioReportFirmIdClientIdGet(firmId: string, clientId: string, contentType?: string, apiToken?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfolioReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioReportFirmIdClientIdGet(firmId, clientId, contentType, apiToken, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Full text search for clients/portfolios using name, email, NINO, or clientId.  Filterable by clientType, nodeId, and status. Optionally includes portfolio summary metrics. 
         * @summary Search portfolios
         * @param {string} firmId 
         * @param {string} query Free-text search (partial name, email, NINO, clientId)
         * @param {string} [apiToken] 
         * @param {'Individual' | 'Individual Minor' | 'Corporate' | 'Trust'} [clientType] 
         * @param {'Active' | 'Closed' | 'Closing' | 'Pending' | 'Registered' | 'Suspended'} [status] 
         * @param {string} [nodeId] 
         * @param {string} [searchAfter] Cursor for forward pagination (next page)
         * @param {string} [searchBefore] Cursor for backward pagination (previous page)
         * @param {string} [sort] Comma-separated list of field:direction pairs (asc|desc)
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioSearchFirmIdGet(firmId: string, query: string, apiToken?: string, clientType?: 'Individual' | 'Individual Minor' | 'Corporate' | 'Trust', status?: 'Active' | 'Closed' | 'Closing' | 'Pending' | 'Registered' | 'Suspended', nodeId?: string, searchAfter?: string, searchBefore?: string, sort?: string, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfolioSearch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioSearchFirmIdGet(firmId, query, apiToken, clientType, status, nodeId, searchAfter, searchBefore, sort, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a summary of the positions and investment accounts within the portfolio, as well as information on the portfolio as a whole.
         * @summary Retrieve the portfolio summary
         * @param {string} firmId 
         * @param {string} clientId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioSummaryFirmIdClientIdGet(firmId: string, clientId: string, contentType?: string, apiToken?: string, fromDate?: string, toDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfolioSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioSummaryFirmIdClientIdGet(firmId, clientId, contentType, apiToken, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortfoliosApi - factory interface
 * @export
 */
export const PortfoliosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfoliosApiFp(configuration)
    return {
        /**
         * This command returns a capital gains tax report with disclaimers.
         * @summary Retrieve a capital gains tax report
         * @param {PortfoliosApiPortfolioCgtReportFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioCgtReportFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioCgtReportFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetCapitalGainsTaxReport> {
            return localVarFp.portfolioCgtReportFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a link to a capital gains tax report with disclaimers as a spreadsheet.
         * @summary Retrieve a capital gains tax report spreadsheet link
         * @param {PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioCgtReportSpreadsheetFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetCapitalGainsTaxReportSpreadsheetLink> {
            return localVarFp.portfolioCgtReportSpreadsheetFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a summary of the client group within the portfolio.
         * @summary Retrieve the portfolio client group summary
         * @param {PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioClientgroupsummaryFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetPortfolioClientGroupSummary> {
            return localVarFp.portfolioClientgroupsummaryFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns the portfolio objects for all clients on the platform
         * @summary List portfolio summaries
         * @param {PortfoliosApiPortfolioFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioFirmIdGet(requestParameters: PortfoliosApiPortfolioFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetPortfolioList> {
            return localVarFp.portfolioFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.name, requestParameters.id, requestParameters.nodeId, requestParameters.status, requestParameters.clientType, requestParameters.pageSize, requestParameters.page, requestParameters.intentDetails, requestParameters.idOrName, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a summary of transactions that have taken place in the client portfolio. This includes:  *   Payments *   Charges *   Income (dividends and cash interest) *   Transfers *   Internal cash movements *   Sell and invest orders
         * @summary Retrieve the portfolio report
         * @param {PortfoliosApiPortfolioReportFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioReportFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioReportFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetPortfolioReport> {
            return localVarFp.portfolioReportFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Full text search for clients/portfolios using name, email, NINO, or clientId.  Filterable by clientType, nodeId, and status. Optionally includes portfolio summary metrics. 
         * @summary Search portfolios
         * @param {PortfoliosApiPortfolioSearchFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSearchFirmIdGet(requestParameters: PortfoliosApiPortfolioSearchFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetPortfolioSearch> {
            return localVarFp.portfolioSearchFirmIdGet(requestParameters.firmId, requestParameters.query, requestParameters.apiToken, requestParameters.clientType, requestParameters.status, requestParameters.nodeId, requestParameters.searchAfter, requestParameters.searchBefore, requestParameters.sort, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a summary of the positions and investment accounts within the portfolio, as well as information on the portfolio as a whole.
         * @summary Retrieve the portfolio summary
         * @param {PortfoliosApiPortfolioSummaryFirmIdClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioSummaryFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioSummaryFirmIdClientIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetPortfolioSummary> {
            return localVarFp.portfolioSummaryFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for portfolioCgtReportFirmIdClientIdGet operation in PortfoliosApi.
 * @export
 * @interface PortfoliosApiPortfolioCgtReportFirmIdClientIdGetRequest
 */
export interface PortfoliosApiPortfolioCgtReportFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportFirmIdClientIdGet
     */
    readonly toDate?: string
}

/**
 * Request parameters for portfolioCgtReportSpreadsheetFirmIdClientIdGet operation in PortfoliosApi.
 * @export
 * @interface PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest
 */
export interface PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGet
     */
    readonly toDate?: string
}

/**
 * Request parameters for portfolioClientgroupsummaryFirmIdClientIdGet operation in PortfoliosApi.
 * @export
 * @interface PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGetRequest
 */
export interface PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGet
     */
    readonly apiToken?: string
}

/**
 * Request parameters for portfolioFirmIdGet operation in PortfoliosApi.
 * @export
 * @interface PortfoliosApiPortfolioFirmIdGetRequest
 */
export interface PortfoliosApiPortfolioFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly id?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly nodeId?: string

    /**
     * 
     * @type {ClientFirmIdGetStatusParameter}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly status?: ClientFirmIdGetStatusParameter

    /**
     * 
     * @type {PortfolioFirmIdGetClientTypeParameter}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly clientType?: PortfolioFirmIdGetClientTypeParameter

    /**
     * 
     * @type {number}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly page?: number

    /**
     * 
     * @type {PortfolioFirmIdGetIntentDetailsParameter}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly intentDetails?: PortfolioFirmIdGetIntentDetailsParameter

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly idOrName?: string

    /**
     * Comma-separated list of field:direction pairs (asc|desc)
     * @type {string}
     * @memberof PortfoliosApiPortfolioFirmIdGet
     */
    readonly sort?: string
}

/**
 * Request parameters for portfolioReportFirmIdClientIdGet operation in PortfoliosApi.
 * @export
 * @interface PortfoliosApiPortfolioReportFirmIdClientIdGetRequest
 */
export interface PortfoliosApiPortfolioReportFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioReportFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioReportFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioReportFirmIdClientIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioReportFirmIdClientIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioReportFirmIdClientIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioReportFirmIdClientIdGet
     */
    readonly toDate?: string
}

/**
 * Request parameters for portfolioSearchFirmIdGet operation in PortfoliosApi.
 * @export
 * @interface PortfoliosApiPortfolioSearchFirmIdGetRequest
 */
export interface PortfoliosApiPortfolioSearchFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly firmId: string

    /**
     * Free-text search (partial name, email, NINO, clientId)
     * @type {string}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly query: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {'Individual' | 'Individual Minor' | 'Corporate' | 'Trust'}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly clientType?: 'Individual' | 'Individual Minor' | 'Corporate' | 'Trust'

    /**
     * 
     * @type {'Active' | 'Closed' | 'Closing' | 'Pending' | 'Registered' | 'Suspended'}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly status?: 'Active' | 'Closed' | 'Closing' | 'Pending' | 'Registered' | 'Suspended'

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly nodeId?: string

    /**
     * Cursor for forward pagination (next page)
     * @type {string}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly searchAfter?: string

    /**
     * Cursor for backward pagination (previous page)
     * @type {string}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly searchBefore?: string

    /**
     * Comma-separated list of field:direction pairs (asc|desc)
     * @type {string}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly sort?: string

    /**
     * 
     * @type {number}
     * @memberof PortfoliosApiPortfolioSearchFirmIdGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for portfolioSummaryFirmIdClientIdGet operation in PortfoliosApi.
 * @export
 * @interface PortfoliosApiPortfolioSummaryFirmIdClientIdGetRequest
 */
export interface PortfoliosApiPortfolioSummaryFirmIdClientIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSummaryFirmIdClientIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSummaryFirmIdClientIdGet
     */
    readonly clientId: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSummaryFirmIdClientIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSummaryFirmIdClientIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSummaryFirmIdClientIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof PortfoliosApiPortfolioSummaryFirmIdClientIdGet
     */
    readonly toDate?: string
}

/**
 * PortfoliosApi - object-oriented interface
 * @export
 * @class PortfoliosApi
 * @extends {BaseAPI}
 */
export class PortfoliosApi extends BaseAPI {
    /**
     * This command returns a capital gains tax report with disclaimers.
     * @summary Retrieve a capital gains tax report
     * @param {PortfoliosApiPortfolioCgtReportFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfoliosApi
     */
    public portfolioCgtReportFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioCgtReportFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return PortfoliosApiFp(this.configuration).portfolioCgtReportFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a link to a capital gains tax report with disclaimers as a spreadsheet.
     * @summary Retrieve a capital gains tax report spreadsheet link
     * @param {PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfoliosApi
     */
    public portfolioCgtReportSpreadsheetFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioCgtReportSpreadsheetFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return PortfoliosApiFp(this.configuration).portfolioCgtReportSpreadsheetFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a summary of the client group within the portfolio.
     * @summary Retrieve the portfolio client group summary
     * @param {PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfoliosApi
     */
    public portfolioClientgroupsummaryFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioClientgroupsummaryFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return PortfoliosApiFp(this.configuration).portfolioClientgroupsummaryFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns the portfolio objects for all clients on the platform
     * @summary List portfolio summaries
     * @param {PortfoliosApiPortfolioFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfoliosApi
     */
    public portfolioFirmIdGet(requestParameters: PortfoliosApiPortfolioFirmIdGetRequest, options?: AxiosRequestConfig) {
        return PortfoliosApiFp(this.configuration).portfolioFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.name, requestParameters.id, requestParameters.nodeId, requestParameters.status, requestParameters.clientType, requestParameters.pageSize, requestParameters.page, requestParameters.intentDetails, requestParameters.idOrName, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a summary of transactions that have taken place in the client portfolio. This includes:  *   Payments *   Charges *   Income (dividends and cash interest) *   Transfers *   Internal cash movements *   Sell and invest orders
     * @summary Retrieve the portfolio report
     * @param {PortfoliosApiPortfolioReportFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfoliosApi
     */
    public portfolioReportFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioReportFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return PortfoliosApiFp(this.configuration).portfolioReportFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full text search for clients/portfolios using name, email, NINO, or clientId.  Filterable by clientType, nodeId, and status. Optionally includes portfolio summary metrics. 
     * @summary Search portfolios
     * @param {PortfoliosApiPortfolioSearchFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfoliosApi
     */
    public portfolioSearchFirmIdGet(requestParameters: PortfoliosApiPortfolioSearchFirmIdGetRequest, options?: AxiosRequestConfig) {
        return PortfoliosApiFp(this.configuration).portfolioSearchFirmIdGet(requestParameters.firmId, requestParameters.query, requestParameters.apiToken, requestParameters.clientType, requestParameters.status, requestParameters.nodeId, requestParameters.searchAfter, requestParameters.searchBefore, requestParameters.sort, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a summary of the positions and investment accounts within the portfolio, as well as information on the portfolio as a whole.
     * @summary Retrieve the portfolio summary
     * @param {PortfoliosApiPortfolioSummaryFirmIdClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfoliosApi
     */
    public portfolioSummaryFirmIdClientIdGet(requestParameters: PortfoliosApiPortfolioSummaryFirmIdClientIdGetRequest, options?: AxiosRequestConfig) {
        return PortfoliosApiFp(this.configuration).portfolioSummaryFirmIdClientIdGet(requestParameters.firmId, requestParameters.clientId, requestParameters.contentType, requestParameters.apiToken, requestParameters.fromDate, requestParameters.toDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PositionManagementApi - axios parameter creator
 * @export
 */
export const PositionManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This command retrieves a position object.
         * @summary Retrieve a position
         * @param {string} firmId 
         * @param {string} positionId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionFirmIdPositionIdGet: async (firmId: string, positionId: string, fromDate?: string, toDate?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('positionFirmIdPositionIdGet', 'firmId', firmId)
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('positionFirmIdPositionIdGet', 'positionId', positionId)
            const localVarPath = `/position/{firmId}/{positionId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substr(0,10) :
                    toDate;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PositionManagementApi - functional programming interface
 * @export
 */
export const PositionManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PositionManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * This command retrieves a position object.
         * @summary Retrieve a position
         * @param {string} firmId 
         * @param {string} positionId 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionFirmIdPositionIdGet(firmId: string, positionId: string, fromDate?: string, toDate?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionFirmIdPositionIdGet(firmId, positionId, fromDate, toDate, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PositionManagementApi - factory interface
 * @export
 */
export const PositionManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PositionManagementApiFp(configuration)
    return {
        /**
         * This command retrieves a position object.
         * @summary Retrieve a position
         * @param {PositionManagementApiPositionFirmIdPositionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionFirmIdPositionIdGet(requestParameters: PositionManagementApiPositionFirmIdPositionIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetPosition> {
            return localVarFp.positionFirmIdPositionIdGet(requestParameters.firmId, requestParameters.positionId, requestParameters.fromDate, requestParameters.toDate, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for positionFirmIdPositionIdGet operation in PositionManagementApi.
 * @export
 * @interface PositionManagementApiPositionFirmIdPositionIdGetRequest
 */
export interface PositionManagementApiPositionFirmIdPositionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PositionManagementApiPositionFirmIdPositionIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PositionManagementApiPositionFirmIdPositionIdGet
     */
    readonly positionId: string

    /**
     * 
     * @type {string}
     * @memberof PositionManagementApiPositionFirmIdPositionIdGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof PositionManagementApiPositionFirmIdPositionIdGet
     */
    readonly toDate?: string

    /**
     * 
     * @type {string}
     * @memberof PositionManagementApiPositionFirmIdPositionIdGet
     */
    readonly apiToken?: string
}

/**
 * PositionManagementApi - object-oriented interface
 * @export
 * @class PositionManagementApi
 * @extends {BaseAPI}
 */
export class PositionManagementApi extends BaseAPI {
    /**
     * This command retrieves a position object.
     * @summary Retrieve a position
     * @param {PositionManagementApiPositionFirmIdPositionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionManagementApi
     */
    public positionFirmIdPositionIdGet(requestParameters: PositionManagementApiPositionFirmIdPositionIdGetRequest, options?: AxiosRequestConfig) {
        return PositionManagementApiFp(this.configuration).positionFirmIdPositionIdGet(requestParameters.firmId, requestParameters.positionId, requestParameters.fromDate, requestParameters.toDate, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PricesApi - axios parameter creator
 * @export
 */
export const PricesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This returns the latest and historical prices of an asset. Price values are shown from the point at which the asset was added to Seccl\'s system.
         * @summary Retrieve asset prices
         * @param {string} firmId 
         * @param {string} assetId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        priceFirmIdAssetIdGet: async (firmId: string, assetId: string, contentType?: string, apiToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('priceFirmIdAssetIdGet', 'firmId', firmId)
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('priceFirmIdAssetIdGet', 'assetId', assetId)
            const localVarPath = `/price/{firmId}/{assetId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)))
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PricesApi - functional programming interface
 * @export
 */
export const PricesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PricesApiAxiosParamCreator(configuration)
    return {
        /**
         * This returns the latest and historical prices of an asset. Price values are shown from the point at which the asset was added to Seccl\'s system.
         * @summary Retrieve asset prices
         * @param {string} firmId 
         * @param {string} assetId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async priceFirmIdAssetIdGet(firmId: string, assetId: string, contentType?: string, apiToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssetPrice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.priceFirmIdAssetIdGet(firmId, assetId, contentType, apiToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PricesApi - factory interface
 * @export
 */
export const PricesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PricesApiFp(configuration)
    return {
        /**
         * This returns the latest and historical prices of an asset. Price values are shown from the point at which the asset was added to Seccl\'s system.
         * @summary Retrieve asset prices
         * @param {PricesApiPriceFirmIdAssetIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        priceFirmIdAssetIdGet(requestParameters: PricesApiPriceFirmIdAssetIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetAssetPrice> {
            return localVarFp.priceFirmIdAssetIdGet(requestParameters.firmId, requestParameters.assetId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for priceFirmIdAssetIdGet operation in PricesApi.
 * @export
 * @interface PricesApiPriceFirmIdAssetIdGetRequest
 */
export interface PricesApiPriceFirmIdAssetIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PricesApiPriceFirmIdAssetIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof PricesApiPriceFirmIdAssetIdGet
     */
    readonly assetId: string

    /**
     * 
     * @type {string}
     * @memberof PricesApiPriceFirmIdAssetIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof PricesApiPriceFirmIdAssetIdGet
     */
    readonly apiToken?: string
}

/**
 * PricesApi - object-oriented interface
 * @export
 * @class PricesApi
 * @extends {BaseAPI}
 */
export class PricesApi extends BaseAPI {
    /**
     * This returns the latest and historical prices of an asset. Price values are shown from the point at which the asset was added to Seccl\'s system.
     * @summary Retrieve asset prices
     * @param {PricesApiPriceFirmIdAssetIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricesApi
     */
    public priceFirmIdAssetIdGet(requestParameters: PricesApiPriceFirmIdAssetIdGetRequest, options?: AxiosRequestConfig) {
        return PricesApiFp(this.configuration).priceFirmIdAssetIdGet(requestParameters.firmId, requestParameters.assetId, requestParameters.contentType, requestParameters.apiToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SchemeProductManagementApi - axios parameter creator
 * @export
 */
export const SchemeProductManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} firmId 
         * @param {string} [apiToken] 
         * @param {WrapperType} [wrapperType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeProductFirmIdGet: async (firmId: string, apiToken?: string, wrapperType?: WrapperType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('schemeProductFirmIdGet', 'firmId', firmId)
            const localVarPath = `/schemeProduct/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (wrapperType !== undefined) {
                localVarQueryParameter['wrapperType'] = wrapperType;
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchemeProductManagementApi - functional programming interface
 * @export
 */
export const SchemeProductManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchemeProductManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} firmId 
         * @param {string} [apiToken] 
         * @param {WrapperType} [wrapperType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schemeProductFirmIdGet(firmId: string, apiToken?: string, wrapperType?: WrapperType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchemeProductFirmIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schemeProductFirmIdGet(firmId, apiToken, wrapperType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchemeProductManagementApi - factory interface
 * @export
 */
export const SchemeProductManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchemeProductManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {SchemeProductManagementApiSchemeProductFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeProductFirmIdGet(requestParameters: SchemeProductManagementApiSchemeProductFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<SchemeProductFirmIdGet200Response> {
            return localVarFp.schemeProductFirmIdGet(requestParameters.firmId, requestParameters.apiToken, requestParameters.wrapperType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for schemeProductFirmIdGet operation in SchemeProductManagementApi.
 * @export
 * @interface SchemeProductManagementApiSchemeProductFirmIdGetRequest
 */
export interface SchemeProductManagementApiSchemeProductFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SchemeProductManagementApiSchemeProductFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof SchemeProductManagementApiSchemeProductFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {WrapperType}
     * @memberof SchemeProductManagementApiSchemeProductFirmIdGet
     */
    readonly wrapperType?: WrapperType
}

/**
 * SchemeProductManagementApi - object-oriented interface
 * @export
 * @class SchemeProductManagementApi
 * @extends {BaseAPI}
 */
export class SchemeProductManagementApi extends BaseAPI {
    /**
     * 
     * @param {SchemeProductManagementApiSchemeProductFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeProductManagementApi
     */
    public schemeProductFirmIdGet(requestParameters: SchemeProductManagementApiSchemeProductFirmIdGetRequest, options?: AxiosRequestConfig) {
        return SchemeProductManagementApiFp(this.configuration).schemeProductFirmIdGet(requestParameters.firmId, requestParameters.apiToken, requestParameters.wrapperType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TransfersApi - axios parameter creator
 * @export
 */
export const TransfersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a temporary URL that can be used to retrieve the uploaded file
         * @summary Retrieve a temporary URL that can be used to retrieve the uploaded file
         * @param {string} firmid 
         * @param {string} fileUploadId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filestoreManualtransferinFirmidFileUploadIdGet: async (firmid: string, fileUploadId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmid' is not null or undefined
            assertParamExists('filestoreManualtransferinFirmidFileUploadIdGet', 'firmid', firmid)
            // verify required parameter 'fileUploadId' is not null or undefined
            assertParamExists('filestoreManualtransferinFirmidFileUploadIdGet', 'fileUploadId', fileUploadId)
            const localVarPath = `/filestore/manualtransferin/{firmid}/{fileUploadId}`
                .replace(`{${"firmid"}}`, encodeURIComponent(String(firmid)))
                .replace(`{${"fileUploadId"}}`, encodeURIComponent(String(fileUploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create file record for Manual Transfer In and return an upload URL
         * @summary Create file record for Manual Transfer In and return an upload URL
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {FilestoreManualtransferinPostRequest} [filestoreManualtransferinPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filestoreManualtransferinPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, filestoreManualtransferinPostRequest?: FilestoreManualtransferinPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/filestore/manualtransferin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filestoreManualtransferinPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh the upload URL for a file upload
         * @summary Refresh the upload URL for a file upload
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {FilestoreManualtransferinRefreshPostRequest} [filestoreManualtransferinRefreshPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filestoreManualtransferinRefreshPost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, filestoreManualtransferinRefreshPostRequest?: FilestoreManualtransferinRefreshPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/filestore/manualtransferin/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filestoreManualtransferinRefreshPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns the available ceding providers for Origo and ATG.  To reduce the number of rejected transfer instructions, we suggest that you include the data available on this endpoint in your application.  The endpoint can be queried by (1) wrapper type and (2) whether it\'s in-specie or cash.  **Please note: The ceding provider list differs depending on the wrapper type and whether the instruction is in-specie or cash. Full information can be found on the masterparty/platform endpoint.**  **Adding Query Params to the endpoint narrows your search to the relevant ceding providers:**  `transferWrapperType` = the account wrapperType `productTransferType` = the Product Transfer transactionSubType `Cash` or `In Specie` `name` = fuzzy match criteria on the name attribute `status` = the status of the provider, `Active` or `Suspended`
         * @summary Retrieve available ceding providers
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {WrapperType} [transferWrapperType] 
         * @param {'Cash' | 'In Specie'} [productTransferType] 
         * @param {string} [name] 
         * @param {'Active' | 'Suspended'} [status] 
         * @param {'True' | 'False'} [cedingCashSupported] Filter providers by whether they support ceding cash transfers for the given wrapper type. Requires transferWrapperType.
         * @param {'True' | 'False'} [cedingStocksAndSharesSupported] Filter providers by whether they support ceding Stocks and Shares transfers for the given wrapper type. Requires transferWrapperType.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterpartyPlatformFirmIdGet: async (firmId: string, contentType?: string, apiToken?: string, transferWrapperType?: WrapperType, productTransferType?: 'Cash' | 'In Specie', name?: string, status?: 'Active' | 'Suspended', cedingCashSupported?: 'True' | 'False', cedingStocksAndSharesSupported?: 'True' | 'False', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firmId' is not null or undefined
            assertParamExists('masterpartyPlatformFirmIdGet', 'firmId', firmId)
            const localVarPath = `/masterparty/platform/{firmId}`
                .replace(`{${"firmId"}}`, encodeURIComponent(String(firmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (transferWrapperType !== undefined) {
                localVarQueryParameter['transferWrapperType'] = transferWrapperType;
            }

            if (productTransferType !== undefined) {
                localVarQueryParameter['productTransferType'] = productTransferType;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (cedingCashSupported !== undefined) {
                localVarQueryParameter['cedingCashSupported'] = cedingCashSupported;
            }

            if (cedingStocksAndSharesSupported !== undefined) {
                localVarQueryParameter['cedingStocksAndSharesSupported'] = cedingStocksAndSharesSupported;
            }

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This command returns a successful array. You can update the book value of many stock transactions in a single request.  Please see the documentation for updating the book value of a single transfer for more information on the effect of the `bookValue` parameter.
         * @summary Update multiple book values
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateBookValues} [updateBookValues] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBookvaluePost: async (contentType?: string, apiToken?: string, idempotencyKey?: string, updateBookValues?: UpdateBookValues, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/upload/bookvalue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (contentType != null) {
                localVarHeaderParameter['Content-Type'] = String(contentType);
            }

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookValues, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransfersApi - functional programming interface
 * @export
 */
export const TransfersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransfersApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a temporary URL that can be used to retrieve the uploaded file
         * @summary Retrieve a temporary URL that can be used to retrieve the uploaded file
         * @param {string} firmid 
         * @param {string} fileUploadId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filestoreManualtransferinFirmidFileUploadIdGet(firmid: string, fileUploadId: string, contentType?: string, apiToken?: string, idempotencyKey?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilestoreManualtransferinFirmidFileUploadIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filestoreManualtransferinFirmidFileUploadIdGet(firmid, fileUploadId, contentType, apiToken, idempotencyKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create file record for Manual Transfer In and return an upload URL
         * @summary Create file record for Manual Transfer In and return an upload URL
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {FilestoreManualtransferinPostRequest} [filestoreManualtransferinPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filestoreManualtransferinPost(contentType?: string, apiToken?: string, idempotencyKey?: string, filestoreManualtransferinPostRequest?: FilestoreManualtransferinPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilestoreManualtransferinPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filestoreManualtransferinPost(contentType, apiToken, idempotencyKey, filestoreManualtransferinPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refresh the upload URL for a file upload
         * @summary Refresh the upload URL for a file upload
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {FilestoreManualtransferinRefreshPostRequest} [filestoreManualtransferinRefreshPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filestoreManualtransferinRefreshPost(contentType?: string, apiToken?: string, idempotencyKey?: string, filestoreManualtransferinRefreshPostRequest?: FilestoreManualtransferinRefreshPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilestoreManualtransferinPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filestoreManualtransferinRefreshPost(contentType, apiToken, idempotencyKey, filestoreManualtransferinRefreshPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns the available ceding providers for Origo and ATG.  To reduce the number of rejected transfer instructions, we suggest that you include the data available on this endpoint in your application.  The endpoint can be queried by (1) wrapper type and (2) whether it\'s in-specie or cash.  **Please note: The ceding provider list differs depending on the wrapper type and whether the instruction is in-specie or cash. Full information can be found on the masterparty/platform endpoint.**  **Adding Query Params to the endpoint narrows your search to the relevant ceding providers:**  `transferWrapperType` = the account wrapperType `productTransferType` = the Product Transfer transactionSubType `Cash` or `In Specie` `name` = fuzzy match criteria on the name attribute `status` = the status of the provider, `Active` or `Suspended`
         * @summary Retrieve available ceding providers
         * @param {string} firmId 
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {WrapperType} [transferWrapperType] 
         * @param {'Cash' | 'In Specie'} [productTransferType] 
         * @param {string} [name] 
         * @param {'Active' | 'Suspended'} [status] 
         * @param {'True' | 'False'} [cedingCashSupported] Filter providers by whether they support ceding cash transfers for the given wrapper type. Requires transferWrapperType.
         * @param {'True' | 'False'} [cedingStocksAndSharesSupported] Filter providers by whether they support ceding Stocks and Shares transfers for the given wrapper type. Requires transferWrapperType.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterpartyPlatformFirmIdGet(firmId: string, contentType?: string, apiToken?: string, transferWrapperType?: WrapperType, productTransferType?: 'Cash' | 'In Specie', name?: string, status?: 'Active' | 'Suspended', cedingCashSupported?: 'True' | 'False', cedingStocksAndSharesSupported?: 'True' | 'False', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCedingProviders>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterpartyPlatformFirmIdGet(firmId, contentType, apiToken, transferWrapperType, productTransferType, name, status, cedingCashSupported, cedingStocksAndSharesSupported, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This command returns a successful array. You can update the book value of many stock transactions in a single request.  Please see the documentation for updating the book value of a single transfer for more information on the effect of the `bookValue` parameter.
         * @summary Update multiple book values
         * @param {string} [contentType] 
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {UpdateBookValues} [updateBookValues] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBookvaluePost(contentType?: string, apiToken?: string, idempotencyKey?: string, updateBookValues?: UpdateBookValues, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBookvaluePost(contentType, apiToken, idempotencyKey, updateBookValues, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransfersApi - factory interface
 * @export
 */
export const TransfersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransfersApiFp(configuration)
    return {
        /**
         * Retrieve a temporary URL that can be used to retrieve the uploaded file
         * @summary Retrieve a temporary URL that can be used to retrieve the uploaded file
         * @param {TransfersApiFilestoreManualtransferinFirmidFileUploadIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filestoreManualtransferinFirmidFileUploadIdGet(requestParameters: TransfersApiFilestoreManualtransferinFirmidFileUploadIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FilestoreManualtransferinFirmidFileUploadIdGet200Response> {
            return localVarFp.filestoreManualtransferinFirmidFileUploadIdGet(requestParameters.firmid, requestParameters.fileUploadId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Create file record for Manual Transfer In and return an upload URL
         * @summary Create file record for Manual Transfer In and return an upload URL
         * @param {TransfersApiFilestoreManualtransferinPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filestoreManualtransferinPost(requestParameters: TransfersApiFilestoreManualtransferinPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<FilestoreManualtransferinPost200Response> {
            return localVarFp.filestoreManualtransferinPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.filestoreManualtransferinPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh the upload URL for a file upload
         * @summary Refresh the upload URL for a file upload
         * @param {TransfersApiFilestoreManualtransferinRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filestoreManualtransferinRefreshPost(requestParameters: TransfersApiFilestoreManualtransferinRefreshPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<FilestoreManualtransferinPost200Response> {
            return localVarFp.filestoreManualtransferinRefreshPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.filestoreManualtransferinRefreshPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns the available ceding providers for Origo and ATG.  To reduce the number of rejected transfer instructions, we suggest that you include the data available on this endpoint in your application.  The endpoint can be queried by (1) wrapper type and (2) whether it\'s in-specie or cash.  **Please note: The ceding provider list differs depending on the wrapper type and whether the instruction is in-specie or cash. Full information can be found on the masterparty/platform endpoint.**  **Adding Query Params to the endpoint narrows your search to the relevant ceding providers:**  `transferWrapperType` = the account wrapperType `productTransferType` = the Product Transfer transactionSubType `Cash` or `In Specie` `name` = fuzzy match criteria on the name attribute `status` = the status of the provider, `Active` or `Suspended`
         * @summary Retrieve available ceding providers
         * @param {TransfersApiMasterpartyPlatformFirmIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterpartyPlatformFirmIdGet(requestParameters: TransfersApiMasterpartyPlatformFirmIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<GetCedingProviders> {
            return localVarFp.masterpartyPlatformFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.transferWrapperType, requestParameters.productTransferType, requestParameters.name, requestParameters.status, requestParameters.cedingCashSupported, requestParameters.cedingStocksAndSharesSupported, options).then((request) => request(axios, basePath));
        },
        /**
         * This command returns a successful array. You can update the book value of many stock transactions in a single request.  Please see the documentation for updating the book value of a single transfer for more information on the effect of the `bookValue` parameter.
         * @summary Update multiple book values
         * @param {TransfersApiUploadBookvaluePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBookvaluePost(requestParameters: TransfersApiUploadBookvaluePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ResetPost200Response> {
            return localVarFp.uploadBookvaluePost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateBookValues, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for filestoreManualtransferinFirmidFileUploadIdGet operation in TransfersApi.
 * @export
 * @interface TransfersApiFilestoreManualtransferinFirmidFileUploadIdGetRequest
 */
export interface TransfersApiFilestoreManualtransferinFirmidFileUploadIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinFirmidFileUploadIdGet
     */
    readonly firmid: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinFirmidFileUploadIdGet
     */
    readonly fileUploadId: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinFirmidFileUploadIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinFirmidFileUploadIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinFirmidFileUploadIdGet
     */
    readonly idempotencyKey?: string
}

/**
 * Request parameters for filestoreManualtransferinPost operation in TransfersApi.
 * @export
 * @interface TransfersApiFilestoreManualtransferinPostRequest
 */
export interface TransfersApiFilestoreManualtransferinPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {FilestoreManualtransferinPostRequest}
     * @memberof TransfersApiFilestoreManualtransferinPost
     */
    readonly filestoreManualtransferinPostRequest?: FilestoreManualtransferinPostRequest
}

/**
 * Request parameters for filestoreManualtransferinRefreshPost operation in TransfersApi.
 * @export
 * @interface TransfersApiFilestoreManualtransferinRefreshPostRequest
 */
export interface TransfersApiFilestoreManualtransferinRefreshPostRequest {
    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinRefreshPost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinRefreshPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiFilestoreManualtransferinRefreshPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {FilestoreManualtransferinRefreshPostRequest}
     * @memberof TransfersApiFilestoreManualtransferinRefreshPost
     */
    readonly filestoreManualtransferinRefreshPostRequest?: FilestoreManualtransferinRefreshPostRequest
}

/**
 * Request parameters for masterpartyPlatformFirmIdGet operation in TransfersApi.
 * @export
 * @interface TransfersApiMasterpartyPlatformFirmIdGetRequest
 */
export interface TransfersApiMasterpartyPlatformFirmIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly firmId: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly apiToken?: string

    /**
     * 
     * @type {WrapperType}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly transferWrapperType?: WrapperType

    /**
     * 
     * @type {'Cash' | 'In Specie'}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly productTransferType?: 'Cash' | 'In Specie'

    /**
     * 
     * @type {string}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly name?: string

    /**
     * 
     * @type {'Active' | 'Suspended'}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly status?: 'Active' | 'Suspended'

    /**
     * Filter providers by whether they support ceding cash transfers for the given wrapper type. Requires transferWrapperType.
     * @type {'True' | 'False'}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly cedingCashSupported?: 'True' | 'False'

    /**
     * Filter providers by whether they support ceding Stocks and Shares transfers for the given wrapper type. Requires transferWrapperType.
     * @type {'True' | 'False'}
     * @memberof TransfersApiMasterpartyPlatformFirmIdGet
     */
    readonly cedingStocksAndSharesSupported?: 'True' | 'False'
}

/**
 * Request parameters for uploadBookvaluePost operation in TransfersApi.
 * @export
 * @interface TransfersApiUploadBookvaluePostRequest
 */
export interface TransfersApiUploadBookvaluePostRequest {
    /**
     * 
     * @type {string}
     * @memberof TransfersApiUploadBookvaluePost
     */
    readonly contentType?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiUploadBookvaluePost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof TransfersApiUploadBookvaluePost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {UpdateBookValues}
     * @memberof TransfersApiUploadBookvaluePost
     */
    readonly updateBookValues?: UpdateBookValues
}

/**
 * TransfersApi - object-oriented interface
 * @export
 * @class TransfersApi
 * @extends {BaseAPI}
 */
export class TransfersApi extends BaseAPI {
    /**
     * Retrieve a temporary URL that can be used to retrieve the uploaded file
     * @summary Retrieve a temporary URL that can be used to retrieve the uploaded file
     * @param {TransfersApiFilestoreManualtransferinFirmidFileUploadIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public filestoreManualtransferinFirmidFileUploadIdGet(requestParameters: TransfersApiFilestoreManualtransferinFirmidFileUploadIdGetRequest, options?: AxiosRequestConfig) {
        return TransfersApiFp(this.configuration).filestoreManualtransferinFirmidFileUploadIdGet(requestParameters.firmid, requestParameters.fileUploadId, requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create file record for Manual Transfer In and return an upload URL
     * @summary Create file record for Manual Transfer In and return an upload URL
     * @param {TransfersApiFilestoreManualtransferinPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public filestoreManualtransferinPost(requestParameters: TransfersApiFilestoreManualtransferinPostRequest = {}, options?: AxiosRequestConfig) {
        return TransfersApiFp(this.configuration).filestoreManualtransferinPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.filestoreManualtransferinPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh the upload URL for a file upload
     * @summary Refresh the upload URL for a file upload
     * @param {TransfersApiFilestoreManualtransferinRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public filestoreManualtransferinRefreshPost(requestParameters: TransfersApiFilestoreManualtransferinRefreshPostRequest = {}, options?: AxiosRequestConfig) {
        return TransfersApiFp(this.configuration).filestoreManualtransferinRefreshPost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.filestoreManualtransferinRefreshPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns the available ceding providers for Origo and ATG.  To reduce the number of rejected transfer instructions, we suggest that you include the data available on this endpoint in your application.  The endpoint can be queried by (1) wrapper type and (2) whether it\'s in-specie or cash.  **Please note: The ceding provider list differs depending on the wrapper type and whether the instruction is in-specie or cash. Full information can be found on the masterparty/platform endpoint.**  **Adding Query Params to the endpoint narrows your search to the relevant ceding providers:**  `transferWrapperType` = the account wrapperType `productTransferType` = the Product Transfer transactionSubType `Cash` or `In Specie` `name` = fuzzy match criteria on the name attribute `status` = the status of the provider, `Active` or `Suspended`
     * @summary Retrieve available ceding providers
     * @param {TransfersApiMasterpartyPlatformFirmIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public masterpartyPlatformFirmIdGet(requestParameters: TransfersApiMasterpartyPlatformFirmIdGetRequest, options?: AxiosRequestConfig) {
        return TransfersApiFp(this.configuration).masterpartyPlatformFirmIdGet(requestParameters.firmId, requestParameters.contentType, requestParameters.apiToken, requestParameters.transferWrapperType, requestParameters.productTransferType, requestParameters.name, requestParameters.status, requestParameters.cedingCashSupported, requestParameters.cedingStocksAndSharesSupported, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This command returns a successful array. You can update the book value of many stock transactions in a single request.  Please see the documentation for updating the book value of a single transfer for more information on the effect of the `bookValue` parameter.
     * @summary Update multiple book values
     * @param {TransfersApiUploadBookvaluePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransfersApi
     */
    public uploadBookvaluePost(requestParameters: TransfersApiUploadBookvaluePostRequest = {}, options?: AxiosRequestConfig) {
        return TransfersApiFp(this.configuration).uploadBookvaluePost(requestParameters.contentType, requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.updateBookValues, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WithdrawalsTakingIncomeFromAGaudiPensionApi - axios parameter creator
 * @export
 */
export const WithdrawalsTakingIncomeFromAGaudiPensionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This returns a link to the Gaudi drawdown request form.  This form needs to be completed and emailed to [sipp@gaudiltd.co.uk](mailto:sipp@gaudiltd.co.uk), with the following wording:  *I can confirm that I have provided positive advice for the drawdown application.*
         * @summary Download Gaudi drawdown request form
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesDrawdownapplicationPost: async (apiToken?: string, idempotencyKey?: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files/drawdownapplication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "api-token", configuration)

            if (apiToken != null) {
                localVarHeaderParameter['api-token'] = String(apiToken);
            }

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WithdrawalsTakingIncomeFromAGaudiPensionApi - functional programming interface
 * @export
 */
export const WithdrawalsTakingIncomeFromAGaudiPensionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WithdrawalsTakingIncomeFromAGaudiPensionApiAxiosParamCreator(configuration)
    return {
        /**
         * This returns a link to the Gaudi drawdown request form.  This form needs to be completed and emailed to [sipp@gaudiltd.co.uk](mailto:sipp@gaudiltd.co.uk), with the following wording:  *I can confirm that I have provided positive advice for the drawdown application.*
         * @summary Download Gaudi drawdown request form
         * @param {string} [apiToken] 
         * @param {string} [idempotencyKey] 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesDrawdownapplicationPost(apiToken?: string, idempotencyKey?: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesDrawdownapplicationPost(apiToken, idempotencyKey, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WithdrawalsTakingIncomeFromAGaudiPensionApi - factory interface
 * @export
 */
export const WithdrawalsTakingIncomeFromAGaudiPensionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WithdrawalsTakingIncomeFromAGaudiPensionApiFp(configuration)
    return {
        /**
         * This returns a link to the Gaudi drawdown request form.  This form needs to be completed and emailed to [sipp@gaudiltd.co.uk](mailto:sipp@gaudiltd.co.uk), with the following wording:  *I can confirm that I have provided positive advice for the drawdown application.*
         * @summary Download Gaudi drawdown request form
         * @param {WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesDrawdownapplicationPost(requestParameters: WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.filesDrawdownapplicationPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for filesDrawdownapplicationPost operation in WithdrawalsTakingIncomeFromAGaudiPensionApi.
 * @export
 * @interface WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPostRequest
 */
export interface WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPostRequest {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPost
     */
    readonly apiToken?: string

    /**
     * 
     * @type {string}
     * @memberof WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPost
     */
    readonly idempotencyKey?: string

    /**
     * 
     * @type {object}
     * @memberof WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPost
     */
    readonly body?: object
}

/**
 * WithdrawalsTakingIncomeFromAGaudiPensionApi - object-oriented interface
 * @export
 * @class WithdrawalsTakingIncomeFromAGaudiPensionApi
 * @extends {BaseAPI}
 */
export class WithdrawalsTakingIncomeFromAGaudiPensionApi extends BaseAPI {
    /**
     * This returns a link to the Gaudi drawdown request form.  This form needs to be completed and emailed to [sipp@gaudiltd.co.uk](mailto:sipp@gaudiltd.co.uk), with the following wording:  *I can confirm that I have provided positive advice for the drawdown application.*
     * @summary Download Gaudi drawdown request form
     * @param {WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsTakingIncomeFromAGaudiPensionApi
     */
    public filesDrawdownapplicationPost(requestParameters: WithdrawalsTakingIncomeFromAGaudiPensionApiFilesDrawdownapplicationPostRequest = {}, options?: AxiosRequestConfig) {
        return WithdrawalsTakingIncomeFromAGaudiPensionApiFp(this.configuration).filesDrawdownapplicationPost(requestParameters.apiToken, requestParameters.idempotencyKey, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}


